webpackJsonp([1],Array(887).concat([
/* 887 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _getPrototypeOf = __webpack_require__(942);

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__(947);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(948);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(952);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(977);

var _inherits3 = _interopRequireDefault(_inherits2);

var _react = __webpack_require__(71);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(985);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _hoistNonReactStatics = __webpack_require__(988);

var _hoistNonReactStatics2 = _interopRequireDefault(_hoistNonReactStatics);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var contextTypes = {
  insertCss: _propTypes2.default.func
}; /**
    * Isomorphic CSS style loader for Webpack
    *
    * Copyright © 2015-present Kriasoft, LLC. All rights reserved.
    *
    * This source code is licensed under the MIT license found in the
    * LICENSE.txt file in the root directory of this source tree.
    */

function withStyles() {
  for (var _len = arguments.length, styles = Array(_len), _key = 0; _key < _len; _key++) {
    styles[_key] = arguments[_key];
  }

  return function wrapWithStyles(ComposedComponent) {
    var WithStyles = function (_Component) {
      (0, _inherits3.default)(WithStyles, _Component);

      function WithStyles() {
        (0, _classCallCheck3.default)(this, WithStyles);
        return (0, _possibleConstructorReturn3.default)(this, (WithStyles.__proto__ || (0, _getPrototypeOf2.default)(WithStyles)).apply(this, arguments));
      }

      (0, _createClass3.default)(WithStyles, [{
        key: 'componentWillMount',
        value: function componentWillMount() {
          this.removeCss = this.context.insertCss.apply(undefined, styles);
        }
      }, {
        key: 'componentWillUnmount',
        value: function componentWillUnmount() {
          setTimeout(this.removeCss, 0);
        }
      }, {
        key: 'render',
        value: function render() {
          return _react2.default.createElement(ComposedComponent, this.props);
        }
      }]);
      return WithStyles;
    }(_react.Component);

    var displayName = ComposedComponent.displayName || ComposedComponent.name || 'Component';

    WithStyles.displayName = 'WithStyles(' + displayName + ')';
    WithStyles.contextTypes = contextTypes;
    WithStyles.ComposedComponent = ComposedComponent;

    return (0, _hoistNonReactStatics2.default)(WithStyles, ComposedComponent);
  };
}

exports.default = withStyles;

/***/ }),
/* 888 */
/***/ (function(module, exports) {

/*
	MIT License http://www.opensource.org/licenses/mit-license.php
	Author Tobias Koppers @sokra
*/
// css base code, injected by the css-loader
module.exports = function(useSourceMap) {
	var list = [];

	// return the list of modules as css string
	list.toString = function toString() {
		return this.map(function (item) {
			var content = cssWithMappingToString(item, useSourceMap);
			if(item[2]) {
				return "@media " + item[2] + "{" + content + "}";
			} else {
				return content;
			}
		}).join("");
	};

	// import a list of modules into the list
	list.i = function(modules, mediaQuery) {
		if(typeof modules === "string")
			modules = [[null, modules, ""]];
		var alreadyImportedModules = {};
		for(var i = 0; i < this.length; i++) {
			var id = this[i][0];
			if(typeof id === "number")
				alreadyImportedModules[id] = true;
		}
		for(i = 0; i < modules.length; i++) {
			var item = modules[i];
			// skip already imported module
			// this implementation is not 100% perfect for weird media query combinations
			//  when a module is imported multiple times with different media queries.
			//  I hope this will never occur (Hey this way we have smaller bundles)
			if(typeof item[0] !== "number" || !alreadyImportedModules[item[0]]) {
				if(mediaQuery && !item[2]) {
					item[2] = mediaQuery;
				} else if(mediaQuery) {
					item[2] = "(" + item[2] + ") and (" + mediaQuery + ")";
				}
				list.push(item);
			}
		}
	};
	return list;
};

function cssWithMappingToString(item, useSourceMap) {
	var content = item[1] || '';
	var cssMapping = item[3];
	if (!cssMapping) {
		return content;
	}

	if (useSourceMap && typeof btoa === 'function') {
		var sourceMapping = toComment(cssMapping);
		var sourceURLs = cssMapping.sources.map(function (source) {
			return '/*# sourceURL=' + cssMapping.sourceRoot + source + ' */'
		});

		return [content].concat(sourceURLs).concat([sourceMapping]).join('\n');
	}

	return [content].join('\n');
}

// Adapted from convert-source-map (MIT)
function toComment(sourceMap) {
	// eslint-disable-next-line no-undef
	var base64 = btoa(unescape(encodeURIComponent(JSON.stringify(sourceMap))));
	var data = 'sourceMappingURL=data:application/json;charset=utf-8;base64,' + base64;

	return '/*# ' + data + ' */';
}


/***/ }),
/* 889 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _stringify = __webpack_require__(990);

var _stringify2 = _interopRequireDefault(_stringify);

var _slicedToArray2 = __webpack_require__(992);

var _slicedToArray3 = _interopRequireDefault(_slicedToArray2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/**
 * Isomorphic CSS style loader for Webpack
 *
 * Copyright © 2015-present Kriasoft, LLC. All rights reserved.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE.txt file in the root directory of this source tree.
 */

var prefix = 's';
var inserted = {};

// Base64 encoding and decoding - The "Unicode Problem"
// https://developer.mozilla.org/en-US/docs/Web/API/WindowBase64/Base64_encoding_and_decoding#The_Unicode_Problem
function b64EncodeUnicode(str) {
  return btoa(encodeURIComponent(str).replace(/%([0-9A-F]{2})/g, function (match, p1) {
    return String.fromCharCode('0x' + p1);
  }));
}

/**
 * Remove style/link elements for specified node IDs
 * if they are no longer referenced by UI components.
 */
function removeCss(ids) {
  ids.forEach(function (id) {
    if (--inserted[id] <= 0) {
      var elem = document.getElementById(prefix + id);
      if (elem) {
        elem.parentNode.removeChild(elem);
      }
    }
  });
}

/**
 * Example:
 *   // Insert CSS styles object generated by `css-loader` into DOM
 *   var removeCss = insertCss([[1, 'body { color: red; }']]);
 *
 *   // Remove it from the DOM
 *   removeCss();
 */
function insertCss(styles) {
  var _ref = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {},
      _ref$replace = _ref.replace,
      replace = _ref$replace === undefined ? false : _ref$replace,
      _ref$prepend = _ref.prepend,
      prepend = _ref$prepend === undefined ? false : _ref$prepend;

  var ids = [];
  for (var i = 0; i < styles.length; i++) {
    var _styles$i = (0, _slicedToArray3.default)(styles[i], 4),
        moduleId = _styles$i[0],
        css = _styles$i[1],
        media = _styles$i[2],
        sourceMap = _styles$i[3];

    var id = moduleId + '-' + i;

    ids.push(id);

    if (inserted[id]) {
      if (!replace) {
        inserted[id]++;
        continue;
      }
    }

    inserted[id] = 1;

    var elem = document.getElementById(prefix + id);
    var create = false;

    if (!elem) {
      create = true;

      elem = document.createElement('style');
      elem.setAttribute('type', 'text/css');
      elem.id = prefix + id;

      if (media) {
        elem.setAttribute('media', media);
      }
    }

    var cssText = css;
    if (sourceMap && typeof btoa === 'function') {
      // skip IE9 and below, see http://caniuse.com/atob-btoa
      cssText += '\n/*# sourceMappingURL=data:application/json;base64,' + b64EncodeUnicode((0, _stringify2.default)(sourceMap)) + '*/';
      cssText += '\n/*# sourceURL=' + sourceMap.file + '?' + id + '*/';
    }

    if ('textContent' in elem) {
      elem.textContent = cssText;
    } else {
      elem.styleSheet.cssText = cssText;
    }

    if (create) {
      if (prepend) {
        document.head.insertBefore(elem, document.head.childNodes[0]);
      } else {
        document.head.appendChild(elem);
      }
    }
  }

  return removeCss.bind(null, ids);
}

module.exports = insertCss;

/***/ }),
/* 890 */
/***/ (function(module, exports, __webpack_require__) {

/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 */

if (false) {
  var REACT_ELEMENT_TYPE = (typeof Symbol === 'function' &&
    Symbol.for &&
    Symbol.for('react.element')) ||
    0xeac7;

  var isValidElement = function(object) {
    return typeof object === 'object' &&
      object !== null &&
      object.$$typeof === REACT_ELEMENT_TYPE;
  };

  // By explicitly using `prop-types` you are opting into new development behavior.
  // http://fb.me/prop-types-in-prod
  var throwOnDirectAccess = true;
  module.exports = require('./factoryWithTypeCheckers')(isValidElement, throwOnDirectAccess);
} else {
  // By explicitly using `prop-types` you are opting into new production behavior.
  // http://fb.me/prop-types-in-prod
  module.exports = __webpack_require__(1205)();
}


/***/ }),
/* 891 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;/*!
  Copyright (c) 2016 Jed Watson.
  Licensed under the MIT License (MIT), see
  http://jedwatson.github.io/classnames
*/
/* global define */

(function () {
	'use strict';

	var hasOwn = {}.hasOwnProperty;

	function classNames () {
		var classes = [];

		for (var i = 0; i < arguments.length; i++) {
			var arg = arguments[i];
			if (!arg) continue;

			var argType = typeof arg;

			if (argType === 'string' || argType === 'number') {
				classes.push(arg);
			} else if (Array.isArray(arg)) {
				classes.push(classNames.apply(null, arg));
			} else if (argType === 'object') {
				for (var key in arg) {
					if (hasOwn.call(arg, key) && arg[key]) {
						classes.push(key);
					}
				}
			}
		}

		return classes.join(' ');
	}

	if (typeof module !== 'undefined' && module.exports) {
		module.exports = classNames;
	} else if (true) {
		// register as 'classnames', consistent with npm package name
		!(__WEBPACK_AMD_DEFINE_ARRAY__ = [], __WEBPACK_AMD_DEFINE_RESULT__ = function () {
			return classNames;
		}.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
	} else {
		window.classNames = classNames;
	}
}());


/***/ }),
/* 892 */
/***/ (function(module, exports) {

var core = module.exports = {version: '2.4.0'};
if(typeof __e == 'number')__e = core; // eslint-disable-line no-undef

/***/ }),
/* 893 */
/***/ (function(module, exports, __webpack_require__) {

var store      = __webpack_require__(911)('wks')
  , uid        = __webpack_require__(905)
  , Symbol     = __webpack_require__(894).Symbol
  , USE_SYMBOL = typeof Symbol == 'function';

var $exports = module.exports = function(name){
  return store[name] || (store[name] =
    USE_SYMBOL && Symbol[name] || (USE_SYMBOL ? Symbol : uid)('Symbol.' + name));
};

$exports.store = store;

/***/ }),
/* 894 */
/***/ (function(module, exports) {

// https://github.com/zloirock/core-js/issues/86#issuecomment-115759028
var global = module.exports = typeof window != 'undefined' && window.Math == Math
  ? window : typeof self != 'undefined' && self.Math == Math ? self : Function('return this')();
if(typeof __g == 'number')__g = global; // eslint-disable-line no-undef

/***/ }),
/* 895 */
/***/ (function(module, exports) {

var hasOwnProperty = {}.hasOwnProperty;
module.exports = function(it, key){
  return hasOwnProperty.call(it, key);
};

/***/ }),
/* 896 */
/***/ (function(module, exports, __webpack_require__) {

var anObject       = __webpack_require__(901)
  , IE8_DOM_DEFINE = __webpack_require__(927)
  , toPrimitive    = __webpack_require__(912)
  , dP             = Object.defineProperty;

exports.f = __webpack_require__(897) ? Object.defineProperty : function defineProperty(O, P, Attributes){
  anObject(O);
  P = toPrimitive(P, true);
  anObject(Attributes);
  if(IE8_DOM_DEFINE)try {
    return dP(O, P, Attributes);
  } catch(e){ /* empty */ }
  if('get' in Attributes || 'set' in Attributes)throw TypeError('Accessors not supported!');
  if('value' in Attributes)O[P] = Attributes.value;
  return O;
};

/***/ }),
/* 897 */
/***/ (function(module, exports, __webpack_require__) {

// Thank's IE8 for his funny defineProperty
module.exports = !__webpack_require__(903)(function(){
  return Object.defineProperty({}, 'a', {get: function(){ return 7; }}).a != 7;
});

/***/ }),
/* 898 */
/***/ (function(module, exports, __webpack_require__) {

// to indexed object, toObject with fallback for non-array-like ES3 strings
var IObject = __webpack_require__(958)
  , defined = __webpack_require__(909);
module.exports = function(it){
  return IObject(defined(it));
};

/***/ }),
/* 899 */
/***/ (function(module, exports, __webpack_require__) {

var global    = __webpack_require__(894)
  , core      = __webpack_require__(892)
  , ctx       = __webpack_require__(926)
  , hide      = __webpack_require__(900)
  , PROTOTYPE = 'prototype';

var $export = function(type, name, source){
  var IS_FORCED = type & $export.F
    , IS_GLOBAL = type & $export.G
    , IS_STATIC = type & $export.S
    , IS_PROTO  = type & $export.P
    , IS_BIND   = type & $export.B
    , IS_WRAP   = type & $export.W
    , exports   = IS_GLOBAL ? core : core[name] || (core[name] = {})
    , expProto  = exports[PROTOTYPE]
    , target    = IS_GLOBAL ? global : IS_STATIC ? global[name] : (global[name] || {})[PROTOTYPE]
    , key, own, out;
  if(IS_GLOBAL)source = name;
  for(key in source){
    // contains in native
    own = !IS_FORCED && target && target[key] !== undefined;
    if(own && key in exports)continue;
    // export native or passed
    out = own ? target[key] : source[key];
    // prevent global pollution for namespaces
    exports[key] = IS_GLOBAL && typeof target[key] != 'function' ? source[key]
    // bind timers to global for call from export context
    : IS_BIND && own ? ctx(out, global)
    // wrap global constructors for prevent change them in library
    : IS_WRAP && target[key] == out ? (function(C){
      var F = function(a, b, c){
        if(this instanceof C){
          switch(arguments.length){
            case 0: return new C;
            case 1: return new C(a);
            case 2: return new C(a, b);
          } return new C(a, b, c);
        } return C.apply(this, arguments);
      };
      F[PROTOTYPE] = C[PROTOTYPE];
      return F;
    // make static versions for prototype methods
    })(out) : IS_PROTO && typeof out == 'function' ? ctx(Function.call, out) : out;
    // export proto methods to core.%CONSTRUCTOR%.methods.%NAME%
    if(IS_PROTO){
      (exports.virtual || (exports.virtual = {}))[key] = out;
      // export proto methods to core.%CONSTRUCTOR%.prototype.%NAME%
      if(type & $export.R && expProto && !expProto[key])hide(expProto, key, out);
    }
  }
};
// type bitmap
$export.F = 1;   // forced
$export.G = 2;   // global
$export.S = 4;   // static
$export.P = 8;   // proto
$export.B = 16;  // bind
$export.W = 32;  // wrap
$export.U = 64;  // safe
$export.R = 128; // real proto method for `library` 
module.exports = $export;

/***/ }),
/* 900 */
/***/ (function(module, exports, __webpack_require__) {

var dP         = __webpack_require__(896)
  , createDesc = __webpack_require__(906);
module.exports = __webpack_require__(897) ? function(object, key, value){
  return dP.f(object, key, createDesc(1, value));
} : function(object, key, value){
  object[key] = value;
  return object;
};

/***/ }),
/* 901 */
/***/ (function(module, exports, __webpack_require__) {

var isObject = __webpack_require__(902);
module.exports = function(it){
  if(!isObject(it))throw TypeError(it + ' is not an object!');
  return it;
};

/***/ }),
/* 902 */
/***/ (function(module, exports) {

module.exports = function(it){
  return typeof it === 'object' ? it !== null : typeof it === 'function';
};

/***/ }),
/* 903 */
/***/ (function(module, exports) {

module.exports = function(exec){
  try {
    return !!exec();
  } catch(e){
    return true;
  }
};

/***/ }),
/* 904 */
/***/ (function(module, exports) {

module.exports = {};

/***/ }),
/* 905 */
/***/ (function(module, exports) {

var id = 0
  , px = Math.random();
module.exports = function(key){
  return 'Symbol('.concat(key === undefined ? '' : key, ')_', (++id + px).toString(36));
};

/***/ }),
/* 906 */
/***/ (function(module, exports) {

module.exports = function(bitmap, value){
  return {
    enumerable  : !(bitmap & 1),
    configurable: !(bitmap & 2),
    writable    : !(bitmap & 4),
    value       : value
  };
};

/***/ }),
/* 907 */
/***/ (function(module, exports, __webpack_require__) {

// 19.1.2.14 / 15.2.3.14 Object.keys(O)
var $keys       = __webpack_require__(932)
  , enumBugKeys = __webpack_require__(918);

module.exports = Object.keys || function keys(O){
  return $keys(O, enumBugKeys);
};

/***/ }),
/* 908 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";

// CONCATENATED MODULE: ./src/utils/index.js
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash__ = __webpack_require__(183);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__generateAbsoluteUrl__ = __webpack_require__(127);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__generateRelativeUrl__ = __webpack_require__(421);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__redirectTo__ = __webpack_require__(419);









function zeroLeft(n) {
  var s = Object(__WEBPACK_IMPORTED_MODULE_0_lodash__["toString"])(n);

  if (n >= 0 && n < 10) {
    return '0' + s;
  }

  return s;
}

// CONCATENATED MODULE: ./src/components/Link/Link.js
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(71);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(182);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__history__ = __webpack_require__(185);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }






function isLeftClickEvent(event) {
  return event.button === 0;
}

function isModifiedEvent(event) {
  return !!(event.metaKey || event.altKey || event.ctrlKey || event.shiftKey);
}

var Link_Link = function (_React$Component) {
  _inherits(Link, _React$Component);

  function Link() {
    var _ref;

    var _temp, _this, _ret;

    _classCallCheck(this, Link);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = Link.__proto__ || Object.getPrototypeOf(Link)).call.apply(_ref, [this].concat(args))), _this), _this.handleClick = function (event) {
      if (_this.props.onClick) {
        _this.props.onClick(event);
      }

      if (isModifiedEvent(event) || !isLeftClickEvent(event)) {
        return;
      }

      if (event.defaultPrevented === true) {
        return;
      }

      event.preventDefault();
      __WEBPACK_IMPORTED_MODULE_2__history__["a" /* default */].push(__WEBPACK_IMPORTED_MODULE_2__generateRelativeUrl__["a"](_this.props.to));
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }

  _createClass(Link, [{
    key: 'render',
    value: function render() {
      var _props = this.props,
          to = _props.to,
          children = _props.children,
          props = _objectWithoutProperties(_props, ['to', 'children']);

      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'a',
        _extends({ href: __WEBPACK_IMPORTED_MODULE_2__generateRelativeUrl__["a"](to) }, props, { onClick: this.handleClick }),
        children
      );
    }
  }]);

  return Link;
}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component);

Link_Link.defaultProps = {
  onClick: null
};


/* harmony default export */ var Link_defaultExport = __webpack_exports__["a"] = (Link_Link);

/***/ }),
/* 909 */
/***/ (function(module, exports) {

// 7.2.1 RequireObjectCoercible(argument)
module.exports = function(it){
  if(it == undefined)throw TypeError("Can't call method on  " + it);
  return it;
};

/***/ }),
/* 910 */
/***/ (function(module, exports, __webpack_require__) {

var shared = __webpack_require__(911)('keys')
  , uid    = __webpack_require__(905);
module.exports = function(key){
  return shared[key] || (shared[key] = uid(key));
};

/***/ }),
/* 911 */
/***/ (function(module, exports, __webpack_require__) {

var global = __webpack_require__(894)
  , SHARED = '__core-js_shared__'
  , store  = global[SHARED] || (global[SHARED] = {});
module.exports = function(key){
  return store[key] || (store[key] = {});
};

/***/ }),
/* 912 */
/***/ (function(module, exports, __webpack_require__) {

// 7.1.1 ToPrimitive(input [, PreferredType])
var isObject = __webpack_require__(902);
// instead of the ES6 spec version, we didn't implement @@toPrimitive case
// and the second argument - flag - preferred type is a string
module.exports = function(it, S){
  if(!isObject(it))return it;
  var fn, val;
  if(S && typeof (fn = it.toString) == 'function' && !isObject(val = fn.call(it)))return val;
  if(typeof (fn = it.valueOf) == 'function' && !isObject(val = fn.call(it)))return val;
  if(!S && typeof (fn = it.toString) == 'function' && !isObject(val = fn.call(it)))return val;
  throw TypeError("Can't convert object to primitive value");
};

/***/ }),
/* 913 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $at  = __webpack_require__(955)(true);

// 21.1.3.27 String.prototype[@@iterator]()
__webpack_require__(930)(String, 'String', function(iterated){
  this._t = String(iterated); // target
  this._i = 0;                // next index
// 21.1.5.2.1 %StringIteratorPrototype%.next()
}, function(){
  var O     = this._t
    , index = this._i
    , point;
  if(index >= O.length)return {value: undefined, done: true};
  point = $at(O, index);
  this._i += point.length;
  return {value: point, done: false};
});

/***/ }),
/* 914 */
/***/ (function(module, exports) {

// 7.1.4 ToInteger
var ceil  = Math.ceil
  , floor = Math.floor;
module.exports = function(it){
  return isNaN(it = +it) ? 0 : (it > 0 ? floor : ceil)(it);
};

/***/ }),
/* 915 */
/***/ (function(module, exports) {

module.exports = true;

/***/ }),
/* 916 */
/***/ (function(module, exports, __webpack_require__) {

// 19.1.2.2 / 15.2.3.5 Object.create(O [, Properties])
var anObject    = __webpack_require__(901)
  , dPs         = __webpack_require__(957)
  , enumBugKeys = __webpack_require__(918)
  , IE_PROTO    = __webpack_require__(910)('IE_PROTO')
  , Empty       = function(){ /* empty */ }
  , PROTOTYPE   = 'prototype';

// Create object with fake `null` prototype: use iframe Object with cleared prototype
var createDict = function(){
  // Thrash, waste and sodomy: IE GC bug
  var iframe = __webpack_require__(928)('iframe')
    , i      = enumBugKeys.length
    , lt     = '<'
    , gt     = '>'
    , iframeDocument;
  iframe.style.display = 'none';
  __webpack_require__(962).appendChild(iframe);
  iframe.src = 'javascript:'; // eslint-disable-line no-script-url
  // createDict = iframe.contentWindow.Object;
  // html.removeChild(iframe);
  iframeDocument = iframe.contentWindow.document;
  iframeDocument.open();
  iframeDocument.write(lt + 'script' + gt + 'document.F=Object' + lt + '/script' + gt);
  iframeDocument.close();
  createDict = iframeDocument.F;
  while(i--)delete createDict[PROTOTYPE][enumBugKeys[i]];
  return createDict();
};

module.exports = Object.create || function create(O, Properties){
  var result;
  if(O !== null){
    Empty[PROTOTYPE] = anObject(O);
    result = new Empty;
    Empty[PROTOTYPE] = null;
    // add "__proto__" for Object.getPrototypeOf polyfill
    result[IE_PROTO] = O;
  } else result = createDict();
  return Properties === undefined ? result : dPs(result, Properties);
};


/***/ }),
/* 917 */
/***/ (function(module, exports) {

var toString = {}.toString;

module.exports = function(it){
  return toString.call(it).slice(8, -1);
};

/***/ }),
/* 918 */
/***/ (function(module, exports) {

// IE 8- don't enum bug keys
module.exports = (
  'constructor,hasOwnProperty,isPrototypeOf,propertyIsEnumerable,toLocaleString,toString,valueOf'
).split(',');

/***/ }),
/* 919 */
/***/ (function(module, exports, __webpack_require__) {

var def = __webpack_require__(896).f
  , has = __webpack_require__(895)
  , TAG = __webpack_require__(893)('toStringTag');

module.exports = function(it, tag, stat){
  if(it && !has(it = stat ? it : it.prototype, TAG))def(it, TAG, {configurable: true, value: tag});
};

/***/ }),
/* 920 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(963);
var global        = __webpack_require__(894)
  , hide          = __webpack_require__(900)
  , Iterators     = __webpack_require__(904)
  , TO_STRING_TAG = __webpack_require__(893)('toStringTag');

for(var collections = ['NodeList', 'DOMTokenList', 'MediaList', 'StyleSheetList', 'CSSRuleList'], i = 0; i < 5; i++){
  var NAME       = collections[i]
    , Collection = global[NAME]
    , proto      = Collection && Collection.prototype;
  if(proto && !proto[TO_STRING_TAG])hide(proto, TO_STRING_TAG, NAME);
  Iterators[NAME] = Iterators.Array;
}

/***/ }),
/* 921 */
/***/ (function(module, exports, __webpack_require__) {

exports.f = __webpack_require__(893);

/***/ }),
/* 922 */
/***/ (function(module, exports, __webpack_require__) {

var global         = __webpack_require__(894)
  , core           = __webpack_require__(892)
  , LIBRARY        = __webpack_require__(915)
  , wksExt         = __webpack_require__(921)
  , defineProperty = __webpack_require__(896).f;
module.exports = function(name){
  var $Symbol = core.Symbol || (core.Symbol = LIBRARY ? {} : global.Symbol || {});
  if(name.charAt(0) != '_' && !(name in $Symbol))defineProperty($Symbol, name, {value: wksExt.f(name)});
};

/***/ }),
/* 923 */
/***/ (function(module, exports) {

exports.f = {}.propertyIsEnumerable;

/***/ }),
/* 924 */
/***/ (function(module, exports, __webpack_require__) {

// 7.1.13 ToObject(argument)
var defined = __webpack_require__(909);
module.exports = function(it){
  return Object(defined(it));
};

/***/ }),
/* 925 */
/***/ (function(module, exports, __webpack_require__) {

// 19.1.2.9 / 15.2.3.2 Object.getPrototypeOf(O)
var has         = __webpack_require__(895)
  , toObject    = __webpack_require__(924)
  , IE_PROTO    = __webpack_require__(910)('IE_PROTO')
  , ObjectProto = Object.prototype;

module.exports = Object.getPrototypeOf || function(O){
  O = toObject(O);
  if(has(O, IE_PROTO))return O[IE_PROTO];
  if(typeof O.constructor == 'function' && O instanceof O.constructor){
    return O.constructor.prototype;
  } return O instanceof Object ? ObjectProto : null;
};

/***/ }),
/* 926 */
/***/ (function(module, exports, __webpack_require__) {

// optional / simple context binding
var aFunction = __webpack_require__(946);
module.exports = function(fn, that, length){
  aFunction(fn);
  if(that === undefined)return fn;
  switch(length){
    case 1: return function(a){
      return fn.call(that, a);
    };
    case 2: return function(a, b){
      return fn.call(that, a, b);
    };
    case 3: return function(a, b, c){
      return fn.call(that, a, b, c);
    };
  }
  return function(/* ...args */){
    return fn.apply(that, arguments);
  };
};

/***/ }),
/* 927 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = !__webpack_require__(897) && !__webpack_require__(903)(function(){
  return Object.defineProperty(__webpack_require__(928)('div'), 'a', {get: function(){ return 7; }}).a != 7;
});

/***/ }),
/* 928 */
/***/ (function(module, exports, __webpack_require__) {

var isObject = __webpack_require__(902)
  , document = __webpack_require__(894).document
  // in old IE typeof document.createElement is 'object'
  , is = isObject(document) && isObject(document.createElement);
module.exports = function(it){
  return is ? document.createElement(it) : {};
};

/***/ }),
/* 929 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _iterator = __webpack_require__(953);

var _iterator2 = _interopRequireDefault(_iterator);

var _symbol = __webpack_require__(966);

var _symbol2 = _interopRequireDefault(_symbol);

var _typeof = typeof _symbol2.default === "function" && typeof _iterator2.default === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof _symbol2.default === "function" && obj.constructor === _symbol2.default && obj !== _symbol2.default.prototype ? "symbol" : typeof obj; };

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = typeof _symbol2.default === "function" && _typeof(_iterator2.default) === "symbol" ? function (obj) {
  return typeof obj === "undefined" ? "undefined" : _typeof(obj);
} : function (obj) {
  return obj && typeof _symbol2.default === "function" && obj.constructor === _symbol2.default && obj !== _symbol2.default.prototype ? "symbol" : typeof obj === "undefined" ? "undefined" : _typeof(obj);
};

/***/ }),
/* 930 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var LIBRARY        = __webpack_require__(915)
  , $export        = __webpack_require__(899)
  , redefine       = __webpack_require__(931)
  , hide           = __webpack_require__(900)
  , has            = __webpack_require__(895)
  , Iterators      = __webpack_require__(904)
  , $iterCreate    = __webpack_require__(956)
  , setToStringTag = __webpack_require__(919)
  , getPrototypeOf = __webpack_require__(925)
  , ITERATOR       = __webpack_require__(893)('iterator')
  , BUGGY          = !([].keys && 'next' in [].keys()) // Safari has buggy iterators w/o `next`
  , FF_ITERATOR    = '@@iterator'
  , KEYS           = 'keys'
  , VALUES         = 'values';

var returnThis = function(){ return this; };

module.exports = function(Base, NAME, Constructor, next, DEFAULT, IS_SET, FORCED){
  $iterCreate(Constructor, NAME, next);
  var getMethod = function(kind){
    if(!BUGGY && kind in proto)return proto[kind];
    switch(kind){
      case KEYS: return function keys(){ return new Constructor(this, kind); };
      case VALUES: return function values(){ return new Constructor(this, kind); };
    } return function entries(){ return new Constructor(this, kind); };
  };
  var TAG        = NAME + ' Iterator'
    , DEF_VALUES = DEFAULT == VALUES
    , VALUES_BUG = false
    , proto      = Base.prototype
    , $native    = proto[ITERATOR] || proto[FF_ITERATOR] || DEFAULT && proto[DEFAULT]
    , $default   = $native || getMethod(DEFAULT)
    , $entries   = DEFAULT ? !DEF_VALUES ? $default : getMethod('entries') : undefined
    , $anyNative = NAME == 'Array' ? proto.entries || $native : $native
    , methods, key, IteratorPrototype;
  // Fix native
  if($anyNative){
    IteratorPrototype = getPrototypeOf($anyNative.call(new Base));
    if(IteratorPrototype !== Object.prototype){
      // Set @@toStringTag to native iterators
      setToStringTag(IteratorPrototype, TAG, true);
      // fix for some old engines
      if(!LIBRARY && !has(IteratorPrototype, ITERATOR))hide(IteratorPrototype, ITERATOR, returnThis);
    }
  }
  // fix Array#{values, @@iterator}.name in V8 / FF
  if(DEF_VALUES && $native && $native.name !== VALUES){
    VALUES_BUG = true;
    $default = function values(){ return $native.call(this); };
  }
  // Define iterator
  if((!LIBRARY || FORCED) && (BUGGY || VALUES_BUG || !proto[ITERATOR])){
    hide(proto, ITERATOR, $default);
  }
  // Plug for library
  Iterators[NAME] = $default;
  Iterators[TAG]  = returnThis;
  if(DEFAULT){
    methods = {
      values:  DEF_VALUES ? $default : getMethod(VALUES),
      keys:    IS_SET     ? $default : getMethod(KEYS),
      entries: $entries
    };
    if(FORCED)for(key in methods){
      if(!(key in proto))redefine(proto, key, methods[key]);
    } else $export($export.P + $export.F * (BUGGY || VALUES_BUG), NAME, methods);
  }
  return methods;
};

/***/ }),
/* 931 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__(900);

/***/ }),
/* 932 */
/***/ (function(module, exports, __webpack_require__) {

var has          = __webpack_require__(895)
  , toIObject    = __webpack_require__(898)
  , arrayIndexOf = __webpack_require__(959)(false)
  , IE_PROTO     = __webpack_require__(910)('IE_PROTO');

module.exports = function(object, names){
  var O      = toIObject(object)
    , i      = 0
    , result = []
    , key;
  for(key in O)if(key != IE_PROTO)has(O, key) && result.push(key);
  // Don't enum bug & hidden keys
  while(names.length > i)if(has(O, key = names[i++])){
    ~arrayIndexOf(result, key) || result.push(key);
  }
  return result;
};

/***/ }),
/* 933 */
/***/ (function(module, exports) {

exports.f = Object.getOwnPropertySymbols;

/***/ }),
/* 934 */
/***/ (function(module, exports, __webpack_require__) {

// 19.1.2.7 / 15.2.3.4 Object.getOwnPropertyNames(O)
var $keys      = __webpack_require__(932)
  , hiddenKeys = __webpack_require__(918).concat('length', 'prototype');

exports.f = Object.getOwnPropertyNames || function getOwnPropertyNames(O){
  return $keys(O, hiddenKeys);
};

/***/ }),
/* 935 */
/***/ (function(module, exports, __webpack_require__) {

var pIE            = __webpack_require__(923)
  , createDesc     = __webpack_require__(906)
  , toIObject      = __webpack_require__(898)
  , toPrimitive    = __webpack_require__(912)
  , has            = __webpack_require__(895)
  , IE8_DOM_DEFINE = __webpack_require__(927)
  , gOPD           = Object.getOwnPropertyDescriptor;

exports.f = __webpack_require__(897) ? gOPD : function getOwnPropertyDescriptor(O, P){
  O = toIObject(O);
  P = toPrimitive(P, true);
  if(IE8_DOM_DEFINE)try {
    return gOPD(O, P);
  } catch(e){ /* empty */ }
  if(has(O, P))return createDesc(!pIE.f.call(O, P), O[P]);
};

/***/ }),
/* 936 */
/***/ (function(module, exports, __webpack_require__) {


    var content = __webpack_require__(989);
    var insertCss = __webpack_require__(889);

    if (typeof content === 'string') {
      content = [[module.i, content, '']];
    }

    module.exports = content.locals || {};
    module.exports._getContent = function() { return content; };
    module.exports._getCss = function() { return content.toString(); };
    module.exports._insertCss = function(options) { return insertCss(content, options) };
    
    // Hot Module Replacement
    // https://webpack.github.io/docs/hot-module-replacement
    // Only activated in browser context
    if (false) {
      var removeCss = function() {};
      module.hot.accept("!!../css-loader/index.js??ref--2-rules-1!../postcss-loader/lib/index.js??ref--2-rules-3!./normalize.css", function() {
        content = require("!!../css-loader/index.js??ref--2-rules-1!../postcss-loader/lib/index.js??ref--2-rules-3!./normalize.css");

        if (typeof content === 'string') {
          content = [[module.id, content, '']];
        }

        removeCss = insertCss(content, { replace: true });
      });
      module.hot.dispose(function() { removeCss(); });
    }
  

/***/ }),
/* 937 */
/***/ (function(module, exports, __webpack_require__) {

// getting tag from 19.1.3.6 Object.prototype.toString()
var cof = __webpack_require__(917)
  , TAG = __webpack_require__(893)('toStringTag')
  // ES3 wrong here
  , ARG = cof(function(){ return arguments; }()) == 'Arguments';

// fallback for IE11 Script Access Denied error
var tryGet = function(it, key){
  try {
    return it[key];
  } catch(e){ /* empty */ }
};

module.exports = function(it){
  var O, T, B;
  return it === undefined ? 'Undefined' : it === null ? 'Null'
    // @@toStringTag case
    : typeof (T = tryGet(O = Object(it), TAG)) == 'string' ? T
    // builtinTag case
    : ARG ? cof(O)
    // ES3 arguments fallback
    : (B = cof(O)) == 'Object' && typeof O.callee == 'function' ? 'Arguments' : B;
};

/***/ }),
/* 938 */
/***/ (function(module, exports, __webpack_require__) {


    var content = __webpack_require__(1025);
    var insertCss = __webpack_require__(889);

    if (typeof content === 'string') {
      content = [[module.i, content, '']];
    }

    module.exports = content.locals || {};
    module.exports._getContent = function() { return content; };
    module.exports._getCss = function() { return content.toString(); };
    module.exports._insertCss = function(options) { return insertCss(content, options) };
    
    // Hot Module Replacement
    // https://webpack.github.io/docs/hot-module-replacement
    // Only activated in browser context
    if (false) {
      var removeCss = function() {};
      module.hot.accept("!!../../../../node_modules/css-loader/index.js??ref--2-rules-2!../../../../node_modules/postcss-loader/lib/index.js??ref--2-rules-3!./ModalError.css", function() {
        content = require("!!../../../../node_modules/css-loader/index.js??ref--2-rules-2!../../../../node_modules/postcss-loader/lib/index.js??ref--2-rules-3!./ModalError.css");

        if (typeof content === 'string') {
          content = [[module.id, content, '']];
        }

        removeCss = insertCss(content, { replace: true });
      });
      module.hot.dispose(function() { removeCss(); });
    }
  

/***/ }),
/* 939 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(71);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_redux__ = __webpack_require__(415);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_isomorphic_style_loader_lib_withStyles__ = __webpack_require__(887);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_isomorphic_style_loader_lib_withStyles___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_isomorphic_style_loader_lib_withStyles__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__ModalError_css__ = __webpack_require__(938);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__ModalError_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__ModalError_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__clientConfig__ = __webpack_require__(128);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__clientConfig___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__clientConfig__);
var _jsx = function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; }();

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

/* eslint react/no-did-mount-set-state: 0 */
/* eslint react/prop-types: 0 */
/* eslint consistent-return: 0 */
/* global $ */






var _ref = _jsx('div', {
  className: 'modal-header'
}, void 0, _jsx('h5', {
  className: 'modal-title'
}, void 0, 'Error'), _jsx('button', {
  type: 'button',
  className: 'close',
  'data-dismiss': 'modal',
  'aria-label': 'Close'
}, void 0, _jsx('span', {
  'aria-hidden': 'true'
}, void 0, '\xD7')));

var ModalError = function (_React$Component) {
  _inherits(ModalError, _React$Component);

  function ModalError() {
    _classCallCheck(this, ModalError);

    return _possibleConstructorReturn(this, (ModalError.__proto__ || Object.getPrototypeOf(ModalError)).apply(this, arguments));
  }

  _createClass(ModalError, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      $('#ModalError').modal({ backdrop: 'static', keyboard: false });
      $('.close').hide();
    }
  }, {
    key: 'render',
    value: function render() {
      var hideLayout = this.props.hideLayout;

      var url = __WEBPACK_IMPORTED_MODULE_4__clientConfig__["urlPrefix"] + '/telemedicina/solicitud-turnos';

      // Para el iframe que se implementa en el dashboard de la web
      if (hideLayout) {
        url += '?hideLayout=true';
      }

      return _jsx('div', {
        className: 'modal fade',
        id: 'ModalError'
      }, void 0, _jsx('div', {
        className: 'modal-dialog'
      }, void 0, _jsx('div', {
        className: __WEBPACK_IMPORTED_MODULE_3__ModalError_css___default.a.modalContent + ' modal-content'
      }, void 0, _ref, _jsx('div', {
        className: __WEBPACK_IMPORTED_MODULE_3__ModalError_css___default.a.modalBody + ' modal-body'
      }, void 0, _jsx('div', {}, void 0, this.props.msg)), _jsx('div', {
        className: __WEBPACK_IMPORTED_MODULE_3__ModalError_css___default.a.modalFooter + ' modal-footer'
      }, void 0, _jsx('a', {
        type: 'button',
        className: 'btn btn-default',
        style: {
          width: '140px',
          color: '#fff',
          fontSize: '14px',
          backgroundColor: '#e4002b',
          cursor: 'pointer',
          borderRadius: '.25rem',
          fontFamily: 'Roboto, Medium, sans-serif',
          fontWeight: 'bold'
        },
        href: url
      }, void 0, 'Aceptar')))));
    }
  }]);

  return ModalError;
}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component);

var mapStateToProps = function mapStateToProps(state) {
  return {
    hideLayout: state.auth.hideLayout
  };
};

/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_1_react_redux__["b" /* connect */])(mapStateToProps, null)(__WEBPACK_IMPORTED_MODULE_2_isomorphic_style_loader_lib_withStyles___default()(__WEBPACK_IMPORTED_MODULE_3__ModalError_css___default.a)(ModalError)));

/***/ }),
/* 940 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(71);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_isomorphic_style_loader_lib_withStyles__ = __webpack_require__(887);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_isomorphic_style_loader_lib_withStyles___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_isomorphic_style_loader_lib_withStyles__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_normalize_css__ = __webpack_require__(936);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_normalize_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_normalize_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__Loading_css__ = __webpack_require__(1109);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__Loading_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__Loading_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__images_4_gif__ = __webpack_require__(1111);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__images_4_gif___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__images_4_gif__);
var _jsx = function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; }();

/**
 * @author Juan Carlos Cancela <cancela.juancarlos@gmail.com>
 */




// external-global styles must be imported in your JS.




var _ref = _jsx('img', {
  src: __WEBPACK_IMPORTED_MODULE_4__images_4_gif___default.a,
  alt: 'loading'
});

function Loading(props) {
  return _jsx('div', {
    className: __WEBPACK_IMPORTED_MODULE_3__Loading_css___default.a.root
  }, void 0, _jsx('div', {
    className: __WEBPACK_IMPORTED_MODULE_3__Loading_css___default.a.container
  }, void 0, _ref));
}

/* harmony default export */ __webpack_exports__["a"] = (__WEBPACK_IMPORTED_MODULE_1_isomorphic_style_loader_lib_withStyles___default()(__WEBPACK_IMPORTED_MODULE_2_normalize_css___default.a, __WEBPACK_IMPORTED_MODULE_3__Loading_css___default.a)(Loading));

/***/ }),
/* 941 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";

// CONCATENATED MODULE: ./src/components/ExternalLink/ExternalLink.js
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(71);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(182);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };




function ExternalLink(props) {
  var to = props.to,
      children = props.children,
      target = props.target;

  var properties = props;
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    'a',
    _extends({ href: to }, properties, { target: target }),
    children
  );
}

/* harmony default export */ var ExternalLink_defaultExport = (ExternalLink);
// CONCATENATED MODULE: ./src/components/Navigation/Navigation.js
/* harmony import */ var Navigation___WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(71);
/* harmony import */ var Navigation___WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(Navigation___WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_redux__ = __webpack_require__(415);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_isomorphic_style_loader_lib_withStyles__ = __webpack_require__(887);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_isomorphic_style_loader_lib_withStyles___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_isomorphic_style_loader_lib_withStyles__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_lodash__ = __webpack_require__(183);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__actions_authActions__ = __webpack_require__(184);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__constants__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__Navigation_css__ = __webpack_require__(1010);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__Navigation_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__Navigation_css__);
var _jsx = function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; }();

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

/**
 * @author Juan Carlos Cancela <cancela.juancarlos@gmail.com>
 */
/* eslint react/no-did-mount-set-state: 0 */
/* eslint react/prop-types: 0 */
/* eslint consistent-return: 0 */










var LOGIN_STATUS_PENDING = 'pending';
var LOGIN_STATUS_NOT_LOGGED_IN = 'not-logged-in';

var Navigation_Navigation = function (_React$Component) {
  _inherits(Navigation, _React$Component);

  function Navigation(props) {
    _classCallCheck(this, Navigation);

    var _this = _possibleConstructorReturn(this, (Navigation.__proto__ || Object.getPrototypeOf(Navigation)).call(this, props));

    _this.state = {
      loginStatus: LOGIN_STATUS_PENDING
    };
    return _this;
  }

  _createClass(Navigation, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      var auth = localStorage.getItem(__WEBPACK_IMPORTED_MODULE_5__constants__["_30" /* LOCALSTORAGE_AUTH_KEY */]);
      if (__WEBPACK_IMPORTED_MODULE_3_lodash___default.a.isEmpty(auth)) {
        this.setState({ loginStatus: LOGIN_STATUS_NOT_LOGGED_IN });
      } else {
        this.props.authSuccess(JSON.parse(auth));
      }
    }
  }, {
    key: 'render',
    value: function render() {
      return _jsx('div', {
        className: __WEBPACK_IMPORTED_MODULE_6__Navigation_css___default.a.root + ' hidden-sm-down',
        role: 'navigation',
        id: 'navigation_top'
      }, void 0, __WEBPACK_IMPORTED_MODULE_3_lodash___default.a.isEmpty(this.props.auth) ? _jsx('ul', {}, void 0, _jsx('li', {}, void 0, _jsx(ExternalLink_defaultExport, {
        className: __WEBPACK_IMPORTED_MODULE_6__Navigation_css___default.a.link + ' ' + __WEBPACK_IMPORTED_MODULE_6__Navigation_css___default.a.active + ' ',
        target: '_self',
        to: __WEBPACK_IMPORTED_MODULE_5__constants__["_24" /* HOST_SERVER */] + 'smgnewsite/prepaga/index.php'
      }, void 0, 'PERSONAS')), _jsx('li', {}, void 0, _jsx('span', {
        className: __WEBPACK_IMPORTED_MODULE_6__Navigation_css___default.a.spacer
      }, void 0, ' | ')), _jsx('li', {}, void 0, _jsx(ExternalLink_defaultExport, {
        className: __WEBPACK_IMPORTED_MODULE_6__Navigation_css___default.a.link,
        target: '_self',
        to: __WEBPACK_IMPORTED_MODULE_5__constants__["_24" /* HOST_SERVER */] + 'smgnewsite/prepagaempresas/index.php'
      }, void 0, 'EMPRESAS')), _jsx('li', {}, void 0, _jsx('span', {
        className: __WEBPACK_IMPORTED_MODULE_6__Navigation_css___default.a.spacer
      }, void 0, ' | ')), _jsx(ExternalLink_defaultExport, {
        className: __WEBPACK_IMPORTED_MODULE_6__Navigation_css___default.a.link,
        target: '_self',
        to: __WEBPACK_IMPORTED_MODULE_5__constants__["_24" /* HOST_SERVER */] + 'smgnewsite/prestadores/home'
      }, void 0, 'PRESTADORES'), _jsx('li', {}, void 0, _jsx('span', {
        className: __WEBPACK_IMPORTED_MODULE_6__Navigation_css___default.a.spacer
      }, void 0, ' | ')), _jsx('li', {}, void 0, _jsx(ExternalLink_defaultExport, {
        className: __WEBPACK_IMPORTED_MODULE_6__Navigation_css___default.a.link,
        target: '_self',
        to: __WEBPACK_IMPORTED_MODULE_5__constants__["_24" /* HOST_SERVER */] + 'proveedores'
      }, void 0, 'PROVEEDORES')), _jsx('li', {}, void 0, _jsx('span', {
        className: __WEBPACK_IMPORTED_MODULE_6__Navigation_css___default.a.spacer
      }, void 0, ' | ')), _jsx('li', {}, void 0, _jsx(ExternalLink_defaultExport, {
        className: __WEBPACK_IMPORTED_MODULE_6__Navigation_css___default.a.link,
        target: '_self',
        to: 'https://sts.swissmedical.com.ar/adfs/ls/?client-request-id=8dd8db82-48a4-402a-8cc2-bc85131f4299&username=&wa=wsignin1.0&wtrealm=urn%3afederation%3aMicrosoftOnline&wctx=estsredirect%3d2%26estsrequest%3drQIIAeNisDLKKCkpKLbS1y8uzywuzk1NyUxOzEkvyi8t0CvOSCxKLcjPzCvRS87P1csvSs9MAbGKhLgEmm7f6F3ioeXQc2hPq7C808xZjMLIBoA1JBatYvQh1nj94syS1GL95Py81OSSxJT8Yv2AxPTMvMRi_cy8lNQKvcTigooLjIwvGBlvMQn6F6V7poQXu6WmpBYllmTm511gEXjFwmPAbMXBwSbAKMGgwPCDhXERK9ChCVl28VuL5Bzn9u69xsTFznCKVT_SK8o4wCQ92LRAOy_S0TUsNTjL3yInItGsOKus1ELfJMfR1zUy0zTPzdPT1sDKcAKb0AQ2plNsDLs4qeobAA2'
      }, void 0, 'COLABORADORES')), _jsx('li', {}, void 0, _jsx('span', {
        className: __WEBPACK_IMPORTED_MODULE_6__Navigation_css___default.a.spacer
      }, void 0, ' | ')), _jsx('li', {}, void 0, _jsx(ExternalLink_defaultExport, {
        className: __WEBPACK_IMPORTED_MODULE_6__Navigation_css___default.a.link,
        target: '_self',
        to: 'http://rrhh.swissmedical.com.ar/frontend/index.asp'
      }, void 0, 'RRHH'))) : null);
    }
  }]);

  return Navigation;
}(Navigation___WEBPACK_IMPORTED_MODULE_0_react___default.a.Component);

var mapStateToProps = function mapStateToProps(state) {
  return {
    auth: state.auth
  };
};

/* harmony default export */ var Navigation_defaultExport = (Object(__WEBPACK_IMPORTED_MODULE_1_react_redux__["b" /* connect */])(mapStateToProps, __WEBPACK_IMPORTED_MODULE_4__actions_authActions__)(__WEBPACK_IMPORTED_MODULE_2_isomorphic_style_loader_lib_withStyles___default()(__WEBPACK_IMPORTED_MODULE_6__Navigation_css___default.a)(Navigation_Navigation)));
// CONCATENATED MODULE: ./src/components/Login/ModalErrorLogin/ModalErrorLogin.js
/* harmony import */ var ModalErrorLogin___WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(71);
/* harmony import */ var ModalErrorLogin___WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(ModalErrorLogin___WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var ModalErrorLogin___WEBPACK_IMPORTED_MODULE_1_react_redux__ = __webpack_require__(415);
/* harmony import */ var ModalErrorLogin___WEBPACK_IMPORTED_MODULE_2_isomorphic_style_loader_lib_withStyles__ = __webpack_require__(887);
/* harmony import */ var ModalErrorLogin___WEBPACK_IMPORTED_MODULE_2_isomorphic_style_loader_lib_withStyles___default = __webpack_require__.n(ModalErrorLogin___WEBPACK_IMPORTED_MODULE_2_isomorphic_style_loader_lib_withStyles__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__ModalErrorLogin_css__ = __webpack_require__(1015);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__ModalErrorLogin_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__ModalErrorLogin_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__constants__ = __webpack_require__(17);
var ModalErrorLogin__jsx = function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; }();

var ModalErrorLogin__createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function ModalErrorLogin__classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function ModalErrorLogin__possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function ModalErrorLogin__inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

/* eslint react/no-did-mount-set-state: 0 */
/* eslint react/prop-types: 0 */
/* eslint consistent-return: 0 */
/* global $ */






var _ref = ModalErrorLogin__jsx('b', {}, void 0, 'Error en DNI y/o contrase\xF1a');

var _ref2 = ModalErrorLogin__jsx('path', {
  d: 'M256 8C119 8 8 119 8 256s111 248 248 248 248-111 248-248S393 8 256 8zm0 448c-110.5 0-200-89.5-200-200S145.5 56 256 56s200 89.5 200 200-89.5 200-200 200zm101.8-262.2L295.6 256l62.2 62.2c4.7 4.7 4.7 12.3 0 17l-22.6 22.6c-4.7 4.7-12.3 4.7-17 0L256 295.6l-62.2 62.2c-4.7 4.7-12.3 4.7-17 0l-22.6-22.6c-4.7-4.7-4.7-12.3 0-17l62.2-62.2-62.2-62.2c-4.7-4.7-4.7-12.3 0-17l22.6-22.6c4.7-4.7 12.3-4.7 17 0l62.2 62.2 62.2-62.2c4.7-4.7 12.3-4.7 17 0l22.6 22.6c4.7 4.7 4.7 12.3 0 17z'
});

var _ref3 = ModalErrorLogin__jsx('br', {});

var _ref4 = ModalErrorLogin__jsx('div', {
  className: 'row row-text'
}, void 0, ModalErrorLogin__jsx('div', {
  className: 'col-md-12 text-center'
}, void 0, ModalErrorLogin__jsx('p', {}, void 0, ModalErrorLogin__jsx('b', {
  className: 'inte'
}, void 0, 'Tu DNI y/o contrase\xF1a son incorrectos.'), ModalErrorLogin__jsx('br', {}), 'Por favor intentalo nuevamente.')));

var ModalErrorLogin = function (_React$Component) {
  ModalErrorLogin__inherits(ModalErrorLogin, _React$Component);

  function ModalErrorLogin() {
    ModalErrorLogin__classCallCheck(this, ModalErrorLogin);

    return ModalErrorLogin__possibleConstructorReturn(this, (ModalErrorLogin.__proto__ || Object.getPrototypeOf(ModalErrorLogin)).apply(this, arguments));
  }

  ModalErrorLogin__createClass(ModalErrorLogin, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      $('#ModalErrorLogin').modal({ backdrop: 'static', keyboard: false });
      $('.close').hide();
    }
  }, {
    key: 'render',
    value: function render() {
      return ModalErrorLogin__jsx('div', {
        className: 'modal fade modal-admin in',
        id: 'ModalErrorLogin',
        tabIndex: '-1',
        role: 'dialog',
        'aria-labelledby': 'myModalLabel',
        'aria-hidden': 'false'
      }, void 0, ModalErrorLogin__jsx('div', {
        className: 'modal-dialog',
        role: 'document'
      }, void 0, ModalErrorLogin__jsx('div', {
        className: 'modal-content'
      }, void 0, ModalErrorLogin__jsx('div', {
        className: __WEBPACK_IMPORTED_MODULE_3__ModalErrorLogin_css___default.a.header + ' modal-header'
      }, void 0, ModalErrorLogin__jsx('h4', {
        className: 'modal-title',
        style: { fontSize: '20px' }
      }, void 0, _ref)), ModalErrorLogin__jsx('div', {
        className: 'modal-body'
      }, void 0, ModalErrorLogin__jsx('div', {
        className: 'row'
      }, void 0, ModalErrorLogin__jsx('div', {
        className: 'col-md-12 text-center'
      }, void 0, ModalErrorLogin__jsx('svg', {
        xmlns: 'http://www.w3.org/2000/svg',
        viewBox: '0 0 512 512',
        className: '' + __WEBPACK_IMPORTED_MODULE_3__ModalErrorLogin_css___default.a.icono,
        width: '68px',
        height: '68px'
      }, void 0, _ref2))), _ref3, _ref4), ModalErrorLogin__jsx('div', {
        className: 'modal-footer'
      }, void 0, ModalErrorLogin__jsx('div', {
        className: 'col-6 text-center'
      }, void 0, ModalErrorLogin__jsx('button', {
        'data-dismiss': 'modal',
        className: __WEBPACK_IMPORTED_MODULE_3__ModalErrorLogin_css___default.a.boton_blanco + ' btn btn-default text-center',
        onClick: function onClick() {
          ModalErrorLogin.redirectToRecuperoPass();
        }
      }, void 0, 'Olvid\xE9 mi contrase\xF1a')), ModalErrorLogin__jsx('div', {
        className: 'col-6 text-center'
      }, void 0, ModalErrorLogin__jsx('button', {
        'data-dismiss': 'modal',
        className: __WEBPACK_IMPORTED_MODULE_3__ModalErrorLogin_css___default.a.boton_rojo + ' btn btn-danger text-center',
        onClick: function onClick() {
          location.reload();
        }
      }, void 0, 'Aceptar'))))));
    }
  }], [{
    key: 'redirectToRecuperoPass',
    value: function redirectToRecuperoPass() {
      window.location.href = __WEBPACK_IMPORTED_MODULE_4__constants__["_24" /* HOST_SERVER */] + 'smgnewsite/prepaga/olvido_password.php';
    }
  }]);

  return ModalErrorLogin;
}(ModalErrorLogin___WEBPACK_IMPORTED_MODULE_0_react___default.a.Component);

/* harmony default export */ var ModalErrorLogin_defaultExport = (Object(ModalErrorLogin___WEBPACK_IMPORTED_MODULE_1_react_redux__["b" /* connect */])(null, null)(ModalErrorLogin___WEBPACK_IMPORTED_MODULE_2_isomorphic_style_loader_lib_withStyles___default()(__WEBPACK_IMPORTED_MODULE_3__ModalErrorLogin_css___default.a)(ModalErrorLogin)));
// CONCATENATED MODULE: ./src/components/Login/ModalUsuarioBloqueado/ModalUsuarioBloqueado.js
/* harmony import */ var ModalUsuarioBloqueado___WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(71);
/* harmony import */ var ModalUsuarioBloqueado___WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(ModalUsuarioBloqueado___WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var ModalUsuarioBloqueado___WEBPACK_IMPORTED_MODULE_1_react_redux__ = __webpack_require__(415);
/* harmony import */ var ModalUsuarioBloqueado___WEBPACK_IMPORTED_MODULE_2_isomorphic_style_loader_lib_withStyles__ = __webpack_require__(887);
/* harmony import */ var ModalUsuarioBloqueado___WEBPACK_IMPORTED_MODULE_2_isomorphic_style_loader_lib_withStyles___default = __webpack_require__.n(ModalUsuarioBloqueado___WEBPACK_IMPORTED_MODULE_2_isomorphic_style_loader_lib_withStyles__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__ModalUsuarioBloqueado_css__ = __webpack_require__(1017);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__ModalUsuarioBloqueado_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__ModalUsuarioBloqueado_css__);
/* harmony import */ var ModalUsuarioBloqueado___WEBPACK_IMPORTED_MODULE_4__constants__ = __webpack_require__(17);
var ModalUsuarioBloqueado__jsx = function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; }();

var ModalUsuarioBloqueado__createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function ModalUsuarioBloqueado__classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function ModalUsuarioBloqueado__possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function ModalUsuarioBloqueado__inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

/* eslint react/no-did-mount-set-state: 0 */
/* eslint react/prop-types: 0 */
/* eslint consistent-return: 0 */
/* global $ */






var ModalUsuarioBloqueado__ref = ModalUsuarioBloqueado__jsx('path', {
  d: 'M256 8C119 8 8 119 8 256s111 248 248 248 248-111 248-248S393 8 256 8zm0 448c-110.5 0-200-89.5-200-200S145.5 56 256 56s200 89.5 200 200-89.5 200-200 200zm101.8-262.2L295.6 256l62.2 62.2c4.7 4.7 4.7 12.3 0 17l-22.6 22.6c-4.7 4.7-12.3 4.7-17 0L256 295.6l-62.2 62.2c-4.7 4.7-12.3 4.7-17 0l-22.6-22.6c-4.7-4.7-4.7-12.3 0-17l62.2-62.2-62.2-62.2c-4.7-4.7-4.7-12.3 0-17l22.6-22.6c4.7-4.7 12.3-4.7 17 0l62.2 62.2 62.2-62.2c4.7-4.7 12.3-4.7 17 0l22.6 22.6c4.7 4.7 4.7 12.3 0 17z'
});

var ModalUsuarioBloqueado__ref2 = ModalUsuarioBloqueado__jsx('br', {});

var ModalUsuarioBloqueado__ref3 = ModalUsuarioBloqueado__jsx('div', {
  className: 'row row-text'
}, void 0, ModalUsuarioBloqueado__jsx('div', {
  className: 'col-md-12 text-center'
}, void 0, ModalUsuarioBloqueado__jsx('p', {}, void 0, 'Tu cuenta ha sido bloqueada porque superaste el l\xEDmite de intentos fallidos. A continuaci\xF3n podr\xE1s restablecer tu contrase\xF1a.')));

var ModalUsuarioBloqueado = function (_React$Component) {
  ModalUsuarioBloqueado__inherits(ModalUsuarioBloqueado, _React$Component);

  function ModalUsuarioBloqueado() {
    ModalUsuarioBloqueado__classCallCheck(this, ModalUsuarioBloqueado);

    return ModalUsuarioBloqueado__possibleConstructorReturn(this, (ModalUsuarioBloqueado.__proto__ || Object.getPrototypeOf(ModalUsuarioBloqueado)).apply(this, arguments));
  }

  ModalUsuarioBloqueado__createClass(ModalUsuarioBloqueado, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      $('#ModalUsuarioBloqueado').modal({ backdrop: 'static', keyboard: false });
      $('.close').hide();
    }
  }, {
    key: 'render',
    value: function render() {
      return ModalUsuarioBloqueado__jsx('div', {
        className: 'modal fade modal-admin in',
        id: 'ModalUsuarioBloqueado',
        tabIndex: '-1',
        role: 'dialog',
        'aria-labelledby': 'myModalLabel',
        'aria-hidden': 'false'
      }, void 0, ModalUsuarioBloqueado__jsx('div', {
        className: 'modal-dialog',
        role: 'document'
      }, void 0, ModalUsuarioBloqueado__jsx('div', {
        className: 'modal-content'
      }, void 0, ' ', ModalUsuarioBloqueado__jsx('div', {
        className: 'modal-body'
      }, void 0, ModalUsuarioBloqueado__jsx('div', {
        className: 'row'
      }, void 0, ModalUsuarioBloqueado__jsx('div', {
        className: 'col-md-12 text-center'
      }, void 0, ModalUsuarioBloqueado__jsx('svg', {
        xmlns: 'http://www.w3.org/2000/svg',
        viewBox: '0 0 512 512',
        className: '' + __WEBPACK_IMPORTED_MODULE_3__ModalUsuarioBloqueado_css___default.a.icono,
        width: '68px',
        height: '68px'
      }, void 0, ModalUsuarioBloqueado__ref))), ModalUsuarioBloqueado__ref2, ModalUsuarioBloqueado__ref3), ModalUsuarioBloqueado__jsx('div', {
        className: 'modal-footer'
      }, void 0, ModalUsuarioBloqueado__jsx('div', {
        className: 'col-12 text-center'
      }, void 0, ModalUsuarioBloqueado__jsx('button', {
        'data-dismiss': 'modal',
        className: __WEBPACK_IMPORTED_MODULE_3__ModalUsuarioBloqueado_css___default.a.boton_rojo + ' btn btn-danger text-center',
        onClick: function onClick() {
          ModalUsuarioBloqueado.redirectToRecuperoPass();
        }
      }, void 0, 'Aceptar'))))));
    }
  }], [{
    key: 'redirectToRecuperoPass',
    value: function redirectToRecuperoPass() {
      window.location.href = ModalUsuarioBloqueado___WEBPACK_IMPORTED_MODULE_4__constants__["_24" /* HOST_SERVER */] + 'smgnewsite/prepaga/olvido_password.php';
    }
  }]);

  return ModalUsuarioBloqueado;
}(ModalUsuarioBloqueado___WEBPACK_IMPORTED_MODULE_0_react___default.a.Component);

/* harmony default export */ var ModalUsuarioBloqueado_defaultExport = (Object(ModalUsuarioBloqueado___WEBPACK_IMPORTED_MODULE_1_react_redux__["b" /* connect */])(null, null)(ModalUsuarioBloqueado___WEBPACK_IMPORTED_MODULE_2_isomorphic_style_loader_lib_withStyles___default()(__WEBPACK_IMPORTED_MODULE_3__ModalUsuarioBloqueado_css___default.a)(ModalUsuarioBloqueado)));
// CONCATENATED MODULE: ./src/components/Login/ModalUsuarioNoRegistrado/ModalUsuarioNoRegistrado.js
/* harmony import */ var ModalUsuarioNoRegistrado___WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(71);
/* harmony import */ var ModalUsuarioNoRegistrado___WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(ModalUsuarioNoRegistrado___WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var ModalUsuarioNoRegistrado___WEBPACK_IMPORTED_MODULE_1_react_redux__ = __webpack_require__(415);
/* harmony import */ var ModalUsuarioNoRegistrado___WEBPACK_IMPORTED_MODULE_2_isomorphic_style_loader_lib_withStyles__ = __webpack_require__(887);
/* harmony import */ var ModalUsuarioNoRegistrado___WEBPACK_IMPORTED_MODULE_2_isomorphic_style_loader_lib_withStyles___default = __webpack_require__.n(ModalUsuarioNoRegistrado___WEBPACK_IMPORTED_MODULE_2_isomorphic_style_loader_lib_withStyles__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__ModalUsuarioNoRegistrado_css__ = __webpack_require__(1019);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__ModalUsuarioNoRegistrado_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__ModalUsuarioNoRegistrado_css__);
/* harmony import */ var ModalUsuarioNoRegistrado___WEBPACK_IMPORTED_MODULE_4__constants__ = __webpack_require__(17);
var ModalUsuarioNoRegistrado__jsx = function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; }();

var ModalUsuarioNoRegistrado__createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function ModalUsuarioNoRegistrado__classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function ModalUsuarioNoRegistrado__possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function ModalUsuarioNoRegistrado__inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

/* eslint react/no-did-mount-set-state: 0 */
/* eslint react/prop-types: 0 */
/* eslint consistent-return: 0 */
/* global $ */






var ModalUsuarioNoRegistrado__ref = ModalUsuarioNoRegistrado__jsx('b', {}, void 0, 'Usuario no registrado');

var ModalUsuarioNoRegistrado__ref2 = ModalUsuarioNoRegistrado__jsx('path', {
  d: 'M256 8C119 8 8 119 8 256s111 248 248 248 248-111 248-248S393 8 256 8zm0 448c-110.5 0-200-89.5-200-200S145.5 56 256 56s200 89.5 200 200-89.5 200-200 200zm101.8-262.2L295.6 256l62.2 62.2c4.7 4.7 4.7 12.3 0 17l-22.6 22.6c-4.7 4.7-12.3 4.7-17 0L256 295.6l-62.2 62.2c-4.7 4.7-12.3 4.7-17 0l-22.6-22.6c-4.7-4.7-4.7-12.3 0-17l62.2-62.2-62.2-62.2c-4.7-4.7-4.7-12.3 0-17l22.6-22.6c4.7-4.7 12.3-4.7 17 0l62.2 62.2 62.2-62.2c4.7-4.7 12.3-4.7 17 0l22.6 22.6c4.7 4.7 4.7 12.3 0 17z'
});

var ModalUsuarioNoRegistrado__ref3 = ModalUsuarioNoRegistrado__jsx('br', {});

var ModalUsuarioNoRegistrado = function (_React$Component) {
  ModalUsuarioNoRegistrado__inherits(ModalUsuarioNoRegistrado, _React$Component);

  function ModalUsuarioNoRegistrado() {
    ModalUsuarioNoRegistrado__classCallCheck(this, ModalUsuarioNoRegistrado);

    return ModalUsuarioNoRegistrado__possibleConstructorReturn(this, (ModalUsuarioNoRegistrado.__proto__ || Object.getPrototypeOf(ModalUsuarioNoRegistrado)).apply(this, arguments));
  }

  ModalUsuarioNoRegistrado__createClass(ModalUsuarioNoRegistrado, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      $('#ModalUsuarioNoRegistrado').modal({
        backdrop: 'static',
        keyboard: false
      });
      $('.close').hide();
    }
  }, {
    key: 'render',
    value: function render() {
      return ModalUsuarioNoRegistrado__jsx('div', {
        className: 'modal fade modal-admin in',
        id: 'ModalUsuarioNoRegistrado',
        tabIndex: '-1',
        role: 'dialog',
        'aria-labelledby': 'myModalLabel',
        'aria-hidden': 'false'
      }, void 0, ModalUsuarioNoRegistrado__jsx('div', {
        className: 'modal-dialog',
        role: 'document'
      }, void 0, ModalUsuarioNoRegistrado__jsx('div', {
        className: 'modal-content'
      }, void 0, ModalUsuarioNoRegistrado__jsx('div', {
        className: __WEBPACK_IMPORTED_MODULE_3__ModalUsuarioNoRegistrado_css___default.a.header + ' modal-header'
      }, void 0, ModalUsuarioNoRegistrado__jsx('h4', {
        className: 'modal-title',
        style: { fontSize: '20px' }
      }, void 0, ModalUsuarioNoRegistrado__ref)), ModalUsuarioNoRegistrado__jsx('div', {
        className: 'modal-body'
      }, void 0, ModalUsuarioNoRegistrado__jsx('div', {
        className: 'row'
      }, void 0, ModalUsuarioNoRegistrado__jsx('div', {
        className: 'col-md-12 text-center'
      }, void 0, ModalUsuarioNoRegistrado__jsx('svg', {
        xmlns: 'http://www.w3.org/2000/svg',
        viewBox: '0 0 512 512',
        className: '' + __WEBPACK_IMPORTED_MODULE_3__ModalUsuarioNoRegistrado_css___default.a.icono,
        width: '68px',
        height: '68px'
      }, void 0, ModalUsuarioNoRegistrado__ref2))), ModalUsuarioNoRegistrado__ref3, ModalUsuarioNoRegistrado__jsx('div', {
        className: 'row row-text'
      }, void 0, ModalUsuarioNoRegistrado__jsx('div', {
        className: 'col-md-12 text-center'
      }, void 0, ModalUsuarioNoRegistrado__jsx('p', {}, void 0, ModalUsuarioNoRegistrado__jsx('b', {}, void 0, 'Su DNI ' + $('#userField').val() + ' no est\xE1 registrado para utilizar en nuestro sitio web'))))), ModalUsuarioNoRegistrado__jsx('div', {
        className: 'modal-footer'
      }, void 0, ModalUsuarioNoRegistrado__jsx('div', {
        className: 'col-6 text-center'
      }, void 0, ModalUsuarioNoRegistrado__jsx('button', {
        'data-dismiss': 'modal',
        className: __WEBPACK_IMPORTED_MODULE_3__ModalUsuarioNoRegistrado_css___default.a.boton_blanco + ' btn btn-default text-center',
        onClick: function onClick() {
          location.reload();
        }
      }, void 0, 'Cancelar')), ModalUsuarioNoRegistrado__jsx('div', {
        className: 'col-6 text-center'
      }, void 0, ModalUsuarioNoRegistrado__jsx('button', {
        'data-dismiss': 'modal',
        className: __WEBPACK_IMPORTED_MODULE_3__ModalUsuarioNoRegistrado_css___default.a.boton_rojo + ' btn btn-danger text-center',
        onClick: function onClick() {
          ModalUsuarioNoRegistrado.redirectToRegistracion();
        }
      }, void 0, 'Registrarse'))))));
    }
  }], [{
    key: 'redirectToRegistracion',
    value: function redirectToRegistracion() {
      window.location.href = ModalUsuarioNoRegistrado___WEBPACK_IMPORTED_MODULE_4__constants__["_24" /* HOST_SERVER */] + 'smgnewsite/prepaga/registracion.php';
    }
  }]);

  return ModalUsuarioNoRegistrado;
}(ModalUsuarioNoRegistrado___WEBPACK_IMPORTED_MODULE_0_react___default.a.Component);

/* harmony default export */ var ModalUsuarioNoRegistrado_defaultExport = (Object(ModalUsuarioNoRegistrado___WEBPACK_IMPORTED_MODULE_1_react_redux__["b" /* connect */])(null, null)(ModalUsuarioNoRegistrado___WEBPACK_IMPORTED_MODULE_2_isomorphic_style_loader_lib_withStyles___default()(__WEBPACK_IMPORTED_MODULE_3__ModalUsuarioNoRegistrado_css___default.a)(ModalUsuarioNoRegistrado)));
// CONCATENATED MODULE: ./src/components/Login/ModalErrorConexionLogin/ModalErrorConexionLogin.js
/* harmony import */ var ModalErrorConexionLogin___WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(71);
/* harmony import */ var ModalErrorConexionLogin___WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(ModalErrorConexionLogin___WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var ModalErrorConexionLogin___WEBPACK_IMPORTED_MODULE_1_react_redux__ = __webpack_require__(415);
/* harmony import */ var ModalErrorConexionLogin___WEBPACK_IMPORTED_MODULE_2_isomorphic_style_loader_lib_withStyles__ = __webpack_require__(887);
/* harmony import */ var ModalErrorConexionLogin___WEBPACK_IMPORTED_MODULE_2_isomorphic_style_loader_lib_withStyles___default = __webpack_require__.n(ModalErrorConexionLogin___WEBPACK_IMPORTED_MODULE_2_isomorphic_style_loader_lib_withStyles__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__ModalErrorConexionLogin_css__ = __webpack_require__(1021);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__ModalErrorConexionLogin_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__ModalErrorConexionLogin_css__);
var ModalErrorConexionLogin__jsx = function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; }();

var ModalErrorConexionLogin__createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function ModalErrorConexionLogin__classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function ModalErrorConexionLogin__possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function ModalErrorConexionLogin__inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

/* eslint react/no-did-mount-set-state: 0 */
/* eslint react/prop-types: 0 */
/* eslint consistent-return: 0 */
/* global $ */





var ModalErrorConexionLogin__ref = ModalErrorConexionLogin__jsx('b', {}, void 0, 'Error de conexi\xF3n');

var ModalErrorConexionLogin__ref2 = ModalErrorConexionLogin__jsx('path', {
  d: 'M256 8C119 8 8 119 8 256s111 248 248 248 248-111 248-248S393 8 256 8zm0 448c-110.5 0-200-89.5-200-200S145.5 56 256 56s200 89.5 200 200-89.5 200-200 200zm101.8-262.2L295.6 256l62.2 62.2c4.7 4.7 4.7 12.3 0 17l-22.6 22.6c-4.7 4.7-12.3 4.7-17 0L256 295.6l-62.2 62.2c-4.7 4.7-12.3 4.7-17 0l-22.6-22.6c-4.7-4.7-4.7-12.3 0-17l62.2-62.2-62.2-62.2c-4.7-4.7-4.7-12.3 0-17l22.6-22.6c4.7-4.7 12.3-4.7 17 0l62.2 62.2 62.2-62.2c4.7-4.7 12.3-4.7 17 0l22.6 22.6c4.7 4.7 4.7 12.3 0 17z'
});

var ModalErrorConexionLogin__ref3 = ModalErrorConexionLogin__jsx('br', {});

var ModalErrorConexionLogin__ref4 = ModalErrorConexionLogin__jsx('div', {
  className: 'row row-text'
}, void 0, ModalErrorConexionLogin__jsx('div', {
  className: 'col-md-12 text-center'
}, void 0, ModalErrorConexionLogin__jsx('p', {}, void 0, 'En este momento no podemos validar tus datos. Por favor volv\xE9 a intentarlo m\xE1s tarde.')));

var ModalErrorConexionLogin = function (_React$Component) {
  ModalErrorConexionLogin__inherits(ModalErrorConexionLogin, _React$Component);

  function ModalErrorConexionLogin() {
    ModalErrorConexionLogin__classCallCheck(this, ModalErrorConexionLogin);

    return ModalErrorConexionLogin__possibleConstructorReturn(this, (ModalErrorConexionLogin.__proto__ || Object.getPrototypeOf(ModalErrorConexionLogin)).apply(this, arguments));
  }

  ModalErrorConexionLogin__createClass(ModalErrorConexionLogin, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      $('#ModalErrorConexionLogin').modal({
        backdrop: 'static',
        keyboard: false
      });
      $('.close').hide();
    }
  }, {
    key: 'render',
    value: function render() {
      return ModalErrorConexionLogin__jsx('div', {
        className: 'modal fade modal-admin in',
        id: 'ModalErrorConexionLogin',
        tabIndex: '-1',
        role: 'dialog',
        'aria-labelledby': 'myModalLabel',
        'aria-hidden': 'false'
      }, void 0, ModalErrorConexionLogin__jsx('div', {
        className: 'modal-dialog',
        role: 'document'
      }, void 0, ModalErrorConexionLogin__jsx('div', {
        className: 'modal-content'
      }, void 0, ModalErrorConexionLogin__jsx('div', {
        className: 'modal-header'
      }, void 0, ModalErrorConexionLogin__jsx('h4', {
        className: 'modal-title',
        style: { fontSize: '20px' }
      }, void 0, ModalErrorConexionLogin__ref)), ModalErrorConexionLogin__jsx('div', {
        className: 'modal-body'
      }, void 0, ModalErrorConexionLogin__jsx('div', {
        className: 'row'
      }, void 0, ModalErrorConexionLogin__jsx('div', {
        className: 'col-md-12 text-center'
      }, void 0, ModalErrorConexionLogin__jsx('svg', {
        xmlns: 'http://www.w3.org/2000/svg',
        viewBox: '0 0 512 512',
        className: '' + __WEBPACK_IMPORTED_MODULE_3__ModalErrorConexionLogin_css___default.a.icono,
        width: '68px',
        height: '68px'
      }, void 0, ModalErrorConexionLogin__ref2))), ModalErrorConexionLogin__ref3, ModalErrorConexionLogin__ref4), ModalErrorConexionLogin__jsx('div', {
        className: 'modal-footer'
      }, void 0, ModalErrorConexionLogin__jsx('div', {
        className: 'col-12 text-center'
      }, void 0, ModalErrorConexionLogin__jsx('button', {
        'data-dismiss': 'modal',
        className: __WEBPACK_IMPORTED_MODULE_3__ModalErrorConexionLogin_css___default.a.boton_rojo + ' btn btn-danger text-center',
        onClick: function onClick() {
          location.reload();
        }
      }, void 0, 'Aceptar'))))));
    }
  }]);

  return ModalErrorConexionLogin;
}(ModalErrorConexionLogin___WEBPACK_IMPORTED_MODULE_0_react___default.a.Component);

/* harmony default export */ var ModalErrorConexionLogin_defaultExport = (Object(ModalErrorConexionLogin___WEBPACK_IMPORTED_MODULE_1_react_redux__["b" /* connect */])(null, null)(ModalErrorConexionLogin___WEBPACK_IMPORTED_MODULE_2_isomorphic_style_loader_lib_withStyles___default()(__WEBPACK_IMPORTED_MODULE_3__ModalErrorConexionLogin_css___default.a)(ModalErrorConexionLogin)));
// CONCATENATED MODULE: ./src/components/Login/ModalAltaPendiente/ModalAltaPendiente.js
/* harmony import */ var ModalAltaPendiente___WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(71);
/* harmony import */ var ModalAltaPendiente___WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(ModalAltaPendiente___WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var ModalAltaPendiente___WEBPACK_IMPORTED_MODULE_1_react_redux__ = __webpack_require__(415);
/* harmony import */ var ModalAltaPendiente___WEBPACK_IMPORTED_MODULE_2_isomorphic_style_loader_lib_withStyles__ = __webpack_require__(887);
/* harmony import */ var ModalAltaPendiente___WEBPACK_IMPORTED_MODULE_2_isomorphic_style_loader_lib_withStyles___default = __webpack_require__.n(ModalAltaPendiente___WEBPACK_IMPORTED_MODULE_2_isomorphic_style_loader_lib_withStyles__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__ModalAltaPendiente_css__ = __webpack_require__(1023);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__ModalAltaPendiente_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__ModalAltaPendiente_css__);
var ModalAltaPendiente__jsx = function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; }();

var ModalAltaPendiente__createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function ModalAltaPendiente__classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function ModalAltaPendiente__possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function ModalAltaPendiente__inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

/* eslint react/no-did-mount-set-state: 0 */
/* eslint react/prop-types: 0 */
/* eslint consistent-return: 0 */
/* global $ */





var ModalAltaPendiente__ref = ModalAltaPendiente__jsx('b', {}, void 0, 'Alta pendiente');

var ModalAltaPendiente__ref2 = ModalAltaPendiente__jsx('path', {
  d: 'M256 8C119.043 8 8 119.083 8 256c0 136.997 111.043 248 248 248s248-111.003 248-248C504 119.083 392.957 8 256 8zm0 448c-110.532 0-200-89.431-200-200 0-110.495 89.472-200 200-200 110.491 0 200 89.471 200 200 0 110.53-89.431 200-200 200zm42-104c0 23.159-18.841 42-42 42s-42-18.841-42-42 18.841-42 42-42 42 18.841 42 42zm-81.37-211.401l6.8 136c.319 6.387 5.591 11.401 11.985 11.401h41.17c6.394 0 11.666-5.014 11.985-11.401l6.8-136c.343-6.854-5.122-12.599-11.985-12.599h-54.77c-6.863 0-12.328 5.745-11.985 12.599z'
});

var ModalAltaPendiente__ref3 = ModalAltaPendiente__jsx('br', {});

var ModalAltaPendiente__ref4 = ModalAltaPendiente__jsx('br', {});

var ModalAltaPendiente = function (_React$Component) {
  ModalAltaPendiente__inherits(ModalAltaPendiente, _React$Component);

  function ModalAltaPendiente() {
    ModalAltaPendiente__classCallCheck(this, ModalAltaPendiente);

    return ModalAltaPendiente__possibleConstructorReturn(this, (ModalAltaPendiente.__proto__ || Object.getPrototypeOf(ModalAltaPendiente)).apply(this, arguments));
  }

  ModalAltaPendiente__createClass(ModalAltaPendiente, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      $('#ModalAltaPendiente').modal({ backdrop: 'static', keyboard: false });
      $('.close').hide();
    }
  }, {
    key: 'render',
    value: function render() {
      return ModalAltaPendiente__jsx('div', {
        className: 'modal fade modal-admin in',
        id: 'ModalAltaPendiente',
        tabIndex: '-1',
        role: 'dialog',
        'aria-labelledby': 'myModalLabel',
        'aria-hidden': 'false'
      }, void 0, ModalAltaPendiente__jsx('div', {
        className: 'modal-dialog',
        role: 'document'
      }, void 0, ModalAltaPendiente__jsx('div', {
        className: 'modal-content'
      }, void 0, ModalAltaPendiente__jsx('div', {
        className: 'modal-header'
      }, void 0, ModalAltaPendiente__jsx('h4', {
        className: 'modal-title',
        style: { fontSize: '20px' }
      }, void 0, ModalAltaPendiente__ref)), ModalAltaPendiente__jsx('div', {
        className: 'modal-body'
      }, void 0, ModalAltaPendiente__jsx('div', {
        className: 'row'
      }, void 0, ModalAltaPendiente__jsx('div', {
        className: 'col-md-12 text-center'
      }, void 0, ModalAltaPendiente__jsx('svg', {
        xmlns: 'http://www.w3.org/2000/svg',
        viewBox: '0 0 512 512',
        className: '' + __WEBPACK_IMPORTED_MODULE_3__ModalAltaPendiente_css___default.a.icono,
        width: '68px',
        height: '68px'
      }, void 0, ModalAltaPendiente__ref2))), ModalAltaPendiente__ref3, ModalAltaPendiente__jsx('div', {
        className: 'row row-text'
      }, void 0, ModalAltaPendiente__jsx('div', {
        className: 'col-md-12 text-center'
      }, void 0, ModalAltaPendiente__jsx('p', {}, void 0, 'Tu cuenta ser\xE1 activada a partir del ' + ModalAltaPendiente.formatearFecha(this.props.fechaAlta) + ' ', ModalAltaPendiente__ref4, 'Ante cualquier duda por favor comunicate al 0810-444-7700.')))), ModalAltaPendiente__jsx('div', {
        className: 'modal-footer'
      }, void 0, ModalAltaPendiente__jsx('div', {
        className: 'col-12 text-center'
      }, void 0, ModalAltaPendiente__jsx('button', {
        'data-dismiss': 'modal',
        className: __WEBPACK_IMPORTED_MODULE_3__ModalAltaPendiente_css___default.a.boton_rojo + ' btn btn-danger text-center'
      }, void 0, 'Aceptar'))))));
    }
  }], [{
    key: 'formatearFecha',
    value: function formatearFecha(fecha) {
      var anio = fecha.substr(0, 4);
      var mes = fecha.substr(4, 2);
      var dia = fecha.substr(6, 2);

      return dia + '/' + mes + '/' + anio;
    }
  }]);

  return ModalAltaPendiente;
}(ModalAltaPendiente___WEBPACK_IMPORTED_MODULE_0_react___default.a.Component);

/* harmony default export */ var ModalAltaPendiente_defaultExport = (Object(ModalAltaPendiente___WEBPACK_IMPORTED_MODULE_1_react_redux__["b" /* connect */])(null, null)(ModalAltaPendiente___WEBPACK_IMPORTED_MODULE_2_isomorphic_style_loader_lib_withStyles___default()(__WEBPACK_IMPORTED_MODULE_3__ModalAltaPendiente_css___default.a)(ModalAltaPendiente)));
// CONCATENATED MODULE: ./src/components/Login/Login.js
/* harmony import */ var Login___WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(71);
/* harmony import */ var Login___WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(Login___WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var Login___WEBPACK_IMPORTED_MODULE_1_react_redux__ = __webpack_require__(415);
/* harmony import */ var Login___WEBPACK_IMPORTED_MODULE_2_isomorphic_style_loader_lib_withStyles__ = __webpack_require__(887);
/* harmony import */ var Login___WEBPACK_IMPORTED_MODULE_2_isomorphic_style_loader_lib_withStyles___default = __webpack_require__.n(Login___WEBPACK_IMPORTED_MODULE_2_isomorphic_style_loader_lib_withStyles__);
/* harmony import */ var Login___WEBPACK_IMPORTED_MODULE_3_lodash__ = __webpack_require__(183);
/* harmony import */ var Login___WEBPACK_IMPORTED_MODULE_3_lodash___default = __webpack_require__.n(Login___WEBPACK_IMPORTED_MODULE_3_lodash__);
/* harmony import */ var Login___WEBPACK_IMPORTED_MODULE_4__actions_authActions__ = __webpack_require__(184);
/* harmony import */ var Login___WEBPACK_IMPORTED_MODULE_5__constants__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__Login_css__ = __webpack_require__(1013);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__Login_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__Login_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__Link__ = __webpack_require__(908);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__Telemedicina_ModalError_ModalError__ = __webpack_require__(939);
var Login__jsx = function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; }();

var Login__createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function Login__classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function Login__possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function Login__inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

/**
 * Login Component
 * @author Juan Carlos Cancela <cancela.juancarlos@gmail.com>
 */
/* global $ */
/* eslint react/no-did-mount-set-state: 0 */
/* eslint react/prop-types: 0 */
/* eslint consistent-return: 0 */
/* eslint-disable */
















var Login__ref = Login__jsx('li', {
  role: 'presentation'
}, void 0, Login__jsx('a', {
  role: 'menuitem',
  tabIndex: '-1',
  href: 'mis_datos.php'
}, void 0, 'Mis Datos'));

var Login__ref2 = Login__jsx('div', {});

var Login__ref3 = Login__jsx(ModalErrorLogin_defaultExport, {});

var Login__ref4 = Login__jsx(ModalUsuarioNoRegistrado_defaultExport, {});

var _ref5 = Login__jsx(ModalUsuarioBloqueado_defaultExport, {});

var _ref6 = Login__jsx(ModalErrorConexionLogin_defaultExport, {});

var _ref7 = Login__jsx(__WEBPACK_IMPORTED_MODULE_13__Telemedicina_ModalError_ModalError__["a" /* default */], {
  msg: 'Se ha producido un error. Intente nuevamente'
});

var _ref8 = Login__jsx('option', {
  value: 'DU'
}, void 0, 'DNI');

var _ref9 = Login__jsx('option', {
  value: 'LC'
}, void 0, 'LC');

var _ref10 = Login__jsx('option', {
  value: 'LE'
}, void 0, 'LE');

var _ref11 = Login__jsx('option', {
  value: 'PA'
}, void 0, 'PA');

var _ref12 = Login__jsx('div', {
  className: 'form-group'
}, void 0, Login__jsx(__WEBPACK_IMPORTED_MODULE_7__Link__["a" /* default */], {
  to: '/'
}, void 0, '\xBFOlvidaste tu contrase\xF1a?'));

var _ref13 = Login__jsx('a', {
  className: 'btn boton_gris',
  href: 'login_mobile.php'
}, void 0, Login__jsx('i', {
  className: 'fa fa-user'
}));

var _ref14 = Login__jsx('a', {
  className: 'btn boton_gris',
  href: 'index.php'
}, void 0, Login__jsx('i', {
  className: 'fa fa-home'
}));

var Login_Login = function (_React$Component) {
  Login__inherits(Login, _React$Component);

  function Login(props) {
    Login__classCallCheck(this, Login);

    var _this = Login__possibleConstructorReturn(this, (Login.__proto__ || Object.getPrototypeOf(Login)).call(this, props));

    _this.state = {
      loginStatus: Login___WEBPACK_IMPORTED_MODULE_5__constants__["_33" /* LOGIN_STATUS_PENDING */],
      showLoginPop: false,
      showUserPop: false,
      errorPassword: false,
      numError: '',
      fechaAlta: '',
      dataErrorLogin: ''
    };
    return _this;
  }

  Login__createClass(Login, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      var _this2 = this;

      var auth = localStorage.getItem(Login___WEBPACK_IMPORTED_MODULE_5__constants__["_30" /* LOCALSTORAGE_AUTH_KEY */]);
      if (Login___WEBPACK_IMPORTED_MODULE_3_lodash___default.a.isEmpty(auth)) {
        this.setState({ loginStatus: Login___WEBPACK_IMPORTED_MODULE_5__constants__["_32" /* LOGIN_STATUS_NOT_LOGGED_IN */] });
      } else {
        this.props.authSuccess(JSON.parse(auth));
      }
      $('body').on('keypress', function (e) {
        if (e.which === 13) {
          _this2.onLoginDataSubmit();
        }
      });
    }
  }, {
    key: 'componentWillReceiveProps',
    value: function componentWillReceiveProps(props) {
      if (!Login___WEBPACK_IMPORTED_MODULE_3_lodash___default.a.isEmpty(props.loginError)) {
        /*console.log('LOGIN ERROR');
        console.log(props.loginError);
        console.log(props.loginError.data.errNumber);*/
        this.setState({ errorPassword: true,
          numError: props.loginError.data ? props.loginError.data.errNumber : props.loginError,
          dataErrorLogin: props.loginError });
        //this.setState({ errorPassword: true, numError: '1003', dataErrorLogin: {data:{errInfo:{fechaAlta:'20190129'}}}});
        this.props.cleanAuthLogin();
        this.props.cleanLoginError();
      }

      if (Login___WEBPACK_IMPORTED_MODULE_3_lodash___default.a.isEmpty(props.auth) && this.state.loginStatus !== Login___WEBPACK_IMPORTED_MODULE_5__constants__["_32" /* LOGIN_STATUS_NOT_LOGGED_IN */]) {
        this.setState({ loginStatus: Login___WEBPACK_IMPORTED_MODULE_5__constants__["_32" /* LOGIN_STATUS_NOT_LOGGED_IN */] });
        this.setState({ errorPassword: false });
        this.setState({ showLoginPop: false });
        this.setState({ showUserPop: false });
      }
    }
  }, {
    key: 'onLoginDataSubmit',
    value: function onLoginDataSubmit() {
      var user = $('#userField').val();
      var pass = $('#passwordField').val();
      this.props.fetchAuth(user, pass);
    }
  }, {
    key: 'focusInput',
    value: function focusInput() {
      this.setState({ errorPassword: false });
    }
  }, {
    key: 'showLoginPop',
    value: function showLoginPop(_showLoginPop) {
      this.setState({ showLoginPop: !_showLoginPop });
    }
  }, {
    key: 'showUserPop',
    value: function showUserPop(_showUserPop) {
      this.setState({ showUserPop: !_showUserPop });
    }
  }, {
    key: 'logOut',
    value: function logOut(e) {
      $('#nav_main').css('z-index', '');
      e.preventDefault();
      this.props.authLogOut();
      this.setState({ loginStatus: Login___WEBPACK_IMPORTED_MODULE_5__constants__["_32" /* LOGIN_STATUS_NOT_LOGGED_IN */] });
      this.setState({ errorPassword: false });
      this.setState({ showLoginPop: false });
      this.setState({ showUserPop: false });
    }
  }, {
    key: 'render',
    value: function render() {
      var _this3 = this;

      var loginStatus = this.state.loginStatus;
      var showLoginPop = this.state.showLoginPop;
      var showUserPop = this.state.showUserPop;
      var modalErrorLogin = '';

      if (!Login___WEBPACK_IMPORTED_MODULE_3_lodash___default.a.isEmpty(this.props.auth) && !Login___WEBPACK_IMPORTED_MODULE_3_lodash___default.a.isEmpty(this.props.auth.modelEspecifico)) {
        localStorage.setItem(Login___WEBPACK_IMPORTED_MODULE_5__constants__["_30" /* LOCALSTORAGE_AUTH_KEY */], JSON.stringify(this.props.auth));
        var name = this.props.auth.modelEspecifico.nombre;
        var surname = this.props.auth.modelEspecifico.apellido;
        var contra = this.props.auth.modelEspecifico.contra;
        var inte = this.props.auth.modelEspecifico.inte;
        newrelic.setCustomAttribute('contra', contra);
        newrelic.setCustomAttribute('inte', inte);

        return Login__jsx('div', {
          className: __WEBPACK_IMPORTED_MODULE_6__Login_css___default.a.welcome
        }, void 0, Login__jsx('button', {
          onClick: function onClick() {
            return _this3.showUserPop(showUserPop);
          },
          className: showUserPop ? '' + __WEBPACK_IMPORTED_MODULE_6__Login_css___default.a.active : null
        }, void 0, Login__jsx('i', {
          className: __WEBPACK_IMPORTED_MODULE_6__Login_css___default.a.user_icon + ' glyphicon glyphicon-user'
        }), name, ' ', surname, Login__jsx('i', {
          className: __WEBPACK_IMPORTED_MODULE_6__Login_css___default.a.down_arrow + ' fa fa-sort-desc',
          'aria-hidden': 'true'
        })), showUserPop ? Login__jsx('ul', {
          id: 'listaAccionesUser',
          className: __WEBPACK_IMPORTED_MODULE_6__Login_css___default.a.listaAccionesUser + ' dropdown-menu',
          role: 'menu',
          'aria-labelledby': 'dropDownUser'
        }, void 0, Login__ref, Login__jsx('li', {
          role: 'presentation'
        }, void 0, Login__jsx('a', {
          role: 'menuitem',
          tabIndex: '-1',
          onClick: function onClick(e) {
            return _this3.logOut(e);
          }
        }, void 0, 'Cerrar Sesi\xF3n'))) : null);
      }
      if (loginStatus === Login___WEBPACK_IMPORTED_MODULE_5__constants__["_33" /* LOGIN_STATUS_PENDING */]) {
        return Login__ref2;
      }
      if (loginStatus === Login___WEBPACK_IMPORTED_MODULE_5__constants__["_32" /* LOGIN_STATUS_NOT_LOGGED_IN */]) {
        switch (this.state.numError) {

          case '401':
            modalErrorLogin = Login__ref3;
            break;
          case '1000':
            modalErrorLogin = Login__ref4;
            break;
          case '1002':
            modalErrorLogin = Login__jsx(ModalAltaPendiente_defaultExport, {
              fechaAlta: this.state.dataErrorLogin.data.errInfo.fechaAlta
            });
            break;
          case '1003':
            localStorage.setItem('dni', $('#userField').val());
            localStorage.setItem('tipo', $('#tipoDoc').val());
            window.location.href = Login___WEBPACK_IMPORTED_MODULE_5__constants__["_24" /* HOST_SERVER */] + 'smgnewsite/prepaga/update_password.php?wf=2&econsulta=1';
            break;
          case '1005':
            modalErrorLogin = _ref5;
            break;
          case '500':
            modalErrorLogin = _ref6;
          case '0':
            modalErrorLogin = _ref7;
          default:
            '';
        }

        return Login__jsx('div', {}, void 0, modalErrorLogin, Login__jsx('div', {
          className: __WEBPACK_IMPORTED_MODULE_6__Login_css___default.a.loginWrap + ' hidden-sm-down'
        }, void 0, Login__jsx('button', {
          type: 'button',
          onClick: function onClick() {
            return _this3.showLoginPop(showLoginPop);
          },
          className: __WEBPACK_IMPORTED_MODULE_6__Login_css___default.a.btn_ing + ' btn btn-sm'
        }, void 0, 'Iniciar Sesi\xF3n'), Login__jsx('button', {
          type: 'button',
          className: __WEBPACK_IMPORTED_MODULE_6__Login_css___default.a.btn_reg + ' btn btn-sm'
        }, void 0, 'Reg\xEDstrese'), showLoginPop ? Login__jsx('div', {}, void 0, Login__jsx('div', {
          className: '' + __WEBPACK_IMPORTED_MODULE_6__Login_css___default.a.loginDialogArrow
        }), Login__jsx('div', {
          className: __WEBPACK_IMPORTED_MODULE_6__Login_css___default.a.loginDialog + ' container'
        }, void 0, Login__jsx('div', {
          className: __WEBPACK_IMPORTED_MODULE_6__Login_css___default.a.row + ' form-group row'
        }, void 0, Login__jsx('div', {
          className: __WEBPACK_IMPORTED_MODULE_6__Login_css___default.a.col + ' col-lg-5'
        }, void 0, Login__jsx('select', {
          id: 'tipoDoc',
          className: __WEBPACK_IMPORTED_MODULE_6__Login_css___default.a.loginTooltipTipoDoc + ' custom-select'
        }, void 0, _ref8, _ref9, _ref10, _ref11)), Login__jsx('div', {
          className: __WEBPACK_IMPORTED_MODULE_6__Login_css___default.a.col + ' col-lg-7'
        }, void 0, Login__jsx('input', {
          autoFocus: true,
          id: 'userField',
          type: 'number',
          className: 'form-control',
          placeholder: 'N\xB0 Documento',
          maxLength: '10',
          onFocus: function onFocus() {
            return _this3.focusInput();
          }
        }))), Login__jsx('div', {
          className: __WEBPACK_IMPORTED_MODULE_6__Login_css___default.a.row + ' form-group row'
        }, void 0, Login__jsx('div', {
          className: __WEBPACK_IMPORTED_MODULE_6__Login_css___default.a.col + ' col-lg-12'
        }, void 0, Login__jsx('input', {
          id: 'passwordField',
          type: 'password',
          className: this.state.errorPassword ? 'form-control ' + __WEBPACK_IMPORTED_MODULE_6__Login_css___default.a.errorLogin : 'form-control',
          placeholder: 'Contrase\xF1a',
          onFocus: function onFocus() {
            return _this3.focusInput();
          }
        }))), Login__jsx('div', {
          className: __WEBPACK_IMPORTED_MODULE_6__Login_css___default.a.row + ' form-group row'
        }, void 0, Login__jsx('div', {
          className: __WEBPACK_IMPORTED_MODULE_6__Login_css___default.a.col + ' col-lg-12'
        }, void 0, Login__jsx('button', {
          id: 'botonSubmit',
          type: 'button',
          onClick: function onClick() {
            return _this3.onLoginDataSubmit();
          },
          className: __WEBPACK_IMPORTED_MODULE_6__Login_css___default.a.boton_rojo + ' btn btn-danger'
        }, void 0, 'Iniciar Sesi\xF3n'))), _ref12)) : null), Login__jsx('div', {
          className: __WEBPACK_IMPORTED_MODULE_6__Login_css___default.a.loginWrapSmall + ' hidden-md-up visible-md-down'
        }, void 0, _ref13, _ref14));
      }
    }
  }]);

  return Login;
}(Login___WEBPACK_IMPORTED_MODULE_0_react___default.a.Component);

var Login_mapStateToProps = function mapStateToProps(state) {
  return {
    auth: state.auth.loginResponse,
    loginError: state.auth.loginError
  };
};

/* harmony default export */ var Login_defaultExport = (Object(Login___WEBPACK_IMPORTED_MODULE_1_react_redux__["b" /* connect */])(Login_mapStateToProps, Login___WEBPACK_IMPORTED_MODULE_4__actions_authActions__)(Login___WEBPACK_IMPORTED_MODULE_2_isomorphic_style_loader_lib_withStyles___default()(__WEBPACK_IMPORTED_MODULE_6__Login_css___default.a)(Login_Login)));
// CONCATENATED MODULE: ./src/components/MenuTop/MenuTop.js
/* harmony import */ var MenuTop___WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(71);
/* harmony import */ var MenuTop___WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(MenuTop___WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_isomorphic_style_loader_lib_withStyles__ = __webpack_require__(887);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_isomorphic_style_loader_lib_withStyles___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_isomorphic_style_loader_lib_withStyles__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__MenuTop_css__ = __webpack_require__(1026);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__MenuTop_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__MenuTop_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__constants__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__clientConfig__ = __webpack_require__(128);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__clientConfig___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__clientConfig__);
var MenuTop__jsx = function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; }();

var MenuTop__createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function MenuTop__classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function MenuTop__possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function MenuTop__inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

/* global $ */







var MenuTop__ref = MenuTop__jsx('li', {}, void 0, MenuTop__jsx('h3', {}, void 0, 'QUIERO ASOCIARME'));

var MenuTop__ref2 = MenuTop__jsx('li', {}, void 0, MenuTop__jsx('a', {
  href: 'https://www.swissmedical.com.ar/smgnewsite/prepaga/nuestros_planes.php'
}, void 0, 'Nuestros Planes'));

var MenuTop__ref3 = MenuTop__jsx('li', {}, void 0, MenuTop__jsx('a', {
  href: 'https://www.swissmedical.com.ar/smgnewsite/prepaga/profesionales.php'
}, void 0, 'Cartillas'));

var MenuTop__ref4 = MenuTop__jsx('li', {}, void 0, MenuTop__jsx('a', {
  href: 'https://www.swissmedical.com.ar/smgnewsite/prepaga/mapa_de_sucursales.php'
}, void 0, 'Sucursales'));

var MenuTop__ref5 = MenuTop__jsx('li', {}, void 0, MenuTop__jsx('a', {
  href: 'https://www.swissmedical.com.ar/smgnewsite/prepaga/derivacion_aportes.php'
}, void 0, 'Derivaci\xF3n de Aportes'));

var MenuTop__ref6 = MenuTop__jsx('li', {}, void 0, MenuTop__jsx('a', {
  href: 'https://www.swissmedical.com.ar/smgnewsite/prepaga/solicite_un_asesor.php'
}, void 0, 'Solicite un Asesor'));

var MenuTop__ref7 = MenuTop__jsx('ul', {
  className: 'list-unstyled col-sm-2 col-xs-11  col-xs-offset-1  col-sm-offset-0  hidden-xs  hidden-ms'
}, void 0, MenuTop__jsx('li', {
  className: 'itemsMenu '
}, void 0, MenuTop__jsx('h3', {}, void 0, 'INFORMACI\xD3N \xDATIL')), MenuTop__jsx('li', {}, void 0, MenuTop__jsx('a', {
  href: 'https://www.swissmedical.com.ar/smgnewsite/prepaga/mapa_de_sucursales.php'
}, void 0, 'Sucursales')), MenuTop__jsx('li', {}, void 0, MenuTop__jsx('a', {
  href: 'https://www.swissmedical.com.ar/smgnewsite/prepaga/telefonos.php'
}, void 0, 'Tel\xE9fonos \xDAtiles')), MenuTop__jsx('li', {}, void 0, MenuTop__jsx('a', {
  href: 'https://www.swissmedical.com.ar/smgnewsite/prepaga/autorizaciones_info.php'
}, void 0, 'Autorizaciones')), MenuTop__jsx('li', {}, void 0, MenuTop__jsx('a', {
  href: 'https://www.swissmedical.com.ar/smgnewsite/prepaga/reintegros.php'
}, void 0, 'Gesti\xF3n de Reintegros')), MenuTop__jsx('li', {}, void 0, MenuTop__jsx('a', {
  href: 'https://www.swissmedical.com.ar/smgnewsite/prepaga/formas_de_pago.php'
}, void 0, 'Formas de Pago')), MenuTop__jsx('li', {}, void 0, MenuTop__jsx('a', {
  href: 'https://www.swissmedical.com.ar/smgnewsite/prepaga/cobertura.php'
}, void 0, 'Cobertura')), MenuTop__jsx('li', {}, void 0, MenuTop__jsx('a', {
  href: 'https://www.swissmedical.com.ar/smgnewsite/prepaga/beneficios.php'
}, void 0, 'Beneficios')), MenuTop__jsx('li', {}, void 0, MenuTop__jsx('a', {
  href: 'https://www.swissmedical.com.ar/smgnewsite/prepaga/novedades.php'
}, void 0, 'Swiss Medical News')), MenuTop__jsx('li', {}, void 0, MenuTop__jsx('a', {
  href: 'https://www.swissmedical.com.ar/smgnewsite/prepaga/comunicaciones_judiciales.php'
}, void 0, 'Comunicaciones judiciales')));

var MenuTop__ref8 = MenuTop__jsx('ul', {
  className: 'list-unstyled col-sm-2 col-xs-11  col-xs-offset-1  col-sm-offset-0  hidden-xs  hidden-ms'
}, void 0, MenuTop__jsx('li', {}, void 0, MenuTop__jsx('h3', {}, void 0, 'CENTROS M\xC9DICOS')), MenuTop__jsx('li', {}, void 0, MenuTop__jsx('a', {
  href: 'https://www.swissmedical.com.ar/smgnewsite/prepaga/nuestras_clinicas.php'
}, void 0, 'Nuestras Cl\xEDnicas')), MenuTop__jsx('li', {}, void 0, MenuTop__jsx('a', {
  href: 'https://www.swissmedical.com.ar/smgnewsite/prepaga/swiss_medical_center.php'
}, void 0, 'Swiss Medical Center')), MenuTop__jsx('li', {}, void 0, MenuTop__jsx('a', {
  href: 'https://www.swissmedical.com.ar/smgnewsite/prepaga/swiss_medical_center.php?center=2'
}, void 0, 'Centros Odontol\xF3gicos')), MenuTop__jsx('li', {}, void 0, MenuTop__jsx('a', {
  href: 'https://www.swissmedical.com.ar/smgnewsite/prepaga/vacunatorio.php'
}, void 0, 'Vacunatorios')));

var MenuTop__ref9 = MenuTop__jsx('ul', {
  className: 'list-unstyled col-sm-2 col-xs-11  col-xs-offset-1  col-sm-offset-0  hidden-xs  hidden-ms'
}, void 0, MenuTop__jsx('li', {}, void 0, MenuTop__jsx('h3', {}, void 0, 'PREVENCI\xD3N')), MenuTop__jsx('li', {}, void 0, MenuTop__jsx('a', {
  href: 'https://www.swissmedical.com.ar/smgnewsite/prepaga/prevencion.php'
}, void 0, 'Programas de Prevenci\xF3n')), MenuTop__jsx('li', {}, void 0, MenuTop__jsx('a', {
  href: 'https://www.swissmedical.com.ar/smgnewsite/prepaga/charlas_comunidad.php'
}, void 0, 'Charlas a la Comunidad')), MenuTop__jsx('li', {}, void 0, MenuTop__jsx('a', {
  href: 'https://www.swissmedical.com.ar/smgnewsite/prepaga/ciclo_actividades.php'
}, void 0, 'Ciclo de Actividades')), MenuTop__jsx('li', {}, void 0, MenuTop__jsx('a', {
  href: 'https://www.swissmedical.com.ar/smgnewsite/prepaga/guias_prevencion.php'
}, void 0, 'Gu\xEDas de Prevenci\xF3n')));

var MenuTop__ref10 = MenuTop__jsx('li', {}, void 0, MenuTop__jsx('h3', {}, void 0, 'TR\xC1MITES ONLINE'));

var MenuTop__ref11 = MenuTop__jsx('li', {}, void 0, MenuTop__jsx('a', {
  href: 'https://www.swissmedical.com.ar/smgnewsite/prepaga/mis_datos.php'
}, void 0, 'Mis Datos'));

var MenuTop__ref12 = MenuTop__jsx('li', {}, void 0, MenuTop__jsx('a', {
  href: 'https://www.swissmedical.com.ar/smgnewsite/prepaga/mi_plan.php'
}, void 0, 'Mi Plan'));

var MenuTop__ref13 = MenuTop__jsx('li', {}, void 0, MenuTop__jsx('a', {
  href: 'https://www.swissmedical.com.ar/smgnewsite/prepaga/profesionales.php'
}, void 0, 'Mi Cartilla'));

var MenuTop__ref14 = MenuTop__jsx('li', {}, void 0, MenuTop__jsx('a', {
  href: 'https://www.swissmedical.com.ar/smgnewsite/prepaga/efactura.php'
}, void 0, 'E-factura'));

var _ref15 = MenuTop__jsx('li', {}, void 0, MenuTop__jsx('a', {
  href: 'https://www.swissmedical.com.ar/smgnewsite/prepaga/turnos_online.php'
}, void 0, 'Turnos Online'));

var _ref16 = MenuTop__jsx('li', {}, void 0, MenuTop__jsx('a', {
  href: 'https://www.swissmedical.com.ar/smgnewsite/prepaga/laboratorio_imagenes.php'
}, void 0, 'Resultados de Estudios'));

var _ref17 = MenuTop__jsx('li', {}, void 0, MenuTop__jsx('a', {
  href: 'https://www.swissmedical.com.ar/smgnewsite/prepaga/gestion_tramites.php'
}, void 0, 'Gesti\xF3n de Tr\xE1mites'));

var _ref18 = MenuTop__jsx('li', {}, void 0, MenuTop__jsx('a', {
  href: 'https://www.swissmedical.com.ar/smgnewsite/prepaga/credencialesProvisorias.php'
}, void 0, 'Gesti\xF3n de Credenciales'));

var _ref19 = MenuTop__jsx('li', {}, void 0, MenuTop__jsx('a', {
  href: 'https://www.swissmedical.com.ar/smgnewsite/prepaga/mis_consumos.php'
}, void 0, 'Historial de Atenciones'));

var _ref20 = MenuTop__jsx('hr', {});

var _ref21 = MenuTop__jsx('li', {}, void 0, MenuTop__jsx('a', {
  href: 'https://www.swissmedical.com.ar/smgnewsite/prepaga/formularios.php'
}, void 0, 'Formularios'));

var _ref22 = MenuTop__jsx('li', {}, void 0, MenuTop__jsx('a', {
  href: 'https://www.swissmedical.com.ar/smgnewsite/prepaga/reglamento_modelo.php'
}, void 0, 'Reglamento y Modelo de Contrato'));

var MenuTop = function (_React$Component) {
  MenuTop__inherits(MenuTop, _React$Component);

  function MenuTop(props) {
    MenuTop__classCallCheck(this, MenuTop);

    var _this = MenuTop__possibleConstructorReturn(this, (MenuTop.__proto__ || Object.getPrototypeOf(MenuTop)).call(this, props));

    _this.state = {
      showMenuTop: false
    };
    return _this;
  }

  MenuTop__createClass(MenuTop, [{
    key: 'showMenuTop',
    value: function showMenuTop(_showMenuTop) {
      this.setState({ showMenuTop: !_showMenuTop });
      if ($(window).scrollTop() > 30 || $(window).width() < 768) {
        setTimeout(function () {
          $('#menu_top').css({
            top: '51px'
          });
        }, 0);
      }
    }
  }, {
    key: 'render',
    value: function render() {
      var _this2 = this;

      var showMenuTop = this.state.showMenuTop;
      return MenuTop__jsx('div', {
        className: __WEBPACK_IMPORTED_MODULE_2__MenuTop_css___default.a.menuLeft + ' nav'
      }, void 0, MenuTop__jsx('button', {
        id: 'iconMenu',
        type: 'button',
        className: '' + __WEBPACK_IMPORTED_MODULE_2__MenuTop_css___default.a.navbarToggle,
        onClick: function onClick() {
          return _this2.showMenuTop(showMenuTop);
        }
      }, void 0, MenuTop__jsx('span', {
        className: __WEBPACK_IMPORTED_MODULE_2__MenuTop_css___default.a.iconBar
      }), MenuTop__jsx('span', {
        className: __WEBPACK_IMPORTED_MODULE_2__MenuTop_css___default.a.iconBar
      }), MenuTop__jsx('span', {
        className: __WEBPACK_IMPORTED_MODULE_2__MenuTop_css___default.a.iconBar
      })), MenuTop__jsx('div', {
        className: 'dropdown open'
      }, void 0, MenuTop__jsx('a', {
        className: __WEBPACK_IMPORTED_MODULE_2__MenuTop_css___default.a.smgbarPersonas + ' navbar-brand hidden-sm-down',
        href: '/'
      }, void 0, 'PERSONAS'), showMenuTop ? MenuTop__jsx('ul', {
        id: 'menu_top',
        className: __WEBPACK_IMPORTED_MODULE_2__MenuTop_css___default.a.menuDesple + ' dropdown-menu',
        role: 'menu',
        'aria-labelledby': 'menuDropdown'
      }, void 0, MenuTop__jsx('li', {}, void 0, MenuTop__jsx('div', {
        id: 'menuCompleto_prepaga',
        className: __WEBPACK_IMPORTED_MODULE_2__MenuTop_css___default.a.menuCompleto_prepaga + ' row'
      }, void 0, MenuTop__jsx('ul', {
        className: 'list-unstyled col-sm-2  col-xs-11 offset-lg-1  hidden-xs  hidden-ms'
      }, void 0, MenuTop__ref, MenuTop__jsx('li', {}, void 0, MenuTop__jsx('a', {
        href: __WEBPACK_IMPORTED_MODULE_3__constants__["_24" /* HOST_SERVER */] + 'smgnewsite/prepaga/nosotros.php'
      }, void 0, 'Sobre Nosotros')), MenuTop__ref2, MenuTop__ref3, MenuTop__ref4, MenuTop__ref5, MenuTop__ref6), MenuTop__ref7, MenuTop__ref8, MenuTop__ref9, MenuTop__jsx('ul', {
        className: __WEBPACK_IMPORTED_MODULE_2__MenuTop_css___default.a.loguedMenu + ' list-unstyled col-sm-2 col-xs-11  col-xs-offset-1  col-sm-offset-0'
      }, void 0, MenuTop__ref10, MenuTop__ref11, MenuTop__ref12, MenuTop__ref13, MenuTop__ref14, _ref15, _ref16, _ref17, _ref18, _ref19, !/Android|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera/i.test(navigator.userAgent) ? MenuTop__jsx('li', {}, void 0, MenuTop__jsx('a', {
        href: __WEBPACK_IMPORTED_MODULE_4__clientConfig__["urlPrefix"] + '/telemedicina'
      }, void 0, 'E-Consulta')) : '', _ref20, _ref21, _ref22)))) : null));
    }
  }]);

  return MenuTop;
}(MenuTop___WEBPACK_IMPORTED_MODULE_0_react___default.a.Component);

/* harmony default export */ var MenuTop_defaultExport = (__WEBPACK_IMPORTED_MODULE_1_isomorphic_style_loader_lib_withStyles___default()(__WEBPACK_IMPORTED_MODULE_2__MenuTop_css___default.a)(MenuTop));
// CONCATENATED MODULE: ./src/actions/footerActions.js
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__constants_index__ = __webpack_require__(17);


/* harmony default export */ var footerActions_defaultExport = (function (data) {
  return {
    type: __WEBPACK_IMPORTED_MODULE_0__constants_index__["_55" /* TOGGLE_MENU */],
    data: data
  };
});
// CONCATENATED MODULE: ./src/actions/sendEmailActions.js
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_request__ = __webpack_require__(129);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_request___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_request__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__loadingActions__ = __webpack_require__(130);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__constants_index__ = __webpack_require__(17);




var sendEmailError = function sendEmailError(data) {
  return {
    type: __WEBPACK_IMPORTED_MODULE_2__constants_index__["_39" /* SEND_EMAIL_ERROR */],
    data: data
  };
};
var sendEmailSucces = function sendEmailSucces(data) {
  return {
    type: __WEBPACK_IMPORTED_MODULE_2__constants_index__["_40" /* SEND_EMAIL_SUCCESS */],
    data: data
  };
};

var sendEmail = function sendEmail(name, email, phone, description) {
  return function (dispatch) {
    dispatch(Object(__WEBPACK_IMPORTED_MODULE_1__loadingActions__["b" /* responseWait */])());
    var options = {
      uri: __WEBPACK_IMPORTED_MODULE_2__constants_index__["_29" /* LOCALHOST_SERVER */] + 'send',
      method: 'POST',
      json: {
        name: name,
        email: email,
        phone: phone,
        description: description
      }
    };
    __WEBPACK_IMPORTED_MODULE_0_request___default()(options, function (err, rsp) {
      if (err || rsp.statusCode === 401) {
        dispatch(sendEmailError());
        dispatch(Object(__WEBPACK_IMPORTED_MODULE_1__loadingActions__["a" /* responseEnd */])());
      }
      if (!err && rsp.statusCode === 200) {
        dispatch(sendEmailSucces());
        dispatch(Object(__WEBPACK_IMPORTED_MODULE_1__loadingActions__["a" /* responseEnd */])());
      }
    });
  };
};
// CONCATENATED MODULE: ./src/components/Contact/ContacForm/ContacForm.js
/* harmony import */ var ContacForm___WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(71);
/* harmony import */ var ContacForm___WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(ContacForm___WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var ContacForm___WEBPACK_IMPORTED_MODULE_1_react_redux__ = __webpack_require__(415);
/* harmony import */ var ContacForm___WEBPACK_IMPORTED_MODULE_2_isomorphic_style_loader_lib_withStyles__ = __webpack_require__(887);
/* harmony import */ var ContacForm___WEBPACK_IMPORTED_MODULE_2_isomorphic_style_loader_lib_withStyles___default = __webpack_require__.n(ContacForm___WEBPACK_IMPORTED_MODULE_2_isomorphic_style_loader_lib_withStyles__);
/* harmony import */ var ContacForm___WEBPACK_IMPORTED_MODULE_3_lodash__ = __webpack_require__(183);
/* harmony import */ var ContacForm___WEBPACK_IMPORTED_MODULE_3_lodash___default = __webpack_require__.n(ContacForm___WEBPACK_IMPORTED_MODULE_3_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_prop_types__ = __webpack_require__(182);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__actions_authActions__ = __webpack_require__(184);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__constants__ = __webpack_require__(17);
var ContacForm__jsx = function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; }();

var ContacForm__createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function ContacForm__classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function ContacForm__possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function ContacForm__inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

/**
 * Contact Component
 */
/* eslint react/no-did-mount-set-state: 0 */
/* eslint react/prop-types: 0 */
/* eslint consistent-return: 0 */









var ContactForm = function (_React$Component) {
  ContacForm__inherits(ContactForm, _React$Component);

  function ContactForm(props) {
    ContacForm__classCallCheck(this, ContactForm);

    var _this = ContacForm__possibleConstructorReturn(this, (ContactForm.__proto__ || Object.getPrototypeOf(ContactForm)).call(this, props));

    _this.state = {
      loginStatus: __WEBPACK_IMPORTED_MODULE_6__constants__["_33" /* LOGIN_STATUS_PENDING */],
      name: '',
      email: '',
      phone: '',
      description: ''
    };
    return _this;
  }

  ContacForm__createClass(ContactForm, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      var auth = localStorage.getItem(__WEBPACK_IMPORTED_MODULE_6__constants__["_30" /* LOCALSTORAGE_AUTH_KEY */]);
      if (ContacForm___WEBPACK_IMPORTED_MODULE_3_lodash___default.a.isEmpty(auth)) {
        this.setState({ loginStatus: __WEBPACK_IMPORTED_MODULE_6__constants__["_32" /* LOGIN_STATUS_NOT_LOGGED_IN */] });
      } else {
        this.props.authSuccess(JSON.parse(auth));
      }
    }
  }, {
    key: 'nameChange',
    value: function nameChange(e) {
      this.setState({ name: e.target.value });
    }
  }, {
    key: 'emailChange',
    value: function emailChange(e) {
      this.setState({ email: e.target.value });
    }
  }, {
    key: 'phoneChange',
    value: function phoneChange(e) {
      this.setState({ phone: e.target.value });
    }
  }, {
    key: 'descriptionChange',
    value: function descriptionChange(e) {
      this.setState({ description: e.target.value });
    }
  }, {
    key: 'render',
    value: function render() {
      var _this2 = this;

      return ContacForm__jsx('form', {
        className: 'form-horizontal'
      }, void 0, ContacForm___WEBPACK_IMPORTED_MODULE_3_lodash___default.a.isEmpty(this.props.auth) ? ContacForm__jsx('div', {}, void 0, ContacForm__jsx('div', {
        className: 'form-group'
      }, void 0, ContacForm__jsx('div', {
        className: 'col-sm-12'
      }, void 0, ContacForm__jsx('input', {
        type: 'text',
        placeholder: 'Nombre y Apellido',
        required: '',
        className: 'form-control',
        value: this.state.name,
        onChange: function onChange(e) {
          return _this2.nameChange(e);
        }
      }))), ContacForm__jsx('div', {
        className: 'form-group'
      }, void 0, ContacForm__jsx('div', {
        className: 'col-sm-12'
      }, void 0, ContacForm__jsx('input', {
        type: 'email',
        className: 'form-control',
        placeholder: 'E-Mail',
        required: '',
        value: this.state.email,
        onChange: function onChange(e) {
          return _this2.emailChange(e);
        }
      })))) : null, ContacForm__jsx('div', {
        className: 'form-group'
      }, void 0, ContacForm__jsx('div', {
        className: 'col-sm-12'
      }, void 0, ContacForm__jsx('input', {
        type: 'tel',
        className: 'form-control',
        placeholder: 'Tel\xE9fono',
        required: '',
        value: this.state.phone,
        onChange: function onChange(e) {
          return _this2.phoneChange(e);
        }
      }))), ContacForm__jsx('div', {
        className: 'form-group'
      }, void 0, ContacForm__jsx('div', {
        className: 'col-sm-12'
      }, void 0, ContacForm__jsx('textarea', {
        className: 'form-control',
        placeholder: 'Consulta',
        required: '',
        rows: '3',
        value: this.state.description,
        onChange: function onChange(e) {
          return _this2.descriptionChange(e);
        }
      }))), ContacForm__jsx('div', {
        className: 'form-group'
      }, void 0, ContacForm__jsx('div', {
        className: 'col-sm-12 '
      }, void 0, ContacForm__jsx('button', {
        className: 'btn btn-danger boton_rojo pull-right',
        onClick: function onClick(e) {
          return _this2.props.onClickSendMail(e, _this2.state.name, _this2.state.email, _this2.state.phone, _this2.state.description, _this2.props.sendEmailProps);
        }
      }, void 0, 'ENVIAR'))));
    }
  }]);

  return ContactForm;
}(ContacForm___WEBPACK_IMPORTED_MODULE_0_react___default.a.Component);

var ContacForm_mapStateToProps = function mapStateToProps(state) {
  return {
    auth: state.auth,
    sendEmail: state.sendEmail.send
  };
};

/* harmony default export */ var ContacForm_defaultExport = (Object(ContacForm___WEBPACK_IMPORTED_MODULE_1_react_redux__["b" /* connect */])(ContacForm_mapStateToProps, __WEBPACK_IMPORTED_MODULE_5__actions_authActions__)(ContacForm___WEBPACK_IMPORTED_MODULE_2_isomorphic_style_loader_lib_withStyles___default()()(ContactForm)));
// CONCATENATED MODULE: ./src/components/Contact/Contact.js
/* harmony import */ var Contact___WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(71);
/* harmony import */ var Contact___WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(Contact___WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var Contact___WEBPACK_IMPORTED_MODULE_1_react_redux__ = __webpack_require__(415);
/* harmony import */ var Contact___WEBPACK_IMPORTED_MODULE_2_isomorphic_style_loader_lib_withStyles__ = __webpack_require__(887);
/* harmony import */ var Contact___WEBPACK_IMPORTED_MODULE_2_isomorphic_style_loader_lib_withStyles___default = __webpack_require__.n(Contact___WEBPACK_IMPORTED_MODULE_2_isomorphic_style_loader_lib_withStyles__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__Contact_css__ = __webpack_require__(1028);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__Contact_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__Contact_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__images_cerrar_png__ = __webpack_require__(1031);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__images_cerrar_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__images_cerrar_png__);
var Contact__jsx = function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; }();

var Contact__createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function Contact__classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function Contact__possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function Contact__inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

/**
 * Contact Component
 */
/* eslint react/no-did-mount-set-state: 0 */
/* eslint react/prop-types: 0 */
/* eslint consistent-return: 0 */
/* eslint class-methods-use-this: 0 */










var Contact__ref = Contact__jsx('img', {
  src: __WEBPACK_IMPORTED_MODULE_6__images_cerrar_png___default.a,
  height: '20',
  alt: 'Cerrar'
});

var Contact__ref2 = Contact__jsx('div', {
  className: 'alert alert-success text-center'
}, void 0, 'Se envio el mensaje correctamente');

var Contact__ref3 = Contact__jsx('div', {
  className: 'alert alert-danger text-center'
}, void 0, 'Error al enviar el mensaje');

var Contact__ref4 = Contact__jsx('div', {
  className: 'alert alert-danger text-center'
}, void 0, 'Todos los campos son obligatorios.');

var Contact_Contact = function (_React$Component) {
  Contact__inherits(Contact, _React$Component);

  function Contact() {
    Contact__classCallCheck(this, Contact);

    return Contact__possibleConstructorReturn(this, (Contact.__proto__ || Object.getPrototypeOf(Contact)).apply(this, arguments));
  }

  Contact__createClass(Contact, [{
    key: 'onClickSendMail',
    value: function onClickSendMail(e, name, email, phone, description, sendEmailProps) {
      e.preventDefault();
      sendEmailProps(name, email, phone, description);
    }
  }, {
    key: 'onClick',
    value: function onClick() {
      this.props.onClickButton();
    }
  }, {
    key: 'render',
    value: function render() {
      var _this2 = this;

      return Contact__jsx('div', {
        className: this.props.ContactClick ? __WEBPACK_IMPORTED_MODULE_5__Contact_css___default.a.formulario_opinion + ' ' + __WEBPACK_IMPORTED_MODULE_5__Contact_css___default.a.show + ' hidden-sm-down' : __WEBPACK_IMPORTED_MODULE_5__Contact_css___default.a.formulario_opinion + ' ' + __WEBPACK_IMPORTED_MODULE_5__Contact_css___default.a.hidden + ' hidden-sm-down'
      }, void 0, Contact__jsx('p', {}, void 0, Contact__jsx('a', {
        className: '' + __WEBPACK_IMPORTED_MODULE_5__Contact_css___default.a.handle,
        role: 'button',
        onClick: function onClick() {
          return _this2.onClick();
        },
        tabIndex: 0
      }, void 0, Contact__ref)), function () {
        switch (_this2.props.sendEmail) {
          case true:
            return Contact__ref2;
          case false:
            return Contact__ref3;
          default:
            return Contact__ref4;
        }
      }(), Contact__jsx(ContacForm_defaultExport, {
        sendEmailProps: this.props.sendEmailProps,
        onClickSendMail: this.onClickSendMail
      }));
    }
  }]);

  return Contact;
}(Contact___WEBPACK_IMPORTED_MODULE_0_react___default.a.Component);

var Contact_mapStateToProps = function mapStateToProps(state) {
  return {
    ContactClick: state.footer.show,
    sendEmail: state.sendEmail.send
  };
};

var Contact_mapDispatchToProps = function mapDispatchToProps(dispatch) {
  return {
    onClickButton: function onClickButton() {
      return dispatch(footerActions_defaultExport());
    },
    sendEmailProps: function sendEmailProps(name, email, phone, description) {
      return dispatch(sendEmail(name, email, phone, description));
    }
  };
};

/* harmony default export */ var Contact_defaultExport = (Object(Contact___WEBPACK_IMPORTED_MODULE_1_react_redux__["b" /* connect */])(Contact_mapStateToProps, Contact_mapDispatchToProps)(Contact___WEBPACK_IMPORTED_MODULE_2_isomorphic_style_loader_lib_withStyles___default()(__WEBPACK_IMPORTED_MODULE_5__Contact_css___default.a)(Contact_Contact)));
// CONCATENATED MODULE: ./src/components/Header/Header.js
/* harmony import */ var Header___WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(71);
/* harmony import */ var Header___WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(Header___WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var Header___WEBPACK_IMPORTED_MODULE_1_isomorphic_style_loader_lib_withStyles__ = __webpack_require__(887);
/* harmony import */ var Header___WEBPACK_IMPORTED_MODULE_1_isomorphic_style_loader_lib_withStyles___default = __webpack_require__.n(Header___WEBPACK_IMPORTED_MODULE_1_isomorphic_style_loader_lib_withStyles__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Header_css__ = __webpack_require__(1002);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Header_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__Header_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__images_swiss_logo_png__ = __webpack_require__(1012);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__images_swiss_logo_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__images_swiss_logo_png__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__constants__ = __webpack_require__(17);
var Header__jsx = function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; }();

var Header__createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function Header__classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function Header__possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function Header__inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

/* eslint-disable react/prop-types */
/* eslint-disable prettier/prettier */
/**
 * @author Juan Carlos Cancela <cancela.juancarlos@gmail.com>
 */
/* global $ */



// eslint-disable-next-line css-modules/no-unused-class


// import logoUrl from './images/logo-smg.png';






var Header__ref = Header__jsx(MenuTop_defaultExport, {});

var Header__ref2 = Header__jsx('i', {
  className: 'glyphicon glyphicon-link'
});

var Header__ref3 = Header__jsx('a', {
  href: 'index.php'
}, void 0, Header__jsx('button', {
  type: 'button',
  className: 'btn-apps'
}, void 0, Header__jsx('i', {
  className: 'glyphicon glyphicon-home'
})));

var Header__ref4 = Header__jsx(Login_defaultExport, {});

var Header__ref5 = Header__jsx(Navigation_defaultExport, {});

var Header__ref6 = Header__jsx(Contact_defaultExport, {});

var Header = function (_React$Component) {
  Header__inherits(Header, _React$Component);

  function Header(props) {
    Header__classCallCheck(this, Header);

    var _this = Header__possibleConstructorReturn(this, (Header.__proto__ || Object.getPrototypeOf(Header)).call(this, props));

    _this.state = {
      showProductosPop: false
    };
    return _this;
  }

  Header__createClass(Header, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      function acomodarMenuScroll() {
        if ($(window).scrollTop() > 65 || $(window).width() < 768) {
          $('#navigation_top, #logo_header').hide();
          $('#app').css('padding-top', '123px');
          $('#nav_main').css({
            top: '0',
            position: 'fixed'
          });
          $('#menu_top').css('top', '51px');
        } else {
          $('#navigation_top, #logo_header').show();
          $('#app').css('padding-top', '0');
          $('#nav_main').css({
            position: 'relative'
          });
          $('#menu_top').css('top', '121px');
        }
      }

      function acomodarMenuResize() {
        if ($(window).width() < 768) {
          acomodarMenuScroll();
        } else {
          acomodarMenuScroll();
        }
      }

      $(window).resize(function () {
        acomodarMenuResize();
      });

      $(window).on('scroll', function () {
        acomodarMenuScroll();
      });

      acomodarMenuResize();
    }
  }, {
    key: 'navigationBar',
    value: function navigationBar() {
      var _this2 = this;

      var showProductosPop = this.state.showProductosPop;
      return Header__jsx('nav', {
        className: __WEBPACK_IMPORTED_MODULE_2__Header_css___default.a.smgbar + ' navbar navbar-toggleable-md navbar-light bg-faded',
        id: 'nav_main'
      }, void 0, Header__jsx('div', {
        className: '' + __WEBPACK_IMPORTED_MODULE_2__Header_css___default.a.nav_inner
      }, void 0, Header__ref, Header__jsx('div', {
        className: __WEBPACK_IMPORTED_MODULE_2__Header_css___default.a.navbar_right + ' btn-group hidden-md-down',
        id: 'navbar_right'
      }, void 0, Header__jsx('button', {
        type: 'button',
        className: 'btn-apps',
        onClick: function onClick() {
          return _this2.showProductosPop(showProductosPop);
        }
      }, void 0, Header__ref2), Header__ref3, showProductosPop ? Header__jsx('ul', {
        className: '' + __WEBPACK_IMPORTED_MODULE_2__Header_css___default.a.dropdown_menu,
        role: 'menu'
      }, void 0, Header__jsx('div', {
        className: '' + __WEBPACK_IMPORTED_MODULE_2__Header_css___default.a.btn_group
      }, void 0, Header__jsx('a', {
        href: __WEBPACK_IMPORTED_MODULE_8__constants__["_24" /* HOST_SERVER */] + 'smgnewsite/prepaga/?origen=nav'
      }, void 0, Header__jsx('div', {
        className: '' + __WEBPACK_IMPORTED_MODULE_2__Header_css___default.a.logoSMMP
      })), Header__jsx('a', {
        href: __WEBPACK_IMPORTED_MODULE_8__constants__["_24" /* HOST_SERVER */] + 'smgnewsite/smglife/?origen=nav'
      }, void 0, Header__jsx('div', {
        className: '' + __WEBPACK_IMPORTED_MODULE_2__Header_css___default.a.logoLIFE
      })), Header__jsx('a', {
        href: __WEBPACK_IMPORTED_MODULE_8__constants__["_24" /* HOST_SERVER */] + 'smgnewsite/seguros/?origen=nav'
      }, void 0, Header__jsx('div', {
        className: '' + __WEBPACK_IMPORTED_MODULE_2__Header_css___default.a.logoSEGUROS
      })))) : null), Header__ref4));
    }
  }, {
    key: 'showProductosPop',
    value: function showProductosPop(_showProductosPop) {
      this.setState({ showProductosPop: !_showProductosPop });
    }
  }, {
    key: 'render',
    value: function render() {
      return Header__jsx('div', {}, void 0, Header__ref5, Header__jsx('div', {
        className: __WEBPACK_IMPORTED_MODULE_2__Header_css___default.a.container + ' hidden-sm-down',
        id: 'logo_header'
      }, void 0, Header__jsx('img', {
        src: __WEBPACK_IMPORTED_MODULE_4__images_swiss_logo_png___default.a,
        height: '49',
        width: '257',
        alt: 'Swiss Medical Group',
        style: { "margin-top": "10px" }
      })), this.navigationBar(), Header__ref6);
    }
  }]);

  return Header;
}(Header___WEBPACK_IMPORTED_MODULE_0_react___default.a.Component);

/* harmony default export */ var Header_defaultExport = (Header___WEBPACK_IMPORTED_MODULE_1_isomorphic_style_loader_lib_withStyles___default()(__WEBPACK_IMPORTED_MODULE_2__Header_css___default.a)(Header));
// CONCATENATED MODULE: ./src/components/LeftNavigationButton/LeftNavigationButton.js
/* harmony import */ var LeftNavigationButton___WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(71);
/* harmony import */ var LeftNavigationButton___WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(LeftNavigationButton___WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var LeftNavigationButton___WEBPACK_IMPORTED_MODULE_1_isomorphic_style_loader_lib_withStyles__ = __webpack_require__(887);
/* harmony import */ var LeftNavigationButton___WEBPACK_IMPORTED_MODULE_1_isomorphic_style_loader_lib_withStyles___default = __webpack_require__.n(LeftNavigationButton___WEBPACK_IMPORTED_MODULE_1_isomorphic_style_loader_lib_withStyles__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types__ = __webpack_require__(182);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__constants_index__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__LeftNavigationButton_css__ = __webpack_require__(1034);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__LeftNavigationButton_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__LeftNavigationButton_css__);
var LeftNavigationButton__jsx = function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; }();

var LeftNavigationButton__createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function LeftNavigationButton__classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function LeftNavigationButton__possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function LeftNavigationButton__inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

/* eslint-disable */








var LeftNavigationButton = function (_React$Component) {
  LeftNavigationButton__inherits(LeftNavigationButton, _React$Component);

  function LeftNavigationButton(props) {
    LeftNavigationButton__classCallCheck(this, LeftNavigationButton);

    return LeftNavigationButton__possibleConstructorReturn(this, (LeftNavigationButton.__proto__ || Object.getPrototypeOf(LeftNavigationButton)).call(this, props));
  }

  LeftNavigationButton__createClass(LeftNavigationButton, [{
    key: 'style',
    value: function style() {
      var background = this.props.background;
      return { backgroundImage: 'url(' + background + ')' };
    }
  }, {
    key: 'render',
    value: function render() {
      return LeftNavigationButton__jsx('li', {
        className: __WEBPACK_IMPORTED_MODULE_4__LeftNavigationButton_css___default.a.datosIco
      }, void 0, LeftNavigationButton__jsx('a', {
        href: this.props.href,
        target: '_self',
        'data-toggle': 'tooltip',
        'data-placement': 'right',
        title: this.props.title,
        style: this.style()
      }, void 0, '\xA0'));
    }
  }]);

  return LeftNavigationButton;
}(LeftNavigationButton___WEBPACK_IMPORTED_MODULE_0_react___default.a.Component);

/* harmony default export */ var LeftNavigationButton_defaultExport = (LeftNavigationButton___WEBPACK_IMPORTED_MODULE_1_isomorphic_style_loader_lib_withStyles___default()(__WEBPACK_IMPORTED_MODULE_4__LeftNavigationButton_css___default.a)(LeftNavigationButton));
// CONCATENATED MODULE: ./src/components/LeftNavigation/buttons.js
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__constants__ = __webpack_require__(17);


/* harmony default export */ var buttons_defaultExport = ([{
  title: 'E-CONSULTA',
  image: 'e_consulta.png',
  to: __WEBPACK_IMPORTED_MODULE_0__constants__["_24" /* HOST_SERVER */] + 'clientes/telemedicina'
}, {
  title: 'MI PLAN',
  image: 'plan.png',
  to: __WEBPACK_IMPORTED_MODULE_0__constants__["_24" /* HOST_SERVER */] + 'smgnewsite/prepaga/mi_plan.php?origen=react'
}, {
  title: 'MI CARTILLA',
  image: 'cartillas.png',
  to: __WEBPACK_IMPORTED_MODULE_0__constants__["_24" /* HOST_SERVER */] + 'smgnewsite/prepaga/cartillaweb.php?origen=react'
}, {
  title: 'E-FACTURAS',
  image: 'facturas.png',
  to: __WEBPACK_IMPORTED_MODULE_0__constants__["_24" /* HOST_SERVER */] + 'smgnewsite/prepaga/efactura.php?origen=react'
}, {
  title: 'TURNOS ONLINE',
  image: 'turnos.png',
  to: __WEBPACK_IMPORTED_MODULE_0__constants__["_24" /* HOST_SERVER */] + 'smgnewsite/prepaga/turnos_consulta.php?origen=react'
}, {
  title: 'RESULTADO DE ESTUDIOS',
  image: 'laboratorio.png',
  to: __WEBPACK_IMPORTED_MODULE_0__constants__["_24" /* HOST_SERVER */] + 'smgnewsite/prepaga/laboratorio_imagenes.php?origen=react'
}, {
  title: 'GESTIÓN DE CREDENCIALES',
  image: 'credencialprovi.png',
  to: __WEBPACK_IMPORTED_MODULE_0__constants__["_24" /* HOST_SERVER */] + 'smgnewsite/prepaga/credencialesProvisorias.php?origen=react'
}, {
  title: 'GESTIÓN DE TRAMITES',
  image: 'autorizaciones.png',
  to: __WEBPACK_IMPORTED_MODULE_0__constants__["_24" /* HOST_SERVER */] + 'smgnewsite/prepaga/gestion_tramites.php?origen=react'
}, {
  title: 'HISTORIAL DE ATENCIONES',
  image: 'historial.png',
  to: __WEBPACK_IMPORTED_MODULE_0__constants__["_24" /* HOST_SERVER */] + 'smgnewsite/prepaga/mis_consumos.php?origen=react'
}, {
  title: 'MIS DATOS',
  image: 'mis_datos.png',
  to: __WEBPACK_IMPORTED_MODULE_0__constants__["_24" /* HOST_SERVER */] + 'smgnewsite/prepaga/mis_datos.php?origen=react'
}]);
// CONCATENATED MODULE: ./src/components/LeftNavigation/LeftNavigation.js
/* harmony import */ var LeftNavigation___WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(71);
/* harmony import */ var LeftNavigation___WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(LeftNavigation___WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var LeftNavigation___WEBPACK_IMPORTED_MODULE_1_isomorphic_style_loader_lib_withStyles__ = __webpack_require__(887);
/* harmony import */ var LeftNavigation___WEBPACK_IMPORTED_MODULE_1_isomorphic_style_loader_lib_withStyles___default = __webpack_require__.n(LeftNavigation___WEBPACK_IMPORTED_MODULE_1_isomorphic_style_loader_lib_withStyles__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__LeftNavigation_css__ = __webpack_require__(1032);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__LeftNavigation_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__LeftNavigation_css__);
var LeftNavigation__jsx = function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; }();

var LeftNavigation__createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function LeftNavigation__classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function LeftNavigation__possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function LeftNavigation__inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

/* global $ */
/* eslint-env jquery */
/* eslint-disable */







var LeftNavigation_LeftNavigation = function (_React$Component) {
  LeftNavigation__inherits(LeftNavigation, _React$Component);

  function LeftNavigation() {
    LeftNavigation__classCallCheck(this, LeftNavigation);

    return LeftNavigation__possibleConstructorReturn(this, (LeftNavigation.__proto__ || Object.getPrototypeOf(LeftNavigation)).apply(this, arguments));
  }

  LeftNavigation__createClass(LeftNavigation, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      $('#navigationIz a').tooltip();
    }
  }, {
    key: 'render',
    value: function render() {
      var images = LeftNavigation.importAll(__webpack_require__(1036));
      var items = buttons_defaultExport.map(function (item) {
        return LeftNavigation__jsx(LeftNavigationButton_defaultExport, {
          href: item.to,
          title: item.title,
          background: images['' + item.image]
        }, item.image);
      });

      return LeftNavigation__jsx('ul', {
        className: __WEBPACK_IMPORTED_MODULE_2__LeftNavigation_css___default.a.navigationIz,
        id: 'navigationIz'
      }, void 0, items);
    }
  }], [{
    key: 'importAll',
    value: function importAll(path) {
      var images = [];
      path.keys().map(function (item) {
        images[item.replace('./', '')] = path(item);
        return images;
      });
      return images;
    }
  }]);

  return LeftNavigation;
}(LeftNavigation___WEBPACK_IMPORTED_MODULE_0_react___default.a.Component);

/* harmony default export */ var LeftNavigation_defaultExport = (LeftNavigation___WEBPACK_IMPORTED_MODULE_1_isomorphic_style_loader_lib_withStyles___default()(__WEBPACK_IMPORTED_MODULE_2__LeftNavigation_css___default.a)(LeftNavigation_LeftNavigation));
// CONCATENATED MODULE: ./src/components/LegalGroup/LegalGroup.js
/* harmony import */ var LegalGroup___WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(71);
/* harmony import */ var LegalGroup___WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(LegalGroup___WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var LegalGroup___WEBPACK_IMPORTED_MODULE_1_isomorphic_style_loader_lib_withStyles__ = __webpack_require__(887);
/* harmony import */ var LegalGroup___WEBPACK_IMPORTED_MODULE_1_isomorphic_style_loader_lib_withStyles___default = __webpack_require__.n(LegalGroup___WEBPACK_IMPORTED_MODULE_1_isomorphic_style_loader_lib_withStyles__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__LegalGroup_css__ = __webpack_require__(1049);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__LegalGroup_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__LegalGroup_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__Link__ = __webpack_require__(908);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__logo_verisign_png__ = __webpack_require__(1051);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__logo_verisign_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__logo_verisign_png__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__logo_ministerio_justicia_png__ = __webpack_require__(1052);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__logo_ministerio_justicia_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__logo_ministerio_justicia_png__);
var LegalGroup__jsx = function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; }();

/**
 * @author React
 */








var LegalGroup__ref = LegalGroup__jsx('li', {}, void 0, 'Superintendencia del Servicios de Salud');

var LegalGroup__ref2 = LegalGroup__jsx('li', {}, void 0, 'Organo Control de Obras Sociales y entidades de Medicina Prepaga');

var LegalGroup__ref3 = LegalGroup__jsx('img', {
  src: __WEBPACK_IMPORTED_MODULE_4__logo_verisign_png___default.a,
  alt: 'Verisign'
});

var LegalGroup__ref4 = LegalGroup__jsx('img', {
  src: __WEBPACK_IMPORTED_MODULE_5__logo_ministerio_justicia_png___default.a,
  alt: 'Ministerio de Justicia'
});

function LegalGroup(props) {
  return LegalGroup__jsx('div', {
    className: __WEBPACK_IMPORTED_MODULE_2__LegalGroup_css___default.a.root + ' hidden-sm-down'
  }, void 0, LegalGroup__jsx('div', {
    className: __WEBPACK_IMPORTED_MODULE_2__LegalGroup_css___default.a.container + ' container'
  }, void 0, LegalGroup__jsx('div', {
    className: 'row'
  }, void 0, LegalGroup__jsx('div', {
    className: 'col-sm-8'
  }, void 0, LegalGroup__jsx('ul', {
    className: __WEBPACK_IMPORTED_MODULE_2__LegalGroup_css___default.a.text + ' text-left list-unstyled'
  }, void 0, LegalGroup__ref, LegalGroup__ref2, LegalGroup__jsx('li', {}, void 0, '0800-222-SALUD (72583) |', LegalGroup__jsx(__WEBPACK_IMPORTED_MODULE_3__Link__["a" /* default */], {
    className: __WEBPACK_IMPORTED_MODULE_2__LegalGroup_css___default.a.link,
    to: 'http://www.sssalud.gov.ar'
  }, void 0, 'www.sssalud.gov.ar'), '| RNEMP N\xBA 132'))), LegalGroup__jsx('div', {
    className: 'col-sm-4'
  }, void 0, LegalGroup__jsx('div', {
    className: __WEBPACK_IMPORTED_MODULE_2__LegalGroup_css___default.a.logos + ' text-right'
  }, void 0, LegalGroup__ref3, LegalGroup__ref4)))));
}

/* harmony default export */ var LegalGroup_defaultExport = (LegalGroup___WEBPACK_IMPORTED_MODULE_1_isomorphic_style_loader_lib_withStyles___default()(__WEBPACK_IMPORTED_MODULE_2__LegalGroup_css___default.a)(LegalGroup));
// CONCATENATED MODULE: ./src/components/CarouselItem/CarouselItem.js
/* harmony import */ var CarouselItem___WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(71);
/* harmony import */ var CarouselItem___WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(CarouselItem___WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var CarouselItem___WEBPACK_IMPORTED_MODULE_1_isomorphic_style_loader_lib_withStyles__ = __webpack_require__(887);
/* harmony import */ var CarouselItem___WEBPACK_IMPORTED_MODULE_1_isomorphic_style_loader_lib_withStyles___default = __webpack_require__.n(CarouselItem___WEBPACK_IMPORTED_MODULE_1_isomorphic_style_loader_lib_withStyles__);
/* harmony import */ var CarouselItem___WEBPACK_IMPORTED_MODULE_2_prop_types__ = __webpack_require__(182);
/* harmony import */ var CarouselItem___WEBPACK_IMPORTED_MODULE_2_prop_types___default = __webpack_require__.n(CarouselItem___WEBPACK_IMPORTED_MODULE_2_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__CarouselItem_css__ = __webpack_require__(1055);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__CarouselItem_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__CarouselItem_css__);
var CarouselItem__jsx = function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; }();

var CarouselItem__createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function CarouselItem__classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function CarouselItem__possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function CarouselItem__inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

/**
 * @author React - Componente de Footer.js
 */
/* eslint-env jquery */






var CarouselItem = function (_React$Component) {
  CarouselItem__inherits(CarouselItem, _React$Component);

  function CarouselItem() {
    CarouselItem__classCallCheck(this, CarouselItem);

    var _this = CarouselItem__possibleConstructorReturn(this, (CarouselItem.__proto__ || Object.getPrototypeOf(CarouselItem)).call(this));

    _this.state = {
      hover: false
    };
    _this.handleMouseOver = _this.handleMouseOver.bind(_this);
    _this.handleMouseOut = _this.handleMouseOut.bind(_this);
    return _this;
  }

  CarouselItem__createClass(CarouselItem, [{
    key: 'handleMouseOver',
    value: function handleMouseOver() {
      this.setState({
        hover: true
      });
    }
  }, {
    key: 'style',
    value: function style() {
      var style = void 0;
      var background = this.props.background;
      var backgroundHover = this.props.backgroundHover;
      if (this.state.hover === false) {
        style = { content: 'url(' + background + ')' };
      } else {
        style = { content: 'url(' + backgroundHover + ')' };
      }
      return style;
    }
  }, {
    key: 'handleMouseOut',
    value: function handleMouseOut() {
      this.setState({
        hover: false
      });
    }
  }, {
    key: 'render',
    value: function render() {
      return CarouselItem__jsx('div', {
        className: __WEBPACK_IMPORTED_MODULE_3__CarouselItem_css___default.a.item
      }, void 0, CarouselItem__jsx('a', {
        href: this.props.href,
        onMouseOver: this.handleMouseOver,
        onMouseOut: this.handleMouseOut,
        style: this.style(),
        target: '_blank'
      }, void 0, '\xA0'));
    }
  }]);

  return CarouselItem;
}(CarouselItem___WEBPACK_IMPORTED_MODULE_0_react___default.a.Component);

/* harmony default export */ var CarouselItem_defaultExport = (CarouselItem___WEBPACK_IMPORTED_MODULE_1_isomorphic_style_loader_lib_withStyles___default()(__WEBPACK_IMPORTED_MODULE_3__CarouselItem_css___default.a)(CarouselItem));
// CONCATENATED MODULE: ./src/components/Carousel/items.js
/* harmony default export */ var items_defaultExport = ([{
  background: 'logo_arcos.png',
  backgroundHover: 'logo_arcos_color.png',
  href: 'http://www.sanatoriodelosarcos.com.ar/'
}, {
  background: 'logo_smmp.png',
  backgroundHover: 'logo_smmp_color.png',
  href: 'http://www.swissmedical.com.ar/smgnewsite/prepaga/'
}, {
  background: 'logo_qualitas.png',
  backgroundHover: 'logo_qualitas_color.png',
  href: 'https://www.swissmedical.com.ar/smgnewsite/prepaga/'
}, {
  background: 'logo_smc.png',
  backgroundHover: 'logo_smc_color.png',
  href: 'http://www.swissmedicalcenter.com.ar/'
}, {
  background: 'logo_cymsa.png',
  backgroundHover: 'logo_cymsa_color.png',
  href: 'http://www.cymsa.com.ar/'
}, {
  background: 'logo_agote.png',
  backgroundHover: 'logo_agote_color.png',
  href: 'http://www.sanatorioagote.com.ar/'
}, {
  background: 'logo_sanlucas.png',
  backgroundHover: 'logo_sanlucas_color.png',
  href: 'http://www.clinicasanlucas.com.ar/'
}, {
  background: 'logo_maternidad.png',
  backgroundHover: 'logo_maternidad_color.png',
  href: 'http://www.sanlucasmaternidad.com.ar/'
}, {
  background: 'logo_olivos.png',
  backgroundHover: 'logo_olivos_color.png',
  href: 'http://www.clinicaolivos.com.ar/'
}, {
  background: 'logo_zabala.png',
  backgroundHover: 'logo_zabala_color.png',
  href: 'http://www.clinicazabala.com.ar/zabala/'
}, {
  background: 'logo_art.png',
  backgroundHover: 'logo_art_color.png',
  href: 'http://www.swissmedical.com.ar/smgnewsite/smgart'
}, {
  background: 'logo_seguros.png',
  backgroundHover: 'logo_seguros_color.png',
  href: 'http://www.swissmedical.com.ar/smgnewsite/seguros/'
}, {
  background: 'logo_life.png',
  backgroundHover: 'logo_life_color.png',
  href: 'http://www.swissmedical.com.ar/smgnewsite/smglife/'
}, {
  background: 'logo_ecco.png',
  backgroundHover: 'logo_ecco_color.png',
  href: 'http://www.ecco.com.ar/'
}, {
  background: 'logo_blue.png',
  backgroundHover: 'logo_blue_color.png',
  href: 'http://www.bcbsu.com.uy/espaniol/index.asp'
}, {
  background: 'logo_salta.png',
  backgroundHover: 'logo_salta_color.png',
  href: 'http://www.institutovida.com.ar/'
}, {
  background: 'logo_travel.png',
  backgroundHover: 'logo_travel_color.png',
  href: '/'
}, {
  background: 'logo_cells.png',
  backgroundHover: 'logo_cells_color.png',
  href: 'https://www.swissmedical.com.ar/clinewsite/cells/'
}, {
  background: 'logo_fundacion.png',
  backgroundHover: 'logo_fundacion_color.png',
  href: 'https://www.swissmedical.com.ar/clinewsite/fundacion/'
}, {
  background: 'logo_altos.png',
  backgroundHover: 'logo_altos_color.png',
  href: 'https://www.swissmedical.com.ar/clinewsite/altos_salta/'
}]);
// CONCATENATED MODULE: ./src/components/Carousel/Carousel.js
/* harmony import */ var Carousel___WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(71);
/* harmony import */ var Carousel___WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(Carousel___WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var Carousel___WEBPACK_IMPORTED_MODULE_1_isomorphic_style_loader_lib_withStyles__ = __webpack_require__(887);
/* harmony import */ var Carousel___WEBPACK_IMPORTED_MODULE_1_isomorphic_style_loader_lib_withStyles___default = __webpack_require__.n(Carousel___WEBPACK_IMPORTED_MODULE_1_isomorphic_style_loader_lib_withStyles__);
/* harmony import */ var Carousel___WEBPACK_IMPORTED_MODULE_2_prop_types__ = __webpack_require__(182);
/* harmony import */ var Carousel___WEBPACK_IMPORTED_MODULE_2_prop_types___default = __webpack_require__.n(Carousel___WEBPACK_IMPORTED_MODULE_2_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__Carousel_css__ = __webpack_require__(1053);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__Carousel_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__Carousel_css__);
var Carousel__jsx = function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; }();

var Carousel__createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function Carousel__classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function Carousel__possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function Carousel__inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

/**
 * @author React - Componente de Footer.js
 */
/* eslint-env jquery */
/* eslint global-require: "error" */
/* eslint no-return-assign: 2,
         no-extra-parens: 2,
         brace-style: 2,
         semi: 2
*/








var Carousel_Carousel = function (_React$Component) {
  Carousel__inherits(Carousel, _React$Component);

  function Carousel() {
    Carousel__classCallCheck(this, Carousel);

    return Carousel__possibleConstructorReturn(this, (Carousel.__proto__ || Object.getPrototypeOf(Carousel)).apply(this, arguments));
  }

  Carousel__createClass(Carousel, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      var carousel = this.carousel;
      $(carousel).carouFredSel({
        auto: {
          items: this.props.items,
          duration: this.props.duration,
          width: this.props.width,
          easing: this.props.easing,
          timeoutDuration: this.props.timeoutDuration,
          pauseOnHover: this.props.pauseOnHover
        }
      });
    }
  }, {
    key: 'render',
    value: function render() {
      var _this2 = this;

      var images = Carousel.importAll(__webpack_require__(1057));
      var itemlist = items_defaultExport.map(function (item) {
        return Carousel__jsx(CarouselItem_defaultExport, {
          href: item.href,
          background: images['' + item.background],
          backgroundHover: images['' + item.backgroundHover]
        }, item.background);
      });

      return Carousel__jsx('div', {
        className: __WEBPACK_IMPORTED_MODULE_3__Carousel_css___default.a.root + ' hidden-sm-down'
      }, void 0, Carousel___WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'div',
        {
          ref: function ref(c) {
            _this2.carousel = c;
          }
        },
        itemlist
      ));
    }
  }], [{
    key: 'importAll',
    value: function importAll(path) {
      var images = [];
      path.keys().map(function (item) {
        images[item.replace('./', '')] = path(item);
        return images;
      });
      return images;
    }
  }]);

  return Carousel;
}(Carousel___WEBPACK_IMPORTED_MODULE_0_react___default.a.Component);

/* harmony default export */ var Carousel_defaultExport = (Carousel___WEBPACK_IMPORTED_MODULE_1_isomorphic_style_loader_lib_withStyles___default()(__WEBPACK_IMPORTED_MODULE_3__Carousel_css___default.a)(Carousel_Carousel));
// CONCATENATED MODULE: ./src/components/FooterNavigation/links.js
/* harmony import */ var links___WEBPACK_IMPORTED_MODULE_0__constants__ = __webpack_require__(17);


/* harmony default export */ var links_defaultExport = ({
  '© SWISS MEDICAL GROUP 2017': [{
    to: 'mailto:info@swissmedical.com.ar',
    name: 'info@swissmedical.com.ar',
    target: '_self'
  }, {
    to: '#',
    name: 'Todos los derechos reservados',
    target: '_self'
  }, {
    to: links___WEBPACK_IMPORTED_MODULE_0__constants__["_24" /* HOST_SERVER */] + 'smgnewsite/terminos/politica_privacidad.pdf',
    name: 'Politica de Privacidad del Sitio',
    target: '_blank'
  }, {
    to: links___WEBPACK_IMPORTED_MODULE_0__constants__["_24" /* HOST_SERVER */] + 'smgnewsite/terminos/terminos.pdf',
    name: 'Términos y Condiciones',
    target: '_blank'
  }],
  PERSONAS: [{
    to: links___WEBPACK_IMPORTED_MODULE_0__constants__["_24" /* HOST_SERVER */] + 'smgnewsite/prepaga/nuestros_planes.php',
    name: 'Nuestros Planes',
    target: '_self'
  }, {
    to: links___WEBPACK_IMPORTED_MODULE_0__constants__["_24" /* HOST_SERVER */] + 'smgnewsite/prepaga/cartillaweb.php',
    name: 'Cartillas',
    target: '_self'
  }, {
    to: links___WEBPACK_IMPORTED_MODULE_0__constants__["_24" /* HOST_SERVER */] + 'smgnewsite/prepaga/mapa_de_sucursales.php',
    name: 'Sucursales',
    target: '_self'
  }, {
    to: links___WEBPACK_IMPORTED_MODULE_0__constants__["_24" /* HOST_SERVER */] + 'smgnewsite/prepaga/telefonos.php',
    name: 'Teléfonos Útiles',
    target: '_self'
  }, {
    to: links___WEBPACK_IMPORTED_MODULE_0__constants__["_24" /* HOST_SERVER */] + 'smgnewsite/prepaga/novedades.php',
    name: 'Swiss Medical News',
    target: '_self'
  }, {
    to: links___WEBPACK_IMPORTED_MODULE_0__constants__["_24" /* HOST_SERVER */] + 'smgnewsite/prepaga/mobile.php',
    name: 'Swiss Medical Móvil',
    target: '_self'
  }, {
    to: links___WEBPACK_IMPORTED_MODULE_0__constants__["_24" /* HOST_SERVER */] + 'smgnewsite/prepaga/beneficios.php',
    name: 'Beneficios',
    target: '_self'
  }, {
    to: links___WEBPACK_IMPORTED_MODULE_0__constants__["_24" /* HOST_SERVER */] + 'smgnewsite/prepaga/programas_prevencion.php',
    name: 'Ciclo de Actividades',
    target: '_self'
  }],
  'CENTROS MÉDICOS': [{
    to: links___WEBPACK_IMPORTED_MODULE_0__constants__["_24" /* HOST_SERVER */] + 'smgnewsite/prepaga/nuestras_clinicas.php',
    name: 'Nuestras Clínicas',
    target: '_self'
  }, {
    to: links___WEBPACK_IMPORTED_MODULE_0__constants__["_24" /* HOST_SERVER */] + 'smgnewsite/prepaga/swiss_medical_center.php',
    name: 'Swiss Medical Center',
    target: '_self'
  }, {
    to: links___WEBPACK_IMPORTED_MODULE_0__constants__["_24" /* HOST_SERVER */] + 'smgnewsite/prepaga/swiss_medical_center.php?center=2',
    name: 'Centros Odontológicos',
    target: '_self'
  }, {
    to: links___WEBPACK_IMPORTED_MODULE_0__constants__["_24" /* HOST_SERVER */] + 'smgnewsite/prepaga/vacunatorio.php',
    name: 'Vacunatorios',
    target: '_blank'
  }],
  '': [{
    to: links___WEBPACK_IMPORTED_MODULE_0__constants__["_24" /* HOST_SERVER */] + 'smgnewsite/prepaga/nosotros.php',
    name: 'Sobre Nosotros',
    target: '_blank'
  }, {
    to: links___WEBPACK_IMPORTED_MODULE_0__constants__["_24" /* HOST_SERVER */] + 'frontend/index.asp',
    name: 'Recursos Humanos',
    target: '_blank'
  }, {
    to: 'http://web.swissmedical.com.ar/subsitio/rse/index.asp',
    name: 'RSE',
    target: '_self'
  }, {
    to: links___WEBPACK_IMPORTED_MODULE_0__constants__["_24" /* HOST_SERVER */] + 'smgnewsite/prepagaempresas/index.php',
    name: 'Empresas',
    target: '_self'
  }, {
    to: links___WEBPACK_IMPORTED_MODULE_0__constants__["_24" /* HOST_SERVER */] + 'prestadores/home/',
    name: 'Profesionales',
    target: '_blank'
  }, {
    to: links___WEBPACK_IMPORTED_MODULE_0__constants__["_24" /* HOST_SERVER */] + 'proveedores/',
    name: 'Proveedores',
    target: '_blank'
  }, {
    to: 'https://swissmedicalgroup.sharepoint.com/sites/conectados/Paginas/index.aspx?wa=wsignin1.0',
    name: 'Colaboradores',
    target: '_blank'
  }]
});
// CONCATENATED MODULE: ./src/components/FooterContactButton/FooterContactButton.js
/* harmony import */ var FooterContactButton___WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(71);
/* harmony import */ var FooterContactButton___WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(FooterContactButton___WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var FooterContactButton___WEBPACK_IMPORTED_MODULE_1_isomorphic_style_loader_lib_withStyles__ = __webpack_require__(887);
/* harmony import */ var FooterContactButton___WEBPACK_IMPORTED_MODULE_1_isomorphic_style_loader_lib_withStyles___default = __webpack_require__.n(FooterContactButton___WEBPACK_IMPORTED_MODULE_1_isomorphic_style_loader_lib_withStyles__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_redux__ = __webpack_require__(415);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_prop_types__ = __webpack_require__(182);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__FooterContactButton_css__ = __webpack_require__(1105);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__FooterContactButton_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__FooterContactButton_css__);
var FooterContactButton__jsx = function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; }();

var FooterContactButton__createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function FooterContactButton__classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function FooterContactButton__possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function FooterContactButton__inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

/**
 * @author Componentes del Footer
 */








var FooterContactButton = function (_React$Component) {
  FooterContactButton__inherits(FooterContactButton, _React$Component);

  function FooterContactButton(props) {
    FooterContactButton__classCallCheck(this, FooterContactButton);

    var _this = FooterContactButton__possibleConstructorReturn(this, (FooterContactButton.__proto__ || Object.getPrototypeOf(FooterContactButton)).call(this, props));

    _this.onClick = _this.onClick.bind(_this);
    return _this;
  }

  FooterContactButton__createClass(FooterContactButton, [{
    key: 'onClick',
    value: function onClick() {
      this.props.onClickButton();
    }
  }, {
    key: 'render',
    value: function render() {
      var _this2 = this;

      return FooterContactButton__jsx('a', {
        tabIndex: 0,
        role: 'button',
        onClick: function onClick() {
          return _this2.onClick();
        },
        className: __WEBPACK_IMPORTED_MODULE_5__FooterContactButton_css___default.a.root + ' btn-link'
      }, void 0, '\xA0');
    }
  }]);

  return FooterContactButton;
}(FooterContactButton___WEBPACK_IMPORTED_MODULE_0_react___default.a.Component);

function FooterContactButton_mapStateToProps(state) {
  return {
    show: state.show
  };
}

var FooterContactButton_mapDispatchToProps = function mapDispatchToProps(dispatch) {
  return {
    onClickButton: function onClickButton() {
      return dispatch(footerActions_defaultExport());
    }
  };
};

/* harmony default export */ var FooterContactButton_defaultExport = (Object(__WEBPACK_IMPORTED_MODULE_2_react_redux__["b" /* connect */])(FooterContactButton_mapStateToProps, FooterContactButton_mapDispatchToProps)(FooterContactButton___WEBPACK_IMPORTED_MODULE_1_isomorphic_style_loader_lib_withStyles___default()(__WEBPACK_IMPORTED_MODULE_5__FooterContactButton_css___default.a)(FooterContactButton)));
// CONCATENATED MODULE: ./src/components/FooterNavigation/FooterNavigation.js
/* harmony import */ var FooterNavigation___WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(71);
/* harmony import */ var FooterNavigation___WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(FooterNavigation___WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var FooterNavigation___WEBPACK_IMPORTED_MODULE_1_isomorphic_style_loader_lib_withStyles__ = __webpack_require__(887);
/* harmony import */ var FooterNavigation___WEBPACK_IMPORTED_MODULE_1_isomorphic_style_loader_lib_withStyles___default = __webpack_require__.n(FooterNavigation___WEBPACK_IMPORTED_MODULE_1_isomorphic_style_loader_lib_withStyles__);
/* harmony import */ var FooterNavigation___WEBPACK_IMPORTED_MODULE_3__Link__ = __webpack_require__(908);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__FooterNavigation_css__ = __webpack_require__(1102);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__FooterNavigation_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__FooterNavigation_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__images_logo_group_pie_png__ = __webpack_require__(1104);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__images_logo_group_pie_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__images_logo_group_pie_png__);
var FooterNavigation__jsx = function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; }();

/**
 * @author Componente del footer
 */










var FooterNavigation__ref = FooterNavigation__jsx('li', {}, void 0, FooterNavigation__jsx(FooterContactButton_defaultExport, {}));

function FooterNavigation(props) {
  var ItemLinks = Object.keys(links_defaultExport).map(function (column, index) {
    return FooterNavigation__jsx('div', {
      className: index === 0 ? 'col-md-3 col-xs-12 ' + __WEBPACK_IMPORTED_MODULE_4__FooterNavigation_css___default.a.col : 'col-md-3 col-xs-12 hidden-sm-down ' + __WEBPACK_IMPORTED_MODULE_4__FooterNavigation_css___default.a.col
    }, column, index === 0 && FooterNavigation__jsx(FooterNavigation___WEBPACK_IMPORTED_MODULE_3__Link__["a" /* default */], {
      to: '/'
    }, void 0, FooterNavigation__jsx('img', {
      className: __WEBPACK_IMPORTED_MODULE_4__FooterNavigation_css___default.a.logo,
      src: __WEBPACK_IMPORTED_MODULE_5__images_logo_group_pie_png___default.a,
      alt: 'Swiss Medical Group'
    })), FooterNavigation__jsx('h3', {}, void 0, column), FooterNavigation__jsx('ul', {
      className: 'list-unstyled'
    }, void 0, links_defaultExport[column].map(function (link) {
      return FooterNavigation__jsx('li', {}, link.name, FooterNavigation__jsx(ExternalLink_defaultExport, {
        className: __WEBPACK_IMPORTED_MODULE_4__FooterNavigation_css___default.a.link,
        to: link.to,
        target: link.target
      }, void 0, link.name));
    }), index === 3 && FooterNavigation__ref));
  });
  return FooterNavigation__jsx('div', {
    className: __WEBPACK_IMPORTED_MODULE_4__FooterNavigation_css___default.a.root + ' row'
  }, void 0, ItemLinks);
}

/* harmony default export */ var FooterNavigation_defaultExport = (FooterNavigation___WEBPACK_IMPORTED_MODULE_1_isomorphic_style_loader_lib_withStyles___default()(__WEBPACK_IMPORTED_MODULE_4__FooterNavigation_css___default.a)(FooterNavigation));
// CONCATENATED MODULE: ./src/components/Accordion/Accordion.js
/* harmony import */ var Accordion___WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(71);
/* harmony import */ var Accordion___WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(Accordion___WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var Accordion___WEBPACK_IMPORTED_MODULE_1_isomorphic_style_loader_lib_withStyles__ = __webpack_require__(887);
/* harmony import */ var Accordion___WEBPACK_IMPORTED_MODULE_1_isomorphic_style_loader_lib_withStyles___default = __webpack_require__.n(Accordion___WEBPACK_IMPORTED_MODULE_1_isomorphic_style_loader_lib_withStyles__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Accordion_css__ = __webpack_require__(1098);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Accordion_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__Accordion_css__);
var Accordion__jsx = function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; }();

/**
 * @author React - Componente de Footer.js
 */






var Accordion__ref = Accordion__jsx(FooterNavigation_defaultExport, {});

function Accordion(props) {
  return Accordion__jsx('div', {
    className: __WEBPACK_IMPORTED_MODULE_2__Accordion_css___default.a.root
  }, void 0, Accordion__jsx('input', {
    className: __WEBPACK_IMPORTED_MODULE_2__Accordion_css___default.a.toggle,
    type: 'checkbox'
  }), Accordion__jsx('i', {
    className: __WEBPACK_IMPORTED_MODULE_2__Accordion_css___default.a.label
  }, void 0, '\xA0'), Accordion__jsx('div', {
    className: __WEBPACK_IMPORTED_MODULE_2__Accordion_css___default.a.collapsed
  }, void 0, Accordion__jsx('div', {
    className: __WEBPACK_IMPORTED_MODULE_2__Accordion_css___default.a.container + ' container'
  }, void 0, Accordion__ref)));
}

/* harmony default export */ var Accordion_defaultExport = (Accordion___WEBPACK_IMPORTED_MODULE_1_isomorphic_style_loader_lib_withStyles___default()(__WEBPACK_IMPORTED_MODULE_2__Accordion_css___default.a)(Accordion));
// CONCATENATED MODULE: ./src/components/Footer/Footer.js
/* harmony import */ var Footer___WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(71);
/* harmony import */ var Footer___WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(Footer___WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var Footer___WEBPACK_IMPORTED_MODULE_1_isomorphic_style_loader_lib_withStyles__ = __webpack_require__(887);
/* harmony import */ var Footer___WEBPACK_IMPORTED_MODULE_1_isomorphic_style_loader_lib_withStyles___default = __webpack_require__.n(Footer___WEBPACK_IMPORTED_MODULE_1_isomorphic_style_loader_lib_withStyles__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Footer_css__ = __webpack_require__(1047);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Footer_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__Footer_css__);
var Footer__jsx = function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; }();

/**
 * @author Juan Carlos Cancela <cancela.juancarlos@gmail.com>
 */








var Footer__ref = Footer__jsx(Accordion_defaultExport, {
  className: 'hidden-xs'
});

var Footer__ref2 = Footer__jsx(Carousel_defaultExport, {
  className: 'hidden-sm-down',
  items: 5,
  duration: 15000,
  width: '100%',
  easing: 'linear',
  timeoutDuration: 0,
  pauseOnHover: 'immediate'
});

var Footer__ref3 = Footer__jsx(LegalGroup_defaultExport, {});

function Footer(props) {
  return Footer__jsx('footer', {
    className: __WEBPACK_IMPORTED_MODULE_2__Footer_css___default.a.root + ' hidden-xs'
  }, void 0, Footer__ref, Footer__ref2, Footer__ref3);
}

/* harmony default export */ var Footer_defaultExport = (Footer___WEBPACK_IMPORTED_MODULE_1_isomorphic_style_loader_lib_withStyles___default()(__WEBPACK_IMPORTED_MODULE_2__Footer_css___default.a)(Footer));
// CONCATENATED MODULE: ./src/components/LoadingIndicator/index.js
/* harmony import */ var LoadingIndicator___WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(71);
/* harmony import */ var LoadingIndicator___WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(LoadingIndicator___WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var LoadingIndicator___WEBPACK_IMPORTED_MODULE_1_isomorphic_style_loader_lib_withStyles__ = __webpack_require__(887);
/* harmony import */ var LoadingIndicator___WEBPACK_IMPORTED_MODULE_1_isomorphic_style_loader_lib_withStyles___default = __webpack_require__.n(LoadingIndicator___WEBPACK_IMPORTED_MODULE_1_isomorphic_style_loader_lib_withStyles__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Loading_css__ = __webpack_require__(1112);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Loading_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__Loading_css__);
var LoadingIndicator__extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };






function Loading(props) {
  return LoadingIndicator___WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div', LoadingIndicator__extends({}, props, { className: '' + __WEBPACK_IMPORTED_MODULE_2__Loading_css___default.a.loader }));
}

/* harmony default export */ var LoadingIndicator_defaultExport = (LoadingIndicator___WEBPACK_IMPORTED_MODULE_1_isomorphic_style_loader_lib_withStyles___default()(__WEBPACK_IMPORTED_MODULE_2__Loading_css___default.a)(Loading));
// CONCATENATED MODULE: ./src/components/Telemedicina/ModalHorarios/ModalHorarios.js
/* harmony import */ var ModalHorarios___WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(71);
/* harmony import */ var ModalHorarios___WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(ModalHorarios___WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var ModalHorarios___WEBPACK_IMPORTED_MODULE_1_react_redux__ = __webpack_require__(415);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_moment__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_moment__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_isomorphic_style_loader_lib_withStyles__ = __webpack_require__(887);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_isomorphic_style_loader_lib_withStyles___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_isomorphic_style_loader_lib_withStyles__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__ModalError_ModalError_css__ = __webpack_require__(938);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__ModalError_ModalError_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__ModalError_ModalError_css__);
var ModalHorarios__jsx = function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; }();

var ModalHorarios__extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var ModalHorarios__createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function ModalHorarios__classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function ModalHorarios__possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function ModalHorarios__inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

/* eslint react/no-did-mount-set-state: 0 */
/* eslint react/prop-types: 0 */
/* eslint consistent-return: 0 */
/* global $ */





// import { urlPrefix } from '../../../clientConfig';

var initialState = {
  disabledButton: true
};

var ModalHorarios = function (_React$Component) {
  ModalHorarios__inherits(ModalHorarios, _React$Component);

  function ModalHorarios(props) {
    ModalHorarios__classCallCheck(this, ModalHorarios);

    var _this = ModalHorarios__possibleConstructorReturn(this, (ModalHorarios.__proto__ || Object.getPrototypeOf(ModalHorarios)).call(this, props));

    _this.close = function () {
      $('#ModalHorarios').modal('hide');
    };

    _this.state = ModalHorarios__extends({}, initialState);
    return _this;
  }

  ModalHorarios__createClass(ModalHorarios, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      $('#ModalHorarios').modal({ backdrop: 'static', keyboard: false });
      $('.close').hide();
      this.configHora();
    }
  }, {
    key: 'configHora',
    value: function configHora() {
      var date = new Date();
      var editDate = __WEBPACK_IMPORTED_MODULE_2_moment___default()(date).format('HH');
      var timeIn = ['08', '09', '10', '11', '12', '13', '14', '15', '16', '17', '18', '19'];

      for (var i = 0; timeIn.length > i; i += 1) {
        if (timeIn[i] === editDate) {
          this.setState({ disabledButton: false });
          break;
        } else {
          this.setState({ disabledButton: true });
        }
      }
    }
  }, {
    key: 'render',
    value: function render() {
      var _this2 = this;

      // const { hideLayout } = this.props;
      // const url = `${urlPrefix}/telemedicina/`;
      return ModalHorarios__jsx('div', {
        className: 'modal fade',
        id: 'ModalHorarios'
      }, void 0, ModalHorarios__jsx('div', {
        className: 'modal-dialog',
        style: { minWidth: '700px' }
      }, void 0, ModalHorarios__jsx('div', {
        className: __WEBPACK_IMPORTED_MODULE_4__ModalError_ModalError_css___default.a.modalContent + ' modal-content'
      }, void 0, ModalHorarios__jsx('div', {
        className: __WEBPACK_IMPORTED_MODULE_4__ModalError_ModalError_css___default.a.modalBody + ' modal-body'
      }, void 0, ModalHorarios__jsx('div', {
        className: 'row'
      }, void 0, ModalHorarios__jsx('div', {
        className: 'col-sm-12',
        style: { textAlign: 'center' }
      }, void 0, ModalHorarios__jsx('p', {
        style: {
          fontWeight: '700',
          color: '#e4002b',
          fontSize: '18px'
        }
      }, void 0, 'IMPORTANTE'), ModalHorarios__jsx('p', {
        style: { padding: '10px', marginBottom: '0' }
      }, void 0, 'Este servicio est\xE1 disponible todos los d\xEDas de 8 a 20 hs.'), ModalHorarios__jsx('p', {
        style: { padding: '0px 4em 0px 4em' }
      }, void 0, 'Rercord\xE1 que tambi\xE9n pod\xE9s acceder desde tu celular utilizando nuestra app', ModalHorarios__jsx('span', {
        style: { color: '#e4002b', fontWeight: 'bold' }
      }, void 0, ' ', 'Swiss Medical Mobile')), ModalHorarios__jsx('p', {
        style: {
          paddingLeft: '30px',
          paddingRight: '30px',
          marginBottom: '10px'
        }
      }, void 0, 'Si tu consulta es por una urgencia, por favor comunicate al 0800-777-7800.')))), ModalHorarios__jsx('div', {
        className: __WEBPACK_IMPORTED_MODULE_4__ModalError_ModalError_css___default.a.modalFooter + ' modal-footer'
      }, void 0, ModalHorarios__jsx('button', {
        type: 'button',
        styling: 'link',
        tabIndex: 0,
        className: 'btn btn-default',
        disabled: this.state.disabledButton,
        style: {
          color: '#fff',
          fontSize: '14px',
          backgroundColor: '#e4002b',
          cursor: 'pointer',
          borderRadius: '.25rem',
          fontFamily: 'Roboto, Medium, sans-serif',
          fontWeight: 'bold'
        },
        onClick: function onClick() {
          return _this2.close();
        }
      }, void 0, 'Ingresar a E-Consulta')))));
    }
  }]);

  return ModalHorarios;
}(ModalHorarios___WEBPACK_IMPORTED_MODULE_0_react___default.a.Component);

var ModalHorarios_mapStateToProps = function mapStateToProps(state) {
  return {
    hideLayout: state.auth.hideLayout
  };
};

/* harmony default export */ var ModalHorarios_defaultExport = (Object(ModalHorarios___WEBPACK_IMPORTED_MODULE_1_react_redux__["b" /* connect */])(ModalHorarios_mapStateToProps, null)(__WEBPACK_IMPORTED_MODULE_3_isomorphic_style_loader_lib_withStyles___default()(__WEBPACK_IMPORTED_MODULE_4__ModalError_ModalError_css___default.a)(ModalHorarios)));
// CONCATENATED MODULE: ./src/components/Layout/Layout.js
/* harmony import */ var Layout___WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(71);
/* harmony import */ var Layout___WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(Layout___WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var Layout___WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(182);
/* harmony import */ var Layout___WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(Layout___WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var Layout___WEBPACK_IMPORTED_MODULE_2_isomorphic_style_loader_lib_withStyles__ = __webpack_require__(887);
/* harmony import */ var Layout___WEBPACK_IMPORTED_MODULE_2_isomorphic_style_loader_lib_withStyles___default = __webpack_require__.n(Layout___WEBPACK_IMPORTED_MODULE_2_isomorphic_style_loader_lib_withStyles__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_normalize_css__ = __webpack_require__(936);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_normalize_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_normalize_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react_redux__ = __webpack_require__(415);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_lodash__ = __webpack_require__(183);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__Layout_css__ = __webpack_require__(1000);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__Layout_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__Layout_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__Loading_Loading__ = __webpack_require__(940);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__actions_authActions__ = __webpack_require__(184);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__public_images_banner_png__ = __webpack_require__(1114);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__public_images_banner_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_13__public_images_banner_png__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__constants__ = __webpack_require__(17);
var Layout__jsx = function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; }();

var Layout__createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function Layout__classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function Layout__possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function Layout__inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

/* eslint-disable prettier/prettier */
/* eslint-disable react/prop-types */
/**
 * @author Juan Carlos Cancela <cancela.juancarlos@gmail.com>
 */





// external-global styles must be imported in your JS.














var Layout__ref = Layout__jsx('div', {}, void 0, Layout__jsx('small', {}, void 0, 'Tu m\xE9dico en l\xEDnea'));

var Layout__ref2 = Layout__jsx(LoadingIndicator_defaultExport, {});

var Layout__ref3 = Layout__jsx(__WEBPACK_IMPORTED_MODULE_10__Loading_Loading__["a" /* default */], {});

var Layout__ref4 = Layout__jsx(Header_defaultExport, {});

var Layout__ref5 = Layout__jsx(LeftNavigation_defaultExport, {});

var Layout__ref6 = Layout__jsx(ModalHorarios_defaultExport, {});

var Layout__ref7 = Layout__jsx(Footer_defaultExport, {});

var Layout = function (_React$Component) {
  Layout__inherits(Layout, _React$Component);

  function Layout(props) {
    Layout__classCallCheck(this, Layout);

    var _this = Layout__possibleConstructorReturn(this, (Layout.__proto__ || Object.getPrototypeOf(Layout)).call(this, props));

    _this.initHeightMessageInterval = function () {
      // Notifica a la web de react el alto del contenido para actualizar el height del iframe
      setInterval(function () {
        var app = document.getElementById('app');
        var data = JSON.stringify({
          type: 'HEIGHT_UPDATE',
          data: app.scrollHeight
        });
        window.top.postMessage(data, '*');
      }, 500);
    };

    _this.renderBanner = function () {
      return Layout__jsx('div', {
        className: __WEBPACK_IMPORTED_MODULE_6__Layout_css___default.a.imageBanner + ' col-md-12',
        style: { backgroundImage: 'url(' + __WEBPACK_IMPORTED_MODULE_13__public_images_banner_png___default.a + ')' }
      }, void 0, Layout__jsx('h1', {}, void 0, Layout__jsx('div', {
        className: '' + __WEBPACK_IMPORTED_MODULE_6__Layout_css___default.a.eConsultaDiv
      }, void 0, Layout__jsx('span', {
        className: '' + __WEBPACK_IMPORTED_MODULE_6__Layout_css___default.a.eConsulta
      }, void 0, 'E-Consulta')), Layout__ref));
    };

    _this.renderIframeContent = function () {
      var _this$props = _this.props,
          auth = _this$props.auth,
          children = _this$props.children;


      var isAuth = Object(__WEBPACK_IMPORTED_MODULE_5_lodash__["get"])(auth, 'loginResponse.token');

      return isAuth ? children : Layout__jsx('div', {
        style: { paddingTop: 50 }
      }, void 0, Layout__ref2);
    };

    _this.state = {
      hideLayout: props.hideLayout
    };
    return _this;
  }

  Layout__createClass(Layout, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      // Para que funcione en el iframe del dashboard la web react
      if (!this.state.hideLayout) return;

      this.initHeightMessageInterval();
      var auth = localStorage.getItem(__WEBPACK_IMPORTED_MODULE_14__constants__["_30" /* LOCALSTORAGE_AUTH_KEY */]);
      if (auth) {
        this.props.authSuccess(JSON.parse(auth), true);
      }
    }
  }, {
    key: 'render',
    value: function render() {
      var hideLayout = this.state.hideLayout;
      var _props = this.props,
          auth = _props.auth,
          wait = _props.wait,
          children = _props.children;


      if (hideLayout) return this.renderIframeContent();

      var isAuth = Object(__WEBPACK_IMPORTED_MODULE_5_lodash__["get"])(auth, 'loginResponse.token');
      return Layout__jsx('div', {}, void 0, wait ? Layout__ref3 : null, Layout__jsx('div', {}, void 0, Layout__ref4, Layout__ref5, Layout__ref6, isAuth && this.renderBanner(), children, Layout__ref7));
    }
  }]);

  return Layout;
}(Layout___WEBPACK_IMPORTED_MODULE_0_react___default.a.Component);

Layout.defaultProps = {
  wait: false,
  hideLayout: false
};


var Layout_mapStateToProps = function mapStateToProps(state) {
  return {
    wait: state.loading.wait,
    auth: state.auth
  };
};

/* harmony default export */ var Layout_defaultExport = __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_4_react_redux__["b" /* connect */])(Layout_mapStateToProps, __WEBPACK_IMPORTED_MODULE_12__actions_authActions__)(Layout___WEBPACK_IMPORTED_MODULE_2_isomorphic_style_loader_lib_withStyles___default()(__WEBPACK_IMPORTED_MODULE_3_normalize_css___default.a, __WEBPACK_IMPORTED_MODULE_6__Layout_css___default.a)(Layout)));

/***/ }),
/* 942 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = { "default": __webpack_require__(943), __esModule: true };

/***/ }),
/* 943 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(944);
module.exports = __webpack_require__(892).Object.getPrototypeOf;

/***/ }),
/* 944 */
/***/ (function(module, exports, __webpack_require__) {

// 19.1.2.9 Object.getPrototypeOf(O)
var toObject        = __webpack_require__(924)
  , $getPrototypeOf = __webpack_require__(925);

__webpack_require__(945)('getPrototypeOf', function(){
  return function getPrototypeOf(it){
    return $getPrototypeOf(toObject(it));
  };
});

/***/ }),
/* 945 */
/***/ (function(module, exports, __webpack_require__) {

// most Object methods by ES6 should accept primitives
var $export = __webpack_require__(899)
  , core    = __webpack_require__(892)
  , fails   = __webpack_require__(903);
module.exports = function(KEY, exec){
  var fn  = (core.Object || {})[KEY] || Object[KEY]
    , exp = {};
  exp[KEY] = exec(fn);
  $export($export.S + $export.F * fails(function(){ fn(1); }), 'Object', exp);
};

/***/ }),
/* 946 */
/***/ (function(module, exports) {

module.exports = function(it){
  if(typeof it != 'function')throw TypeError(it + ' is not a function!');
  return it;
};

/***/ }),
/* 947 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

exports.default = function (instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
};

/***/ }),
/* 948 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _defineProperty = __webpack_require__(949);

var _defineProperty2 = _interopRequireDefault(_defineProperty);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = function () {
  function defineProperties(target, props) {
    for (var i = 0; i < props.length; i++) {
      var descriptor = props[i];
      descriptor.enumerable = descriptor.enumerable || false;
      descriptor.configurable = true;
      if ("value" in descriptor) descriptor.writable = true;
      (0, _defineProperty2.default)(target, descriptor.key, descriptor);
    }
  }

  return function (Constructor, protoProps, staticProps) {
    if (protoProps) defineProperties(Constructor.prototype, protoProps);
    if (staticProps) defineProperties(Constructor, staticProps);
    return Constructor;
  };
}();

/***/ }),
/* 949 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = { "default": __webpack_require__(950), __esModule: true };

/***/ }),
/* 950 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(951);
var $Object = __webpack_require__(892).Object;
module.exports = function defineProperty(it, key, desc){
  return $Object.defineProperty(it, key, desc);
};

/***/ }),
/* 951 */
/***/ (function(module, exports, __webpack_require__) {

var $export = __webpack_require__(899);
// 19.1.2.4 / 15.2.3.6 Object.defineProperty(O, P, Attributes)
$export($export.S + $export.F * !__webpack_require__(897), 'Object', {defineProperty: __webpack_require__(896).f});

/***/ }),
/* 952 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _typeof2 = __webpack_require__(929);

var _typeof3 = _interopRequireDefault(_typeof2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = function (self, call) {
  if (!self) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }

  return call && ((typeof call === "undefined" ? "undefined" : (0, _typeof3.default)(call)) === "object" || typeof call === "function") ? call : self;
};

/***/ }),
/* 953 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = { "default": __webpack_require__(954), __esModule: true };

/***/ }),
/* 954 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(913);
__webpack_require__(920);
module.exports = __webpack_require__(921).f('iterator');

/***/ }),
/* 955 */
/***/ (function(module, exports, __webpack_require__) {

var toInteger = __webpack_require__(914)
  , defined   = __webpack_require__(909);
// true  -> String#at
// false -> String#codePointAt
module.exports = function(TO_STRING){
  return function(that, pos){
    var s = String(defined(that))
      , i = toInteger(pos)
      , l = s.length
      , a, b;
    if(i < 0 || i >= l)return TO_STRING ? '' : undefined;
    a = s.charCodeAt(i);
    return a < 0xd800 || a > 0xdbff || i + 1 === l || (b = s.charCodeAt(i + 1)) < 0xdc00 || b > 0xdfff
      ? TO_STRING ? s.charAt(i) : a
      : TO_STRING ? s.slice(i, i + 2) : (a - 0xd800 << 10) + (b - 0xdc00) + 0x10000;
  };
};

/***/ }),
/* 956 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var create         = __webpack_require__(916)
  , descriptor     = __webpack_require__(906)
  , setToStringTag = __webpack_require__(919)
  , IteratorPrototype = {};

// 25.1.2.1.1 %IteratorPrototype%[@@iterator]()
__webpack_require__(900)(IteratorPrototype, __webpack_require__(893)('iterator'), function(){ return this; });

module.exports = function(Constructor, NAME, next){
  Constructor.prototype = create(IteratorPrototype, {next: descriptor(1, next)});
  setToStringTag(Constructor, NAME + ' Iterator');
};

/***/ }),
/* 957 */
/***/ (function(module, exports, __webpack_require__) {

var dP       = __webpack_require__(896)
  , anObject = __webpack_require__(901)
  , getKeys  = __webpack_require__(907);

module.exports = __webpack_require__(897) ? Object.defineProperties : function defineProperties(O, Properties){
  anObject(O);
  var keys   = getKeys(Properties)
    , length = keys.length
    , i = 0
    , P;
  while(length > i)dP.f(O, P = keys[i++], Properties[P]);
  return O;
};

/***/ }),
/* 958 */
/***/ (function(module, exports, __webpack_require__) {

// fallback for non-array-like ES3 and non-enumerable old V8 strings
var cof = __webpack_require__(917);
module.exports = Object('z').propertyIsEnumerable(0) ? Object : function(it){
  return cof(it) == 'String' ? it.split('') : Object(it);
};

/***/ }),
/* 959 */
/***/ (function(module, exports, __webpack_require__) {

// false -> Array#indexOf
// true  -> Array#includes
var toIObject = __webpack_require__(898)
  , toLength  = __webpack_require__(960)
  , toIndex   = __webpack_require__(961);
module.exports = function(IS_INCLUDES){
  return function($this, el, fromIndex){
    var O      = toIObject($this)
      , length = toLength(O.length)
      , index  = toIndex(fromIndex, length)
      , value;
    // Array#includes uses SameValueZero equality algorithm
    if(IS_INCLUDES && el != el)while(length > index){
      value = O[index++];
      if(value != value)return true;
    // Array#toIndex ignores holes, Array#includes - not
    } else for(;length > index; index++)if(IS_INCLUDES || index in O){
      if(O[index] === el)return IS_INCLUDES || index || 0;
    } return !IS_INCLUDES && -1;
  };
};

/***/ }),
/* 960 */
/***/ (function(module, exports, __webpack_require__) {

// 7.1.15 ToLength
var toInteger = __webpack_require__(914)
  , min       = Math.min;
module.exports = function(it){
  return it > 0 ? min(toInteger(it), 0x1fffffffffffff) : 0; // pow(2, 53) - 1 == 9007199254740991
};

/***/ }),
/* 961 */
/***/ (function(module, exports, __webpack_require__) {

var toInteger = __webpack_require__(914)
  , max       = Math.max
  , min       = Math.min;
module.exports = function(index, length){
  index = toInteger(index);
  return index < 0 ? max(index + length, 0) : min(index, length);
};

/***/ }),
/* 962 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__(894).document && document.documentElement;

/***/ }),
/* 963 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var addToUnscopables = __webpack_require__(964)
  , step             = __webpack_require__(965)
  , Iterators        = __webpack_require__(904)
  , toIObject        = __webpack_require__(898);

// 22.1.3.4 Array.prototype.entries()
// 22.1.3.13 Array.prototype.keys()
// 22.1.3.29 Array.prototype.values()
// 22.1.3.30 Array.prototype[@@iterator]()
module.exports = __webpack_require__(930)(Array, 'Array', function(iterated, kind){
  this._t = toIObject(iterated); // target
  this._i = 0;                   // next index
  this._k = kind;                // kind
// 22.1.5.2.1 %ArrayIteratorPrototype%.next()
}, function(){
  var O     = this._t
    , kind  = this._k
    , index = this._i++;
  if(!O || index >= O.length){
    this._t = undefined;
    return step(1);
  }
  if(kind == 'keys'  )return step(0, index);
  if(kind == 'values')return step(0, O[index]);
  return step(0, [index, O[index]]);
}, 'values');

// argumentsList[@@iterator] is %ArrayProto_values% (9.4.4.6, 9.4.4.7)
Iterators.Arguments = Iterators.Array;

addToUnscopables('keys');
addToUnscopables('values');
addToUnscopables('entries');

/***/ }),
/* 964 */
/***/ (function(module, exports) {

module.exports = function(){ /* empty */ };

/***/ }),
/* 965 */
/***/ (function(module, exports) {

module.exports = function(done, value){
  return {value: value, done: !!done};
};

/***/ }),
/* 966 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = { "default": __webpack_require__(967), __esModule: true };

/***/ }),
/* 967 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(968);
__webpack_require__(974);
__webpack_require__(975);
__webpack_require__(976);
module.exports = __webpack_require__(892).Symbol;

/***/ }),
/* 968 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// ECMAScript 6 symbols shim
var global         = __webpack_require__(894)
  , has            = __webpack_require__(895)
  , DESCRIPTORS    = __webpack_require__(897)
  , $export        = __webpack_require__(899)
  , redefine       = __webpack_require__(931)
  , META           = __webpack_require__(969).KEY
  , $fails         = __webpack_require__(903)
  , shared         = __webpack_require__(911)
  , setToStringTag = __webpack_require__(919)
  , uid            = __webpack_require__(905)
  , wks            = __webpack_require__(893)
  , wksExt         = __webpack_require__(921)
  , wksDefine      = __webpack_require__(922)
  , keyOf          = __webpack_require__(970)
  , enumKeys       = __webpack_require__(971)
  , isArray        = __webpack_require__(972)
  , anObject       = __webpack_require__(901)
  , toIObject      = __webpack_require__(898)
  , toPrimitive    = __webpack_require__(912)
  , createDesc     = __webpack_require__(906)
  , _create        = __webpack_require__(916)
  , gOPNExt        = __webpack_require__(973)
  , $GOPD          = __webpack_require__(935)
  , $DP            = __webpack_require__(896)
  , $keys          = __webpack_require__(907)
  , gOPD           = $GOPD.f
  , dP             = $DP.f
  , gOPN           = gOPNExt.f
  , $Symbol        = global.Symbol
  , $JSON          = global.JSON
  , _stringify     = $JSON && $JSON.stringify
  , PROTOTYPE      = 'prototype'
  , HIDDEN         = wks('_hidden')
  , TO_PRIMITIVE   = wks('toPrimitive')
  , isEnum         = {}.propertyIsEnumerable
  , SymbolRegistry = shared('symbol-registry')
  , AllSymbols     = shared('symbols')
  , OPSymbols      = shared('op-symbols')
  , ObjectProto    = Object[PROTOTYPE]
  , USE_NATIVE     = typeof $Symbol == 'function'
  , QObject        = global.QObject;
// Don't use setters in Qt Script, https://github.com/zloirock/core-js/issues/173
var setter = !QObject || !QObject[PROTOTYPE] || !QObject[PROTOTYPE].findChild;

// fallback for old Android, https://code.google.com/p/v8/issues/detail?id=687
var setSymbolDesc = DESCRIPTORS && $fails(function(){
  return _create(dP({}, 'a', {
    get: function(){ return dP(this, 'a', {value: 7}).a; }
  })).a != 7;
}) ? function(it, key, D){
  var protoDesc = gOPD(ObjectProto, key);
  if(protoDesc)delete ObjectProto[key];
  dP(it, key, D);
  if(protoDesc && it !== ObjectProto)dP(ObjectProto, key, protoDesc);
} : dP;

var wrap = function(tag){
  var sym = AllSymbols[tag] = _create($Symbol[PROTOTYPE]);
  sym._k = tag;
  return sym;
};

var isSymbol = USE_NATIVE && typeof $Symbol.iterator == 'symbol' ? function(it){
  return typeof it == 'symbol';
} : function(it){
  return it instanceof $Symbol;
};

var $defineProperty = function defineProperty(it, key, D){
  if(it === ObjectProto)$defineProperty(OPSymbols, key, D);
  anObject(it);
  key = toPrimitive(key, true);
  anObject(D);
  if(has(AllSymbols, key)){
    if(!D.enumerable){
      if(!has(it, HIDDEN))dP(it, HIDDEN, createDesc(1, {}));
      it[HIDDEN][key] = true;
    } else {
      if(has(it, HIDDEN) && it[HIDDEN][key])it[HIDDEN][key] = false;
      D = _create(D, {enumerable: createDesc(0, false)});
    } return setSymbolDesc(it, key, D);
  } return dP(it, key, D);
};
var $defineProperties = function defineProperties(it, P){
  anObject(it);
  var keys = enumKeys(P = toIObject(P))
    , i    = 0
    , l = keys.length
    , key;
  while(l > i)$defineProperty(it, key = keys[i++], P[key]);
  return it;
};
var $create = function create(it, P){
  return P === undefined ? _create(it) : $defineProperties(_create(it), P);
};
var $propertyIsEnumerable = function propertyIsEnumerable(key){
  var E = isEnum.call(this, key = toPrimitive(key, true));
  if(this === ObjectProto && has(AllSymbols, key) && !has(OPSymbols, key))return false;
  return E || !has(this, key) || !has(AllSymbols, key) || has(this, HIDDEN) && this[HIDDEN][key] ? E : true;
};
var $getOwnPropertyDescriptor = function getOwnPropertyDescriptor(it, key){
  it  = toIObject(it);
  key = toPrimitive(key, true);
  if(it === ObjectProto && has(AllSymbols, key) && !has(OPSymbols, key))return;
  var D = gOPD(it, key);
  if(D && has(AllSymbols, key) && !(has(it, HIDDEN) && it[HIDDEN][key]))D.enumerable = true;
  return D;
};
var $getOwnPropertyNames = function getOwnPropertyNames(it){
  var names  = gOPN(toIObject(it))
    , result = []
    , i      = 0
    , key;
  while(names.length > i){
    if(!has(AllSymbols, key = names[i++]) && key != HIDDEN && key != META)result.push(key);
  } return result;
};
var $getOwnPropertySymbols = function getOwnPropertySymbols(it){
  var IS_OP  = it === ObjectProto
    , names  = gOPN(IS_OP ? OPSymbols : toIObject(it))
    , result = []
    , i      = 0
    , key;
  while(names.length > i){
    if(has(AllSymbols, key = names[i++]) && (IS_OP ? has(ObjectProto, key) : true))result.push(AllSymbols[key]);
  } return result;
};

// 19.4.1.1 Symbol([description])
if(!USE_NATIVE){
  $Symbol = function Symbol(){
    if(this instanceof $Symbol)throw TypeError('Symbol is not a constructor!');
    var tag = uid(arguments.length > 0 ? arguments[0] : undefined);
    var $set = function(value){
      if(this === ObjectProto)$set.call(OPSymbols, value);
      if(has(this, HIDDEN) && has(this[HIDDEN], tag))this[HIDDEN][tag] = false;
      setSymbolDesc(this, tag, createDesc(1, value));
    };
    if(DESCRIPTORS && setter)setSymbolDesc(ObjectProto, tag, {configurable: true, set: $set});
    return wrap(tag);
  };
  redefine($Symbol[PROTOTYPE], 'toString', function toString(){
    return this._k;
  });

  $GOPD.f = $getOwnPropertyDescriptor;
  $DP.f   = $defineProperty;
  __webpack_require__(934).f = gOPNExt.f = $getOwnPropertyNames;
  __webpack_require__(923).f  = $propertyIsEnumerable;
  __webpack_require__(933).f = $getOwnPropertySymbols;

  if(DESCRIPTORS && !__webpack_require__(915)){
    redefine(ObjectProto, 'propertyIsEnumerable', $propertyIsEnumerable, true);
  }

  wksExt.f = function(name){
    return wrap(wks(name));
  }
}

$export($export.G + $export.W + $export.F * !USE_NATIVE, {Symbol: $Symbol});

for(var symbols = (
  // 19.4.2.2, 19.4.2.3, 19.4.2.4, 19.4.2.6, 19.4.2.8, 19.4.2.9, 19.4.2.10, 19.4.2.11, 19.4.2.12, 19.4.2.13, 19.4.2.14
  'hasInstance,isConcatSpreadable,iterator,match,replace,search,species,split,toPrimitive,toStringTag,unscopables'
).split(','), i = 0; symbols.length > i; )wks(symbols[i++]);

for(var symbols = $keys(wks.store), i = 0; symbols.length > i; )wksDefine(symbols[i++]);

$export($export.S + $export.F * !USE_NATIVE, 'Symbol', {
  // 19.4.2.1 Symbol.for(key)
  'for': function(key){
    return has(SymbolRegistry, key += '')
      ? SymbolRegistry[key]
      : SymbolRegistry[key] = $Symbol(key);
  },
  // 19.4.2.5 Symbol.keyFor(sym)
  keyFor: function keyFor(key){
    if(isSymbol(key))return keyOf(SymbolRegistry, key);
    throw TypeError(key + ' is not a symbol!');
  },
  useSetter: function(){ setter = true; },
  useSimple: function(){ setter = false; }
});

$export($export.S + $export.F * !USE_NATIVE, 'Object', {
  // 19.1.2.2 Object.create(O [, Properties])
  create: $create,
  // 19.1.2.4 Object.defineProperty(O, P, Attributes)
  defineProperty: $defineProperty,
  // 19.1.2.3 Object.defineProperties(O, Properties)
  defineProperties: $defineProperties,
  // 19.1.2.6 Object.getOwnPropertyDescriptor(O, P)
  getOwnPropertyDescriptor: $getOwnPropertyDescriptor,
  // 19.1.2.7 Object.getOwnPropertyNames(O)
  getOwnPropertyNames: $getOwnPropertyNames,
  // 19.1.2.8 Object.getOwnPropertySymbols(O)
  getOwnPropertySymbols: $getOwnPropertySymbols
});

// 24.3.2 JSON.stringify(value [, replacer [, space]])
$JSON && $export($export.S + $export.F * (!USE_NATIVE || $fails(function(){
  var S = $Symbol();
  // MS Edge converts symbol values to JSON as {}
  // WebKit converts symbol values to JSON as null
  // V8 throws on boxed symbols
  return _stringify([S]) != '[null]' || _stringify({a: S}) != '{}' || _stringify(Object(S)) != '{}';
})), 'JSON', {
  stringify: function stringify(it){
    if(it === undefined || isSymbol(it))return; // IE8 returns string on undefined
    var args = [it]
      , i    = 1
      , replacer, $replacer;
    while(arguments.length > i)args.push(arguments[i++]);
    replacer = args[1];
    if(typeof replacer == 'function')$replacer = replacer;
    if($replacer || !isArray(replacer))replacer = function(key, value){
      if($replacer)value = $replacer.call(this, key, value);
      if(!isSymbol(value))return value;
    };
    args[1] = replacer;
    return _stringify.apply($JSON, args);
  }
});

// 19.4.3.4 Symbol.prototype[@@toPrimitive](hint)
$Symbol[PROTOTYPE][TO_PRIMITIVE] || __webpack_require__(900)($Symbol[PROTOTYPE], TO_PRIMITIVE, $Symbol[PROTOTYPE].valueOf);
// 19.4.3.5 Symbol.prototype[@@toStringTag]
setToStringTag($Symbol, 'Symbol');
// 20.2.1.9 Math[@@toStringTag]
setToStringTag(Math, 'Math', true);
// 24.3.3 JSON[@@toStringTag]
setToStringTag(global.JSON, 'JSON', true);

/***/ }),
/* 969 */
/***/ (function(module, exports, __webpack_require__) {

var META     = __webpack_require__(905)('meta')
  , isObject = __webpack_require__(902)
  , has      = __webpack_require__(895)
  , setDesc  = __webpack_require__(896).f
  , id       = 0;
var isExtensible = Object.isExtensible || function(){
  return true;
};
var FREEZE = !__webpack_require__(903)(function(){
  return isExtensible(Object.preventExtensions({}));
});
var setMeta = function(it){
  setDesc(it, META, {value: {
    i: 'O' + ++id, // object ID
    w: {}          // weak collections IDs
  }});
};
var fastKey = function(it, create){
  // return primitive with prefix
  if(!isObject(it))return typeof it == 'symbol' ? it : (typeof it == 'string' ? 'S' : 'P') + it;
  if(!has(it, META)){
    // can't set metadata to uncaught frozen object
    if(!isExtensible(it))return 'F';
    // not necessary to add metadata
    if(!create)return 'E';
    // add missing metadata
    setMeta(it);
  // return object ID
  } return it[META].i;
};
var getWeak = function(it, create){
  if(!has(it, META)){
    // can't set metadata to uncaught frozen object
    if(!isExtensible(it))return true;
    // not necessary to add metadata
    if(!create)return false;
    // add missing metadata
    setMeta(it);
  // return hash weak collections IDs
  } return it[META].w;
};
// add metadata on freeze-family methods calling
var onFreeze = function(it){
  if(FREEZE && meta.NEED && isExtensible(it) && !has(it, META))setMeta(it);
  return it;
};
var meta = module.exports = {
  KEY:      META,
  NEED:     false,
  fastKey:  fastKey,
  getWeak:  getWeak,
  onFreeze: onFreeze
};

/***/ }),
/* 970 */
/***/ (function(module, exports, __webpack_require__) {

var getKeys   = __webpack_require__(907)
  , toIObject = __webpack_require__(898);
module.exports = function(object, el){
  var O      = toIObject(object)
    , keys   = getKeys(O)
    , length = keys.length
    , index  = 0
    , key;
  while(length > index)if(O[key = keys[index++]] === el)return key;
};

/***/ }),
/* 971 */
/***/ (function(module, exports, __webpack_require__) {

// all enumerable object keys, includes symbols
var getKeys = __webpack_require__(907)
  , gOPS    = __webpack_require__(933)
  , pIE     = __webpack_require__(923);
module.exports = function(it){
  var result     = getKeys(it)
    , getSymbols = gOPS.f;
  if(getSymbols){
    var symbols = getSymbols(it)
      , isEnum  = pIE.f
      , i       = 0
      , key;
    while(symbols.length > i)if(isEnum.call(it, key = symbols[i++]))result.push(key);
  } return result;
};

/***/ }),
/* 972 */
/***/ (function(module, exports, __webpack_require__) {

// 7.2.2 IsArray(argument)
var cof = __webpack_require__(917);
module.exports = Array.isArray || function isArray(arg){
  return cof(arg) == 'Array';
};

/***/ }),
/* 973 */
/***/ (function(module, exports, __webpack_require__) {

// fallback for IE11 buggy Object.getOwnPropertyNames with iframe and window
var toIObject = __webpack_require__(898)
  , gOPN      = __webpack_require__(934).f
  , toString  = {}.toString;

var windowNames = typeof window == 'object' && window && Object.getOwnPropertyNames
  ? Object.getOwnPropertyNames(window) : [];

var getWindowNames = function(it){
  try {
    return gOPN(it);
  } catch(e){
    return windowNames.slice();
  }
};

module.exports.f = function getOwnPropertyNames(it){
  return windowNames && toString.call(it) == '[object Window]' ? getWindowNames(it) : gOPN(toIObject(it));
};


/***/ }),
/* 974 */
/***/ (function(module, exports) {



/***/ }),
/* 975 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(922)('asyncIterator');

/***/ }),
/* 976 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(922)('observable');

/***/ }),
/* 977 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _setPrototypeOf = __webpack_require__(978);

var _setPrototypeOf2 = _interopRequireDefault(_setPrototypeOf);

var _create = __webpack_require__(982);

var _create2 = _interopRequireDefault(_create);

var _typeof2 = __webpack_require__(929);

var _typeof3 = _interopRequireDefault(_typeof2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = function (subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function, not " + (typeof superClass === "undefined" ? "undefined" : (0, _typeof3.default)(superClass)));
  }

  subClass.prototype = (0, _create2.default)(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      enumerable: false,
      writable: true,
      configurable: true
    }
  });
  if (superClass) _setPrototypeOf2.default ? (0, _setPrototypeOf2.default)(subClass, superClass) : subClass.__proto__ = superClass;
};

/***/ }),
/* 978 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = { "default": __webpack_require__(979), __esModule: true };

/***/ }),
/* 979 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(980);
module.exports = __webpack_require__(892).Object.setPrototypeOf;

/***/ }),
/* 980 */
/***/ (function(module, exports, __webpack_require__) {

// 19.1.3.19 Object.setPrototypeOf(O, proto)
var $export = __webpack_require__(899);
$export($export.S, 'Object', {setPrototypeOf: __webpack_require__(981).set});

/***/ }),
/* 981 */
/***/ (function(module, exports, __webpack_require__) {

// Works with __proto__ only. Old v8 can't work with null proto objects.
/* eslint-disable no-proto */
var isObject = __webpack_require__(902)
  , anObject = __webpack_require__(901);
var check = function(O, proto){
  anObject(O);
  if(!isObject(proto) && proto !== null)throw TypeError(proto + ": can't set as prototype!");
};
module.exports = {
  set: Object.setPrototypeOf || ('__proto__' in {} ? // eslint-disable-line
    function(test, buggy, set){
      try {
        set = __webpack_require__(926)(Function.call, __webpack_require__(935).f(Object.prototype, '__proto__').set, 2);
        set(test, []);
        buggy = !(test instanceof Array);
      } catch(e){ buggy = true; }
      return function setPrototypeOf(O, proto){
        check(O, proto);
        if(buggy)O.__proto__ = proto;
        else set(O, proto);
        return O;
      };
    }({}, false) : undefined),
  check: check
};

/***/ }),
/* 982 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = { "default": __webpack_require__(983), __esModule: true };

/***/ }),
/* 983 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(984);
var $Object = __webpack_require__(892).Object;
module.exports = function create(P, D){
  return $Object.create(P, D);
};

/***/ }),
/* 984 */
/***/ (function(module, exports, __webpack_require__) {

var $export = __webpack_require__(899)
// 19.1.2.2 / 15.2.3.5 Object.create(O [, Properties])
$export($export.S, 'Object', {create: __webpack_require__(916)});

/***/ }),
/* 985 */
/***/ (function(module, exports, __webpack_require__) {

/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 */

if (false) {
  var REACT_ELEMENT_TYPE = (typeof Symbol === 'function' &&
    Symbol.for &&
    Symbol.for('react.element')) ||
    0xeac7;

  var isValidElement = function(object) {
    return typeof object === 'object' &&
      object !== null &&
      object.$$typeof === REACT_ELEMENT_TYPE;
  };

  // By explicitly using `prop-types` you are opting into new development behavior.
  // http://fb.me/prop-types-in-prod
  var throwOnDirectAccess = true;
  module.exports = require('./factoryWithTypeCheckers')(isValidElement, throwOnDirectAccess);
} else {
  // By explicitly using `prop-types` you are opting into new production behavior.
  // http://fb.me/prop-types-in-prod
  module.exports = __webpack_require__(986)();
}


/***/ }),
/* 986 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 */



var emptyFunction = __webpack_require__(418);
var invariant = __webpack_require__(417);
var ReactPropTypesSecret = __webpack_require__(987);

module.exports = function() {
  function shim(props, propName, componentName, location, propFullName, secret) {
    if (secret === ReactPropTypesSecret) {
      // It is still safe when called from React.
      return;
    }
    invariant(
      false,
      'Calling PropTypes validators directly is not supported by the `prop-types` package. ' +
      'Use PropTypes.checkPropTypes() to call them. ' +
      'Read more at http://fb.me/use-check-prop-types'
    );
  };
  shim.isRequired = shim;
  function getShim() {
    return shim;
  };
  // Important!
  // Keep this list in sync with production version in `./factoryWithTypeCheckers.js`.
  var ReactPropTypes = {
    array: shim,
    bool: shim,
    func: shim,
    number: shim,
    object: shim,
    string: shim,
    symbol: shim,

    any: shim,
    arrayOf: getShim,
    element: shim,
    instanceOf: getShim,
    node: shim,
    objectOf: getShim,
    oneOf: getShim,
    oneOfType: getShim,
    shape: getShim
  };

  ReactPropTypes.checkPropTypes = emptyFunction;
  ReactPropTypes.PropTypes = ReactPropTypes;

  return ReactPropTypes;
};


/***/ }),
/* 987 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 */



var ReactPropTypesSecret = 'SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED';

module.exports = ReactPropTypesSecret;


/***/ }),
/* 988 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2015, Yahoo! Inc.
 * Copyrights licensed under the New BSD License. See the accompanying LICENSE file for terms.
 */


var REACT_STATICS = {
    childContextTypes: true,
    contextTypes: true,
    defaultProps: true,
    displayName: true,
    getDefaultProps: true,
    mixins: true,
    propTypes: true,
    type: true
};

var KNOWN_STATICS = {
  name: true,
  length: true,
  prototype: true,
  caller: true,
  callee: true,
  arguments: true,
  arity: true
};

var getOwnPropertySymbols = Object.getOwnPropertySymbols;
var hasOwnProperty = Object.prototype.hasOwnProperty;
var propIsEnumerable = Object.prototype.propertyIsEnumerable;
var getPrototypeOf = Object.getPrototypeOf;
var objectPrototype = getPrototypeOf && getPrototypeOf(Object);
var getOwnPropertyNames = Object.getOwnPropertyNames;

module.exports = function hoistNonReactStatics(targetComponent, sourceComponent, blacklist) {
    if (typeof sourceComponent !== 'string') { // don't hoist over string (html) components

        if (objectPrototype) {
            var inheritedComponent = getPrototypeOf(sourceComponent);
            if (inheritedComponent && inheritedComponent !== objectPrototype) {
                hoistNonReactStatics(targetComponent, inheritedComponent, blacklist);
            }
        }

        var keys = getOwnPropertyNames(sourceComponent);

        if (getOwnPropertySymbols) {
            keys = keys.concat(getOwnPropertySymbols(sourceComponent));
        }

        for (var i = 0; i < keys.length; ++i) {
            var key = keys[i];
            if (!REACT_STATICS[key] && !KNOWN_STATICS[key] && (!blacklist || !blacklist[key])) {
                // Only hoist enumerables and non-enumerable functions
                if(propIsEnumerable.call(sourceComponent, key) || typeof sourceComponent[key] === 'function') {
                    try { // Avoid failures from read-only properties
                        targetComponent[key] = sourceComponent[key];
                    } catch (e) {}
                }
            }
        }

        return targetComponent;
    }

    return targetComponent;
};


/***/ }),
/* 989 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(888)(false);
// imports


// module
exports.push([module.i, "/*! normalize.css v7.0.0 | MIT License | github.com/necolas/normalize.css */html{line-height:1.15;-ms-text-size-adjust:100%;-webkit-text-size-adjust:100%}body{margin:0}article,aside,footer,header,nav,section{display:block}h1{font-size:2em;margin:.67em 0}figcaption,figure,main{display:block}figure{margin:1em 40px}hr{-webkit-box-sizing:content-box;box-sizing:content-box;height:0;overflow:visible}pre{font-family:monospace,monospace;font-size:1em}a{background-color:transparent;-webkit-text-decoration-skip:objects}abbr[title]{border-bottom:none;text-decoration:underline;-webkit-text-decoration:underline dotted;text-decoration:underline dotted}b,strong{font-weight:inherit;font-weight:bolder}code,kbd,samp{font-family:monospace,monospace;font-size:1em}dfn{font-style:italic}mark{background-color:#ff0;color:#000}small{font-size:80%}sub,sup{font-size:75%;line-height:0;position:relative;vertical-align:baseline}sub{bottom:-.25em}sup{top:-.5em}audio,video{display:inline-block}audio:not([controls]){display:none;height:0}img{border-style:none}svg:not(:root){overflow:hidden}button,input,optgroup,select,textarea{font-family:sans-serif;font-size:100%;line-height:1.15;margin:0}button,input{overflow:visible}button,select{text-transform:none}[type=reset],[type=submit],button,html [type=button]{-webkit-appearance:button}[type=button]::-moz-focus-inner,[type=reset]::-moz-focus-inner,[type=submit]::-moz-focus-inner,button::-moz-focus-inner{border-style:none;padding:0}[type=button]:-moz-focusring,[type=reset]:-moz-focusring,[type=submit]:-moz-focusring,button:-moz-focusring{outline:1px dotted ButtonText}fieldset{padding:.35em .75em .625em}legend{-webkit-box-sizing:border-box;box-sizing:border-box;color:inherit;display:table;max-width:100%;padding:0;white-space:normal}progress{display:inline-block;vertical-align:baseline}textarea{overflow:auto}[type=checkbox],[type=radio]{-webkit-box-sizing:border-box;box-sizing:border-box;padding:0}[type=number]::-webkit-inner-spin-button,[type=number]::-webkit-outer-spin-button{height:auto}[type=search]{-webkit-appearance:textfield;outline-offset:-2px}[type=search]::-webkit-search-cancel-button,[type=search]::-webkit-search-decoration{-webkit-appearance:none}::-webkit-file-upload-button{-webkit-appearance:button;font:inherit}details,menu{display:block}summary{display:list-item}canvas{display:inline-block}[hidden],template{display:none}", ""]);

// exports


/***/ }),
/* 990 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = { "default": __webpack_require__(991), __esModule: true };

/***/ }),
/* 991 */
/***/ (function(module, exports, __webpack_require__) {

var core  = __webpack_require__(892)
  , $JSON = core.JSON || (core.JSON = {stringify: JSON.stringify});
module.exports = function stringify(it){ // eslint-disable-line no-unused-vars
  return $JSON.stringify.apply($JSON, arguments);
};

/***/ }),
/* 992 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _isIterable2 = __webpack_require__(993);

var _isIterable3 = _interopRequireDefault(_isIterable2);

var _getIterator2 = __webpack_require__(996);

var _getIterator3 = _interopRequireDefault(_getIterator2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = function () {
  function sliceIterator(arr, i) {
    var _arr = [];
    var _n = true;
    var _d = false;
    var _e = undefined;

    try {
      for (var _i = (0, _getIterator3.default)(arr), _s; !(_n = (_s = _i.next()).done); _n = true) {
        _arr.push(_s.value);

        if (i && _arr.length === i) break;
      }
    } catch (err) {
      _d = true;
      _e = err;
    } finally {
      try {
        if (!_n && _i["return"]) _i["return"]();
      } finally {
        if (_d) throw _e;
      }
    }

    return _arr;
  }

  return function (arr, i) {
    if (Array.isArray(arr)) {
      return arr;
    } else if ((0, _isIterable3.default)(Object(arr))) {
      return sliceIterator(arr, i);
    } else {
      throw new TypeError("Invalid attempt to destructure non-iterable instance");
    }
  };
}();

/***/ }),
/* 993 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = { "default": __webpack_require__(994), __esModule: true };

/***/ }),
/* 994 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(920);
__webpack_require__(913);
module.exports = __webpack_require__(995);

/***/ }),
/* 995 */
/***/ (function(module, exports, __webpack_require__) {

var classof   = __webpack_require__(937)
  , ITERATOR  = __webpack_require__(893)('iterator')
  , Iterators = __webpack_require__(904);
module.exports = __webpack_require__(892).isIterable = function(it){
  var O = Object(it);
  return O[ITERATOR] !== undefined
    || '@@iterator' in O
    || Iterators.hasOwnProperty(classof(O));
};

/***/ }),
/* 996 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = { "default": __webpack_require__(997), __esModule: true };

/***/ }),
/* 997 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(920);
__webpack_require__(913);
module.exports = __webpack_require__(998);

/***/ }),
/* 998 */
/***/ (function(module, exports, __webpack_require__) {

var anObject = __webpack_require__(901)
  , get      = __webpack_require__(999);
module.exports = __webpack_require__(892).getIterator = function(it){
  var iterFn = get(it);
  if(typeof iterFn != 'function')throw TypeError(it + ' is not iterable!');
  return anObject(iterFn.call(it));
};

/***/ }),
/* 999 */
/***/ (function(module, exports, __webpack_require__) {

var classof   = __webpack_require__(937)
  , ITERATOR  = __webpack_require__(893)('iterator')
  , Iterators = __webpack_require__(904);
module.exports = __webpack_require__(892).getIteratorMethod = function(it){
  if(it != undefined)return it[ITERATOR]
    || it['@@iterator']
    || Iterators[classof(it)];
};

/***/ }),
/* 1000 */
/***/ (function(module, exports, __webpack_require__) {


    var content = __webpack_require__(1001);
    var insertCss = __webpack_require__(889);

    if (typeof content === 'string') {
      content = [[module.i, content, '']];
    }

    module.exports = content.locals || {};
    module.exports._getContent = function() { return content; };
    module.exports._getCss = function() { return content.toString(); };
    module.exports._insertCss = function(options) { return insertCss(content, options) };
    
    // Hot Module Replacement
    // https://webpack.github.io/docs/hot-module-replacement
    // Only activated in browser context
    if (false) {
      var removeCss = function() {};
      module.hot.accept("!!../../../node_modules/css-loader/index.js??ref--2-rules-2!../../../node_modules/postcss-loader/lib/index.js??ref--2-rules-3!./Layout.css", function() {
        content = require("!!../../../node_modules/css-loader/index.js??ref--2-rules-2!../../../node_modules/postcss-loader/lib/index.js??ref--2-rules-3!./Layout.css");

        if (typeof content === 'string') {
          content = [[module.id, content, '']];
        }

        removeCss = insertCss(content, { replace: true });
      });
      module.hot.dispose(function() { removeCss(); });
    }
  

/***/ }),
/* 1001 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(888)(false);
// imports


// module
exports.push([module.i, "html{color:#222;font-weight:100;font-size:1em;font-family:Open Sans,Helvetica,Arial,sans-serif;line-height:1.375}body{margin:0}a{color:#0074c2}::-moz-selection{background:#b3d4fc;text-shadow:none}::selection{background:#b3d4fc;text-shadow:none}hr{display:block;height:1px;border:0;border-top:1px solid #ccc;margin:1em 0;padding:0}audio,canvas,iframe,img,svg,video{vertical-align:middle}fieldset{border:0;margin:0;padding:0}textarea{resize:vertical}.browserupgrade{margin:.2em 0;background:#ccc;color:#000;padding:.2em 0}@media print{*,:after,:before{background:transparent!important;color:#000!important;-webkit-box-shadow:none!important;box-shadow:none!important;text-shadow:none!important}a,a:visited{text-decoration:underline}a[href]:after{content:\" (\" attr(href) \")\"}abbr[title]:after{content:\" (\" attr(title) \")\"}a[href^=\"#\"]:after,a[href^=\"javascript:\"]:after{content:\"\"}blockquote,pre{border:1px solid #999;page-break-inside:avoid}thead{display:table-header-group}img,tr{page-break-inside:avoid}img{max-width:100%!important}h2,h3,p{orphans:3;widows:3}h2,h3{page-break-after:avoid}}._2JqOK{margin-top:22px}._3UUCd{height:200px}._3UUCd h1{color:#fff;margin:0 50px;padding:30px 15px;font-family:Roboto\\, Thin,sans-serif}._3UUCd h1 small{font-family:Roboto\\, Medium,sans-serif;font-size:20px}._2G6JY{font-size:48px}", ""]);

// exports
exports.locals = {
	"eConsultaDiv": "_2JqOK",
	"imageBanner": "_3UUCd",
	"eConsulta": "_2G6JY"
};

/***/ }),
/* 1002 */
/***/ (function(module, exports, __webpack_require__) {


    var content = __webpack_require__(1003);
    var insertCss = __webpack_require__(889);

    if (typeof content === 'string') {
      content = [[module.i, content, '']];
    }

    module.exports = content.locals || {};
    module.exports._getContent = function() { return content; };
    module.exports._getCss = function() { return content.toString(); };
    module.exports._insertCss = function(options) { return insertCss(content, options) };
    
    // Hot Module Replacement
    // https://webpack.github.io/docs/hot-module-replacement
    // Only activated in browser context
    if (false) {
      var removeCss = function() {};
      module.hot.accept("!!../../../node_modules/css-loader/index.js??ref--2-rules-2!../../../node_modules/postcss-loader/lib/index.js??ref--2-rules-3!./Header.css", function() {
        content = require("!!../../../node_modules/css-loader/index.js??ref--2-rules-2!../../../node_modules/postcss-loader/lib/index.js??ref--2-rules-3!./Header.css");

        if (typeof content === 'string') {
          content = [[module.id, content, '']];
        }

        removeCss = insertCss(content, { replace: true });
      });
      module.hot.dispose(function() { removeCss(); });
    }
  

/***/ }),
/* 1003 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(888)(false);
// imports


// module
exports.push([module.i, ".qQ2mF{margin:0 auto;max-width:970px}._2oS_y{color:color(var(--brand-color) lightness(10%));text-decoration:none;font-size:1.75em;display:block;padding:10px 15px;overflow:auto}._2oS_y img{vertical-align:bottom}._2O9_2{width:100%;min-height:54px;background-color:#222;-webkit-box-shadow:0 2px 4px rgba(0,0,0,.6);box-shadow:0 2px 4px rgba(0,0,0,.6);border-top:1px solid #ccc;border-bottom:1px solid #000;padding:0;height:54px}._3hLjh{max-width:970px;width:100%;margin:0 auto;padding:0 15px}._3CwZ_{background-color:#fff;width:560px;height:90px;max-height:315px;margin-right:0;min-height:80px;overflow:hidden;font-size:11px;font-family:Open Sans,sans-serif;opacity:1;-moz-opacity:100;filter:alpha(opacity=100);padding:0;border:1px solid #787878;border-radius:0;-webkit-box-shadow:none;box-shadow:none;top:55px;position:absolute}._3CwZ_ ._3P-sK a div{height:70px;background-position-y:10px;background-repeat:no-repeat;margin-left:10px;display:inline-block;cursor:pointer;background-size:auto}._2Gw65{background-image:url(" + __webpack_require__(1004) + ");background-size:100%;width:200px}._2Gw65:hover{background-image:url(" + __webpack_require__(1005) + ");background-size:100%}._2dLDe{background-image:url(" + __webpack_require__(1006) + ");background-size:100%;width:170px;background-position-y:17px}._2dLDe:hover{background-image:url(" + __webpack_require__(1007) + ");background-size:100%}._20lE2{background-image:url(" + __webpack_require__(1008) + ");background-size:100%;width:140px}._20lE2:hover{background-image:url(" + __webpack_require__(1009) + ");background-size:100%}._2vema{float:right;padding:10px 0;margin:0 16px 0 18px}._2vema button{margin-left:3px;height:35px;width:40px;font-style:italic;background-color:transparent;background-image:none;color:#eee;outline:none;cursor:pointer;font-size:16px;line-height:15px}._2vema button,._2vema button:hover{border:1px solid #333;border-radius:4px}._2vema button:hover{background-color:#333}@media (min-width:768px){._2vema ._3CwZ_{right:0;left:auto}}", ""]);

// exports
exports.locals = {
	"container": "qQ2mF",
	"brand": "_2oS_y",
	"smgbar": "_2O9_2",
	"nav_inner": "_3hLjh",
	"dropdown_menu": "_3CwZ_",
	"btn_group": "_3P-sK",
	"logoSMMP": "_2Gw65",
	"logoLIFE": "_2dLDe",
	"logoSEGUROS": "_20lE2",
	"navbar_right": "_2vema"
};

/***/ }),
/* 1004 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,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"

/***/ }),
/* 1005 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,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"

/***/ }),
/* 1006 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,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"

/***/ }),
/* 1007 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAMYAAABECAYAAADa40qOAAAAGXRFWHRTb2Z0d2FyZQBBZG9iZSBJbWFnZVJlYWR5ccllPAAAAyJpVFh0WE1MOmNvbS5hZG9iZS54bXAAAAAAADw/eHBhY2tldCBiZWdpbj0i77u/IiBpZD0iVzVNME1wQ2VoaUh6cmVTek5UY3prYzlkIj8+IDx4OnhtcG1ldGEgeG1sbnM6eD0iYWRvYmU6bnM6bWV0YS8iIHg6eG1wdGs9IkFkb2JlIFhNUCBDb3JlIDUuMy1jMDExIDY2LjE0NTY2MSwgMjAxMi8wMi8wNi0xNDo1NjoyNyAgICAgICAgIj4gPHJkZjpSREYgeG1sbnM6cmRmPSJodHRwOi8vd3d3LnczLm9yZy8xOTk5LzAyLzIyLXJkZi1zeW50YXgtbnMjIj4gPHJkZjpEZXNjcmlwdGlvbiByZGY6YWJvdXQ9IiIgeG1sbnM6eG1wPSJodHRwOi8vbnMuYWRvYmUuY29tL3hhcC8xLjAvIiB4bWxuczp4bXBNTT0iaHR0cDovL25zLmFkb2JlLmNvbS94YXAvMS4wL21tLyIgeG1sbnM6c3RSZWY9Imh0dHA6Ly9ucy5hZG9iZS5jb20veGFwLzEuMC9zVHlwZS9SZXNvdXJjZVJlZiMiIHhtcDpDcmVhdG9yVG9vbD0iQWRvYmUgUGhvdG9zaG9wIENTNiAoV2luZG93cykiIHhtcE1NOkluc3RhbmNlSUQ9InhtcC5paWQ6NzE2QjZDNkVENjEzMTFFM0JCNThBRTRDOEQ3QTM4OUEiIHhtcE1NOkRvY3VtZW50SUQ9InhtcC5kaWQ6NzE2QjZDNkZENjEzMTFFM0JCNThBRTRDOEQ3QTM4OUEiPiA8eG1wTU06RGVyaXZlZEZyb20gc3RSZWY6aW5zdGFuY2VJRD0ieG1wLmlpZDo3MTZCNkM2Q0Q2MTMxMUUzQkI1OEFFNEM4RDdBMzg5QSIgc3RSZWY6ZG9jdW1lbnRJRD0ieG1wLmRpZDo3MTZCNkM2REQ2MTMxMUUzQkI1OEFFNEM4RDdBMzg5QSIvPiA8L3JkZjpEZXNjcmlwdGlvbj4gPC9yZGY6UkRGPiA8L3g6eG1wbWV0YT4gPD94cGFja2V0IGVuZD0iciI/PhDWiekAAAoTSURBVHja7Fy/b+tGEl4Hxr3yMYdDihyCx9QJYLq6dKb+gEB2k1ZSkN7WXyDpL5Dd30VUe41lpLxCdKq8ynyHC1KGQZCUCY0g1R3g2/F9G89b7/KHzHuh7PkAQj/IXe7Ozje7M7Pkzs3NjRIIBK/jLRGBQCDEEAiEGAKBEEMgEGIIBEIMgUCIIRAIMQQCIYZAIMQQCIQYAoEQQyAQYggEQgyBQCDEEAiEGAKBEEMgEGIIBEIMgeDNYLdpgZ2dndd+//XzxVB/9PUR6CPWR8pO038Xn306murrYpx3IdXXpFX31nWE+mNYckmi68kd5ajMgT6ofKSPDKfo85pd+hxtHLva88MHH5XdP/3z119tXAZtDCtEUFdOZbI2yHVdib52+kAdaqseRXpCn114D8HupgW1IEjBzqH8pEgJ/j/UHxMiBJTxwAgQpKHBn+tjBsVc6GOgj/dr3Jbu+UIfS3yfow6qq8BhE2KO/+mamSEO2n+Ie1MfEnxGnv4O//XPbw4+/MeXZcRMbQXVZQY1yxiyctkMQKqVPs4gw1rKinqPIe8xkzthxOpKcZ8Y1ymMicLvnBm5PtozQ7kJxjfB7xj3HEHmC3b/jNVzwPq1ZP2cqo5g9wGkMJ3e18qWMdZTZ1f6mnOcz/F/br7rc3TNFZXFgM9J8Qy5SkBCvySrifrJWu172riAsKltPX1dYVmnDOemsHbHGMAhBs/G4Ne3n8cNRRXrMsOa1vK2Pbott+TQv9/W39f0n/5+1NDyGlmTnL7FOIToV4/POvhO110xo0DXjRzjQeM6A8H2IL/IqmcPBFrinmSMTj31TJgRfRQ+hrHUKSeFhZFRDsfAFbAWc1ibAlajioyKzUABhO8jhcGRTQrPFN7DICnfrPGGkDPrqlpQmhyy5kRw4cKa8VIf6UDUCxgRe3xfWW321VPoY4wxnGw9MbTSGWv6XYWyFWZqZmXsZZFRQBq4mCm/b7awifDc0b4p2hb7fI4Si30Ekh48JkeyyjCUzDpl5xMsqVwoGtwnYXoSbS0xoMyXZjYo6wyWVWmJBV6yNatRfp/THVtTe2bXi+v6OBdimdZEGTIMUqQEXsceclZYIqVw9pvWE5pyGNeVZwm7NcTImcNFWMPh9mHkmb5D1DGAdSLBDD2zyzEjT1Bilcx1A6boTS1lgrX+odDAiT6Pnml59epEyhw45MswWp5tWE83nG9SYliMAEsPWs+f6/8yWOgVn7pLpmRaqxa6XIro0RmEdcKjEyDKIdajNiFCW9h0HXyMhwjZ6ez+8s6f1MtPPr73/1/+/kXPFzHapEyHZ4sIM/xFC/VMms7onY9KwbFew2F9H8o8AEkWuuOJYqHRCpBwFmR5dLkc9fCw3YntW4AsGbc4EHbGSNv2mnz872d/CH567917J1z5CyDRZdKGZTq7hML4Bi2Q4rxLy6bWiIFw6RE6SEp7iiTeobqLddOy6BQEKRzCydkMlEPwMxCLh26JKDwkewkf4NpqVoCISMh8kDYd2E2WZfm2zQpWEMNgD3IlQ/htw6oGzAfZw9iR7lw9OmIwcuzDoq/NUkr/P2Kx7hM46HYeIbCiWibJM0Y5+p5giZWWRVWIZB6lva5hueY1upqxZdxTQmr5lQNfcKQCr5iRyjH2x13v/O5DCkNhybKY2WKCpQwR5Eh/P2EEmVrEsEk2x/9nqMesQ3sexz1z1cXwosYM0ANJhrgXOYAZSw6OHcmpJwGHI5xY+aG6yKy6EuhFp/FWi4JcIfFDRx9Z2wTRJjt5FzmWOmdQRrOEOsdskTssWeiIShUgQ+5xzKsiUUsQMjbteKqkKJHTqI0lKuS6elTEqLIaLDOaYbZYepS0cChnH/8nKLOs0aSIzQARiFQ0IQYj3Cv2+14C84cPPor1ceM5pq5KNynTcVx0rJ7OzBjDOhlKrMtj5c437Hn+J2EdwsH27SQt1N0+HXsplcHikzUKTSKqJWd0/fKTj9dNHdimZVpo5wJLw64jd7Q90MfP20qMooHzZJwtmwSBx2E+Rd0HyhPjRrnA45CbfTdmpnlSSTrmG/3flikUfWwjEUd1mG3mhhTqfymAdFuJkdWdNYC+Y6DCEmf+Nj+B7SR1cGA5jGaryAo+Q914efhISJFssjfqd257BFJEXVlibep800ywKFM6nAthtWfs/xjLHF9ZurYqPBozvyBwlB9gOZareiFZQzCzFX1rNhKSUmHLuHke5bKlesM31P4TBFrMCmK1rcQwD/2Q4NYlCj7HNWPr4aAFFHZY4ryvSgQZM+HdJvv4JjZYyx5mKiJOXBUwYA8thbBc+e84JqF1/wOf4iLEfQ5Dcg0jkZbNhCUb/vrWkjfesP0vPEbs3jgickn928d1WVdmu03yGK8gxDNY5ivdwbFRZliaOTpKeYEVFM8k1IxFp2VOASUoqjLLZqYxdeB3Cp/kHEnFjAm3B2tUYOkX496/7eUCqU9QRwHFOvJtZfnPs2fKtb3jj9//mPrIVLcM2hLDRzpiPtcJCHDBFN08Srw0yUdDfssIHTOirPB7Dlml2KsW4p4ZcjgFu65QFQlWa4Yh4xIhyWu27Rxjq0+m7p6QHOD3DDmsSN1tKu0Edpo+X/u3RRJAAOYZatsipBjEhCngXJVv5a7MLsO61MGYk8xsQoQyRcyCGn/mEmSpIqa3D7TPy1NmqDwPYNllasiolv+HTZTe+zqurZSrr38bjk8ZiOhJF575bkwM+2UIAkHb6AIx5PU5AoEQQyAQYjw6NMjJCB6I3Q0GZ4goRu5wINeIPKS2M83KGQd5ZZfFw0rkzMc8K4rzN3CYR46yU+ZszuzXviA6daxqvIoGWxJy3Ou1N4ygbSbmPvY57CYsTa/2gUzsgMBUWVteWN0FggGuYMQhvV6n6jVDiFBRUIG2znxXthmSvToocYzZmjvFnrGcWeemcNhd45crx6POCDyYXQoUMUu2ccYITAd90Q71+mY8A+r8Po5006iLcr8AYcDqdiX0XhhlrnMPvKsqV+4tJSaJ5g1hggQFtuIHDR5yonvTE5GxJ98wUfVeNWPe2RTX3CF8T64MJlHK+0eKu7QJUwO5Y/xuc0jod0/VT8h2jhhGKL4nsPiDKcozuD+XLBXKlguRw5oEGKyiQlGoXW2EFAsQuyq2v8QM0MpzzbDSt/Kp2iTIXi4xq1l9pPw7mVPVTsKzUHdbdVznzGewrcSYqLuEmAsD5Y6hJyATWcJTj9Vaq7uXufkUfO6wzuaNe1ceRaQyfVXvfUcRlhC+QQwhg7BCORPMAE0s6m/bOxwb9Y5hUY9UdY6CcK3qv9/pVq4eH2aiNs+C2+N7pqwNqOwNjFcYv048LbnThZixQCBRKYFAiCEQCDEEAiGGQCDEEAiEGAKBQIghEAgxBAIhhkAgxBAIhBgCgRBDIBBiCARCDIFAiCEQCDEEAiGGQCDEEAieAv4rwACWI/c4Vo51PQAAAABJRU5ErkJggg=="

/***/ }),
/* 1008 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,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"

/***/ }),
/* 1009 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,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"

/***/ }),
/* 1010 */
/***/ (function(module, exports, __webpack_require__) {


    var content = __webpack_require__(1011);
    var insertCss = __webpack_require__(889);

    if (typeof content === 'string') {
      content = [[module.i, content, '']];
    }

    module.exports = content.locals || {};
    module.exports._getContent = function() { return content; };
    module.exports._getCss = function() { return content.toString(); };
    module.exports._insertCss = function(options) { return insertCss(content, options) };
    
    // Hot Module Replacement
    // https://webpack.github.io/docs/hot-module-replacement
    // Only activated in browser context
    if (false) {
      var removeCss = function() {};
      module.hot.accept("!!../../../node_modules/css-loader/index.js??ref--2-rules-2!../../../node_modules/postcss-loader/lib/index.js??ref--2-rules-3!./Navigation.css", function() {
        content = require("!!../../../node_modules/css-loader/index.js??ref--2-rules-2!../../../node_modules/postcss-loader/lib/index.js??ref--2-rules-3!./Navigation.css");

        if (typeof content === 'string') {
          content = [[module.id, content, '']];
        }

        removeCss = insertCss(content, { replace: true });
      });
      module.hot.dispose(function() { removeCss(); });
    }
  

/***/ }),
/* 1011 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(888)(false);
// imports


// module
exports.push([module.i, "._2gcJx{float:right;position:relative;z-index:2;margin-right:15px;min-height:70px}._2gcJx ul{margin-bottom:10px}._2gcJx ul li{list-style:none;display:inline}.Ntl35{display:inline-block;text-decoration:none!important;font-size:11px;padding:25px 15px 10px;cursor:pointer;line-height:20px}._3hAr4{font-weight:700}.Ntl35,.Ntl35:active,.Ntl35:visited{color:#000;text-decoration:none}.Ntl35:hover{text-decoration:none;background-color:#eee;color:#f40000}._3vZVG{color:#000;font-size:.8em;margin:0 1px}._3vZVG:hover{color:#f40000}", ""]);

// exports
exports.locals = {
	"root": "_2gcJx",
	"link": "Ntl35",
	"active": "_3hAr4",
	"spacer": "_3vZVG"
};

/***/ }),
/* 1012 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "05f491b7.png";

/***/ }),
/* 1013 */
/***/ (function(module, exports, __webpack_require__) {


    var content = __webpack_require__(1014);
    var insertCss = __webpack_require__(889);

    if (typeof content === 'string') {
      content = [[module.i, content, '']];
    }

    module.exports = content.locals || {};
    module.exports._getContent = function() { return content; };
    module.exports._getCss = function() { return content.toString(); };
    module.exports._insertCss = function(options) { return insertCss(content, options) };
    
    // Hot Module Replacement
    // https://webpack.github.io/docs/hot-module-replacement
    // Only activated in browser context
    if (false) {
      var removeCss = function() {};
      module.hot.accept("!!../../../node_modules/css-loader/index.js??ref--2-rules-2!../../../node_modules/postcss-loader/lib/index.js??ref--2-rules-3!./Login.css", function() {
        content = require("!!../../../node_modules/css-loader/index.js??ref--2-rules-2!../../../node_modules/postcss-loader/lib/index.js??ref--2-rules-3!./Login.css");

        if (typeof content === 'string') {
          content = [[module.id, content, '']];
        }

        removeCss = insertCss(content, { replace: true });
      });
      module.hot.dispose(function() { removeCss(); });
    }
  

/***/ }),
/* 1014 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(888)(false);
// imports


// module
exports.push([module.i, "._2X8p1{margin-left:auto;margin-right:0;float:right;position:relative;padding:10px 0}._2X8p1 button{border:0 none;background:transparent;color:#fff;cursor:pointer;padding:8px;padding:.5rem;font-size:14px;padding-right:16px;position:relative}.Thqp2{border:1px solid red!important}._2X8p1 button:focus{outline:0}._2X8p1 button._5tz0M{color:#fff;background-color:#080808;border:0 none}._2X8p1 button i._33oPt{margin-right:5px}._2X8p1 button i._1gq5M{color:#f40000;position:absolute;right:1px;top:8px;line-height:10px}._2KK4E{max-height:482px;overflow:hidden;font-size:11px;font-family:Open Sans,sans-serif;-moz-opacity:100;opacity:1;filter:alpha(opacity=100);padding:0;border-radius:0;-webkit-box-shadow:none;box-shadow:none;display:block}._2KK4E li a{display:block;padding:3px 20px;clear:both;font-weight:400;line-height:1.428571429;color:#333;white-space:nowrap;text-decoration:none;cursor:pointer}._2KK4E li a:hover{background-color:#ddd}.nDeV0{background-color:#222;position:absolute;top:62px;right:110px;width:25px;height:25px;-webkit-transform:rotate(-45deg);-ms-transform:rotate(-45deg);transform:rotate(-45deg)}._3bPTx,._38A26{position:relative;text-align:right;float:right;padding:14px;max-width:250px;width:100%}._3bPTx button{font-size:12px;line-height:1.5;cursor:pointer;padding:5px 10px}._38A26 a{margin:0 5px;height:35px;width:40px;padding:2px 0;font-size:16px;font-style:italic;background-color:transparent;background-image:none;color:#eee;outline:none}._38A26 a,._38A26 a:hover{border:1px solid #333;border-radius:4px}._38A26 a:hover{background-color:#333}._38A26 a i{font-size:22px;line-height:27px}._1N9iR{padding-top:15px;position:absolute;top:70px;color:#fff;left:0;background-color:#222;border-radius:5px;-webkit-box-shadow:3px 4px 10px #333;box-shadow:3px 4px 10px #333;width:250px;text-align:center}._1N9iR ._37UD4{width:100%}._1N9iR input,._1N9iR select{height:30px;padding:0 10px;font-size:12px;border-radius:0;outline:none;border:none}._1N9iR a{color:#fff;text-decoration:underline;font-size:12px!important}._1N9iR ._3rO-A{margin-bottom:8px;margin-bottom:.5rem;margin-right:0;margin-left:0}._1N9iR ._3rO-A ._7hYbG{padding:0 2px}._1N9iR button{width:100%}.rQiaU{outline:none}.rQiaU,.rQiaU:hover{background-color:#fe0000}.rQiaU:hover{text-decoration:underline}._2VC_X{background-color:#fe0000}._2VC_X,.uxilS{color:#fff;height:25px;border-radius:2px;border:0}.uxilS{background-color:#838383;margin-left:5px!important}", ""]);

// exports
exports.locals = {
	"welcome": "_2X8p1",
	"errorLogin": "Thqp2",
	"active": "_5tz0M",
	"user_icon": "_33oPt",
	"down_arrow": "_1gq5M",
	"listaAccionesUser": "_2KK4E",
	"loginDialogArrow": "nDeV0",
	"loginWrap": "_3bPTx",
	"loginWrapSmall": "_38A26",
	"loginDialog": "_1N9iR",
	"loginTooltipTipoDoc": "_37UD4",
	"row": "_3rO-A",
	"col": "_7hYbG",
	"boton_rojo": "rQiaU",
	"btn_ing": "_2VC_X",
	"btn_reg": "uxilS"
};

/***/ }),
/* 1015 */
/***/ (function(module, exports, __webpack_require__) {


    var content = __webpack_require__(1016);
    var insertCss = __webpack_require__(889);

    if (typeof content === 'string') {
      content = [[module.i, content, '']];
    }

    module.exports = content.locals || {};
    module.exports._getContent = function() { return content; };
    module.exports._getCss = function() { return content.toString(); };
    module.exports._insertCss = function(options) { return insertCss(content, options) };
    
    // Hot Module Replacement
    // https://webpack.github.io/docs/hot-module-replacement
    // Only activated in browser context
    if (false) {
      var removeCss = function() {};
      module.hot.accept("!!../../../../node_modules/css-loader/index.js??ref--2-rules-2!../../../../node_modules/postcss-loader/lib/index.js??ref--2-rules-3!./ModalErrorLogin.css", function() {
        content = require("!!../../../../node_modules/css-loader/index.js??ref--2-rules-2!../../../../node_modules/postcss-loader/lib/index.js??ref--2-rules-3!./ModalErrorLogin.css");

        if (typeof content === 'string') {
          content = [[module.id, content, '']];
        }

        removeCss = insertCss(content, { replace: true });
      });
      module.hot.dispose(function() { removeCss(); });
    }
  

/***/ }),
/* 1016 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(888)(false);
// imports


// module
exports.push([module.i, "._9ZgUw{border-bottom:1px solid hsla(204,2%,59%,.5);background-clip:padding-box}._16hfB{color:#fff;background-color:#e4002b;border-color:#e4002b;cursor:pointer;font-family:Roboto\\, Medium;width:190px}._1hOkW{color:#333;background-color:#fff;border-color:#ccc;cursor:pointer;width:200px}._300Mb{fill:#e4002b}", ""]);

// exports
exports.locals = {
	"header": "_9ZgUw",
	"boton_rojo": "_16hfB",
	"boton_blanco": "_1hOkW",
	"icono": "_300Mb"
};

/***/ }),
/* 1017 */
/***/ (function(module, exports, __webpack_require__) {


    var content = __webpack_require__(1018);
    var insertCss = __webpack_require__(889);

    if (typeof content === 'string') {
      content = [[module.i, content, '']];
    }

    module.exports = content.locals || {};
    module.exports._getContent = function() { return content; };
    module.exports._getCss = function() { return content.toString(); };
    module.exports._insertCss = function(options) { return insertCss(content, options) };
    
    // Hot Module Replacement
    // https://webpack.github.io/docs/hot-module-replacement
    // Only activated in browser context
    if (false) {
      var removeCss = function() {};
      module.hot.accept("!!../../../../node_modules/css-loader/index.js??ref--2-rules-2!../../../../node_modules/postcss-loader/lib/index.js??ref--2-rules-3!./ModalUsuarioBloqueado.css", function() {
        content = require("!!../../../../node_modules/css-loader/index.js??ref--2-rules-2!../../../../node_modules/postcss-loader/lib/index.js??ref--2-rules-3!./ModalUsuarioBloqueado.css");

        if (typeof content === 'string') {
          content = [[module.id, content, '']];
        }

        removeCss = insertCss(content, { replace: true });
      });
      module.hot.dispose(function() { removeCss(); });
    }
  

/***/ }),
/* 1018 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(888)(false);
// imports


// module
exports.push([module.i, "._3OaKh{color:#fff;background-color:#e4002b;border-color:#e4002b;cursor:pointer;font-family:Roboto\\, Medium;width:190px}._2zgab{fill:#e4002b}", ""]);

// exports
exports.locals = {
	"boton_rojo": "_3OaKh",
	"icono": "_2zgab"
};

/***/ }),
/* 1019 */
/***/ (function(module, exports, __webpack_require__) {


    var content = __webpack_require__(1020);
    var insertCss = __webpack_require__(889);

    if (typeof content === 'string') {
      content = [[module.i, content, '']];
    }

    module.exports = content.locals || {};
    module.exports._getContent = function() { return content; };
    module.exports._getCss = function() { return content.toString(); };
    module.exports._insertCss = function(options) { return insertCss(content, options) };
    
    // Hot Module Replacement
    // https://webpack.github.io/docs/hot-module-replacement
    // Only activated in browser context
    if (false) {
      var removeCss = function() {};
      module.hot.accept("!!../../../../node_modules/css-loader/index.js??ref--2-rules-2!../../../../node_modules/postcss-loader/lib/index.js??ref--2-rules-3!./ModalUsuarioNoRegistrado.css", function() {
        content = require("!!../../../../node_modules/css-loader/index.js??ref--2-rules-2!../../../../node_modules/postcss-loader/lib/index.js??ref--2-rules-3!./ModalUsuarioNoRegistrado.css");

        if (typeof content === 'string') {
          content = [[module.id, content, '']];
        }

        removeCss = insertCss(content, { replace: true });
      });
      module.hot.dispose(function() { removeCss(); });
    }
  

/***/ }),
/* 1020 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(888)(false);
// imports


// module
exports.push([module.i, "._1V_I0{border-bottom:1px solid hsla(204,2%,59%,.5);background-clip:padding-box}._3rCwW{color:#fff;background-color:#e4002b;border-color:#e4002b;cursor:pointer;font-family:Roboto\\, Medium;width:190px}.zwAKm{color:#333;background-color:#fff;border-color:#ccc;cursor:pointer;width:200px}._2z97_{fill:#e4002b}", ""]);

// exports
exports.locals = {
	"header": "_1V_I0",
	"boton_rojo": "_3rCwW",
	"boton_blanco": "zwAKm",
	"icono": "_2z97_"
};

/***/ }),
/* 1021 */
/***/ (function(module, exports, __webpack_require__) {


    var content = __webpack_require__(1022);
    var insertCss = __webpack_require__(889);

    if (typeof content === 'string') {
      content = [[module.i, content, '']];
    }

    module.exports = content.locals || {};
    module.exports._getContent = function() { return content; };
    module.exports._getCss = function() { return content.toString(); };
    module.exports._insertCss = function(options) { return insertCss(content, options) };
    
    // Hot Module Replacement
    // https://webpack.github.io/docs/hot-module-replacement
    // Only activated in browser context
    if (false) {
      var removeCss = function() {};
      module.hot.accept("!!../../../../node_modules/css-loader/index.js??ref--2-rules-2!../../../../node_modules/postcss-loader/lib/index.js??ref--2-rules-3!./ModalErrorConexionLogin.css", function() {
        content = require("!!../../../../node_modules/css-loader/index.js??ref--2-rules-2!../../../../node_modules/postcss-loader/lib/index.js??ref--2-rules-3!./ModalErrorConexionLogin.css");

        if (typeof content === 'string') {
          content = [[module.id, content, '']];
        }

        removeCss = insertCss(content, { replace: true });
      });
      module.hot.dispose(function() { removeCss(); });
    }
  

/***/ }),
/* 1022 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(888)(false);
// imports


// module
exports.push([module.i, ".gpMFX{color:#fff;background-color:#e4002b;border-color:#e4002b;cursor:pointer;font-family:Roboto\\, Medium;width:190px}._2rm5R{fill:#e4002b}", ""]);

// exports
exports.locals = {
	"boton_rojo": "gpMFX",
	"icono": "_2rm5R"
};

/***/ }),
/* 1023 */
/***/ (function(module, exports, __webpack_require__) {


    var content = __webpack_require__(1024);
    var insertCss = __webpack_require__(889);

    if (typeof content === 'string') {
      content = [[module.i, content, '']];
    }

    module.exports = content.locals || {};
    module.exports._getContent = function() { return content; };
    module.exports._getCss = function() { return content.toString(); };
    module.exports._insertCss = function(options) { return insertCss(content, options) };
    
    // Hot Module Replacement
    // https://webpack.github.io/docs/hot-module-replacement
    // Only activated in browser context
    if (false) {
      var removeCss = function() {};
      module.hot.accept("!!../../../../node_modules/css-loader/index.js??ref--2-rules-2!../../../../node_modules/postcss-loader/lib/index.js??ref--2-rules-3!./ModalAltaPendiente.css", function() {
        content = require("!!../../../../node_modules/css-loader/index.js??ref--2-rules-2!../../../../node_modules/postcss-loader/lib/index.js??ref--2-rules-3!./ModalAltaPendiente.css");

        if (typeof content === 'string') {
          content = [[module.id, content, '']];
        }

        removeCss = insertCss(content, { replace: true });
      });
      module.hot.dispose(function() { removeCss(); });
    }
  

/***/ }),
/* 1024 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(888)(false);
// imports


// module
exports.push([module.i, "._3IPRQ{color:#fff;background-color:#e4002b;border-color:#e4002b;cursor:pointer;font-family:Roboto\\, Medium;width:190px}._3LosR{fill:#f81}", ""]);

// exports
exports.locals = {
	"boton_rojo": "_3IPRQ",
	"icono": "_3LosR"
};

/***/ }),
/* 1025 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(888)(false);
// imports


// module
exports.push([module.i, ".A1-FM{text-align:center}._1RSe0{margin:0 auto}._3kZqv{font-family:Roboto,sans-serif;padding:25px 0}", ""]);

// exports
exports.locals = {
	"modalContent": "A1-FM",
	"modalFooter": "_1RSe0",
	"modalBody": "_3kZqv"
};

/***/ }),
/* 1026 */
/***/ (function(module, exports, __webpack_require__) {


    var content = __webpack_require__(1027);
    var insertCss = __webpack_require__(889);

    if (typeof content === 'string') {
      content = [[module.i, content, '']];
    }

    module.exports = content.locals || {};
    module.exports._getContent = function() { return content; };
    module.exports._getCss = function() { return content.toString(); };
    module.exports._insertCss = function(options) { return insertCss(content, options) };
    
    // Hot Module Replacement
    // https://webpack.github.io/docs/hot-module-replacement
    // Only activated in browser context
    if (false) {
      var removeCss = function() {};
      module.hot.accept("!!../../../node_modules/css-loader/index.js??ref--2-rules-2!../../../node_modules/postcss-loader/lib/index.js??ref--2-rules-3!./MenuTop.css", function() {
        content = require("!!../../../node_modules/css-loader/index.js??ref--2-rules-2!../../../node_modules/postcss-loader/lib/index.js??ref--2-rules-3!./MenuTop.css");

        if (typeof content === 'string') {
          content = [[module.id, content, '']];
        }

        removeCss = insertCss(content, { replace: true });
      });
      module.hot.dispose(function() { removeCss(); });
    }
  

/***/ }),
/* 1027 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(888)(false);
// imports


// module
exports.push([module.i, "._3DpUG{color:#fff!important;font-style:normal;font-weight:700;font-size:16px;cursor:pointer;display:block;padding:14px 15px}._3qJwM{border:1px solid #333;border-radius:4px;padding:10px;background-color:transparent;cursor:pointer;font-size:17px;margin:8px 0}._3SrxN{background-color:#fff;display:block;width:22px;height:2px;border-radius:1px}._3SrxN+._3SrxN{margin-top:4px}._3qJwM:hover{background-color:#333}._3qJwM:active,._3qJwM:focus{outline:0}._19-dt{overflow-y:auto;z-index:50;min-height:80px;overflow:hidden;font-size:11px;-moz-opacity:100;opacity:1;filter:alpha(opacity=100);padding:0;border:1px solid #787878;border-radius:0;-webkit-box-shadow:none;box-shadow:none;top:121px;display:block}._3VQ9m{float:left;margin-top:1px}._3VQ9m ._19-dt{position:fixed!important;width:100%;background-color:#535353}._1MLza{line-height:25px;z-index:10}._1MLza ul{padding-top:10px}._1MLza ul li>h3{font-size:14px;font-weight:700;margin-bottom:10px}._1MLza ul li>a,._1MLza ul li>h3{font-family:Open Sans;font-style:normal;color:#fff}._1MLza ul li>a{font-size:12px;font-weight:400;text-decoration:none}._1MLza ul li>a:hover{text-decoration:underline}._1MLza ul._1MjUW{background:#666;padding-bottom:25px}h3{color:#fff!important;padding-left:0}", ""]);

// exports
exports.locals = {
	"smgbarPersonas": "_3DpUG",
	"navbarToggle": "_3qJwM",
	"iconBar": "_3SrxN",
	"menuDesple": "_19-dt",
	"menuLeft": "_3VQ9m",
	"menuCompleto_prepaga": "_1MLza",
	"loguedMenu": "_1MjUW"
};

/***/ }),
/* 1028 */
/***/ (function(module, exports, __webpack_require__) {


    var content = __webpack_require__(1029);
    var insertCss = __webpack_require__(889);

    if (typeof content === 'string') {
      content = [[module.i, content, '']];
    }

    module.exports = content.locals || {};
    module.exports._getContent = function() { return content; };
    module.exports._getCss = function() { return content.toString(); };
    module.exports._insertCss = function(options) { return insertCss(content, options) };
    
    // Hot Module Replacement
    // https://webpack.github.io/docs/hot-module-replacement
    // Only activated in browser context
    if (false) {
      var removeCss = function() {};
      module.hot.accept("!!../../../node_modules/css-loader/index.js??ref--2-rules-2!../../../node_modules/postcss-loader/lib/index.js??ref--2-rules-3!./Contact.css", function() {
        content = require("!!../../../node_modules/css-loader/index.js??ref--2-rules-2!../../../node_modules/postcss-loader/lib/index.js??ref--2-rules-3!./Contact.css");

        if (typeof content === 'string') {
          content = [[module.id, content, '']];
        }

        removeCss = insertCss(content, { replace: true });
      });
      module.hot.dispose(function() { removeCss(); });
    }
  

/***/ }),
/* 1029 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(888)(false);
// imports


// module
exports.push([module.i, "._1CaLC{display:block;line-height:1;position:fixed;min-height:393px;top:220px;right:-500px;padding:30px 20px 15px;width:500px;background:#f2f2f2;z-index:20;border:1px solid #e4e4e4;-webkit-transition:all .5s;-o-transition:all .5s;transition:all .5s}._1Wv-i{right:-3px}._2aAN6{right:-500px}._2BA46{background:url(" + __webpack_require__(1030) + ") no-repeat;width:45px;height:146px;display:block;text-indent:500px;outline:none;position:absolute;top:0;left:-45px;padding-top:10px}", ""]);

// exports
exports.locals = {
	"formulario_opinion": "_1CaLC",
	"show": "_1Wv-i",
	"hidden": "_2aAN6",
	"handle": "_2BA46"
};

/***/ }),
/* 1030 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,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"

/***/ }),
/* 1031 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "5b6ca674.png";

/***/ }),
/* 1032 */
/***/ (function(module, exports, __webpack_require__) {


    var content = __webpack_require__(1033);
    var insertCss = __webpack_require__(889);

    if (typeof content === 'string') {
      content = [[module.i, content, '']];
    }

    module.exports = content.locals || {};
    module.exports._getContent = function() { return content; };
    module.exports._getCss = function() { return content.toString(); };
    module.exports._insertCss = function(options) { return insertCss(content, options) };
    
    // Hot Module Replacement
    // https://webpack.github.io/docs/hot-module-replacement
    // Only activated in browser context
    if (false) {
      var removeCss = function() {};
      module.hot.accept("!!../../../node_modules/css-loader/index.js??ref--2-rules-2!../../../node_modules/postcss-loader/lib/index.js??ref--2-rules-3!./LeftNavigation.css", function() {
        content = require("!!../../../node_modules/css-loader/index.js??ref--2-rules-2!../../../node_modules/postcss-loader/lib/index.js??ref--2-rules-3!./LeftNavigation.css");

        if (typeof content === 'string') {
          content = [[module.id, content, '']];
        }

        removeCss = insertCss(content, { replace: true });
      });
      module.hot.dispose(function() { removeCss(); });
    }
  

/***/ }),
/* 1033 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(888)(false);
// imports


// module
exports.push([module.i, "._1mTEY{position:fixed;margin:0;padding:0;top:150px;left:0;list-style:none;z-index:5}", ""]);

// exports
exports.locals = {
	"navigationIz": "_1mTEY"
};

/***/ }),
/* 1034 */
/***/ (function(module, exports, __webpack_require__) {


    var content = __webpack_require__(1035);
    var insertCss = __webpack_require__(889);

    if (typeof content === 'string') {
      content = [[module.i, content, '']];
    }

    module.exports = content.locals || {};
    module.exports._getContent = function() { return content; };
    module.exports._getCss = function() { return content.toString(); };
    module.exports._insertCss = function(options) { return insertCss(content, options) };
    
    // Hot Module Replacement
    // https://webpack.github.io/docs/hot-module-replacement
    // Only activated in browser context
    if (false) {
      var removeCss = function() {};
      module.hot.accept("!!../../../node_modules/css-loader/index.js??ref--2-rules-2!../../../node_modules/postcss-loader/lib/index.js??ref--2-rules-3!./LeftNavigationButton.css", function() {
        content = require("!!../../../node_modules/css-loader/index.js??ref--2-rules-2!../../../node_modules/postcss-loader/lib/index.js??ref--2-rules-3!./LeftNavigationButton.css");

        if (typeof content === 'string') {
          content = [[module.id, content, '']];
        }

        removeCss = insertCss(content, { replace: true });
      });
      module.hot.dispose(function() { removeCss(); });
    }
  

/***/ }),
/* 1035 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(888)(false);
// imports


// module
exports.push([module.i, "li._32AIy{width:100px;margin-bottom:1px}li._32AIy a{display:block;margin-left:-45px;-webkit-transition:margin-left .2s;-o-transition:margin-left .2s;transition:margin-left .2s;width:100px;height:51px;background-color:#f40000;background-repeat:no-repeat;background-position:45px;cursor:pointer}li._32AIy a:hover{margin-left:-30px}", ""]);

// exports
exports.locals = {
	"datosIco": "_32AIy"
};

/***/ }),
/* 1036 */
/***/ (function(module, exports, __webpack_require__) {

var map = {
	"./autorizaciones.png": 1037,
	"./cartillas.png": 1038,
	"./credencialprovi.png": 1039,
	"./e_consulta.png": 1040,
	"./facturas.png": 1041,
	"./historial.png": 1042,
	"./laboratorio.png": 1043,
	"./mis_datos.png": 1044,
	"./plan.png": 1045,
	"./turnos.png": 1046
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 1036;

/***/ }),
/* 1037 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "326848fd.png";

/***/ }),
/* 1038 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "3a13c4b2.png";

/***/ }),
/* 1039 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "68de0a12.png";

/***/ }),
/* 1040 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "78467987.png";

/***/ }),
/* 1041 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "2628b4bc.png";

/***/ }),
/* 1042 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "4684918d.png";

/***/ }),
/* 1043 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "2667ba93.png";

/***/ }),
/* 1044 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "639b511e.png";

/***/ }),
/* 1045 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "9955e9a5.png";

/***/ }),
/* 1046 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "894deb10.png";

/***/ }),
/* 1047 */
/***/ (function(module, exports, __webpack_require__) {


    var content = __webpack_require__(1048);
    var insertCss = __webpack_require__(889);

    if (typeof content === 'string') {
      content = [[module.i, content, '']];
    }

    module.exports = content.locals || {};
    module.exports._getContent = function() { return content; };
    module.exports._getCss = function() { return content.toString(); };
    module.exports._insertCss = function(options) { return insertCss(content, options) };
    
    // Hot Module Replacement
    // https://webpack.github.io/docs/hot-module-replacement
    // Only activated in browser context
    if (false) {
      var removeCss = function() {};
      module.hot.accept("!!../../../node_modules/css-loader/index.js??ref--2-rules-2!../../../node_modules/postcss-loader/lib/index.js??ref--2-rules-3!./Footer.css", function() {
        content = require("!!../../../node_modules/css-loader/index.js??ref--2-rules-2!../../../node_modules/postcss-loader/lib/index.js??ref--2-rules-3!./Footer.css");

        if (typeof content === 'string') {
          content = [[module.id, content, '']];
        }

        removeCss = insertCss(content, { replace: true });
      });
      module.hot.dispose(function() { removeCss(); });
    }
  

/***/ }),
/* 1048 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(888)(false);
// imports


// module
exports.push([module.i, "._1UUMy{width:100%;background-color:#858585;color:#999;padding-top:10px;font-size:11px;font-weight:300;font-family:Open Sans,Helvetica,Arial,sans-serif}", ""]);

// exports
exports.locals = {
	"root": "_1UUMy"
};

/***/ }),
/* 1049 */
/***/ (function(module, exports, __webpack_require__) {


    var content = __webpack_require__(1050);
    var insertCss = __webpack_require__(889);

    if (typeof content === 'string') {
      content = [[module.i, content, '']];
    }

    module.exports = content.locals || {};
    module.exports._getContent = function() { return content; };
    module.exports._getCss = function() { return content.toString(); };
    module.exports._insertCss = function(options) { return insertCss(content, options) };
    
    // Hot Module Replacement
    // https://webpack.github.io/docs/hot-module-replacement
    // Only activated in browser context
    if (false) {
      var removeCss = function() {};
      module.hot.accept("!!../../../node_modules/css-loader/index.js??ref--2-rules-2!../../../node_modules/postcss-loader/lib/index.js??ref--2-rules-3!./LegalGroup.css", function() {
        content = require("!!../../../node_modules/css-loader/index.js??ref--2-rules-2!../../../node_modules/postcss-loader/lib/index.js??ref--2-rules-3!./LegalGroup.css");

        if (typeof content === 'string') {
          content = [[module.id, content, '']];
        }

        removeCss = insertCss(content, { replace: true });
      });
      module.hot.dispose(function() { removeCss(); });
    }
  

/***/ }),
/* 1050 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(888)(false);
// imports


// module
exports.push([module.i, "._3UYT_{background-color:#383838;height:98px;width:100%;color:#999;left:0}._2oTVh{padding-right:15px;padding-left:15px;margin-right:auto;margin-left:auto;max-width:970px}._3G-Lp{padding-top:20px}._3G-Lp li{line-height:15px;font-weight:300}._3Rs7t{padding:0 5px}._3Rs7t,._3Rs7t:active,._3Rs7t:hover,._3Rs7t:visited{color:#999}._3avzK{padding-top:8%}._3avzK img{width:102px;height:50px}._3avzK img:first-child{padding-right:18px}", ""]);

// exports
exports.locals = {
	"root": "_3UYT_",
	"container": "_2oTVh",
	"text": "_3G-Lp",
	"link": "_3Rs7t",
	"logos": "_3avzK"
};

/***/ }),
/* 1051 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "18ae7b84.png";

/***/ }),
/* 1052 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "606c4a05.png";

/***/ }),
/* 1053 */
/***/ (function(module, exports, __webpack_require__) {


    var content = __webpack_require__(1054);
    var insertCss = __webpack_require__(889);

    if (typeof content === 'string') {
      content = [[module.i, content, '']];
    }

    module.exports = content.locals || {};
    module.exports._getContent = function() { return content; };
    module.exports._getCss = function() { return content.toString(); };
    module.exports._insertCss = function(options) { return insertCss(content, options) };
    
    // Hot Module Replacement
    // https://webpack.github.io/docs/hot-module-replacement
    // Only activated in browser context
    if (false) {
      var removeCss = function() {};
      module.hot.accept("!!../../../node_modules/css-loader/index.js??ref--2-rules-2!../../../node_modules/postcss-loader/lib/index.js??ref--2-rules-3!./Carousel.css", function() {
        content = require("!!../../../node_modules/css-loader/index.js??ref--2-rules-2!../../../node_modules/postcss-loader/lib/index.js??ref--2-rules-3!./Carousel.css");

        if (typeof content === 'string') {
          content = [[module.id, content, '']];
        }

        removeCss = insertCss(content, { replace: true });
      });
      module.hot.dispose(function() { removeCss(); });
    }
  

/***/ }),
/* 1054 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(888)(false);
// imports


// module
exports.push([module.i, "._2HMcI{width:100%;height:90px;overflow:hidden;margin:0 auto;padding:10px 0}._2HMcI>div{width:100%!important;position:absolute;height:100px!important;overflow:hidden;z-index:-10}", ""]);

// exports
exports.locals = {
	"root": "_2HMcI"
};

/***/ }),
/* 1055 */
/***/ (function(module, exports, __webpack_require__) {


    var content = __webpack_require__(1056);
    var insertCss = __webpack_require__(889);

    if (typeof content === 'string') {
      content = [[module.i, content, '']];
    }

    module.exports = content.locals || {};
    module.exports._getContent = function() { return content; };
    module.exports._getCss = function() { return content.toString(); };
    module.exports._insertCss = function(options) { return insertCss(content, options) };
    
    // Hot Module Replacement
    // https://webpack.github.io/docs/hot-module-replacement
    // Only activated in browser context
    if (false) {
      var removeCss = function() {};
      module.hot.accept("!!../../../node_modules/css-loader/index.js??ref--2-rules-2!../../../node_modules/postcss-loader/lib/index.js??ref--2-rules-3!./CarouselItem.css", function() {
        content = require("!!../../../node_modules/css-loader/index.js??ref--2-rules-2!../../../node_modules/postcss-loader/lib/index.js??ref--2-rules-3!./CarouselItem.css");

        if (typeof content === 'string') {
          content = [[module.id, content, '']];
        }

        removeCss = insertCss(content, { replace: true });
      });
      module.hot.dispose(function() { removeCss(); });
    }
  

/***/ }),
/* 1056 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(888)(false);
// imports


// module
exports.push([module.i, "._3Bpik{float:left;text-align:center;padding:5px 10px;border-right:.1px solid #4b4b4b}._3Bpik a{width:120px;height:60px;display:block}", ""]);

// exports
exports.locals = {
	"item": "_3Bpik"
};

/***/ }),
/* 1057 */
/***/ (function(module, exports, __webpack_require__) {

var map = {
	"./logo_agote.png": 1058,
	"./logo_agote_color.png": 1059,
	"./logo_altos.png": 1060,
	"./logo_altos_color.png": 1061,
	"./logo_arcos.png": 1062,
	"./logo_arcos_color.png": 1063,
	"./logo_art.png": 1064,
	"./logo_art_color.png": 1065,
	"./logo_blue.png": 1066,
	"./logo_blue_color.png": 1067,
	"./logo_cells.png": 1068,
	"./logo_cells_color.png": 1069,
	"./logo_cymsa.png": 1070,
	"./logo_cymsa_color.png": 1071,
	"./logo_ecco.png": 1072,
	"./logo_ecco_color.png": 1073,
	"./logo_fundacion.png": 1074,
	"./logo_fundacion_color.png": 1075,
	"./logo_life.png": 1076,
	"./logo_life_color.png": 1077,
	"./logo_maternidad.png": 1078,
	"./logo_maternidad_color.png": 1079,
	"./logo_olivos.png": 1080,
	"./logo_olivos_color.png": 1081,
	"./logo_qualitas.png": 1082,
	"./logo_qualitas_color.png": 1083,
	"./logo_salta.png": 1084,
	"./logo_salta_color.png": 1085,
	"./logo_sanlucas.png": 1086,
	"./logo_sanlucas_color.png": 1087,
	"./logo_seguros.png": 1088,
	"./logo_seguros_color.png": 1089,
	"./logo_smc.png": 1090,
	"./logo_smc_color.png": 1091,
	"./logo_smmp.png": 1092,
	"./logo_smmp_color.png": 1093,
	"./logo_travel.png": 1094,
	"./logo_travel_color.png": 1095,
	"./logo_zabala.png": 1096,
	"./logo_zabala_color.png": 1097
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 1057;

/***/ }),
/* 1058 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "a191d300.png";

/***/ }),
/* 1059 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "7cd27f1a.png";

/***/ }),
/* 1060 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "fdc252da.png";

/***/ }),
/* 1061 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "b662f614.png";

/***/ }),
/* 1062 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "d6a8a0af.png";

/***/ }),
/* 1063 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "6b3da026.png";

/***/ }),
/* 1064 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "a1b8b456.png";

/***/ }),
/* 1065 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "89f70dc3.png";

/***/ }),
/* 1066 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "c3179548.png";

/***/ }),
/* 1067 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "347ed45d.png";

/***/ }),
/* 1068 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "ba4f67da.png";

/***/ }),
/* 1069 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "8708b470.png";

/***/ }),
/* 1070 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "c7d6b9ea.png";

/***/ }),
/* 1071 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "f6022541.png";

/***/ }),
/* 1072 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "8c2b28bd.png";

/***/ }),
/* 1073 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "63b4f73f.png";

/***/ }),
/* 1074 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "6afced08.png";

/***/ }),
/* 1075 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "b1161380.png";

/***/ }),
/* 1076 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "6d2fbd5b.png";

/***/ }),
/* 1077 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "c64531a1.png";

/***/ }),
/* 1078 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "14b025bf.png";

/***/ }),
/* 1079 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "6e9da47a.png";

/***/ }),
/* 1080 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "138ce1fd.png";

/***/ }),
/* 1081 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "fc529390.png";

/***/ }),
/* 1082 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "62cc60dc.png";

/***/ }),
/* 1083 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "f970ca77.png";

/***/ }),
/* 1084 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "0b9a60e3.png";

/***/ }),
/* 1085 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "ceab5436.png";

/***/ }),
/* 1086 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "3a68155a.png";

/***/ }),
/* 1087 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "dbea18ab.png";

/***/ }),
/* 1088 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "a1d782e9.png";

/***/ }),
/* 1089 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "8edc9183.png";

/***/ }),
/* 1090 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "ab402350.png";

/***/ }),
/* 1091 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "b09cc46c.png";

/***/ }),
/* 1092 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "5367a177.png";

/***/ }),
/* 1093 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "d9452693.png";

/***/ }),
/* 1094 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "b2a66cbe.png";

/***/ }),
/* 1095 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "bdb13c50.png";

/***/ }),
/* 1096 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "28a5a220.png";

/***/ }),
/* 1097 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "d720494a.png";

/***/ }),
/* 1098 */
/***/ (function(module, exports, __webpack_require__) {


    var content = __webpack_require__(1099);
    var insertCss = __webpack_require__(889);

    if (typeof content === 'string') {
      content = [[module.i, content, '']];
    }

    module.exports = content.locals || {};
    module.exports._getContent = function() { return content; };
    module.exports._getCss = function() { return content.toString(); };
    module.exports._insertCss = function(options) { return insertCss(content, options) };
    
    // Hot Module Replacement
    // https://webpack.github.io/docs/hot-module-replacement
    // Only activated in browser context
    if (false) {
      var removeCss = function() {};
      module.hot.accept("!!../../../node_modules/css-loader/index.js??ref--2-rules-2!../../../node_modules/postcss-loader/lib/index.js??ref--2-rules-3!./Accordion.css", function() {
        content = require("!!../../../node_modules/css-loader/index.js??ref--2-rules-2!../../../node_modules/postcss-loader/lib/index.js??ref--2-rules-3!./Accordion.css");

        if (typeof content === 'string') {
          content = [[module.id, content, '']];
        }

        removeCss = insertCss(content, { replace: true });
      });
      module.hot.dispose(function() { removeCss(); });
    }
  

/***/ }),
/* 1099 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(888)(false);
// imports


// module
exports.push([module.i, "._2VR7s{height:auto;width:100%;color:#fff;text-align:center}._2Lc5M{opacity:0;width:50px;height:50px;position:absolute;left:48%}._2Lc5M:hover{cursor:pointer}._2tgoQ{display:block;padding:.5em;text-align:center;border-bottom:1px solid #9e9e9e}._2tgoQ:before{content:url(" + __webpack_require__(1100) + ");display:inline-block;width:40px;height:40px}.DJte0{height:0;overflow:hidden}._2Lc5M:checked~.DJte0,.DJte0{-webkit-transition-duration:.5s;-o-transition-duration:.5s;transition-duration:.5s}._2Lc5M:checked~.DJte0{height:320px}._2Lc5M:checked~._2tgoQ:before{content:url(" + __webpack_require__(1101) + ")}._1vVgX{max-width:970px}", ""]);

// exports
exports.locals = {
	"root": "_2VR7s",
	"toggle": "_2Lc5M",
	"label": "_2tgoQ",
	"collapsed": "DJte0",
	"container": "_1vVgX"
};

/***/ }),
/* 1100 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,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"

/***/ }),
/* 1101 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,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"

/***/ }),
/* 1102 */
/***/ (function(module, exports, __webpack_require__) {


    var content = __webpack_require__(1103);
    var insertCss = __webpack_require__(889);

    if (typeof content === 'string') {
      content = [[module.i, content, '']];
    }

    module.exports = content.locals || {};
    module.exports._getContent = function() { return content; };
    module.exports._getCss = function() { return content.toString(); };
    module.exports._insertCss = function(options) { return insertCss(content, options) };
    
    // Hot Module Replacement
    // https://webpack.github.io/docs/hot-module-replacement
    // Only activated in browser context
    if (false) {
      var removeCss = function() {};
      module.hot.accept("!!../../../node_modules/css-loader/index.js??ref--2-rules-2!../../../node_modules/postcss-loader/lib/index.js??ref--2-rules-3!./FooterNavigation.css", function() {
        content = require("!!../../../node_modules/css-loader/index.js??ref--2-rules-2!../../../node_modules/postcss-loader/lib/index.js??ref--2-rules-3!./FooterNavigation.css");

        if (typeof content === 'string') {
          content = [[module.id, content, '']];
        }

        removeCss = insertCss(content, { replace: true });
      });
      module.hot.dispose(function() { removeCss(); });
    }
  

/***/ }),
/* 1103 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(888)(false);
// imports


// module
exports.push([module.i, ".S6Xus{margin-bottom:10px}.BDiu9{padding-top:20px}.BDiu9 ._1FK77:first-child h3{margin:0}.BDiu9 ._1FK77:nth-child(4)>h3{display:none;visibility:hidden}.BDiu9 ._1FK77 h3{text-transform:Uppercase;font-weight:700;font-size:12px;margin:20px 0 0}._1FK77:nth-child(2),._1FK77:nth-child(3),._1FK77:nth-child(4){text-align:left;border-left:1px solid #ccc;padding-left:30px;height:280px}._1FK77:nth-child(2) li a._1NJ0q,._1FK77:nth-child(3) li a._1NJ0q,._1FK77:nth-child(4) li a._1NJ0q{text-align:left}.BDiu9 ul li:nth-child(odd){padding-top:10px;padding-bottom:10px}a._1NJ0q:active,a._1NJ0q:link,a._1NJ0q:visited{color:#fff;text-decoration:none;font-size:11px}a._1NJ0q:hover,a._1NJ0q:visited:hover{color:#000;text-decoration:none}h3{color:#fff}", ""]);

// exports
exports.locals = {
	"logo": "S6Xus",
	"root": "BDiu9",
	"col": "_1FK77",
	"link": "_1NJ0q"
};

/***/ }),
/* 1104 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "2bdf8e9d.png";

/***/ }),
/* 1105 */
/***/ (function(module, exports, __webpack_require__) {


    var content = __webpack_require__(1106);
    var insertCss = __webpack_require__(889);

    if (typeof content === 'string') {
      content = [[module.i, content, '']];
    }

    module.exports = content.locals || {};
    module.exports._getContent = function() { return content; };
    module.exports._getCss = function() { return content.toString(); };
    module.exports._insertCss = function(options) { return insertCss(content, options) };
    
    // Hot Module Replacement
    // https://webpack.github.io/docs/hot-module-replacement
    // Only activated in browser context
    if (false) {
      var removeCss = function() {};
      module.hot.accept("!!../../../node_modules/css-loader/index.js??ref--2-rules-2!../../../node_modules/postcss-loader/lib/index.js??ref--2-rules-3!./FooterContactButton.css", function() {
        content = require("!!../../../node_modules/css-loader/index.js??ref--2-rules-2!../../../node_modules/postcss-loader/lib/index.js??ref--2-rules-3!./FooterContactButton.css");

        if (typeof content === 'string') {
          content = [[module.id, content, '']];
        }

        removeCss = insertCss(content, { replace: true });
      });
      module.hot.dispose(function() { removeCss(); });
    }
  

/***/ }),
/* 1106 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(888)(false);
// imports


// module
exports.push([module.i, "._1mXRj{background:url(" + __webpack_require__(1107) + ");background-position:-75px 0;display:inline-block;width:33px;height:35px;outline:none}._1mXRj:hover{background:url(" + __webpack_require__(1108) + ");background-position:-75px 0;cursor:pointer}", ""]);

// exports
exports.locals = {
	"root": "_1mXRj"
};

/***/ }),
/* 1107 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,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"

/***/ }),
/* 1108 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,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"

/***/ }),
/* 1109 */
/***/ (function(module, exports, __webpack_require__) {


    var content = __webpack_require__(1110);
    var insertCss = __webpack_require__(889);

    if (typeof content === 'string') {
      content = [[module.i, content, '']];
    }

    module.exports = content.locals || {};
    module.exports._getContent = function() { return content; };
    module.exports._getCss = function() { return content.toString(); };
    module.exports._insertCss = function(options) { return insertCss(content, options) };
    
    // Hot Module Replacement
    // https://webpack.github.io/docs/hot-module-replacement
    // Only activated in browser context
    if (false) {
      var removeCss = function() {};
      module.hot.accept("!!../../../node_modules/css-loader/index.js??ref--2-rules-2!../../../node_modules/postcss-loader/lib/index.js??ref--2-rules-3!./Loading.css", function() {
        content = require("!!../../../node_modules/css-loader/index.js??ref--2-rules-2!../../../node_modules/postcss-loader/lib/index.js??ref--2-rules-3!./Loading.css");

        if (typeof content === 'string') {
          content = [[module.id, content, '']];
        }

        removeCss = insertCss(content, { replace: true });
      });
      module.hot.dispose(function() { removeCss(); });
    }
  

/***/ }),
/* 1110 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(888)(false);
// imports


// module
exports.push([module.i, "._2f2wz{text-align:center;position:fixed;top:0;right:0;bottom:0;left:0;z-index:1040;background-color:rgba(0,0,0,.42);overflow:none}.kUvEQ{height:100px;width:100px;margin:0 auto;position:absolute;top:50%;left:50%;margin-top:-50px;margin-left:-50px}", ""]);

// exports
exports.locals = {
	"root": "_2f2wz",
	"container": "kUvEQ"
};

/***/ }),
/* 1111 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "9f851e18.gif";

/***/ }),
/* 1112 */
/***/ (function(module, exports, __webpack_require__) {


    var content = __webpack_require__(1113);
    var insertCss = __webpack_require__(889);

    if (typeof content === 'string') {
      content = [[module.i, content, '']];
    }

    module.exports = content.locals || {};
    module.exports._getContent = function() { return content; };
    module.exports._getCss = function() { return content.toString(); };
    module.exports._insertCss = function(options) { return insertCss(content, options) };
    
    // Hot Module Replacement
    // https://webpack.github.io/docs/hot-module-replacement
    // Only activated in browser context
    if (false) {
      var removeCss = function() {};
      module.hot.accept("!!../../../node_modules/css-loader/index.js??ref--2-rules-2!../../../node_modules/postcss-loader/lib/index.js??ref--2-rules-3!./Loading.css", function() {
        content = require("!!../../../node_modules/css-loader/index.js??ref--2-rules-2!../../../node_modules/postcss-loader/lib/index.js??ref--2-rules-3!./Loading.css");

        if (typeof content === 'string') {
          content = [[module.id, content, '']];
        }

        removeCss = insertCss(content, { replace: true });
      });
      module.hot.dispose(function() { removeCss(); });
    }
  

/***/ }),
/* 1113 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(888)(false);
// imports


// module
exports.push([module.i, ".eqnIz{border:3px solid #f6f6f6;border-radius:50%;border-top:3px solid #666;width:50px;height:50px;margin:auto;-webkit-animation:jyWyk 2s linear infinite;animation:jyWyk 2s linear infinite}@-webkit-keyframes jyWyk{0%{-webkit-transform:rotate(0deg)}to{-webkit-transform:rotate(1turn)}}@keyframes jyWyk{0%{-webkit-transform:rotate(0deg);transform:rotate(0deg)}to{-webkit-transform:rotate(1turn);transform:rotate(1turn)}}", ""]);

// exports
exports.locals = {
	"loader": "eqnIz",
	"spin": "jyWyk"
};

/***/ }),
/* 1114 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "53b0c520.png";

/***/ }),
/* 1115 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2014-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */



var _assign = __webpack_require__(131);

var ReactCurrentOwner = __webpack_require__(1132);

var warning = __webpack_require__(1118);
var canDefineProperty = __webpack_require__(1130);
var hasOwnProperty = Object.prototype.hasOwnProperty;

var REACT_ELEMENT_TYPE = __webpack_require__(1133);

var RESERVED_PROPS = {
  key: true,
  ref: true,
  __self: true,
  __source: true
};

var specialPropKeyWarningShown, specialPropRefWarningShown;

function hasValidRef(config) {
  if (false) {
    if (hasOwnProperty.call(config, 'ref')) {
      var getter = Object.getOwnPropertyDescriptor(config, 'ref').get;
      if (getter && getter.isReactWarning) {
        return false;
      }
    }
  }
  return config.ref !== undefined;
}

function hasValidKey(config) {
  if (false) {
    if (hasOwnProperty.call(config, 'key')) {
      var getter = Object.getOwnPropertyDescriptor(config, 'key').get;
      if (getter && getter.isReactWarning) {
        return false;
      }
    }
  }
  return config.key !== undefined;
}

function defineKeyPropWarningGetter(props, displayName) {
  var warnAboutAccessingKey = function () {
    if (!specialPropKeyWarningShown) {
      specialPropKeyWarningShown = true;
       false ? warning(false, '%s: `key` is not a prop. Trying to access it will result ' + 'in `undefined` being returned. If you need to access the same ' + 'value within the child component, you should pass it as a different ' + 'prop. (https://fb.me/react-special-props)', displayName) : void 0;
    }
  };
  warnAboutAccessingKey.isReactWarning = true;
  Object.defineProperty(props, 'key', {
    get: warnAboutAccessingKey,
    configurable: true
  });
}

function defineRefPropWarningGetter(props, displayName) {
  var warnAboutAccessingRef = function () {
    if (!specialPropRefWarningShown) {
      specialPropRefWarningShown = true;
       false ? warning(false, '%s: `ref` is not a prop. Trying to access it will result ' + 'in `undefined` being returned. If you need to access the same ' + 'value within the child component, you should pass it as a different ' + 'prop. (https://fb.me/react-special-props)', displayName) : void 0;
    }
  };
  warnAboutAccessingRef.isReactWarning = true;
  Object.defineProperty(props, 'ref', {
    get: warnAboutAccessingRef,
    configurable: true
  });
}

/**
 * Factory method to create a new React element. This no longer adheres to
 * the class pattern, so do not use new to call it. Also, no instanceof check
 * will work. Instead test $$typeof field against Symbol.for('react.element') to check
 * if something is a React Element.
 *
 * @param {*} type
 * @param {*} key
 * @param {string|object} ref
 * @param {*} self A *temporary* helper to detect places where `this` is
 * different from the `owner` when React.createElement is called, so that we
 * can warn. We want to get rid of owner and replace string `ref`s with arrow
 * functions, and as long as `this` and owner are the same, there will be no
 * change in behavior.
 * @param {*} source An annotation object (added by a transpiler or otherwise)
 * indicating filename, line number, and/or other information.
 * @param {*} owner
 * @param {*} props
 * @internal
 */
var ReactElement = function (type, key, ref, self, source, owner, props) {
  var element = {
    // This tag allow us to uniquely identify this as a React Element
    $$typeof: REACT_ELEMENT_TYPE,

    // Built-in properties that belong on the element
    type: type,
    key: key,
    ref: ref,
    props: props,

    // Record the component responsible for creating this element.
    _owner: owner
  };

  if (false) {
    // The validation flag is currently mutative. We put it on
    // an external backing store so that we can freeze the whole object.
    // This can be replaced with a WeakMap once they are implemented in
    // commonly used development environments.
    element._store = {};

    // To make comparing ReactElements easier for testing purposes, we make
    // the validation flag non-enumerable (where possible, which should
    // include every environment we run tests in), so the test framework
    // ignores it.
    if (canDefineProperty) {
      Object.defineProperty(element._store, 'validated', {
        configurable: false,
        enumerable: false,
        writable: true,
        value: false
      });
      // self and source are DEV only properties.
      Object.defineProperty(element, '_self', {
        configurable: false,
        enumerable: false,
        writable: false,
        value: self
      });
      // Two elements created in two different places should be considered
      // equal for testing purposes and therefore we hide it from enumeration.
      Object.defineProperty(element, '_source', {
        configurable: false,
        enumerable: false,
        writable: false,
        value: source
      });
    } else {
      element._store.validated = false;
      element._self = self;
      element._source = source;
    }
    if (Object.freeze) {
      Object.freeze(element.props);
      Object.freeze(element);
    }
  }

  return element;
};

/**
 * Create and return a new ReactElement of the given type.
 * See https://facebook.github.io/react/docs/top-level-api.html#react.createelement
 */
ReactElement.createElement = function (type, config, children) {
  var propName;

  // Reserved names are extracted
  var props = {};

  var key = null;
  var ref = null;
  var self = null;
  var source = null;

  if (config != null) {
    if (hasValidRef(config)) {
      ref = config.ref;
    }
    if (hasValidKey(config)) {
      key = '' + config.key;
    }

    self = config.__self === undefined ? null : config.__self;
    source = config.__source === undefined ? null : config.__source;
    // Remaining properties are added to a new props object
    for (propName in config) {
      if (hasOwnProperty.call(config, propName) && !RESERVED_PROPS.hasOwnProperty(propName)) {
        props[propName] = config[propName];
      }
    }
  }

  // Children can be more than one argument, and those are transferred onto
  // the newly allocated props object.
  var childrenLength = arguments.length - 2;
  if (childrenLength === 1) {
    props.children = children;
  } else if (childrenLength > 1) {
    var childArray = Array(childrenLength);
    for (var i = 0; i < childrenLength; i++) {
      childArray[i] = arguments[i + 2];
    }
    if (false) {
      if (Object.freeze) {
        Object.freeze(childArray);
      }
    }
    props.children = childArray;
  }

  // Resolve default props
  if (type && type.defaultProps) {
    var defaultProps = type.defaultProps;
    for (propName in defaultProps) {
      if (props[propName] === undefined) {
        props[propName] = defaultProps[propName];
      }
    }
  }
  if (false) {
    if (key || ref) {
      if (typeof props.$$typeof === 'undefined' || props.$$typeof !== REACT_ELEMENT_TYPE) {
        var displayName = typeof type === 'function' ? type.displayName || type.name || 'Unknown' : type;
        if (key) {
          defineKeyPropWarningGetter(props, displayName);
        }
        if (ref) {
          defineRefPropWarningGetter(props, displayName);
        }
      }
    }
  }
  return ReactElement(type, key, ref, self, source, ReactCurrentOwner.current, props);
};

/**
 * Return a function that produces ReactElements of a given type.
 * See https://facebook.github.io/react/docs/top-level-api.html#react.createfactory
 */
ReactElement.createFactory = function (type) {
  var factory = ReactElement.createElement.bind(null, type);
  // Expose the type on the factory and the prototype so that it can be
  // easily accessed on elements. E.g. `<Foo />.type === Foo`.
  // This should not be named `constructor` since this may not be the function
  // that created the element, and it may not even be a constructor.
  // Legacy hook TODO: Warn if this is accessed
  factory.type = type;
  return factory;
};

ReactElement.cloneAndReplaceKey = function (oldElement, newKey) {
  var newElement = ReactElement(oldElement.type, newKey, oldElement.ref, oldElement._self, oldElement._source, oldElement._owner, oldElement.props);

  return newElement;
};

/**
 * Clone and return a new ReactElement using element as the starting point.
 * See https://facebook.github.io/react/docs/top-level-api.html#react.cloneelement
 */
ReactElement.cloneElement = function (element, config, children) {
  var propName;

  // Original props are copied
  var props = _assign({}, element.props);

  // Reserved names are extracted
  var key = element.key;
  var ref = element.ref;
  // Self is preserved since the owner is preserved.
  var self = element._self;
  // Source is preserved since cloneElement is unlikely to be targeted by a
  // transpiler, and the original source is probably a better indicator of the
  // true owner.
  var source = element._source;

  // Owner will be preserved, unless ref is overridden
  var owner = element._owner;

  if (config != null) {
    if (hasValidRef(config)) {
      // Silently steal the ref from the parent.
      ref = config.ref;
      owner = ReactCurrentOwner.current;
    }
    if (hasValidKey(config)) {
      key = '' + config.key;
    }

    // Remaining properties override existing props
    var defaultProps;
    if (element.type && element.type.defaultProps) {
      defaultProps = element.type.defaultProps;
    }
    for (propName in config) {
      if (hasOwnProperty.call(config, propName) && !RESERVED_PROPS.hasOwnProperty(propName)) {
        if (config[propName] === undefined && defaultProps !== undefined) {
          // Resolve default props
          props[propName] = defaultProps[propName];
        } else {
          props[propName] = config[propName];
        }
      }
    }
  }

  // Children can be more than one argument, and those are transferred onto
  // the newly allocated props object.
  var childrenLength = arguments.length - 2;
  if (childrenLength === 1) {
    props.children = children;
  } else if (childrenLength > 1) {
    var childArray = Array(childrenLength);
    for (var i = 0; i < childrenLength; i++) {
      childArray[i] = arguments[i + 2];
    }
    props.children = childArray;
  }

  return ReactElement(element.type, key, ref, self, source, owner, props);
};

/**
 * Verifies the object is a ReactElement.
 * See https://facebook.github.io/react/docs/top-level-api.html#react.isvalidelement
 * @param {?object} object
 * @return {boolean} True if `object` is a valid component.
 * @final
 */
ReactElement.isValidElement = function (object) {
  return typeof object === 'object' && object !== null && object.$$typeof === REACT_ELEMENT_TYPE;
};

module.exports = ReactElement;

/***/ }),
/* 1116 */
/***/ (function(module, exports, __webpack_require__) {

/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */

if (false) {
  var ReactIs = require('react-is');

  // By explicitly using `prop-types` you are opting into new development behavior.
  // http://fb.me/prop-types-in-prod
  var throwOnDirectAccess = true;
  module.exports = require('./factoryWithTypeCheckers')(ReactIs.isElement, throwOnDirectAccess);
} else {
  // By explicitly using `prop-types` you are opting into new production behavior.
  // http://fb.me/prop-types-in-prod
  module.exports = __webpack_require__(1212)();
}


/***/ }),
/* 1117 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * 
 */


/**
 * WARNING: DO NOT manually require this module.
 * This is a replacement for `invariant(...)` used by the error code system
 * and will _only_ be required by the corresponding babel pass.
 * It always throws.
 */

function reactProdInvariant(code) {
  var argCount = arguments.length - 1;

  var message = 'Minified React error #' + code + '; visit ' + 'http://facebook.github.io/react/docs/error-decoder.html?invariant=' + code;

  for (var argIdx = 0; argIdx < argCount; argIdx++) {
    message += '&args[]=' + encodeURIComponent(arguments[argIdx + 1]);
  }

  message += ' for the full message or use the non-minified dev environment' + ' for full errors and additional helpful warnings.';

  var error = new Error(message);
  error.name = 'Invariant Violation';
  error.framesToPop = 1; // we don't care about reactProdInvariant's own frame

  throw error;
}

module.exports = reactProdInvariant;

/***/ }),
/* 1118 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2014-2015, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 */



var emptyFunction = __webpack_require__(418);

/**
 * Similar to invariant but only logs a warning if the condition is not met.
 * This can be used to log issues in development environments in critical
 * paths. Removing the logging code for production environments will keep the
 * same logic and follow the same code paths.
 */

var warning = emptyFunction;

if (false) {
  var printWarning = function printWarning(format) {
    for (var _len = arguments.length, args = Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
      args[_key - 1] = arguments[_key];
    }

    var argIndex = 0;
    var message = 'Warning: ' + format.replace(/%s/g, function () {
      return args[argIndex++];
    });
    if (typeof console !== 'undefined') {
      console.error(message);
    }
    try {
      // --- Welcome to debugging React ---
      // This error was thrown as a convenience so that you can use this stack
      // to find the callsite that caused this warning to fire.
      throw new Error(message);
    } catch (x) {}
  };

  warning = function warning(condition, format) {
    if (format === undefined) {
      throw new Error('`warning(condition, format, ...args)` requires a warning ' + 'message argument');
    }

    if (format.indexOf('Failed Composite propType: ') === 0) {
      return; // Ignore CompositeComponent proptype check.
    }

    if (!condition) {
      for (var _len2 = arguments.length, args = Array(_len2 > 2 ? _len2 - 2 : 0), _key2 = 2; _key2 < _len2; _key2++) {
        args[_key2 - 2] = arguments[_key2];
      }

      printWarning.apply(undefined, [format].concat(args));
    }
  };
}

module.exports = warning;

/***/ }),
/* 1119 */
/***/ (function(module, exports, __webpack_require__) {

/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */

if (false) {
  var ReactIs = require('react-is');

  // By explicitly using `prop-types` you are opting into new development behavior.
  // http://fb.me/prop-types-in-prod
  var throwOnDirectAccess = true;
  module.exports = require('./factoryWithTypeCheckers')(ReactIs.isElement, throwOnDirectAccess);
} else {
  // By explicitly using `prop-types` you are opting into new production behavior.
  // http://fb.me/prop-types-in-prod
  module.exports = __webpack_require__(1208)();
}


/***/ }),
/* 1120 */,
/* 1121 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _CSSTransition = _interopRequireDefault(__webpack_require__(1211));

var _ReplaceTransition = _interopRequireDefault(__webpack_require__(1218));

var _TransitionGroup = _interopRequireDefault(__webpack_require__(1138));

var _Transition = _interopRequireDefault(__webpack_require__(1136));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

module.exports = {
  Transition: _Transition.default,
  TransitionGroup: _TransitionGroup.default,
  ReplaceTransition: _ReplaceTransition.default,
  CSSTransition: _CSSTransition.default
};

/***/ }),
/* 1122 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "polyfill", function() { return polyfill; });
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */

function componentWillMount() {
  // Call this.constructor.gDSFP to support sub-classes.
  var state = this.constructor.getDerivedStateFromProps(this.props, this.state);
  if (state !== null && state !== undefined) {
    this.setState(state);
  }
}

function componentWillReceiveProps(nextProps) {
  // Call this.constructor.gDSFP to support sub-classes.
  // Use the setState() updater to ensure state isn't stale in certain edge cases.
  function updater(prevState) {
    var state = this.constructor.getDerivedStateFromProps(nextProps, prevState);
    return state !== null && state !== undefined ? state : null;
  }
  // Binding "this" is important for shallow renderer support.
  this.setState(updater.bind(this));
}

function componentWillUpdate(nextProps, nextState) {
  try {
    var prevProps = this.props;
    var prevState = this.state;
    this.props = nextProps;
    this.state = nextState;
    this.__reactInternalSnapshotFlag = true;
    this.__reactInternalSnapshot = this.getSnapshotBeforeUpdate(
      prevProps,
      prevState
    );
  } finally {
    this.props = prevProps;
    this.state = prevState;
  }
}

// React may warn about cWM/cWRP/cWU methods being deprecated.
// Add a flag to suppress these warnings for this special case.
componentWillMount.__suppressDeprecationWarning = true;
componentWillReceiveProps.__suppressDeprecationWarning = true;
componentWillUpdate.__suppressDeprecationWarning = true;

function polyfill(Component) {
  var prototype = Component.prototype;

  if (!prototype || !prototype.isReactComponent) {
    throw new Error('Can only polyfill class components');
  }

  if (
    typeof Component.getDerivedStateFromProps !== 'function' &&
    typeof prototype.getSnapshotBeforeUpdate !== 'function'
  ) {
    return Component;
  }

  // If new component APIs are defined, "unsafe" lifecycles won't be called.
  // Error if any of these lifecycles are present,
  // Because they would work differently between older and newer (16.3+) versions of React.
  var foundWillMountName = null;
  var foundWillReceivePropsName = null;
  var foundWillUpdateName = null;
  if (typeof prototype.componentWillMount === 'function') {
    foundWillMountName = 'componentWillMount';
  } else if (typeof prototype.UNSAFE_componentWillMount === 'function') {
    foundWillMountName = 'UNSAFE_componentWillMount';
  }
  if (typeof prototype.componentWillReceiveProps === 'function') {
    foundWillReceivePropsName = 'componentWillReceiveProps';
  } else if (typeof prototype.UNSAFE_componentWillReceiveProps === 'function') {
    foundWillReceivePropsName = 'UNSAFE_componentWillReceiveProps';
  }
  if (typeof prototype.componentWillUpdate === 'function') {
    foundWillUpdateName = 'componentWillUpdate';
  } else if (typeof prototype.UNSAFE_componentWillUpdate === 'function') {
    foundWillUpdateName = 'UNSAFE_componentWillUpdate';
  }
  if (
    foundWillMountName !== null ||
    foundWillReceivePropsName !== null ||
    foundWillUpdateName !== null
  ) {
    var componentName = Component.displayName || Component.name;
    var newApiName =
      typeof Component.getDerivedStateFromProps === 'function'
        ? 'getDerivedStateFromProps()'
        : 'getSnapshotBeforeUpdate()';

    throw Error(
      'Unsafe legacy lifecycles will not be called for components using new component APIs.\n\n' +
        componentName +
        ' uses ' +
        newApiName +
        ' but also contains the following legacy lifecycles:' +
        (foundWillMountName !== null ? '\n  ' + foundWillMountName : '') +
        (foundWillReceivePropsName !== null
          ? '\n  ' + foundWillReceivePropsName
          : '') +
        (foundWillUpdateName !== null ? '\n  ' + foundWillUpdateName : '') +
        '\n\nThe above lifecycles should be removed. Learn more about this warning here:\n' +
        'https://fb.me/react-async-component-lifecycle-hooks'
    );
  }

  // React <= 16.2 does not support static getDerivedStateFromProps.
  // As a workaround, use cWM and cWRP to invoke the new static lifecycle.
  // Newer versions of React will ignore these lifecycles if gDSFP exists.
  if (typeof Component.getDerivedStateFromProps === 'function') {
    prototype.componentWillMount = componentWillMount;
    prototype.componentWillReceiveProps = componentWillReceiveProps;
  }

  // React <= 16.2 does not support getSnapshotBeforeUpdate.
  // As a workaround, use cWU to invoke the new lifecycle.
  // Newer versions of React will ignore that lifecycle if gSBU exists.
  if (typeof prototype.getSnapshotBeforeUpdate === 'function') {
    if (typeof prototype.componentDidUpdate !== 'function') {
      throw new Error(
        'Cannot polyfill getSnapshotBeforeUpdate() for components that do not define componentDidUpdate() on the prototype'
      );
    }

    prototype.componentWillUpdate = componentWillUpdate;

    var componentDidUpdate = prototype.componentDidUpdate;

    prototype.componentDidUpdate = function componentDidUpdatePolyfill(
      prevProps,
      prevState,
      maybeSnapshot
    ) {
      // 16.3+ will not execute our will-update method;
      // It will pass a snapshot value to did-update though.
      // Older versions will require our polyfilled will-update value.
      // We need to handle both cases, but can't just check for the presence of "maybeSnapshot",
      // Because for <= 15.x versions this might be a "prevContext" object.
      // We also can't just check "__reactInternalSnapshot",
      // Because get-snapshot might return a falsy value.
      // So check for the explicit __reactInternalSnapshotFlag flag to determine behavior.
      var snapshot = this.__reactInternalSnapshotFlag
        ? this.__reactInternalSnapshot
        : maybeSnapshot;

      componentDidUpdate.call(this, prevProps, prevState, snapshot);
    };
  }

  return Component;
}




/***/ }),
/* 1123 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(71);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(182);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_isomorphic_style_loader_lib_withStyles__ = __webpack_require__(887);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_isomorphic_style_loader_lib_withStyles___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_isomorphic_style_loader_lib_withStyles__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__NotLoggedIn_css__ = __webpack_require__(1126);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__NotLoggedIn_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__NotLoggedIn_css__);
var _jsx = function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; }();

/* eslint react/prop-types: 0 */





function NotLoggedIn(props) {
  return _jsx('div', {
    className: __WEBPACK_IMPORTED_MODULE_3__NotLoggedIn_css___default.a.root
  }, void 0, _jsx('div', {
    className: __WEBPACK_IMPORTED_MODULE_3__NotLoggedIn_css___default.a.container
  }, void 0, _jsx('h1', {}, void 0, props.titulo), _jsx('div', {
    className: __WEBPACK_IMPORTED_MODULE_3__NotLoggedIn_css___default.a.alert + ' alert alert-danger'
  }, void 0, _jsx('strong', {}, void 0, props.children))));
}

/* harmony default export */ __webpack_exports__["a"] = (__WEBPACK_IMPORTED_MODULE_2_isomorphic_style_loader_lib_withStyles___default()(__WEBPACK_IMPORTED_MODULE_3__NotLoggedIn_css___default.a)(NotLoggedIn));

/***/ }),
/* 1124 */
/***/ (function(module, exports, __webpack_require__) {

/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 */

if (false) {
  var REACT_ELEMENT_TYPE = (typeof Symbol === 'function' &&
    Symbol.for &&
    Symbol.for('react.element')) ||
    0xeac7;

  var isValidElement = function(object) {
    return typeof object === 'object' &&
      object !== null &&
      object.$$typeof === REACT_ELEMENT_TYPE;
  };

  // By explicitly using `prop-types` you are opting into new development behavior.
  // http://fb.me/prop-types-in-prod
  var throwOnDirectAccess = true;
  module.exports = require('./factoryWithTypeCheckers')(isValidElement, throwOnDirectAccess);
} else {
  // By explicitly using `prop-types` you are opting into new production behavior.
  // http://fb.me/prop-types-in-prod
  module.exports = __webpack_require__(1261)();
}


/***/ }),
/* 1125 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _captialize = __webpack_require__(1264);

Object.defineProperty(exports, 'captialize', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_captialize).default;
  }
});

var _clamp = __webpack_require__(1265);

Object.defineProperty(exports, 'clamp', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_clamp).default;
  }
});

var _distanceTo = __webpack_require__(1266);

Object.defineProperty(exports, 'distanceTo', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_distanceTo).default;
  }
});

var _isDefined = __webpack_require__(1267);

Object.defineProperty(exports, 'isDefined', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_isDefined).default;
  }
});

var _isNumber = __webpack_require__(1268);

Object.defineProperty(exports, 'isNumber', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_isNumber).default;
  }
});

var _isObject = __webpack_require__(1269);

Object.defineProperty(exports, 'isObject', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_isObject).default;
  }
});

var _length = __webpack_require__(1270);

Object.defineProperty(exports, 'length', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_length).default;
  }
});

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
//# sourceMappingURL=index.js.map

/***/ }),
/* 1126 */
/***/ (function(module, exports, __webpack_require__) {


    var content = __webpack_require__(1127);
    var insertCss = __webpack_require__(889);

    if (typeof content === 'string') {
      content = [[module.i, content, '']];
    }

    module.exports = content.locals || {};
    module.exports._getContent = function() { return content; };
    module.exports._getCss = function() { return content.toString(); };
    module.exports._insertCss = function(options) { return insertCss(content, options) };
    
    // Hot Module Replacement
    // https://webpack.github.io/docs/hot-module-replacement
    // Only activated in browser context
    if (false) {
      var removeCss = function() {};
      module.hot.accept("!!../../../node_modules/css-loader/index.js??ref--2-rules-2!../../../node_modules/postcss-loader/lib/index.js??ref--2-rules-3!./NotLoggedIn.css", function() {
        content = require("!!../../../node_modules/css-loader/index.js??ref--2-rules-2!../../../node_modules/postcss-loader/lib/index.js??ref--2-rules-3!./NotLoggedIn.css");

        if (typeof content === 'string') {
          content = [[module.id, content, '']];
        }

        removeCss = insertCss(content, { replace: true });
      });
      module.hot.dispose(function() { removeCss(); });
    }
  

/***/ }),
/* 1127 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(888)(false);
// imports


// module
exports.push([module.i, "._20Prv{padding-top:124px;padding-left:20px;padding-right:20px}._2gWJk{margin:0 auto;padding:0 0 40px;max-width:970px}._3xbhc{background-color:#f40000;color:#fff;font-size:14px}", ""]);

// exports
exports.locals = {
	"root": "_20Prv",
	"container": "_2gWJk",
	"alert": "_3xbhc"
};

/***/ }),
/* 1128 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */



var _prodInvariant = __webpack_require__(1117),
    _assign = __webpack_require__(131);

var ReactNoopUpdateQueue = __webpack_require__(1129);

var canDefineProperty = __webpack_require__(1130);
var emptyObject = __webpack_require__(1131);
var invariant = __webpack_require__(417);
var lowPriorityWarning = __webpack_require__(1170);

/**
 * Base class helpers for the updating state of a component.
 */
function ReactComponent(props, context, updater) {
  this.props = props;
  this.context = context;
  this.refs = emptyObject;
  // We initialize the default updater but the real one gets injected by the
  // renderer.
  this.updater = updater || ReactNoopUpdateQueue;
}

ReactComponent.prototype.isReactComponent = {};

/**
 * Sets a subset of the state. Always use this to mutate
 * state. You should treat `this.state` as immutable.
 *
 * There is no guarantee that `this.state` will be immediately updated, so
 * accessing `this.state` after calling this method may return the old value.
 *
 * There is no guarantee that calls to `setState` will run synchronously,
 * as they may eventually be batched together.  You can provide an optional
 * callback that will be executed when the call to setState is actually
 * completed.
 *
 * When a function is provided to setState, it will be called at some point in
 * the future (not synchronously). It will be called with the up to date
 * component arguments (state, props, context). These values can be different
 * from this.* because your function may be called after receiveProps but before
 * shouldComponentUpdate, and this new state, props, and context will not yet be
 * assigned to this.
 *
 * @param {object|function} partialState Next partial state or function to
 *        produce next partial state to be merged with current state.
 * @param {?function} callback Called after state is updated.
 * @final
 * @protected
 */
ReactComponent.prototype.setState = function (partialState, callback) {
  !(typeof partialState === 'object' || typeof partialState === 'function' || partialState == null) ?  false ? invariant(false, 'setState(...): takes an object of state variables to update or a function which returns an object of state variables.') : _prodInvariant('85') : void 0;
  this.updater.enqueueSetState(this, partialState);
  if (callback) {
    this.updater.enqueueCallback(this, callback, 'setState');
  }
};

/**
 * Forces an update. This should only be invoked when it is known with
 * certainty that we are **not** in a DOM transaction.
 *
 * You may want to call this when you know that some deeper aspect of the
 * component's state has changed but `setState` was not called.
 *
 * This will not invoke `shouldComponentUpdate`, but it will invoke
 * `componentWillUpdate` and `componentDidUpdate`.
 *
 * @param {?function} callback Called after update is complete.
 * @final
 * @protected
 */
ReactComponent.prototype.forceUpdate = function (callback) {
  this.updater.enqueueForceUpdate(this);
  if (callback) {
    this.updater.enqueueCallback(this, callback, 'forceUpdate');
  }
};

/**
 * Deprecated APIs. These APIs used to exist on classic React classes but since
 * we would like to deprecate them, we're not going to move them over to this
 * modern base class. Instead, we define a getter that warns if it's accessed.
 */
if (false) {
  var deprecatedAPIs = {
    isMounted: ['isMounted', 'Instead, make sure to clean up subscriptions and pending requests in ' + 'componentWillUnmount to prevent memory leaks.'],
    replaceState: ['replaceState', 'Refactor your code to use setState instead (see ' + 'https://github.com/facebook/react/issues/3236).']
  };
  var defineDeprecationWarning = function (methodName, info) {
    if (canDefineProperty) {
      Object.defineProperty(ReactComponent.prototype, methodName, {
        get: function () {
          lowPriorityWarning(false, '%s(...) is deprecated in plain JavaScript React classes. %s', info[0], info[1]);
          return undefined;
        }
      });
    }
  };
  for (var fnName in deprecatedAPIs) {
    if (deprecatedAPIs.hasOwnProperty(fnName)) {
      defineDeprecationWarning(fnName, deprecatedAPIs[fnName]);
    }
  }
}

/**
 * Base class helpers for the updating state of a component.
 */
function ReactPureComponent(props, context, updater) {
  // Duplicated from ReactComponent.
  this.props = props;
  this.context = context;
  this.refs = emptyObject;
  // We initialize the default updater but the real one gets injected by the
  // renderer.
  this.updater = updater || ReactNoopUpdateQueue;
}

function ComponentDummy() {}
ComponentDummy.prototype = ReactComponent.prototype;
ReactPureComponent.prototype = new ComponentDummy();
ReactPureComponent.prototype.constructor = ReactPureComponent;
// Avoid an extra prototype jump for these methods.
_assign(ReactPureComponent.prototype, ReactComponent.prototype);
ReactPureComponent.prototype.isPureReactComponent = true;

module.exports = {
  Component: ReactComponent,
  PureComponent: ReactPureComponent
};

/***/ }),
/* 1129 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2015-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */



var warning = __webpack_require__(1118);

function warnNoop(publicInstance, callerName) {
  if (false) {
    var constructor = publicInstance.constructor;
    process.env.NODE_ENV !== 'production' ? warning(false, '%s(...): Can only update a mounted or mounting component. ' + 'This usually means you called %s() on an unmounted component. ' + 'This is a no-op. Please check the code for the %s component.', callerName, callerName, constructor && (constructor.displayName || constructor.name) || 'ReactClass') : void 0;
  }
}

/**
 * This is the abstract API for an update queue.
 */
var ReactNoopUpdateQueue = {
  /**
   * Checks whether or not this composite component is mounted.
   * @param {ReactClass} publicInstance The instance we want to test.
   * @return {boolean} True if mounted, false otherwise.
   * @protected
   * @final
   */
  isMounted: function (publicInstance) {
    return false;
  },

  /**
   * Enqueue a callback that will be executed after all the pending updates
   * have processed.
   *
   * @param {ReactClass} publicInstance The instance to use as `this` context.
   * @param {?function} callback Called after state is updated.
   * @internal
   */
  enqueueCallback: function (publicInstance, callback) {},

  /**
   * Forces an update. This should only be invoked when it is known with
   * certainty that we are **not** in a DOM transaction.
   *
   * You may want to call this when you know that some deeper aspect of the
   * component's state has changed but `setState` was not called.
   *
   * This will not invoke `shouldComponentUpdate`, but it will invoke
   * `componentWillUpdate` and `componentDidUpdate`.
   *
   * @param {ReactClass} publicInstance The instance that should rerender.
   * @internal
   */
  enqueueForceUpdate: function (publicInstance) {
    warnNoop(publicInstance, 'forceUpdate');
  },

  /**
   * Replaces all of the state. Always use this or `setState` to mutate state.
   * You should treat `this.state` as immutable.
   *
   * There is no guarantee that `this.state` will be immediately updated, so
   * accessing `this.state` after calling this method may return the old value.
   *
   * @param {ReactClass} publicInstance The instance that should rerender.
   * @param {object} completeState Next state.
   * @internal
   */
  enqueueReplaceState: function (publicInstance, completeState) {
    warnNoop(publicInstance, 'replaceState');
  },

  /**
   * Sets a subset of the state. This only exists because _pendingState is
   * internal. This provides a merging strategy that is not available to deep
   * properties which is confusing. TODO: Expose pendingState or don't use it
   * during the merge.
   *
   * @param {ReactClass} publicInstance The instance that should rerender.
   * @param {object} partialState Next partial state to be merged with state.
   * @internal
   */
  enqueueSetState: function (publicInstance, partialState) {
    warnNoop(publicInstance, 'setState');
  }
};

module.exports = ReactNoopUpdateQueue;

/***/ }),
/* 1130 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * 
 */



var canDefineProperty = false;
if (false) {
  try {
    // $FlowFixMe https://github.com/facebook/flow/issues/285
    Object.defineProperty({}, 'x', { get: function () {} });
    canDefineProperty = true;
  } catch (x) {
    // IE will fail on defineProperty
  }
}

module.exports = canDefineProperty;

/***/ }),
/* 1131 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 */



var emptyObject = {};

if (false) {
  Object.freeze(emptyObject);
}

module.exports = emptyObject;

/***/ }),
/* 1132 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * 
 */



/**
 * Keeps track of the current owner.
 *
 * The current owner is the component who should own any components that are
 * currently being constructed.
 */
var ReactCurrentOwner = {
  /**
   * @internal
   * @type {ReactComponent}
   */
  current: null
};

module.exports = ReactCurrentOwner;

/***/ }),
/* 1133 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2014-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * 
 */



// The Symbol used to tag the ReactElement type. If there is no native Symbol
// nor polyfill, then a plain number is used for performance.

var REACT_ELEMENT_TYPE = typeof Symbol === 'function' && Symbol['for'] && Symbol['for']('react.element') || 0xeac7;

module.exports = REACT_ELEMENT_TYPE;

/***/ }),
/* 1134 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 */



var ReactPropTypesSecret = 'SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED';

module.exports = ReactPropTypesSecret;


/***/ }),
/* 1135 */
/***/ (function(module, exports) {

/**
 * lodash 3.0.2 (Custom Build) <https://lodash.com/>
 * Build: `lodash modern modularize exports="npm" -o ./`
 * Copyright 2012-2015 The Dojo Foundation <http://dojofoundation.org/>
 * Based on Underscore.js 1.8.3 <http://underscorejs.org/LICENSE>
 * Copyright 2009-2015 Jeremy Ashkenas, DocumentCloud and Investigative Reporters & Editors
 * Available under MIT license <https://lodash.com/license>
 */

/**
 * Checks if `value` is the [language type](https://es5.github.io/#x8) of `Object`.
 * (e.g. arrays, functions, objects, regexes, `new Number(0)`, and `new String('')`)
 *
 * @static
 * @memberOf _
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an object, else `false`.
 * @example
 *
 * _.isObject({});
 * // => true
 *
 * _.isObject([1, 2, 3]);
 * // => true
 *
 * _.isObject(1);
 * // => false
 */
function isObject(value) {
  // Avoid a V8 JIT bug in Chrome 19-20.
  // See https://code.google.com/p/v8/issues/detail?id=2291 for more details.
  var type = typeof value;
  return !!value && (type == 'object' || type == 'function');
}

module.exports = isObject;


/***/ }),
/* 1136 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
exports.default = exports.EXITING = exports.ENTERED = exports.ENTERING = exports.EXITED = exports.UNMOUNTED = void 0;

var PropTypes = _interopRequireWildcard(__webpack_require__(1116));

var _react = _interopRequireDefault(__webpack_require__(71));

var _reactDom = _interopRequireDefault(__webpack_require__(420));

var _reactLifecyclesCompat = __webpack_require__(1122);

var _PropTypes = __webpack_require__(1137);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = Object.defineProperty && Object.getOwnPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : {}; if (desc.get || desc.set) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } } newObj.default = obj; return newObj; } }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

function _inheritsLoose(subClass, superClass) { subClass.prototype = Object.create(superClass.prototype); subClass.prototype.constructor = subClass; subClass.__proto__ = superClass; }

var UNMOUNTED = 'unmounted';
exports.UNMOUNTED = UNMOUNTED;
var EXITED = 'exited';
exports.EXITED = EXITED;
var ENTERING = 'entering';
exports.ENTERING = ENTERING;
var ENTERED = 'entered';
exports.ENTERED = ENTERED;
var EXITING = 'exiting';
/**
 * The Transition component lets you describe a transition from one component
 * state to another _over time_ with a simple declarative API. Most commonly
 * it's used to animate the mounting and unmounting of a component, but can also
 * be used to describe in-place transition states as well.
 *
 * By default the `Transition` component does not alter the behavior of the
 * component it renders, it only tracks "enter" and "exit" states for the components.
 * It's up to you to give meaning and effect to those states. For example we can
 * add styles to a component when it enters or exits:
 *
 * ```jsx
 * import Transition from 'react-transition-group/Transition';
 *
 * const duration = 300;
 *
 * const defaultStyle = {
 *   transition: `opacity ${duration}ms ease-in-out`,
 *   opacity: 0,
 * }
 *
 * const transitionStyles = {
 *   entering: { opacity: 0 },
 *   entered:  { opacity: 1 },
 * };
 *
 * const Fade = ({ in: inProp }) => (
 *   <Transition in={inProp} timeout={duration}>
 *     {(state) => (
 *       <div style={{
 *         ...defaultStyle,
 *         ...transitionStyles[state]
 *       }}>
 *         I'm a fade Transition!
 *       </div>
 *     )}
 *   </Transition>
 * );
 * ```
 *
 * As noted the `Transition` component doesn't _do_ anything by itself to its child component.
 * What it does do is track transition states over time so you can update the
 * component (such as by adding styles or classes) when it changes states.
 *
 * There are 4 main states a Transition can be in:
 *  - `'entering'`
 *  - `'entered'`
 *  - `'exiting'`
 *  - `'exited'`
 *
 * Transition state is toggled via the `in` prop. When `true` the component begins the
 * "Enter" stage. During this stage, the component will shift from its current transition state,
 * to `'entering'` for the duration of the transition and then to the `'entered'` stage once
 * it's complete. Let's take the following example:
 *
 * ```jsx
 * state = { in: false };
 *
 * toggleEnterState = () => {
 *   this.setState({ in: true });
 * }
 *
 * render() {
 *   return (
 *     <div>
 *       <Transition in={this.state.in} timeout={500} />
 *       <button onClick={this.toggleEnterState}>Click to Enter</button>
 *     </div>
 *   );
 * }
 * ```
 *
 * When the button is clicked the component will shift to the `'entering'` state and
 * stay there for 500ms (the value of `timeout`) before it finally switches to `'entered'`.
 *
 * When `in` is `false` the same thing happens except the state moves from `'exiting'` to `'exited'`.
 *
 * ## Timing
 *
 * Timing is often the trickiest part of animation, mistakes can result in slight delays
 * that are hard to pin down. A common example is when you want to add an exit transition,
 * you should set the desired final styles when the state is `'exiting'`. That's when the
 * transition to those styles will start and, if you matched the `timeout` prop with the
 * CSS Transition duration, it will end exactly when the state changes to `'exited'`.
 *
 * > **Note**: For simpler transitions the `Transition` component might be enough, but
 * > take into account that it's platform-agnostic, while the `CSSTransition` component
 * > [forces reflows](https://github.com/reactjs/react-transition-group/blob/5007303e729a74be66a21c3e2205e4916821524b/src/CSSTransition.js#L208-L215)
 * > in order to make more complex transitions more predictable. For example, even though
 * > classes `example-enter` and `example-enter-active` are applied immediately one after
 * > another, you can still transition from one to the other because of the forced reflow
 * > (read [this issue](https://github.com/reactjs/react-transition-group/issues/159#issuecomment-322761171)
 * > for more info). Take this into account when choosing between `Transition` and
 * > `CSSTransition`.
 */

exports.EXITING = EXITING;

var Transition =
/*#__PURE__*/
function (_React$Component) {
  _inheritsLoose(Transition, _React$Component);

  function Transition(props, context) {
    var _this;

    _this = _React$Component.call(this, props, context) || this;
    var parentGroup = context.transitionGroup; // In the context of a TransitionGroup all enters are really appears

    var appear = parentGroup && !parentGroup.isMounting ? props.enter : props.appear;
    var initialStatus;
    _this.appearStatus = null;

    if (props.in) {
      if (appear) {
        initialStatus = EXITED;
        _this.appearStatus = ENTERING;
      } else {
        initialStatus = ENTERED;
      }
    } else {
      if (props.unmountOnExit || props.mountOnEnter) {
        initialStatus = UNMOUNTED;
      } else {
        initialStatus = EXITED;
      }
    }

    _this.state = {
      status: initialStatus
    };
    _this.nextCallback = null;
    return _this;
  }

  var _proto = Transition.prototype;

  _proto.getChildContext = function getChildContext() {
    return {
      transitionGroup: null // allows for nested Transitions

    };
  };

  Transition.getDerivedStateFromProps = function getDerivedStateFromProps(_ref, prevState) {
    var nextIn = _ref.in;

    if (nextIn && prevState.status === UNMOUNTED) {
      return {
        status: EXITED
      };
    }

    return null;
  }; // getSnapshotBeforeUpdate(prevProps) {
  //   let nextStatus = null
  //   if (prevProps !== this.props) {
  //     const { status } = this.state
  //     if (this.props.in) {
  //       if (status !== ENTERING && status !== ENTERED) {
  //         nextStatus = ENTERING
  //       }
  //     } else {
  //       if (status === ENTERING || status === ENTERED) {
  //         nextStatus = EXITING
  //       }
  //     }
  //   }
  //   return { nextStatus }
  // }


  _proto.componentDidMount = function componentDidMount() {
    this.updateStatus(true, this.appearStatus);
  };

  _proto.componentDidUpdate = function componentDidUpdate(prevProps) {
    var nextStatus = null;

    if (prevProps !== this.props) {
      var status = this.state.status;

      if (this.props.in) {
        if (status !== ENTERING && status !== ENTERED) {
          nextStatus = ENTERING;
        }
      } else {
        if (status === ENTERING || status === ENTERED) {
          nextStatus = EXITING;
        }
      }
    }

    this.updateStatus(false, nextStatus);
  };

  _proto.componentWillUnmount = function componentWillUnmount() {
    this.cancelNextCallback();
  };

  _proto.getTimeouts = function getTimeouts() {
    var timeout = this.props.timeout;
    var exit, enter, appear;
    exit = enter = appear = timeout;

    if (timeout != null && typeof timeout !== 'number') {
      exit = timeout.exit;
      enter = timeout.enter; // TODO: remove fallback for next major

      appear = timeout.appear !== undefined ? timeout.appear : enter;
    }

    return {
      exit: exit,
      enter: enter,
      appear: appear
    };
  };

  _proto.updateStatus = function updateStatus(mounting, nextStatus) {
    if (mounting === void 0) {
      mounting = false;
    }

    if (nextStatus !== null) {
      // nextStatus will always be ENTERING or EXITING.
      this.cancelNextCallback();

      var node = _reactDom.default.findDOMNode(this);

      if (nextStatus === ENTERING) {
        this.performEnter(node, mounting);
      } else {
        this.performExit(node);
      }
    } else if (this.props.unmountOnExit && this.state.status === EXITED) {
      this.setState({
        status: UNMOUNTED
      });
    }
  };

  _proto.performEnter = function performEnter(node, mounting) {
    var _this2 = this;

    var enter = this.props.enter;
    var appearing = this.context.transitionGroup ? this.context.transitionGroup.isMounting : mounting;
    var timeouts = this.getTimeouts();
    var enterTimeout = appearing ? timeouts.appear : timeouts.enter; // no enter animation skip right to ENTERED
    // if we are mounting and running this it means appear _must_ be set

    if (!mounting && !enter) {
      this.safeSetState({
        status: ENTERED
      }, function () {
        _this2.props.onEntered(node);
      });
      return;
    }

    this.props.onEnter(node, appearing);
    this.safeSetState({
      status: ENTERING
    }, function () {
      _this2.props.onEntering(node, appearing);

      _this2.onTransitionEnd(node, enterTimeout, function () {
        _this2.safeSetState({
          status: ENTERED
        }, function () {
          _this2.props.onEntered(node, appearing);
        });
      });
    });
  };

  _proto.performExit = function performExit(node) {
    var _this3 = this;

    var exit = this.props.exit;
    var timeouts = this.getTimeouts(); // no exit animation skip right to EXITED

    if (!exit) {
      this.safeSetState({
        status: EXITED
      }, function () {
        _this3.props.onExited(node);
      });
      return;
    }

    this.props.onExit(node);
    this.safeSetState({
      status: EXITING
    }, function () {
      _this3.props.onExiting(node);

      _this3.onTransitionEnd(node, timeouts.exit, function () {
        _this3.safeSetState({
          status: EXITED
        }, function () {
          _this3.props.onExited(node);
        });
      });
    });
  };

  _proto.cancelNextCallback = function cancelNextCallback() {
    if (this.nextCallback !== null) {
      this.nextCallback.cancel();
      this.nextCallback = null;
    }
  };

  _proto.safeSetState = function safeSetState(nextState, callback) {
    // This shouldn't be necessary, but there are weird race conditions with
    // setState callbacks and unmounting in testing, so always make sure that
    // we can cancel any pending setState callbacks after we unmount.
    callback = this.setNextCallback(callback);
    this.setState(nextState, callback);
  };

  _proto.setNextCallback = function setNextCallback(callback) {
    var _this4 = this;

    var active = true;

    this.nextCallback = function (event) {
      if (active) {
        active = false;
        _this4.nextCallback = null;
        callback(event);
      }
    };

    this.nextCallback.cancel = function () {
      active = false;
    };

    return this.nextCallback;
  };

  _proto.onTransitionEnd = function onTransitionEnd(node, timeout, handler) {
    this.setNextCallback(handler);

    if (node) {
      if (this.props.addEndListener) {
        this.props.addEndListener(node, this.nextCallback);
      }

      if (timeout != null) {
        setTimeout(this.nextCallback, timeout);
      }
    } else {
      setTimeout(this.nextCallback, 0);
    }
  };

  _proto.render = function render() {
    var status = this.state.status;

    if (status === UNMOUNTED) {
      return null;
    }

    var _this$props = this.props,
        children = _this$props.children,
        childProps = _objectWithoutPropertiesLoose(_this$props, ["children"]); // filter props for Transtition


    delete childProps.in;
    delete childProps.mountOnEnter;
    delete childProps.unmountOnExit;
    delete childProps.appear;
    delete childProps.enter;
    delete childProps.exit;
    delete childProps.timeout;
    delete childProps.addEndListener;
    delete childProps.onEnter;
    delete childProps.onEntering;
    delete childProps.onEntered;
    delete childProps.onExit;
    delete childProps.onExiting;
    delete childProps.onExited;

    if (typeof children === 'function') {
      return children(status, childProps);
    }

    var child = _react.default.Children.only(children);

    return _react.default.cloneElement(child, childProps);
  };

  return Transition;
}(_react.default.Component);

Transition.contextTypes = {
  transitionGroup: PropTypes.object
};
Transition.childContextTypes = {
  transitionGroup: function transitionGroup() {}
};
Transition.propTypes =  false ? {
  /**
   * A `function` child can be used instead of a React element.
   * This function is called with the current transition status
   * ('entering', 'entered', 'exiting', 'exited', 'unmounted'), which can be used
   * to apply context specific props to a component.
   *
   * ```jsx
   * <Transition timeout={150}>
   *   {(status) => (
   *     <MyComponent className={`fade fade-${status}`} />
   *   )}
   * </Transition>
   * ```
   */
  children: PropTypes.oneOfType([PropTypes.func.isRequired, PropTypes.element.isRequired]).isRequired,

  /**
   * Show the component; triggers the enter or exit states
   */
  in: PropTypes.bool,

  /**
   * By default the child component is mounted immediately along with
   * the parent `Transition` component. If you want to "lazy mount" the component on the
   * first `in={true}` you can set `mountOnEnter`. After the first enter transition the component will stay
   * mounted, even on "exited", unless you also specify `unmountOnExit`.
   */
  mountOnEnter: PropTypes.bool,

  /**
   * By default the child component stays mounted after it reaches the `'exited'` state.
   * Set `unmountOnExit` if you'd prefer to unmount the component after it finishes exiting.
   */
  unmountOnExit: PropTypes.bool,

  /**
   * Normally a component is not transitioned if it is shown when the `<Transition>` component mounts.
   * If you want to transition on the first mount set `appear` to `true`, and the
   * component will transition in as soon as the `<Transition>` mounts.
   *
   * > Note: there are no specific "appear" states. `appear` only adds an additional `enter` transition.
   */
  appear: PropTypes.bool,

  /**
   * Enable or disable enter transitions.
   */
  enter: PropTypes.bool,

  /**
   * Enable or disable exit transitions.
   */
  exit: PropTypes.bool,

  /**
   * The duration of the transition, in milliseconds.
   * Required unless `addEndListener` is provided
   *
   * You may specify a single timeout for all transitions like: `timeout={500}`,
   * or individually like:
   *
   * ```jsx
   * timeout={{
   *  enter: 300,
   *  exit: 500,
   *  appear: 500,
   * }}
   * ```
   *
   * If the value of appear is not set, then the value from enter is taken.
   *
   * @type {number | { enter?: number, exit?: number }}
   */
  timeout: function timeout(props) {
    var pt = process.env.NODE_ENV !== "production" ? _PropTypes.timeoutsShape : {};;
    if (!props.addEndListener) pt = pt.isRequired;

    for (var _len = arguments.length, args = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
      args[_key - 1] = arguments[_key];
    }

    return pt.apply(void 0, [props].concat(args));
  },

  /**
   * Add a custom transition end trigger. Called with the transitioning
   * DOM node and a `done` callback. Allows for more fine grained transition end
   * logic. **Note:** Timeouts are still used as a fallback if provided.
   *
   * ```jsx
   * addEndListener={(node, done) => {
   *   // use the css transitionend event to mark the finish of a transition
   *   node.addEventListener('transitionend', done, false);
   * }}
   * ```
   */
  addEndListener: PropTypes.func,

  /**
   * Callback fired before the "entering" status is applied. An extra parameter
   * `isAppearing` is supplied to indicate if the enter stage is occurring on the initial mount
   *
   * @type Function(node: HtmlElement, isAppearing: bool) -> void
   */
  onEnter: PropTypes.func,

  /**
   * Callback fired after the "entering" status is applied. An extra parameter
   * `isAppearing` is supplied to indicate if the enter stage is occurring on the initial mount
   *
   * @type Function(node: HtmlElement, isAppearing: bool)
   */
  onEntering: PropTypes.func,

  /**
   * Callback fired after the "entered" status is applied. An extra parameter
   * `isAppearing` is supplied to indicate if the enter stage is occurring on the initial mount
   *
   * @type Function(node: HtmlElement, isAppearing: bool) -> void
   */
  onEntered: PropTypes.func,

  /**
   * Callback fired before the "exiting" status is applied.
   *
   * @type Function(node: HtmlElement) -> void
   */
  onExit: PropTypes.func,

  /**
   * Callback fired after the "exiting" status is applied.
   *
   * @type Function(node: HtmlElement) -> void
   */
  onExiting: PropTypes.func,

  /**
   * Callback fired after the "exited" status is applied.
   *
   * @type Function(node: HtmlElement) -> void
   */
  onExited: PropTypes.func // Name the function so it is clearer in the documentation

} : {};

function noop() {}

Transition.defaultProps = {
  in: false,
  mountOnEnter: false,
  unmountOnExit: false,
  appear: false,
  enter: true,
  exit: true,
  onEnter: noop,
  onEntering: noop,
  onEntered: noop,
  onExit: noop,
  onExiting: noop,
  onExited: noop
};
Transition.UNMOUNTED = 0;
Transition.EXITED = 1;
Transition.ENTERING = 2;
Transition.ENTERED = 3;
Transition.EXITING = 4;

var _default = (0, _reactLifecyclesCompat.polyfill)(Transition);

exports.default = _default;

/***/ }),
/* 1137 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
exports.classNamesShape = exports.timeoutsShape = void 0;

var _propTypes = _interopRequireDefault(__webpack_require__(1116));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var timeoutsShape =  false ? _propTypes.default.oneOfType([_propTypes.default.number, _propTypes.default.shape({
  enter: _propTypes.default.number,
  exit: _propTypes.default.number,
  appear: _propTypes.default.number
}).isRequired]) : null;
exports.timeoutsShape = timeoutsShape;
var classNamesShape =  false ? _propTypes.default.oneOfType([_propTypes.default.string, _propTypes.default.shape({
  enter: _propTypes.default.string,
  exit: _propTypes.default.string,
  active: _propTypes.default.string
}), _propTypes.default.shape({
  enter: _propTypes.default.string,
  enterDone: _propTypes.default.string,
  enterActive: _propTypes.default.string,
  exit: _propTypes.default.string,
  exitDone: _propTypes.default.string,
  exitActive: _propTypes.default.string
})]) : null;
exports.classNamesShape = classNamesShape;

/***/ }),
/* 1138 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
exports.default = void 0;

var _propTypes = _interopRequireDefault(__webpack_require__(1116));

var _react = _interopRequireDefault(__webpack_require__(71));

var _reactLifecyclesCompat = __webpack_require__(1122);

var _ChildMapping = __webpack_require__(1219);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _inheritsLoose(subClass, superClass) { subClass.prototype = Object.create(superClass.prototype); subClass.prototype.constructor = subClass; subClass.__proto__ = superClass; }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

var values = Object.values || function (obj) {
  return Object.keys(obj).map(function (k) {
    return obj[k];
  });
};

var defaultProps = {
  component: 'div',
  childFactory: function childFactory(child) {
    return child;
  }
  /**
   * The `<TransitionGroup>` component manages a set of transition components
   * (`<Transition>` and `<CSSTransition>`) in a list. Like with the transition
   * components, `<TransitionGroup>` is a state machine for managing the mounting
   * and unmounting of components over time.
   *
   * Consider the example below. As items are removed or added to the TodoList the
   * `in` prop is toggled automatically by the `<TransitionGroup>`.
   *
   * Note that `<TransitionGroup>`  does not define any animation behavior!
   * Exactly _how_ a list item animates is up to the individual transition
   * component. This means you can mix and match animations across different list
   * items.
   */

};

var TransitionGroup =
/*#__PURE__*/
function (_React$Component) {
  _inheritsLoose(TransitionGroup, _React$Component);

  function TransitionGroup(props, context) {
    var _this;

    _this = _React$Component.call(this, props, context) || this;

    var handleExited = _this.handleExited.bind(_assertThisInitialized(_assertThisInitialized(_this))); // Initial children should all be entering, dependent on appear


    _this.state = {
      handleExited: handleExited,
      firstRender: true
    };
    return _this;
  }

  var _proto = TransitionGroup.prototype;

  _proto.getChildContext = function getChildContext() {
    return {
      transitionGroup: {
        isMounting: !this.appeared
      }
    };
  };

  _proto.componentDidMount = function componentDidMount() {
    this.appeared = true;
    this.mounted = true;
  };

  _proto.componentWillUnmount = function componentWillUnmount() {
    this.mounted = false;
  };

  TransitionGroup.getDerivedStateFromProps = function getDerivedStateFromProps(nextProps, _ref) {
    var prevChildMapping = _ref.children,
        handleExited = _ref.handleExited,
        firstRender = _ref.firstRender;
    return {
      children: firstRender ? (0, _ChildMapping.getInitialChildMapping)(nextProps, handleExited) : (0, _ChildMapping.getNextChildMapping)(nextProps, prevChildMapping, handleExited),
      firstRender: false
    };
  };

  _proto.handleExited = function handleExited(child, node) {
    var currentChildMapping = (0, _ChildMapping.getChildMapping)(this.props.children);
    if (child.key in currentChildMapping) return;

    if (child.props.onExited) {
      child.props.onExited(node);
    }

    if (this.mounted) {
      this.setState(function (state) {
        var children = _extends({}, state.children);

        delete children[child.key];
        return {
          children: children
        };
      });
    }
  };

  _proto.render = function render() {
    var _this$props = this.props,
        Component = _this$props.component,
        childFactory = _this$props.childFactory,
        props = _objectWithoutPropertiesLoose(_this$props, ["component", "childFactory"]);

    var children = values(this.state.children).map(childFactory);
    delete props.appear;
    delete props.enter;
    delete props.exit;

    if (Component === null) {
      return children;
    }

    return _react.default.createElement(Component, props, children);
  };

  return TransitionGroup;
}(_react.default.Component);

TransitionGroup.childContextTypes = {
  transitionGroup: _propTypes.default.object.isRequired
};
TransitionGroup.propTypes =  false ? {
  /**
   * `<TransitionGroup>` renders a `<div>` by default. You can change this
   * behavior by providing a `component` prop.
   * If you use React v16+ and would like to avoid a wrapping `<div>` element
   * you can pass in `component={null}`. This is useful if the wrapping div
   * borks your css styles.
   */
  component: _propTypes.default.any,

  /**
   * A set of `<Transition>` components, that are toggled `in` and out as they
   * leave. the `<TransitionGroup>` will inject specific transition props, so
   * remember to spread them through if you are wrapping the `<Transition>` as
   * with our `<Fade>` example.
   */
  children: _propTypes.default.node,

  /**
   * A convenience prop that enables or disables appear animations
   * for all children. Note that specifying this will override any defaults set
   * on individual children Transitions.
   */
  appear: _propTypes.default.bool,

  /**
   * A convenience prop that enables or disables enter animations
   * for all children. Note that specifying this will override any defaults set
   * on individual children Transitions.
   */
  enter: _propTypes.default.bool,

  /**
   * A convenience prop that enables or disables exit animations
   * for all children. Note that specifying this will override any defaults set
   * on individual children Transitions.
   */
  exit: _propTypes.default.bool,

  /**
   * You may need to apply reactive updates to a child as it is exiting.
   * This is generally done by using `cloneElement` however in the case of an exiting
   * child the element has already been removed and not accessible to the consumer.
   *
   * If you do need to update a child as it leaves you can provide a `childFactory`
   * to wrap every child, even the ones that are leaving.
   *
   * @type Function(child: ReactElement) -> ReactElement
   */
  childFactory: _propTypes.default.func
} : {};
TransitionGroup.defaultProps = defaultProps;

var _default = (0, _reactLifecyclesCompat.polyfill)(TransitionGroup);

exports.default = _default;
module.exports = exports["default"];

/***/ }),
/* 1139 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_moment__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_moment__);
var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }



var TimeManipulation = function () {
  function TimeManipulation() {
    _classCallCheck(this, TimeManipulation);
  }

  _createClass(TimeManipulation, null, [{
    key: 'changeAproxWaitingTime',
    value: function changeAproxWaitingTime(aproxTimeDesc, aproxTimeInterval) {
      var arr = '';
      var rx = /(\d+) Minutos/g;
      arr = aproxTimeDesc.match(rx);
      var minutes = '';
      if (arr) {
        minutes = parseInt(arr[0], 10);
        if (minutes - 5 > 5) {
          return 'Tiempo Aproximado De Atenci\xF3n: ' + (minutes - 5) + ' Minutos';
        }
      }
      clearInterval(aproxTimeInterval);
      return 'Debido a la alta demanda de este servicio el tiempo de espera puede ser prolongado, también puede comunicarse con nuestra línea de Orientación Médica Telefónica al 011 4363-4710. Por cualquier urgencia comuníquese al 0-800-777-7800';
    }
  }]);

  return TimeManipulation;
}();

TimeManipulation.turnHour = function (turnTime) {
  return Number(turnTime.slice(0, 2));
};

TimeManipulation.hourDifferenceLessThan = function (programmedTurnDate, now, hours) {
  return __WEBPACK_IMPORTED_MODULE_0_moment___default()(programmedTurnDate, 'YYYYMMDDHHmm').diff(now, 'hours') < hours;
};

TimeManipulation.minutesDifference = function (turnTime, today) {
  var minuteDiff = Number(turnTime.slice(2, 4)) - today.getMinutes();
  if (minuteDiff < 0) {
    if (TimeManipulation.turnHour(turnTime) > today.getHours()) {
      // example: turn -> 12:15 y today 11:51
      minuteDiff = 60 - today.getMinutes() + Number(turnTime.slice(2, 4));
    } else {
      // if patient entered in the 10 minute tolerance of the turns time the diff is negative,
      // so that i reset the minuteDiff to zero
      // example: turn: 11:15 y today: 11:20
      minuteDiff = 0;
    }
  } else if (TimeManipulation.turnHour(turnTime) < today.getHours()) {
    // 10:50 (turn time) and 11:00 (today)
    minuteDiff = 0;
  }
  return minuteDiff;
};

TimeManipulation.WaitingTime = function (turnTime) {
  var minuteDiff = TimeManipulation.minutesDifference(turnTime, new Date());
  var minutes = void 0;
  function range(init, end) {
    return init <= minuteDiff && minuteDiff < end;
  }
  var functions = {
    // turns are 15 minutes long.
    // always setting the lower value of the range to the waiting minutes
    time: function time(init, end) {
      if (range(init, end)) {
        minutes = init;
      } else {
        this.time(init + 15, end + 15);
      }
    },
    getMinutes: function getMinutes() {
      return minutes;
    }
  };
  return functions;
};

/* harmony default export */ __webpack_exports__["a"] = (TimeManipulation);

/***/ }),
/* 1140 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";

// CONCATENATED MODULE: ./node_modules/@babel/runtime/helpers/esm/extends.js
function _extends() {
  _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  return _extends.apply(this, arguments);
}
// CONCATENATED MODULE: ./node_modules/@babel/runtime/helpers/esm/objectWithoutPropertiesLoose.js
function _objectWithoutPropertiesLoose(source, excluded) {
  if (source == null) return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key, i;

  for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];
    if (excluded.indexOf(key) >= 0) continue;
    target[key] = source[key];
  }

  return target;
}
// CONCATENATED MODULE: ./node_modules/reactstrap/es/utils.js
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash_isfunction__ = __webpack_require__(1207);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash_isfunction___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_lodash_isfunction__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(890);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);

 // https://github.com/twbs/bootstrap/blob/v4.0.0-alpha.4/js/src/modal.js#L436-L443

function getScrollbarWidth() {
  var scrollDiv = document.createElement('div'); // .modal-scrollbar-measure styles // https://github.com/twbs/bootstrap/blob/v4.0.0-alpha.4/scss/_modal.scss#L106-L113

  scrollDiv.style.position = 'absolute';
  scrollDiv.style.top = '-9999px';
  scrollDiv.style.width = '50px';
  scrollDiv.style.height = '50px';
  scrollDiv.style.overflow = 'scroll';
  document.body.appendChild(scrollDiv);
  var scrollbarWidth = scrollDiv.offsetWidth - scrollDiv.clientWidth;
  document.body.removeChild(scrollDiv);
  return scrollbarWidth;
}
function setScrollbarWidth(padding) {
  document.body.style.paddingRight = padding > 0 ? padding + "px" : null;
}
function isBodyOverflowing() {
  return document.body.clientWidth < window.innerWidth;
}
function getOriginalBodyPadding() {
  var style = window.getComputedStyle(document.body, null);
  return parseInt(style && style.getPropertyValue('padding-right') || 0, 10);
}
function conditionallyUpdateScrollbar() {
  var scrollbarWidth = getScrollbarWidth(); // https://github.com/twbs/bootstrap/blob/v4.0.0-alpha.6/js/src/modal.js#L433

  var fixedContent = document.querySelectorAll('.fixed-top, .fixed-bottom, .is-fixed, .sticky-top')[0];
  var bodyPadding = fixedContent ? parseInt(fixedContent.style.paddingRight || 0, 10) : 0;

  if (isBodyOverflowing()) {
    setScrollbarWidth(bodyPadding + scrollbarWidth);
  }
}
var globalCssModule;
function setGlobalCssModule(cssModule) {
  globalCssModule = cssModule;
}
function mapToCssModules(className, cssModule) {
  if (className === void 0) {
    className = '';
  }

  if (cssModule === void 0) {
    cssModule = globalCssModule;
  }

  if (!cssModule) return className;
  return className.split(' ').map(function (c) {
    return cssModule[c] || c;
  }).join(' ');
}
/**
 * Returns a new object with the key/value pairs from `obj` that are not in the array `omitKeys`.
 */

function omit(obj, omitKeys) {
  var result = {};
  Object.keys(obj).forEach(function (key) {
    if (omitKeys.indexOf(key) === -1) {
      result[key] = obj[key];
    }
  });
  return result;
}
/**
 * Returns a filtered copy of an object with only the specified keys.
 */

function pick(obj, keys) {
  var pickKeys = Array.isArray(keys) ? keys : [keys];
  var length = pickKeys.length;
  var key;
  var result = {};

  while (length > 0) {
    length -= 1;
    key = pickKeys[length];
    result[key] = obj[key];
  }

  return result;
}
var warned = {};
function warnOnce(message) {
  if (!warned[message]) {
    /* istanbul ignore else */
    if (typeof console !== 'undefined') {
      console.error(message); // eslint-disable-line no-console
    }

    warned[message] = true;
  }
}
function deprecated(propType, explanation) {
  return function validate(props, propName, componentName) {
    if (props[propName] !== null && typeof props[propName] !== 'undefined') {
      warnOnce("\"" + propName + "\" property of \"" + componentName + "\" has been deprecated.\n" + explanation);
    }

    for (var _len = arguments.length, rest = new Array(_len > 3 ? _len - 3 : 0), _key = 3; _key < _len; _key++) {
      rest[_key - 3] = arguments[_key];
    }

    return propType.apply(void 0, [props, propName, componentName].concat(rest));
  };
}
function DOMElement(props, propName, componentName) {
  if (!(props[propName] instanceof Element)) {
    return new Error('Invalid prop `' + propName + '` supplied to `' + componentName + '`. Expected prop to be an instance of Element. Validation failed.');
  }
}
var targetPropType = __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string, __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func, DOMElement, __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.shape({
  current: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.any
})]);
var tagPropType = __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func, __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string, __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.shape({
  $$typeof: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.symbol,
  render: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func
}), __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.arrayOf(__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func, __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string, __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.shape({
  $$typeof: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.symbol,
  render: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func
})]))]);
/* eslint key-spacing: ["error", { afterColon: true, align: "value" }] */
// These are all setup to match what is in the bootstrap _variables.scss
// https://github.com/twbs/bootstrap/blob/v4-dev/scss/_variables.scss

var TransitionTimeouts = {
  Fade: 150,
  // $transition-fade
  Collapse: 350,
  // $transition-collapse
  Modal: 300,
  // $modal-transition
  Carousel: 600 // $carousel-transition

}; // Duplicated Transition.propType keys to ensure that Reactstrap builds
// for distribution properly exclude these keys for nested child HTML attributes
// since `react-transition-group` removes propTypes in production builds.

var TransitionPropTypeKeys = ['in', 'mountOnEnter', 'unmountOnExit', 'appear', 'enter', 'exit', 'timeout', 'onEnter', 'onEntering', 'onEntered', 'onExit', 'onExiting', 'onExited'];
var TransitionStatuses = {
  ENTERING: 'entering',
  ENTERED: 'entered',
  EXITING: 'exiting',
  EXITED: 'exited'
};
var keyCodes = {
  esc: 27,
  space: 32,
  enter: 13,
  tab: 9,
  up: 38,
  down: 40,
  home: 36,
  end: 35,
  n: 78,
  p: 80
};
var PopperPlacements = ['auto-start', 'auto', 'auto-end', 'top-start', 'top', 'top-end', 'right-start', 'right', 'right-end', 'bottom-end', 'bottom', 'bottom-start', 'left-end', 'left', 'left-start'];
var canUseDOM = !!(typeof window !== 'undefined' && window.document && window.document.createElement);
function isReactRefObj(target) {
  if (target && typeof target === 'object') {
    return 'current' in target;
  }

  return false;
}
function findDOMElements(target) {
  if (isReactRefObj(target)) {
    return target.current;
  }

  if (__WEBPACK_IMPORTED_MODULE_0_lodash_isfunction___default()(target)) {
    return target();
  }

  if (typeof target === 'string' && canUseDOM) {
    var selection = document.querySelectorAll(target);

    if (!selection.length) {
      selection = document.querySelectorAll("#" + target);
    }

    if (!selection.length) {
      throw new Error("The target '" + target + "' could not be identified in the dom, tip: check spelling");
    }

    return selection;
  }

  return target;
}
function isArrayOrNodeList(els) {
  if (els === null) {
    return false;
  }

  return Array.isArray(els) || canUseDOM && typeof els.length === 'number';
}
function getTarget(target) {
  var els = findDOMElements(target);

  if (isArrayOrNodeList(els)) {
    return els[0];
  }

  return els;
}
var defaultToggleEvents = ['touchstart', 'click'];
function addMultipleEventListeners(_els, handler, _events, useCapture) {
  var els = _els;

  if (!isArrayOrNodeList(els)) {
    els = [els];
  }

  var events = _events;

  if (typeof events === 'string') {
    events = events.split(/\s+/);
  }

  if (!isArrayOrNodeList(els) || typeof handler !== 'function' || !Array.isArray(events)) {
    throw new Error("\n      The first argument of this function must be DOM node or an array on DOM nodes or NodeList.\n      The second must be a function.\n      The third is a string or an array of strings that represents DOM events\n    ");
  }

  Array.prototype.forEach.call(events, function (event) {
    Array.prototype.forEach.call(els, function (el) {
      el.addEventListener(event, handler, useCapture);
    });
  });
  return function removeEvents() {
    Array.prototype.forEach.call(events, function (event) {
      Array.prototype.forEach.call(els, function (el) {
        el.removeEventListener(event, handler, useCapture);
      });
    });
  };
}
var focusableElements = ['a[href]', 'area[href]', 'input:not([disabled]):not([type=hidden])', 'select:not([disabled])', 'textarea:not([disabled])', 'button:not([disabled])', 'object', 'embed', '[tabindex]:not(.modal)', 'audio[controls]', 'video[controls]', '[contenteditable]:not([contenteditable="false"])'];
// CONCATENATED MODULE: ./node_modules/reactstrap/es/Container.js
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react__ = __webpack_require__(71);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_prop_types__ = __webpack_require__(890);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_classnames__ = __webpack_require__(891);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_classnames__);






var propTypes = {
  tag: tagPropType,
  fluid: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.bool,
  className: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.string,
  cssModule: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.object
};
var defaultProps = {
  tag: 'div'
};

var Container_Container = function Container(props) {
  var className = props.className,
      cssModule = props.cssModule,
      fluid = props.fluid,
      Tag = props.tag,
      attributes = _objectWithoutPropertiesLoose(props, ["className", "cssModule", "fluid", "tag"]);

  var classes = mapToCssModules(__WEBPACK_IMPORTED_MODULE_4_classnames___default()(className, fluid ? 'container-fluid' : 'container'), cssModule);
  return __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(Tag, _extends({}, attributes, {
    className: classes
  }));
};

Container_Container.propTypes = propTypes;
Container_Container.defaultProps = defaultProps;
/* harmony default export */ var Container_defaultExport = (Container_Container);
// CONCATENATED MODULE: ./node_modules/reactstrap/es/Row.js
/* harmony import */ var Row___WEBPACK_IMPORTED_MODULE_2_react__ = __webpack_require__(71);
/* harmony import */ var Row___WEBPACK_IMPORTED_MODULE_2_react___default = __webpack_require__.n(Row___WEBPACK_IMPORTED_MODULE_2_react__);
/* harmony import */ var Row___WEBPACK_IMPORTED_MODULE_3_prop_types__ = __webpack_require__(890);
/* harmony import */ var Row___WEBPACK_IMPORTED_MODULE_3_prop_types___default = __webpack_require__.n(Row___WEBPACK_IMPORTED_MODULE_3_prop_types__);
/* harmony import */ var Row___WEBPACK_IMPORTED_MODULE_4_classnames__ = __webpack_require__(891);
/* harmony import */ var Row___WEBPACK_IMPORTED_MODULE_4_classnames___default = __webpack_require__.n(Row___WEBPACK_IMPORTED_MODULE_4_classnames__);






var Row_propTypes = {
  tag: tagPropType,
  noGutters: Row___WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.bool,
  className: Row___WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.string,
  cssModule: Row___WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.object,
  form: Row___WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.bool
};
var Row_defaultProps = {
  tag: 'div'
};

var Row_Row = function Row(props) {
  var className = props.className,
      cssModule = props.cssModule,
      noGutters = props.noGutters,
      Tag = props.tag,
      form = props.form,
      attributes = _objectWithoutPropertiesLoose(props, ["className", "cssModule", "noGutters", "tag", "form"]);

  var classes = mapToCssModules(Row___WEBPACK_IMPORTED_MODULE_4_classnames___default()(className, noGutters ? 'no-gutters' : null, form ? 'form-row' : 'row'), cssModule);
  return Row___WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(Tag, _extends({}, attributes, {
    className: classes
  }));
};

Row_Row.propTypes = Row_propTypes;
Row_Row.defaultProps = Row_defaultProps;
/* harmony default export */ var Row_defaultExport = (Row_Row);
// CONCATENATED MODULE: ./node_modules/reactstrap/es/Col.js
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_lodash_isobject__ = __webpack_require__(1135);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_lodash_isobject___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_lodash_isobject__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react__ = __webpack_require__(71);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_prop_types__ = __webpack_require__(890);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_classnames__ = __webpack_require__(891);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_classnames__);







var colWidths = ['xs', 'sm', 'md', 'lg', 'xl'];
var stringOrNumberProp = __WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.number, __WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.string]);
var columnProps = __WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.bool, __WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.number, __WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.string, __WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.shape({
  size: __WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.bool, __WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.number, __WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.string]),
  push: deprecated(stringOrNumberProp, 'Please use the prop "order"'),
  pull: deprecated(stringOrNumberProp, 'Please use the prop "order"'),
  order: stringOrNumberProp,
  offset: stringOrNumberProp
})]);
var Col_propTypes = {
  tag: tagPropType,
  xs: columnProps,
  sm: columnProps,
  md: columnProps,
  lg: columnProps,
  xl: columnProps,
  className: __WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.string,
  cssModule: __WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.object,
  widths: __WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.array
};
var Col_defaultProps = {
  tag: 'div',
  widths: colWidths
};

var getColumnSizeClass = function getColumnSizeClass(isXs, colWidth, colSize) {
  if (colSize === true || colSize === '') {
    return isXs ? 'col' : "col-" + colWidth;
  } else if (colSize === 'auto') {
    return isXs ? 'col-auto' : "col-" + colWidth + "-auto";
  }

  return isXs ? "col-" + colSize : "col-" + colWidth + "-" + colSize;
};

var Col_Col = function Col(props) {
  var className = props.className,
      cssModule = props.cssModule,
      widths = props.widths,
      Tag = props.tag,
      attributes = _objectWithoutPropertiesLoose(props, ["className", "cssModule", "widths", "tag"]);

  var colClasses = [];
  widths.forEach(function (colWidth, i) {
    var columnProp = props[colWidth];
    delete attributes[colWidth];

    if (!columnProp && columnProp !== '') {
      return;
    }

    var isXs = !i;

    if (__WEBPACK_IMPORTED_MODULE_2_lodash_isobject___default()(columnProp)) {
      var _classNames;

      var colSizeInterfix = isXs ? '-' : "-" + colWidth + "-";
      var colClass = getColumnSizeClass(isXs, colWidth, columnProp.size);
      colClasses.push(mapToCssModules(__WEBPACK_IMPORTED_MODULE_5_classnames___default()((_classNames = {}, _classNames[colClass] = columnProp.size || columnProp.size === '', _classNames["order" + colSizeInterfix + columnProp.order] = columnProp.order || columnProp.order === 0, _classNames["offset" + colSizeInterfix + columnProp.offset] = columnProp.offset || columnProp.offset === 0, _classNames)), cssModule));
    } else {
      var _colClass = getColumnSizeClass(isXs, colWidth, columnProp);

      colClasses.push(_colClass);
    }
  });

  if (!colClasses.length) {
    colClasses.push('col');
  }

  var classes = mapToCssModules(__WEBPACK_IMPORTED_MODULE_5_classnames___default()(className, colClasses), cssModule);
  return __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(Tag, _extends({}, attributes, {
    className: classes
  }));
};

Col_Col.propTypes = Col_propTypes;
Col_Col.defaultProps = Col_defaultProps;
/* harmony default export */ var Col_defaultExport = (Col_Col);
// CONCATENATED MODULE: ./node_modules/reactstrap/es/Navbar.js
/* harmony import */ var Navbar___WEBPACK_IMPORTED_MODULE_2_react__ = __webpack_require__(71);
/* harmony import */ var Navbar___WEBPACK_IMPORTED_MODULE_2_react___default = __webpack_require__.n(Navbar___WEBPACK_IMPORTED_MODULE_2_react__);
/* harmony import */ var Navbar___WEBPACK_IMPORTED_MODULE_3_prop_types__ = __webpack_require__(890);
/* harmony import */ var Navbar___WEBPACK_IMPORTED_MODULE_3_prop_types___default = __webpack_require__.n(Navbar___WEBPACK_IMPORTED_MODULE_3_prop_types__);
/* harmony import */ var Navbar___WEBPACK_IMPORTED_MODULE_4_classnames__ = __webpack_require__(891);
/* harmony import */ var Navbar___WEBPACK_IMPORTED_MODULE_4_classnames___default = __webpack_require__.n(Navbar___WEBPACK_IMPORTED_MODULE_4_classnames__);






var Navbar_propTypes = {
  light: Navbar___WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.bool,
  dark: Navbar___WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.bool,
  inverse: deprecated(Navbar___WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.bool, 'Please use the prop "dark"'),
  full: Navbar___WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.bool,
  fixed: Navbar___WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.string,
  sticky: Navbar___WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.string,
  color: Navbar___WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.string,
  role: Navbar___WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.string,
  tag: tagPropType,
  className: Navbar___WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.string,
  cssModule: Navbar___WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.object,
  toggleable: deprecated(Navbar___WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.oneOfType([Navbar___WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.bool, Navbar___WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.string]), 'Please use the prop "expand"'),
  expand: Navbar___WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.oneOfType([Navbar___WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.bool, Navbar___WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.string])
};
var Navbar_defaultProps = {
  tag: 'nav',
  expand: false
};

var getExpandClass = function getExpandClass(expand) {
  if (expand === false) {
    return false;
  } else if (expand === true || expand === 'xs') {
    return 'navbar-expand';
  }

  return "navbar-expand-" + expand;
}; // To better maintain backwards compatibility while toggleable is deprecated.
// We must map breakpoints to the next breakpoint so that toggleable and expand do the same things at the same breakpoint.


var toggleableToExpand = {
  xs: 'sm',
  sm: 'md',
  md: 'lg',
  lg: 'xl'
};

var getToggleableClass = function getToggleableClass(toggleable) {
  if (toggleable === undefined || toggleable === 'xl') {
    return false;
  } else if (toggleable === false) {
    return 'navbar-expand';
  }

  return "navbar-expand-" + (toggleable === true ? 'sm' : toggleableToExpand[toggleable] || toggleable);
};

var Navbar_Navbar = function Navbar(props) {
  var _classNames;

  var toggleable = props.toggleable,
      expand = props.expand,
      className = props.className,
      cssModule = props.cssModule,
      light = props.light,
      dark = props.dark,
      inverse = props.inverse,
      fixed = props.fixed,
      sticky = props.sticky,
      color = props.color,
      Tag = props.tag,
      attributes = _objectWithoutPropertiesLoose(props, ["toggleable", "expand", "className", "cssModule", "light", "dark", "inverse", "fixed", "sticky", "color", "tag"]);

  var classes = mapToCssModules(Navbar___WEBPACK_IMPORTED_MODULE_4_classnames___default()(className, 'navbar', getExpandClass(expand) || getToggleableClass(toggleable), (_classNames = {
    'navbar-light': light,
    'navbar-dark': inverse || dark
  }, _classNames["bg-" + color] = color, _classNames["fixed-" + fixed] = fixed, _classNames["sticky-" + sticky] = sticky, _classNames)), cssModule);
  return Navbar___WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(Tag, _extends({}, attributes, {
    className: classes
  }));
};

Navbar_Navbar.propTypes = Navbar_propTypes;
Navbar_Navbar.defaultProps = Navbar_defaultProps;
/* harmony default export */ var Navbar_defaultExport = (Navbar_Navbar);
// CONCATENATED MODULE: ./node_modules/reactstrap/es/NavbarBrand.js
/* harmony import */ var NavbarBrand___WEBPACK_IMPORTED_MODULE_2_react__ = __webpack_require__(71);
/* harmony import */ var NavbarBrand___WEBPACK_IMPORTED_MODULE_2_react___default = __webpack_require__.n(NavbarBrand___WEBPACK_IMPORTED_MODULE_2_react__);
/* harmony import */ var NavbarBrand___WEBPACK_IMPORTED_MODULE_3_prop_types__ = __webpack_require__(890);
/* harmony import */ var NavbarBrand___WEBPACK_IMPORTED_MODULE_3_prop_types___default = __webpack_require__.n(NavbarBrand___WEBPACK_IMPORTED_MODULE_3_prop_types__);
/* harmony import */ var NavbarBrand___WEBPACK_IMPORTED_MODULE_4_classnames__ = __webpack_require__(891);
/* harmony import */ var NavbarBrand___WEBPACK_IMPORTED_MODULE_4_classnames___default = __webpack_require__.n(NavbarBrand___WEBPACK_IMPORTED_MODULE_4_classnames__);






var NavbarBrand_propTypes = {
  tag: tagPropType,
  className: NavbarBrand___WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.string,
  cssModule: NavbarBrand___WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.object
};
var NavbarBrand_defaultProps = {
  tag: 'a'
};

var NavbarBrand_NavbarBrand = function NavbarBrand(props) {
  var className = props.className,
      cssModule = props.cssModule,
      Tag = props.tag,
      attributes = _objectWithoutPropertiesLoose(props, ["className", "cssModule", "tag"]);

  var classes = mapToCssModules(NavbarBrand___WEBPACK_IMPORTED_MODULE_4_classnames___default()(className, 'navbar-brand'), cssModule);
  return NavbarBrand___WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(Tag, _extends({}, attributes, {
    className: classes
  }));
};

NavbarBrand_NavbarBrand.propTypes = NavbarBrand_propTypes;
NavbarBrand_NavbarBrand.defaultProps = NavbarBrand_defaultProps;
/* harmony default export */ var NavbarBrand_defaultExport = (NavbarBrand_NavbarBrand);
// CONCATENATED MODULE: ./node_modules/reactstrap/es/NavbarToggler.js
/* harmony import */ var NavbarToggler___WEBPACK_IMPORTED_MODULE_2_react__ = __webpack_require__(71);
/* harmony import */ var NavbarToggler___WEBPACK_IMPORTED_MODULE_2_react___default = __webpack_require__.n(NavbarToggler___WEBPACK_IMPORTED_MODULE_2_react__);
/* harmony import */ var NavbarToggler___WEBPACK_IMPORTED_MODULE_3_prop_types__ = __webpack_require__(890);
/* harmony import */ var NavbarToggler___WEBPACK_IMPORTED_MODULE_3_prop_types___default = __webpack_require__.n(NavbarToggler___WEBPACK_IMPORTED_MODULE_3_prop_types__);
/* harmony import */ var NavbarToggler___WEBPACK_IMPORTED_MODULE_4_classnames__ = __webpack_require__(891);
/* harmony import */ var NavbarToggler___WEBPACK_IMPORTED_MODULE_4_classnames___default = __webpack_require__.n(NavbarToggler___WEBPACK_IMPORTED_MODULE_4_classnames__);






var NavbarToggler_propTypes = {
  tag: tagPropType,
  type: NavbarToggler___WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.string,
  className: NavbarToggler___WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.string,
  cssModule: NavbarToggler___WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.object,
  children: NavbarToggler___WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.node
};
var NavbarToggler_defaultProps = {
  tag: 'button',
  type: 'button'
};

var NavbarToggler_NavbarToggler = function NavbarToggler(props) {
  var className = props.className,
      cssModule = props.cssModule,
      children = props.children,
      Tag = props.tag,
      attributes = _objectWithoutPropertiesLoose(props, ["className", "cssModule", "children", "tag"]);

  var classes = mapToCssModules(NavbarToggler___WEBPACK_IMPORTED_MODULE_4_classnames___default()(className, 'navbar-toggler'), cssModule);
  return NavbarToggler___WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(Tag, _extends({}, attributes, {
    className: classes
  }), children || NavbarToggler___WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement("span", {
    className: mapToCssModules('navbar-toggler-icon', cssModule)
  }));
};

NavbarToggler_NavbarToggler.propTypes = NavbarToggler_propTypes;
NavbarToggler_NavbarToggler.defaultProps = NavbarToggler_defaultProps;
/* harmony default export */ var NavbarToggler_defaultExport = (NavbarToggler_NavbarToggler);
// CONCATENATED MODULE: ./node_modules/reactstrap/es/Nav.js
/* harmony import */ var Nav___WEBPACK_IMPORTED_MODULE_2_react__ = __webpack_require__(71);
/* harmony import */ var Nav___WEBPACK_IMPORTED_MODULE_2_react___default = __webpack_require__.n(Nav___WEBPACK_IMPORTED_MODULE_2_react__);
/* harmony import */ var Nav___WEBPACK_IMPORTED_MODULE_3_prop_types__ = __webpack_require__(890);
/* harmony import */ var Nav___WEBPACK_IMPORTED_MODULE_3_prop_types___default = __webpack_require__.n(Nav___WEBPACK_IMPORTED_MODULE_3_prop_types__);
/* harmony import */ var Nav___WEBPACK_IMPORTED_MODULE_4_classnames__ = __webpack_require__(891);
/* harmony import */ var Nav___WEBPACK_IMPORTED_MODULE_4_classnames___default = __webpack_require__.n(Nav___WEBPACK_IMPORTED_MODULE_4_classnames__);






var Nav_propTypes = {
  tabs: Nav___WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.bool,
  pills: Nav___WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.bool,
  vertical: Nav___WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.oneOfType([Nav___WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.bool, Nav___WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.string]),
  horizontal: Nav___WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.string,
  justified: Nav___WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.bool,
  fill: Nav___WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.bool,
  navbar: Nav___WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.bool,
  card: Nav___WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.bool,
  tag: tagPropType,
  className: Nav___WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.string,
  cssModule: Nav___WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.object
};
var Nav_defaultProps = {
  tag: 'ul',
  vertical: false
};

var getVerticalClass = function getVerticalClass(vertical) {
  if (vertical === false) {
    return false;
  } else if (vertical === true || vertical === 'xs') {
    return 'flex-column';
  }

  return "flex-" + vertical + "-column";
};

var Nav_Nav = function Nav(props) {
  var className = props.className,
      cssModule = props.cssModule,
      tabs = props.tabs,
      pills = props.pills,
      vertical = props.vertical,
      horizontal = props.horizontal,
      justified = props.justified,
      fill = props.fill,
      navbar = props.navbar,
      card = props.card,
      Tag = props.tag,
      attributes = _objectWithoutPropertiesLoose(props, ["className", "cssModule", "tabs", "pills", "vertical", "horizontal", "justified", "fill", "navbar", "card", "tag"]);

  var classes = mapToCssModules(Nav___WEBPACK_IMPORTED_MODULE_4_classnames___default()(className, navbar ? 'navbar-nav' : 'nav', horizontal ? "justify-content-" + horizontal : false, getVerticalClass(vertical), {
    'nav-tabs': tabs,
    'card-header-tabs': card && tabs,
    'nav-pills': pills,
    'card-header-pills': card && pills,
    'nav-justified': justified,
    'nav-fill': fill
  }), cssModule);
  return Nav___WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(Tag, _extends({}, attributes, {
    className: classes
  }));
};

Nav_Nav.propTypes = Nav_propTypes;
Nav_Nav.defaultProps = Nav_defaultProps;
/* harmony default export */ var Nav_defaultExport = (Nav_Nav);
// CONCATENATED MODULE: ./node_modules/reactstrap/es/NavItem.js
/* harmony import */ var NavItem___WEBPACK_IMPORTED_MODULE_2_react__ = __webpack_require__(71);
/* harmony import */ var NavItem___WEBPACK_IMPORTED_MODULE_2_react___default = __webpack_require__.n(NavItem___WEBPACK_IMPORTED_MODULE_2_react__);
/* harmony import */ var NavItem___WEBPACK_IMPORTED_MODULE_3_prop_types__ = __webpack_require__(890);
/* harmony import */ var NavItem___WEBPACK_IMPORTED_MODULE_3_prop_types___default = __webpack_require__.n(NavItem___WEBPACK_IMPORTED_MODULE_3_prop_types__);
/* harmony import */ var NavItem___WEBPACK_IMPORTED_MODULE_4_classnames__ = __webpack_require__(891);
/* harmony import */ var NavItem___WEBPACK_IMPORTED_MODULE_4_classnames___default = __webpack_require__.n(NavItem___WEBPACK_IMPORTED_MODULE_4_classnames__);






var NavItem_propTypes = {
  tag: tagPropType,
  active: NavItem___WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.bool,
  className: NavItem___WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.string,
  cssModule: NavItem___WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.object
};
var NavItem_defaultProps = {
  tag: 'li'
};

var NavItem_NavItem = function NavItem(props) {
  var className = props.className,
      cssModule = props.cssModule,
      active = props.active,
      Tag = props.tag,
      attributes = _objectWithoutPropertiesLoose(props, ["className", "cssModule", "active", "tag"]);

  var classes = mapToCssModules(NavItem___WEBPACK_IMPORTED_MODULE_4_classnames___default()(className, 'nav-item', active ? 'active' : false), cssModule);
  return NavItem___WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(Tag, _extends({}, attributes, {
    className: classes
  }));
};

NavItem_NavItem.propTypes = NavItem_propTypes;
NavItem_NavItem.defaultProps = NavItem_defaultProps;
/* harmony default export */ var NavItem_defaultExport = (NavItem_NavItem);
// CONCATENATED MODULE: ./node_modules/@babel/runtime/helpers/esm/inheritsLoose.js
function _inheritsLoose(subClass, superClass) {
  subClass.prototype = Object.create(superClass.prototype);
  subClass.prototype.constructor = subClass;
  subClass.__proto__ = superClass;
}
// CONCATENATED MODULE: ./node_modules/@babel/runtime/helpers/esm/assertThisInitialized.js
function _assertThisInitialized(self) {
  if (self === void 0) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }

  return self;
}
// CONCATENATED MODULE: ./node_modules/react-popper/lib/Manager.js
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(71);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var Manager___WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1119);
/* harmony import */ var Manager___WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(Manager___WEBPACK_IMPORTED_MODULE_1_prop_types__);
var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }




var Manager = function (_Component) {
  _inherits(Manager, _Component);

  function Manager() {
    var _ref;

    var _temp, _this, _ret;

    _classCallCheck(this, Manager);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = Manager.__proto__ || Object.getPrototypeOf(Manager)).call.apply(_ref, [this].concat(args))), _this), _this._setTargetNode = function (node) {
      _this._targetNode = node;
    }, _this._getTargetNode = function () {
      return _this._targetNode;
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }

  _createClass(Manager, [{
    key: 'getChildContext',
    value: function getChildContext() {
      return {
        popperManager: {
          setTargetNode: this._setTargetNode,
          getTargetNode: this._getTargetNode
        }
      };
    }
  }, {
    key: 'render',
    value: function render() {
      var _props = this.props,
          tag = _props.tag,
          children = _props.children,
          restProps = _objectWithoutProperties(_props, ['tag', 'children']);

      if (tag !== false) {
        return Object(__WEBPACK_IMPORTED_MODULE_0_react__["createElement"])(tag, restProps, children);
      } else {
        return children;
      }
    }
  }]);

  return Manager;
}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);

Manager.childContextTypes = {
  popperManager: Manager___WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object.isRequired
};
Manager.propTypes = {
  tag: Manager___WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.oneOfType([Manager___WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string, Manager___WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool]),
  children: Manager___WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.oneOfType([Manager___WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.node, Manager___WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func])
};
Manager.defaultProps = {
  tag: 'div'
};


/* harmony default export */ var Manager_defaultExport = (Manager);
// CONCATENATED MODULE: ./node_modules/react-popper/lib/Target.js
/* harmony import */ var Target___WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(71);
/* harmony import */ var Target___WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(Target___WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var Target___WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1119);
/* harmony import */ var Target___WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(Target___WEBPACK_IMPORTED_MODULE_1_prop_types__);
var Target__extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function Target__objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }




var Target = function Target(props, context) {
  var _props$component = props.component,
      component = _props$component === undefined ? 'div' : _props$component,
      innerRef = props.innerRef,
      children = props.children,
      restProps = Target__objectWithoutProperties(props, ['component', 'innerRef', 'children']);

  var popperManager = context.popperManager;

  var targetRef = function targetRef(node) {
    popperManager.setTargetNode(node);
    if (typeof innerRef === 'function') {
      innerRef(node);
    }
  };

  if (typeof children === 'function') {
    var targetProps = { ref: targetRef };
    return children({ targetProps: targetProps, restProps: restProps });
  }

  var componentProps = Target__extends({}, restProps);

  if (typeof component === 'string') {
    componentProps.ref = targetRef;
  } else {
    componentProps.innerRef = targetRef;
  }

  return Object(Target___WEBPACK_IMPORTED_MODULE_0_react__["createElement"])(component, componentProps, children);
};

Target.contextTypes = {
  popperManager: Target___WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object.isRequired
};

Target.propTypes = {
  component: Target___WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.oneOfType([Target___WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.node, Target___WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func]),
  innerRef: Target___WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func,
  children: Target___WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.oneOfType([Target___WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.node, Target___WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func])
};

/* harmony default export */ var Target_defaultExport = (Target);
// CONCATENATED MODULE: ./node_modules/react-popper/lib/Popper.js
/* harmony import */ var Popper___WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(71);
/* harmony import */ var Popper___WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(Popper___WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var Popper___WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1119);
/* harmony import */ var Popper___WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(Popper___WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_popper_js__ = __webpack_require__(1210);
var Popper__extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var Popper__createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function Popper__objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

function Popper__classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function Popper__possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function Popper__inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }





var placements = __WEBPACK_IMPORTED_MODULE_2_popper_js__["a" /* default */].placements;

var Popper = function (_Component) {
  Popper__inherits(Popper, _Component);

  function Popper() {
    var _ref;

    var _temp, _this, _ret;

    Popper__classCallCheck(this, Popper);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = Popper__possibleConstructorReturn(this, (_ref = Popper.__proto__ || Object.getPrototypeOf(Popper)).call.apply(_ref, [this].concat(args))), _this), _this.state = {}, _this._setArrowNode = function (node) {
      _this._arrowNode = node;
    }, _this._getTargetNode = function () {
      if (_this.props.target) {
        return _this.props.target;
      } else if (!_this.context.popperManager || !_this.context.popperManager.getTargetNode()) {
        throw new Error('Target missing. Popper must be given a target from the Popper Manager, or as a prop.');
      }
      return _this.context.popperManager.getTargetNode();
    }, _this._getOffsets = function (data) {
      return Object.keys(data.offsets).map(function (key) {
        return data.offsets[key];
      });
    }, _this._isDataDirty = function (data) {
      if (_this.state.data) {
        return JSON.stringify(_this._getOffsets(_this.state.data)) !== JSON.stringify(_this._getOffsets(data));
      } else {
        return true;
      }
    }, _this._updateStateModifier = {
      enabled: true,
      order: 900,
      fn: function fn(data) {
        if (_this._isDataDirty(data)) {
          _this.setState({ data: data });
        }
        return data;
      }
    }, _this._getPopperStyle = function () {
      var data = _this.state.data;


      if (!_this._popper || !data) {
        return {
          position: 'absolute',
          pointerEvents: 'none',
          opacity: 0
        };
      }

      return Popper__extends({
        position: data.offsets.popper.position
      }, data.styles);
    }, _this._getPopperPlacement = function () {
      return _this.state.data ? _this.state.data.placement : undefined;
    }, _this._getPopperHide = function () {
      return !!_this.state.data && _this.state.data.hide ? '' : undefined;
    }, _this._getArrowStyle = function () {
      if (!_this.state.data || !_this.state.data.offsets.arrow) {
        return {};
      } else {
        var _this$state$data$offs = _this.state.data.offsets.arrow,
            top = _this$state$data$offs.top,
            left = _this$state$data$offs.left;

        return { top: top, left: left };
      }
    }, _this._handlePopperRef = function (node) {
      _this._popperNode = node;
      if (node) {
        _this._createPopper();
      } else {
        _this._destroyPopper();
      }
      if (_this.props.innerRef) {
        _this.props.innerRef(node);
      }
    }, _this._scheduleUpdate = function () {
      _this._popper && _this._popper.scheduleUpdate();
    }, _temp), Popper__possibleConstructorReturn(_this, _ret);
  }

  Popper__createClass(Popper, [{
    key: 'getChildContext',
    value: function getChildContext() {
      return {
        popper: {
          setArrowNode: this._setArrowNode,
          getArrowStyle: this._getArrowStyle
        }
      };
    }
  }, {
    key: 'componentDidUpdate',
    value: function componentDidUpdate(lastProps) {
      if (lastProps.placement !== this.props.placement || lastProps.eventsEnabled !== this.props.eventsEnabled || lastProps.target !== this.props.target) {
        this._destroyPopper();
        this._createPopper();
      }
      if (lastProps.children !== this.props.children) {
        this._scheduleUpdate();
      }
    }
  }, {
    key: 'componentWillUnmount',
    value: function componentWillUnmount() {
      this._destroyPopper();
    }
  }, {
    key: '_createPopper',
    value: function _createPopper() {
      var _this2 = this;

      var _props = this.props,
          placement = _props.placement,
          eventsEnabled = _props.eventsEnabled,
          positionFixed = _props.positionFixed;

      var modifiers = Popper__extends({}, this.props.modifiers, {
        applyStyle: { enabled: false },
        updateState: this._updateStateModifier
      });
      if (this._arrowNode) {
        modifiers.arrow = Popper__extends({}, this.props.modifiers.arrow || {}, {
          element: this._arrowNode
        });
      }
      this._popper = new __WEBPACK_IMPORTED_MODULE_2_popper_js__["a" /* default */](this._getTargetNode(), this._popperNode, {
        placement: placement,
        positionFixed: positionFixed,
        eventsEnabled: eventsEnabled,
        modifiers: modifiers
      });

      // TODO: look into setTimeout scheduleUpdate call, without it, the popper will not position properly on creation
      setTimeout(function () {
        return _this2._scheduleUpdate();
      });
    }
  }, {
    key: '_destroyPopper',
    value: function _destroyPopper() {
      if (this._popper) {
        this._popper.destroy();
      }
    }
  }, {
    key: 'render',
    value: function render() {
      var _props2 = this.props,
          component = _props2.component,
          innerRef = _props2.innerRef,
          placement = _props2.placement,
          eventsEnabled = _props2.eventsEnabled,
          positionFixed = _props2.positionFixed,
          modifiers = _props2.modifiers,
          children = _props2.children,
          restProps = Popper__objectWithoutProperties(_props2, ['component', 'innerRef', 'placement', 'eventsEnabled', 'positionFixed', 'modifiers', 'children']);

      var popperStyle = this._getPopperStyle();
      var popperPlacement = this._getPopperPlacement();
      var popperHide = this._getPopperHide();

      if (typeof children === 'function') {
        var popperProps = {
          ref: this._handlePopperRef,
          style: popperStyle,
          'data-placement': popperPlacement,
          'data-x-out-of-boundaries': popperHide
        };
        return children({
          popperProps: popperProps,
          restProps: restProps,
          scheduleUpdate: this._scheduleUpdate
        });
      }

      var componentProps = Popper__extends({}, restProps, {
        style: Popper__extends({}, restProps.style, popperStyle),
        'data-placement': popperPlacement,
        'data-x-out-of-boundaries': popperHide
      });

      if (typeof component === 'string') {
        componentProps.ref = this._handlePopperRef;
      } else {
        componentProps.innerRef = this._handlePopperRef;
      }

      return Object(Popper___WEBPACK_IMPORTED_MODULE_0_react__["createElement"])(component, componentProps, children);
    }
  }]);

  return Popper;
}(Popper___WEBPACK_IMPORTED_MODULE_0_react__["Component"]);

Popper.contextTypes = {
  popperManager: Popper___WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object
};
Popper.childContextTypes = {
  popper: Popper___WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object.isRequired
};
Popper.propTypes = {
  component: Popper___WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.oneOfType([Popper___WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.node, Popper___WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func]),
  innerRef: Popper___WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func,
  placement: Popper___WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.oneOf(placements),
  eventsEnabled: Popper___WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
  positionFixed: Popper___WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
  modifiers: Popper___WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object,
  children: Popper___WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.oneOfType([Popper___WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.node, Popper___WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func]),
  target: Popper___WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.oneOfType([
  // the following check is needed for SSR
  Popper___WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.instanceOf(typeof Element !== 'undefined' ? Element : Object), Popper___WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.shape({
    getBoundingClientRect: Popper___WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired,
    clientWidth: Popper___WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.number.isRequired,
    clientHeight: Popper___WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.number.isRequired
  })])
};
Popper.defaultProps = {
  component: 'div',
  placement: 'bottom',
  eventsEnabled: true,
  positionFixed: false,
  modifiers: {}
};


/* harmony default export */ var Popper_defaultExport = (Popper);
// CONCATENATED MODULE: ./node_modules/react-popper/lib/Arrow.js
/* harmony import */ var Arrow___WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(71);
/* harmony import */ var Arrow___WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(Arrow___WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var Arrow___WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1119);
/* harmony import */ var Arrow___WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(Arrow___WEBPACK_IMPORTED_MODULE_1_prop_types__);
var Arrow__extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function Arrow__objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }




var Arrow = function Arrow(props, context) {
  var _props$component = props.component,
      component = _props$component === undefined ? 'span' : _props$component,
      innerRef = props.innerRef,
      children = props.children,
      restProps = Arrow__objectWithoutProperties(props, ['component', 'innerRef', 'children']);

  var popper = context.popper;

  var arrowRef = function arrowRef(node) {
    popper.setArrowNode(node);
    if (typeof innerRef === 'function') {
      innerRef(node);
    }
  };
  var arrowStyle = popper.getArrowStyle();

  if (typeof children === 'function') {
    var arrowProps = {
      ref: arrowRef,
      style: arrowStyle
    };
    return children({ arrowProps: arrowProps, restProps: restProps });
  }

  var componentProps = Arrow__extends({}, restProps, {
    style: Arrow__extends({}, arrowStyle, restProps.style)
  });

  if (typeof component === 'string') {
    componentProps.ref = arrowRef;
  } else {
    componentProps.innerRef = arrowRef;
  }

  return Object(Arrow___WEBPACK_IMPORTED_MODULE_0_react__["createElement"])(component, componentProps, children);
};

Arrow.contextTypes = {
  popper: Arrow___WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object.isRequired
};

Arrow.propTypes = {
  component: Arrow___WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.oneOfType([Arrow___WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.node, Arrow___WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func]),
  innerRef: Arrow___WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func,
  children: Arrow___WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.oneOfType([Arrow___WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.node, Arrow___WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func])
};

/* harmony default export */ var Arrow_defaultExport = (Arrow);
// CONCATENATED MODULE: ./node_modules/react-popper/lib/react-popper.js




// CONCATENATED MODULE: ./node_modules/reactstrap/es/Dropdown.js
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react__ = __webpack_require__(71);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_prop_types__ = __webpack_require__(890);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react_dom__ = __webpack_require__(420);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react_dom___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_react_dom__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_classnames__ = __webpack_require__(891);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_classnames__);





/* eslint react/no-find-dom-node: 0 */
// https://github.com/yannickcr/eslint-plugin-react/blob/master/docs/rules/no-find-dom-node.md






var Dropdown_propTypes = {
  disabled: __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.bool,
  dropup: deprecated(__WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.bool, 'Please use the prop "direction" with the value "up".'),
  direction: __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.oneOf(['up', 'down', 'left', 'right']),
  group: __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.bool,
  isOpen: __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.bool,
  nav: __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.bool,
  active: __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.bool,
  addonType: __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.bool, __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.oneOf(['prepend', 'append'])]),
  size: __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.string,
  tag: tagPropType,
  toggle: __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.func,
  children: __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.node,
  className: __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.string,
  cssModule: __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.object,
  inNavbar: __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.bool,
  setActiveFromChild: __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.bool
};
var Dropdown_defaultProps = {
  isOpen: false,
  direction: 'down',
  nav: false,
  active: false,
  addonType: false,
  inNavbar: false,
  setActiveFromChild: false
};
var childContextTypes = {
  toggle: __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.func.isRequired,
  isOpen: __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.bool.isRequired,
  direction: __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.oneOf(['up', 'down', 'left', 'right']).isRequired,
  inNavbar: __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.bool.isRequired
};

var Dropdown_Dropdown =
/*#__PURE__*/
function (_React$Component) {
  _inheritsLoose(Dropdown, _React$Component);

  function Dropdown(props) {
    var _this;

    _this = _React$Component.call(this, props) || this;
    _this.addEvents = _this.addEvents.bind(_assertThisInitialized(_assertThisInitialized(_this)));
    _this.handleDocumentClick = _this.handleDocumentClick.bind(_assertThisInitialized(_assertThisInitialized(_this)));
    _this.handleKeyDown = _this.handleKeyDown.bind(_assertThisInitialized(_assertThisInitialized(_this)));
    _this.removeEvents = _this.removeEvents.bind(_assertThisInitialized(_assertThisInitialized(_this)));
    _this.toggle = _this.toggle.bind(_assertThisInitialized(_assertThisInitialized(_this)));
    return _this;
  }

  var _proto = Dropdown.prototype;

  _proto.getChildContext = function getChildContext() {
    return {
      toggle: this.props.toggle,
      isOpen: this.props.isOpen,
      direction: this.props.direction === 'down' && this.props.dropup ? 'up' : this.props.direction,
      inNavbar: this.props.inNavbar
    };
  };

  _proto.componentDidMount = function componentDidMount() {
    this.handleProps();
  };

  _proto.componentDidUpdate = function componentDidUpdate(prevProps) {
    if (this.props.isOpen !== prevProps.isOpen) {
      this.handleProps();
    }
  };

  _proto.componentWillUnmount = function componentWillUnmount() {
    this.removeEvents();
  };

  _proto.getContainer = function getContainer() {
    if (this._$container) return this._$container;
    this._$container = __WEBPACK_IMPORTED_MODULE_6_react_dom___default.a.findDOMNode(this);
    return __WEBPACK_IMPORTED_MODULE_6_react_dom___default.a.findDOMNode(this);
  };

  _proto.getMenuCtrl = function getMenuCtrl() {
    if (this._$menuCtrl) return this._$menuCtrl;
    this._$menuCtrl = this.getContainer().querySelector('[aria-expanded]');
    return this._$menuCtrl;
  };

  _proto.getMenuItems = function getMenuItems() {
    return [].slice.call(this.getContainer().querySelectorAll('[role="menuitem"]'));
  };

  _proto.addEvents = function addEvents() {
    var _this2 = this;

    ['click', 'touchstart', 'keyup'].forEach(function (event) {
      return document.addEventListener(event, _this2.handleDocumentClick, true);
    });
  };

  _proto.removeEvents = function removeEvents() {
    var _this3 = this;

    ['click', 'touchstart', 'keyup'].forEach(function (event) {
      return document.removeEventListener(event, _this3.handleDocumentClick, true);
    });
  };

  _proto.handleDocumentClick = function handleDocumentClick(e) {
    if (e && (e.which === 3 || e.type === 'keyup' && e.which !== keyCodes.tab)) return;
    var container = this.getContainer();

    if (container.contains(e.target) && container !== e.target && (e.type !== 'keyup' || e.which === keyCodes.tab)) {
      return;
    }

    this.toggle(e);
  };

  _proto.handleKeyDown = function handleKeyDown(e) {
    var _this4 = this;

    if (/input|textarea/i.test(e.target.tagName) || keyCodes.tab === e.which && e.target.getAttribute('role') !== 'menuitem') {
      return;
    }

    e.preventDefault();
    if (this.props.disabled) return;

    if (this.getMenuCtrl() === e.target) {
      if (!this.props.isOpen && [keyCodes.space, keyCodes.enter, keyCodes.up, keyCodes.down].indexOf(e.which) > -1) {
        this.toggle(e);
        setTimeout(function () {
          return _this4.getMenuItems()[0].focus();
        });
      }
    }

    if (this.props.isOpen && e.target.getAttribute('role') === 'menuitem') {
      if ([keyCodes.tab, keyCodes.esc].indexOf(e.which) > -1) {
        this.toggle(e);
        this.getMenuCtrl().focus();
      } else if ([keyCodes.space, keyCodes.enter].indexOf(e.which) > -1) {
        e.target.click();
        this.getMenuCtrl().focus();
      } else if ([keyCodes.down, keyCodes.up].indexOf(e.which) > -1 || [keyCodes.n, keyCodes.p].indexOf(e.which) > -1 && e.ctrlKey) {
        var $menuitems = this.getMenuItems();
        var index = $menuitems.indexOf(e.target);

        if (keyCodes.up === e.which || keyCodes.p === e.which && e.ctrlKey) {
          index = index !== 0 ? index - 1 : $menuitems.length - 1;
        } else if (keyCodes.down === e.which || keyCodes.n === e.which && e.ctrlKey) {
          index = index === $menuitems.length - 1 ? 0 : index + 1;
        }

        $menuitems[index].focus();
      } else if (keyCodes.end === e.which) {
        var _$menuitems = this.getMenuItems();

        _$menuitems[_$menuitems.length - 1].focus();
      } else if (keyCodes.home === e.which) {
        var _$menuitems2 = this.getMenuItems();

        _$menuitems2[0].focus();
      } else if (e.which >= 48 && e.which <= 90) {
        var _$menuitems3 = this.getMenuItems();

        var charPressed = String.fromCharCode(e.which).toLowerCase();

        for (var i = 0; i < _$menuitems3.length; i += 1) {
          var firstLetter = _$menuitems3[i].textContent && _$menuitems3[i].textContent[0].toLowerCase();

          if (firstLetter === charPressed) {
            _$menuitems3[i].focus();

            break;
          }
        }
      }
    }
  };

  _proto.handleProps = function handleProps() {
    if (this.props.isOpen) {
      this.addEvents();
    } else {
      this.removeEvents();
    }
  };

  _proto.toggle = function toggle(e) {
    if (this.props.disabled) {
      return e && e.preventDefault();
    }

    return this.props.toggle(e);
  };

  _proto.render = function render() {
    var _classNames;

    var _omit = omit(this.props, ['toggle', 'disabled', 'inNavbar', 'direction']),
        className = _omit.className,
        cssModule = _omit.cssModule,
        dropup = _omit.dropup,
        isOpen = _omit.isOpen,
        group = _omit.group,
        size = _omit.size,
        nav = _omit.nav,
        setActiveFromChild = _omit.setActiveFromChild,
        active = _omit.active,
        addonType = _omit.addonType,
        attrs = _objectWithoutPropertiesLoose(_omit, ["className", "cssModule", "dropup", "isOpen", "group", "size", "nav", "setActiveFromChild", "active", "addonType"]);

    var direction = this.props.direction === 'down' && dropup ? 'up' : this.props.direction;
    attrs.tag = attrs.tag || (nav ? 'li' : 'div');
    var subItemIsActive = false;

    if (setActiveFromChild) {
      __WEBPACK_IMPORTED_MODULE_4_react___default.a.Children.map(this.props.children[1].props.children, function (dropdownItem) {
        if (dropdownItem && dropdownItem.props.active) subItemIsActive = true;
      });
    }

    var classes = mapToCssModules(__WEBPACK_IMPORTED_MODULE_8_classnames___default()(className, direction !== 'down' && "drop" + direction, nav && active ? 'active' : false, setActiveFromChild && subItemIsActive ? 'active' : false, (_classNames = {}, _classNames["input-group-" + addonType] = addonType, _classNames['btn-group'] = group, _classNames["btn-group-" + size] = !!size, _classNames.dropdown = !group && !addonType, _classNames.show = isOpen, _classNames['nav-item'] = nav, _classNames)), cssModule);
    return __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(Manager_defaultExport, _extends({}, attrs, {
      className: classes,
      onKeyDown: this.handleKeyDown
    }));
  };

  return Dropdown;
}(__WEBPACK_IMPORTED_MODULE_4_react___default.a.Component);

Dropdown_Dropdown.propTypes = Dropdown_propTypes;
Dropdown_Dropdown.defaultProps = Dropdown_defaultProps;
Dropdown_Dropdown.childContextTypes = childContextTypes;
/* harmony default export */ var Dropdown_defaultExport = (Dropdown_Dropdown);
// CONCATENATED MODULE: ./node_modules/reactstrap/es/NavDropdown.js
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__(71);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);




function NavDropdown(props) {
  warnOnce('The "NavDropdown" component has been deprecated.\nPlease use component "Dropdown" with nav prop.');
  return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(Dropdown_defaultExport, _extends({
    nav: true
  }, props));
}
// CONCATENATED MODULE: ./node_modules/reactstrap/es/NavLink.js
/* harmony import */ var NavLink___WEBPACK_IMPORTED_MODULE_4_react__ = __webpack_require__(71);
/* harmony import */ var NavLink___WEBPACK_IMPORTED_MODULE_4_react___default = __webpack_require__.n(NavLink___WEBPACK_IMPORTED_MODULE_4_react__);
/* harmony import */ var NavLink___WEBPACK_IMPORTED_MODULE_5_prop_types__ = __webpack_require__(890);
/* harmony import */ var NavLink___WEBPACK_IMPORTED_MODULE_5_prop_types___default = __webpack_require__.n(NavLink___WEBPACK_IMPORTED_MODULE_5_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_classnames__ = __webpack_require__(891);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_classnames__);








var NavLink_propTypes = {
  tag: tagPropType,
  innerRef: NavLink___WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.oneOfType([NavLink___WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.object, NavLink___WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.func, NavLink___WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.string]),
  disabled: NavLink___WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.bool,
  active: NavLink___WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.bool,
  className: NavLink___WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.string,
  cssModule: NavLink___WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.object,
  onClick: NavLink___WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.func,
  href: NavLink___WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.any
};
var NavLink_defaultProps = {
  tag: 'a'
};

var NavLink_NavLink =
/*#__PURE__*/
function (_React$Component) {
  _inheritsLoose(NavLink, _React$Component);

  function NavLink(props) {
    var _this;

    _this = _React$Component.call(this, props) || this;
    _this.onClick = _this.onClick.bind(_assertThisInitialized(_assertThisInitialized(_this)));
    return _this;
  }

  var _proto = NavLink.prototype;

  _proto.onClick = function onClick(e) {
    if (this.props.disabled) {
      e.preventDefault();
      return;
    }

    if (this.props.href === '#') {
      e.preventDefault();
    }

    if (this.props.onClick) {
      this.props.onClick(e);
    }
  };

  _proto.render = function render() {
    var _this$props = this.props,
        className = _this$props.className,
        cssModule = _this$props.cssModule,
        active = _this$props.active,
        Tag = _this$props.tag,
        innerRef = _this$props.innerRef,
        attributes = _objectWithoutPropertiesLoose(_this$props, ["className", "cssModule", "active", "tag", "innerRef"]);

    var classes = mapToCssModules(__WEBPACK_IMPORTED_MODULE_6_classnames___default()(className, 'nav-link', {
      disabled: attributes.disabled,
      active: active
    }), cssModule);
    return NavLink___WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(Tag, _extends({}, attributes, {
      ref: innerRef,
      onClick: this.onClick,
      className: classes
    }));
  };

  return NavLink;
}(NavLink___WEBPACK_IMPORTED_MODULE_4_react___default.a.Component);

NavLink_NavLink.propTypes = NavLink_propTypes;
NavLink_NavLink.defaultProps = NavLink_defaultProps;
/* harmony default export */ var NavLink_defaultExport = (NavLink_NavLink);
// CONCATENATED MODULE: ./node_modules/reactstrap/es/Breadcrumb.js
/* harmony import */ var Breadcrumb___WEBPACK_IMPORTED_MODULE_2_react__ = __webpack_require__(71);
/* harmony import */ var Breadcrumb___WEBPACK_IMPORTED_MODULE_2_react___default = __webpack_require__.n(Breadcrumb___WEBPACK_IMPORTED_MODULE_2_react__);
/* harmony import */ var Breadcrumb___WEBPACK_IMPORTED_MODULE_3_prop_types__ = __webpack_require__(890);
/* harmony import */ var Breadcrumb___WEBPACK_IMPORTED_MODULE_3_prop_types___default = __webpack_require__.n(Breadcrumb___WEBPACK_IMPORTED_MODULE_3_prop_types__);
/* harmony import */ var Breadcrumb___WEBPACK_IMPORTED_MODULE_4_classnames__ = __webpack_require__(891);
/* harmony import */ var Breadcrumb___WEBPACK_IMPORTED_MODULE_4_classnames___default = __webpack_require__.n(Breadcrumb___WEBPACK_IMPORTED_MODULE_4_classnames__);






var Breadcrumb_propTypes = {
  tag: tagPropType,
  listTag: tagPropType,
  className: Breadcrumb___WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.string,
  listClassName: Breadcrumb___WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.string,
  cssModule: Breadcrumb___WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.object,
  children: Breadcrumb___WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.node,
  'aria-label': Breadcrumb___WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.string
};
var Breadcrumb_defaultProps = {
  tag: 'nav',
  listTag: 'ol',
  'aria-label': 'breadcrumb'
};

var Breadcrumb_Breadcrumb = function Breadcrumb(props) {
  var className = props.className,
      listClassName = props.listClassName,
      cssModule = props.cssModule,
      children = props.children,
      Tag = props.tag,
      ListTag = props.listTag,
      label = props['aria-label'],
      attributes = _objectWithoutPropertiesLoose(props, ["className", "listClassName", "cssModule", "children", "tag", "listTag", "aria-label"]);

  var classes = mapToCssModules(Breadcrumb___WEBPACK_IMPORTED_MODULE_4_classnames___default()(className), cssModule);
  var listClasses = mapToCssModules(Breadcrumb___WEBPACK_IMPORTED_MODULE_4_classnames___default()('breadcrumb', listClassName), cssModule);
  return Breadcrumb___WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(Tag, _extends({}, attributes, {
    className: classes,
    "aria-label": label
  }), Breadcrumb___WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(ListTag, {
    className: listClasses
  }, children));
};

Breadcrumb_Breadcrumb.propTypes = Breadcrumb_propTypes;
Breadcrumb_Breadcrumb.defaultProps = Breadcrumb_defaultProps;
/* harmony default export */ var Breadcrumb_defaultExport = (Breadcrumb_Breadcrumb);
// CONCATENATED MODULE: ./node_modules/reactstrap/es/BreadcrumbItem.js
/* harmony import */ var BreadcrumbItem___WEBPACK_IMPORTED_MODULE_2_react__ = __webpack_require__(71);
/* harmony import */ var BreadcrumbItem___WEBPACK_IMPORTED_MODULE_2_react___default = __webpack_require__.n(BreadcrumbItem___WEBPACK_IMPORTED_MODULE_2_react__);
/* harmony import */ var BreadcrumbItem___WEBPACK_IMPORTED_MODULE_3_prop_types__ = __webpack_require__(890);
/* harmony import */ var BreadcrumbItem___WEBPACK_IMPORTED_MODULE_3_prop_types___default = __webpack_require__.n(BreadcrumbItem___WEBPACK_IMPORTED_MODULE_3_prop_types__);
/* harmony import */ var BreadcrumbItem___WEBPACK_IMPORTED_MODULE_4_classnames__ = __webpack_require__(891);
/* harmony import */ var BreadcrumbItem___WEBPACK_IMPORTED_MODULE_4_classnames___default = __webpack_require__.n(BreadcrumbItem___WEBPACK_IMPORTED_MODULE_4_classnames__);






var BreadcrumbItem_propTypes = {
  tag: tagPropType,
  active: BreadcrumbItem___WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.bool,
  className: BreadcrumbItem___WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.string,
  cssModule: BreadcrumbItem___WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.object
};
var BreadcrumbItem_defaultProps = {
  tag: 'li'
};

var BreadcrumbItem_BreadcrumbItem = function BreadcrumbItem(props) {
  var className = props.className,
      cssModule = props.cssModule,
      active = props.active,
      Tag = props.tag,
      attributes = _objectWithoutPropertiesLoose(props, ["className", "cssModule", "active", "tag"]);

  var classes = mapToCssModules(BreadcrumbItem___WEBPACK_IMPORTED_MODULE_4_classnames___default()(className, active ? 'active' : false, 'breadcrumb-item'), cssModule);
  return BreadcrumbItem___WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(Tag, _extends({}, attributes, {
    className: classes,
    "aria-current": active ? 'page' : undefined
  }));
};

BreadcrumbItem_BreadcrumbItem.propTypes = BreadcrumbItem_propTypes;
BreadcrumbItem_BreadcrumbItem.defaultProps = BreadcrumbItem_defaultProps;
/* harmony default export */ var BreadcrumbItem_defaultExport = (BreadcrumbItem_BreadcrumbItem);
// CONCATENATED MODULE: ./node_modules/reactstrap/es/Button.js
/* harmony import */ var Button___WEBPACK_IMPORTED_MODULE_4_react__ = __webpack_require__(71);
/* harmony import */ var Button___WEBPACK_IMPORTED_MODULE_4_react___default = __webpack_require__.n(Button___WEBPACK_IMPORTED_MODULE_4_react__);
/* harmony import */ var Button___WEBPACK_IMPORTED_MODULE_5_prop_types__ = __webpack_require__(890);
/* harmony import */ var Button___WEBPACK_IMPORTED_MODULE_5_prop_types___default = __webpack_require__.n(Button___WEBPACK_IMPORTED_MODULE_5_prop_types__);
/* harmony import */ var Button___WEBPACK_IMPORTED_MODULE_6_classnames__ = __webpack_require__(891);
/* harmony import */ var Button___WEBPACK_IMPORTED_MODULE_6_classnames___default = __webpack_require__.n(Button___WEBPACK_IMPORTED_MODULE_6_classnames__);








var Button_propTypes = {
  active: Button___WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.bool,
  'aria-label': Button___WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.string,
  block: Button___WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.bool,
  color: Button___WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.string,
  disabled: Button___WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.bool,
  outline: Button___WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.bool,
  tag: tagPropType,
  innerRef: Button___WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.oneOfType([Button___WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.object, Button___WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.func, Button___WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.string]),
  onClick: Button___WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.func,
  size: Button___WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.string,
  children: Button___WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.node,
  className: Button___WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.string,
  cssModule: Button___WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.object,
  close: Button___WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.bool
};
var Button_defaultProps = {
  color: 'secondary',
  tag: 'button'
};

var Button_Button =
/*#__PURE__*/
function (_React$Component) {
  _inheritsLoose(Button, _React$Component);

  function Button(props) {
    var _this;

    _this = _React$Component.call(this, props) || this;
    _this.onClick = _this.onClick.bind(_assertThisInitialized(_assertThisInitialized(_this)));
    return _this;
  }

  var _proto = Button.prototype;

  _proto.onClick = function onClick(e) {
    if (this.props.disabled) {
      e.preventDefault();
      return;
    }

    if (this.props.onClick) {
      this.props.onClick(e);
    }
  };

  _proto.render = function render() {
    var _this$props = this.props,
        active = _this$props.active,
        ariaLabel = _this$props['aria-label'],
        block = _this$props.block,
        className = _this$props.className,
        close = _this$props.close,
        cssModule = _this$props.cssModule,
        color = _this$props.color,
        outline = _this$props.outline,
        size = _this$props.size,
        Tag = _this$props.tag,
        innerRef = _this$props.innerRef,
        attributes = _objectWithoutPropertiesLoose(_this$props, ["active", "aria-label", "block", "className", "close", "cssModule", "color", "outline", "size", "tag", "innerRef"]);

    if (close && typeof attributes.children === 'undefined') {
      attributes.children = Button___WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement("span", {
        "aria-hidden": true
      }, "\xD7");
    }

    var btnOutlineColor = "btn" + (outline ? '-outline' : '') + "-" + color;
    var classes = mapToCssModules(Button___WEBPACK_IMPORTED_MODULE_6_classnames___default()(className, {
      close: close
    }, close || 'btn', close || btnOutlineColor, size ? "btn-" + size : false, block ? 'btn-block' : false, {
      active: active,
      disabled: this.props.disabled
    }), cssModule);

    if (attributes.href && Tag === 'button') {
      Tag = 'a';
    }

    var defaultAriaLabel = close ? 'Close' : null;
    return Button___WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(Tag, _extends({
      type: Tag === 'button' && attributes.onClick ? 'button' : undefined
    }, attributes, {
      className: classes,
      ref: innerRef,
      onClick: this.onClick,
      "aria-label": ariaLabel || defaultAriaLabel
    }));
  };

  return Button;
}(Button___WEBPACK_IMPORTED_MODULE_4_react___default.a.Component);

Button_Button.propTypes = Button_propTypes;
Button_Button.defaultProps = Button_defaultProps;
/* harmony default export */ var Button_defaultExport = (Button_Button);
// CONCATENATED MODULE: ./node_modules/reactstrap/es/ButtonDropdown.js
/* harmony import */ var ButtonDropdown___WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__(71);
/* harmony import */ var ButtonDropdown___WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(ButtonDropdown___WEBPACK_IMPORTED_MODULE_1_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types__ = __webpack_require__(890);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_prop_types__);




var ButtonDropdown_propTypes = {
  children: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.node
};

var ButtonDropdown_ButtonDropdown = function ButtonDropdown(props) {
  return ButtonDropdown___WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(Dropdown_defaultExport, _extends({
    group: true
  }, props));
};

ButtonDropdown_ButtonDropdown.propTypes = ButtonDropdown_propTypes;
/* harmony default export */ var ButtonDropdown_defaultExport = (ButtonDropdown_ButtonDropdown);
// CONCATENATED MODULE: ./node_modules/reactstrap/es/ButtonGroup.js
/* harmony import */ var ButtonGroup___WEBPACK_IMPORTED_MODULE_2_react__ = __webpack_require__(71);
/* harmony import */ var ButtonGroup___WEBPACK_IMPORTED_MODULE_2_react___default = __webpack_require__.n(ButtonGroup___WEBPACK_IMPORTED_MODULE_2_react__);
/* harmony import */ var ButtonGroup___WEBPACK_IMPORTED_MODULE_3_prop_types__ = __webpack_require__(890);
/* harmony import */ var ButtonGroup___WEBPACK_IMPORTED_MODULE_3_prop_types___default = __webpack_require__.n(ButtonGroup___WEBPACK_IMPORTED_MODULE_3_prop_types__);
/* harmony import */ var ButtonGroup___WEBPACK_IMPORTED_MODULE_4_classnames__ = __webpack_require__(891);
/* harmony import */ var ButtonGroup___WEBPACK_IMPORTED_MODULE_4_classnames___default = __webpack_require__.n(ButtonGroup___WEBPACK_IMPORTED_MODULE_4_classnames__);






var ButtonGroup_propTypes = {
  tag: tagPropType,
  'aria-label': ButtonGroup___WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.string,
  className: ButtonGroup___WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.string,
  cssModule: ButtonGroup___WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.object,
  role: ButtonGroup___WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.string,
  size: ButtonGroup___WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.string,
  vertical: ButtonGroup___WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.bool
};
var ButtonGroup_defaultProps = {
  tag: 'div',
  role: 'group'
};

var ButtonGroup_ButtonGroup = function ButtonGroup(props) {
  var className = props.className,
      cssModule = props.cssModule,
      size = props.size,
      vertical = props.vertical,
      Tag = props.tag,
      attributes = _objectWithoutPropertiesLoose(props, ["className", "cssModule", "size", "vertical", "tag"]);

  var classes = mapToCssModules(ButtonGroup___WEBPACK_IMPORTED_MODULE_4_classnames___default()(className, size ? 'btn-group-' + size : false, vertical ? 'btn-group-vertical' : 'btn-group'), cssModule);
  return ButtonGroup___WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(Tag, _extends({}, attributes, {
    className: classes
  }));
};

ButtonGroup_ButtonGroup.propTypes = ButtonGroup_propTypes;
ButtonGroup_ButtonGroup.defaultProps = ButtonGroup_defaultProps;
/* harmony default export */ var ButtonGroup_defaultExport = (ButtonGroup_ButtonGroup);
// CONCATENATED MODULE: ./node_modules/reactstrap/es/ButtonToolbar.js
/* harmony import */ var ButtonToolbar___WEBPACK_IMPORTED_MODULE_2_react__ = __webpack_require__(71);
/* harmony import */ var ButtonToolbar___WEBPACK_IMPORTED_MODULE_2_react___default = __webpack_require__.n(ButtonToolbar___WEBPACK_IMPORTED_MODULE_2_react__);
/* harmony import */ var ButtonToolbar___WEBPACK_IMPORTED_MODULE_3_prop_types__ = __webpack_require__(890);
/* harmony import */ var ButtonToolbar___WEBPACK_IMPORTED_MODULE_3_prop_types___default = __webpack_require__.n(ButtonToolbar___WEBPACK_IMPORTED_MODULE_3_prop_types__);
/* harmony import */ var ButtonToolbar___WEBPACK_IMPORTED_MODULE_4_classnames__ = __webpack_require__(891);
/* harmony import */ var ButtonToolbar___WEBPACK_IMPORTED_MODULE_4_classnames___default = __webpack_require__.n(ButtonToolbar___WEBPACK_IMPORTED_MODULE_4_classnames__);






var ButtonToolbar_propTypes = {
  tag: tagPropType,
  'aria-label': ButtonToolbar___WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.string,
  className: ButtonToolbar___WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.string,
  cssModule: ButtonToolbar___WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.object,
  role: ButtonToolbar___WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.string
};
var ButtonToolbar_defaultProps = {
  tag: 'div',
  role: 'toolbar'
};

var ButtonToolbar_ButtonToolbar = function ButtonToolbar(props) {
  var className = props.className,
      cssModule = props.cssModule,
      Tag = props.tag,
      attributes = _objectWithoutPropertiesLoose(props, ["className", "cssModule", "tag"]);

  var classes = mapToCssModules(ButtonToolbar___WEBPACK_IMPORTED_MODULE_4_classnames___default()(className, 'btn-toolbar'), cssModule);
  return ButtonToolbar___WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(Tag, _extends({}, attributes, {
    className: classes
  }));
};

ButtonToolbar_ButtonToolbar.propTypes = ButtonToolbar_propTypes;
ButtonToolbar_ButtonToolbar.defaultProps = ButtonToolbar_defaultProps;
/* harmony default export */ var ButtonToolbar_defaultExport = (ButtonToolbar_ButtonToolbar);
// CONCATENATED MODULE: ./node_modules/reactstrap/es/DropdownItem.js
/* harmony import */ var DropdownItem___WEBPACK_IMPORTED_MODULE_4_react__ = __webpack_require__(71);
/* harmony import */ var DropdownItem___WEBPACK_IMPORTED_MODULE_4_react___default = __webpack_require__.n(DropdownItem___WEBPACK_IMPORTED_MODULE_4_react__);
/* harmony import */ var DropdownItem___WEBPACK_IMPORTED_MODULE_5_prop_types__ = __webpack_require__(890);
/* harmony import */ var DropdownItem___WEBPACK_IMPORTED_MODULE_5_prop_types___default = __webpack_require__.n(DropdownItem___WEBPACK_IMPORTED_MODULE_5_prop_types__);
/* harmony import */ var DropdownItem___WEBPACK_IMPORTED_MODULE_6_classnames__ = __webpack_require__(891);
/* harmony import */ var DropdownItem___WEBPACK_IMPORTED_MODULE_6_classnames___default = __webpack_require__.n(DropdownItem___WEBPACK_IMPORTED_MODULE_6_classnames__);








var DropdownItem_propTypes = {
  children: DropdownItem___WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.node,
  active: DropdownItem___WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.bool,
  disabled: DropdownItem___WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.bool,
  divider: DropdownItem___WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.bool,
  tag: tagPropType,
  header: DropdownItem___WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.bool,
  onClick: DropdownItem___WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.func,
  className: DropdownItem___WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.string,
  cssModule: DropdownItem___WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.object,
  toggle: DropdownItem___WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.bool
};
var contextTypes = {
  toggle: DropdownItem___WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.func
};
var DropdownItem_defaultProps = {
  tag: 'button',
  toggle: true
};

var DropdownItem_DropdownItem =
/*#__PURE__*/
function (_React$Component) {
  _inheritsLoose(DropdownItem, _React$Component);

  function DropdownItem(props) {
    var _this;

    _this = _React$Component.call(this, props) || this;
    _this.onClick = _this.onClick.bind(_assertThisInitialized(_assertThisInitialized(_this)));
    _this.getTabIndex = _this.getTabIndex.bind(_assertThisInitialized(_assertThisInitialized(_this)));
    return _this;
  }

  var _proto = DropdownItem.prototype;

  _proto.onClick = function onClick(e) {
    if (this.props.disabled || this.props.header || this.props.divider) {
      e.preventDefault();
      return;
    }

    if (this.props.onClick) {
      this.props.onClick(e);
    }

    if (this.props.toggle) {
      this.context.toggle(e);
    }
  };

  _proto.getTabIndex = function getTabIndex() {
    if (this.props.disabled || this.props.header || this.props.divider) {
      return '-1';
    }

    return '0';
  };

  _proto.render = function render() {
    var tabIndex = this.getTabIndex();
    var role = tabIndex > -1 ? 'menuitem' : undefined;

    var _omit = omit(this.props, ['toggle']),
        className = _omit.className,
        cssModule = _omit.cssModule,
        divider = _omit.divider,
        Tag = _omit.tag,
        header = _omit.header,
        active = _omit.active,
        props = _objectWithoutPropertiesLoose(_omit, ["className", "cssModule", "divider", "tag", "header", "active"]);

    var classes = mapToCssModules(DropdownItem___WEBPACK_IMPORTED_MODULE_6_classnames___default()(className, {
      disabled: props.disabled,
      'dropdown-item': !divider && !header,
      active: active,
      'dropdown-header': header,
      'dropdown-divider': divider
    }), cssModule);

    if (Tag === 'button') {
      if (header) {
        Tag = 'h6';
      } else if (divider) {
        Tag = 'div';
      } else if (props.href) {
        Tag = 'a';
      }
    }

    return DropdownItem___WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(Tag, _extends({
      type: Tag === 'button' && (props.onClick || this.props.toggle) ? 'button' : undefined
    }, props, {
      tabIndex: tabIndex,
      role: role,
      className: classes,
      onClick: this.onClick
    }));
  };

  return DropdownItem;
}(DropdownItem___WEBPACK_IMPORTED_MODULE_4_react___default.a.Component);

DropdownItem_DropdownItem.propTypes = DropdownItem_propTypes;
DropdownItem_DropdownItem.defaultProps = DropdownItem_defaultProps;
DropdownItem_DropdownItem.contextTypes = contextTypes;
/* harmony default export */ var DropdownItem_defaultExport = (DropdownItem_DropdownItem);
// CONCATENATED MODULE: ./node_modules/@babel/runtime/helpers/esm/defineProperty.js
function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
}
// CONCATENATED MODULE: ./node_modules/@babel/runtime/helpers/esm/objectSpread.js

function _objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? arguments[i] : {};
    var ownKeys = Object.keys(source);

    if (typeof Object.getOwnPropertySymbols === 'function') {
      ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function (sym) {
        return Object.getOwnPropertyDescriptor(source, sym).enumerable;
      }));
    }

    ownKeys.forEach(function (key) {
      _defineProperty(target, key, source[key]);
    });
  }

  return target;
}
// CONCATENATED MODULE: ./node_modules/reactstrap/es/DropdownMenu.js
/* harmony import */ var DropdownMenu___WEBPACK_IMPORTED_MODULE_3_react__ = __webpack_require__(71);
/* harmony import */ var DropdownMenu___WEBPACK_IMPORTED_MODULE_3_react___default = __webpack_require__.n(DropdownMenu___WEBPACK_IMPORTED_MODULE_3_react__);
/* harmony import */ var DropdownMenu___WEBPACK_IMPORTED_MODULE_4_prop_types__ = __webpack_require__(890);
/* harmony import */ var DropdownMenu___WEBPACK_IMPORTED_MODULE_4_prop_types___default = __webpack_require__.n(DropdownMenu___WEBPACK_IMPORTED_MODULE_4_prop_types__);
/* harmony import */ var DropdownMenu___WEBPACK_IMPORTED_MODULE_5_classnames__ = __webpack_require__(891);
/* harmony import */ var DropdownMenu___WEBPACK_IMPORTED_MODULE_5_classnames___default = __webpack_require__.n(DropdownMenu___WEBPACK_IMPORTED_MODULE_5_classnames__);








var DropdownMenu_propTypes = {
  tag: tagPropType,
  children: DropdownMenu___WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.node.isRequired,
  right: DropdownMenu___WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.bool,
  flip: DropdownMenu___WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.bool,
  modifiers: DropdownMenu___WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.object,
  className: DropdownMenu___WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.string,
  cssModule: DropdownMenu___WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.object,
  persist: DropdownMenu___WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.bool
};
var DropdownMenu_defaultProps = {
  tag: 'div',
  flip: true
};
var DropdownMenu_contextTypes = {
  isOpen: DropdownMenu___WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.bool.isRequired,
  direction: DropdownMenu___WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.oneOf(['up', 'down', 'left', 'right']).isRequired,
  inNavbar: DropdownMenu___WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.bool.isRequired
};
var noFlipModifier = {
  flip: {
    enabled: false
  }
};
var directionPositionMap = {
  up: 'top',
  left: 'left',
  right: 'right',
  down: 'bottom'
};

var DropdownMenu_DropdownMenu = function DropdownMenu(props, context) {
  var className = props.className,
      cssModule = props.cssModule,
      right = props.right,
      tag = props.tag,
      flip = props.flip,
      modifiers = props.modifiers,
      persist = props.persist,
      attrs = _objectWithoutPropertiesLoose(props, ["className", "cssModule", "right", "tag", "flip", "modifiers", "persist"]);

  var classes = mapToCssModules(DropdownMenu___WEBPACK_IMPORTED_MODULE_5_classnames___default()(className, 'dropdown-menu', {
    'dropdown-menu-right': right,
    show: context.isOpen
  }), cssModule);
  var Tag = tag;

  if (persist || context.isOpen && !context.inNavbar) {
    Tag = Popper_defaultExport;
    var position1 = directionPositionMap[context.direction] || 'bottom';
    var position2 = right ? 'end' : 'start';
    attrs.placement = position1 + "-" + position2;
    attrs.component = tag;
    attrs.modifiers = !flip ? _objectSpread({}, modifiers, noFlipModifier) : modifiers;
  }

  return DropdownMenu___WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(Tag, _extends({
    tabIndex: "-1",
    role: "menu"
  }, attrs, {
    "aria-hidden": !context.isOpen,
    className: classes,
    "x-placement": attrs.placement
  }));
};

DropdownMenu_DropdownMenu.propTypes = DropdownMenu_propTypes;
DropdownMenu_DropdownMenu.defaultProps = DropdownMenu_defaultProps;
DropdownMenu_DropdownMenu.contextTypes = DropdownMenu_contextTypes;
/* harmony default export */ var DropdownMenu_defaultExport = (DropdownMenu_DropdownMenu);
// CONCATENATED MODULE: ./node_modules/reactstrap/es/DropdownToggle.js
/* harmony import */ var DropdownToggle___WEBPACK_IMPORTED_MODULE_4_react__ = __webpack_require__(71);
/* harmony import */ var DropdownToggle___WEBPACK_IMPORTED_MODULE_4_react___default = __webpack_require__.n(DropdownToggle___WEBPACK_IMPORTED_MODULE_4_react__);
/* harmony import */ var DropdownToggle___WEBPACK_IMPORTED_MODULE_5_prop_types__ = __webpack_require__(890);
/* harmony import */ var DropdownToggle___WEBPACK_IMPORTED_MODULE_5_prop_types___default = __webpack_require__.n(DropdownToggle___WEBPACK_IMPORTED_MODULE_5_prop_types__);
/* harmony import */ var DropdownToggle___WEBPACK_IMPORTED_MODULE_6_classnames__ = __webpack_require__(891);
/* harmony import */ var DropdownToggle___WEBPACK_IMPORTED_MODULE_6_classnames___default = __webpack_require__.n(DropdownToggle___WEBPACK_IMPORTED_MODULE_6_classnames__);










var DropdownToggle_propTypes = {
  caret: DropdownToggle___WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.bool,
  color: DropdownToggle___WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.string,
  children: DropdownToggle___WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.node,
  className: DropdownToggle___WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.string,
  cssModule: DropdownToggle___WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.object,
  disabled: DropdownToggle___WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.bool,
  onClick: DropdownToggle___WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.func,
  'aria-haspopup': DropdownToggle___WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.bool,
  split: DropdownToggle___WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.bool,
  tag: tagPropType,
  nav: DropdownToggle___WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.bool
};
var DropdownToggle_defaultProps = {
  'aria-haspopup': true,
  color: 'secondary'
};
var DropdownToggle_contextTypes = {
  isOpen: DropdownToggle___WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.bool.isRequired,
  toggle: DropdownToggle___WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.func.isRequired,
  inNavbar: DropdownToggle___WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.bool.isRequired
};

var DropdownToggle_DropdownToggle =
/*#__PURE__*/
function (_React$Component) {
  _inheritsLoose(DropdownToggle, _React$Component);

  function DropdownToggle(props) {
    var _this;

    _this = _React$Component.call(this, props) || this;
    _this.onClick = _this.onClick.bind(_assertThisInitialized(_assertThisInitialized(_this)));
    return _this;
  }

  var _proto = DropdownToggle.prototype;

  _proto.onClick = function onClick(e) {
    if (this.props.disabled) {
      e.preventDefault();
      return;
    }

    if (this.props.nav && !this.props.tag) {
      e.preventDefault();
    }

    if (this.props.onClick) {
      this.props.onClick(e);
    }

    this.context.toggle(e);
  };

  _proto.render = function render() {
    var _this$props = this.props,
        className = _this$props.className,
        color = _this$props.color,
        cssModule = _this$props.cssModule,
        caret = _this$props.caret,
        split = _this$props.split,
        nav = _this$props.nav,
        tag = _this$props.tag,
        props = _objectWithoutPropertiesLoose(_this$props, ["className", "color", "cssModule", "caret", "split", "nav", "tag"]);

    var ariaLabel = props['aria-label'] || 'Toggle Dropdown';
    var classes = mapToCssModules(DropdownToggle___WEBPACK_IMPORTED_MODULE_6_classnames___default()(className, {
      'dropdown-toggle': caret || split,
      'dropdown-toggle-split': split,
      'nav-link': nav
    }), cssModule);
    var children = props.children || DropdownToggle___WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement("span", {
      className: "sr-only"
    }, ariaLabel);
    var Tag;

    if (nav && !tag) {
      Tag = 'a';
      props.href = '#';
    } else if (!tag) {
      Tag = Button_defaultExport;
      props.color = color;
      props.cssModule = cssModule;
    } else {
      Tag = tag;
    }

    if (this.context.inNavbar) {
      return DropdownToggle___WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(Tag, _extends({}, props, {
        className: classes,
        onClick: this.onClick,
        "aria-expanded": this.context.isOpen,
        children: children
      }));
    }

    return DropdownToggle___WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(Target_defaultExport, _extends({}, props, {
      className: classes,
      component: Tag,
      onClick: this.onClick,
      "aria-expanded": this.context.isOpen,
      children: children
    }));
  };

  return DropdownToggle;
}(DropdownToggle___WEBPACK_IMPORTED_MODULE_4_react___default.a.Component);

DropdownToggle_DropdownToggle.propTypes = DropdownToggle_propTypes;
DropdownToggle_DropdownToggle.defaultProps = DropdownToggle_defaultProps;
DropdownToggle_DropdownToggle.contextTypes = DropdownToggle_contextTypes;
/* harmony default export */ var DropdownToggle_defaultExport = (DropdownToggle_DropdownToggle);
// CONCATENATED MODULE: ./node_modules/reactstrap/es/Fade.js
/* harmony import */ var Fade___WEBPACK_IMPORTED_MODULE_3_react__ = __webpack_require__(71);
/* harmony import */ var Fade___WEBPACK_IMPORTED_MODULE_3_react___default = __webpack_require__.n(Fade___WEBPACK_IMPORTED_MODULE_3_react__);
/* harmony import */ var Fade___WEBPACK_IMPORTED_MODULE_4_prop_types__ = __webpack_require__(890);
/* harmony import */ var Fade___WEBPACK_IMPORTED_MODULE_4_prop_types___default = __webpack_require__.n(Fade___WEBPACK_IMPORTED_MODULE_4_prop_types__);
/* harmony import */ var Fade___WEBPACK_IMPORTED_MODULE_5_classnames__ = __webpack_require__(891);
/* harmony import */ var Fade___WEBPACK_IMPORTED_MODULE_5_classnames___default = __webpack_require__.n(Fade___WEBPACK_IMPORTED_MODULE_5_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react_transition_group__ = __webpack_require__(1121);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react_transition_group___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_react_transition_group__);









var Fade_propTypes = _objectSpread({}, __WEBPACK_IMPORTED_MODULE_6_react_transition_group__["Transition"].propTypes, {
  children: Fade___WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.oneOfType([Fade___WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.arrayOf(Fade___WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.node), Fade___WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.node]),
  tag: tagPropType,
  baseClass: Fade___WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.string,
  baseClassActive: Fade___WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.string,
  className: Fade___WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.string,
  cssModule: Fade___WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.object,
  innerRef: Fade___WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.oneOfType([Fade___WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.object, Fade___WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.string, Fade___WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.func])
});

var Fade_defaultProps = _objectSpread({}, __WEBPACK_IMPORTED_MODULE_6_react_transition_group__["Transition"].defaultProps, {
  tag: 'div',
  baseClass: 'fade',
  baseClassActive: 'show',
  timeout: TransitionTimeouts.Fade,
  appear: true,
  enter: true,
  exit: true,
  in: true
});

function Fade(props) {
  var Tag = props.tag,
      baseClass = props.baseClass,
      baseClassActive = props.baseClassActive,
      className = props.className,
      cssModule = props.cssModule,
      children = props.children,
      innerRef = props.innerRef,
      otherProps = _objectWithoutPropertiesLoose(props, ["tag", "baseClass", "baseClassActive", "className", "cssModule", "children", "innerRef"]);

  var transitionProps = pick(otherProps, TransitionPropTypeKeys);
  var childProps = omit(otherProps, TransitionPropTypeKeys);
  return Fade___WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_react_transition_group__["Transition"], transitionProps, function (status) {
    var isActive = status === 'entered';
    var classes = mapToCssModules(Fade___WEBPACK_IMPORTED_MODULE_5_classnames___default()(className, baseClass, isActive && baseClassActive), cssModule);
    return Fade___WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(Tag, _extends({
      className: classes
    }, childProps, {
      ref: innerRef
    }), children);
  });
}

Fade.propTypes = Fade_propTypes;
Fade.defaultProps = Fade_defaultProps;
/* harmony default export */ var Fade_defaultExport = (Fade);
// CONCATENATED MODULE: ./node_modules/reactstrap/es/Badge.js
/* harmony import */ var Badge___WEBPACK_IMPORTED_MODULE_2_react__ = __webpack_require__(71);
/* harmony import */ var Badge___WEBPACK_IMPORTED_MODULE_2_react___default = __webpack_require__.n(Badge___WEBPACK_IMPORTED_MODULE_2_react__);
/* harmony import */ var Badge___WEBPACK_IMPORTED_MODULE_3_prop_types__ = __webpack_require__(890);
/* harmony import */ var Badge___WEBPACK_IMPORTED_MODULE_3_prop_types___default = __webpack_require__.n(Badge___WEBPACK_IMPORTED_MODULE_3_prop_types__);
/* harmony import */ var Badge___WEBPACK_IMPORTED_MODULE_4_classnames__ = __webpack_require__(891);
/* harmony import */ var Badge___WEBPACK_IMPORTED_MODULE_4_classnames___default = __webpack_require__.n(Badge___WEBPACK_IMPORTED_MODULE_4_classnames__);






var Badge_propTypes = {
  color: Badge___WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.string,
  pill: Badge___WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.bool,
  tag: tagPropType,
  innerRef: Badge___WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.oneOfType([Badge___WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.object, Badge___WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.func, Badge___WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.string]),
  children: Badge___WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.node,
  className: Badge___WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.string,
  cssModule: Badge___WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.object
};
var Badge_defaultProps = {
  color: 'secondary',
  pill: false,
  tag: 'span'
};

var Badge_Badge = function Badge(props) {
  var className = props.className,
      cssModule = props.cssModule,
      color = props.color,
      innerRef = props.innerRef,
      pill = props.pill,
      Tag = props.tag,
      attributes = _objectWithoutPropertiesLoose(props, ["className", "cssModule", "color", "innerRef", "pill", "tag"]);

  var classes = mapToCssModules(Badge___WEBPACK_IMPORTED_MODULE_4_classnames___default()(className, 'badge', 'badge-' + color, pill ? 'badge-pill' : false), cssModule);

  if (attributes.href && Tag === 'span') {
    Tag = 'a';
  }

  return Badge___WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(Tag, _extends({}, attributes, {
    className: classes,
    ref: innerRef
  }));
};

Badge_Badge.propTypes = Badge_propTypes;
Badge_Badge.defaultProps = Badge_defaultProps;
/* harmony default export */ var Badge_defaultExport = (Badge_Badge);
// CONCATENATED MODULE: ./node_modules/reactstrap/es/Card.js
/* harmony import */ var Card___WEBPACK_IMPORTED_MODULE_2_react__ = __webpack_require__(71);
/* harmony import */ var Card___WEBPACK_IMPORTED_MODULE_2_react___default = __webpack_require__.n(Card___WEBPACK_IMPORTED_MODULE_2_react__);
/* harmony import */ var Card___WEBPACK_IMPORTED_MODULE_3_prop_types__ = __webpack_require__(890);
/* harmony import */ var Card___WEBPACK_IMPORTED_MODULE_3_prop_types___default = __webpack_require__.n(Card___WEBPACK_IMPORTED_MODULE_3_prop_types__);
/* harmony import */ var Card___WEBPACK_IMPORTED_MODULE_4_classnames__ = __webpack_require__(891);
/* harmony import */ var Card___WEBPACK_IMPORTED_MODULE_4_classnames___default = __webpack_require__.n(Card___WEBPACK_IMPORTED_MODULE_4_classnames__);






var Card_propTypes = {
  tag: tagPropType,
  inverse: Card___WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.bool,
  color: Card___WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.string,
  block: deprecated(Card___WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.bool, 'Please use the props "body"'),
  body: Card___WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.bool,
  outline: Card___WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.bool,
  className: Card___WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.string,
  cssModule: Card___WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.object,
  innerRef: Card___WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.oneOfType([Card___WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.object, Card___WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.string, Card___WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.func])
};
var Card_defaultProps = {
  tag: 'div'
};

var Card_Card = function Card(props) {
  var className = props.className,
      cssModule = props.cssModule,
      color = props.color,
      block = props.block,
      body = props.body,
      inverse = props.inverse,
      outline = props.outline,
      Tag = props.tag,
      innerRef = props.innerRef,
      attributes = _objectWithoutPropertiesLoose(props, ["className", "cssModule", "color", "block", "body", "inverse", "outline", "tag", "innerRef"]);

  var classes = mapToCssModules(Card___WEBPACK_IMPORTED_MODULE_4_classnames___default()(className, 'card', inverse ? 'text-white' : false, block || body ? 'card-body' : false, color ? (outline ? 'border' : 'bg') + "-" + color : false), cssModule);
  return Card___WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(Tag, _extends({}, attributes, {
    className: classes,
    ref: innerRef
  }));
};

Card_Card.propTypes = Card_propTypes;
Card_Card.defaultProps = Card_defaultProps;
/* harmony default export */ var Card_defaultExport = (Card_Card);
// CONCATENATED MODULE: ./node_modules/reactstrap/es/CardGroup.js
/* harmony import */ var CardGroup___WEBPACK_IMPORTED_MODULE_2_react__ = __webpack_require__(71);
/* harmony import */ var CardGroup___WEBPACK_IMPORTED_MODULE_2_react___default = __webpack_require__.n(CardGroup___WEBPACK_IMPORTED_MODULE_2_react__);
/* harmony import */ var CardGroup___WEBPACK_IMPORTED_MODULE_3_prop_types__ = __webpack_require__(890);
/* harmony import */ var CardGroup___WEBPACK_IMPORTED_MODULE_3_prop_types___default = __webpack_require__.n(CardGroup___WEBPACK_IMPORTED_MODULE_3_prop_types__);
/* harmony import */ var CardGroup___WEBPACK_IMPORTED_MODULE_4_classnames__ = __webpack_require__(891);
/* harmony import */ var CardGroup___WEBPACK_IMPORTED_MODULE_4_classnames___default = __webpack_require__.n(CardGroup___WEBPACK_IMPORTED_MODULE_4_classnames__);






var CardGroup_propTypes = {
  tag: tagPropType,
  className: CardGroup___WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.string,
  cssModule: CardGroup___WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.object
};
var CardGroup_defaultProps = {
  tag: 'div'
};

var CardGroup_CardGroup = function CardGroup(props) {
  var className = props.className,
      cssModule = props.cssModule,
      Tag = props.tag,
      attributes = _objectWithoutPropertiesLoose(props, ["className", "cssModule", "tag"]);

  var classes = mapToCssModules(CardGroup___WEBPACK_IMPORTED_MODULE_4_classnames___default()(className, 'card-group'), cssModule);
  return CardGroup___WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(Tag, _extends({}, attributes, {
    className: classes
  }));
};

CardGroup_CardGroup.propTypes = CardGroup_propTypes;
CardGroup_CardGroup.defaultProps = CardGroup_defaultProps;
/* harmony default export */ var CardGroup_defaultExport = (CardGroup_CardGroup);
// CONCATENATED MODULE: ./node_modules/reactstrap/es/CardDeck.js
/* harmony import */ var CardDeck___WEBPACK_IMPORTED_MODULE_2_react__ = __webpack_require__(71);
/* harmony import */ var CardDeck___WEBPACK_IMPORTED_MODULE_2_react___default = __webpack_require__.n(CardDeck___WEBPACK_IMPORTED_MODULE_2_react__);
/* harmony import */ var CardDeck___WEBPACK_IMPORTED_MODULE_3_prop_types__ = __webpack_require__(890);
/* harmony import */ var CardDeck___WEBPACK_IMPORTED_MODULE_3_prop_types___default = __webpack_require__.n(CardDeck___WEBPACK_IMPORTED_MODULE_3_prop_types__);
/* harmony import */ var CardDeck___WEBPACK_IMPORTED_MODULE_4_classnames__ = __webpack_require__(891);
/* harmony import */ var CardDeck___WEBPACK_IMPORTED_MODULE_4_classnames___default = __webpack_require__.n(CardDeck___WEBPACK_IMPORTED_MODULE_4_classnames__);






var CardDeck_propTypes = {
  tag: tagPropType,
  className: CardDeck___WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.string,
  cssModule: CardDeck___WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.object
};
var CardDeck_defaultProps = {
  tag: 'div'
};

var CardDeck_CardDeck = function CardDeck(props) {
  var className = props.className,
      cssModule = props.cssModule,
      Tag = props.tag,
      attributes = _objectWithoutPropertiesLoose(props, ["className", "cssModule", "tag"]);

  var classes = mapToCssModules(CardDeck___WEBPACK_IMPORTED_MODULE_4_classnames___default()(className, 'card-deck'), cssModule);
  return CardDeck___WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(Tag, _extends({}, attributes, {
    className: classes
  }));
};

CardDeck_CardDeck.propTypes = CardDeck_propTypes;
CardDeck_CardDeck.defaultProps = CardDeck_defaultProps;
/* harmony default export */ var CardDeck_defaultExport = (CardDeck_CardDeck);
// CONCATENATED MODULE: ./node_modules/reactstrap/es/CardColumns.js
/* harmony import */ var CardColumns___WEBPACK_IMPORTED_MODULE_2_react__ = __webpack_require__(71);
/* harmony import */ var CardColumns___WEBPACK_IMPORTED_MODULE_2_react___default = __webpack_require__.n(CardColumns___WEBPACK_IMPORTED_MODULE_2_react__);
/* harmony import */ var CardColumns___WEBPACK_IMPORTED_MODULE_3_prop_types__ = __webpack_require__(890);
/* harmony import */ var CardColumns___WEBPACK_IMPORTED_MODULE_3_prop_types___default = __webpack_require__.n(CardColumns___WEBPACK_IMPORTED_MODULE_3_prop_types__);
/* harmony import */ var CardColumns___WEBPACK_IMPORTED_MODULE_4_classnames__ = __webpack_require__(891);
/* harmony import */ var CardColumns___WEBPACK_IMPORTED_MODULE_4_classnames___default = __webpack_require__.n(CardColumns___WEBPACK_IMPORTED_MODULE_4_classnames__);






var CardColumns_propTypes = {
  tag: tagPropType,
  className: CardColumns___WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.string,
  cssModule: CardColumns___WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.object
};
var CardColumns_defaultProps = {
  tag: 'div'
};

var CardColumns_CardColumns = function CardColumns(props) {
  var className = props.className,
      cssModule = props.cssModule,
      Tag = props.tag,
      attributes = _objectWithoutPropertiesLoose(props, ["className", "cssModule", "tag"]);

  var classes = mapToCssModules(CardColumns___WEBPACK_IMPORTED_MODULE_4_classnames___default()(className, 'card-columns'), cssModule);
  return CardColumns___WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(Tag, _extends({}, attributes, {
    className: classes
  }));
};

CardColumns_CardColumns.propTypes = CardColumns_propTypes;
CardColumns_CardColumns.defaultProps = CardColumns_defaultProps;
/* harmony default export */ var CardColumns_defaultExport = (CardColumns_CardColumns);
// CONCATENATED MODULE: ./node_modules/reactstrap/es/CardBody.js
/* harmony import */ var CardBody___WEBPACK_IMPORTED_MODULE_2_react__ = __webpack_require__(71);
/* harmony import */ var CardBody___WEBPACK_IMPORTED_MODULE_2_react___default = __webpack_require__.n(CardBody___WEBPACK_IMPORTED_MODULE_2_react__);
/* harmony import */ var CardBody___WEBPACK_IMPORTED_MODULE_3_prop_types__ = __webpack_require__(890);
/* harmony import */ var CardBody___WEBPACK_IMPORTED_MODULE_3_prop_types___default = __webpack_require__.n(CardBody___WEBPACK_IMPORTED_MODULE_3_prop_types__);
/* harmony import */ var CardBody___WEBPACK_IMPORTED_MODULE_4_classnames__ = __webpack_require__(891);
/* harmony import */ var CardBody___WEBPACK_IMPORTED_MODULE_4_classnames___default = __webpack_require__.n(CardBody___WEBPACK_IMPORTED_MODULE_4_classnames__);






var CardBody_propTypes = {
  tag: tagPropType,
  className: CardBody___WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.string,
  cssModule: CardBody___WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.object,
  innerRef: CardBody___WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.oneOfType([CardBody___WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.object, CardBody___WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.string, CardBody___WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.func])
};
var CardBody_defaultProps = {
  tag: 'div'
};

var CardBody_CardBody = function CardBody(props) {
  var className = props.className,
      cssModule = props.cssModule,
      innerRef = props.innerRef,
      Tag = props.tag,
      attributes = _objectWithoutPropertiesLoose(props, ["className", "cssModule", "innerRef", "tag"]);

  var classes = mapToCssModules(CardBody___WEBPACK_IMPORTED_MODULE_4_classnames___default()(className, 'card-body'), cssModule);
  return CardBody___WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(Tag, _extends({}, attributes, {
    className: classes,
    ref: innerRef
  }));
};

CardBody_CardBody.propTypes = CardBody_propTypes;
CardBody_CardBody.defaultProps = CardBody_defaultProps;
/* harmony default export */ var CardBody_defaultExport = (CardBody_CardBody);
// CONCATENATED MODULE: ./node_modules/reactstrap/es/CardBlock.js
/* harmony import */ var CardBlock___WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(71);
/* harmony import */ var CardBlock___WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(CardBlock___WEBPACK_IMPORTED_MODULE_0_react__);



function CardBlock(props) {
  warnOnce('The "CardBlock" component has been deprecated.\nPlease use component "CardBody".');
  return CardBlock___WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(CardBody_defaultExport, props);
}
// CONCATENATED MODULE: ./node_modules/reactstrap/es/CardLink.js
/* harmony import */ var CardLink___WEBPACK_IMPORTED_MODULE_2_react__ = __webpack_require__(71);
/* harmony import */ var CardLink___WEBPACK_IMPORTED_MODULE_2_react___default = __webpack_require__.n(CardLink___WEBPACK_IMPORTED_MODULE_2_react__);
/* harmony import */ var CardLink___WEBPACK_IMPORTED_MODULE_3_prop_types__ = __webpack_require__(890);
/* harmony import */ var CardLink___WEBPACK_IMPORTED_MODULE_3_prop_types___default = __webpack_require__.n(CardLink___WEBPACK_IMPORTED_MODULE_3_prop_types__);
/* harmony import */ var CardLink___WEBPACK_IMPORTED_MODULE_4_classnames__ = __webpack_require__(891);
/* harmony import */ var CardLink___WEBPACK_IMPORTED_MODULE_4_classnames___default = __webpack_require__.n(CardLink___WEBPACK_IMPORTED_MODULE_4_classnames__);






var CardLink_propTypes = {
  tag: tagPropType,
  innerRef: CardLink___WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.oneOfType([CardLink___WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.object, CardLink___WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.func, CardLink___WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.string]),
  className: CardLink___WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.string,
  cssModule: CardLink___WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.object
};
var CardLink_defaultProps = {
  tag: 'a'
};

var CardLink_CardLink = function CardLink(props) {
  var className = props.className,
      cssModule = props.cssModule,
      Tag = props.tag,
      innerRef = props.innerRef,
      attributes = _objectWithoutPropertiesLoose(props, ["className", "cssModule", "tag", "innerRef"]);

  var classes = mapToCssModules(CardLink___WEBPACK_IMPORTED_MODULE_4_classnames___default()(className, 'card-link'), cssModule);
  return CardLink___WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(Tag, _extends({}, attributes, {
    ref: innerRef,
    className: classes
  }));
};

CardLink_CardLink.propTypes = CardLink_propTypes;
CardLink_CardLink.defaultProps = CardLink_defaultProps;
/* harmony default export */ var CardLink_defaultExport = (CardLink_CardLink);
// CONCATENATED MODULE: ./node_modules/reactstrap/es/CardFooter.js
/* harmony import */ var CardFooter___WEBPACK_IMPORTED_MODULE_2_react__ = __webpack_require__(71);
/* harmony import */ var CardFooter___WEBPACK_IMPORTED_MODULE_2_react___default = __webpack_require__.n(CardFooter___WEBPACK_IMPORTED_MODULE_2_react__);
/* harmony import */ var CardFooter___WEBPACK_IMPORTED_MODULE_3_prop_types__ = __webpack_require__(890);
/* harmony import */ var CardFooter___WEBPACK_IMPORTED_MODULE_3_prop_types___default = __webpack_require__.n(CardFooter___WEBPACK_IMPORTED_MODULE_3_prop_types__);
/* harmony import */ var CardFooter___WEBPACK_IMPORTED_MODULE_4_classnames__ = __webpack_require__(891);
/* harmony import */ var CardFooter___WEBPACK_IMPORTED_MODULE_4_classnames___default = __webpack_require__.n(CardFooter___WEBPACK_IMPORTED_MODULE_4_classnames__);






var CardFooter_propTypes = {
  tag: tagPropType,
  className: CardFooter___WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.string,
  cssModule: CardFooter___WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.object
};
var CardFooter_defaultProps = {
  tag: 'div'
};

var CardFooter_CardFooter = function CardFooter(props) {
  var className = props.className,
      cssModule = props.cssModule,
      Tag = props.tag,
      attributes = _objectWithoutPropertiesLoose(props, ["className", "cssModule", "tag"]);

  var classes = mapToCssModules(CardFooter___WEBPACK_IMPORTED_MODULE_4_classnames___default()(className, 'card-footer'), cssModule);
  return CardFooter___WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(Tag, _extends({}, attributes, {
    className: classes
  }));
};

CardFooter_CardFooter.propTypes = CardFooter_propTypes;
CardFooter_CardFooter.defaultProps = CardFooter_defaultProps;
/* harmony default export */ var CardFooter_defaultExport = (CardFooter_CardFooter);
// CONCATENATED MODULE: ./node_modules/reactstrap/es/CardHeader.js
/* harmony import */ var CardHeader___WEBPACK_IMPORTED_MODULE_2_react__ = __webpack_require__(71);
/* harmony import */ var CardHeader___WEBPACK_IMPORTED_MODULE_2_react___default = __webpack_require__.n(CardHeader___WEBPACK_IMPORTED_MODULE_2_react__);
/* harmony import */ var CardHeader___WEBPACK_IMPORTED_MODULE_3_prop_types__ = __webpack_require__(890);
/* harmony import */ var CardHeader___WEBPACK_IMPORTED_MODULE_3_prop_types___default = __webpack_require__.n(CardHeader___WEBPACK_IMPORTED_MODULE_3_prop_types__);
/* harmony import */ var CardHeader___WEBPACK_IMPORTED_MODULE_4_classnames__ = __webpack_require__(891);
/* harmony import */ var CardHeader___WEBPACK_IMPORTED_MODULE_4_classnames___default = __webpack_require__.n(CardHeader___WEBPACK_IMPORTED_MODULE_4_classnames__);






var CardHeader_propTypes = {
  tag: tagPropType,
  className: CardHeader___WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.string,
  cssModule: CardHeader___WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.object
};
var CardHeader_defaultProps = {
  tag: 'div'
};

var CardHeader_CardHeader = function CardHeader(props) {
  var className = props.className,
      cssModule = props.cssModule,
      Tag = props.tag,
      attributes = _objectWithoutPropertiesLoose(props, ["className", "cssModule", "tag"]);

  var classes = mapToCssModules(CardHeader___WEBPACK_IMPORTED_MODULE_4_classnames___default()(className, 'card-header'), cssModule);
  return CardHeader___WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(Tag, _extends({}, attributes, {
    className: classes
  }));
};

CardHeader_CardHeader.propTypes = CardHeader_propTypes;
CardHeader_CardHeader.defaultProps = CardHeader_defaultProps;
/* harmony default export */ var CardHeader_defaultExport = (CardHeader_CardHeader);
// CONCATENATED MODULE: ./node_modules/reactstrap/es/CardImg.js
/* harmony import */ var CardImg___WEBPACK_IMPORTED_MODULE_2_react__ = __webpack_require__(71);
/* harmony import */ var CardImg___WEBPACK_IMPORTED_MODULE_2_react___default = __webpack_require__.n(CardImg___WEBPACK_IMPORTED_MODULE_2_react__);
/* harmony import */ var CardImg___WEBPACK_IMPORTED_MODULE_3_prop_types__ = __webpack_require__(890);
/* harmony import */ var CardImg___WEBPACK_IMPORTED_MODULE_3_prop_types___default = __webpack_require__.n(CardImg___WEBPACK_IMPORTED_MODULE_3_prop_types__);
/* harmony import */ var CardImg___WEBPACK_IMPORTED_MODULE_4_classnames__ = __webpack_require__(891);
/* harmony import */ var CardImg___WEBPACK_IMPORTED_MODULE_4_classnames___default = __webpack_require__.n(CardImg___WEBPACK_IMPORTED_MODULE_4_classnames__);






var CardImg_propTypes = {
  tag: tagPropType,
  top: CardImg___WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.bool,
  bottom: CardImg___WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.bool,
  className: CardImg___WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.string,
  cssModule: CardImg___WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.object
};
var CardImg_defaultProps = {
  tag: 'img'
};

var CardImg_CardImg = function CardImg(props) {
  var className = props.className,
      cssModule = props.cssModule,
      top = props.top,
      bottom = props.bottom,
      Tag = props.tag,
      attributes = _objectWithoutPropertiesLoose(props, ["className", "cssModule", "top", "bottom", "tag"]);

  var cardImgClassName = 'card-img';

  if (top) {
    cardImgClassName = 'card-img-top';
  }

  if (bottom) {
    cardImgClassName = 'card-img-bottom';
  }

  var classes = mapToCssModules(CardImg___WEBPACK_IMPORTED_MODULE_4_classnames___default()(className, cardImgClassName), cssModule);
  return CardImg___WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(Tag, _extends({}, attributes, {
    className: classes
  }));
};

CardImg_CardImg.propTypes = CardImg_propTypes;
CardImg_CardImg.defaultProps = CardImg_defaultProps;
/* harmony default export */ var CardImg_defaultExport = (CardImg_CardImg);
// CONCATENATED MODULE: ./node_modules/reactstrap/es/CardImgOverlay.js
/* harmony import */ var CardImgOverlay___WEBPACK_IMPORTED_MODULE_2_react__ = __webpack_require__(71);
/* harmony import */ var CardImgOverlay___WEBPACK_IMPORTED_MODULE_2_react___default = __webpack_require__.n(CardImgOverlay___WEBPACK_IMPORTED_MODULE_2_react__);
/* harmony import */ var CardImgOverlay___WEBPACK_IMPORTED_MODULE_3_prop_types__ = __webpack_require__(890);
/* harmony import */ var CardImgOverlay___WEBPACK_IMPORTED_MODULE_3_prop_types___default = __webpack_require__.n(CardImgOverlay___WEBPACK_IMPORTED_MODULE_3_prop_types__);
/* harmony import */ var CardImgOverlay___WEBPACK_IMPORTED_MODULE_4_classnames__ = __webpack_require__(891);
/* harmony import */ var CardImgOverlay___WEBPACK_IMPORTED_MODULE_4_classnames___default = __webpack_require__.n(CardImgOverlay___WEBPACK_IMPORTED_MODULE_4_classnames__);






var CardImgOverlay_propTypes = {
  tag: tagPropType,
  className: CardImgOverlay___WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.string,
  cssModule: CardImgOverlay___WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.object
};
var CardImgOverlay_defaultProps = {
  tag: 'div'
};

var CardImgOverlay_CardImgOverlay = function CardImgOverlay(props) {
  var className = props.className,
      cssModule = props.cssModule,
      Tag = props.tag,
      attributes = _objectWithoutPropertiesLoose(props, ["className", "cssModule", "tag"]);

  var classes = mapToCssModules(CardImgOverlay___WEBPACK_IMPORTED_MODULE_4_classnames___default()(className, 'card-img-overlay'), cssModule);
  return CardImgOverlay___WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(Tag, _extends({}, attributes, {
    className: classes
  }));
};

CardImgOverlay_CardImgOverlay.propTypes = CardImgOverlay_propTypes;
CardImgOverlay_CardImgOverlay.defaultProps = CardImgOverlay_defaultProps;
/* harmony default export */ var CardImgOverlay_defaultExport = (CardImgOverlay_CardImgOverlay);
// CONCATENATED MODULE: ./node_modules/reactstrap/es/CarouselItem.js
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react__ = __webpack_require__(71);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_prop_types__ = __webpack_require__(890);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_classnames__ = __webpack_require__(891);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_react_transition_group__ = __webpack_require__(1121);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_react_transition_group___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_react_transition_group__);











var CarouselItem_CarouselItem =
/*#__PURE__*/
function (_React$Component) {
  _inheritsLoose(CarouselItem, _React$Component);

  function CarouselItem(props) {
    var _this;

    _this = _React$Component.call(this, props) || this;
    _this.state = {
      startAnimation: false
    };
    _this.onEnter = _this.onEnter.bind(_assertThisInitialized(_assertThisInitialized(_this)));
    _this.onEntering = _this.onEntering.bind(_assertThisInitialized(_assertThisInitialized(_this)));
    _this.onExit = _this.onExit.bind(_assertThisInitialized(_assertThisInitialized(_this)));
    _this.onExiting = _this.onExiting.bind(_assertThisInitialized(_assertThisInitialized(_this)));
    _this.onExited = _this.onExited.bind(_assertThisInitialized(_assertThisInitialized(_this)));
    return _this;
  }

  var _proto = CarouselItem.prototype;

  _proto.onEnter = function onEnter(node, isAppearing) {
    this.setState({
      startAnimation: false
    });
    this.props.onEnter(node, isAppearing);
  };

  _proto.onEntering = function onEntering(node, isAppearing) {
    // getting this variable triggers a reflow
    var offsetHeight = node.offsetHeight;
    this.setState({
      startAnimation: true
    });
    this.props.onEntering(node, isAppearing);
    return offsetHeight;
  };

  _proto.onExit = function onExit(node) {
    this.setState({
      startAnimation: false
    });
    this.props.onExit(node);
  };

  _proto.onExiting = function onExiting(node) {
    this.setState({
      startAnimation: true
    });
    node.dispatchEvent(new CustomEvent('slide.bs.carousel'));
    this.props.onExiting(node);
  };

  _proto.onExited = function onExited(node) {
    node.dispatchEvent(new CustomEvent('slid.bs.carousel'));
    this.props.onExited(node);
  };

  _proto.render = function render() {
    var _this2 = this;

    var _this$props = this.props,
        isIn = _this$props.in,
        children = _this$props.children,
        cssModule = _this$props.cssModule,
        slide = _this$props.slide,
        Tag = _this$props.tag,
        className = _this$props.className,
        transitionProps = _objectWithoutPropertiesLoose(_this$props, ["in", "children", "cssModule", "slide", "tag", "className"]);

    return __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8_react_transition_group__["Transition"], _extends({}, transitionProps, {
      enter: slide,
      exit: slide,
      in: isIn,
      onEnter: this.onEnter,
      onEntering: this.onEntering,
      onExit: this.onExit,
      onExiting: this.onExiting,
      onExited: this.onExited
    }), function (status) {
      var direction = _this2.context.direction;
      var isActive = status === TransitionStatuses.ENTERED || status === TransitionStatuses.EXITING;
      var directionClassName = (status === TransitionStatuses.ENTERING || status === TransitionStatuses.EXITING) && _this2.state.startAnimation && (direction === 'right' ? 'carousel-item-left' : 'carousel-item-right');
      var orderClassName = status === TransitionStatuses.ENTERING && (direction === 'right' ? 'carousel-item-next' : 'carousel-item-prev');
      var itemClasses = mapToCssModules(__WEBPACK_IMPORTED_MODULE_7_classnames___default()(className, 'carousel-item', isActive && 'active', directionClassName, orderClassName), cssModule);
      return __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(Tag, {
        className: itemClasses
      }, children);
    });
  };

  return CarouselItem;
}(__WEBPACK_IMPORTED_MODULE_5_react___default.a.Component);

CarouselItem_CarouselItem.propTypes = _objectSpread({}, __WEBPACK_IMPORTED_MODULE_8_react_transition_group__["Transition"].propTypes, {
  tag: tagPropType,
  in: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.bool,
  cssModule: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.object,
  children: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.node,
  slide: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.bool,
  className: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.string
});
CarouselItem_CarouselItem.defaultProps = _objectSpread({}, __WEBPACK_IMPORTED_MODULE_8_react_transition_group__["Transition"].defaultProps, {
  tag: 'div',
  timeout: TransitionTimeouts.Carousel,
  slide: true
});
CarouselItem_CarouselItem.contextTypes = {
  direction: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.string
};
/* harmony default export */ var CarouselItem_defaultExport = (CarouselItem_CarouselItem);
// CONCATENATED MODULE: ./node_modules/reactstrap/es/Carousel.js
/* harmony import */ var Carousel___WEBPACK_IMPORTED_MODULE_2_react__ = __webpack_require__(71);
/* harmony import */ var Carousel___WEBPACK_IMPORTED_MODULE_2_react___default = __webpack_require__.n(Carousel___WEBPACK_IMPORTED_MODULE_2_react__);
/* harmony import */ var Carousel___WEBPACK_IMPORTED_MODULE_3_prop_types__ = __webpack_require__(890);
/* harmony import */ var Carousel___WEBPACK_IMPORTED_MODULE_3_prop_types___default = __webpack_require__.n(Carousel___WEBPACK_IMPORTED_MODULE_3_prop_types__);
/* harmony import */ var Carousel___WEBPACK_IMPORTED_MODULE_4_classnames__ = __webpack_require__(891);
/* harmony import */ var Carousel___WEBPACK_IMPORTED_MODULE_4_classnames___default = __webpack_require__.n(Carousel___WEBPACK_IMPORTED_MODULE_4_classnames__);








var Carousel_Carousel =
/*#__PURE__*/
function (_React$Component) {
  _inheritsLoose(Carousel, _React$Component);

  function Carousel(props) {
    var _this;

    _this = _React$Component.call(this, props) || this;
    _this.handleKeyPress = _this.handleKeyPress.bind(_assertThisInitialized(_assertThisInitialized(_this)));
    _this.renderItems = _this.renderItems.bind(_assertThisInitialized(_assertThisInitialized(_this)));
    _this.hoverStart = _this.hoverStart.bind(_assertThisInitialized(_assertThisInitialized(_this)));
    _this.hoverEnd = _this.hoverEnd.bind(_assertThisInitialized(_assertThisInitialized(_this)));
    _this.state = {
      direction: 'right',
      indicatorClicked: false
    };
    return _this;
  }

  var _proto = Carousel.prototype;

  _proto.getChildContext = function getChildContext() {
    return {
      direction: this.state.direction
    };
  };

  _proto.componentDidMount = function componentDidMount() {
    // Set up the cycle
    if (this.props.ride === 'carousel') {
      this.setInterval();
    } // TODO: move this to the specific carousel like bootstrap. Currently it will trigger ALL carousels on the page.


    document.addEventListener('keyup', this.handleKeyPress);
  };

  _proto.componentWillReceiveProps = function componentWillReceiveProps(nextProps) {
    this.setInterval(nextProps); // Calculate the direction to turn

    if (this.props.activeIndex + 1 === nextProps.activeIndex) {
      this.setState({
        direction: 'right'
      });
    } else if (this.props.activeIndex - 1 === nextProps.activeIndex) {
      this.setState({
        direction: 'left'
      });
    } else if (this.props.activeIndex > nextProps.activeIndex) {
      this.setState({
        direction: this.state.indicatorClicked ? 'left' : 'right'
      });
    } else if (this.props.activeIndex !== nextProps.activeIndex) {
      this.setState({
        direction: this.state.indicatorClicked ? 'right' : 'left'
      });
    }

    this.setState({
      indicatorClicked: false
    });
  };

  _proto.componentWillUnmount = function componentWillUnmount() {
    this.clearInterval();
    document.removeEventListener('keyup', this.handleKeyPress);
  };

  _proto.setInterval = function (_setInterval) {
    function setInterval() {
      return _setInterval.apply(this, arguments);
    }

    setInterval.toString = function () {
      return _setInterval.toString();
    };

    return setInterval;
  }(function (props) {
    if (props === void 0) {
      props = this.props;
    }

    // make sure not to have multiple intervals going...
    this.clearInterval();

    if (props.interval) {
      this.cycleInterval = setInterval(function () {
        props.next();
      }, parseInt(props.interval, 10));
    }
  });

  _proto.clearInterval = function (_clearInterval) {
    function clearInterval() {
      return _clearInterval.apply(this, arguments);
    }

    clearInterval.toString = function () {
      return _clearInterval.toString();
    };

    return clearInterval;
  }(function () {
    clearInterval(this.cycleInterval);
  });

  _proto.hoverStart = function hoverStart() {
    if (this.props.pause === 'hover') {
      this.clearInterval();
    }

    if (this.props.mouseEnter) {
      var _this$props;

      (_this$props = this.props).mouseEnter.apply(_this$props, arguments);
    }
  };

  _proto.hoverEnd = function hoverEnd() {
    if (this.props.pause === 'hover') {
      this.setInterval();
    }

    if (this.props.mouseLeave) {
      var _this$props2;

      (_this$props2 = this.props).mouseLeave.apply(_this$props2, arguments);
    }
  };

  _proto.handleKeyPress = function handleKeyPress(evt) {
    if (this.props.keyboard) {
      if (evt.keyCode === 37) {
        this.props.previous();
      } else if (evt.keyCode === 39) {
        this.props.next();
      }
    }
  };

  _proto.renderItems = function renderItems(carouselItems, className) {
    var _this2 = this;

    var slide = this.props.slide;
    return Carousel___WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement("div", {
      role: "listbox",
      className: className
    }, carouselItems.map(function (item, index) {
      var isIn = index === _this2.props.activeIndex;
      return Carousel___WEBPACK_IMPORTED_MODULE_2_react___default.a.cloneElement(item, {
        in: isIn,
        slide: slide
      });
    }));
  };

  _proto.render = function render() {
    var _this3 = this;

    var _this$props3 = this.props,
        cssModule = _this$props3.cssModule,
        slide = _this$props3.slide,
        className = _this$props3.className;
    var outerClasses = mapToCssModules(Carousel___WEBPACK_IMPORTED_MODULE_4_classnames___default()(className, 'carousel', slide && 'slide'), cssModule);
    var innerClasses = mapToCssModules(Carousel___WEBPACK_IMPORTED_MODULE_4_classnames___default()('carousel-inner'), cssModule); // filter out booleans, null, or undefined

    var children = this.props.children.filter(function (child) {
      return child !== null && child !== undefined && typeof child !== 'boolean';
    });
    var slidesOnly = children.every(function (child) {
      return child.type === CarouselItem_defaultExport;
    }); // Rendering only slides

    if (slidesOnly) {
      return Carousel___WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement("div", {
        className: outerClasses,
        onMouseEnter: this.hoverStart,
        onMouseLeave: this.hoverEnd
      }, this.renderItems(children, innerClasses));
    } // Rendering slides and controls


    if (children[0] instanceof Array) {
      var _carouselItems = children[0];
      var _controlLeft = children[1];
      var _controlRight = children[2];
      return Carousel___WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement("div", {
        className: outerClasses,
        onMouseEnter: this.hoverStart,
        onMouseLeave: this.hoverEnd
      }, this.renderItems(_carouselItems, innerClasses), _controlLeft, _controlRight);
    } // Rendering indicators, slides and controls


    var indicators = children[0];

    var wrappedOnClick = function wrappedOnClick(e) {
      if (typeof indicators.props.onClickHandler === 'function') {
        _this3.setState({
          indicatorClicked: true
        }, function () {
          return indicators.props.onClickHandler(e);
        });
      }
    };

    var wrappedIndicators = Carousel___WEBPACK_IMPORTED_MODULE_2_react___default.a.cloneElement(indicators, {
      onClickHandler: wrappedOnClick
    });
    var carouselItems = children[1];
    var controlLeft = children[2];
    var controlRight = children[3];
    return Carousel___WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement("div", {
      className: outerClasses,
      onMouseEnter: this.hoverStart,
      onMouseLeave: this.hoverEnd
    }, wrappedIndicators, this.renderItems(carouselItems, innerClasses), controlLeft, controlRight);
  };

  return Carousel;
}(Carousel___WEBPACK_IMPORTED_MODULE_2_react___default.a.Component);

Carousel_Carousel.propTypes = {
  // the current active slide of the carousel
  activeIndex: Carousel___WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.number,
  // a function which should advance the carousel to the next slide (via activeIndex)
  next: Carousel___WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.func.isRequired,
  // a function which should advance the carousel to the previous slide (via activeIndex)
  previous: Carousel___WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.func.isRequired,
  // controls if the left and right arrow keys should control the carousel
  keyboard: Carousel___WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.bool,

  /* If set to "hover", pauses the cycling of the carousel on mouseenter and resumes the cycling of the carousel on
   * mouseleave. If set to false, hovering over the carousel won't pause it. (default: "hover")
   */
  pause: Carousel___WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.oneOf(['hover', false]),
  // Autoplays the carousel after the user manually cycles the first item. If "carousel", autoplays the carousel on load.
  // This is how bootstrap defines it... I would prefer a bool named autoplay or something...
  ride: Carousel___WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.oneOf(['carousel']),
  // the interval at which the carousel automatically cycles (default: 5000)
  // eslint-disable-next-line react/no-unused-prop-types
  interval: Carousel___WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.oneOfType([Carousel___WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.number, Carousel___WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.string, Carousel___WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.bool]),
  children: Carousel___WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.array,
  // called when the mouse enters the Carousel
  mouseEnter: Carousel___WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.func,
  // called when the mouse exits the Carousel
  mouseLeave: Carousel___WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.func,
  // controls whether the slide animation on the Carousel works or not
  slide: Carousel___WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.bool,
  cssModule: Carousel___WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.object,
  className: Carousel___WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.string
};
Carousel_Carousel.defaultProps = {
  interval: 5000,
  pause: 'hover',
  keyboard: true,
  slide: true
};
Carousel_Carousel.childContextTypes = {
  direction: Carousel___WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.string
};
/* harmony default export */ var Carousel_defaultExport = (Carousel_Carousel);
// CONCATENATED MODULE: ./node_modules/reactstrap/es/CarouselControl.js
/* harmony import */ var CarouselControl___WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(71);
/* harmony import */ var CarouselControl___WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(CarouselControl___WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var CarouselControl___WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(890);
/* harmony import */ var CarouselControl___WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(CarouselControl___WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_classnames__ = __webpack_require__(891);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_classnames__);





var CarouselControl_CarouselControl = function CarouselControl(props) {
  var direction = props.direction,
      onClickHandler = props.onClickHandler,
      cssModule = props.cssModule,
      directionText = props.directionText,
      className = props.className;
  var anchorClasses = mapToCssModules(__WEBPACK_IMPORTED_MODULE_2_classnames___default()(className, "carousel-control-" + direction), cssModule);
  var iconClasses = mapToCssModules(__WEBPACK_IMPORTED_MODULE_2_classnames___default()("carousel-control-" + direction + "-icon"), cssModule);
  var screenReaderClasses = mapToCssModules(__WEBPACK_IMPORTED_MODULE_2_classnames___default()('sr-only'), cssModule);
  return CarouselControl___WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("a", {
    className: anchorClasses,
    role: "button",
    tabIndex: "0",
    onClick: function onClick(e) {
      e.preventDefault();
      onClickHandler();
    }
  }, CarouselControl___WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("span", {
    className: iconClasses,
    "aria-hidden": "true"
  }), CarouselControl___WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("span", {
    className: screenReaderClasses
  }, directionText || direction));
};

CarouselControl_CarouselControl.propTypes = {
  direction: CarouselControl___WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.oneOf(['prev', 'next']).isRequired,
  onClickHandler: CarouselControl___WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired,
  cssModule: CarouselControl___WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object,
  directionText: CarouselControl___WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  className: CarouselControl___WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string
};
/* harmony default export */ var CarouselControl_defaultExport = (CarouselControl_CarouselControl);
// CONCATENATED MODULE: ./node_modules/reactstrap/es/CarouselIndicators.js
/* harmony import */ var CarouselIndicators___WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(71);
/* harmony import */ var CarouselIndicators___WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(CarouselIndicators___WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var CarouselIndicators___WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(890);
/* harmony import */ var CarouselIndicators___WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(CarouselIndicators___WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var CarouselIndicators___WEBPACK_IMPORTED_MODULE_2_classnames__ = __webpack_require__(891);
/* harmony import */ var CarouselIndicators___WEBPACK_IMPORTED_MODULE_2_classnames___default = __webpack_require__.n(CarouselIndicators___WEBPACK_IMPORTED_MODULE_2_classnames__);





var CarouselIndicators_CarouselIndicators = function CarouselIndicators(props) {
  var items = props.items,
      activeIndex = props.activeIndex,
      cssModule = props.cssModule,
      onClickHandler = props.onClickHandler,
      className = props.className;
  var listClasses = mapToCssModules(CarouselIndicators___WEBPACK_IMPORTED_MODULE_2_classnames___default()(className, 'carousel-indicators'), cssModule);
  var indicators = items.map(function (item, idx) {
    var indicatorClasses = mapToCssModules(CarouselIndicators___WEBPACK_IMPORTED_MODULE_2_classnames___default()({
      active: activeIndex === idx
    }), cssModule);
    return CarouselIndicators___WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("li", {
      key: "" + (item.key || Object.values(item).join('')),
      onClick: function onClick(e) {
        e.preventDefault();
        onClickHandler(idx);
      },
      className: indicatorClasses
    });
  });
  return CarouselIndicators___WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("ol", {
    className: listClasses
  }, indicators);
};

CarouselIndicators_CarouselIndicators.propTypes = {
  items: CarouselIndicators___WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.array.isRequired,
  activeIndex: CarouselIndicators___WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.number.isRequired,
  cssModule: CarouselIndicators___WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object,
  onClickHandler: CarouselIndicators___WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired,
  className: CarouselIndicators___WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string
};
/* harmony default export */ var CarouselIndicators_defaultExport = (CarouselIndicators_CarouselIndicators);
// CONCATENATED MODULE: ./node_modules/reactstrap/es/CarouselCaption.js
/* harmony import */ var CarouselCaption___WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(71);
/* harmony import */ var CarouselCaption___WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(CarouselCaption___WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var CarouselCaption___WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(890);
/* harmony import */ var CarouselCaption___WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(CarouselCaption___WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var CarouselCaption___WEBPACK_IMPORTED_MODULE_2_classnames__ = __webpack_require__(891);
/* harmony import */ var CarouselCaption___WEBPACK_IMPORTED_MODULE_2_classnames___default = __webpack_require__.n(CarouselCaption___WEBPACK_IMPORTED_MODULE_2_classnames__);





var CarouselCaption_CarouselCaption = function CarouselCaption(props) {
  var captionHeader = props.captionHeader,
      captionText = props.captionText,
      cssModule = props.cssModule,
      className = props.className;
  var classes = mapToCssModules(CarouselCaption___WEBPACK_IMPORTED_MODULE_2_classnames___default()(className, 'carousel-caption', 'd-none', 'd-md-block'), cssModule);
  return CarouselCaption___WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", {
    className: classes
  }, CarouselCaption___WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("h3", null, captionHeader), CarouselCaption___WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p", null, captionText));
};

CarouselCaption_CarouselCaption.propTypes = {
  captionHeader: CarouselCaption___WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  captionText: CarouselCaption___WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string.isRequired,
  cssModule: CarouselCaption___WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object,
  className: CarouselCaption___WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string
};
/* harmony default export */ var CarouselCaption_defaultExport = (CarouselCaption_CarouselCaption);
// CONCATENATED MODULE: ./node_modules/reactstrap/es/UncontrolledCarousel.js
/* harmony import */ var UncontrolledCarousel___WEBPACK_IMPORTED_MODULE_4_react__ = __webpack_require__(71);
/* harmony import */ var UncontrolledCarousel___WEBPACK_IMPORTED_MODULE_4_react___default = __webpack_require__.n(UncontrolledCarousel___WEBPACK_IMPORTED_MODULE_4_react__);
/* harmony import */ var UncontrolledCarousel___WEBPACK_IMPORTED_MODULE_5_prop_types__ = __webpack_require__(890);
/* harmony import */ var UncontrolledCarousel___WEBPACK_IMPORTED_MODULE_5_prop_types___default = __webpack_require__.n(UncontrolledCarousel___WEBPACK_IMPORTED_MODULE_5_prop_types__);











var UncontrolledCarousel_propTypes = {
  items: UncontrolledCarousel___WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.array.isRequired,
  indicators: UncontrolledCarousel___WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.bool,
  controls: UncontrolledCarousel___WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.bool,
  autoPlay: UncontrolledCarousel___WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.bool,
  defaultActiveIndex: UncontrolledCarousel___WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.number,
  activeIndex: UncontrolledCarousel___WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.number,
  next: UncontrolledCarousel___WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.func,
  previous: UncontrolledCarousel___WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.func,
  goToIndex: UncontrolledCarousel___WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.func
};

var UncontrolledCarousel_UncontrolledCarousel =
/*#__PURE__*/
function (_Component) {
  _inheritsLoose(UncontrolledCarousel, _Component);

  function UncontrolledCarousel(props) {
    var _this;

    _this = _Component.call(this, props) || this;
    _this.animating = false;
    _this.state = {
      activeIndex: props.defaultActiveIndex || 0
    };
    _this.next = _this.next.bind(_assertThisInitialized(_assertThisInitialized(_this)));
    _this.previous = _this.previous.bind(_assertThisInitialized(_assertThisInitialized(_this)));
    _this.goToIndex = _this.goToIndex.bind(_assertThisInitialized(_assertThisInitialized(_this)));
    _this.onExiting = _this.onExiting.bind(_assertThisInitialized(_assertThisInitialized(_this)));
    _this.onExited = _this.onExited.bind(_assertThisInitialized(_assertThisInitialized(_this)));
    return _this;
  }

  var _proto = UncontrolledCarousel.prototype;

  _proto.onExiting = function onExiting() {
    this.animating = true;
  };

  _proto.onExited = function onExited() {
    this.animating = false;
  };

  _proto.next = function next() {
    if (this.animating) return;
    var nextIndex = this.state.activeIndex === this.props.items.length - 1 ? 0 : this.state.activeIndex + 1;
    this.setState({
      activeIndex: nextIndex
    });
  };

  _proto.previous = function previous() {
    if (this.animating) return;
    var nextIndex = this.state.activeIndex === 0 ? this.props.items.length - 1 : this.state.activeIndex - 1;
    this.setState({
      activeIndex: nextIndex
    });
  };

  _proto.goToIndex = function goToIndex(newIndex) {
    if (this.animating) return;
    this.setState({
      activeIndex: newIndex
    });
  };

  _proto.render = function render() {
    var _this2 = this;

    var _this$props = this.props,
        defaultActiveIndex = _this$props.defaultActiveIndex,
        autoPlay = _this$props.autoPlay,
        indicators = _this$props.indicators,
        controls = _this$props.controls,
        items = _this$props.items,
        goToIndex = _this$props.goToIndex,
        props = _objectWithoutPropertiesLoose(_this$props, ["defaultActiveIndex", "autoPlay", "indicators", "controls", "items", "goToIndex"]);

    var activeIndex = this.state.activeIndex;
    var slides = items.map(function (item) {
      return UncontrolledCarousel___WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(CarouselItem_defaultExport, {
        onExiting: _this2.onExiting,
        onExited: _this2.onExited,
        key: item.src
      }, UncontrolledCarousel___WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement("img", {
        className: "d-block w-100",
        src: item.src,
        alt: item.altText
      }), UncontrolledCarousel___WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(CarouselCaption_defaultExport, {
        captionText: item.caption,
        captionHeader: item.header || item.caption
      }));
    });
    return UncontrolledCarousel___WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(Carousel_defaultExport, _extends({
      activeIndex: activeIndex,
      next: this.next,
      previous: this.previous,
      ride: autoPlay ? 'carousel' : undefined
    }, props), indicators && UncontrolledCarousel___WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(CarouselIndicators_defaultExport, {
      items: items,
      activeIndex: props.activeIndex || activeIndex,
      onClickHandler: goToIndex || this.goToIndex
    }), slides, controls && UncontrolledCarousel___WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(CarouselControl_defaultExport, {
      direction: "prev",
      directionText: "Previous",
      onClickHandler: props.previous || this.previous
    }), controls && UncontrolledCarousel___WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(CarouselControl_defaultExport, {
      direction: "next",
      directionText: "Next",
      onClickHandler: props.next || this.next
    }));
  };

  return UncontrolledCarousel;
}(UncontrolledCarousel___WEBPACK_IMPORTED_MODULE_4_react__["Component"]);

UncontrolledCarousel_UncontrolledCarousel.propTypes = UncontrolledCarousel_propTypes;
UncontrolledCarousel_UncontrolledCarousel.defaultProps = {
  controls: true,
  indicators: true,
  autoPlay: true
};
/* harmony default export */ var UncontrolledCarousel_defaultExport = (UncontrolledCarousel_UncontrolledCarousel);
// CONCATENATED MODULE: ./node_modules/reactstrap/es/CardSubtitle.js
/* harmony import */ var CardSubtitle___WEBPACK_IMPORTED_MODULE_2_react__ = __webpack_require__(71);
/* harmony import */ var CardSubtitle___WEBPACK_IMPORTED_MODULE_2_react___default = __webpack_require__.n(CardSubtitle___WEBPACK_IMPORTED_MODULE_2_react__);
/* harmony import */ var CardSubtitle___WEBPACK_IMPORTED_MODULE_3_prop_types__ = __webpack_require__(890);
/* harmony import */ var CardSubtitle___WEBPACK_IMPORTED_MODULE_3_prop_types___default = __webpack_require__.n(CardSubtitle___WEBPACK_IMPORTED_MODULE_3_prop_types__);
/* harmony import */ var CardSubtitle___WEBPACK_IMPORTED_MODULE_4_classnames__ = __webpack_require__(891);
/* harmony import */ var CardSubtitle___WEBPACK_IMPORTED_MODULE_4_classnames___default = __webpack_require__.n(CardSubtitle___WEBPACK_IMPORTED_MODULE_4_classnames__);






var CardSubtitle_propTypes = {
  tag: tagPropType,
  className: CardSubtitle___WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.string,
  cssModule: CardSubtitle___WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.object
};
var CardSubtitle_defaultProps = {
  tag: 'div'
};

var CardSubtitle_CardSubtitle = function CardSubtitle(props) {
  var className = props.className,
      cssModule = props.cssModule,
      Tag = props.tag,
      attributes = _objectWithoutPropertiesLoose(props, ["className", "cssModule", "tag"]);

  var classes = mapToCssModules(CardSubtitle___WEBPACK_IMPORTED_MODULE_4_classnames___default()(className, 'card-subtitle'), cssModule);
  return CardSubtitle___WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(Tag, _extends({}, attributes, {
    className: classes
  }));
};

CardSubtitle_CardSubtitle.propTypes = CardSubtitle_propTypes;
CardSubtitle_CardSubtitle.defaultProps = CardSubtitle_defaultProps;
/* harmony default export */ var CardSubtitle_defaultExport = (CardSubtitle_CardSubtitle);
// CONCATENATED MODULE: ./node_modules/reactstrap/es/CardText.js
/* harmony import */ var CardText___WEBPACK_IMPORTED_MODULE_2_react__ = __webpack_require__(71);
/* harmony import */ var CardText___WEBPACK_IMPORTED_MODULE_2_react___default = __webpack_require__.n(CardText___WEBPACK_IMPORTED_MODULE_2_react__);
/* harmony import */ var CardText___WEBPACK_IMPORTED_MODULE_3_prop_types__ = __webpack_require__(890);
/* harmony import */ var CardText___WEBPACK_IMPORTED_MODULE_3_prop_types___default = __webpack_require__.n(CardText___WEBPACK_IMPORTED_MODULE_3_prop_types__);
/* harmony import */ var CardText___WEBPACK_IMPORTED_MODULE_4_classnames__ = __webpack_require__(891);
/* harmony import */ var CardText___WEBPACK_IMPORTED_MODULE_4_classnames___default = __webpack_require__.n(CardText___WEBPACK_IMPORTED_MODULE_4_classnames__);






var CardText_propTypes = {
  tag: tagPropType,
  className: CardText___WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.string,
  cssModule: CardText___WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.object
};
var CardText_defaultProps = {
  tag: 'p'
};

var CardText_CardText = function CardText(props) {
  var className = props.className,
      cssModule = props.cssModule,
      Tag = props.tag,
      attributes = _objectWithoutPropertiesLoose(props, ["className", "cssModule", "tag"]);

  var classes = mapToCssModules(CardText___WEBPACK_IMPORTED_MODULE_4_classnames___default()(className, 'card-text'), cssModule);
  return CardText___WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(Tag, _extends({}, attributes, {
    className: classes
  }));
};

CardText_CardText.propTypes = CardText_propTypes;
CardText_CardText.defaultProps = CardText_defaultProps;
/* harmony default export */ var CardText_defaultExport = (CardText_CardText);
// CONCATENATED MODULE: ./node_modules/reactstrap/es/CardTitle.js
/* harmony import */ var CardTitle___WEBPACK_IMPORTED_MODULE_2_react__ = __webpack_require__(71);
/* harmony import */ var CardTitle___WEBPACK_IMPORTED_MODULE_2_react___default = __webpack_require__.n(CardTitle___WEBPACK_IMPORTED_MODULE_2_react__);
/* harmony import */ var CardTitle___WEBPACK_IMPORTED_MODULE_3_prop_types__ = __webpack_require__(890);
/* harmony import */ var CardTitle___WEBPACK_IMPORTED_MODULE_3_prop_types___default = __webpack_require__.n(CardTitle___WEBPACK_IMPORTED_MODULE_3_prop_types__);
/* harmony import */ var CardTitle___WEBPACK_IMPORTED_MODULE_4_classnames__ = __webpack_require__(891);
/* harmony import */ var CardTitle___WEBPACK_IMPORTED_MODULE_4_classnames___default = __webpack_require__.n(CardTitle___WEBPACK_IMPORTED_MODULE_4_classnames__);






var CardTitle_propTypes = {
  tag: tagPropType,
  className: CardTitle___WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.string,
  cssModule: CardTitle___WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.object
};
var CardTitle_defaultProps = {
  tag: 'div'
};

var CardTitle_CardTitle = function CardTitle(props) {
  var className = props.className,
      cssModule = props.cssModule,
      Tag = props.tag,
      attributes = _objectWithoutPropertiesLoose(props, ["className", "cssModule", "tag"]);

  var classes = mapToCssModules(CardTitle___WEBPACK_IMPORTED_MODULE_4_classnames___default()(className, 'card-title'), cssModule);
  return CardTitle___WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(Tag, _extends({}, attributes, {
    className: classes
  }));
};

CardTitle_CardTitle.propTypes = CardTitle_propTypes;
CardTitle_CardTitle.defaultProps = CardTitle_defaultProps;
/* harmony default export */ var CardTitle_defaultExport = (CardTitle_CardTitle);
// CONCATENATED MODULE: ./node_modules/reactstrap/es/CustomInput.js
/* harmony import */ var CustomInput___WEBPACK_IMPORTED_MODULE_2_react__ = __webpack_require__(71);
/* harmony import */ var CustomInput___WEBPACK_IMPORTED_MODULE_2_react___default = __webpack_require__.n(CustomInput___WEBPACK_IMPORTED_MODULE_2_react__);
/* harmony import */ var CustomInput___WEBPACK_IMPORTED_MODULE_3_prop_types__ = __webpack_require__(890);
/* harmony import */ var CustomInput___WEBPACK_IMPORTED_MODULE_3_prop_types___default = __webpack_require__.n(CustomInput___WEBPACK_IMPORTED_MODULE_3_prop_types__);
/* harmony import */ var CustomInput___WEBPACK_IMPORTED_MODULE_4_classnames__ = __webpack_require__(891);
/* harmony import */ var CustomInput___WEBPACK_IMPORTED_MODULE_4_classnames___default = __webpack_require__.n(CustomInput___WEBPACK_IMPORTED_MODULE_4_classnames__);






var CustomInput_propTypes = {
  className: CustomInput___WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.string,
  id: CustomInput___WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.oneOfType([CustomInput___WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.string, CustomInput___WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.number]).isRequired,
  type: CustomInput___WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.string.isRequired,
  label: CustomInput___WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.node,
  inline: CustomInput___WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.bool,
  valid: CustomInput___WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.bool,
  invalid: CustomInput___WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.bool,
  bsSize: CustomInput___WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.string,
  cssModule: CustomInput___WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.object,
  children: CustomInput___WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.oneOfType([CustomInput___WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.node, CustomInput___WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.array, CustomInput___WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.func]),
  innerRef: CustomInput___WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.oneOfType([CustomInput___WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.object, CustomInput___WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.string, CustomInput___WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.func])
};

function CustomInput(props) {
  var className = props.className,
      label = props.label,
      inline = props.inline,
      valid = props.valid,
      invalid = props.invalid,
      cssModule = props.cssModule,
      children = props.children,
      bsSize = props.bsSize,
      innerRef = props.innerRef,
      attributes = _objectWithoutPropertiesLoose(props, ["className", "label", "inline", "valid", "invalid", "cssModule", "children", "bsSize", "innerRef"]);

  var type = attributes.type;
  var customClass = mapToCssModules(CustomInput___WEBPACK_IMPORTED_MODULE_4_classnames___default()(className, "custom-" + type, bsSize ? "custom-" + type + "-" + bsSize : false), cssModule);
  var validationClassNames = mapToCssModules(CustomInput___WEBPACK_IMPORTED_MODULE_4_classnames___default()(invalid && 'is-invalid', valid && 'is-valid'), cssModule);

  if (type === 'select') {
    return CustomInput___WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement("select", _extends({}, attributes, {
      ref: innerRef,
      className: CustomInput___WEBPACK_IMPORTED_MODULE_4_classnames___default()(validationClassNames, customClass)
    }), children);
  }

  if (type === 'file') {
    return CustomInput___WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement("div", {
      className: customClass
    }, CustomInput___WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement("input", _extends({}, attributes, {
      ref: innerRef,
      className: CustomInput___WEBPACK_IMPORTED_MODULE_4_classnames___default()(validationClassNames, mapToCssModules('custom-file-input', cssModule))
    })), CustomInput___WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement("label", {
      className: mapToCssModules('custom-file-label', cssModule),
      htmlFor: attributes.id
    }, label || 'Choose file'));
  }

  if (type !== 'checkbox' && type !== 'radio' && type !== 'switch') {
    return CustomInput___WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement("input", _extends({}, attributes, {
      ref: innerRef,
      className: CustomInput___WEBPACK_IMPORTED_MODULE_4_classnames___default()(validationClassNames, customClass)
    }));
  }

  var wrapperClasses = CustomInput___WEBPACK_IMPORTED_MODULE_4_classnames___default()(customClass, mapToCssModules(CustomInput___WEBPACK_IMPORTED_MODULE_4_classnames___default()('custom-control', {
    'custom-control-inline': inline
  }), cssModule));
  return CustomInput___WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement("div", {
    className: wrapperClasses
  }, CustomInput___WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement("input", _extends({}, attributes, {
    type: type === 'switch' ? 'checkbox' : type,
    ref: innerRef,
    className: CustomInput___WEBPACK_IMPORTED_MODULE_4_classnames___default()(validationClassNames, mapToCssModules('custom-control-input', cssModule))
  })), CustomInput___WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement("label", {
    className: mapToCssModules('custom-control-label', cssModule),
    htmlFor: attributes.id
  }, label), children);
}

CustomInput.propTypes = CustomInput_propTypes;
/* harmony default export */ var CustomInput_defaultExport = (CustomInput);
// CONCATENATED MODULE: ./node_modules/reactstrap/es/PopperContent.js
/* harmony import */ var PopperContent___WEBPACK_IMPORTED_MODULE_5_react__ = __webpack_require__(71);
/* harmony import */ var PopperContent___WEBPACK_IMPORTED_MODULE_5_react___default = __webpack_require__.n(PopperContent___WEBPACK_IMPORTED_MODULE_5_react__);
/* harmony import */ var PopperContent___WEBPACK_IMPORTED_MODULE_6_prop_types__ = __webpack_require__(890);
/* harmony import */ var PopperContent___WEBPACK_IMPORTED_MODULE_6_prop_types___default = __webpack_require__.n(PopperContent___WEBPACK_IMPORTED_MODULE_6_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_react_dom__ = __webpack_require__(420);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_react_dom___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_react_dom__);
/* harmony import */ var PopperContent___WEBPACK_IMPORTED_MODULE_8_classnames__ = __webpack_require__(891);
/* harmony import */ var PopperContent___WEBPACK_IMPORTED_MODULE_8_classnames___default = __webpack_require__.n(PopperContent___WEBPACK_IMPORTED_MODULE_8_classnames__);











var PopperContent_propTypes = {
  children: PopperContent___WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.node.isRequired,
  className: PopperContent___WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.string,
  placement: PopperContent___WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.string,
  placementPrefix: PopperContent___WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.string,
  arrowClassName: PopperContent___WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.string,
  hideArrow: PopperContent___WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.bool,
  tag: tagPropType,
  isOpen: PopperContent___WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.bool.isRequired,
  cssModule: PopperContent___WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.object,
  offset: PopperContent___WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.oneOfType([PopperContent___WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.string, PopperContent___WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.number]),
  fallbackPlacement: PopperContent___WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.oneOfType([PopperContent___WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.string, PopperContent___WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.array]),
  flip: PopperContent___WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.bool,
  container: targetPropType,
  target: targetPropType.isRequired,
  modifiers: PopperContent___WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.object,
  boundariesElement: PopperContent___WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.oneOfType([PopperContent___WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.string, DOMElement])
};
var PopperContent_defaultProps = {
  boundariesElement: 'scrollParent',
  placement: 'auto',
  hideArrow: false,
  isOpen: false,
  offset: 0,
  fallbackPlacement: 'flip',
  flip: true,
  container: 'body',
  modifiers: {}
};
var PopperContent_childContextTypes = {
  popperManager: PopperContent___WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.object.isRequired
};

var PopperContent_PopperContent =
/*#__PURE__*/
function (_React$Component) {
  _inheritsLoose(PopperContent, _React$Component);

  function PopperContent(props) {
    var _this;

    _this = _React$Component.call(this, props) || this;
    _this.handlePlacementChange = _this.handlePlacementChange.bind(_assertThisInitialized(_assertThisInitialized(_this)));
    _this.setTargetNode = _this.setTargetNode.bind(_assertThisInitialized(_assertThisInitialized(_this)));
    _this.getTargetNode = _this.getTargetNode.bind(_assertThisInitialized(_assertThisInitialized(_this)));
    _this.getRef = _this.getRef.bind(_assertThisInitialized(_assertThisInitialized(_this)));
    _this.state = {};
    return _this;
  }

  var _proto = PopperContent.prototype;

  _proto.getChildContext = function getChildContext() {
    return {
      popperManager: {
        setTargetNode: this.setTargetNode,
        getTargetNode: this.getTargetNode
      }
    };
  };

  _proto.componentDidUpdate = function componentDidUpdate() {
    if (this._element && this._element.childNodes && this._element.childNodes[0] && this._element.childNodes[0].focus) {
      this._element.childNodes[0].focus();
    }
  };

  _proto.setTargetNode = function setTargetNode(node) {
    this.targetNode = node;
  };

  _proto.getTargetNode = function getTargetNode() {
    return this.targetNode;
  };

  _proto.getContainerNode = function getContainerNode() {
    return getTarget(this.props.container);
  };

  _proto.getRef = function getRef(ref) {
    this._element = ref;
  };

  _proto.handlePlacementChange = function handlePlacementChange(data) {
    if (this.state.placement !== data.placement) {
      this.setState({
        placement: data.placement
      });
    }

    return data;
  };

  _proto.renderChildren = function renderChildren() {
    var _this$props = this.props,
        cssModule = _this$props.cssModule,
        children = _this$props.children,
        isOpen = _this$props.isOpen,
        flip = _this$props.flip,
        target = _this$props.target,
        offset = _this$props.offset,
        fallbackPlacement = _this$props.fallbackPlacement,
        placementPrefix = _this$props.placementPrefix,
        _arrowClassName = _this$props.arrowClassName,
        hideArrow = _this$props.hideArrow,
        className = _this$props.className,
        tag = _this$props.tag,
        container = _this$props.container,
        modifiers = _this$props.modifiers,
        boundariesElement = _this$props.boundariesElement,
        attrs = _objectWithoutPropertiesLoose(_this$props, ["cssModule", "children", "isOpen", "flip", "target", "offset", "fallbackPlacement", "placementPrefix", "arrowClassName", "hideArrow", "className", "tag", "container", "modifiers", "boundariesElement"]);

    var arrowClassName = mapToCssModules(PopperContent___WEBPACK_IMPORTED_MODULE_8_classnames___default()('arrow', _arrowClassName), cssModule);
    var placement = (this.state.placement || attrs.placement).split('-')[0];
    var popperClassName = mapToCssModules(PopperContent___WEBPACK_IMPORTED_MODULE_8_classnames___default()(className, placementPrefix ? placementPrefix + "-" + placement : placement), this.props.cssModule);

    var extendedModifiers = _objectSpread({
      offset: {
        offset: offset
      },
      flip: {
        enabled: flip,
        behavior: fallbackPlacement
      },
      preventOverflow: {
        boundariesElement: boundariesElement
      },
      update: {
        enabled: true,
        order: 950,
        fn: this.handlePlacementChange
      }
    }, modifiers);

    return PopperContent___WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(Popper_defaultExport, _extends({
      modifiers: extendedModifiers
    }, attrs, {
      component: tag,
      className: popperClassName,
      "x-placement": this.state.placement || attrs.placement
    }), children, !hideArrow && PopperContent___WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(Arrow_defaultExport, {
      className: arrowClassName
    }));
  };

  _proto.render = function render() {
    this.setTargetNode(getTarget(this.props.target));

    if (this.props.isOpen) {
      return this.props.container === 'inline' ? this.renderChildren() : __WEBPACK_IMPORTED_MODULE_7_react_dom___default.a.createPortal(PopperContent___WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement("div", {
        ref: this.getRef
      }, this.renderChildren()), this.getContainerNode());
    }

    return null;
  };

  return PopperContent;
}(PopperContent___WEBPACK_IMPORTED_MODULE_5_react___default.a.Component);

PopperContent_PopperContent.propTypes = PopperContent_propTypes;
PopperContent_PopperContent.defaultProps = PopperContent_defaultProps;
PopperContent_PopperContent.childContextTypes = PopperContent_childContextTypes;
/* harmony default export */ var PopperContent_defaultExport = (PopperContent_PopperContent);
// CONCATENATED MODULE: ./node_modules/reactstrap/es/PopperTargetHelper.js
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_prop_types__ = __webpack_require__(890);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_prop_types__);



var PopperTargetHelper_PopperTargetHelper = function PopperTargetHelper(props, context) {
  context.popperManager.setTargetNode(getTarget(props.target));
  return null;
};

PopperTargetHelper_PopperTargetHelper.contextTypes = {
  popperManager: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.object.isRequired
};
PopperTargetHelper_PopperTargetHelper.propTypes = {
  target: targetPropType.isRequired
};
/* harmony default export */ var PopperTargetHelper_defaultExport = (PopperTargetHelper_PopperTargetHelper);
// CONCATENATED MODULE: ./node_modules/reactstrap/es/TooltipPopoverWrapper.js
/* harmony import */ var TooltipPopoverWrapper___WEBPACK_IMPORTED_MODULE_3_react__ = __webpack_require__(71);
/* harmony import */ var TooltipPopoverWrapper___WEBPACK_IMPORTED_MODULE_3_react___default = __webpack_require__.n(TooltipPopoverWrapper___WEBPACK_IMPORTED_MODULE_3_react__);
/* harmony import */ var TooltipPopoverWrapper___WEBPACK_IMPORTED_MODULE_4_prop_types__ = __webpack_require__(890);
/* harmony import */ var TooltipPopoverWrapper___WEBPACK_IMPORTED_MODULE_4_prop_types___default = __webpack_require__.n(TooltipPopoverWrapper___WEBPACK_IMPORTED_MODULE_4_prop_types__);







var TooltipPopoverWrapper_propTypes = {
  placement: TooltipPopoverWrapper___WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.oneOf(PopperPlacements),
  target: targetPropType.isRequired,
  container: targetPropType,
  isOpen: TooltipPopoverWrapper___WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.bool,
  disabled: TooltipPopoverWrapper___WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.bool,
  hideArrow: TooltipPopoverWrapper___WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.bool,
  boundariesElement: TooltipPopoverWrapper___WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.oneOfType([TooltipPopoverWrapper___WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.string, DOMElement]),
  className: TooltipPopoverWrapper___WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.string,
  innerClassName: TooltipPopoverWrapper___WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.string,
  arrowClassName: TooltipPopoverWrapper___WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.string,
  cssModule: TooltipPopoverWrapper___WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.object,
  toggle: TooltipPopoverWrapper___WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.func,
  autohide: TooltipPopoverWrapper___WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.bool,
  placementPrefix: TooltipPopoverWrapper___WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.string,
  delay: TooltipPopoverWrapper___WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.oneOfType([TooltipPopoverWrapper___WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.shape({
    show: TooltipPopoverWrapper___WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.number,
    hide: TooltipPopoverWrapper___WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.number
  }), TooltipPopoverWrapper___WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.number]),
  modifiers: TooltipPopoverWrapper___WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.object,
  offset: TooltipPopoverWrapper___WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.oneOfType([TooltipPopoverWrapper___WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.string, TooltipPopoverWrapper___WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.number]),
  innerRef: TooltipPopoverWrapper___WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.oneOfType([TooltipPopoverWrapper___WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.func, TooltipPopoverWrapper___WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.string, TooltipPopoverWrapper___WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.object]),
  trigger: TooltipPopoverWrapper___WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.string
};
var DEFAULT_DELAYS = {
  show: 0,
  hide: 250
};
var TooltipPopoverWrapper_defaultProps = {
  isOpen: false,
  hideArrow: false,
  autohide: false,
  delay: DEFAULT_DELAYS,
  toggle: function toggle() {},
  trigger: 'click'
};

function isInDOMSubtree(element, subtreeRoot) {
  return subtreeRoot && (element === subtreeRoot || subtreeRoot.contains(element));
}

var TooltipPopoverWrapper_TooltipPopoverWrapper =
/*#__PURE__*/
function (_React$Component) {
  _inheritsLoose(TooltipPopoverWrapper, _React$Component);

  function TooltipPopoverWrapper(props) {
    var _this;

    _this = _React$Component.call(this, props) || this;
    _this._target = null;
    _this.addTargetEvents = _this.addTargetEvents.bind(_assertThisInitialized(_assertThisInitialized(_this)));
    _this.handleDocumentClick = _this.handleDocumentClick.bind(_assertThisInitialized(_assertThisInitialized(_this)));
    _this.removeTargetEvents = _this.removeTargetEvents.bind(_assertThisInitialized(_assertThisInitialized(_this)));
    _this.toggle = _this.toggle.bind(_assertThisInitialized(_assertThisInitialized(_this)));
    _this.showWithDelay = _this.showWithDelay.bind(_assertThisInitialized(_assertThisInitialized(_this)));
    _this.hideWithDelay = _this.hideWithDelay.bind(_assertThisInitialized(_assertThisInitialized(_this)));
    _this.onMouseOverTooltipContent = _this.onMouseOverTooltipContent.bind(_assertThisInitialized(_assertThisInitialized(_this)));
    _this.onMouseLeaveTooltipContent = _this.onMouseLeaveTooltipContent.bind(_assertThisInitialized(_assertThisInitialized(_this)));
    _this.show = _this.show.bind(_assertThisInitialized(_assertThisInitialized(_this)));
    _this.hide = _this.hide.bind(_assertThisInitialized(_assertThisInitialized(_this)));
    _this.onEscKeyDown = _this.onEscKeyDown.bind(_assertThisInitialized(_assertThisInitialized(_this)));
    _this.getRef = _this.getRef.bind(_assertThisInitialized(_assertThisInitialized(_this)));
    return _this;
  }

  var _proto = TooltipPopoverWrapper.prototype;

  _proto.componentDidMount = function componentDidMount() {
    this.updateTarget();
  };

  _proto.componentWillUnmount = function componentWillUnmount() {
    this.removeTargetEvents();
  };

  _proto.onMouseOverTooltipContent = function onMouseOverTooltipContent() {
    if (this.props.trigger.indexOf('hover') > -1 && !this.props.autohide) {
      if (this._hideTimeout) {
        this.clearHideTimeout();
      }
    }
  };

  _proto.onMouseLeaveTooltipContent = function onMouseLeaveTooltipContent(e) {
    if (this.props.trigger.indexOf('hover') > -1 && !this.props.autohide) {
      if (this._showTimeout) {
        this.clearShowTimeout();
      }

      e.persist();
      this._hideTimeout = setTimeout(this.hide.bind(this, e), this.getDelay('hide'));
    }
  };

  _proto.onEscKeyDown = function onEscKeyDown(e) {
    if (e.key === 'Escape') {
      this.hide(e);
    }
  };

  _proto.getRef = function getRef(ref) {
    var innerRef = this.props.innerRef;

    if (innerRef) {
      if (typeof innerRef === 'function') {
        innerRef(ref);
      } else if (typeof innerRef === 'object') {
        innerRef.current = ref;
      }
    }

    this._popover = ref;
  };

  _proto.getDelay = function getDelay(key) {
    var delay = this.props.delay;

    if (typeof delay === 'object') {
      return isNaN(delay[key]) ? DEFAULT_DELAYS[key] : delay[key];
    }

    return delay;
  };

  _proto.show = function show(e) {
    if (!this.props.isOpen) {
      this.clearShowTimeout();
      this.toggle(e);
    }
  };

  _proto.showWithDelay = function showWithDelay(e) {
    if (this._hideTimeout) {
      this.clearHideTimeout();
    }

    this._showTimeout = setTimeout(this.show.bind(this, e), this.getDelay('show'));
  };

  _proto.hide = function hide(e) {
    if (this.props.isOpen) {
      this.clearHideTimeout();
      this.toggle(e);
    }
  };

  _proto.hideWithDelay = function hideWithDelay(e) {
    if (this._showTimeout) {
      this.clearShowTimeout();
    }

    this._hideTimeout = setTimeout(this.hide.bind(this, e), this.getDelay('hide'));
  };

  _proto.clearShowTimeout = function clearShowTimeout() {
    clearTimeout(this._showTimeout);
    this._showTimeout = undefined;
  };

  _proto.clearHideTimeout = function clearHideTimeout() {
    clearTimeout(this._hideTimeout);
    this._hideTimeout = undefined;
  };

  _proto.handleDocumentClick = function handleDocumentClick(e) {
    var triggers = this.props.trigger.split(' ');

    if (triggers.indexOf('legacy') > -1 && (this.props.isOpen || isInDOMSubtree(e.target, this._target))) {
      if (this._hideTimeout) {
        this.clearHideTimeout();
      }

      if (this.props.isOpen && !isInDOMSubtree(e.target, this._popover)) {
        this.hideWithDelay(e);
      } else {
        this.showWithDelay(e);
      }
    } else if (triggers.indexOf('click') > -1 && isInDOMSubtree(e.target, this._target)) {
      if (this._hideTimeout) {
        this.clearHideTimeout();
      }

      if (!this.props.isOpen) {
        this.showWithDelay(e);
      } else {
        this.hideWithDelay(e);
      }
    }
  };

  _proto.addTargetEvents = function addTargetEvents() {
    var _this2 = this;

    if (this.props.trigger) {
      var triggers = this.props.trigger.split(' ');

      if (triggers.indexOf('manual') === -1) {
        if (triggers.indexOf('click') > -1 || triggers.indexOf('legacy') > -1) {
          ['click', 'touchstart'].forEach(function (event) {
            return document.addEventListener(event, _this2.handleDocumentClick, true);
          });
        }

        if (this._target) {
          if (triggers.indexOf('hover') > -1) {
            this._target.addEventListener('mouseover', this.showWithDelay, true);

            this._target.addEventListener('mouseout', this.hideWithDelay, true);
          }

          if (triggers.indexOf('focus') > -1) {
            this._target.addEventListener('focusin', this.show, true);

            this._target.addEventListener('focusout', this.hide, true);
          }

          this._target.addEventListener('keydown', this.onEscKeyDown, true);
        }
      }
    }
  };

  _proto.removeTargetEvents = function removeTargetEvents() {
    var _this3 = this;

    if (this._target) {
      this._target.removeEventListener('mouseover', this.showWithDelay, true);

      this._target.removeEventListener('mouseout', this.hideWithDelay, true);

      this._target.removeEventListener('keydown', this.onEscKeyDown, true);

      this._target.removeEventListener('focusin', this.show, true);

      this._target.removeEventListener('focusout', this.hide, true);
    }

    ['click', 'touchstart'].forEach(function (event) {
      return document.removeEventListener(event, _this3.handleDocumentClick, true);
    });
  };

  _proto.updateTarget = function updateTarget() {
    var newTarget = getTarget(this.props.target);

    if (newTarget !== this._target) {
      this.removeTargetEvents();
      this._target = newTarget;
      this.addTargetEvents();
    }
  };

  _proto.toggle = function toggle(e) {
    if (this.props.disabled) {
      return e && e.preventDefault();
    }

    return this.props.toggle(e);
  };

  _proto.render = function render() {
    if (!this.props.isOpen) {
      return null;
    }

    this.updateTarget();
    var _this$props = this.props,
        className = _this$props.className,
        cssModule = _this$props.cssModule,
        innerClassName = _this$props.innerClassName,
        target = _this$props.target,
        isOpen = _this$props.isOpen,
        hideArrow = _this$props.hideArrow,
        boundariesElement = _this$props.boundariesElement,
        placement = _this$props.placement,
        placementPrefix = _this$props.placementPrefix,
        arrowClassName = _this$props.arrowClassName,
        container = _this$props.container,
        modifiers = _this$props.modifiers,
        offset = _this$props.offset;
    var attributes = omit(this.props, Object.keys(TooltipPopoverWrapper_propTypes));
    var popperClasses = mapToCssModules(className, cssModule);
    var classes = mapToCssModules(innerClassName, cssModule);
    return TooltipPopoverWrapper___WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(PopperContent_defaultExport, {
      className: popperClasses,
      target: target,
      isOpen: isOpen,
      hideArrow: hideArrow,
      boundariesElement: boundariesElement,
      placement: placement,
      placementPrefix: placementPrefix,
      arrowClassName: arrowClassName,
      container: container,
      modifiers: modifiers,
      offset: offset,
      cssModule: cssModule
    }, TooltipPopoverWrapper___WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement("div", _extends({}, attributes, {
      ref: this.getRef,
      className: classes,
      role: "tooltip",
      "aria-hidden": isOpen,
      onMouseOver: this.onMouseOverTooltipContent,
      onMouseLeave: this.onMouseLeaveTooltipContent,
      onKeyDown: this.onEscKeyDown
    })));
  };

  return TooltipPopoverWrapper;
}(TooltipPopoverWrapper___WEBPACK_IMPORTED_MODULE_3_react___default.a.Component);

TooltipPopoverWrapper_TooltipPopoverWrapper.propTypes = TooltipPopoverWrapper_propTypes;
TooltipPopoverWrapper_TooltipPopoverWrapper.defaultProps = TooltipPopoverWrapper_defaultProps;
/* harmony default export */ var TooltipPopoverWrapper_defaultExport = (TooltipPopoverWrapper_TooltipPopoverWrapper);
// CONCATENATED MODULE: ./node_modules/reactstrap/es/Popover.js
/* harmony import */ var Popover___WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__(71);
/* harmony import */ var Popover___WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(Popover___WEBPACK_IMPORTED_MODULE_1_react__);
/* harmony import */ var Popover___WEBPACK_IMPORTED_MODULE_2_classnames__ = __webpack_require__(891);
/* harmony import */ var Popover___WEBPACK_IMPORTED_MODULE_2_classnames___default = __webpack_require__.n(Popover___WEBPACK_IMPORTED_MODULE_2_classnames__);




var Popover_defaultProps = {
  placement: 'right',
  placementPrefix: 'bs-popover',
  trigger: 'click'
};

var Popover_Popover = function Popover(props) {
  var popperClasses = Popover___WEBPACK_IMPORTED_MODULE_2_classnames___default()('popover', 'show', props.className);
  var classes = Popover___WEBPACK_IMPORTED_MODULE_2_classnames___default()('popover-inner', props.innerClassName);
  return Popover___WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(TooltipPopoverWrapper_defaultExport, _extends({}, props, {
    className: popperClasses,
    innerClassName: classes
  }));
};

Popover_Popover.propTypes = TooltipPopoverWrapper_propTypes;
Popover_Popover.defaultProps = Popover_defaultProps;
/* harmony default export */ var Popover_defaultExport = (Popover_Popover);
// CONCATENATED MODULE: ./node_modules/reactstrap/es/UncontrolledPopover.js
/* harmony import */ var UncontrolledPopover___WEBPACK_IMPORTED_MODULE_4_react__ = __webpack_require__(71);
/* harmony import */ var UncontrolledPopover___WEBPACK_IMPORTED_MODULE_4_react___default = __webpack_require__.n(UncontrolledPopover___WEBPACK_IMPORTED_MODULE_4_react__);
/* harmony import */ var UncontrolledPopover___WEBPACK_IMPORTED_MODULE_5_prop_types__ = __webpack_require__(890);
/* harmony import */ var UncontrolledPopover___WEBPACK_IMPORTED_MODULE_5_prop_types___default = __webpack_require__.n(UncontrolledPopover___WEBPACK_IMPORTED_MODULE_5_prop_types__);








var omitKeys = ['defaultOpen'];

var UncontrolledPopover_UncontrolledPopover =
/*#__PURE__*/
function (_Component) {
  _inheritsLoose(UncontrolledPopover, _Component);

  function UncontrolledPopover(props) {
    var _this;

    _this = _Component.call(this, props) || this;
    _this.state = {
      isOpen: props.defaultOpen || false
    };
    _this.toggle = _this.toggle.bind(_assertThisInitialized(_assertThisInitialized(_this)));
    return _this;
  }

  var _proto = UncontrolledPopover.prototype;

  _proto.toggle = function toggle() {
    this.setState({
      isOpen: !this.state.isOpen
    });
  };

  _proto.render = function render() {
    return UncontrolledPopover___WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(Popover_defaultExport, _extends({
      isOpen: this.state.isOpen,
      toggle: this.toggle
    }, omit(this.props, omitKeys)));
  };

  return UncontrolledPopover;
}(UncontrolledPopover___WEBPACK_IMPORTED_MODULE_4_react__["Component"]);


UncontrolledPopover_UncontrolledPopover.propTypes = _objectSpread({
  defaultOpen: UncontrolledPopover___WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.bool
}, Popover_defaultExport.propTypes);
// CONCATENATED MODULE: ./node_modules/reactstrap/es/PopoverHeader.js
/* harmony import */ var PopoverHeader___WEBPACK_IMPORTED_MODULE_2_react__ = __webpack_require__(71);
/* harmony import */ var PopoverHeader___WEBPACK_IMPORTED_MODULE_2_react___default = __webpack_require__.n(PopoverHeader___WEBPACK_IMPORTED_MODULE_2_react__);
/* harmony import */ var PopoverHeader___WEBPACK_IMPORTED_MODULE_3_prop_types__ = __webpack_require__(890);
/* harmony import */ var PopoverHeader___WEBPACK_IMPORTED_MODULE_3_prop_types___default = __webpack_require__.n(PopoverHeader___WEBPACK_IMPORTED_MODULE_3_prop_types__);
/* harmony import */ var PopoverHeader___WEBPACK_IMPORTED_MODULE_4_classnames__ = __webpack_require__(891);
/* harmony import */ var PopoverHeader___WEBPACK_IMPORTED_MODULE_4_classnames___default = __webpack_require__.n(PopoverHeader___WEBPACK_IMPORTED_MODULE_4_classnames__);






var PopoverHeader_propTypes = {
  tag: tagPropType,
  className: PopoverHeader___WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.string,
  cssModule: PopoverHeader___WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.object
};
var PopoverHeader_defaultProps = {
  tag: 'h3'
};

var PopoverHeader_PopoverHeader = function PopoverHeader(props) {
  var className = props.className,
      cssModule = props.cssModule,
      Tag = props.tag,
      attributes = _objectWithoutPropertiesLoose(props, ["className", "cssModule", "tag"]);

  var classes = mapToCssModules(PopoverHeader___WEBPACK_IMPORTED_MODULE_4_classnames___default()(className, 'popover-header'), cssModule);
  return PopoverHeader___WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(Tag, _extends({}, attributes, {
    className: classes
  }));
};

PopoverHeader_PopoverHeader.propTypes = PopoverHeader_propTypes;
PopoverHeader_PopoverHeader.defaultProps = PopoverHeader_defaultProps;
/* harmony default export */ var PopoverHeader_defaultExport = (PopoverHeader_PopoverHeader);
// CONCATENATED MODULE: ./node_modules/reactstrap/es/PopoverTitle.js
/* harmony import */ var PopoverTitle___WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(71);
/* harmony import */ var PopoverTitle___WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(PopoverTitle___WEBPACK_IMPORTED_MODULE_0_react__);



function PopoverTitle(props) {
  warnOnce('The "PopoverTitle" component has been deprecated.\nPlease use component "PopoverHeader".');
  return PopoverTitle___WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(PopoverHeader_defaultExport, props);
}
// CONCATENATED MODULE: ./node_modules/reactstrap/es/PopoverBody.js
/* harmony import */ var PopoverBody___WEBPACK_IMPORTED_MODULE_2_react__ = __webpack_require__(71);
/* harmony import */ var PopoverBody___WEBPACK_IMPORTED_MODULE_2_react___default = __webpack_require__.n(PopoverBody___WEBPACK_IMPORTED_MODULE_2_react__);
/* harmony import */ var PopoverBody___WEBPACK_IMPORTED_MODULE_3_prop_types__ = __webpack_require__(890);
/* harmony import */ var PopoverBody___WEBPACK_IMPORTED_MODULE_3_prop_types___default = __webpack_require__.n(PopoverBody___WEBPACK_IMPORTED_MODULE_3_prop_types__);
/* harmony import */ var PopoverBody___WEBPACK_IMPORTED_MODULE_4_classnames__ = __webpack_require__(891);
/* harmony import */ var PopoverBody___WEBPACK_IMPORTED_MODULE_4_classnames___default = __webpack_require__.n(PopoverBody___WEBPACK_IMPORTED_MODULE_4_classnames__);






var PopoverBody_propTypes = {
  tag: tagPropType,
  className: PopoverBody___WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.string,
  cssModule: PopoverBody___WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.object
};
var PopoverBody_defaultProps = {
  tag: 'div'
};

var PopoverBody_PopoverBody = function PopoverBody(props) {
  var className = props.className,
      cssModule = props.cssModule,
      Tag = props.tag,
      attributes = _objectWithoutPropertiesLoose(props, ["className", "cssModule", "tag"]);

  var classes = mapToCssModules(PopoverBody___WEBPACK_IMPORTED_MODULE_4_classnames___default()(className, 'popover-body'), cssModule);
  return PopoverBody___WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(Tag, _extends({}, attributes, {
    className: classes
  }));
};

PopoverBody_PopoverBody.propTypes = PopoverBody_propTypes;
PopoverBody_PopoverBody.defaultProps = PopoverBody_defaultProps;
/* harmony default export */ var PopoverBody_defaultExport = (PopoverBody_PopoverBody);
// CONCATENATED MODULE: ./node_modules/reactstrap/es/PopoverContent.js
/* harmony import */ var PopoverContent___WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(71);
/* harmony import */ var PopoverContent___WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(PopoverContent___WEBPACK_IMPORTED_MODULE_0_react__);



function PopoverContent(props) {
  warnOnce('The "PopoverContent" component has been deprecated.\nPlease use component "PopoverBody".');
  return PopoverContent___WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(PopoverBody_defaultExport, props);
}
// CONCATENATED MODULE: ./node_modules/reactstrap/es/Progress.js
/* harmony import */ var Progress___WEBPACK_IMPORTED_MODULE_2_react__ = __webpack_require__(71);
/* harmony import */ var Progress___WEBPACK_IMPORTED_MODULE_2_react___default = __webpack_require__.n(Progress___WEBPACK_IMPORTED_MODULE_2_react__);
/* harmony import */ var Progress___WEBPACK_IMPORTED_MODULE_3_prop_types__ = __webpack_require__(890);
/* harmony import */ var Progress___WEBPACK_IMPORTED_MODULE_3_prop_types___default = __webpack_require__.n(Progress___WEBPACK_IMPORTED_MODULE_3_prop_types__);
/* harmony import */ var Progress___WEBPACK_IMPORTED_MODULE_4_classnames__ = __webpack_require__(891);
/* harmony import */ var Progress___WEBPACK_IMPORTED_MODULE_4_classnames___default = __webpack_require__.n(Progress___WEBPACK_IMPORTED_MODULE_4_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_lodash_tonumber__ = __webpack_require__(1220);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_lodash_tonumber___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_lodash_tonumber__);







var Progress_propTypes = {
  children: Progress___WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.node,
  bar: Progress___WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.bool,
  multi: Progress___WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.bool,
  tag: tagPropType,
  value: Progress___WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.oneOfType([Progress___WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.string, Progress___WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.number]),
  max: Progress___WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.oneOfType([Progress___WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.string, Progress___WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.number]),
  animated: Progress___WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.bool,
  striped: Progress___WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.bool,
  color: Progress___WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.string,
  className: Progress___WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.string,
  barClassName: Progress___WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.string,
  cssModule: Progress___WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.object
};
var Progress_defaultProps = {
  tag: 'div',
  value: 0,
  max: 100
};

var Progress_Progress = function Progress(props) {
  var children = props.children,
      className = props.className,
      barClassName = props.barClassName,
      cssModule = props.cssModule,
      value = props.value,
      max = props.max,
      animated = props.animated,
      striped = props.striped,
      color = props.color,
      bar = props.bar,
      multi = props.multi,
      Tag = props.tag,
      attributes = _objectWithoutPropertiesLoose(props, ["children", "className", "barClassName", "cssModule", "value", "max", "animated", "striped", "color", "bar", "multi", "tag"]);

  var percent = __WEBPACK_IMPORTED_MODULE_5_lodash_tonumber___default()(value) / __WEBPACK_IMPORTED_MODULE_5_lodash_tonumber___default()(max) * 100;
  var progressClasses = mapToCssModules(Progress___WEBPACK_IMPORTED_MODULE_4_classnames___default()(className, 'progress'), cssModule);
  var progressBarClasses = mapToCssModules(Progress___WEBPACK_IMPORTED_MODULE_4_classnames___default()('progress-bar', bar ? className || barClassName : barClassName, animated ? 'progress-bar-animated' : null, color ? "bg-" + color : null, striped || animated ? 'progress-bar-striped' : null), cssModule);
  var ProgressBar = multi ? children : Progress___WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement("div", {
    className: progressBarClasses,
    style: {
      width: percent + "%"
    },
    role: "progressbar",
    "aria-valuenow": value,
    "aria-valuemin": "0",
    "aria-valuemax": max,
    children: children
  });

  if (bar) {
    return ProgressBar;
  }

  return Progress___WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(Tag, _extends({}, attributes, {
    className: progressClasses,
    children: ProgressBar
  }));
};

Progress_Progress.propTypes = Progress_propTypes;
Progress_Progress.defaultProps = Progress_defaultProps;
/* harmony default export */ var Progress_defaultExport = (Progress_Progress);
// CONCATENATED MODULE: ./node_modules/reactstrap/es/Portal.js
/* harmony import */ var Portal___WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__(71);
/* harmony import */ var Portal___WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(Portal___WEBPACK_IMPORTED_MODULE_1_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_dom__ = __webpack_require__(420);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_dom___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_react_dom__);
/* harmony import */ var Portal___WEBPACK_IMPORTED_MODULE_3_prop_types__ = __webpack_require__(890);
/* harmony import */ var Portal___WEBPACK_IMPORTED_MODULE_3_prop_types___default = __webpack_require__.n(Portal___WEBPACK_IMPORTED_MODULE_3_prop_types__);





var Portal_propTypes = {
  children: Portal___WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.node.isRequired,
  node: Portal___WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.any
};

var Portal_Portal =
/*#__PURE__*/
function (_React$Component) {
  _inheritsLoose(Portal, _React$Component);

  function Portal() {
    return _React$Component.apply(this, arguments) || this;
  }

  var _proto = Portal.prototype;

  _proto.componentWillUnmount = function componentWillUnmount() {
    if (this.defaultNode) {
      document.body.removeChild(this.defaultNode);
    }

    this.defaultNode = null;
  };

  _proto.render = function render() {
    if (!canUseDOM) {
      return null;
    }

    if (!this.props.node && !this.defaultNode) {
      this.defaultNode = document.createElement('div');
      document.body.appendChild(this.defaultNode);
    }

    return __WEBPACK_IMPORTED_MODULE_2_react_dom___default.a.createPortal(this.props.children, this.props.node || this.defaultNode);
  };

  return Portal;
}(Portal___WEBPACK_IMPORTED_MODULE_1_react___default.a.Component);

Portal_Portal.propTypes = Portal_propTypes;
/* harmony default export */ var Portal_defaultExport = (Portal_Portal);
// CONCATENATED MODULE: ./node_modules/reactstrap/es/Modal.js
/* harmony import */ var Modal___WEBPACK_IMPORTED_MODULE_4_react__ = __webpack_require__(71);
/* harmony import */ var Modal___WEBPACK_IMPORTED_MODULE_4_react___default = __webpack_require__.n(Modal___WEBPACK_IMPORTED_MODULE_4_react__);
/* harmony import */ var Modal___WEBPACK_IMPORTED_MODULE_5_prop_types__ = __webpack_require__(890);
/* harmony import */ var Modal___WEBPACK_IMPORTED_MODULE_5_prop_types___default = __webpack_require__.n(Modal___WEBPACK_IMPORTED_MODULE_5_prop_types__);
/* harmony import */ var Modal___WEBPACK_IMPORTED_MODULE_6_classnames__ = __webpack_require__(891);
/* harmony import */ var Modal___WEBPACK_IMPORTED_MODULE_6_classnames___default = __webpack_require__.n(Modal___WEBPACK_IMPORTED_MODULE_6_classnames__);











function noop() {}

var FadePropTypes = Modal___WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.shape(Fade_defaultExport.propTypes);
var Modal_propTypes = {
  isOpen: Modal___WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.bool,
  autoFocus: Modal___WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.bool,
  centered: Modal___WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.bool,
  size: Modal___WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.string,
  toggle: Modal___WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.func,
  keyboard: Modal___WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.bool,
  role: Modal___WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.string,
  labelledBy: Modal___WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.string,
  backdrop: Modal___WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.oneOfType([Modal___WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.bool, Modal___WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.oneOf(['static'])]),
  onEnter: Modal___WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.func,
  onExit: Modal___WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.func,
  onOpened: Modal___WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.func,
  onClosed: Modal___WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.func,
  children: Modal___WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.node,
  className: Modal___WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.string,
  wrapClassName: Modal___WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.string,
  modalClassName: Modal___WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.string,
  backdropClassName: Modal___WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.string,
  contentClassName: Modal___WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.string,
  external: Modal___WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.node,
  fade: Modal___WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.bool,
  cssModule: Modal___WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.object,
  zIndex: Modal___WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.oneOfType([Modal___WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.number, Modal___WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.string]),
  backdropTransition: FadePropTypes,
  modalTransition: FadePropTypes,
  innerRef: Modal___WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.oneOfType([Modal___WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.object, Modal___WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.string, Modal___WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.func])
};
var propsToOmit = Object.keys(Modal_propTypes);
var Modal_defaultProps = {
  isOpen: false,
  autoFocus: true,
  centered: false,
  role: 'dialog',
  backdrop: true,
  keyboard: true,
  zIndex: 1050,
  fade: true,
  onOpened: noop,
  onClosed: noop,
  modalTransition: {
    timeout: TransitionTimeouts.Modal
  },
  backdropTransition: {
    mountOnEnter: true,
    timeout: TransitionTimeouts.Fade // uses standard fade transition

  }
};

var Modal_Modal =
/*#__PURE__*/
function (_React$Component) {
  _inheritsLoose(Modal, _React$Component);

  function Modal(props) {
    var _this;

    _this = _React$Component.call(this, props) || this;
    _this._element = null;
    _this._originalBodyPadding = null;
    _this.getFocusableChildren = _this.getFocusableChildren.bind(_assertThisInitialized(_assertThisInitialized(_this)));
    _this.handleBackdropClick = _this.handleBackdropClick.bind(_assertThisInitialized(_assertThisInitialized(_this)));
    _this.handleBackdropMouseDown = _this.handleBackdropMouseDown.bind(_assertThisInitialized(_assertThisInitialized(_this)));
    _this.handleEscape = _this.handleEscape.bind(_assertThisInitialized(_assertThisInitialized(_this)));
    _this.handleTab = _this.handleTab.bind(_assertThisInitialized(_assertThisInitialized(_this)));
    _this.onOpened = _this.onOpened.bind(_assertThisInitialized(_assertThisInitialized(_this)));
    _this.onClosed = _this.onClosed.bind(_assertThisInitialized(_assertThisInitialized(_this)));
    _this.state = {
      isOpen: props.isOpen
    };

    if (props.isOpen) {
      _this.init();
    }

    return _this;
  }

  var _proto = Modal.prototype;

  _proto.componentDidMount = function componentDidMount() {
    if (this.props.onEnter) {
      this.props.onEnter();
    }

    if (this.state.isOpen && this.props.autoFocus) {
      this.setFocus();
    }

    this._isMounted = true;
  };

  _proto.componentWillReceiveProps = function componentWillReceiveProps(nextProps) {
    if (nextProps.isOpen && !this.props.isOpen) {
      this.setState({
        isOpen: nextProps.isOpen
      });
    }
  };

  _proto.componentWillUpdate = function componentWillUpdate(nextProps, nextState) {
    if (nextState.isOpen && !this.state.isOpen) {
      this.init();
    }
  };

  _proto.componentDidUpdate = function componentDidUpdate(prevProps, prevState) {
    if (this.props.autoFocus && this.state.isOpen && !prevState.isOpen) {
      this.setFocus();
    }

    if (this._element && prevProps.zIndex !== this.props.zIndex) {
      this._element.style.zIndex = this.props.zIndex;
    }
  };

  _proto.componentWillUnmount = function componentWillUnmount() {
    if (this.props.onExit) {
      this.props.onExit();
    }

    if (this.state.isOpen) {
      this.destroy();
    }

    this._isMounted = false;
  };

  _proto.onOpened = function onOpened(node, isAppearing) {
    this.props.onOpened();
    (this.props.modalTransition.onEntered || noop)(node, isAppearing);
  };

  _proto.onClosed = function onClosed(node) {
    // so all methods get called before it is unmounted
    this.props.onClosed();
    (this.props.modalTransition.onExited || noop)(node);
    this.destroy();

    if (this._isMounted) {
      this.setState({
        isOpen: false
      });
    }
  };

  _proto.setFocus = function setFocus() {
    if (this._dialog && this._dialog.parentNode && typeof this._dialog.parentNode.focus === 'function') {
      this._dialog.parentNode.focus();
    }
  };

  _proto.getFocusableChildren = function getFocusableChildren() {
    return this._element.querySelectorAll(focusableElements.join(', '));
  };

  _proto.getFocusedChild = function getFocusedChild() {
    var currentFocus;
    var focusableChildren = this.getFocusableChildren();

    try {
      currentFocus = document.activeElement;
    } catch (err) {
      currentFocus = focusableChildren[0];
    }

    return currentFocus;
  } // not mouseUp because scrollbar fires it, shouldn't close when user scrolls
  ;

  _proto.handleBackdropClick = function handleBackdropClick(e) {
    if (e.target === this._mouseDownElement) {
      e.stopPropagation();
      if (!this.props.isOpen || this.props.backdrop !== true) return;
      var backdrop = this._dialog ? this._dialog.parentNode : null;

      if (backdrop && e.target === backdrop && this.props.toggle) {
        this.props.toggle(e);
      }
    }
  };

  _proto.handleTab = function handleTab(e) {
    if (e.which !== 9) return;
    var focusableChildren = this.getFocusableChildren();
    var totalFocusable = focusableChildren.length;
    var currentFocus = this.getFocusedChild();
    var focusedIndex = 0;

    for (var i = 0; i < totalFocusable; i += 1) {
      if (focusableChildren[i] === currentFocus) {
        focusedIndex = i;
        break;
      }
    }

    if (e.shiftKey && focusedIndex === 0) {
      e.preventDefault();
      focusableChildren[totalFocusable - 1].focus();
    } else if (!e.shiftKey && focusedIndex === totalFocusable - 1) {
      e.preventDefault();
      focusableChildren[0].focus();
    }
  };

  _proto.handleBackdropMouseDown = function handleBackdropMouseDown(e) {
    this._mouseDownElement = e.target;
  };

  _proto.handleEscape = function handleEscape(e) {
    if (this.props.isOpen && this.props.keyboard && e.keyCode === 27 && this.props.toggle) {
      e.preventDefault();
      e.stopPropagation();
      this.props.toggle(e);
    }
  };

  _proto.init = function init() {
    try {
      this._triggeringElement = document.activeElement;
    } catch (err) {
      this._triggeringElement = null;
    }

    this._element = document.createElement('div');

    this._element.setAttribute('tabindex', '-1');

    this._element.style.position = 'relative';
    this._element.style.zIndex = this.props.zIndex;
    this._originalBodyPadding = getOriginalBodyPadding();
    conditionallyUpdateScrollbar();
    document.body.appendChild(this._element);

    if (Modal.openCount === 0) {
      document.body.className = Modal___WEBPACK_IMPORTED_MODULE_6_classnames___default()(document.body.className, mapToCssModules('modal-open', this.props.cssModule));
    }

    Modal.openCount += 1;
  };

  _proto.destroy = function destroy() {
    if (this._element) {
      document.body.removeChild(this._element);
      this._element = null;
    }

    if (this._triggeringElement) {
      if (this._triggeringElement.focus) this._triggeringElement.focus();
      this._triggeringElement = null;
    }

    if (Modal.openCount <= 1) {
      var modalOpenClassName = mapToCssModules('modal-open', this.props.cssModule); // Use regex to prevent matching `modal-open` as part of a different class, e.g. `my-modal-opened`

      var modalOpenClassNameRegex = new RegExp("(^| )" + modalOpenClassName + "( |$)");
      document.body.className = document.body.className.replace(modalOpenClassNameRegex, ' ').trim();
    }

    Modal.openCount -= 1;
    setScrollbarWidth(this._originalBodyPadding);
  };

  _proto.renderModalDialog = function renderModalDialog() {
    var _classNames,
        _this2 = this;

    var attributes = omit(this.props, propsToOmit);
    var dialogBaseClass = 'modal-dialog';
    return Modal___WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement("div", _extends({}, attributes, {
      className: mapToCssModules(Modal___WEBPACK_IMPORTED_MODULE_6_classnames___default()(dialogBaseClass, this.props.className, (_classNames = {}, _classNames["modal-" + this.props.size] = this.props.size, _classNames[dialogBaseClass + "-centered"] = this.props.centered, _classNames)), this.props.cssModule),
      role: "document",
      ref: function ref(c) {
        _this2._dialog = c;
      }
    }), Modal___WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement("div", {
      className: mapToCssModules(Modal___WEBPACK_IMPORTED_MODULE_6_classnames___default()('modal-content', this.props.contentClassName), this.props.cssModule)
    }, this.props.children));
  };

  _proto.render = function render() {
    if (this.state.isOpen) {
      var _this$props = this.props,
          wrapClassName = _this$props.wrapClassName,
          modalClassName = _this$props.modalClassName,
          backdropClassName = _this$props.backdropClassName,
          cssModule = _this$props.cssModule,
          isOpen = _this$props.isOpen,
          backdrop = _this$props.backdrop,
          role = _this$props.role,
          labelledBy = _this$props.labelledBy,
          external = _this$props.external,
          innerRef = _this$props.innerRef;
      var modalAttributes = {
        onClick: this.handleBackdropClick,
        onMouseDown: this.handleBackdropMouseDown,
        onKeyUp: this.handleEscape,
        onKeyDown: this.handleTab,
        style: {
          display: 'block'
        },
        'aria-labelledby': labelledBy,
        role: role,
        tabIndex: '-1'
      };
      var hasTransition = this.props.fade;

      var modalTransition = _objectSpread({}, Fade_defaultExport.defaultProps, this.props.modalTransition, {
        baseClass: hasTransition ? this.props.modalTransition.baseClass : '',
        timeout: hasTransition ? this.props.modalTransition.timeout : 0
      });

      var backdropTransition = _objectSpread({}, Fade_defaultExport.defaultProps, this.props.backdropTransition, {
        baseClass: hasTransition ? this.props.backdropTransition.baseClass : '',
        timeout: hasTransition ? this.props.backdropTransition.timeout : 0
      });

      var Backdrop = backdrop && (hasTransition ? Modal___WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(Fade_defaultExport, _extends({}, backdropTransition, {
        in: isOpen && !!backdrop,
        cssModule: cssModule,
        className: mapToCssModules(Modal___WEBPACK_IMPORTED_MODULE_6_classnames___default()('modal-backdrop', backdropClassName), cssModule)
      })) : Modal___WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement("div", {
        className: mapToCssModules(Modal___WEBPACK_IMPORTED_MODULE_6_classnames___default()('modal-backdrop', 'show', backdropClassName), cssModule)
      }));
      return Modal___WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(Portal_defaultExport, {
        node: this._element
      }, Modal___WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement("div", {
        className: mapToCssModules(wrapClassName)
      }, Modal___WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(Fade_defaultExport, _extends({}, modalAttributes, modalTransition, {
        in: isOpen,
        onEntered: this.onOpened,
        onExited: this.onClosed,
        cssModule: cssModule,
        className: mapToCssModules(Modal___WEBPACK_IMPORTED_MODULE_6_classnames___default()('modal', modalClassName), cssModule),
        innerRef: innerRef
      }), external, this.renderModalDialog()), Backdrop));
    }

    return null;
  };

  return Modal;
}(Modal___WEBPACK_IMPORTED_MODULE_4_react___default.a.Component);

Modal_Modal.propTypes = Modal_propTypes;
Modal_Modal.defaultProps = Modal_defaultProps;
Modal_Modal.openCount = 0;
/* harmony default export */ var Modal_defaultExport = (Modal_Modal);
// CONCATENATED MODULE: ./node_modules/reactstrap/es/ModalHeader.js
/* harmony import */ var ModalHeader___WEBPACK_IMPORTED_MODULE_2_react__ = __webpack_require__(71);
/* harmony import */ var ModalHeader___WEBPACK_IMPORTED_MODULE_2_react___default = __webpack_require__.n(ModalHeader___WEBPACK_IMPORTED_MODULE_2_react__);
/* harmony import */ var ModalHeader___WEBPACK_IMPORTED_MODULE_3_prop_types__ = __webpack_require__(890);
/* harmony import */ var ModalHeader___WEBPACK_IMPORTED_MODULE_3_prop_types___default = __webpack_require__.n(ModalHeader___WEBPACK_IMPORTED_MODULE_3_prop_types__);
/* harmony import */ var ModalHeader___WEBPACK_IMPORTED_MODULE_4_classnames__ = __webpack_require__(891);
/* harmony import */ var ModalHeader___WEBPACK_IMPORTED_MODULE_4_classnames___default = __webpack_require__.n(ModalHeader___WEBPACK_IMPORTED_MODULE_4_classnames__);






var ModalHeader_propTypes = {
  tag: tagPropType,
  wrapTag: tagPropType,
  toggle: ModalHeader___WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.func,
  className: ModalHeader___WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.string,
  cssModule: ModalHeader___WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.object,
  children: ModalHeader___WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.node,
  closeAriaLabel: ModalHeader___WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.string,
  charCode: ModalHeader___WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.oneOfType([ModalHeader___WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.string, ModalHeader___WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.number]),
  close: ModalHeader___WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.object
};
var ModalHeader_defaultProps = {
  tag: 'h5',
  wrapTag: 'div',
  closeAriaLabel: 'Close',
  charCode: 215
};

var ModalHeader_ModalHeader = function ModalHeader(props) {
  var closeButton;

  var className = props.className,
      cssModule = props.cssModule,
      children = props.children,
      toggle = props.toggle,
      Tag = props.tag,
      WrapTag = props.wrapTag,
      closeAriaLabel = props.closeAriaLabel,
      charCode = props.charCode,
      close = props.close,
      attributes = _objectWithoutPropertiesLoose(props, ["className", "cssModule", "children", "toggle", "tag", "wrapTag", "closeAriaLabel", "charCode", "close"]);

  var classes = mapToCssModules(ModalHeader___WEBPACK_IMPORTED_MODULE_4_classnames___default()(className, 'modal-header'), cssModule);

  if (!close && toggle) {
    var closeIcon = typeof charCode === 'number' ? String.fromCharCode(charCode) : charCode;
    closeButton = ModalHeader___WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement("button", {
      type: "button",
      onClick: toggle,
      className: mapToCssModules('close', cssModule),
      "aria-label": closeAriaLabel
    }, ModalHeader___WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement("span", {
      "aria-hidden": "true"
    }, closeIcon));
  }

  return ModalHeader___WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(WrapTag, _extends({}, attributes, {
    className: classes
  }), ModalHeader___WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(Tag, {
    className: mapToCssModules('modal-title', cssModule)
  }, children), close || closeButton);
};

ModalHeader_ModalHeader.propTypes = ModalHeader_propTypes;
ModalHeader_ModalHeader.defaultProps = ModalHeader_defaultProps;
/* harmony default export */ var ModalHeader_defaultExport = (ModalHeader_ModalHeader);
// CONCATENATED MODULE: ./node_modules/reactstrap/es/ModalBody.js
/* harmony import */ var ModalBody___WEBPACK_IMPORTED_MODULE_2_react__ = __webpack_require__(71);
/* harmony import */ var ModalBody___WEBPACK_IMPORTED_MODULE_2_react___default = __webpack_require__.n(ModalBody___WEBPACK_IMPORTED_MODULE_2_react__);
/* harmony import */ var ModalBody___WEBPACK_IMPORTED_MODULE_3_prop_types__ = __webpack_require__(890);
/* harmony import */ var ModalBody___WEBPACK_IMPORTED_MODULE_3_prop_types___default = __webpack_require__.n(ModalBody___WEBPACK_IMPORTED_MODULE_3_prop_types__);
/* harmony import */ var ModalBody___WEBPACK_IMPORTED_MODULE_4_classnames__ = __webpack_require__(891);
/* harmony import */ var ModalBody___WEBPACK_IMPORTED_MODULE_4_classnames___default = __webpack_require__.n(ModalBody___WEBPACK_IMPORTED_MODULE_4_classnames__);






var ModalBody_propTypes = {
  tag: tagPropType,
  className: ModalBody___WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.string,
  cssModule: ModalBody___WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.object
};
var ModalBody_defaultProps = {
  tag: 'div'
};

var ModalBody_ModalBody = function ModalBody(props) {
  var className = props.className,
      cssModule = props.cssModule,
      Tag = props.tag,
      attributes = _objectWithoutPropertiesLoose(props, ["className", "cssModule", "tag"]);

  var classes = mapToCssModules(ModalBody___WEBPACK_IMPORTED_MODULE_4_classnames___default()(className, 'modal-body'), cssModule);
  return ModalBody___WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(Tag, _extends({}, attributes, {
    className: classes
  }));
};

ModalBody_ModalBody.propTypes = ModalBody_propTypes;
ModalBody_ModalBody.defaultProps = ModalBody_defaultProps;
/* harmony default export */ var ModalBody_defaultExport = (ModalBody_ModalBody);
// CONCATENATED MODULE: ./node_modules/reactstrap/es/ModalFooter.js
/* harmony import */ var ModalFooter___WEBPACK_IMPORTED_MODULE_2_react__ = __webpack_require__(71);
/* harmony import */ var ModalFooter___WEBPACK_IMPORTED_MODULE_2_react___default = __webpack_require__.n(ModalFooter___WEBPACK_IMPORTED_MODULE_2_react__);
/* harmony import */ var ModalFooter___WEBPACK_IMPORTED_MODULE_3_prop_types__ = __webpack_require__(890);
/* harmony import */ var ModalFooter___WEBPACK_IMPORTED_MODULE_3_prop_types___default = __webpack_require__.n(ModalFooter___WEBPACK_IMPORTED_MODULE_3_prop_types__);
/* harmony import */ var ModalFooter___WEBPACK_IMPORTED_MODULE_4_classnames__ = __webpack_require__(891);
/* harmony import */ var ModalFooter___WEBPACK_IMPORTED_MODULE_4_classnames___default = __webpack_require__.n(ModalFooter___WEBPACK_IMPORTED_MODULE_4_classnames__);






var ModalFooter_propTypes = {
  tag: tagPropType,
  className: ModalFooter___WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.string,
  cssModule: ModalFooter___WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.object
};
var ModalFooter_defaultProps = {
  tag: 'div'
};

var ModalFooter_ModalFooter = function ModalFooter(props) {
  var className = props.className,
      cssModule = props.cssModule,
      Tag = props.tag,
      attributes = _objectWithoutPropertiesLoose(props, ["className", "cssModule", "tag"]);

  var classes = mapToCssModules(ModalFooter___WEBPACK_IMPORTED_MODULE_4_classnames___default()(className, 'modal-footer'), cssModule);
  return ModalFooter___WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(Tag, _extends({}, attributes, {
    className: classes
  }));
};

ModalFooter_ModalFooter.propTypes = ModalFooter_propTypes;
ModalFooter_ModalFooter.defaultProps = ModalFooter_defaultProps;
/* harmony default export */ var ModalFooter_defaultExport = (ModalFooter_ModalFooter);
// CONCATENATED MODULE: ./node_modules/reactstrap/es/Tooltip.js
/* harmony import */ var Tooltip___WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__(71);
/* harmony import */ var Tooltip___WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(Tooltip___WEBPACK_IMPORTED_MODULE_1_react__);
/* harmony import */ var Tooltip___WEBPACK_IMPORTED_MODULE_2_classnames__ = __webpack_require__(891);
/* harmony import */ var Tooltip___WEBPACK_IMPORTED_MODULE_2_classnames___default = __webpack_require__.n(Tooltip___WEBPACK_IMPORTED_MODULE_2_classnames__);




var Tooltip_defaultProps = {
  placement: 'top',
  autohide: true,
  placementPrefix: 'bs-tooltip',
  trigger: 'click hover focus'
};

var Tooltip_Tooltip = function Tooltip(props) {
  var popperClasses = Tooltip___WEBPACK_IMPORTED_MODULE_2_classnames___default()('tooltip', 'show', props.className);
  var classes = Tooltip___WEBPACK_IMPORTED_MODULE_2_classnames___default()('tooltip-inner', props.innerClassName);
  return Tooltip___WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(TooltipPopoverWrapper_defaultExport, _extends({}, props, {
    className: popperClasses,
    innerClassName: classes
  }));
};

Tooltip_Tooltip.propTypes = TooltipPopoverWrapper_propTypes;
Tooltip_Tooltip.defaultProps = Tooltip_defaultProps;
/* harmony default export */ var Tooltip_defaultExport = (Tooltip_Tooltip);
// CONCATENATED MODULE: ./node_modules/reactstrap/es/Table.js
/* harmony import */ var Table___WEBPACK_IMPORTED_MODULE_2_react__ = __webpack_require__(71);
/* harmony import */ var Table___WEBPACK_IMPORTED_MODULE_2_react___default = __webpack_require__.n(Table___WEBPACK_IMPORTED_MODULE_2_react__);
/* harmony import */ var Table___WEBPACK_IMPORTED_MODULE_3_prop_types__ = __webpack_require__(890);
/* harmony import */ var Table___WEBPACK_IMPORTED_MODULE_3_prop_types___default = __webpack_require__.n(Table___WEBPACK_IMPORTED_MODULE_3_prop_types__);
/* harmony import */ var Table___WEBPACK_IMPORTED_MODULE_4_classnames__ = __webpack_require__(891);
/* harmony import */ var Table___WEBPACK_IMPORTED_MODULE_4_classnames___default = __webpack_require__.n(Table___WEBPACK_IMPORTED_MODULE_4_classnames__);






var Table_propTypes = {
  className: Table___WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.string,
  cssModule: Table___WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.object,
  size: Table___WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.string,
  bordered: Table___WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.bool,
  borderless: Table___WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.bool,
  striped: Table___WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.bool,
  inverse: deprecated(Table___WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.bool, 'Please use the prop "dark"'),
  dark: Table___WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.bool,
  hover: Table___WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.bool,
  responsive: Table___WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.oneOfType([Table___WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.bool, Table___WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.string]),
  tag: tagPropType,
  responsiveTag: tagPropType,
  innerRef: Table___WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.oneOfType([Table___WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.func, Table___WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.string, Table___WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.object])
};
var Table_defaultProps = {
  tag: 'table',
  responsiveTag: 'div'
};

var Table_Table = function Table(props) {
  var className = props.className,
      cssModule = props.cssModule,
      size = props.size,
      bordered = props.bordered,
      borderless = props.borderless,
      striped = props.striped,
      inverse = props.inverse,
      dark = props.dark,
      hover = props.hover,
      responsive = props.responsive,
      Tag = props.tag,
      ResponsiveTag = props.responsiveTag,
      innerRef = props.innerRef,
      attributes = _objectWithoutPropertiesLoose(props, ["className", "cssModule", "size", "bordered", "borderless", "striped", "inverse", "dark", "hover", "responsive", "tag", "responsiveTag", "innerRef"]);

  var classes = mapToCssModules(Table___WEBPACK_IMPORTED_MODULE_4_classnames___default()(className, 'table', size ? 'table-' + size : false, bordered ? 'table-bordered' : false, borderless ? 'table-borderless' : false, striped ? 'table-striped' : false, dark || inverse ? 'table-dark' : false, hover ? 'table-hover' : false), cssModule);
  var table = Table___WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(Tag, _extends({}, attributes, {
    ref: innerRef,
    className: classes
  }));

  if (responsive) {
    var responsiveClassName = responsive === true ? 'table-responsive' : "table-responsive-" + responsive;
    return Table___WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(ResponsiveTag, {
      className: responsiveClassName
    }, table);
  }

  return table;
};

Table_Table.propTypes = Table_propTypes;
Table_Table.defaultProps = Table_defaultProps;
/* harmony default export */ var Table_defaultExport = (Table_Table);
// CONCATENATED MODULE: ./node_modules/reactstrap/es/ListGroup.js
/* harmony import */ var ListGroup___WEBPACK_IMPORTED_MODULE_2_react__ = __webpack_require__(71);
/* harmony import */ var ListGroup___WEBPACK_IMPORTED_MODULE_2_react___default = __webpack_require__.n(ListGroup___WEBPACK_IMPORTED_MODULE_2_react__);
/* harmony import */ var ListGroup___WEBPACK_IMPORTED_MODULE_3_prop_types__ = __webpack_require__(890);
/* harmony import */ var ListGroup___WEBPACK_IMPORTED_MODULE_3_prop_types___default = __webpack_require__.n(ListGroup___WEBPACK_IMPORTED_MODULE_3_prop_types__);
/* harmony import */ var ListGroup___WEBPACK_IMPORTED_MODULE_4_classnames__ = __webpack_require__(891);
/* harmony import */ var ListGroup___WEBPACK_IMPORTED_MODULE_4_classnames___default = __webpack_require__.n(ListGroup___WEBPACK_IMPORTED_MODULE_4_classnames__);






var ListGroup_propTypes = {
  tag: tagPropType,
  flush: ListGroup___WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.bool,
  className: ListGroup___WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.string,
  cssModule: ListGroup___WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.object
};
var ListGroup_defaultProps = {
  tag: 'ul'
};

var ListGroup_ListGroup = function ListGroup(props) {
  var className = props.className,
      cssModule = props.cssModule,
      Tag = props.tag,
      flush = props.flush,
      attributes = _objectWithoutPropertiesLoose(props, ["className", "cssModule", "tag", "flush"]);

  var classes = mapToCssModules(ListGroup___WEBPACK_IMPORTED_MODULE_4_classnames___default()(className, 'list-group', flush ? 'list-group-flush' : false), cssModule);
  return ListGroup___WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(Tag, _extends({}, attributes, {
    className: classes
  }));
};

ListGroup_ListGroup.propTypes = ListGroup_propTypes;
ListGroup_ListGroup.defaultProps = ListGroup_defaultProps;
/* harmony default export */ var ListGroup_defaultExport = (ListGroup_ListGroup);
// CONCATENATED MODULE: ./node_modules/reactstrap/es/Form.js
/* harmony import */ var Form___WEBPACK_IMPORTED_MODULE_4_react__ = __webpack_require__(71);
/* harmony import */ var Form___WEBPACK_IMPORTED_MODULE_4_react___default = __webpack_require__.n(Form___WEBPACK_IMPORTED_MODULE_4_react__);
/* harmony import */ var Form___WEBPACK_IMPORTED_MODULE_5_prop_types__ = __webpack_require__(890);
/* harmony import */ var Form___WEBPACK_IMPORTED_MODULE_5_prop_types___default = __webpack_require__.n(Form___WEBPACK_IMPORTED_MODULE_5_prop_types__);
/* harmony import */ var Form___WEBPACK_IMPORTED_MODULE_6_classnames__ = __webpack_require__(891);
/* harmony import */ var Form___WEBPACK_IMPORTED_MODULE_6_classnames___default = __webpack_require__.n(Form___WEBPACK_IMPORTED_MODULE_6_classnames__);








var Form_propTypes = {
  children: Form___WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.node,
  inline: Form___WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.bool,
  tag: tagPropType,
  innerRef: Form___WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.oneOfType([Form___WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.object, Form___WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.func, Form___WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.string]),
  className: Form___WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.string,
  cssModule: Form___WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.object
};
var Form_defaultProps = {
  tag: 'form'
};

var Form_Form =
/*#__PURE__*/
function (_Component) {
  _inheritsLoose(Form, _Component);

  function Form(props) {
    var _this;

    _this = _Component.call(this, props) || this;
    _this.getRef = _this.getRef.bind(_assertThisInitialized(_assertThisInitialized(_this)));
    _this.submit = _this.submit.bind(_assertThisInitialized(_assertThisInitialized(_this)));
    return _this;
  }

  var _proto = Form.prototype;

  _proto.getRef = function getRef(ref) {
    if (this.props.innerRef) {
      this.props.innerRef(ref);
    }

    this.ref = ref;
  };

  _proto.submit = function submit() {
    if (this.ref) {
      this.ref.submit();
    }
  };

  _proto.render = function render() {
    var _this$props = this.props,
        className = _this$props.className,
        cssModule = _this$props.cssModule,
        inline = _this$props.inline,
        Tag = _this$props.tag,
        innerRef = _this$props.innerRef,
        attributes = _objectWithoutPropertiesLoose(_this$props, ["className", "cssModule", "inline", "tag", "innerRef"]);

    var classes = mapToCssModules(Form___WEBPACK_IMPORTED_MODULE_6_classnames___default()(className, inline ? 'form-inline' : false), cssModule);
    return Form___WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(Tag, _extends({}, attributes, {
      ref: innerRef,
      className: classes
    }));
  };

  return Form;
}(Form___WEBPACK_IMPORTED_MODULE_4_react__["Component"]);

Form_Form.propTypes = Form_propTypes;
Form_Form.defaultProps = Form_defaultProps;
/* harmony default export */ var Form_defaultExport = (Form_Form);
// CONCATENATED MODULE: ./node_modules/reactstrap/es/FormFeedback.js
/* harmony import */ var FormFeedback___WEBPACK_IMPORTED_MODULE_2_react__ = __webpack_require__(71);
/* harmony import */ var FormFeedback___WEBPACK_IMPORTED_MODULE_2_react___default = __webpack_require__.n(FormFeedback___WEBPACK_IMPORTED_MODULE_2_react__);
/* harmony import */ var FormFeedback___WEBPACK_IMPORTED_MODULE_3_prop_types__ = __webpack_require__(890);
/* harmony import */ var FormFeedback___WEBPACK_IMPORTED_MODULE_3_prop_types___default = __webpack_require__.n(FormFeedback___WEBPACK_IMPORTED_MODULE_3_prop_types__);
/* harmony import */ var FormFeedback___WEBPACK_IMPORTED_MODULE_4_classnames__ = __webpack_require__(891);
/* harmony import */ var FormFeedback___WEBPACK_IMPORTED_MODULE_4_classnames___default = __webpack_require__.n(FormFeedback___WEBPACK_IMPORTED_MODULE_4_classnames__);






var FormFeedback_propTypes = {
  children: FormFeedback___WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.node,
  tag: tagPropType,
  className: FormFeedback___WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.string,
  cssModule: FormFeedback___WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.object,
  valid: FormFeedback___WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.bool,
  tooltip: FormFeedback___WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.bool
};
var FormFeedback_defaultProps = {
  tag: 'div',
  valid: undefined
};

var FormFeedback_FormFeedback = function FormFeedback(props) {
  var className = props.className,
      cssModule = props.cssModule,
      valid = props.valid,
      tooltip = props.tooltip,
      Tag = props.tag,
      attributes = _objectWithoutPropertiesLoose(props, ["className", "cssModule", "valid", "tooltip", "tag"]);

  var validMode = tooltip ? 'tooltip' : 'feedback';
  var classes = mapToCssModules(FormFeedback___WEBPACK_IMPORTED_MODULE_4_classnames___default()(className, valid ? "valid-" + validMode : "invalid-" + validMode), cssModule);
  return FormFeedback___WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(Tag, _extends({}, attributes, {
    className: classes
  }));
};

FormFeedback_FormFeedback.propTypes = FormFeedback_propTypes;
FormFeedback_FormFeedback.defaultProps = FormFeedback_defaultProps;
/* harmony default export */ var FormFeedback_defaultExport = (FormFeedback_FormFeedback);
// CONCATENATED MODULE: ./node_modules/reactstrap/es/FormGroup.js
/* harmony import */ var FormGroup___WEBPACK_IMPORTED_MODULE_2_react__ = __webpack_require__(71);
/* harmony import */ var FormGroup___WEBPACK_IMPORTED_MODULE_2_react___default = __webpack_require__.n(FormGroup___WEBPACK_IMPORTED_MODULE_2_react__);
/* harmony import */ var FormGroup___WEBPACK_IMPORTED_MODULE_3_prop_types__ = __webpack_require__(890);
/* harmony import */ var FormGroup___WEBPACK_IMPORTED_MODULE_3_prop_types___default = __webpack_require__.n(FormGroup___WEBPACK_IMPORTED_MODULE_3_prop_types__);
/* harmony import */ var FormGroup___WEBPACK_IMPORTED_MODULE_4_classnames__ = __webpack_require__(891);
/* harmony import */ var FormGroup___WEBPACK_IMPORTED_MODULE_4_classnames___default = __webpack_require__.n(FormGroup___WEBPACK_IMPORTED_MODULE_4_classnames__);






var FormGroup_propTypes = {
  children: FormGroup___WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.node,
  row: FormGroup___WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.bool,
  check: FormGroup___WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.bool,
  inline: FormGroup___WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.bool,
  disabled: FormGroup___WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.bool,
  tag: tagPropType,
  className: FormGroup___WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.string,
  cssModule: FormGroup___WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.object
};
var FormGroup_defaultProps = {
  tag: 'div'
};

var FormGroup_FormGroup = function FormGroup(props) {
  var className = props.className,
      cssModule = props.cssModule,
      row = props.row,
      disabled = props.disabled,
      check = props.check,
      inline = props.inline,
      Tag = props.tag,
      attributes = _objectWithoutPropertiesLoose(props, ["className", "cssModule", "row", "disabled", "check", "inline", "tag"]);

  var classes = mapToCssModules(FormGroup___WEBPACK_IMPORTED_MODULE_4_classnames___default()(className, row ? 'row' : false, check ? 'form-check' : 'form-group', check && inline ? 'form-check-inline' : false, check && disabled ? 'disabled' : false), cssModule);
  return FormGroup___WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(Tag, _extends({}, attributes, {
    className: classes
  }));
};

FormGroup_FormGroup.propTypes = FormGroup_propTypes;
FormGroup_FormGroup.defaultProps = FormGroup_defaultProps;
/* harmony default export */ var FormGroup_defaultExport = (FormGroup_FormGroup);
// CONCATENATED MODULE: ./node_modules/reactstrap/es/FormText.js
/* harmony import */ var FormText___WEBPACK_IMPORTED_MODULE_2_react__ = __webpack_require__(71);
/* harmony import */ var FormText___WEBPACK_IMPORTED_MODULE_2_react___default = __webpack_require__.n(FormText___WEBPACK_IMPORTED_MODULE_2_react__);
/* harmony import */ var FormText___WEBPACK_IMPORTED_MODULE_3_prop_types__ = __webpack_require__(890);
/* harmony import */ var FormText___WEBPACK_IMPORTED_MODULE_3_prop_types___default = __webpack_require__.n(FormText___WEBPACK_IMPORTED_MODULE_3_prop_types__);
/* harmony import */ var FormText___WEBPACK_IMPORTED_MODULE_4_classnames__ = __webpack_require__(891);
/* harmony import */ var FormText___WEBPACK_IMPORTED_MODULE_4_classnames___default = __webpack_require__.n(FormText___WEBPACK_IMPORTED_MODULE_4_classnames__);






var FormText_propTypes = {
  children: FormText___WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.node,
  inline: FormText___WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.bool,
  tag: tagPropType,
  color: FormText___WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.string,
  className: FormText___WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.string,
  cssModule: FormText___WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.object
};
var FormText_defaultProps = {
  tag: 'small',
  color: 'muted'
};

var FormText_FormText = function FormText(props) {
  var className = props.className,
      cssModule = props.cssModule,
      inline = props.inline,
      color = props.color,
      Tag = props.tag,
      attributes = _objectWithoutPropertiesLoose(props, ["className", "cssModule", "inline", "color", "tag"]);

  var classes = mapToCssModules(FormText___WEBPACK_IMPORTED_MODULE_4_classnames___default()(className, !inline ? 'form-text' : false, color ? "text-" + color : false), cssModule);
  return FormText___WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(Tag, _extends({}, attributes, {
    className: classes
  }));
};

FormText_FormText.propTypes = FormText_propTypes;
FormText_FormText.defaultProps = FormText_defaultProps;
/* harmony default export */ var FormText_defaultExport = (FormText_FormText);
// CONCATENATED MODULE: ./node_modules/reactstrap/es/Input.js
/* harmony import */ var Input___WEBPACK_IMPORTED_MODULE_4_react__ = __webpack_require__(71);
/* harmony import */ var Input___WEBPACK_IMPORTED_MODULE_4_react___default = __webpack_require__.n(Input___WEBPACK_IMPORTED_MODULE_4_react__);
/* harmony import */ var Input___WEBPACK_IMPORTED_MODULE_5_prop_types__ = __webpack_require__(890);
/* harmony import */ var Input___WEBPACK_IMPORTED_MODULE_5_prop_types___default = __webpack_require__.n(Input___WEBPACK_IMPORTED_MODULE_5_prop_types__);
/* harmony import */ var Input___WEBPACK_IMPORTED_MODULE_6_classnames__ = __webpack_require__(891);
/* harmony import */ var Input___WEBPACK_IMPORTED_MODULE_6_classnames___default = __webpack_require__.n(Input___WEBPACK_IMPORTED_MODULE_6_classnames__);





/* eslint react/prefer-stateless-function: 0 */




var Input_propTypes = {
  children: Input___WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.node,
  type: Input___WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.string,
  size: Input___WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.string,
  bsSize: Input___WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.string,
  state: deprecated(Input___WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.string, 'Please use the props "valid" and "invalid" to indicate the state.'),
  valid: Input___WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.bool,
  invalid: Input___WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.bool,
  tag: tagPropType,
  innerRef: Input___WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.oneOfType([Input___WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.object, Input___WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.func, Input___WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.string]),
  static: deprecated(Input___WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.bool, 'Please use the prop "plaintext"'),
  plaintext: Input___WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.bool,
  addon: Input___WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.bool,
  className: Input___WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.string,
  cssModule: Input___WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.object
};
var Input_defaultProps = {
  type: 'text'
};

var Input_Input =
/*#__PURE__*/
function (_React$Component) {
  _inheritsLoose(Input, _React$Component);

  function Input(props) {
    var _this;

    _this = _React$Component.call(this, props) || this;
    _this.getRef = _this.getRef.bind(_assertThisInitialized(_assertThisInitialized(_this)));
    _this.focus = _this.focus.bind(_assertThisInitialized(_assertThisInitialized(_this)));
    return _this;
  }

  var _proto = Input.prototype;

  _proto.getRef = function getRef(ref) {
    if (this.props.innerRef) {
      this.props.innerRef(ref);
    }

    this.ref = ref;
  };

  _proto.focus = function focus() {
    if (this.ref) {
      this.ref.focus();
    }
  };

  _proto.render = function render() {
    var _this$props = this.props,
        className = _this$props.className,
        cssModule = _this$props.cssModule,
        type = _this$props.type,
        bsSize = _this$props.bsSize,
        state = _this$props.state,
        valid = _this$props.valid,
        invalid = _this$props.invalid,
        tag = _this$props.tag,
        addon = _this$props.addon,
        staticInput = _this$props.static,
        plaintext = _this$props.plaintext,
        innerRef = _this$props.innerRef,
        attributes = _objectWithoutPropertiesLoose(_this$props, ["className", "cssModule", "type", "bsSize", "state", "valid", "invalid", "tag", "addon", "static", "plaintext", "innerRef"]);

    var checkInput = ['radio', 'checkbox'].indexOf(type) > -1;
    var isNotaNumber = new RegExp('\\D', 'g');
    var fileInput = type === 'file';
    var textareaInput = type === 'textarea';
    var selectInput = type === 'select';
    var Tag = tag || (selectInput || textareaInput ? type : 'input');
    var formControlClass = 'form-control';

    if (plaintext || staticInput) {
      formControlClass = formControlClass + "-plaintext";
      Tag = tag || 'input';
    } else if (fileInput) {
      formControlClass = formControlClass + "-file";
    } else if (checkInput) {
      if (addon) {
        formControlClass = null;
      } else {
        formControlClass = 'form-check-input';
      }
    }

    if (state && typeof valid === 'undefined' && typeof invalid === 'undefined') {
      if (state === 'danger') {
        invalid = true;
      } else if (state === 'success') {
        valid = true;
      }
    }

    if (attributes.size && isNotaNumber.test(attributes.size)) {
      warnOnce('Please use the prop "bsSize" instead of the "size" to bootstrap\'s input sizing.');
      bsSize = attributes.size;
      delete attributes.size;
    }

    var classes = mapToCssModules(Input___WEBPACK_IMPORTED_MODULE_6_classnames___default()(className, invalid && 'is-invalid', valid && 'is-valid', bsSize ? "form-control-" + bsSize : false, formControlClass), cssModule);

    if (Tag === 'input' || tag && typeof tag === 'function') {
      attributes.type = type;
    }

    if (attributes.children && !(plaintext || staticInput || type === 'select' || typeof Tag !== 'string' || Tag === 'select')) {
      warnOnce("Input with a type of \"" + type + "\" cannot have children. Please use \"value\"/\"defaultValue\" instead.");
      delete attributes.children;
    }

    return Input___WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(Tag, _extends({}, attributes, {
      ref: innerRef,
      className: classes
    }));
  };

  return Input;
}(Input___WEBPACK_IMPORTED_MODULE_4_react___default.a.Component);

Input_Input.propTypes = Input_propTypes;
Input_Input.defaultProps = Input_defaultProps;
/* harmony default export */ var Input_defaultExport = (Input_Input);
// CONCATENATED MODULE: ./node_modules/reactstrap/es/InputGroup.js
/* harmony import */ var InputGroup___WEBPACK_IMPORTED_MODULE_2_react__ = __webpack_require__(71);
/* harmony import */ var InputGroup___WEBPACK_IMPORTED_MODULE_2_react___default = __webpack_require__.n(InputGroup___WEBPACK_IMPORTED_MODULE_2_react__);
/* harmony import */ var InputGroup___WEBPACK_IMPORTED_MODULE_3_prop_types__ = __webpack_require__(890);
/* harmony import */ var InputGroup___WEBPACK_IMPORTED_MODULE_3_prop_types___default = __webpack_require__.n(InputGroup___WEBPACK_IMPORTED_MODULE_3_prop_types__);
/* harmony import */ var InputGroup___WEBPACK_IMPORTED_MODULE_4_classnames__ = __webpack_require__(891);
/* harmony import */ var InputGroup___WEBPACK_IMPORTED_MODULE_4_classnames___default = __webpack_require__.n(InputGroup___WEBPACK_IMPORTED_MODULE_4_classnames__);






var InputGroup_propTypes = {
  tag: tagPropType,
  size: InputGroup___WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.string,
  className: InputGroup___WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.string,
  cssModule: InputGroup___WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.object
};
var InputGroup_defaultProps = {
  tag: 'div'
};

var InputGroup_InputGroup = function InputGroup(props) {
  var className = props.className,
      cssModule = props.cssModule,
      Tag = props.tag,
      size = props.size,
      attributes = _objectWithoutPropertiesLoose(props, ["className", "cssModule", "tag", "size"]);

  var classes = mapToCssModules(InputGroup___WEBPACK_IMPORTED_MODULE_4_classnames___default()(className, 'input-group', size ? "input-group-" + size : null), cssModule);
  return InputGroup___WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(Tag, _extends({}, attributes, {
    className: classes
  }));
};

InputGroup_InputGroup.propTypes = InputGroup_propTypes;
InputGroup_InputGroup.defaultProps = InputGroup_defaultProps;
/* harmony default export */ var InputGroup_defaultExport = (InputGroup_InputGroup);
// CONCATENATED MODULE: ./node_modules/reactstrap/es/InputGroupText.js
/* harmony import */ var InputGroupText___WEBPACK_IMPORTED_MODULE_2_react__ = __webpack_require__(71);
/* harmony import */ var InputGroupText___WEBPACK_IMPORTED_MODULE_2_react___default = __webpack_require__.n(InputGroupText___WEBPACK_IMPORTED_MODULE_2_react__);
/* harmony import */ var InputGroupText___WEBPACK_IMPORTED_MODULE_3_prop_types__ = __webpack_require__(890);
/* harmony import */ var InputGroupText___WEBPACK_IMPORTED_MODULE_3_prop_types___default = __webpack_require__.n(InputGroupText___WEBPACK_IMPORTED_MODULE_3_prop_types__);
/* harmony import */ var InputGroupText___WEBPACK_IMPORTED_MODULE_4_classnames__ = __webpack_require__(891);
/* harmony import */ var InputGroupText___WEBPACK_IMPORTED_MODULE_4_classnames___default = __webpack_require__.n(InputGroupText___WEBPACK_IMPORTED_MODULE_4_classnames__);






var InputGroupText_propTypes = {
  tag: tagPropType,
  className: InputGroupText___WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.string,
  cssModule: InputGroupText___WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.object
};
var InputGroupText_defaultProps = {
  tag: 'span'
};

var InputGroupText_InputGroupText = function InputGroupText(props) {
  var className = props.className,
      cssModule = props.cssModule,
      Tag = props.tag,
      attributes = _objectWithoutPropertiesLoose(props, ["className", "cssModule", "tag"]);

  var classes = mapToCssModules(InputGroupText___WEBPACK_IMPORTED_MODULE_4_classnames___default()(className, 'input-group-text'), cssModule);
  return InputGroupText___WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(Tag, _extends({}, attributes, {
    className: classes
  }));
};

InputGroupText_InputGroupText.propTypes = InputGroupText_propTypes;
InputGroupText_InputGroupText.defaultProps = InputGroupText_defaultProps;
/* harmony default export */ var InputGroupText_defaultExport = (InputGroupText_InputGroupText);
// CONCATENATED MODULE: ./node_modules/reactstrap/es/InputGroupAddon.js
/* harmony import */ var InputGroupAddon___WEBPACK_IMPORTED_MODULE_2_react__ = __webpack_require__(71);
/* harmony import */ var InputGroupAddon___WEBPACK_IMPORTED_MODULE_2_react___default = __webpack_require__.n(InputGroupAddon___WEBPACK_IMPORTED_MODULE_2_react__);
/* harmony import */ var InputGroupAddon___WEBPACK_IMPORTED_MODULE_3_prop_types__ = __webpack_require__(890);
/* harmony import */ var InputGroupAddon___WEBPACK_IMPORTED_MODULE_3_prop_types___default = __webpack_require__.n(InputGroupAddon___WEBPACK_IMPORTED_MODULE_3_prop_types__);
/* harmony import */ var InputGroupAddon___WEBPACK_IMPORTED_MODULE_4_classnames__ = __webpack_require__(891);
/* harmony import */ var InputGroupAddon___WEBPACK_IMPORTED_MODULE_4_classnames___default = __webpack_require__.n(InputGroupAddon___WEBPACK_IMPORTED_MODULE_4_classnames__);







var InputGroupAddon_propTypes = {
  tag: tagPropType,
  addonType: InputGroupAddon___WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.oneOf(['prepend', 'append']).isRequired,
  children: InputGroupAddon___WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.node,
  className: InputGroupAddon___WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.string,
  cssModule: InputGroupAddon___WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.object
};
var InputGroupAddon_defaultProps = {
  tag: 'div'
};

var InputGroupAddon_InputGroupAddon = function InputGroupAddon(props) {
  var className = props.className,
      cssModule = props.cssModule,
      Tag = props.tag,
      addonType = props.addonType,
      children = props.children,
      attributes = _objectWithoutPropertiesLoose(props, ["className", "cssModule", "tag", "addonType", "children"]);

  var classes = mapToCssModules(InputGroupAddon___WEBPACK_IMPORTED_MODULE_4_classnames___default()(className, 'input-group-' + addonType), cssModule); // Convenience to assist with transition

  if (typeof children === 'string') {
    return InputGroupAddon___WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(Tag, _extends({}, attributes, {
      className: classes
    }), InputGroupAddon___WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(InputGroupText_defaultExport, {
      children: children
    }));
  }

  return InputGroupAddon___WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(Tag, _extends({}, attributes, {
    className: classes,
    children: children
  }));
};

InputGroupAddon_InputGroupAddon.propTypes = InputGroupAddon_propTypes;
InputGroupAddon_InputGroupAddon.defaultProps = InputGroupAddon_defaultProps;
/* harmony default export */ var InputGroupAddon_defaultExport = (InputGroupAddon_InputGroupAddon);
// CONCATENATED MODULE: ./node_modules/reactstrap/es/InputGroupButton.js
/* harmony import */ var InputGroupButton___WEBPACK_IMPORTED_MODULE_3_react__ = __webpack_require__(71);
/* harmony import */ var InputGroupButton___WEBPACK_IMPORTED_MODULE_3_react___default = __webpack_require__.n(InputGroupButton___WEBPACK_IMPORTED_MODULE_3_react__);
/* harmony import */ var InputGroupButton___WEBPACK_IMPORTED_MODULE_4_prop_types__ = __webpack_require__(890);
/* harmony import */ var InputGroupButton___WEBPACK_IMPORTED_MODULE_4_prop_types___default = __webpack_require__.n(InputGroupButton___WEBPACK_IMPORTED_MODULE_4_prop_types__);








var InputGroupButton_propTypes = {
  tag: tagPropType,
  addonType: InputGroupButton___WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.oneOf(['prepend', 'append']).isRequired,
  children: InputGroupButton___WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.node,
  groupClassName: InputGroupButton___WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.string,
  groupAttributes: InputGroupButton___WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.object,
  className: InputGroupButton___WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.string,
  cssModule: InputGroupButton___WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.object
};

var InputGroupButton_InputGroupButton = function InputGroupButton(props) {
  warnOnce('The "InputGroupButton" component has been deprecated.\nPlease use component "InputGroupAddon".');

  var children = props.children,
      groupClassName = props.groupClassName,
      groupAttributes = props.groupAttributes,
      propsWithoutGroup = _objectWithoutPropertiesLoose(props, ["children", "groupClassName", "groupAttributes"]);

  if (typeof children === 'string') {
    var cssModule = propsWithoutGroup.cssModule,
        tag = propsWithoutGroup.tag,
        addonType = propsWithoutGroup.addonType,
        attributes = _objectWithoutPropertiesLoose(propsWithoutGroup, ["cssModule", "tag", "addonType"]);

    var allGroupAttributes = _objectSpread({}, groupAttributes, {
      cssModule: cssModule,
      tag: tag,
      addonType: addonType
    });

    return InputGroupButton___WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(InputGroupAddon_defaultExport, _extends({}, allGroupAttributes, {
      className: groupClassName
    }), InputGroupButton___WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(Button_defaultExport, _extends({}, attributes, {
      children: children
    })));
  }

  return InputGroupButton___WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(InputGroupAddon_defaultExport, _extends({}, props, {
    children: children
  }));
};

InputGroupButton_InputGroupButton.propTypes = InputGroupButton_propTypes;
/* harmony default export */ var InputGroupButton_defaultExport = (InputGroupButton_InputGroupButton);
// CONCATENATED MODULE: ./node_modules/reactstrap/es/InputGroupButtonDropdown.js
/* harmony import */ var InputGroupButtonDropdown___WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(71);
/* harmony import */ var InputGroupButtonDropdown___WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(InputGroupButtonDropdown___WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var InputGroupButtonDropdown___WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(890);
/* harmony import */ var InputGroupButtonDropdown___WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(InputGroupButtonDropdown___WEBPACK_IMPORTED_MODULE_1_prop_types__);



var InputGroupButtonDropdown_propTypes = {
  addonType: InputGroupButtonDropdown___WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.oneOf(['prepend', 'append']).isRequired,
  children: InputGroupButtonDropdown___WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.node
};

var InputGroupButtonDropdown_InputGroupButtonDropdown = function InputGroupButtonDropdown(props) {
  return InputGroupButtonDropdown___WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(Dropdown_defaultExport, props);
};

InputGroupButtonDropdown_InputGroupButtonDropdown.propTypes = InputGroupButtonDropdown_propTypes;
/* harmony default export */ var InputGroupButtonDropdown_defaultExport = (InputGroupButtonDropdown_InputGroupButtonDropdown);
// CONCATENATED MODULE: ./node_modules/reactstrap/es/Label.js
/* harmony import */ var Label___WEBPACK_IMPORTED_MODULE_2_react__ = __webpack_require__(71);
/* harmony import */ var Label___WEBPACK_IMPORTED_MODULE_2_react___default = __webpack_require__.n(Label___WEBPACK_IMPORTED_MODULE_2_react__);
/* harmony import */ var Label___WEBPACK_IMPORTED_MODULE_3_prop_types__ = __webpack_require__(890);
/* harmony import */ var Label___WEBPACK_IMPORTED_MODULE_3_prop_types___default = __webpack_require__.n(Label___WEBPACK_IMPORTED_MODULE_3_prop_types__);
/* harmony import */ var Label___WEBPACK_IMPORTED_MODULE_4_classnames__ = __webpack_require__(891);
/* harmony import */ var Label___WEBPACK_IMPORTED_MODULE_4_classnames___default = __webpack_require__.n(Label___WEBPACK_IMPORTED_MODULE_4_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_lodash_isobject__ = __webpack_require__(1135);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_lodash_isobject___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_lodash_isobject__);







var Label_colWidths = ['xs', 'sm', 'md', 'lg', 'xl'];
var Label_stringOrNumberProp = Label___WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.oneOfType([Label___WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.number, Label___WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.string]);
var Label_columnProps = Label___WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.oneOfType([Label___WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.string, Label___WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.number, Label___WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.shape({
  size: Label_stringOrNumberProp,
  push: deprecated(Label_stringOrNumberProp, 'Please use the prop "order"'),
  pull: deprecated(Label_stringOrNumberProp, 'Please use the prop "order"'),
  order: Label_stringOrNumberProp,
  offset: Label_stringOrNumberProp
})]);
var Label_propTypes = {
  children: Label___WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.node,
  hidden: Label___WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.bool,
  check: Label___WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.bool,
  size: Label___WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.string,
  for: Label___WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.string,
  tag: tagPropType,
  className: Label___WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.string,
  cssModule: Label___WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.object,
  xs: Label_columnProps,
  sm: Label_columnProps,
  md: Label_columnProps,
  lg: Label_columnProps,
  xl: Label_columnProps,
  widths: Label___WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.array
};
var Label_defaultProps = {
  tag: 'label',
  widths: Label_colWidths
};

var Label_getColumnSizeClass = function getColumnSizeClass(isXs, colWidth, colSize) {
  if (colSize === true || colSize === '') {
    return isXs ? 'col' : "col-" + colWidth;
  } else if (colSize === 'auto') {
    return isXs ? 'col-auto' : "col-" + colWidth + "-auto";
  }

  return isXs ? "col-" + colSize : "col-" + colWidth + "-" + colSize;
};

var Label_Label = function Label(props) {
  var className = props.className,
      cssModule = props.cssModule,
      hidden = props.hidden,
      widths = props.widths,
      Tag = props.tag,
      check = props.check,
      size = props.size,
      htmlFor = props.for,
      attributes = _objectWithoutPropertiesLoose(props, ["className", "cssModule", "hidden", "widths", "tag", "check", "size", "for"]);

  var colClasses = [];
  widths.forEach(function (colWidth, i) {
    var columnProp = props[colWidth];
    delete attributes[colWidth];

    if (!columnProp && columnProp !== '') {
      return;
    }

    var isXs = !i;
    var colClass;

    if (__WEBPACK_IMPORTED_MODULE_5_lodash_isobject___default()(columnProp)) {
      var _classNames;

      var colSizeInterfix = isXs ? '-' : "-" + colWidth + "-";
      colClass = Label_getColumnSizeClass(isXs, colWidth, columnProp.size);
      colClasses.push(mapToCssModules(Label___WEBPACK_IMPORTED_MODULE_4_classnames___default()((_classNames = {}, _classNames[colClass] = columnProp.size || columnProp.size === '', _classNames["order" + colSizeInterfix + columnProp.order] = columnProp.order || columnProp.order === 0, _classNames["offset" + colSizeInterfix + columnProp.offset] = columnProp.offset || columnProp.offset === 0, _classNames))), cssModule);
    } else {
      colClass = Label_getColumnSizeClass(isXs, colWidth, columnProp);
      colClasses.push(colClass);
    }
  });
  var classes = mapToCssModules(Label___WEBPACK_IMPORTED_MODULE_4_classnames___default()(className, hidden ? 'sr-only' : false, check ? 'form-check-label' : false, size ? "col-form-label-" + size : false, colClasses, colClasses.length ? 'col-form-label' : false), cssModule);
  return Label___WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(Tag, _extends({
    htmlFor: htmlFor
  }, attributes, {
    className: classes
  }));
};

Label_Label.propTypes = Label_propTypes;
Label_Label.defaultProps = Label_defaultProps;
/* harmony default export */ var Label_defaultExport = (Label_Label);
// CONCATENATED MODULE: ./node_modules/reactstrap/es/Media.js
/* harmony import */ var Media___WEBPACK_IMPORTED_MODULE_2_react__ = __webpack_require__(71);
/* harmony import */ var Media___WEBPACK_IMPORTED_MODULE_2_react___default = __webpack_require__.n(Media___WEBPACK_IMPORTED_MODULE_2_react__);
/* harmony import */ var Media___WEBPACK_IMPORTED_MODULE_3_prop_types__ = __webpack_require__(890);
/* harmony import */ var Media___WEBPACK_IMPORTED_MODULE_3_prop_types___default = __webpack_require__.n(Media___WEBPACK_IMPORTED_MODULE_3_prop_types__);
/* harmony import */ var Media___WEBPACK_IMPORTED_MODULE_4_classnames__ = __webpack_require__(891);
/* harmony import */ var Media___WEBPACK_IMPORTED_MODULE_4_classnames___default = __webpack_require__.n(Media___WEBPACK_IMPORTED_MODULE_4_classnames__);






var Media_propTypes = {
  body: Media___WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.bool,
  bottom: Media___WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.bool,
  children: Media___WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.node,
  className: Media___WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.string,
  cssModule: Media___WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.object,
  heading: Media___WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.bool,
  left: Media___WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.bool,
  list: Media___WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.bool,
  middle: Media___WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.bool,
  object: Media___WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.bool,
  right: Media___WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.bool,
  tag: tagPropType,
  top: Media___WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.bool
};

var Media_Media = function Media(props) {
  var body = props.body,
      bottom = props.bottom,
      className = props.className,
      cssModule = props.cssModule,
      heading = props.heading,
      left = props.left,
      list = props.list,
      middle = props.middle,
      object = props.object,
      right = props.right,
      tag = props.tag,
      top = props.top,
      attributes = _objectWithoutPropertiesLoose(props, ["body", "bottom", "className", "cssModule", "heading", "left", "list", "middle", "object", "right", "tag", "top"]);

  var defaultTag;

  if (heading) {
    defaultTag = 'h4';
  } else if (attributes.href) {
    defaultTag = 'a';
  } else if (attributes.src || object) {
    defaultTag = 'img';
  } else if (list) {
    defaultTag = 'ul';
  } else {
    defaultTag = 'div';
  }

  var Tag = tag || defaultTag;
  var classes = mapToCssModules(Media___WEBPACK_IMPORTED_MODULE_4_classnames___default()(className, {
    'media-body': body,
    'media-heading': heading,
    'media-left': left,
    'media-right': right,
    'media-top': top,
    'media-bottom': bottom,
    'media-middle': middle,
    'media-object': object,
    'media-list': list,
    media: !body && !heading && !left && !right && !top && !bottom && !middle && !object && !list
  }), cssModule);
  return Media___WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(Tag, _extends({}, attributes, {
    className: classes
  }));
};

Media_Media.propTypes = Media_propTypes;
/* harmony default export */ var Media_defaultExport = (Media_Media);
// CONCATENATED MODULE: ./node_modules/reactstrap/es/Pagination.js
/* harmony import */ var Pagination___WEBPACK_IMPORTED_MODULE_2_react__ = __webpack_require__(71);
/* harmony import */ var Pagination___WEBPACK_IMPORTED_MODULE_2_react___default = __webpack_require__.n(Pagination___WEBPACK_IMPORTED_MODULE_2_react__);
/* harmony import */ var Pagination___WEBPACK_IMPORTED_MODULE_3_prop_types__ = __webpack_require__(890);
/* harmony import */ var Pagination___WEBPACK_IMPORTED_MODULE_3_prop_types___default = __webpack_require__.n(Pagination___WEBPACK_IMPORTED_MODULE_3_prop_types__);
/* harmony import */ var Pagination___WEBPACK_IMPORTED_MODULE_4_classnames__ = __webpack_require__(891);
/* harmony import */ var Pagination___WEBPACK_IMPORTED_MODULE_4_classnames___default = __webpack_require__.n(Pagination___WEBPACK_IMPORTED_MODULE_4_classnames__);






var Pagination_propTypes = {
  children: Pagination___WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.node,
  className: Pagination___WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.string,
  listClassName: Pagination___WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.string,
  cssModule: Pagination___WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.object,
  size: Pagination___WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.string,
  tag: tagPropType,
  listTag: tagPropType,
  'aria-label': Pagination___WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.string
};
var Pagination_defaultProps = {
  tag: 'nav',
  listTag: 'ul',
  'aria-label': 'pagination'
};

var Pagination_Pagination = function Pagination(props) {
  var _classNames;

  var className = props.className,
      listClassName = props.listClassName,
      cssModule = props.cssModule,
      size = props.size,
      Tag = props.tag,
      ListTag = props.listTag,
      label = props['aria-label'],
      attributes = _objectWithoutPropertiesLoose(props, ["className", "listClassName", "cssModule", "size", "tag", "listTag", "aria-label"]);

  var classes = mapToCssModules(Pagination___WEBPACK_IMPORTED_MODULE_4_classnames___default()(className), cssModule);
  var listClasses = mapToCssModules(Pagination___WEBPACK_IMPORTED_MODULE_4_classnames___default()(listClassName, 'pagination', (_classNames = {}, _classNames["pagination-" + size] = !!size, _classNames)), cssModule);
  return Pagination___WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(Tag, {
    className: classes,
    "aria-label": label
  }, Pagination___WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(ListTag, _extends({}, attributes, {
    className: listClasses
  })));
};

Pagination_Pagination.propTypes = Pagination_propTypes;
Pagination_Pagination.defaultProps = Pagination_defaultProps;
/* harmony default export */ var Pagination_defaultExport = (Pagination_Pagination);
// CONCATENATED MODULE: ./node_modules/reactstrap/es/PaginationItem.js
/* harmony import */ var PaginationItem___WEBPACK_IMPORTED_MODULE_2_react__ = __webpack_require__(71);
/* harmony import */ var PaginationItem___WEBPACK_IMPORTED_MODULE_2_react___default = __webpack_require__.n(PaginationItem___WEBPACK_IMPORTED_MODULE_2_react__);
/* harmony import */ var PaginationItem___WEBPACK_IMPORTED_MODULE_3_prop_types__ = __webpack_require__(890);
/* harmony import */ var PaginationItem___WEBPACK_IMPORTED_MODULE_3_prop_types___default = __webpack_require__.n(PaginationItem___WEBPACK_IMPORTED_MODULE_3_prop_types__);
/* harmony import */ var PaginationItem___WEBPACK_IMPORTED_MODULE_4_classnames__ = __webpack_require__(891);
/* harmony import */ var PaginationItem___WEBPACK_IMPORTED_MODULE_4_classnames___default = __webpack_require__.n(PaginationItem___WEBPACK_IMPORTED_MODULE_4_classnames__);






var PaginationItem_propTypes = {
  active: PaginationItem___WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.bool,
  children: PaginationItem___WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.node,
  className: PaginationItem___WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.string,
  cssModule: PaginationItem___WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.object,
  disabled: PaginationItem___WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.bool,
  tag: tagPropType
};
var PaginationItem_defaultProps = {
  tag: 'li'
};

var PaginationItem_PaginationItem = function PaginationItem(props) {
  var active = props.active,
      className = props.className,
      cssModule = props.cssModule,
      disabled = props.disabled,
      Tag = props.tag,
      attributes = _objectWithoutPropertiesLoose(props, ["active", "className", "cssModule", "disabled", "tag"]);

  var classes = mapToCssModules(PaginationItem___WEBPACK_IMPORTED_MODULE_4_classnames___default()(className, 'page-item', {
    active: active,
    disabled: disabled
  }), cssModule);
  return PaginationItem___WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(Tag, _extends({}, attributes, {
    className: classes
  }));
};

PaginationItem_PaginationItem.propTypes = PaginationItem_propTypes;
PaginationItem_PaginationItem.defaultProps = PaginationItem_defaultProps;
/* harmony default export */ var PaginationItem_defaultExport = (PaginationItem_PaginationItem);
// CONCATENATED MODULE: ./node_modules/reactstrap/es/PaginationLink.js
/* harmony import */ var PaginationLink___WEBPACK_IMPORTED_MODULE_2_react__ = __webpack_require__(71);
/* harmony import */ var PaginationLink___WEBPACK_IMPORTED_MODULE_2_react___default = __webpack_require__.n(PaginationLink___WEBPACK_IMPORTED_MODULE_2_react__);
/* harmony import */ var PaginationLink___WEBPACK_IMPORTED_MODULE_3_prop_types__ = __webpack_require__(890);
/* harmony import */ var PaginationLink___WEBPACK_IMPORTED_MODULE_3_prop_types___default = __webpack_require__.n(PaginationLink___WEBPACK_IMPORTED_MODULE_3_prop_types__);
/* harmony import */ var PaginationLink___WEBPACK_IMPORTED_MODULE_4_classnames__ = __webpack_require__(891);
/* harmony import */ var PaginationLink___WEBPACK_IMPORTED_MODULE_4_classnames___default = __webpack_require__.n(PaginationLink___WEBPACK_IMPORTED_MODULE_4_classnames__);






var PaginationLink_propTypes = {
  'aria-label': PaginationLink___WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.string,
  children: PaginationLink___WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.node,
  className: PaginationLink___WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.string,
  cssModule: PaginationLink___WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.object,
  next: PaginationLink___WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.bool,
  previous: PaginationLink___WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.bool,
  tag: tagPropType
};
var PaginationLink_defaultProps = {
  tag: 'a'
};

var PaginationLink_PaginationLink = function PaginationLink(props) {
  var className = props.className,
      cssModule = props.cssModule,
      next = props.next,
      previous = props.previous,
      Tag = props.tag,
      attributes = _objectWithoutPropertiesLoose(props, ["className", "cssModule", "next", "previous", "tag"]);

  var classes = mapToCssModules(PaginationLink___WEBPACK_IMPORTED_MODULE_4_classnames___default()(className, 'page-link'), cssModule);
  var defaultAriaLabel;

  if (previous) {
    defaultAriaLabel = 'Previous';
  } else if (next) {
    defaultAriaLabel = 'Next';
  }

  var ariaLabel = props['aria-label'] || defaultAriaLabel;
  var defaultCaret;

  if (previous) {
    defaultCaret = "\xAB";
  } else if (next) {
    defaultCaret = "\xBB";
  }

  var children = props.children;

  if (children && Array.isArray(children) && children.length === 0) {
    children = null;
  }

  if (!attributes.href && Tag === 'a') {
    Tag = 'button';
  }

  if (previous || next) {
    children = [PaginationLink___WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement("span", {
      "aria-hidden": "true",
      key: "caret"
    }, children || defaultCaret), PaginationLink___WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement("span", {
      className: "sr-only",
      key: "sr"
    }, ariaLabel)];
  }

  return PaginationLink___WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(Tag, _extends({}, attributes, {
    className: classes,
    "aria-label": ariaLabel
  }), children);
};

PaginationLink_PaginationLink.propTypes = PaginationLink_propTypes;
PaginationLink_PaginationLink.defaultProps = PaginationLink_defaultProps;
/* harmony default export */ var PaginationLink_defaultExport = (PaginationLink_PaginationLink);
// CONCATENATED MODULE: ./node_modules/reactstrap/es/TabContent.js
/* harmony import */ var TabContent___WEBPACK_IMPORTED_MODULE_2_react__ = __webpack_require__(71);
/* harmony import */ var TabContent___WEBPACK_IMPORTED_MODULE_2_react___default = __webpack_require__.n(TabContent___WEBPACK_IMPORTED_MODULE_2_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react_lifecycles_compat__ = __webpack_require__(1122);
/* harmony import */ var TabContent___WEBPACK_IMPORTED_MODULE_4_prop_types__ = __webpack_require__(890);
/* harmony import */ var TabContent___WEBPACK_IMPORTED_MODULE_4_prop_types___default = __webpack_require__.n(TabContent___WEBPACK_IMPORTED_MODULE_4_prop_types__);
/* harmony import */ var TabContent___WEBPACK_IMPORTED_MODULE_5_classnames__ = __webpack_require__(891);
/* harmony import */ var TabContent___WEBPACK_IMPORTED_MODULE_5_classnames___default = __webpack_require__.n(TabContent___WEBPACK_IMPORTED_MODULE_5_classnames__);







var TabContent_propTypes = {
  tag: tagPropType,
  activeTab: TabContent___WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.any,
  className: TabContent___WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.string,
  cssModule: TabContent___WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.object
};
var TabContent_defaultProps = {
  tag: 'div'
};
var TabContent_childContextTypes = {
  activeTabId: TabContent___WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.any
};

var TabContent_TabContent =
/*#__PURE__*/
function (_Component) {
  _inheritsLoose(TabContent, _Component);

  TabContent.getDerivedStateFromProps = function getDerivedStateFromProps(nextProps, prevState) {
    if (prevState.activeTab !== nextProps.activeTab) {
      return {
        activeTab: nextProps.activeTab
      };
    }

    return null;
  };

  function TabContent(props) {
    var _this;

    _this = _Component.call(this, props) || this;
    _this.state = {
      activeTab: _this.props.activeTab
    };
    return _this;
  }

  var _proto = TabContent.prototype;

  _proto.getChildContext = function getChildContext() {
    return {
      activeTabId: this.state.activeTab
    };
  };

  _proto.render = function render() {
    var _this$props = this.props,
        className = _this$props.className,
        cssModule = _this$props.cssModule,
        Tag = _this$props.tag;
    var attributes = omit(this.props, Object.keys(TabContent_propTypes));
    var classes = mapToCssModules(TabContent___WEBPACK_IMPORTED_MODULE_5_classnames___default()('tab-content', className), cssModule);
    return TabContent___WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(Tag, _extends({}, attributes, {
      className: classes
    }));
  };

  return TabContent;
}(TabContent___WEBPACK_IMPORTED_MODULE_2_react__["Component"]);

Object(__WEBPACK_IMPORTED_MODULE_3_react_lifecycles_compat__["polyfill"])(TabContent_TabContent);
/* harmony default export */ var TabContent_defaultExport = (TabContent_TabContent);
TabContent_TabContent.propTypes = TabContent_propTypes;
TabContent_TabContent.defaultProps = TabContent_defaultProps;
TabContent_TabContent.childContextTypes = TabContent_childContextTypes;
// CONCATENATED MODULE: ./node_modules/reactstrap/es/TabPane.js
/* harmony import */ var TabPane___WEBPACK_IMPORTED_MODULE_2_react__ = __webpack_require__(71);
/* harmony import */ var TabPane___WEBPACK_IMPORTED_MODULE_2_react___default = __webpack_require__.n(TabPane___WEBPACK_IMPORTED_MODULE_2_react__);
/* harmony import */ var TabPane___WEBPACK_IMPORTED_MODULE_3_prop_types__ = __webpack_require__(890);
/* harmony import */ var TabPane___WEBPACK_IMPORTED_MODULE_3_prop_types___default = __webpack_require__.n(TabPane___WEBPACK_IMPORTED_MODULE_3_prop_types__);
/* harmony import */ var TabPane___WEBPACK_IMPORTED_MODULE_4_classnames__ = __webpack_require__(891);
/* harmony import */ var TabPane___WEBPACK_IMPORTED_MODULE_4_classnames___default = __webpack_require__.n(TabPane___WEBPACK_IMPORTED_MODULE_4_classnames__);






var TabPane_propTypes = {
  tag: tagPropType,
  className: TabPane___WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.string,
  cssModule: TabPane___WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.object,
  tabId: TabPane___WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.any
};
var TabPane_defaultProps = {
  tag: 'div'
};
var TabPane_contextTypes = {
  activeTabId: TabPane___WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.any
};
function TabPane(props, context) {
  var className = props.className,
      cssModule = props.cssModule,
      tabId = props.tabId,
      Tag = props.tag,
      attributes = _objectWithoutPropertiesLoose(props, ["className", "cssModule", "tabId", "tag"]);

  var classes = mapToCssModules(TabPane___WEBPACK_IMPORTED_MODULE_4_classnames___default()('tab-pane', className, {
    active: tabId === context.activeTabId
  }), cssModule);
  return TabPane___WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(Tag, _extends({}, attributes, {
    className: classes
  }));
}
TabPane.propTypes = TabPane_propTypes;
TabPane.defaultProps = TabPane_defaultProps;
TabPane.contextTypes = TabPane_contextTypes;
// CONCATENATED MODULE: ./node_modules/reactstrap/es/Jumbotron.js
/* harmony import */ var Jumbotron___WEBPACK_IMPORTED_MODULE_2_react__ = __webpack_require__(71);
/* harmony import */ var Jumbotron___WEBPACK_IMPORTED_MODULE_2_react___default = __webpack_require__.n(Jumbotron___WEBPACK_IMPORTED_MODULE_2_react__);
/* harmony import */ var Jumbotron___WEBPACK_IMPORTED_MODULE_3_prop_types__ = __webpack_require__(890);
/* harmony import */ var Jumbotron___WEBPACK_IMPORTED_MODULE_3_prop_types___default = __webpack_require__.n(Jumbotron___WEBPACK_IMPORTED_MODULE_3_prop_types__);
/* harmony import */ var Jumbotron___WEBPACK_IMPORTED_MODULE_4_classnames__ = __webpack_require__(891);
/* harmony import */ var Jumbotron___WEBPACK_IMPORTED_MODULE_4_classnames___default = __webpack_require__.n(Jumbotron___WEBPACK_IMPORTED_MODULE_4_classnames__);






var Jumbotron_propTypes = {
  tag: tagPropType,
  fluid: Jumbotron___WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.bool,
  className: Jumbotron___WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.string,
  cssModule: Jumbotron___WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.object
};
var Jumbotron_defaultProps = {
  tag: 'div'
};

var Jumbotron_Jumbotron = function Jumbotron(props) {
  var className = props.className,
      cssModule = props.cssModule,
      Tag = props.tag,
      fluid = props.fluid,
      attributes = _objectWithoutPropertiesLoose(props, ["className", "cssModule", "tag", "fluid"]);

  var classes = mapToCssModules(Jumbotron___WEBPACK_IMPORTED_MODULE_4_classnames___default()(className, 'jumbotron', fluid ? 'jumbotron-fluid' : false), cssModule);
  return Jumbotron___WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(Tag, _extends({}, attributes, {
    className: classes
  }));
};

Jumbotron_Jumbotron.propTypes = Jumbotron_propTypes;
Jumbotron_Jumbotron.defaultProps = Jumbotron_defaultProps;
/* harmony default export */ var Jumbotron_defaultExport = (Jumbotron_Jumbotron);
// CONCATENATED MODULE: ./node_modules/reactstrap/es/Alert.js
/* harmony import */ var Alert___WEBPACK_IMPORTED_MODULE_3_react__ = __webpack_require__(71);
/* harmony import */ var Alert___WEBPACK_IMPORTED_MODULE_3_react___default = __webpack_require__.n(Alert___WEBPACK_IMPORTED_MODULE_3_react__);
/* harmony import */ var Alert___WEBPACK_IMPORTED_MODULE_4_prop_types__ = __webpack_require__(890);
/* harmony import */ var Alert___WEBPACK_IMPORTED_MODULE_4_prop_types___default = __webpack_require__.n(Alert___WEBPACK_IMPORTED_MODULE_4_prop_types__);
/* harmony import */ var Alert___WEBPACK_IMPORTED_MODULE_5_classnames__ = __webpack_require__(891);
/* harmony import */ var Alert___WEBPACK_IMPORTED_MODULE_5_classnames___default = __webpack_require__.n(Alert___WEBPACK_IMPORTED_MODULE_5_classnames__);








var Alert_propTypes = {
  children: Alert___WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.node,
  className: Alert___WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.string,
  closeClassName: Alert___WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.string,
  closeAriaLabel: Alert___WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.string,
  cssModule: Alert___WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.object,
  color: Alert___WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.string,
  fade: Alert___WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.bool,
  isOpen: Alert___WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.bool,
  toggle: Alert___WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.func,
  tag: tagPropType,
  transition: Alert___WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.shape(Fade_defaultExport.propTypes),
  innerRef: Alert___WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.oneOfType([Alert___WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.object, Alert___WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.string, Alert___WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.func])
};
var Alert_defaultProps = {
  color: 'success',
  isOpen: true,
  tag: 'div',
  closeAriaLabel: 'Close',
  fade: true,
  transition: _objectSpread({}, Fade_defaultExport.defaultProps, {
    unmountOnExit: true
  })
};

function Alert(props) {
  var className = props.className,
      closeClassName = props.closeClassName,
      closeAriaLabel = props.closeAriaLabel,
      cssModule = props.cssModule,
      Tag = props.tag,
      color = props.color,
      isOpen = props.isOpen,
      toggle = props.toggle,
      children = props.children,
      transition = props.transition,
      fade = props.fade,
      innerRef = props.innerRef,
      attributes = _objectWithoutPropertiesLoose(props, ["className", "closeClassName", "closeAriaLabel", "cssModule", "tag", "color", "isOpen", "toggle", "children", "transition", "fade", "innerRef"]);

  var classes = mapToCssModules(Alert___WEBPACK_IMPORTED_MODULE_5_classnames___default()(className, 'alert', "alert-" + color, {
    'alert-dismissible': toggle
  }), cssModule);
  var closeClasses = mapToCssModules(Alert___WEBPACK_IMPORTED_MODULE_5_classnames___default()('close', closeClassName), cssModule);

  var alertTransition = _objectSpread({}, Fade_defaultExport.defaultProps, transition, {
    baseClass: fade ? transition.baseClass : '',
    timeout: fade ? transition.timeout : 0
  });

  return Alert___WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(Fade_defaultExport, _extends({}, attributes, alertTransition, {
    tag: Tag,
    className: classes,
    in: isOpen,
    role: "alert",
    innerRef: innerRef
  }), toggle ? Alert___WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement("button", {
    type: "button",
    className: closeClasses,
    "aria-label": closeAriaLabel,
    onClick: toggle
  }, Alert___WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement("span", {
    "aria-hidden": "true"
  }, "\xD7")) : null, children);
}

Alert.propTypes = Alert_propTypes;
Alert.defaultProps = Alert_defaultProps;
/* harmony default export */ var Alert_defaultExport = (Alert);
// CONCATENATED MODULE: ./node_modules/reactstrap/es/Collapse.js
/* harmony import */ var Collapse___WEBPACK_IMPORTED_MODULE_5_react__ = __webpack_require__(71);
/* harmony import */ var Collapse___WEBPACK_IMPORTED_MODULE_5_react___default = __webpack_require__.n(Collapse___WEBPACK_IMPORTED_MODULE_5_react__);
/* harmony import */ var Collapse___WEBPACK_IMPORTED_MODULE_6_prop_types__ = __webpack_require__(890);
/* harmony import */ var Collapse___WEBPACK_IMPORTED_MODULE_6_prop_types___default = __webpack_require__.n(Collapse___WEBPACK_IMPORTED_MODULE_6_prop_types__);
/* harmony import */ var Collapse___WEBPACK_IMPORTED_MODULE_7_classnames__ = __webpack_require__(891);
/* harmony import */ var Collapse___WEBPACK_IMPORTED_MODULE_7_classnames___default = __webpack_require__.n(Collapse___WEBPACK_IMPORTED_MODULE_7_classnames__);
/* harmony import */ var Collapse___WEBPACK_IMPORTED_MODULE_8_react_transition_group__ = __webpack_require__(1121);
/* harmony import */ var Collapse___WEBPACK_IMPORTED_MODULE_8_react_transition_group___default = __webpack_require__.n(Collapse___WEBPACK_IMPORTED_MODULE_8_react_transition_group__);






var _transitionStatusToCl;







var Collapse_propTypes = _objectSpread({}, Collapse___WEBPACK_IMPORTED_MODULE_8_react_transition_group__["Transition"].propTypes, {
  isOpen: Collapse___WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.bool,
  children: Collapse___WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.oneOfType([Collapse___WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.arrayOf(Collapse___WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.node), Collapse___WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.node]),
  tag: tagPropType,
  className: Collapse___WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.node,
  navbar: Collapse___WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.bool,
  cssModule: Collapse___WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.object,
  innerRef: Collapse___WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.oneOfType([Collapse___WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.func, Collapse___WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.string, Collapse___WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.object])
});

var Collapse_defaultProps = _objectSpread({}, Collapse___WEBPACK_IMPORTED_MODULE_8_react_transition_group__["Transition"].defaultProps, {
  isOpen: false,
  appear: false,
  enter: true,
  exit: true,
  tag: 'div',
  timeout: TransitionTimeouts.Collapse
});

var transitionStatusToClassHash = (_transitionStatusToCl = {}, _transitionStatusToCl[TransitionStatuses.ENTERING] = 'collapsing', _transitionStatusToCl[TransitionStatuses.ENTERED] = 'collapse show', _transitionStatusToCl[TransitionStatuses.EXITING] = 'collapsing', _transitionStatusToCl[TransitionStatuses.EXITED] = 'collapse', _transitionStatusToCl);

function getTransitionClass(status) {
  return transitionStatusToClassHash[status] || 'collapse';
}

function getHeight(node) {
  return node.scrollHeight;
}

var Collapse_Collapse =
/*#__PURE__*/
function (_Component) {
  _inheritsLoose(Collapse, _Component);

  function Collapse(props) {
    var _this;

    _this = _Component.call(this, props) || this;
    _this.state = {
      height: null
    };
    ['onEntering', 'onEntered', 'onExit', 'onExiting', 'onExited'].forEach(function (name) {
      _this[name] = _this[name].bind(_assertThisInitialized(_assertThisInitialized(_this)));
    });
    return _this;
  }

  var _proto = Collapse.prototype;

  _proto.onEntering = function onEntering(node, isAppearing) {
    this.setState({
      height: getHeight(node)
    });
    this.props.onEntering(node, isAppearing);
  };

  _proto.onEntered = function onEntered(node, isAppearing) {
    this.setState({
      height: null
    });
    this.props.onEntered(node, isAppearing);
  };

  _proto.onExit = function onExit(node) {
    this.setState({
      height: getHeight(node)
    });
    this.props.onExit(node);
  };

  _proto.onExiting = function onExiting(node) {
    // getting this variable triggers a reflow
    var _unused = node.offsetHeight; // eslint-disable-line no-unused-vars

    this.setState({
      height: 0
    });
    this.props.onExiting(node);
  };

  _proto.onExited = function onExited(node) {
    this.setState({
      height: null
    });
    this.props.onExited(node);
  };

  _proto.render = function render() {
    var _this2 = this;

    var _this$props = this.props,
        Tag = _this$props.tag,
        isOpen = _this$props.isOpen,
        className = _this$props.className,
        navbar = _this$props.navbar,
        cssModule = _this$props.cssModule,
        children = _this$props.children,
        innerRef = _this$props.innerRef,
        otherProps = _objectWithoutPropertiesLoose(_this$props, ["tag", "isOpen", "className", "navbar", "cssModule", "children", "innerRef"]);

    var height = this.state.height;
    var transitionProps = pick(otherProps, TransitionPropTypeKeys);
    var childProps = omit(otherProps, TransitionPropTypeKeys);
    return Collapse___WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(Collapse___WEBPACK_IMPORTED_MODULE_8_react_transition_group__["Transition"], _extends({}, transitionProps, {
      in: isOpen,
      onEntering: this.onEntering,
      onEntered: this.onEntered,
      onExit: this.onExit,
      onExiting: this.onExiting,
      onExited: this.onExited
    }), function (status) {
      var collapseClass = getTransitionClass(status);
      var classes = mapToCssModules(Collapse___WEBPACK_IMPORTED_MODULE_7_classnames___default()(className, collapseClass, navbar && 'navbar-collapse'), cssModule);
      var style = height === null ? null : {
        height: height
      };
      return Collapse___WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(Tag, _extends({}, childProps, {
        style: _objectSpread({}, childProps.style, style),
        className: classes,
        ref: _this2.props.innerRef
      }), children);
    });
  };

  return Collapse;
}(Collapse___WEBPACK_IMPORTED_MODULE_5_react__["Component"]);

Collapse_Collapse.propTypes = Collapse_propTypes;
Collapse_Collapse.defaultProps = Collapse_defaultProps;
/* harmony default export */ var Collapse_defaultExport = (Collapse_Collapse);
// CONCATENATED MODULE: ./node_modules/reactstrap/es/ListGroupItem.js
/* harmony import */ var ListGroupItem___WEBPACK_IMPORTED_MODULE_2_react__ = __webpack_require__(71);
/* harmony import */ var ListGroupItem___WEBPACK_IMPORTED_MODULE_2_react___default = __webpack_require__.n(ListGroupItem___WEBPACK_IMPORTED_MODULE_2_react__);
/* harmony import */ var ListGroupItem___WEBPACK_IMPORTED_MODULE_3_prop_types__ = __webpack_require__(890);
/* harmony import */ var ListGroupItem___WEBPACK_IMPORTED_MODULE_3_prop_types___default = __webpack_require__.n(ListGroupItem___WEBPACK_IMPORTED_MODULE_3_prop_types__);
/* harmony import */ var ListGroupItem___WEBPACK_IMPORTED_MODULE_4_classnames__ = __webpack_require__(891);
/* harmony import */ var ListGroupItem___WEBPACK_IMPORTED_MODULE_4_classnames___default = __webpack_require__.n(ListGroupItem___WEBPACK_IMPORTED_MODULE_4_classnames__);






var ListGroupItem_propTypes = {
  tag: tagPropType,
  active: ListGroupItem___WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.bool,
  disabled: ListGroupItem___WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.bool,
  color: ListGroupItem___WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.string,
  action: ListGroupItem___WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.bool,
  className: ListGroupItem___WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.any,
  cssModule: ListGroupItem___WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.object
};
var ListGroupItem_defaultProps = {
  tag: 'li'
};

var handleDisabledOnClick = function handleDisabledOnClick(e) {
  e.preventDefault();
};

var ListGroupItem_ListGroupItem = function ListGroupItem(props) {
  var className = props.className,
      cssModule = props.cssModule,
      Tag = props.tag,
      active = props.active,
      disabled = props.disabled,
      action = props.action,
      color = props.color,
      attributes = _objectWithoutPropertiesLoose(props, ["className", "cssModule", "tag", "active", "disabled", "action", "color"]);

  var classes = mapToCssModules(ListGroupItem___WEBPACK_IMPORTED_MODULE_4_classnames___default()(className, active ? 'active' : false, disabled ? 'disabled' : false, action ? 'list-group-item-action' : false, color ? "list-group-item-" + color : false, 'list-group-item'), cssModule); // Prevent click event when disabled.

  if (disabled) {
    attributes.onClick = handleDisabledOnClick;
  }

  return ListGroupItem___WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(Tag, _extends({}, attributes, {
    className: classes
  }));
};

ListGroupItem_ListGroupItem.propTypes = ListGroupItem_propTypes;
ListGroupItem_ListGroupItem.defaultProps = ListGroupItem_defaultProps;
/* harmony default export */ var ListGroupItem_defaultExport = (ListGroupItem_ListGroupItem);
// CONCATENATED MODULE: ./node_modules/reactstrap/es/ListGroupItemHeading.js
/* harmony import */ var ListGroupItemHeading___WEBPACK_IMPORTED_MODULE_2_react__ = __webpack_require__(71);
/* harmony import */ var ListGroupItemHeading___WEBPACK_IMPORTED_MODULE_2_react___default = __webpack_require__.n(ListGroupItemHeading___WEBPACK_IMPORTED_MODULE_2_react__);
/* harmony import */ var ListGroupItemHeading___WEBPACK_IMPORTED_MODULE_3_prop_types__ = __webpack_require__(890);
/* harmony import */ var ListGroupItemHeading___WEBPACK_IMPORTED_MODULE_3_prop_types___default = __webpack_require__.n(ListGroupItemHeading___WEBPACK_IMPORTED_MODULE_3_prop_types__);
/* harmony import */ var ListGroupItemHeading___WEBPACK_IMPORTED_MODULE_4_classnames__ = __webpack_require__(891);
/* harmony import */ var ListGroupItemHeading___WEBPACK_IMPORTED_MODULE_4_classnames___default = __webpack_require__.n(ListGroupItemHeading___WEBPACK_IMPORTED_MODULE_4_classnames__);






var ListGroupItemHeading_propTypes = {
  tag: tagPropType,
  className: ListGroupItemHeading___WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.any,
  cssModule: ListGroupItemHeading___WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.object
};
var ListGroupItemHeading_defaultProps = {
  tag: 'h5'
};

var ListGroupItemHeading_ListGroupItemHeading = function ListGroupItemHeading(props) {
  var className = props.className,
      cssModule = props.cssModule,
      Tag = props.tag,
      attributes = _objectWithoutPropertiesLoose(props, ["className", "cssModule", "tag"]);

  var classes = mapToCssModules(ListGroupItemHeading___WEBPACK_IMPORTED_MODULE_4_classnames___default()(className, 'list-group-item-heading'), cssModule);
  return ListGroupItemHeading___WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(Tag, _extends({}, attributes, {
    className: classes
  }));
};

ListGroupItemHeading_ListGroupItemHeading.propTypes = ListGroupItemHeading_propTypes;
ListGroupItemHeading_ListGroupItemHeading.defaultProps = ListGroupItemHeading_defaultProps;
/* harmony default export */ var ListGroupItemHeading_defaultExport = (ListGroupItemHeading_ListGroupItemHeading);
// CONCATENATED MODULE: ./node_modules/reactstrap/es/ListGroupItemText.js
/* harmony import */ var ListGroupItemText___WEBPACK_IMPORTED_MODULE_2_react__ = __webpack_require__(71);
/* harmony import */ var ListGroupItemText___WEBPACK_IMPORTED_MODULE_2_react___default = __webpack_require__.n(ListGroupItemText___WEBPACK_IMPORTED_MODULE_2_react__);
/* harmony import */ var ListGroupItemText___WEBPACK_IMPORTED_MODULE_3_prop_types__ = __webpack_require__(890);
/* harmony import */ var ListGroupItemText___WEBPACK_IMPORTED_MODULE_3_prop_types___default = __webpack_require__.n(ListGroupItemText___WEBPACK_IMPORTED_MODULE_3_prop_types__);
/* harmony import */ var ListGroupItemText___WEBPACK_IMPORTED_MODULE_4_classnames__ = __webpack_require__(891);
/* harmony import */ var ListGroupItemText___WEBPACK_IMPORTED_MODULE_4_classnames___default = __webpack_require__.n(ListGroupItemText___WEBPACK_IMPORTED_MODULE_4_classnames__);






var ListGroupItemText_propTypes = {
  tag: tagPropType,
  className: ListGroupItemText___WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.any,
  cssModule: ListGroupItemText___WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.object
};
var ListGroupItemText_defaultProps = {
  tag: 'p'
};

var ListGroupItemText_ListGroupItemText = function ListGroupItemText(props) {
  var className = props.className,
      cssModule = props.cssModule,
      Tag = props.tag,
      attributes = _objectWithoutPropertiesLoose(props, ["className", "cssModule", "tag"]);

  var classes = mapToCssModules(ListGroupItemText___WEBPACK_IMPORTED_MODULE_4_classnames___default()(className, 'list-group-item-text'), cssModule);
  return ListGroupItemText___WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(Tag, _extends({}, attributes, {
    className: classes
  }));
};

ListGroupItemText_ListGroupItemText.propTypes = ListGroupItemText_propTypes;
ListGroupItemText_ListGroupItemText.defaultProps = ListGroupItemText_defaultProps;
/* harmony default export */ var ListGroupItemText_defaultExport = (ListGroupItemText_ListGroupItemText);
// CONCATENATED MODULE: ./node_modules/reactstrap/es/UncontrolledAlert.js
/* harmony import */ var UncontrolledAlert___WEBPACK_IMPORTED_MODULE_3_react__ = __webpack_require__(71);
/* harmony import */ var UncontrolledAlert___WEBPACK_IMPORTED_MODULE_3_react___default = __webpack_require__.n(UncontrolledAlert___WEBPACK_IMPORTED_MODULE_3_react__);






var UncontrolledAlert_UncontrolledAlert =
/*#__PURE__*/
function (_Component) {
  _inheritsLoose(UncontrolledAlert, _Component);

  function UncontrolledAlert(props) {
    var _this;

    _this = _Component.call(this, props) || this;
    _this.state = {
      isOpen: true
    };
    _this.toggle = _this.toggle.bind(_assertThisInitialized(_assertThisInitialized(_this)));
    return _this;
  }

  var _proto = UncontrolledAlert.prototype;

  _proto.toggle = function toggle() {
    this.setState({
      isOpen: !this.state.isOpen
    });
  };

  _proto.render = function render() {
    return UncontrolledAlert___WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(Alert_defaultExport, _extends({
      isOpen: this.state.isOpen,
      toggle: this.toggle
    }, this.props));
  };

  return UncontrolledAlert;
}(UncontrolledAlert___WEBPACK_IMPORTED_MODULE_3_react__["Component"]);

/* harmony default export */ var UncontrolledAlert_defaultExport = (UncontrolledAlert_UncontrolledAlert);
// CONCATENATED MODULE: ./node_modules/reactstrap/es/UncontrolledButtonDropdown.js
/* harmony import */ var UncontrolledButtonDropdown___WEBPACK_IMPORTED_MODULE_4_react__ = __webpack_require__(71);
/* harmony import */ var UncontrolledButtonDropdown___WEBPACK_IMPORTED_MODULE_4_react___default = __webpack_require__.n(UncontrolledButtonDropdown___WEBPACK_IMPORTED_MODULE_4_react__);
/* harmony import */ var UncontrolledButtonDropdown___WEBPACK_IMPORTED_MODULE_5_prop_types__ = __webpack_require__(890);
/* harmony import */ var UncontrolledButtonDropdown___WEBPACK_IMPORTED_MODULE_5_prop_types___default = __webpack_require__.n(UncontrolledButtonDropdown___WEBPACK_IMPORTED_MODULE_5_prop_types__);








var UncontrolledButtonDropdown_omitKeys = ['defaultOpen'];

var UncontrolledButtonDropdown_UncontrolledButtonDropdown =
/*#__PURE__*/
function (_Component) {
  _inheritsLoose(UncontrolledButtonDropdown, _Component);

  function UncontrolledButtonDropdown(props) {
    var _this;

    _this = _Component.call(this, props) || this;
    _this.state = {
      isOpen: props.defaultOpen || false
    };
    _this.toggle = _this.toggle.bind(_assertThisInitialized(_assertThisInitialized(_this)));
    return _this;
  }

  var _proto = UncontrolledButtonDropdown.prototype;

  _proto.toggle = function toggle() {
    this.setState({
      isOpen: !this.state.isOpen
    });
  };

  _proto.render = function render() {
    return UncontrolledButtonDropdown___WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(ButtonDropdown_defaultExport, _extends({
      isOpen: this.state.isOpen,
      toggle: this.toggle
    }, omit(this.props, UncontrolledButtonDropdown_omitKeys)));
  };

  return UncontrolledButtonDropdown;
}(UncontrolledButtonDropdown___WEBPACK_IMPORTED_MODULE_4_react__["Component"]);


UncontrolledButtonDropdown_UncontrolledButtonDropdown.propTypes = _objectSpread({
  defaultOpen: UncontrolledButtonDropdown___WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.bool
}, ButtonDropdown_defaultExport.propTypes);
// CONCATENATED MODULE: ./node_modules/reactstrap/es/UncontrolledCollapse.js
/* harmony import */ var UncontrolledCollapse___WEBPACK_IMPORTED_MODULE_3_react__ = __webpack_require__(71);
/* harmony import */ var UncontrolledCollapse___WEBPACK_IMPORTED_MODULE_3_react___default = __webpack_require__.n(UncontrolledCollapse___WEBPACK_IMPORTED_MODULE_3_react__);
/* harmony import */ var UncontrolledCollapse___WEBPACK_IMPORTED_MODULE_4_prop_types__ = __webpack_require__(890);
/* harmony import */ var UncontrolledCollapse___WEBPACK_IMPORTED_MODULE_4_prop_types___default = __webpack_require__.n(UncontrolledCollapse___WEBPACK_IMPORTED_MODULE_4_prop_types__);







var UncontrolledCollapse_omitKeys = ['toggleEvents', 'defaultOpen'];
var UncontrolledCollapse_propTypes = {
  defaultOpen: UncontrolledCollapse___WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.bool,
  toggler: UncontrolledCollapse___WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.string.isRequired,
  toggleEvents: UncontrolledCollapse___WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.arrayOf(UncontrolledCollapse___WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.string)
};
var UncontrolledCollapse_defaultProps = {
  toggleEvents: defaultToggleEvents
};

var UncontrolledCollapse_UncontrolledCollapse =
/*#__PURE__*/
function (_Component) {
  _inheritsLoose(UncontrolledCollapse, _Component);

  function UncontrolledCollapse(props) {
    var _this;

    _this = _Component.call(this, props) || this;
    _this.togglers = null;
    _this.removeEventListeners = null;
    _this.toggle = _this.toggle.bind(_assertThisInitialized(_assertThisInitialized(_this)));
    _this.state = {
      isOpen: props.defaultOpen || false
    };
    return _this;
  }

  var _proto = UncontrolledCollapse.prototype;

  _proto.componentDidMount = function componentDidMount() {
    this.togglers = findDOMElements(this.props.toggler);

    if (this.togglers.length) {
      this.removeEventListeners = addMultipleEventListeners(this.togglers, this.toggle, this.props.toggleEvents);
    }
  };

  _proto.componentWillUnmount = function componentWillUnmount() {
    if (this.togglers.length && this.removeEventListeners) {
      this.removeEventListeners();
    }
  };

  _proto.toggle = function toggle(e) {
    this.setState(function (_ref) {
      var isOpen = _ref.isOpen;
      return {
        isOpen: !isOpen
      };
    });
    e.preventDefault();
  };

  _proto.render = function render() {
    return UncontrolledCollapse___WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(Collapse_defaultExport, _extends({
      isOpen: this.state.isOpen
    }, omit(this.props, UncontrolledCollapse_omitKeys)));
  };

  return UncontrolledCollapse;
}(UncontrolledCollapse___WEBPACK_IMPORTED_MODULE_3_react__["Component"]);

UncontrolledCollapse_UncontrolledCollapse.propTypes = UncontrolledCollapse_propTypes;
UncontrolledCollapse_UncontrolledCollapse.defaultProps = UncontrolledCollapse_defaultProps;
/* harmony default export */ var UncontrolledCollapse_defaultExport = (UncontrolledCollapse_UncontrolledCollapse);
// CONCATENATED MODULE: ./node_modules/reactstrap/es/UncontrolledDropdown.js
/* harmony import */ var UncontrolledDropdown___WEBPACK_IMPORTED_MODULE_4_react__ = __webpack_require__(71);
/* harmony import */ var UncontrolledDropdown___WEBPACK_IMPORTED_MODULE_4_react___default = __webpack_require__.n(UncontrolledDropdown___WEBPACK_IMPORTED_MODULE_4_react__);
/* harmony import */ var UncontrolledDropdown___WEBPACK_IMPORTED_MODULE_5_prop_types__ = __webpack_require__(890);
/* harmony import */ var UncontrolledDropdown___WEBPACK_IMPORTED_MODULE_5_prop_types___default = __webpack_require__.n(UncontrolledDropdown___WEBPACK_IMPORTED_MODULE_5_prop_types__);








var UncontrolledDropdown_omitKeys = ['defaultOpen'];

var UncontrolledDropdown_UncontrolledDropdown =
/*#__PURE__*/
function (_Component) {
  _inheritsLoose(UncontrolledDropdown, _Component);

  function UncontrolledDropdown(props) {
    var _this;

    _this = _Component.call(this, props) || this;
    _this.state = {
      isOpen: props.defaultOpen || false
    };
    _this.toggle = _this.toggle.bind(_assertThisInitialized(_assertThisInitialized(_this)));
    return _this;
  }

  var _proto = UncontrolledDropdown.prototype;

  _proto.toggle = function toggle() {
    this.setState({
      isOpen: !this.state.isOpen
    });
  };

  _proto.render = function render() {
    return UncontrolledDropdown___WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(Dropdown_defaultExport, _extends({
      isOpen: this.state.isOpen,
      toggle: this.toggle
    }, omit(this.props, UncontrolledDropdown_omitKeys)));
  };

  return UncontrolledDropdown;
}(UncontrolledDropdown___WEBPACK_IMPORTED_MODULE_4_react__["Component"]);


UncontrolledDropdown_UncontrolledDropdown.propTypes = _objectSpread({
  defaultOpen: UncontrolledDropdown___WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.bool
}, Dropdown_defaultExport.propTypes);
// CONCATENATED MODULE: ./node_modules/reactstrap/es/UncontrolledNavDropdown.js
/* harmony import */ var UncontrolledNavDropdown___WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__(71);
/* harmony import */ var UncontrolledNavDropdown___WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(UncontrolledNavDropdown___WEBPACK_IMPORTED_MODULE_1_react__);





var UncontrolledNavDropdown_UncontrolledNavDropdown = function UncontrolledNavDropdown(props) {
  warnOnce('The "UncontrolledNavDropdown" component has been deprecated.\nPlease use component "UncontrolledDropdown" with nav prop.');
  return UncontrolledNavDropdown___WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(UncontrolledDropdown_UncontrolledDropdown, _extends({
    nav: true
  }, props));
};

/* harmony default export */ var UncontrolledNavDropdown_defaultExport = (UncontrolledNavDropdown_UncontrolledNavDropdown);
// CONCATENATED MODULE: ./node_modules/reactstrap/es/UncontrolledTooltip.js
/* harmony import */ var UncontrolledTooltip___WEBPACK_IMPORTED_MODULE_4_react__ = __webpack_require__(71);
/* harmony import */ var UncontrolledTooltip___WEBPACK_IMPORTED_MODULE_4_react___default = __webpack_require__.n(UncontrolledTooltip___WEBPACK_IMPORTED_MODULE_4_react__);
/* harmony import */ var UncontrolledTooltip___WEBPACK_IMPORTED_MODULE_5_prop_types__ = __webpack_require__(890);
/* harmony import */ var UncontrolledTooltip___WEBPACK_IMPORTED_MODULE_5_prop_types___default = __webpack_require__.n(UncontrolledTooltip___WEBPACK_IMPORTED_MODULE_5_prop_types__);








var UncontrolledTooltip_omitKeys = ['defaultOpen'];

var UncontrolledTooltip_UncontrolledTooltip =
/*#__PURE__*/
function (_Component) {
  _inheritsLoose(UncontrolledTooltip, _Component);

  function UncontrolledTooltip(props) {
    var _this;

    _this = _Component.call(this, props) || this;
    _this.state = {
      isOpen: props.defaultOpen || false
    };
    _this.toggle = _this.toggle.bind(_assertThisInitialized(_assertThisInitialized(_this)));
    return _this;
  }

  var _proto = UncontrolledTooltip.prototype;

  _proto.toggle = function toggle() {
    this.setState({
      isOpen: !this.state.isOpen
    });
  };

  _proto.render = function render() {
    return UncontrolledTooltip___WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(Tooltip_defaultExport, _extends({
      isOpen: this.state.isOpen,
      toggle: this.toggle
    }, omit(this.props, UncontrolledTooltip_omitKeys)));
  };

  return UncontrolledTooltip;
}(UncontrolledTooltip___WEBPACK_IMPORTED_MODULE_4_react__["Component"]);


UncontrolledTooltip_UncontrolledTooltip.propTypes = _objectSpread({
  defaultOpen: UncontrolledTooltip___WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.bool
}, Tooltip_defaultExport.propTypes);
// CONCATENATED MODULE: ./node_modules/reactstrap/es/Spinner.js
/* harmony import */ var Spinner___WEBPACK_IMPORTED_MODULE_2_react__ = __webpack_require__(71);
/* harmony import */ var Spinner___WEBPACK_IMPORTED_MODULE_2_react___default = __webpack_require__.n(Spinner___WEBPACK_IMPORTED_MODULE_2_react__);
/* harmony import */ var Spinner___WEBPACK_IMPORTED_MODULE_3_prop_types__ = __webpack_require__(890);
/* harmony import */ var Spinner___WEBPACK_IMPORTED_MODULE_3_prop_types___default = __webpack_require__.n(Spinner___WEBPACK_IMPORTED_MODULE_3_prop_types__);
/* harmony import */ var Spinner___WEBPACK_IMPORTED_MODULE_4_classnames__ = __webpack_require__(891);
/* harmony import */ var Spinner___WEBPACK_IMPORTED_MODULE_4_classnames___default = __webpack_require__.n(Spinner___WEBPACK_IMPORTED_MODULE_4_classnames__);






var Spinner_propTypes = {
  tag: tagPropType,
  type: Spinner___WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.string,
  size: Spinner___WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.string,
  color: Spinner___WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.string,
  className: Spinner___WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.string,
  cssModule: Spinner___WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.object,
  children: Spinner___WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.string
};
var Spinner_defaultProps = {
  tag: 'div',
  type: 'border',
  children: 'Loading...'
};

var Spinner_Spinner = function Spinner(props) {
  var className = props.className,
      cssModule = props.cssModule,
      type = props.type,
      size = props.size,
      color = props.color,
      children = props.children,
      Tag = props.tag,
      attributes = _objectWithoutPropertiesLoose(props, ["className", "cssModule", "type", "size", "color", "children", "tag"]);

  var classes = mapToCssModules(Spinner___WEBPACK_IMPORTED_MODULE_4_classnames___default()(className, size ? "spinner-" + type + "-" + size : false, "spinner-" + type, color ? "text-" + color : false), cssModule);
  return Spinner___WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(Tag, _extends({
    role: "status"
  }, attributes, {
    className: classes
  }), children && Spinner___WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement("span", {
    className: mapToCssModules('sr-only', cssModule)
  }, children));
};

Spinner_Spinner.propTypes = Spinner_propTypes;
Spinner_Spinner.defaultProps = Spinner_defaultProps;
/* harmony default export */ var Spinner_defaultExport = (Spinner_Spinner);
// CONCATENATED MODULE: ./node_modules/reactstrap/es/index.js




















































































































































































// CONCATENATED MODULE: ./src/components/Telemedicina/ModalConfirmacionTurno/ModalConfirmacionTurno.js
/* harmony import */ var ModalConfirmacionTurno___WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(71);
/* harmony import */ var ModalConfirmacionTurno___WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(ModalConfirmacionTurno___WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_redux__ = __webpack_require__(415);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_isomorphic_style_loader_lib_withStyles__ = __webpack_require__(887);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_isomorphic_style_loader_lib_withStyles___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_isomorphic_style_loader_lib_withStyles__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__ModalConfirmacionTurno_css__ = __webpack_require__(1221);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__ModalConfirmacionTurno_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__ModalConfirmacionTurno_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__actions_telemedicinaActions__ = __webpack_require__(416);
var _jsx = function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; }();

var ModalConfirmacionTurno__createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function ModalConfirmacionTurno__classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function ModalConfirmacionTurno__possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function ModalConfirmacionTurno__inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

/* global $ */
/* eslint react/no-did-mount-set-state: 0 */
/* eslint react/prop-types: 0 */
/* eslint consistent-return: 0 */








// import MonitoringUtil from '../../../utils/monitoringUtil.js';

var _ref = _jsx('strong', {}, void 0, ' Dia y Hora:');

var _ref2 = _jsx('div', {
  className: 'text-left'
}, void 0, 'al siguiente email:');

var _ref3 = _jsx('br', {});

var _ref4 = _jsx('i', {
  className: 'fa fa-envelope-o',
  'aria-hidden': 'true'
});

var _ref5 = _jsx('div', {
  className: 'col-lg-4'
});

var ModalConfirmacionTurno_ModalConfirmacionTurno = function (_React$Component) {
  ModalConfirmacionTurno__inherits(ModalConfirmacionTurno, _React$Component);

  function ModalConfirmacionTurno(props) {
    ModalConfirmacionTurno__classCallCheck(this, ModalConfirmacionTurno);

    var _this = ModalConfirmacionTurno__possibleConstructorReturn(this, (ModalConfirmacionTurno.__proto__ || Object.getPrototypeOf(ModalConfirmacionTurno)).call(this, props));

    _this.onButtonAgendarClick = _this.onButtonAgendarClick.bind(_this);

    // this.monitoringUtil = new MonitoringUtil();
    return _this;
  }

  ModalConfirmacionTurno__createClass(ModalConfirmacionTurno, [{
    key: 'onButtonAgendarClick',
    value: function onButtonAgendarClick() {
      this.props.closeModal();

      // Monitoring log
      /*
      this.monitoringUtil.createAffilliateLog({
        interaction: 'SOLICITUD DE TURNOS - POP-UP CONFIRMACION DE TURNO',
        message: `El afiliado tomo un turno el dia ${this.props
          .displayDate} con el medico ${this.props.nombre} ${this.props
          .apellido}`,
      }); */

      this.props.confirmarTurno(this.props.dataTurno, this.props.email);
    }
  }, {
    key: 'render',
    value: function render() {
      var _this2 = this;

      var urlImage = 'smgnewsite/images/telemedicina/';
      var img = '' + urlImage + this.props.prestadorId + '.jpg';
      var imgDefault = urlImage + 'sin_foto.jpg';
      return _jsx(Modal_defaultExport, {
        isOpen: this.props.show,
        toggle: this.props.closeModal
      }, void 0, _jsx(ModalHeader_defaultExport, {
        toggle: this.props.closeModal,
        className: '' + __WEBPACK_IMPORTED_MODULE_4__ModalConfirmacionTurno_css___default.a.robotoMedium
      }, void 0, 'Confirmaci\xF3n de Turno'), _jsx(ModalBody_defaultExport, {}, void 0, _jsx('img', {
        id: this.props.prestadorId,
        style: {
          borderRadius: '50%',
          width: '100px',
          marginLeft: 'auto',
          marginRight: 'auto',
          display: 'block'
        },
        className: 'align-self-center',
        src: img,
        alt: 'Medico',
        onError: function onError() {
          $('' + _this2.props.prestadorId).attr('src', imgDefault);
        }
      }), _jsx('div', {
        className: __WEBPACK_IMPORTED_MODULE_4__ModalConfirmacionTurno_css___default.a.robotoMedium + ' text-center'
      }, void 0, this.props.nombre + ' ' + this.props.apellido), _jsx('div', {
        style: { marginBottom: '10px' },
        className: __WEBPACK_IMPORTED_MODULE_4__ModalConfirmacionTurno_css___default.a.robotoMedium + ' text-center'
      }, void 0, $('#especialidad option:selected').text()), _jsx('div', {
        style: { padding: '0px 50px' }
      }, void 0, _jsx('div', {
        style: { marginBottom: '10px' },
        className: 'text-left'
      }, void 0, _ref, ' ', this.props.displayDate), _jsx('div', {
        style: { marginBottom: '5px' },
        className: 'text-left'
      }, void 0, 'Se enviar\xE1 confirmaci\xF3n de turno', ' '), _ref2, _ref3, _jsx('div', {
        className: __WEBPACK_IMPORTED_MODULE_4__ModalConfirmacionTurno_css___default.a.innerAddon + ' ' + __WEBPACK_IMPORTED_MODULE_4__ModalConfirmacionTurno_css___default.a.leftAddon
      }, void 0, _ref4, _jsx('input', {
        defaultValue: this.props.email,
        type: 'email',
        id: 'email',
        className: 'form-control',
        placeholder: 'Direcci\xF3n de correo electr\xF3nico'
      })))), _jsx(ModalFooter_defaultExport, {}, void 0, _jsx('div', {
        className: 'container-fluid'
      }, void 0, _jsx('div', {
        className: 'row'
      }, void 0, _jsx('div', {
        className: 'col-lg-4'
      }, void 0, _jsx('button', {
        onClick: this.props.closeModal,
        'data-dismiss': 'modal',
        className: __WEBPACK_IMPORTED_MODULE_4__ModalConfirmacionTurno_css___default.a.boton_blanco + ' ' + __WEBPACK_IMPORTED_MODULE_4__ModalConfirmacionTurno_css___default.a.robotoMedium + ' btn btn-default float-left'
      }, void 0, 'Cancelar')), _ref5, _jsx('div', {
        className: 'col-lg-4'
      }, void 0, _jsx('button', {
        className: __WEBPACK_IMPORTED_MODULE_4__ModalConfirmacionTurno_css___default.a.boton_rojo + ' ' + __WEBPACK_IMPORTED_MODULE_4__ModalConfirmacionTurno_css___default.a.robotoMedium + '  btn btn-danger float-right',
        onClick: function onClick(e) {
          return _this2.onButtonAgendarClick(e);
        }
      }, void 0, 'Agendar'))))));
    }
  }]);

  return ModalConfirmacionTurno;
}(ModalConfirmacionTurno___WEBPACK_IMPORTED_MODULE_0_react___default.a.Component);

/* harmony default export */ var ModalConfirmacionTurno_defaultExport = __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_1_react_redux__["b" /* connect */])(null, __WEBPACK_IMPORTED_MODULE_5__actions_telemedicinaActions__)(__WEBPACK_IMPORTED_MODULE_3_isomorphic_style_loader_lib_withStyles___default()(__WEBPACK_IMPORTED_MODULE_4__ModalConfirmacionTurno_css___default.a)(ModalConfirmacionTurno_ModalConfirmacionTurno)));

/***/ }),
/* 1141 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(71);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_redux__ = __webpack_require__(415);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_isomorphic_style_loader_lib_withStyles__ = __webpack_require__(887);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_isomorphic_style_loader_lib_withStyles___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_isomorphic_style_loader_lib_withStyles__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__ModalConfirmacionTurnoResp_css__ = __webpack_require__(1223);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__ModalConfirmacionTurnoResp_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__ModalConfirmacionTurnoResp_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__public_images_Confirmacion_png__ = __webpack_require__(1225);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__public_images_Confirmacion_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__public_images_Confirmacion_png__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__utils_redirectTo__ = __webpack_require__(419);
var _jsx = function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; }();

/* eslint react/no-did-mount-set-state: 0 */
/* eslint react/prop-types: 0 */
/* eslint consistent-return: 0 */








var _ref = _jsx('div', {
  className: 'modal-header'
}, void 0, _jsx('h5', {
  className: 'modal-title'
}, void 0, '\xA1Confirmaci\xF3n exitosa!'), _jsx('button', {
  type: 'button',
  className: 'close',
  'data-dismiss': 'modal',
  'aria-label': 'Close'
}, void 0, _jsx('span', {
  'aria-hidden': 'true'
}, void 0, '\xD7')));

var _ref2 = _jsx('img', {
  alt: 'Anterior',
  src: __WEBPACK_IMPORTED_MODULE_4__public_images_Confirmacion_png___default.a
});

var _ref3 = _jsx('br', {});

var _ref4 = _jsx('br', {});

var _ref5 = _jsx('span', {}, void 0, 'Se ha enviado un correo electr\xF3nico a');

var _ref6 = _jsx('strong', {}, void 0, _jsx('span', {
  id: 'mail'
}));

var _ref7 = _jsx('span', {}, void 0, ' con los datos de la consulta online.');

function ModalConfirmacionTurnoResp(props) {
  var url = '/telemedicina/consulta-turnos';

  return _jsx('div', {
    className: 'modal fade',
    id: 'modalConfirmTurnoResp'
  }, void 0, _jsx('div', {
    className: 'modal-dialog'
  }, void 0, _jsx('div', {
    className: __WEBPACK_IMPORTED_MODULE_3__ModalConfirmacionTurnoResp_css___default.a.modalContent + ' modal-content'
  }, void 0, _ref, _jsx('div', {
    className: 'modal-body'
  }, void 0, _ref2, _ref3, _ref4, _jsx('div', {
    style: { padding: '0px 50px' }
  }, void 0, _ref5, ' ', _ref6, _ref7)), _jsx('div', {
    className: __WEBPACK_IMPORTED_MODULE_3__ModalConfirmacionTurnoResp_css___default.a.modalFooter + ' modal-footer'
  }, void 0, _jsx('button', {
    'data-dismiss': 'modal',
    onClick: function onClick() {
      return Object(__WEBPACK_IMPORTED_MODULE_5__utils_redirectTo__["a" /* default */])(url);
    },
    className: __WEBPACK_IMPORTED_MODULE_3__ModalConfirmacionTurnoResp_css___default.a.boton_rojo + ' btn btn-danger pull-left'
  }, void 0, 'Aceptar')))));
}

/* const mapStateToProps = state => ({
  removeTurnoResp: state.turnos.remove,
}); */

/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_1_react_redux__["b" /* connect */])(null, null)(__WEBPACK_IMPORTED_MODULE_2_isomorphic_style_loader_lib_withStyles___default()(__WEBPACK_IMPORTED_MODULE_3__ModalConfirmacionTurnoResp_css___default.a)(ModalConfirmacionTurnoResp)));

/***/ }),
/* 1142 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * @copyright 2015, Andrey Popp <8mayday@gmail.com>
 *
 * The decorator may be used on classes or methods
 * ```
 * @autobind
 * class FullBound {}
 *
 * class PartBound {
 *   @autobind
 *   method () {}
 * }
 * ```
 */


Object.defineProperty(exports, '__esModule', {
  value: true
});
exports['default'] = autobind;

function autobind() {
  for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
    args[_key] = arguments[_key];
  }

  if (args.length === 1) {
    return boundClass.apply(undefined, args);
  } else {
    return boundMethod.apply(undefined, args);
  }
}

/**
 * Use boundMethod to bind all methods on the target.prototype
 */
function boundClass(target) {
  // (Using reflect to get all keys including symbols)
  var keys = undefined;
  // Use Reflect if exists
  if (typeof Reflect !== 'undefined' && typeof Reflect.ownKeys === 'function') {
    keys = Reflect.ownKeys(target.prototype);
  } else {
    keys = Object.getOwnPropertyNames(target.prototype);
    // use symbols if support is provided
    if (typeof Object.getOwnPropertySymbols === 'function') {
      keys = keys.concat(Object.getOwnPropertySymbols(target.prototype));
    }
  }

  keys.forEach(function (key) {
    // Ignore special case target method
    if (key === 'constructor') {
      return;
    }

    var descriptor = Object.getOwnPropertyDescriptor(target.prototype, key);

    // Only methods need binding
    if (typeof descriptor.value === 'function') {
      Object.defineProperty(target.prototype, key, boundMethod(target, key, descriptor));
    }
  });
  return target;
}

/**
 * Return a descriptor removing the value and returning a getter
 * The getter will return a .bind version of the function
 * and memoize the result against a symbol on the instance
 */
function boundMethod(target, key, descriptor) {
  var fn = descriptor.value;

  if (typeof fn !== 'function') {
    throw new Error('@autobind decorator can only be applied to methods not: ' + typeof fn);
  }

  // In IE11 calling Object.defineProperty has a side-effect of evaluating the
  // getter for the property which is being replaced. This causes infinite
  // recursion and an "Out of stack space" error.
  var definingProperty = false;

  return {
    configurable: true,
    get: function get() {
      if (definingProperty || this === target.prototype || this.hasOwnProperty(key)) {
        return fn;
      }

      var boundFn = fn.bind(this);
      definingProperty = true;
      Object.defineProperty(this, key, {
        value: boundFn,
        configurable: true,
        writable: true
      });
      definingProperty = false;
      return boundFn;
    }
  };
}
module.exports = exports['default'];


/***/ }),
/* 1143 */,
/* 1144 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";

// CONCATENATED MODULE: ./src/components/Telemedicina/ModalReprogramarTurno/ModalReprogramarTurno.js
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(71);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_redux__ = __webpack_require__(415);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_isomorphic_style_loader_lib_withStyles__ = __webpack_require__(887);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_isomorphic_style_loader_lib_withStyles___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_isomorphic_style_loader_lib_withStyles__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__ModalReprogramarTurno_css__ = __webpack_require__(1153);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__ModalReprogramarTurno_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__ModalReprogramarTurno_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__utils_redirectTo__ = __webpack_require__(419);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__actions_telemedicinaActions__ = __webpack_require__(416);
var _jsx = function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; }();

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

/* eslint react/no-did-mount-set-state: 0 */
/* eslint react/prop-types: 0 */
/* eslint consistent-return: 0 */







var _ref = _jsx('div', {
  className: 'modal-header'
}, void 0, _jsx('h5', {
  className: 'modal-title'
}, void 0, 'Reprogramar turno'));

var _ref2 = _jsx('div', {}, void 0, 'Lo sentimos, en este momento no podemos atenderte. Por favor agend\xE1 un nuevo turno.');

var ModalReprogramarTurno = function (_React$Component) {
  _inherits(ModalReprogramarTurno, _React$Component);

  function ModalReprogramarTurno() {
    _classCallCheck(this, ModalReprogramarTurno);

    return _possibleConstructorReturn(this, (ModalReprogramarTurno.__proto__ || Object.getPrototypeOf(ModalReprogramarTurno)).apply(this, arguments));
  }

  _createClass(ModalReprogramarTurno, [{
    key: 'componentDidMount',
    value: function componentDidMount() {}
  }, {
    key: 'render',
    value: function render() {
      var _this2 = this;

      return _jsx('div', {}, void 0, _jsx('div', {
        className: 'modal fade',
        id: 'ModalReprogramarTurno'
      }, void 0, _jsx('div', {
        className: 'modal-dialog'
      }, void 0, _jsx('div', {
        className: __WEBPACK_IMPORTED_MODULE_3__ModalReprogramarTurno_css___default.a.modalContent + ' modal-content'
      }, void 0, _ref, _jsx('div', {
        className: __WEBPACK_IMPORTED_MODULE_3__ModalReprogramarTurno_css___default.a.modalBody + ' modal-body'
      }, void 0, _ref2), _jsx('div', {
        className: __WEBPACK_IMPORTED_MODULE_3__ModalReprogramarTurno_css___default.a.modalFooter + ' modal-footer'
      }, void 0, _jsx('button', {
        'data-dismiss': 'modal',
        className: __WEBPACK_IMPORTED_MODULE_3__ModalReprogramarTurno_css___default.a.boton_rojo + ' btn btn-danger text-center',
        onClick: function onClick() {
          _this2.props.hideValidacionesTecnicas();
          Object(__WEBPACK_IMPORTED_MODULE_4__utils_redirectTo__["a" /* default */])('/telemedicina/solicitud-turnos');
        }
      }, void 0, 'Agendar nuevo turno'))))));
    }
  }]);

  return ModalReprogramarTurno;
}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component);

/* harmony default export */ var ModalReprogramarTurno_defaultExport = (Object(__WEBPACK_IMPORTED_MODULE_1_react_redux__["b" /* connect */])(null, __WEBPACK_IMPORTED_MODULE_5__actions_telemedicinaActions__)(__WEBPACK_IMPORTED_MODULE_2_isomorphic_style_loader_lib_withStyles___default()(__WEBPACK_IMPORTED_MODULE_3__ModalReprogramarTurno_css___default.a)(ModalReprogramarTurno)));
// CONCATENATED MODULE: ./src/components/Telemedicina/ModalVideoLlamada/TimerModalVideoLlamada/TimerModalVideoLlamada.js
/* harmony import */ var TimerModalVideoLlamada___WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(71);
/* harmony import */ var TimerModalVideoLlamada___WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(TimerModalVideoLlamada___WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var TimerModalVideoLlamada___WEBPACK_IMPORTED_MODULE_1_react_redux__ = __webpack_require__(415);
/* harmony import */ var TimerModalVideoLlamada___WEBPACK_IMPORTED_MODULE_2_isomorphic_style_loader_lib_withStyles__ = __webpack_require__(887);
/* harmony import */ var TimerModalVideoLlamada___WEBPACK_IMPORTED_MODULE_2_isomorphic_style_loader_lib_withStyles___default = __webpack_require__.n(TimerModalVideoLlamada___WEBPACK_IMPORTED_MODULE_2_isomorphic_style_loader_lib_withStyles__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__actions_telemedicinaActions__ = __webpack_require__(416);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__TimerModalVideoLlamada_css__ = __webpack_require__(1149);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__TimerModalVideoLlamada_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__TimerModalVideoLlamada_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__public_images_espera_mp4__ = __webpack_require__(1151);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__public_images_espera_mp4___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__public_images_espera_mp4__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__public_images_video_mp4__ = __webpack_require__(1152);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__public_images_video_mp4___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__public_images_video_mp4__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__utils_timeManipulation__ = __webpack_require__(1139);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_moment__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9_moment__);
var TimerModalVideoLlamada__jsx = function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; }();

var TimerModalVideoLlamada__createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function TimerModalVideoLlamada__classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function TimerModalVideoLlamada__possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function TimerModalVideoLlamada__inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

/* eslint-disable */












var doctors = {
  ClinicaMedica: [{
    img: 'ClinicaMedica/553',
    name: 'Jose Scarlatta	'
  }, {
    img: 'ClinicaMedica/749',
    name: 'Iris Salama'
  }, {
    img: 'ClinicaMedica/24579',
    name: 'Ana Maria Videla'
  }, {
    img: 'ClinicaMedica/19524',
    name: 'Alberto Montes'
  }, {
    img: 'ClinicaMedica/18046',
    name: 'Ezequiel Sosa'
  }, {
    img: 'ClinicaMedica/17991',
    name: 'Maria Marta Plaza'
  }, {
    img: 'ClinicaMedica/17978',
    name: 'Patricia Andrea Molina'
  }, {
    img: 'ClinicaMedica/24580',
    name: 'Eduardo Abbate'
  }],
  Pediatria: [{
    img: 'Pediatria/24576',
    name: 'Sergio Araya'
  }, {
    img: 'Pediatria/426',
    name: 'Maria Isabel Alapont Montoya'
  }, {
    img: 'Pediatria/670',
    name: 'Ariel Marcelo Almada'
  }, {
    img: 'Pediatria/17997',
    name: 'Natalia Cristina Freitas'
  }, {
    img: 'Pediatria/24569',
    name: 'Analia Jimena Bravo'
  }, {
    img: 'Pediatria/24570',
    name: 'Fernanda Perez Simoes'
  }, {
    img: 'Pediatria/24574',
    name: 'Maria Fernanda Rome'
  }, {
    img: 'Pediatria/24572',
    name: 'Karina Grinstein'
  }, {
    img: 'Pediatria/24573',
    name: 'Liliana Mariñansky'
  }, {
    img: 'Pediatria/24577',
    name: 'Silvina Mazzolo'
  }, {
    img: 'Pediatria/25241',
    name: 'Nora Judith Zonis'
  }, {
    img: 'Pediatria/25829',
    name: 'María Florencia Fernandez'
  }]
};

var TimerModalVideoLlamada__ref = TimerModalVideoLlamada__jsx('p', {}, void 0, 'Pacientes en espera');

var TimerModalVideoLlamada__ref2 = TimerModalVideoLlamada__jsx('div', {});

var _ref3 = TimerModalVideoLlamada__jsx('br', {});

var _ref4 = TimerModalVideoLlamada__jsx('br', {});

var _ref5 = TimerModalVideoLlamada__jsx('br', {});

var _ref6 = TimerModalVideoLlamada__jsx(ModalReprogramarTurno_defaultExport, {});

var TimerModalVideoLlamada = function (_React$Component) {
  TimerModalVideoLlamada__inherits(TimerModalVideoLlamada, _React$Component);

  function TimerModalVideoLlamada(props) {
    TimerModalVideoLlamada__classCallCheck(this, TimerModalVideoLlamada);

    var _this = TimerModalVideoLlamada__possibleConstructorReturn(this, (TimerModalVideoLlamada.__proto__ || Object.getPrototypeOf(TimerModalVideoLlamada)).call(this, props));

    _this.changeAproxWaitingTime = function () {
      var newAproxTime = __WEBPACK_IMPORTED_MODULE_8__utils_timeManipulation__["a" /* default */].changeAproxWaitingTime(_this.state.aproxTime, _this.state.aproxTimeInterval);
      _this.setState({ aproxTime: newAproxTime });
    };

    _this.nombreMedico = function () {
      if (_this.props.turno.reemplazo && _this.props.turno.reemplazo.nombreAbre) {
        return _this.props.turno.reemplazo.nombreAbre + " " + _this.props.turno.reemplazo.apeRazon;
      }
      return _this.props.turno.titular.nombreAbre + " " + _this.props.turno.titular.apeRazon;
    };

    _this.medicRandom = function () {
      var medicData = void 0;
      if (_this.props.turno.idEspecialidad == 200) {
        medicData = doctors.Pediatria[Math.floor(Math.random() * doctors.Pediatria.length)];
        _this.setState({ medicData: medicData });
      } else {
        medicData = doctors.ClinicaMedica[Math.floor(Math.random() * doctors.ClinicaMedica.length)];
        _this.setState({ medicData: medicData });
      }
    };

    _this.nombreMedico = _this.nombreMedico.bind(_this);
    _this.state = {
      medicData: '',
      interval: null,
      aproxTimeInterval: null,
      aproxTime: _this.props.turnWaitingTime ? _this.props.turnWaitingTime.aproxTime : ""
      //aproxTime: this.props.turnWaitingTime
    };
    _this.handleWaitingScreen = _this.handleWaitingScreen.bind(_this);
    return _this;
  }

  TimerModalVideoLlamada__createClass(TimerModalVideoLlamada, [{
    key: 'componentWillMount',
    value: function componentWillMount() {
      this.props.admisionDePaciente(this.props.turno).then(function () {
        $('#videoSwiss').attr('src', __WEBPACK_IMPORTED_MODULE_6__public_images_video_mp4___default.a);
      });
    }
  }, {
    key: 'componentDidMount',
    value: function componentDidMount() {
      if (this.props.turno.tipo == 'E') {
        setInterval(this.props.aproxPeopleInQueue, 60000 * 5);
        this.props.aproxPeopleInQueue();
        var interval = setInterval(this.medicRandom, 5000);
        var aproxTimeInterval = setInterval(this.changeAproxWaitingTime, 60000 * 5);
        this.setState({ interval: interval, aproxTimeInterval: aproxTimeInterval });
      }
      if (this.props.admision) {
        $('#videoSwiss').attr('src', __WEBPACK_IMPORTED_MODULE_6__public_images_video_mp4___default.a);
      }
    }
  }, {
    key: 'componentWillUnmount',
    value: function componentWillUnmount() {
      clearInterval(this.admision);
      clearInterval(this.state.interval);
    }
  }, {
    key: 'formatDate',
    value: function formatDate(date) {
      var year = date.substring(0, 4);
      var month = date.substring(4, 6);
      var day = date.substring(6, 8);
      var hour = date.substring(8, 10);
      var min = date.substring(10, 12);
      var dateFormated = year + '-' + month + '-' + day + ' ' + hour + ':' + min;
      return dateFormated;
    }
  }, {
    key: 'handleWaitingScreen',
    value: function handleWaitingScreen() {
      var _this2 = this;

      //Agrego : a la hora para setearla a moment despues
      var horaTurno = this.props.turno.hora.substr(0, 2) + ':' + this.props.turno.hora.substr(2, 4);
      var horaLimiteTurno = __WEBPACK_IMPORTED_MODULE_9_moment___default()(horaTurno, 'HH:mm').add(10, 'minutes');
      var horaServer = void 0;

      //Inicio pantalla de espera
      if (this.props.admision && this.props.admision.clientId) {
        if (this.props.IniciarLlamada != 1) {
          this.props.iniciarVideoLlamada($('#alertaSonora').is(':checked'), this.props.admision.clientId);
        }

        //Si es programado evaluo la hora del server
        //si se pasa del +10 lo saco de la espera
        if (this.props.turno.tipo != 'E' && this.props.admision) {
          horaServer = horaServer ? horaServer : __WEBPACK_IMPORTED_MODULE_9_moment___default()(this.props.admision.horaServer);
          var intervaloChequeoTurno = setInterval(function () {
            var turnoExpirado = horaServer.isAfter(horaLimiteTurno);
            if (turnoExpirado && !_this2.props.stopInterval) {
              _this2.props.cleanLlamada();
              $('#ModalReprogramarTurno').modal({ backdrop: 'static', keyboard: false });
              $('.modal-backdrop').hide();
              if (document.getElementById('localView')) {
                if (document.getElementById('localView').srcObject) {
                  document.getElementById('localView').srcObject.getTracks().forEach(function (track) {
                    return track.stop();
                  });
                  $('localView').srcObject = null;
                }
              }
              clearInterval(intervaloChequeoTurno);
            }
            //Sumo un minuto a la hora server
            horaServer = __WEBPACK_IMPORTED_MODULE_9_moment___default()(horaServer).add(1, 'minutes');
          }, 60000);
        }
      }
    }
  }, {
    key: 'render',
    value: function render() {
      this.handleWaitingScreen();
      console.log(this.props.telefono);
      return TimerModalVideoLlamada__jsx('div', {
        style: { width: '100%' }
      }, void 0, this.props.admision ? TimerModalVideoLlamada__jsx('div', {}, void 0, TimerModalVideoLlamada__jsx('div', {
        id: 'datosMedico'
      }, void 0, TimerModalVideoLlamada__jsx('div', {
        style: {
          margin: '20px auto',
          borderColor: '#e4002b',
          fontWeight: 'bold',
          textAlign: 'center',
          height: 'auto',
          fontFamily: "Roboto",
          fontSize: '20px'
        }
      }, void 0, this.props.turno.tipo == 'E' ? TimerModalVideoLlamada__jsx('div', {}, void 0, TimerModalVideoLlamada__jsx('p', {
        style: { width: '100%' }
      }, void 0, 'Especialidad:', parseInt(this.props.turno.idEspecialidad) === 100 ? TimerModalVideoLlamada__jsx('span', {
        style: { color: '#FFBB24' }
      }, void 0, ' Clinica M\xE9dica') : TimerModalVideoLlamada__jsx('span', {
        style: { color: '#FFBB24' }
      }, void 0, ' Pediatr\xEDa'))) : TimerModalVideoLlamada__jsx('div', {}, void 0)), TimerModalVideoLlamada__jsx('div', {
        style: { textAlign: 'center' }
      }, void 0, TimerModalVideoLlamada__jsx('div', {
        style: { width: '100%', marginBottom: '20px' }
      }, void 0, this.props.turno.tipo == 'E' ? this.props.numeroDePacientes == undefined || this.props.numeroDePacientes.respuesta == "999" ? '' : TimerModalVideoLlamada__jsx('div', {}, void 0, TimerModalVideoLlamada__jsx('div', {
        style: { paddingTop: '1em' }
      }, void 0, TimerModalVideoLlamada__jsx('p', {
        style: { color: '#E4002B', fontSize: '91px', fontWeight: '800', display: 'inline-block' }
      }, void 0, this.props.numeroDePacientes.respuesta), TimerModalVideoLlamada__jsx('img', {
        src: __webpack_require__(1155),
        style: { paddingBottom: '2.5em' }
      })), TimerModalVideoLlamada__ref) : TimerModalVideoLlamada__ref2), TimerModalVideoLlamada__jsx('div', {
        style: { marginBottom: '20px', display: 'flex', justifyContent: 'center' }
      }, void 0, this.props.turno.tipo == 'E' ? TimerModalVideoLlamada__jsx('p', {}, void 0, 'Debido a la alta demanda de este servicio el tiempo de espera puede ', _ref3, ' ser prolongado, tambi\xE9n puede comunicarse con nuestra', _ref4, ' ', TimerModalVideoLlamada__jsx('span', {
        style: { fontWeight: 'bold' }
      }, void 0, 'l\xEDnea de orientaci\xF3n m\xE9dica al 011 4363-4710. '), _ref5, ' Por cualquier ', TimerModalVideoLlamada__jsx('span', {
        style: { fontWeight: 'bold', color: '#E4002B' }
      }, void 0, 'urgencia comun\xEDquese al 0800-777-7800 ')) : TimerModalVideoLlamada__jsx('p', {
        style: { fontWeight: '600', marginTop: '20px', textAlign: 'center', paddingBottom: '30px' }
      }, void 0, ' En Breve Ser\xE1s Atendido ')))), TimerModalVideoLlamada__jsx('div', {
        className: 'row',
        style: { fontSize: 'small', marginTop: '30px', paddingLeft: '59px', paddingBottom: '30px' }
      }, void 0, TimerModalVideoLlamada__jsx('label', {
        className: 'form-check-label d-flex align-items-center col-12'
      }, void 0, TimerModalVideoLlamada__jsx('input', {
        className: 'form-check-input',
        id: 'alertaSonora',
        type: 'checkbox',
        value: '',
        style: { marginRight: '1em', marginBotton: 'auto' }
      }), 'Activar alerta sonora cuando llegue el m\xE9dico'))) : '', _ref6);
    }
  }]);

  return TimerModalVideoLlamada;
}(TimerModalVideoLlamada___WEBPACK_IMPORTED_MODULE_0_react___default.a.Component);

var mapStateToProps = function mapStateToProps(state) {
  return {
    admision: state.telemedicina.admisionado,
    turnWaitingTime: state.telemedicina.turnWaitingTime,
    IniciarLlamada: state.telemedicina.iniciar_llamada,
    telefono: state.telemedicina.telefono,
    numeroDePacientes: state.telemedicina.numeroPacientes
  };
};

/* harmony default export */ var TimerModalVideoLlamada_defaultExport = (Object(TimerModalVideoLlamada___WEBPACK_IMPORTED_MODULE_1_react_redux__["b" /* connect */])(mapStateToProps, __WEBPACK_IMPORTED_MODULE_3__actions_telemedicinaActions__)(TimerModalVideoLlamada___WEBPACK_IMPORTED_MODULE_2_isomorphic_style_loader_lib_withStyles___default()(__WEBPACK_IMPORTED_MODULE_4__TimerModalVideoLlamada_css___default.a)(TimerModalVideoLlamada)));
// CONCATENATED MODULE: ./src/components/Telemedicina/ModalVideoLlamada/UploadsModalVideoLlamada/UploadsModalVideoLlamada.js
/* harmony import */ var UploadsModalVideoLlamada___WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(71);
/* harmony import */ var UploadsModalVideoLlamada___WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(UploadsModalVideoLlamada___WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_isomorphic_style_loader_lib_withStyles__ = __webpack_require__(887);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_isomorphic_style_loader_lib_withStyles___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_isomorphic_style_loader_lib_withStyles__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_progressbar__ = __webpack_require__(1167);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_progressbar___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_react_progressbar__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__UploadsModalVideoLlamada_css__ = __webpack_require__(1187);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__UploadsModalVideoLlamada_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__UploadsModalVideoLlamada_css__);
var UploadsModalVideoLlamada__jsx = function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; }();

var UploadsModalVideoLlamada__createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function UploadsModalVideoLlamada__classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function UploadsModalVideoLlamada__possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function UploadsModalVideoLlamada__inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

/* eslint react/prop-types: 0 */
/* eslint import/no-unresolved:0 */
/* global $ */



 /* upload progress */


var UploadsModalVideoLlamada__ref = UploadsModalVideoLlamada__jsx('div', {
  className: 'col-md-11'
}, void 0, UploadsModalVideoLlamada__jsx('strong', {}, void 0, 'Subiendo Archivos'));

var UploadsModalVideoLlamada__ref2 = UploadsModalVideoLlamada__jsx('br', {});

var UploadsModalVideoLlamada = function (_React$Component) {
  UploadsModalVideoLlamada__inherits(UploadsModalVideoLlamada, _React$Component);

  function UploadsModalVideoLlamada() {
    UploadsModalVideoLlamada__classCallCheck(this, UploadsModalVideoLlamada);

    return UploadsModalVideoLlamada__possibleConstructorReturn(this, (UploadsModalVideoLlamada.__proto__ || Object.getPrototypeOf(UploadsModalVideoLlamada)).apply(this, arguments));
  }

  UploadsModalVideoLlamada__createClass(UploadsModalVideoLlamada, [{
    key: 'componentDidMount',
    value: function componentDidMount() {}
  }, {
    key: 'componentWillReceiveProps',
    value: function componentWillReceiveProps() {}
  }, {
    key: 'componentWillUnmount',
    value: function componentWillUnmount() {}
  }, {
    key: 'render',
    value: function render() {
      var _this2 = this;

      var filesUploaded = this.props.filesUploaded;
      return UploadsModalVideoLlamada__jsx('div', {
        className: __WEBPACK_IMPORTED_MODULE_3__UploadsModalVideoLlamada_css___default.a.modalVideoLlamadaUploads,
        id: 'modalVideoLlamadaUploads'
      }, void 0, UploadsModalVideoLlamada__jsx('div', {
        style: { padding: '0' },
        className: 'col-md-12 row'
      }, void 0, UploadsModalVideoLlamada__ref, UploadsModalVideoLlamada__jsx('div', {
        className: 'col-md-1'
      }, void 0, UploadsModalVideoLlamada__jsx('button', {
        style: {
          backgroundColor: '#fff',
          border: '0',
          cursor: 'pointer',
          textAlign: 'right',
          padding: '0'
        },
        onClick: function onClick() {
          return $('#modalVideoLlamadaUploads').hide(200);
        }
      }, void 0, 'x'))), UploadsModalVideoLlamada__ref2, Object.keys(filesUploaded).map(function (key) {
        return UploadsModalVideoLlamada__jsx('div', {
          className: __WEBPACK_IMPORTED_MODULE_3__UploadsModalVideoLlamada_css___default.a.uploadedFile + ' row'
        }, filesUploaded[key].file.name, UploadsModalVideoLlamada__jsx('i', {
          className: 'fa fa-picture-o col-1',
          'aria-hidden': 'true',
          style: { padding: 0 }
        }), filesUploaded[key].progress < 100 || filesUploaded[key].progress === 'Cancelado' ? UploadsModalVideoLlamada__jsx('div', {
          className: 'col-11'
        }, void 0, UploadsModalVideoLlamada__jsx('div', {
          className: 'row'
        }, void 0, UploadsModalVideoLlamada__jsx('span', {
          className: 'col-4',
          style: {
            textOverflow: 'ellipsis',
            overflow: 'hidden',
            padding: '0',
            whiteSpace: 'nowrap'
          }
        }, void 0, filesUploaded[key].file.name), UploadsModalVideoLlamada__jsx('span', {
          style: { paddingRight: '0' },
          className: 'col-2'
        }, void 0, UploadsModalVideoLlamada__jsx('i', {
          className: 'fa fa-times ',
          'aria-hidden': 'true',
          style: { color: '#e4002b', marginLeft: '5px' }
        })), filesUploaded[key].progress === 'Cancelado' ? UploadsModalVideoLlamada__jsx('div', {
          style: { paddingLeft: '0' },
          className: 'col-6'
        }, void 0, UploadsModalVideoLlamada__jsx('strong', {
          className: filesUploaded[key].motivo === 'Cancelado' ? 'col-8' : 'col-12',
          style: {
            padding: '0',
            color: '#e4002b',
            fontSize: '14px'
          }
        }, void 0, filesUploaded[key].motivo), filesUploaded[key].motivo === 'Cancelado' ? UploadsModalVideoLlamada__jsx('span', {
          className: 'col-2',
          onClick: function onClick() {
            return _this2.props.retryUpload(key);
          },
          role: 'button',
          tabIndex: '-1',
          style: { color: '#EB0000' }
        }, void 0, 'Reintentar') : '') : UploadsModalVideoLlamada__jsx('div', {
          className: 'col-12 row'
        }, void 0, UploadsModalVideoLlamada__jsx(__WEBPACK_IMPORTED_MODULE_2_react_progressbar___default.a, {
          className: 'col-11',
          completed: filesUploaded[key].progress,
          color: '#007a6e',
          style: { paddingLeft: '0' }
        }), UploadsModalVideoLlamada__jsx('span', {
          className: 'col-1',
          onClick: function onClick() {
            return _this2.props.cancelUpload(key);
          },
          role: 'button',
          tabIndex: '-1',
          style: {
            padding: '0px',
            fontSize: '12px',
            fontWeight: 'bold',
            marginTop: '-3px',
            textAlign: 'right'
          }
        }, void 0, 'X')))) : UploadsModalVideoLlamada__jsx('div', {
          className: 'col-11 '
        }, void 0, UploadsModalVideoLlamada__jsx('div', {
          className: 'row'
        }, void 0, UploadsModalVideoLlamada__jsx('span', {
          className: 'col-4',
          style: {
            textOverflow: 'ellipsis',
            overflow: 'hidden',
            padding: '0',
            whiteSpace: 'nowrap',
            maxWidth: '90%'
          }
        }, void 0, filesUploaded[key].file.name), filesUploaded[key].progress === 'ok' ? UploadsModalVideoLlamada__jsx('span', {
          className: 'col-6'
        }, void 0, UploadsModalVideoLlamada__jsx('i', {
          className: 'fa fa-check ',
          'aria-hidden': 'true',
          style: { color: '#478a47', marginLeft: '5px' }
        })) : '', filesUploaded[key].progress === 'cargando' ? UploadsModalVideoLlamada__jsx('span', {
          className: 'col-6'
        }, void 0, UploadsModalVideoLlamada__jsx('strong', {
          style: {
            padding: '0',
            color: '#000',
            fontSize: '14px'
          }
        }, void 0, 'Subiendo archivo...')) : '')));
      }));
    }
  }]);

  return UploadsModalVideoLlamada;
}(UploadsModalVideoLlamada___WEBPACK_IMPORTED_MODULE_0_react___default.a.Component);
/*
const mapStateToProps = state => ({
  fileuploadStatus: state.telemedicina.fileuploadStatus,
});
*/


/* harmony default export */ var UploadsModalVideoLlamada_defaultExport = (__WEBPACK_IMPORTED_MODULE_1_isomorphic_style_loader_lib_withStyles___default()(__WEBPACK_IMPORTED_MODULE_3__UploadsModalVideoLlamada_css___default.a)(UploadsModalVideoLlamada));
// CONCATENATED MODULE: ./src/components/Telemedicina/ModalVideoLlamada/UploadsOkModalVideoLlamada/UploadsOkModalVideoLlamada.js
/* harmony import */ var UploadsOkModalVideoLlamada___WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(71);
/* harmony import */ var UploadsOkModalVideoLlamada___WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(UploadsOkModalVideoLlamada___WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var UploadsOkModalVideoLlamada___WEBPACK_IMPORTED_MODULE_1_isomorphic_style_loader_lib_withStyles__ = __webpack_require__(887);
/* harmony import */ var UploadsOkModalVideoLlamada___WEBPACK_IMPORTED_MODULE_1_isomorphic_style_loader_lib_withStyles___default = __webpack_require__.n(UploadsOkModalVideoLlamada___WEBPACK_IMPORTED_MODULE_1_isomorphic_style_loader_lib_withStyles__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__UploadsOkModalVideoLlamada_css__ = __webpack_require__(1189);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__UploadsOkModalVideoLlamada_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__UploadsOkModalVideoLlamada_css__);
var UploadsOkModalVideoLlamada__jsx = function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; }();

var UploadsOkModalVideoLlamada__createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function UploadsOkModalVideoLlamada__classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function UploadsOkModalVideoLlamada__possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function UploadsOkModalVideoLlamada__inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

/* global $ */




var UploadsOkModalVideoLlamada = function (_React$Component) {
  UploadsOkModalVideoLlamada__inherits(UploadsOkModalVideoLlamada, _React$Component);

  function UploadsOkModalVideoLlamada() {
    UploadsOkModalVideoLlamada__classCallCheck(this, UploadsOkModalVideoLlamada);

    return UploadsOkModalVideoLlamada__possibleConstructorReturn(this, (UploadsOkModalVideoLlamada.__proto__ || Object.getPrototypeOf(UploadsOkModalVideoLlamada)).apply(this, arguments));
  }

  UploadsOkModalVideoLlamada__createClass(UploadsOkModalVideoLlamada, [{
    key: 'componentDidMount',
    value: function componentDidMount() {}
  }, {
    key: 'componentWillReceiveProps',
    value: function componentWillReceiveProps() {}
  }, {
    key: 'componentWillUnmount',
    value: function componentWillUnmount() {}
  }, {
    key: 'render',
    value: function render() {
      return UploadsOkModalVideoLlamada__jsx('div', {
        className: __WEBPACK_IMPORTED_MODULE_2__UploadsOkModalVideoLlamada_css___default.a.modalVideoLlamadaUploadsOk,
        id: 'modalVideoLlamadaUploadsOk'
      }, void 0, UploadsOkModalVideoLlamada__jsx('span', {
        id: 'boton_cerrar',
        style: {
          position: 'absolute',
          right: '10px',
          top: '0',
          fontWeight: 'bold',
          color: '#000'
        },
        role: 'button',
        tabIndex: '-1',
        onClick: UploadsOkModalVideoLlamada.closeUploadsOk
      }, void 0, 'x'), UploadsOkModalVideoLlamada__jsx('div', {
        className: 'row col-12',
        style: { padding: '0' }
      }, void 0, UploadsOkModalVideoLlamada__jsx('i', {
        className: 'fa fa-picture-o col-2',
        'aria-hidden': 'true',
        style: {
          fontSize: '34px',
          textAlign: 'center'
        }
      }), UploadsOkModalVideoLlamada__jsx('div', {
        className: 'col-10',
        style: { fontSize: '20px', lineHeight: '20px' }
      }, void 0, 'Tus archivos se han enviado correctamente.')));
    }
  }], [{
    key: 'closeUploadsOk',
    value: function closeUploadsOk() {
      $('#modalVideoLlamadaUploadsOk').hide(200);
      $('#modalVideoLlamadaUploads').show(200);
    }
  }]);

  return UploadsOkModalVideoLlamada;
}(UploadsOkModalVideoLlamada___WEBPACK_IMPORTED_MODULE_0_react___default.a.Component);
/*
const mapStateToProps = state => ({
  fileuploadStatus: state.telemedicina.fileuploadStatus,
});
*/


/* harmony default export */ var UploadsOkModalVideoLlamada_defaultExport = (UploadsOkModalVideoLlamada___WEBPACK_IMPORTED_MODULE_1_isomorphic_style_loader_lib_withStyles___default()(__WEBPACK_IMPORTED_MODULE_2__UploadsOkModalVideoLlamada_css___default.a)(UploadsOkModalVideoLlamada));
// CONCATENATED MODULE: ./src/components/Telemedicina/ModalConsultaSinFinalizar/ModalConsultaSinFinalizar.js
/* harmony import */ var ModalConsultaSinFinalizar___WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(71);
/* harmony import */ var ModalConsultaSinFinalizar___WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(ModalConsultaSinFinalizar___WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var ModalConsultaSinFinalizar___WEBPACK_IMPORTED_MODULE_1_react_redux__ = __webpack_require__(415);
/* harmony import */ var ModalConsultaSinFinalizar___WEBPACK_IMPORTED_MODULE_2_isomorphic_style_loader_lib_withStyles__ = __webpack_require__(887);
/* harmony import */ var ModalConsultaSinFinalizar___WEBPACK_IMPORTED_MODULE_2_isomorphic_style_loader_lib_withStyles___default = __webpack_require__.n(ModalConsultaSinFinalizar___WEBPACK_IMPORTED_MODULE_2_isomorphic_style_loader_lib_withStyles__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__ModalConsultaSinFinalizar_css__ = __webpack_require__(1193);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__ModalConsultaSinFinalizar_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__ModalConsultaSinFinalizar_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__actions_telemedicinaActions__ = __webpack_require__(416);
var ModalConsultaSinFinalizar__jsx = function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; }();

var ModalConsultaSinFinalizar__createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function ModalConsultaSinFinalizar__classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function ModalConsultaSinFinalizar__possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function ModalConsultaSinFinalizar__inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

/* global $ */
/* eslint react/no-did-mount-set-state: 0 */
/* eslint react/prop-types: 0 */
/* eslint consistent-return: 0 */
/* eslint-disable */







var ModalConsultaSinFinalizar__ref = ModalConsultaSinFinalizar__jsx('div', {
  className: 'modal-header'
}, void 0, ModalConsultaSinFinalizar__jsx('h5', {
  className: 'modal-title'
}, void 0, '\xBFSalir de E-Consulta?'), ModalConsultaSinFinalizar__jsx('button', {
  type: 'button',
  className: 'close',
  'data-dismiss': 'modal',
  'aria-label': 'Close'
}, void 0, ModalConsultaSinFinalizar__jsx('span', {
  'aria-hidden': 'true'
}, void 0, '\xD7')));

var ModalConsultaSinFinalizar__ref2 = ModalConsultaSinFinalizar__jsx('div', {}, void 0, 'A\xFAn no finalizaste la E-Consulta.');

var ModalConsultaSinFinalizar__ref3 = ModalConsultaSinFinalizar__jsx('div', {
  className: 'font-weight-bold'
}, void 0, '\xBFQuer\xE9s salir sin terminarla?');

var ModalConsultaSinFinalizar = function (_React$Component) {
  ModalConsultaSinFinalizar__inherits(ModalConsultaSinFinalizar, _React$Component);

  function ModalConsultaSinFinalizar(props) {
    ModalConsultaSinFinalizar__classCallCheck(this, ModalConsultaSinFinalizar);

    var _this = ModalConsultaSinFinalizar__possibleConstructorReturn(this, (ModalConsultaSinFinalizar.__proto__ || Object.getPrototypeOf(ModalConsultaSinFinalizar)).call(this, props));

    _this.hideModalVideoLlamada = _this.hideModalVideoLlamada.bind(_this);
    return _this;
  }

  ModalConsultaSinFinalizar__createClass(ModalConsultaSinFinalizar, [{
    key: 'hideModalVideoLlamada',
    value: function hideModalVideoLlamada() {
      if (this.props.llamadaIniciada) {
        document.getElementById('localView').srcObject.getTracks().forEach(function (track) {
          return track.stop();
        });
        $('localView').srcObject = null;
      }

      $('#estudiosIcon').popover('hide');
      $('#modalVideoLlamada').fadeOut(200);

      /* const hoy = new Date();
      hoy.setDate(hoy.getDate());
      let dd = hoy.getDate();
      let mm = hoy.getMonth() + 1;
      const yyyy = hoy.getFullYear();
       if (dd < 10) {
        dd = `0${dd}`;
      }
       if (mm < 10) {
        mm = `0${mm}`;
      }
      const fecha = yyyy + mm + dd;
       const datos = JSON.parse(localStorage.getItem(LOCALSTORAGE_AUTH_KEY));
      const datosInteSelected = JSON.parse(localStorage.getItem('inteSelected'));
      const token = datos.token;
      const contra = datos.modelEspecifico.contra;
      const inte = datosInteSelected.inte;
      const prepaga = datosInteSelected.prepaga;
       const dataCalif = {
        token,
        prepaga,
        contra,
        inte,
        fecha,
      };
       fetch(`${generateAbsoluteUrl()}/api/telemedicinaConsumos`, {
        method: 'POST',
        body: JSON.stringify(dataCalif),
        headers: new Headers({
          'Content-Type': 'application/json',
        }),
      })
        .then(res => res.json())
        .then(response => {
          if (response.length > 0) {
            this.props.guardarTransaccionConsumo(response[0].transaccion);
            $('#modalCalificacion').modal();
          } else {
            $('#modalFinalizado').modal({ backdrop: 'static', keyboard: false });
          }
        }); */
      // this.props.cleanLlamada();
      // this.props.disconnect();
      $('#modalFinalizado').modal({ backdrop: 'static', keyboard: false });
    }
  }, {
    key: 'render',
    value: function render() {
      var _this2 = this;

      return ModalConsultaSinFinalizar__jsx('div', {
        className: 'modal fade',
        id: 'modalConsultaSinFinalizar'
      }, void 0, ModalConsultaSinFinalizar__jsx('div', {
        className: 'modal-dialog'
      }, void 0, ModalConsultaSinFinalizar__jsx('div', {
        className: __WEBPACK_IMPORTED_MODULE_3__ModalConsultaSinFinalizar_css___default.a.modalContent + ' modal-content'
      }, void 0, ModalConsultaSinFinalizar__ref, ModalConsultaSinFinalizar__jsx('div', {
        className: __WEBPACK_IMPORTED_MODULE_3__ModalConsultaSinFinalizar_css___default.a.modalBody + ' modal-body'
      }, void 0, ModalConsultaSinFinalizar__ref2, ModalConsultaSinFinalizar__ref3), ModalConsultaSinFinalizar__jsx('div', {
        className: __WEBPACK_IMPORTED_MODULE_3__ModalConsultaSinFinalizar_css___default.a.modalFooter + ' modal-footer'
      }, void 0, ModalConsultaSinFinalizar__jsx('button', {
        'data-dismiss': 'modal',
        className: __WEBPACK_IMPORTED_MODULE_3__ModalConsultaSinFinalizar_css___default.a.boton_blanco + ' btn btn-default'
      }, void 0, 'Continuar'), ModalConsultaSinFinalizar__jsx('button', {
        'data-dismiss': 'modal',
        className: __WEBPACK_IMPORTED_MODULE_3__ModalConsultaSinFinalizar_css___default.a.boton_rojo + ' btn btn-danger',
        onClick: function onClick() {
          // this.props.disconnect();
          _this2.hideModalVideoLlamada();
        }
      }, void 0, 'Si, Salir')))));
    }
  }]);

  return ModalConsultaSinFinalizar;
}(ModalConsultaSinFinalizar___WEBPACK_IMPORTED_MODULE_0_react___default.a.Component);

/* harmony default export */ var ModalConsultaSinFinalizar_defaultExport = (Object(ModalConsultaSinFinalizar___WEBPACK_IMPORTED_MODULE_1_react_redux__["b" /* connect */])(null, __WEBPACK_IMPORTED_MODULE_4__actions_telemedicinaActions__)(ModalConsultaSinFinalizar___WEBPACK_IMPORTED_MODULE_2_isomorphic_style_loader_lib_withStyles___default()(__WEBPACK_IMPORTED_MODULE_3__ModalConsultaSinFinalizar_css___default.a)(ModalConsultaSinFinalizar)));
// CONCATENATED MODULE: ./src/components/Telemedicina/ModalVideoLlamada/HideModalVideoLlamada/HideModalVideoLlamada.js
/* harmony import */ var HideModalVideoLlamada___WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(71);
/* harmony import */ var HideModalVideoLlamada___WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(HideModalVideoLlamada___WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var HideModalVideoLlamada___WEBPACK_IMPORTED_MODULE_1_react_redux__ = __webpack_require__(415);
/* harmony import */ var HideModalVideoLlamada___WEBPACK_IMPORTED_MODULE_2_isomorphic_style_loader_lib_withStyles__ = __webpack_require__(887);
/* harmony import */ var HideModalVideoLlamada___WEBPACK_IMPORTED_MODULE_2_isomorphic_style_loader_lib_withStyles___default = __webpack_require__.n(HideModalVideoLlamada___WEBPACK_IMPORTED_MODULE_2_isomorphic_style_loader_lib_withStyles__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__HideModalVideoLlamada_css__ = __webpack_require__(1191);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__HideModalVideoLlamada_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__HideModalVideoLlamada_css__);
/* harmony import */ var HideModalVideoLlamada___WEBPACK_IMPORTED_MODULE_4__actions_telemedicinaActions__ = __webpack_require__(416);
var HideModalVideoLlamada__jsx = function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; }();

var HideModalVideoLlamada__createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function HideModalVideoLlamada__classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function HideModalVideoLlamada__possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function HideModalVideoLlamada__inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

/* global $ */
/* eslint react/prop-types: 0 */








var HideModalVideoLlamada_HideModalVideoLlamada = function (_React$Component) {
  HideModalVideoLlamada__inherits(HideModalVideoLlamada, _React$Component);

  function HideModalVideoLlamada(props) {
    HideModalVideoLlamada__classCallCheck(this, HideModalVideoLlamada);

    var _this = HideModalVideoLlamada__possibleConstructorReturn(this, (HideModalVideoLlamada.__proto__ || Object.getPrototypeOf(HideModalVideoLlamada)).call(this, props));

    _this.hideModalVideoLlamada = _this.hideModalVideoLlamada.bind(_this);
    return _this;
  }

  HideModalVideoLlamada__createClass(HideModalVideoLlamada, [{
    key: 'hideModalVideoLlamada',
    value: function hideModalVideoLlamada() {
      $('#modalConsultaSinFinalizar').modal('show');
      if (this.props.llamadaIniciada) {
        $('#estudiosIcon').popover('hide');
      } else {
        $('#modalVideoLlamada').fadeOut(200);
        $('#videoSwiss').each(function () {
          $(this)[0].pause();
        });
        // $('#modalFinalizado').modal({ backdrop: 'static', keyboard: false });
      }
    }
  }, {
    key: 'render',
    value: function render() {
      var _this2 = this;

      return HideModalVideoLlamada__jsx('div', {}, void 0, HideModalVideoLlamada__jsx('span', {
        id: 'modalVideoLlamadaHide',
        className: __WEBPACK_IMPORTED_MODULE_3__HideModalVideoLlamada_css___default.a.modalVideoLlamadaHide,
        onClick: function onClick() {
          _this2.hideModalVideoLlamada();
        },
        role: 'button',
        tabIndex: '-1'
      }, void 0, 'X'), HideModalVideoLlamada__jsx(ModalConsultaSinFinalizar_defaultExport, {
        disconnect: this.props.disconnect
      }));
    }
  }]);

  return HideModalVideoLlamada;
}(HideModalVideoLlamada___WEBPACK_IMPORTED_MODULE_0_react___default.a.Component);

/* harmony default export */ var HideModalVideoLlamada_defaultExport = (Object(HideModalVideoLlamada___WEBPACK_IMPORTED_MODULE_1_react_redux__["b" /* connect */])(null, HideModalVideoLlamada___WEBPACK_IMPORTED_MODULE_4__actions_telemedicinaActions__)(HideModalVideoLlamada___WEBPACK_IMPORTED_MODULE_2_isomorphic_style_loader_lib_withStyles___default()(__WEBPACK_IMPORTED_MODULE_3__HideModalVideoLlamada_css___default.a)(HideModalVideoLlamada_HideModalVideoLlamada)));
// CONCATENATED MODULE: ./src/components/Telemedicina/ModalVideoLlamada/ModalVideoLlamada.js
/* harmony import */ var ModalVideoLlamada___WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(71);
/* harmony import */ var ModalVideoLlamada___WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(ModalVideoLlamada___WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var ModalVideoLlamada___WEBPACK_IMPORTED_MODULE_1_react_redux__ = __webpack_require__(415);
/* harmony import */ var ModalVideoLlamada___WEBPACK_IMPORTED_MODULE_2_isomorphic_style_loader_lib_withStyles__ = __webpack_require__(887);
/* harmony import */ var ModalVideoLlamada___WEBPACK_IMPORTED_MODULE_2_isomorphic_style_loader_lib_withStyles___default = __webpack_require__.n(ModalVideoLlamada___WEBPACK_IMPORTED_MODULE_2_isomorphic_style_loader_lib_withStyles__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__ModalVideoLlamada_css__ = __webpack_require__(1147);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__ModalVideoLlamada_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__ModalVideoLlamada_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__utils_generateAbsoluteUrl__ = __webpack_require__(127);
/* harmony import */ var ModalVideoLlamada___WEBPACK_IMPORTED_MODULE_5__actions_telemedicinaActions__ = __webpack_require__(416);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__FooterModalVideoLlamada_FooterModalVideoLlamada__ = __webpack_require__(1156);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__constants_index__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__public_images_360831_tec_studios_fantasy_sfx_002_wav__ = __webpack_require__(1195);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__public_images_360831_tec_studios_fantasy_sfx_002_wav___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_12__public_images_360831_tec_studios_fantasy_sfx_002_wav__);
var ModalVideoLlamada__jsx = function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; }();

var ModalVideoLlamada__createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function ModalVideoLlamada__classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function ModalVideoLlamada__possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function ModalVideoLlamada__inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

/* eslint-disable */














//import MonitoringUtil from '../../../utils/monitoringUtil.js';

var ModalVideoLlamada__ref = ModalVideoLlamada__jsx('audio', {
  id: 'audioSwiss'
}, void 0, ModalVideoLlamada__jsx('source', {
  src: __WEBPACK_IMPORTED_MODULE_12__public_images_360831_tec_studios_fantasy_sfx_002_wav___default.a,
  type: 'audio/wav'
}));

var ModalVideoLlamada__ref2 = ModalVideoLlamada__jsx(UploadsOkModalVideoLlamada_defaultExport, {});

var ModalVideoLlamada__ref3 = ModalVideoLlamada__jsx('video', {
  loop: 'loop',
  width: '100%',
  height: '75%',
  autoPlay: 'autoplay',
  id: 'videoSwiss'
}, void 0);

var ModalVideoLlamada_ModalVideoLlamada = function (_React$Component) {
  ModalVideoLlamada__inherits(ModalVideoLlamada, _React$Component);

  function ModalVideoLlamada(props) {
    ModalVideoLlamada__classCallCheck(this, ModalVideoLlamada);

    var _this = ModalVideoLlamada__possibleConstructorReturn(this, (ModalVideoLlamada.__proto__ || Object.getPrototypeOf(ModalVideoLlamada)).call(this, props));

    _this.isWellTest = function (turno) {
      return turno.titular.prestador === "359" || turno.titular.prestador === "525" || turno.titular.prestador === "36360" || turno.titular.prestador === "349";
    };

    _this.grtcClient = null;
    _this.grtcSession = null;
    _this.localID = '';
    _this.remoteID = '';
    _this.remoteStatusMsg = '';
    _this.remoteViewFactor = 1;
    _this.newSessionOnNewOffer = false;

    //Monitoring log
    //this.monitoringUtil = new MonitoringUtil();    

    _this.state = {
      fullScreenClass: '',
      timeOut: '',
      loading: false,
      files: [],
      detalle: '',
      token: ''
    };

    _this.hideModalVideoLlamada = _this.hideModalVideoLlamada.bind(_this);
    _this.handleLeavePage = _this.handleLeavePage.bind(_this);
    _this.hideFooter = _this.hideFooter.bind(_this);
    _this.maximizeModalVideoLlamada = _this.maximizeModalVideoLlamada.bind(_this);
    _this.exitHandler = _this.exitHandler.bind(_this);
    _this.toggleMaximize = _this.toggleMaximize.bind(_this);
    _this.restoreModalVideoLlamada = _this.restoreModalVideoLlamada.bind(_this);
    _this.getPhoto = _this.getPhoto.bind(_this);
    _this.cancelUpload = _this.cancelUpload.bind(_this);
    _this.retryUpload = _this.retryUpload.bind(_this);
    _this.disconnect = _this.disconnect.bind(_this);
    _this.isWellTest = _this.isWellTest.bind(_this);

    _this.stopInterval = false;
    return _this;
  }

  ModalVideoLlamada__createClass(ModalVideoLlamada, [{
    key: 'crearCliente',
    value: function crearCliente(clientId, alertaSonora, dataToken) {
      var _this2 = this;

      if (this.grtcClient) {
        console.log("INICIO CREAR CLIENTE");
        this.grtcClient.setLogLevel(4);
        this.newSessionOnNewOffer = Grtc.getWebrtcDetectedBrowser() === 'firefox';
        this.grtcClient.setRenewSessionOnNeed(false);
        this.grtcClient.setMediaConstraintsForOffer(true, true);
        this.grtcClient.setMediaConstraintsForAnswer(true, true);
        this.grtcClient.setVideoBandwidth(500);

        this.grtcClient.filterIceCandidates = function (Candidates) {
          var outCandidates = [];
          var count = Candidates.length;
          for (var i = 0; i < count; i++) {
            var strCandidate = JSON.stringify(Candidates[i]);
            if (strCandidate.match(/ 192\.168\.\d{1,3}\.\d{1,3} \d+ typ host/i) === null && strCandidate.match(/ tcp \d+/i) === null) {
              outCandidates.push(Candidates[i]);
            }
          }
          return outCandidates;
        };

        this.grtcSession = new Grtc.MediaSession(this.grtcClient);
        this.grtcSession.onRemoteStream.add(this.updateRemoteStatus);
        this.grtcSession.onRemoteStream.add(this.attachRemoteStream);

        this.grtcSession.onSessionHold.add(function (isTrue) {
          if (isTrue) {
            console.log('Call on-hold');
            $('#remoteStatus').text(_this2.remoteStatusMsg + ' - on-hold');
          }
        });

        this.grtcClient.onIncomingCall.add(function (data) {
          _this2.grtcSession = new Grtc.MediaSession(_this2.grtcClient);
          _this2.grtcSession.onRemoteStream.add(function (data2) {
            _this2.grtcClient.setViewFromStream(document.getElementById('remoteView'), data2.stream);
          });
          _this2.remoteID = data.peer;

          var user_said = window.confirm('Desea recibir la llamada de ' + data.peer + '?');
          if (user_said === true) {
            $('#remoteStatus').empty();
            $('#remoteStatus').append('call from ' + _this2.remoteID);
            _this2.grtcSession.acceptCall(true, true, _this2.remoteID);
          } else {
            _this2.grtcSession.rejectCall();
            _this2.grtcSession = null;
          }
          return false;
        });

        this.grtcClient.onCallEvent.add(function (data) {
          console.log('Call event: ' + data.event);

          if (data.event === 'answer sent') {
            _this2.stopInterval = true;

            //Monitoring log
            //this.monitoringUtil.createAffilliateLog({ interaction:"GRTC - onCallEvent", message:"El usuario INICIA video llamada." });  

            $('#hideModal').show();
            $('#videoSwiss').each(function () {
              $(this)[0].pause();
            });

            if (alertaSonora) {
              setTimeout(function () {
                $('#audioSwiss').trigger('play');
              }, 500);
            }
            $('#divVideoSwiss').hide();
            $('#divRemote').show();
          }
          return false;
        });

        this.grtcClient.onNotifyEvent.add(function (data) {
          console.log('onNotifyEvent');
          if (_this2.remoteID === '') {
            _this2.remoteID = data.peer;
            _this2.remoteStatusMsg = 'Call from ' + _this2.remoteID;
          }
          $('#remoteStatus').empty();
          if (data.event === 'talk') {
            $('#remoteStatus').append(_this2.remoteStatusMsg + ' - established');
          } else if (data.event === 'hold') {
            $('#remoteStatus').append(_this2.remoteStatusMsg + ' - on-hold');
          }
          return false;
        });

        // Invoked when info data arrives from the peer.
        this.grtcClient.onInfoFromPeer.add(function (data) {
          console.log('onInfoFromPeer');
          alert('Got data from peer:\n' + JSON.stringify(data));
          return false;
        });

        this.grtcClient.onIceDisconnected.add(function () {
          console.log('onIceDisconnected');
          if (_this2.grtcSession) {
            _this2.grtcSession.makeOffer();
          }
          return false;
        });

        this.grtcClient.onConnectionError.add(function () {
          console.log('onConnectionError');
          return false;
        });

        this.grtcClient.onGatewayError.add(function () {
          console.log('onGatewayError');
        });

        // Invoked on WebRTC browser API error, which could be recoverable.
        // The app may want to ignore this error, log it, and/or inform the user.
        this.grtcClient.onWebrtcError.add(function (obj) {
          console.log('onConnectionError');
          alert('Got WebRTC error: ' + JSON.stringify(obj));
          return false;
        });

        // When the peer closes, this event is fired; do the necessary clean-up here.
        this.grtcClient.onPeerClosing.add(function () {
          console.log('onPeerClosing');
          _this2.stopInterval = true;
          console.log('disconnect from onPeerClosing');
          _this2.disconnect();
          _this2.cleanupAfterCall();

          //Monitoring log
          //this.monitoringUtil.createAffilliateLog({ interaction:"GRTC - onPeerClosing", message:"El usuario se fue de la video llamada." });  

          $('#modalFinalizado').modal({ backdrop: 'static', keyboard: false });
          return false;
        });

        // Fired on no-answer timeout after making an initial or updated offer to peer.
        this.grtcClient.onPeerNoanswer.add(function () {
          console.log('onPeerNoanswer');
          if (_this2.grtcSession) {
            _this2.grtcSession.closeSession(true);
          }
          //Monitoring log
          //this.monitoringUtil.createAffilliateLog({ interaction:"GRTC - onPeerNoAnswer", message:"El usuario no fue atendido en la llamada." });  

          _this2.cleanupAfterCall();
          return false;
        });

        /* Carga de medios exitosa */
        this.grtcClient.onMediaSuccess.add(function (obj) {
          console.log('onMediaSuccess');
          if (document.getElementById('localView')) {
            document.getElementById('localView').style.opacity = 1;
            _this2.grtcClient.setViewFromStream(document.getElementById('localView'), obj.stream);

            /* Apertura de stream remoto */
            _this2.grtcSession.onRemoteStream.add(function (obj) {
              console.log('onRemoteStream');
              _this2.grtcClient.setViewFromStream(document.getElementById('remoteView'), obj.stream);
            });
          }
          return false;
        });

        /* Falla carga de medios */
        this.grtcClient.onMediaFailure.add(function (obj) {
          console.log('onMediaFailure');
          // $('#modalUserMediaError').modal('show');
          _this2.props.setHasMediaError(true);
          return false;
        });

        /* Callback cuando hay conexion */
        this.grtcClient.onConnect.add(function () {
          console.log('handleOnConnect');
          $('#localStatus').empty();
          $('#localStatus').append('Registered anonymously');
          return false;
        });

        /* Callback register */
        this.grtcClient.onRegister.add(function () {
          console.log('handleOnRegister');
          $('#localStatus').empty();
          $('#localStatus').append('Registered as ' + _this2.localID);

          console.log('Hacer llamada');

          _this2.hacerLlamada(_this2.state.token, _this2.props.direccion);

          //Monitoring log
          //this.monitoringUtil.createAffilliateLog({ interaction:"GRTC - onRegister", message:"El usuario realizo la registracion en GRTC de manera exitosa." });  

          return false;
        });

        /* Callback falla */
        this.grtcClient.onFailed.add(function (obj) {
          console.log('handleOnConnectFailed');
          alert(obj.message);
          _this2.localID = '';

          return false;
        });

        this.habilitarMedios(clientId, dataToken);
      }
    }
  }, {
    key: 'habilitarMedios',
    value: function habilitarMedios(clientId, dataToken) {
      console.log("INICIO HABILITAR MEDIOS");
      if (!this.grtcClient) {
        alert('Grtc.Client instance not created');
      } else {
        this.grtcClient.enableMediaSource(true, { mandatory: { minAspectRatio: 1.777, maxAspectRatio: 1.777 } });
      }

      this.register(clientId, dataToken);
    }
  }, {
    key: 'register',
    value: function register(clientId, dataToken) {
      var _this3 = this;

      console.log("INICIO REGISTER");
      var registerID = clientId;

      var datos = JSON.parse(localStorage.getItem(__WEBPACK_IMPORTED_MODULE_11__constants_index__["_30" /* LOCALSTORAGE_AUTH_KEY */]));
      var contra = datos.modelEspecifico.contra;
      var inte = datos.modelEspecifico.inte;

      this.grtcClient.register(registerID, { dnPaciente: clientId, data: dataToken });
      this.grtcSession = new Grtc.MediaSession(this.grtcClient);
      this.grtcSession.onRemoteStream.add(function (data2) {
        _this3.grtcClient.setViewFromStream(document.getElementById('remoteView'), data2.stream);
      });
    }
  }, {
    key: 'hacerLlamada',
    value: function hacerLlamada(token, direccion) {
      console.log("INICIO HACER LLAMADA");
      var enviroment = Object(__WEBPACK_IMPORTED_MODULE_4__utils_generateAbsoluteUrl__["a" /* default */])();
      //QA = php02
      //INT = php01
      this.remoteID = this.props.turno.tipo == 'E' ? 6097 : this.isWellTest(this.props.turno) ? 6099 : 6098;
      if (enviroment.includes("localhost") || enviroment.includes("pre") || enviroment.includes("clubswiss")) {
        if (this.props.turno.tipo == 'E') {
          this.remoteID = 609701;
        } else if (this.isWellTest(this.props.turno)) {
          this.remoteID = 6095;
        } else {
          this.remoteID = 609801;
        }
      } else if (enviroment.includes("int") || enviroment.includes("srv-php01")) {
        this.remoteID = this.props.turno.tipo == 'E' ? 609702 : 609802;
      } else if (enviroment.includes("srv-php02") || enviroment.includes("qa")) {
        this.remoteID = this.props.turno.tipo == 'E' ? 609703 : 609803;
      }

      $('#remoteStatus').empty();
      this.remoteStatusMsg = 'Call to ' + this.remoteID;
      $('#remoteStatus').append(this.remoteStatusMsg);

      var datos = JSON.parse(localStorage.getItem(__WEBPACK_IMPORTED_MODULE_11__constants_index__["_30" /* LOCALSTORAGE_AUTH_KEY */]));
      var datosInteSelected = JSON.parse(localStorage.getItem('inteSelected'));
      var contra = datos.modelEspecifico.contra;
      var inte = datosInteSelected.inte;

      var json = {
        contra: contra,
        inte: inte,
        domicilio: direccion
      };

      var dataToAttach = [{
        key: 'plain',
        value: json
      }, {
        key: 'encrypted',
        value: token.encrypted
      }];

      this.grtcSession.setData(dataToAttach);
      this.grtcSession.makeOffer(this.remoteID, true, true);
      this.grtcSession.onstablestate();
      console.log("FIN HACER LLAMADA");
    }
  }, {
    key: 'disconnect',
    value: function disconnect() {
      this.grtcClient.disconnect();
    }
  }, {
    key: 'updateRemoteStatus',
    value: function updateRemoteStatus() {
      if (useTalkEvent === false) {
        $('#remoteStatus').empty();
        if (this.remoteID !== '') {
          // A BYE could close session before we get here.
          $('#remoteStatus').append(this.remoteStatusMsg + ' - established');
        }
      }
      return true;
    }
  }, {
    key: 'attachRemoteStream',
    value: function attachRemoteStream(data) {
      var element = document.getElementById('remoteView');
      if (element.getAttribute('src') === null) {
        console.log('Attaching remote stream');
      } else {
        console.log('Reattaching remote stream');
      }
      this.grtcClient.setViewFromStream(element, data.stream);
      return false;
    }
  }, {
    key: 'cleanupAfterCall',
    value: function cleanupAfterCall() {
      this.savedStats = null;
      $('#remoteStatus').empty();
      this.remoteID = '';
      this.remoteStatusMsg = '';
    }
  }, {
    key: 'hideModalVideoLlamada',
    value: function hideModalVideoLlamada() {
      this.restoreModalVideoLlamada();
      $('#modalConsultaSinFinalizar').modal('show');
    }
  }, {
    key: 'componentDidMount',
    value: function componentDidMount() {
      var _this4 = this;

      if (this.props.IniciarLlamada == 0) {
        //renovar token cada 10 minutos
        setInterval(function () {
          //let datos = JSON.parse(localStorage.getItem(LOCALSTORAGE_AUTH_KEY));
          var token = JSON.parse(localStorage.getItem("token"));
          var dataToken = {
            token: token
          };
          $.ajax({
            url: Object(__WEBPACK_IMPORTED_MODULE_4__utils_generateAbsoluteUrl__["a" /* default */])() + '/renew-token',
            global: false,
            type: 'POST',
            headers: {
              'Content-Type': 'application/json'
            },
            data: JSON.stringify(dataToken),
            async: true,
            success: function success(response) {
              if (response.data && response.data.token && response.data.exp) {
                var authData = localStorage.getItem(__WEBPACK_IMPORTED_MODULE_11__constants_index__["_30" /* LOCALSTORAGE_AUTH_KEY */]);
                var authJson = JSON.parse(authData);
                authJson.token = response.data.token;
                authJson.exp = response.data.exp;
                if (authJson) {
                  localStorage.removeItem(__WEBPACK_IMPORTED_MODULE_11__constants_index__["_30" /* LOCALSTORAGE_AUTH_KEY */]);
                  localStorage.removeItem('token');
                  localStorage.setItem('token', JSON.stringify(authJson.token));
                  localStorage.setItem(__WEBPACK_IMPORTED_MODULE_11__constants_index__["_30" /* LOCALSTORAGE_AUTH_KEY */], JSON.stringify(authJson));
                }
              }
            }
          });
        }, 1000 * 60 * 15);
        // fin renovar token cada 5 minutos
      }
      this.grtcClient = null;
      this.grtcSession = null;
      this.localID = '';
      this.remoteID = '';
      this.remoteStatusMsg = '';
      this.remoteViewFactor = 1;
      this.newSessionOnNewOffer = false;
      var configuration = {
        webrtc_gateway: 'https://wrtc-arg.crossnet.la:443',
        turn_server: 'stun-arg.crossnet.la:443?transport=tcp',
        turn_username: 'genesys',
        turn_password: 'genesys',
        noanswer_timeout: 7200000
      };
      this.grtcClient = new Grtc.Client(configuration);
      window.addEventListener('beforeunload', this.handleLeavePage);
      document.addEventListener('fullscreenchange', this.exitHandler);
      document.addEventListener('webkitfullscreenchange', this.exitHandler);
      document.addEventListener('mozfullscreenchange', this.exitHandler);
      document.addEventListener('MSFullscreenChange', this.exitHandler);

      $('#modalVideoLlamada').fadeIn(200);

      $('#iframe_llamada').mousemove(function () {
        if ($('#modalVideoLlamada').hasClass(__WEBPACK_IMPORTED_MODULE_3__ModalVideoLlamada_css___default.a.full)) {
          if (!$('#modalVideoLlamadaFooter.' + __WEBPACK_IMPORTED_MODULE_3__ModalVideoLlamada_css___default.a.full).is(':visible')) {
            $('#modalVideoLlamadaFooter.' + __WEBPACK_IMPORTED_MODULE_3__ModalVideoLlamada_css___default.a.full + ', #modalVideoLlamadaheader.' + __WEBPACK_IMPORTED_MODULE_3__ModalVideoLlamada_css___default.a.full).slideToggle(100);
          }
          clearTimeout(_this4.state.timeOut);
          _this4.hideFooter();
        }
      });

      $('#modalVideoLlamadaFooter').mouseenter(function () {
        clearTimeout(_this4.state.timeOut);
      });
    }
  }, {
    key: 'componentWillReceiveProps',
    value: function componentWillReceiveProps(props) {
      var _this5 = this;

      if (props.IniciarLlamada == 1) {
        var datos = JSON.parse(localStorage.getItem(__WEBPACK_IMPORTED_MODULE_11__constants_index__["_30" /* LOCALSTORAGE_AUTH_KEY */]));
        var datosInteSelected = JSON.parse(localStorage.getItem('inteSelected'));
        var token = datos.token;
        var inte = datosInteSelected.inte;

        var objInte = this.props.integrante.filter(function (element) {
          return element.inte == inte;
        });

        var dataToken = {
          token: token,
          json: this.generarJsonTurno(this.props.turno, objInte[0])
        };
        fetch(Object(__WEBPACK_IMPORTED_MODULE_4__utils_generateAbsoluteUrl__["a" /* default */])() + '/api/generarTokenLlamada', {
          method: 'POST',
          body: JSON.stringify(dataToken),
          headers: new Headers({
            'Content-Type': 'application/json'
          })
        }).then(function (res) {
          return res.json();
        }).then(function (response) {
          var contra = datos.modelEspecifico.contra;
          var inte = datos.modelEspecifico.inte;

          //Monitoring log
          //this.monitoringUtil.createAffilliateLog({ interaction:"GRTC - GENERACION TOKEN", message:"Se genera el token de la video llamada." });  

          _this5.setState({ token: response });
          _this5.crearCliente(_this5.props.clientId, _this5.props.alerta_sonora, dataToken);
        });
      }
    }
  }, {
    key: 'componentWillUnmount',
    value: function componentWillUnmount() {
      this.props.cleanTurnoTomado();
      this.props.cleanAdmision();
      this.props.cleanDomicilio();
      console.log('disconnect from willUnMount');
      this.grtcClient.disconnect();
      this.grtcClient = null;
      this.grtcSession = null;
      this.localID = '';
      this.remoteID = '';
      this.remoteStatusMsg = '';
      this.remoteViewFactor = 1;
      this.newSessionOnNewOffer = false;
      window.removeEventListener('beforeunload', this.handleLeavePage);
    }
  }, {
    key: 'generarJsonTurno',
    value: function generarJsonTurno(turno, afiliado) {
      var objAfiliado = {
        afiliado: { afiliado: afiliado }
      };

      var objTurno = {
        turno: { turno: turno }
      };
      var turnoCompleto = $.extend(objTurno.turno, objAfiliado.afiliado);
      return turnoCompleto;
    }
  }, {
    key: 'getPhoto',
    value: function getPhoto(e) {
      var _this6 = this;

      e.preventDefault();
      this.setState({
        loading: true
      });
      $('#modalVideoLlamadaUploads').show(200);
      $('#estudiosIcon').popover('hide');

      var file = e.target.files[0];
      var progress = 0;

      if (file) {
        var extension = file.name.split('.').pop().toLowerCase();
        var fileTypes = ['jpg', 'jpeg', 'png', 'pdf'];
        var fileTypeSuccess = fileTypes.indexOf(extension) > -1;
        var fileSizeSuccess = file.size < 10485760;

        if (fileTypeSuccess && fileSizeSuccess) {
          var reader = new FileReader();
          reader.onprogress = function (data) {
            if (data.lengthComputable) {
              $('#modalVideoLlamadaUploadsOk').hide(200);
              progress = parseInt(data.loaded / data.total * 100, 10);

              if (progress < 100) {
                $('#modalVideoLlamadaUploads').show(200);
                _this6.setState({
                  loading: true
                });
              }

              var fileAdded = {
                file: file,
                progress: progress,
                reader: reader,
                motivo: ''
              };

              var filesAddedState = _this6.state.files;
              filesAddedState[fileAdded.file.name] = fileAdded;

              _this6.setState({
                files: filesAddedState
              });
            }
          };

          reader.onloadend = function () {
            var filesAddedState = _this6.state.files;
            var fileInState = filesAddedState[file.name];

            if (fileInState.progress == 100 && fileInState.progress !== 'Cancelado') {

              var fileAdded = {
                file: file,
                progress: 'cargando',
                motivo: '',
                reader: null
              };
              var _filesAddedState = _this6.state.files;
              _filesAddedState[fileAdded.file.name] = fileAdded;
              _this6.setState({ files: _filesAddedState, loading: true });

              var medico = _this6.props.turno.prestador;
              var content = reader.result;

              content = content.replace('data:image/png;base64,', '');
              content = content.replace('data:application/pdf;base64,', '');
              content = content.replace('data:image/jpg;base64,', '');
              content = content.replace('data:image/jpeg;base64,', '');

              var datos = JSON.parse(localStorage.getItem(__WEBPACK_IMPORTED_MODULE_11__constants_index__["_30" /* LOCALSTORAGE_AUTH_KEY */]));
              var token = datos.token;

              var dataUpload = {
                token: token,
                paciente: datos.modelEspecifico.apellido + ' ' + datos.modelEspecifico.nombre,
                filename: file.name,
                content: content,
                medico: medico
              };
              // this.props.uploadFilesTelemedicina(file.name, content, medico);
              fetch(Object(__WEBPACK_IMPORTED_MODULE_4__utils_generateAbsoluteUrl__["a" /* default */])() + '/api/fileUploadModalVideollamada', {
                method: 'POST',
                body: JSON.stringify(dataUpload),
                headers: new Headers({
                  'Content-Type': 'application/json'
                })
              }).then(function (res) {
                return res.json();
              }).then(function (response) {
                if (response.directory) {
                  var _fileAdded = {
                    file: file,
                    progress: 'ok',
                    motivo: '',
                    reader: null
                  };
                  var _filesAddedState2 = _this6.state.files;
                  _filesAddedState2[_fileAdded.file.name] = _fileAdded;
                  _this6.setState({ files: _filesAddedState2, loading: true });
                  $('#modalVideoLlamadaUploads').hide(200);
                  $('#modalVideoLlamadaUploadsOk').show(200);
                  setTimeout(function () {
                    $('#boton_cerrar').click();
                  }, 2000);
                } else {
                  var _fileAdded2 = {
                    file: file,
                    progress: 'Cancelado',
                    motivo: 'Error al subir',
                    reader: null
                  };
                  var _filesAddedState3 = _this6.state.files;
                  _filesAddedState3[_fileAdded2.file.name] = _fileAdded2;
                  _this6.setState({ files: _filesAddedState3, loading: true });
                  $('#modalVideoLlamadaUploadsOk').hide(200);
                }
              });
            }
          };

          if (file) {
            reader.readAsDataURL(file);
          }
        } else if (!fileTypeSuccess) {
          // error de extension
          var fileAdded = {
            file: file,
            progress: 'Cancelado',
            motivo: 'Extensión no válida',
            reader: null
          };

          var filesAddedState = this.state.files;
          filesAddedState[fileAdded.file.name] = fileAdded;
          this.setState({ files: filesAddedState, loading: true });
          $('#modalVideoLlamadaUploadsOk').hide(200);
        } else {
          // error de tamanio
          var _fileAdded3 = {
            file: file,
            progress: 'Cancelado',
            motivo: 'Peso excedido',
            reader: null
          };

          var _filesAddedState4 = this.state.files;
          _filesAddedState4[_fileAdded3.file.name] = _fileAdded3;
          this.setState({ files: _filesAddedState4, loading: true });
          $('#modalVideoLlamadaUploadsOk').hide(200);
        }
      } else {
        this.setState({ loading: true });
        $('#modalVideoLlamadaUploadsOk, #modalVideoLlamadaUploads').hide(200);
      }
    }
  }, {
    key: 'maximizeModalVideoLlamada',
    value: function maximizeModalVideoLlamada() {
      $('#medico_nombre').show();
      $('#divInputVolume').hide();
      $('#divEstudios').hide();

      if ($("#divVideoSwiss").is(":visible")) {

        var elem = document.getElementById('videoSwiss');
        if (elem.requestFullscreen) {
          elem.requestFullscreen();
        } else if (elem.mozRequestFullScreen) {
          elem.mozRequestFullScreen();
        } else if (elem.webkitRequestFullscreen) {
          elem.webkitRequestFullscreen();
        }
        $('#modalVideoLlamadaheader').show(); // , #modalVideoLlamadaEnd
        // this.hideFooter();
      } else {
        //$('#localView').hide();
        //$("#elemento").is(":visible");
        $('#modalVideoLlamada').css({
          width: '100%',
          height: '100%',
          left: '0',
          top: '0',
          padding: '0',
          border: '0'
        });

        $('#divLlamada').css({
          padding: '0'
        });

        this.setState({
          fullScreenClass: __WEBPACK_IMPORTED_MODULE_3__ModalVideoLlamada_css___default.a.full
        });

        $('#texto_modal_videollamada').hide();
        $('#iframe_llamada').width('100%');
        $('#iframe_llamada').removeClass('col-8');
        $('#iframe_llamada').addClass('col-12');
        $('#divRemoteVideo').removeClass('col-10');
        $('#divRemoteVideo').addClass('col-12');

        // Cambiar color de iconos
        $('#modalMaximize').hide();
        $('#modalRestore').show();

        $('#VolumeIcon').hide();
        $('#VolumeIconWhite').show();

        $('#modalClip').hide();
        $('#modalClipWhite').show();

        $('#estudiosIcon').hide();
        $('#estudiosIconWhite').show();
        var _elem = document.getElementById('modalVideoLlamada');
        if (_elem.requestFullscreen) {
          _elem.requestFullscreen();
        } else if (_elem.mozRequestFullScreen) {
          _elem.mozRequestFullScreen();
        } else if (_elem.webkitRequestFullscreen) {
          _elem.webkitRequestFullscreen();
        }
        $('#modalVideoLlamadaheader').show(); // , #modalVideoLlamadaEnd
        //this.hideFooter();
      }
    }
  }, {
    key: 'restoreModalVideoLlamada',
    value: function restoreModalVideoLlamada() {
      $('#medico_nombre').hide();
      $('#divInputVolume').hide();
      $('#divEstudios').hide();

      // Cambiar color de iconos
      $('#modalRestore').hide();
      $('#modalMaximize').show();

      $('#VolumeIconWhite').hide();
      $('#VolumeIcon').show();

      $('#modalClipWhite').hide();
      $('#modalClip').show();

      $('#estudiosIconWhite').hide();
      $('#estudiosIcon').show();

      // Si esta en full screen la saca
      if (document.exitFullscreen) {
        document.exitFullscreen();
      } else if (document.mozCancelFullScreen) {
        document.mozCancelFullScreen();
      } else if (document.webkitExitFullscreen) {
        document.webkitExitFullscreen();
      } else if (document.msExitFullscreen) {
        document.msExitFullscreen();
      }

      if ($("#divVideoSwiss").is(":visible")) {
        $('#hideModal').hide();
      } else {
        $('#divLlamada').css({
          padding: '10px'
        });

        this.setState({
          fullScreenClass: ''
        });

        $('#modalVideoLlamada').css(_defineProperty({
          width: '98%',
          height: '80%',
          left: '20px',
          top: '70px',
          padding: '0',
          border: '0'
        }, 'padding', '10px 10px 68px'));
      }

      $('#modalVideoLlamadaheader').hide(); // , ##modalVideoLlamadaEnd
    }
  }, {
    key: 'toggleMaximize',
    value: function toggleMaximize() {
      $('#divInputVolume').hide();
      $('#divEstudios').hide();
      if ($("#divVideoSwiss").is(":visible")) {
        $('#hideModal').hide();
      }
      if (!document.fullscreenElement && // alternative standard method
      !document.mozFullScreenElement && !document.webkitFullscreenElement && !document.msFullscreenElement) {
        this.maximizeModalVideoLlamada();
      } else {
        this.restoreModalVideoLlamada();
      }
    }
  }, {
    key: 'exitHandler',
    value: function exitHandler() {
      $('#divInputVolume').hide();
      $('#divEstudios').hide();
      if ($("#divVideoSwiss").is(":visible")) {
        $('#hideModal').hide();
      }

      if (!document.fullscreenElement && !document.webkitIsFullScreen && !document.mozFullScreen && !document.msFullscreenElement) {
        $('#modalVideoLlamada').css({
          width: '98%',
          height: '80%',
          top: '60px',
          //right: '60px',
          padding: '10px 10px 68px 10px',
          border: '1px solid #ccc'
        });

        $('#divLlamada').css({
          padding: '10px'
        });

        // Cambiar color de iconos
        $('#modalRestore').hide();
        $('#modalMaximize').show();

        $('#VolumeIconWhite').hide();
        $('#VolumeIcon').show();

        $('#modalClipWhite').hide();
        $('#modalClip').show();

        $('#estudiosIconWhite').hide();
        $('#estudiosIcon').show();

        /* $('#texto_modal_videollamada').show();
         $('#iframe_llamada').width('60%');
          $('#modalRestore').hide();
         $('#modalMaximize').show();*/

        this.setState({
          fullScreenClass: ''
        });
        $('#modalVideoLlamadaFooter').show();
        $('#modalVideoLlamadaheader').hide(); // , #modalVideoLlamadaEnd
      }
    }
  }, {
    key: 'hideFooter',
    value: function hideFooter() {
      this.setState({
        timeOut: setTimeout(function () {
          $('#modalVideoLlamadaFooter.' + __WEBPACK_IMPORTED_MODULE_3__ModalVideoLlamada_css___default.a.full + ', #modalVideoLlamadaheader.' + __WEBPACK_IMPORTED_MODULE_3__ModalVideoLlamada_css___default.a.full // #modalVideoLlamadaEnd.${s.full}
          ).fadeOut(1000, function () {
            if (!$('#modalVideoLlamadaFooter').hasClass(__WEBPACK_IMPORTED_MODULE_3__ModalVideoLlamada_css___default.a.full)) {
              $('#modalVideoLlamadaFooter').show();
            }
          });
        }, 2000)
      });
    }
  }, {
    key: 'handleLeavePage',
    value: function handleLeavePage(e) {
      var confirmationMessage = 'Aún no finalizaste la E-Consulta ¿Querés salir sin terminarla?';
      e.returnValue = confirmationMessage; // Gecko, Trident, Chrome 34+
      return confirmationMessage; // Gecko, WebKit, Chrome <34
    }
  }, {
    key: 'cancelUpload',
    value: function cancelUpload(key) {
      var filesAddedState = this.state.files;
      var stateFile = filesAddedState[key];
      stateFile.reader.abort();
      stateFile.progress = 'Cancelado';
      stateFile.motivo = 'Cancelado';
      filesAddedState[key] = stateFile;
      this.setState({ files: filesAddedState, loading: true });
    }
  }, {
    key: 'retryUpload',
    value: function retryUpload(key) {
      var filesAddedState = this.state.files;
      var stateFile = filesAddedState[key];

      if (stateFile.file) {
        stateFile.reader.readAsDataURL(stateFile.file);
      }

      filesAddedState[key] = stateFile;
      this.setState({ files: filesAddedState, loading: true });
    }
  }, {
    key: 'render',
    value: function render() {
      if (this.props.espontaneo) {
        this.props.turno.tipo = 'E';
      }

      var filesUploaded = this.state.files;
      return ModalVideoLlamada__jsx('div', {
        className: __WEBPACK_IMPORTED_MODULE_3__ModalVideoLlamada_css___default.a.root
      }, void 0, ModalVideoLlamada__jsx('div', {
        id: 'divRemote'
      }, void 0, ModalVideoLlamada__jsx('div', {
        id: 'modalVideoLlamada',
        style: { display: 'none' },
        className: __WEBPACK_IMPORTED_MODULE_3__ModalVideoLlamada_css___default.a.modalVideoLLamada + ' \n        ' + this.state.fullScreenClass + ' divRemote'
      }, void 0, ModalVideoLlamada__jsx('div', {
        id: 'divLlamada',
        className: 'row',
        style: { height: '100%', padding: '10px' }
      }, void 0, ModalVideoLlamada__jsx('div', {
        style: { border: '5px solid', padding: '0', backgroundColor: '#000', height: 'inherit' },
        id: 'divRemoteVideo',
        className: 'col-12',
        onDoubleClick: this.toggleMaximize
      }, void 0, ModalVideoLlamada__jsx('div', {
        id: 'medico_nombre',
        style: { display: 'none', marginTop: '45px', position: 'absolute' }
      }, void 0, ModalVideoLlamada__jsx('span', {
        style: { fontSize: '30px', marginLeft: '20px', color: '#fff' }
      }, void 0, ModalVideoLlamada__jsx('strong', {}, void 0, 'M\xE9dico: ', this.props.turno.titular.apeRazon + ' ' + this.props.turno.titular.nombreAbre))), ModalVideoLlamada__ref, ModalVideoLlamada__jsx('video', {
        'data-caption': '1080 OGG',
        width: '100%',
        height: '90%',
        id: 'remoteView',
        className: '' + __WEBPACK_IMPORTED_MODULE_3__ModalVideoLlamada_css___default.a.modalRemoteView,
        autoPlay: 'autoplay'
      }, void 0), ModalVideoLlamada__jsx('video', {
        className: '' + __WEBPACK_IMPORTED_MODULE_3__ModalVideoLlamada_css___default.a.modalLocalView,
        style: { width: '15%', position: 'absolute', right: '0', bottom: '0' },
        id: 'localView',
        autoPlay: 'autoplay',
        volume: '0.5',
        muted: 'muted'
      }))), ModalVideoLlamada__jsx('div', {
        className: __WEBPACK_IMPORTED_MODULE_3__ModalVideoLlamada_css___default.a.modalVideoLlamadaheader + ' \n          ' + this.state.fullScreenClass,
        id: 'modalVideoLlamadaheader'
      }, void 0), ModalVideoLlamada__jsx('div', {
        className: __WEBPACK_IMPORTED_MODULE_3__ModalVideoLlamada_css___default.a.modalVideoLlamadaEnd + ' \n          ' + this.state.fullScreenClass,
        id: 'modalVideoLlamadaEnd'
      }, void 0, ModalVideoLlamada__jsx('i', {
        className: 'fa fa-phone',
        'aria-hidden': 'true',
        onClick: this.hideModalVideoLlamada,
        role: 'button',
        tabIndex: '-1'
      })), ModalVideoLlamada__jsx('div', {
        className: __WEBPACK_IMPORTED_MODULE_3__ModalVideoLlamada_css___default.a.modalVideoLlamadaFooter + ' \n          ' + this.state.fullScreenClass,
        id: 'modalVideoLlamadaFooter'
      }, void 0, ModalVideoLlamada__jsx(__WEBPACK_IMPORTED_MODULE_7__FooterModalVideoLlamada_FooterModalVideoLlamada__["a" /* default */], {
        maximizeModalVideoLlamada: this.maximizeModalVideoLlamada,
        restoreModalVideoLlamada: this.restoreModalVideoLlamada,
        getPhoto: this.getPhoto,
        llamadaIniciada: true
      })), ModalVideoLlamada__jsx(UploadsModalVideoLlamada_defaultExport, {
        filesUploaded: filesUploaded,
        cancelUpload: this.cancelUpload,
        retryUpload: this.retryUpload
      }), ModalVideoLlamada__ref2, ModalVideoLlamada__jsx('div', {
        id: 'hideModal'
      }, void 0, ModalVideoLlamada__jsx(HideModalVideoLlamada_defaultExport, {
        llamadaIniciada: true,
        disconnect: this.disconnect
      })))), ModalVideoLlamada__jsx('div', {
        id: 'divVideoSwiss'
      }, void 0, ModalVideoLlamada__jsx('div', {
        id: 'modalVideoLlamada',
        className: __WEBPACK_IMPORTED_MODULE_3__ModalVideoLlamada_css___default.a.modalVideoLLamada + ' \n    ' + this.state.fullScreenClass + ' divVideoSwiss'
      }, void 0, ModalVideoLlamada__jsx('div', {
        className: 'row',
        style: { height: '100%' }
      }, void 0, ModalVideoLlamada__jsx('div', {
        className: 'col-7',
        id: 'iframe_llamada',
        onDoubleClick: this.toggleMaximize
      }, void 0, ModalVideoLlamada__ref3, ModalVideoLlamada__jsx('video', {
        style: { width: '15%', position: 'absolute', right: '0', bottom: '0', display: 'none', paddingBottom: '3%' },
        id: 'localView',
        autoPlay: 'autoplay',
        volume: '0.5',
        muted: 'muted'
      })), ModalVideoLlamada__jsx('div', {
        className: 'col-5 d-flex align-items-center',
        style: { paddingBottom: '72px' }
      }, void 0, ModalVideoLlamada__jsx('div', {
        id: 'texto_modal_videollamada',
        className: 'col-12 row'
      }, void 0, ModalVideoLlamada__jsx(TimerModalVideoLlamada_defaultExport, {
        turno: this.props.turno,
        stopInterval: this.stopInterval
      }))), ModalVideoLlamada__jsx('div', {
        className: __WEBPACK_IMPORTED_MODULE_3__ModalVideoLlamada_css___default.a.modalVideoLlamadaFooter + ' \n          ' + this.state.fullScreenClass,
        id: 'modalVideoLlamadaFooter'
      }, void 0, ModalVideoLlamada__jsx(__WEBPACK_IMPORTED_MODULE_7__FooterModalVideoLlamada_FooterModalVideoLlamada__["a" /* default */], {
        maximizeModalVideoLlamada: this.maximizeModalVideoLlamada,
        restoreModalVideoLlamada: this.restoreModalVideoLlamada,
        getPhoto: this.getPhoto,
        llamadaIniciada: false,
        fullScreen: this.state.fullScreenClass
      }))), ModalVideoLlamada__jsx(HideModalVideoLlamada_defaultExport, {
        llamadaIniciada: false,
        disconnect: this.disconnect
      }))));
    }
  }]);

  return ModalVideoLlamada;
}(ModalVideoLlamada___WEBPACK_IMPORTED_MODULE_0_react___default.a.Component);

var ModalVideoLlamada_mapStateToProps = function mapStateToProps(state) {
  return {
    IniciarLlamada: state.telemedicina.iniciar_llamada,
    alerta_sonora: state.telemedicina.alerta_sonora,
    clientId: state.telemedicina.clientId,
    practica: state.telemedicina.practica,
    integrante: state.integrantes
  };
};

/* harmony default export */ var ModalVideoLlamada_defaultExport = (Object(ModalVideoLlamada___WEBPACK_IMPORTED_MODULE_1_react_redux__["b" /* connect */])(ModalVideoLlamada_mapStateToProps, ModalVideoLlamada___WEBPACK_IMPORTED_MODULE_5__actions_telemedicinaActions__)(ModalVideoLlamada___WEBPACK_IMPORTED_MODULE_2_isomorphic_style_loader_lib_withStyles___default()(__WEBPACK_IMPORTED_MODULE_3__ModalVideoLlamada_css___default.a)(ModalVideoLlamada_ModalVideoLlamada)));
// CONCATENATED MODULE: ./src/components/Telemedicina/ModalTurnoElegidoYaFueSeleccionado/ModalTurnoElegidoYaFueSeleccionado.js
/* harmony import */ var ModalTurnoElegidoYaFueSeleccionado___WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(71);
/* harmony import */ var ModalTurnoElegidoYaFueSeleccionado___WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(ModalTurnoElegidoYaFueSeleccionado___WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var ModalTurnoElegidoYaFueSeleccionado___WEBPACK_IMPORTED_MODULE_1_react_redux__ = __webpack_require__(415);
/* harmony import */ var ModalTurnoElegidoYaFueSeleccionado___WEBPACK_IMPORTED_MODULE_2_isomorphic_style_loader_lib_withStyles__ = __webpack_require__(887);
/* harmony import */ var ModalTurnoElegidoYaFueSeleccionado___WEBPACK_IMPORTED_MODULE_2_isomorphic_style_loader_lib_withStyles___default = __webpack_require__.n(ModalTurnoElegidoYaFueSeleccionado___WEBPACK_IMPORTED_MODULE_2_isomorphic_style_loader_lib_withStyles__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__ModalTurnoElegidoYaFueSeleccionado_css__ = __webpack_require__(1203);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__ModalTurnoElegidoYaFueSeleccionado_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__ModalTurnoElegidoYaFueSeleccionado_css__);
/* harmony import */ var ModalTurnoElegidoYaFueSeleccionado___WEBPACK_IMPORTED_MODULE_4__actions_telemedicinaActions__ = __webpack_require__(416);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_Telemedicina_ModalConfirmacionTurno_ModalConfirmacionTurno__ = __webpack_require__(1140);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_Telemedicina_ModalConfirmacionTurnoResp_ModalConfirmacionTurnoResp__ = __webpack_require__(1141);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__constants_index__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__components_Telemedicina_images_medico_png__ = __webpack_require__(1226);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__components_Telemedicina_images_medico_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8__components_Telemedicina_images_medico_png__);
var ModalTurnoElegidoYaFueSeleccionado__jsx = function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; }();

var ModalTurnoElegidoYaFueSeleccionado__createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function ModalTurnoElegidoYaFueSeleccionado__classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function ModalTurnoElegidoYaFueSeleccionado__possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function ModalTurnoElegidoYaFueSeleccionado__inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

/* eslint react/no-did-mount-set-state: 0 */
/* eslint react/prop-types: 0 */
/* eslint consistent-return: 0 */
/* global $ */










var ModalTurnoElegidoYaFueSeleccionado__ref = ModalTurnoElegidoYaFueSeleccionado__jsx('div', {});

var ModalTurnoElegidoYaFueSeleccionado__ref2 = ModalTurnoElegidoYaFueSeleccionado__jsx(__WEBPACK_IMPORTED_MODULE_6__components_Telemedicina_ModalConfirmacionTurnoResp_ModalConfirmacionTurnoResp__["a" /* default */], {});

var ModalTurnoElegidoYaFueSeleccionado__ref3 = ModalTurnoElegidoYaFueSeleccionado__jsx('div', {
  className: 'modal-header'
}, void 0, ModalTurnoElegidoYaFueSeleccionado__jsx('h5', {
  className: 'modal-title'
}, void 0, 'El turno elegido ya fue seleccionado'), ModalTurnoElegidoYaFueSeleccionado__jsx('button', {
  type: 'button',
  className: 'close',
  'data-dismiss': 'modal',
  'aria-label': 'Close'
}, void 0, ModalTurnoElegidoYaFueSeleccionado__jsx('span', {
  'aria-hidden': 'true'
}, void 0, '\xD7')));

var ModalTurnoElegidoYaFueSeleccionado__ref4 = ModalTurnoElegidoYaFueSeleccionado__jsx('div', {
  className: 'font-weight-bold'
}, void 0, 'Durante la validaci\xF3n alguien tom\xF3 tu turno.');

var ModalTurnoElegidoYaFueSeleccionado__ref5 = ModalTurnoElegidoYaFueSeleccionado__jsx('div', {}, void 0, 'El pr\xF3ximo disponible es el');

var ModalTurnoElegidoYaFueSeleccionado = function (_React$Component) {
  ModalTurnoElegidoYaFueSeleccionado__inherits(ModalTurnoElegidoYaFueSeleccionado, _React$Component);

  ModalTurnoElegidoYaFueSeleccionado__createClass(ModalTurnoElegidoYaFueSeleccionado, null, [{
    key: 'formatearFecha',
    value: function formatearFecha(fecha) {
      var year = fecha.substring(0, 4);
      var month = fecha.substring(4, 6);
      var day = fecha.substring(6, 8);

      return day + '/' + month + '/' + year;
    }
  }, {
    key: 'formatearHora',
    value: function formatearHora(hora) {
      return hora.substr(0, 2) + ':' + hora.substr(2, 4);
    }
  }, {
    key: 'getDataUser',
    value: function getDataUser() {
      var auth = localStorage.getItem(__WEBPACK_IMPORTED_MODULE_7__constants_index__["_30" /* LOCALSTORAGE_AUTH_KEY */]);
      var user = void 0;
      if (auth) {
        user = {
          email: JSON.parse(auth).modelEspecifico.email
        };
      }
      return user;
    }
  }]);

  function ModalTurnoElegidoYaFueSeleccionado(props) {
    ModalTurnoElegidoYaFueSeleccionado__classCallCheck(this, ModalTurnoElegidoYaFueSeleccionado);

    var _this = ModalTurnoElegidoYaFueSeleccionado__possibleConstructorReturn(this, (ModalTurnoElegidoYaFueSeleccionado.__proto__ || Object.getPrototypeOf(ModalTurnoElegidoYaFueSeleccionado)).call(this, props));

    _this.state = {
      email: '',
      dataTurno: '',
      nombreapellido: '',
      especialidad: ''
    };

    _this.showModal = _this.showModal.bind(_this);
    return _this;
  }

  ModalTurnoElegidoYaFueSeleccionado__createClass(ModalTurnoElegidoYaFueSeleccionado, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      $('#modalTurnoYaSeleccionado').modal('show');
    }
  }, {
    key: 'componentWillReceiveProps',
    value: function componentWillReceiveProps(props) {
      if (this.props.confirmacionTurno !== props.confirmacionTurno) {
        var email = $('#email').val();
        $('#mail').html(email);
        $('#modalConfirmTurnoResp').modal('show');
      }
    }
  }, {
    key: 'showModal',
    value: function showModal(data) {
      $('#modalTurnoYaSeleccionado').modal('hide');
      this.setState({
        dataTurno: data,
        nombre: data.titular.nombreAbre,
        apellido: data.titular.apeRazon,
        especialidad: data.idEspecialidad
      });
      $('#modalConfirmTurno').modal('show');
    }
  }, {
    key: 'render',
    value: function render() {
      var _this2 = this;

      // console.log('TURNO PROXIMO');
      // console.log(this.props.proximoTurno);
      return ModalTurnoElegidoYaFueSeleccionado__jsx('div', {}, void 0, ModalTurnoElegidoYaFueSeleccionado__jsx('div', {}, void 0, ModalTurnoElegidoYaFueSeleccionado__jsx(__WEBPACK_IMPORTED_MODULE_5__components_Telemedicina_ModalConfirmacionTurno_ModalConfirmacionTurno__["a" /* default */], {
        image: __WEBPACK_IMPORTED_MODULE_8__components_Telemedicina_images_medico_png___default.a,
        nombre: this.state.nombre,
        apellido: this.state.apellido,
        email: ModalTurnoElegidoYaFueSeleccionado.getDataUser().email,
        dataTurno: this.state.dataTurno
      }), ModalTurnoElegidoYaFueSeleccionado__ref, ModalTurnoElegidoYaFueSeleccionado__ref2), ModalTurnoElegidoYaFueSeleccionado__jsx('div', {
        className: 'modal fade',
        id: 'modalTurnoYaSeleccionado'
      }, void 0, ModalTurnoElegidoYaFueSeleccionado__jsx('div', {
        className: 'modal-dialog'
      }, void 0, ModalTurnoElegidoYaFueSeleccionado__jsx('div', {
        className: __WEBPACK_IMPORTED_MODULE_3__ModalTurnoElegidoYaFueSeleccionado_css___default.a.modalContent + ' modal-content'
      }, void 0, ModalTurnoElegidoYaFueSeleccionado__ref3, ModalTurnoElegidoYaFueSeleccionado__jsx('div', {
        className: __WEBPACK_IMPORTED_MODULE_3__ModalTurnoElegidoYaFueSeleccionado_css___default.a.modalBody + ' modal-body'
      }, void 0, ModalTurnoElegidoYaFueSeleccionado__ref4, ModalTurnoElegidoYaFueSeleccionado__ref5, ModalTurnoElegidoYaFueSeleccionado__jsx('div', {}, void 0, ModalTurnoElegidoYaFueSeleccionado.formatearFecha(this.props.proximoTurno.fecha) + ' a las ' + ModalTurnoElegidoYaFueSeleccionado.formatearHora(this.props.proximoTurno.hora) + ' Hs.')), ModalTurnoElegidoYaFueSeleccionado__jsx('div', {
        className: __WEBPACK_IMPORTED_MODULE_3__ModalTurnoElegidoYaFueSeleccionado_css___default.a.modalFooter + ' modal-footer'
      }, void 0, ModalTurnoElegidoYaFueSeleccionado__jsx('button', {
        'data-dismiss': 'modal',
        className: __WEBPACK_IMPORTED_MODULE_3__ModalTurnoElegidoYaFueSeleccionado_css___default.a.boton_blanco + ' btn btn-default'
      }, void 0, 'Seleccionar Otro'), ModalTurnoElegidoYaFueSeleccionado__jsx('button', {
        className: __WEBPACK_IMPORTED_MODULE_3__ModalTurnoElegidoYaFueSeleccionado_css___default.a.boton_rojo + ' btn btn-danger',
        onClick: function onClick() {
          return (
            // this.props.confirmarTurno(this.props.proximoTurno)}
            _this2.showModal(_this2.props.proximoTurno)
          );
        }
      }, void 0, 'Tomar Turno'))))));
    }
  }]);

  return ModalTurnoElegidoYaFueSeleccionado;
}(ModalTurnoElegidoYaFueSeleccionado___WEBPACK_IMPORTED_MODULE_0_react___default.a.Component);

var ModalTurnoElegidoYaFueSeleccionado_mapStateToProps = function mapStateToProps(state) {
  return {
    confirmacionTurno: state.telemedicina.confirmacion_turno
  };
};

/* harmony default export */ var ModalTurnoElegidoYaFueSeleccionado_defaultExport = (Object(ModalTurnoElegidoYaFueSeleccionado___WEBPACK_IMPORTED_MODULE_1_react_redux__["b" /* connect */])(ModalTurnoElegidoYaFueSeleccionado_mapStateToProps, ModalTurnoElegidoYaFueSeleccionado___WEBPACK_IMPORTED_MODULE_4__actions_telemedicinaActions__)(ModalTurnoElegidoYaFueSeleccionado___WEBPACK_IMPORTED_MODULE_2_isomorphic_style_loader_lib_withStyles___default()(__WEBPACK_IMPORTED_MODULE_3__ModalTurnoElegidoYaFueSeleccionado_css___default.a)(ModalTurnoElegidoYaFueSeleccionado)));
// CONCATENATED MODULE: ./src/components/Telemedicina/ModalUserMediaError/ModalUserMediaError.js
/* harmony import */ var ModalUserMediaError___WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(71);
/* harmony import */ var ModalUserMediaError___WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(ModalUserMediaError___WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var ModalUserMediaError___WEBPACK_IMPORTED_MODULE_1_react_redux__ = __webpack_require__(415);
/* harmony import */ var ModalUserMediaError___WEBPACK_IMPORTED_MODULE_2_isomorphic_style_loader_lib_withStyles__ = __webpack_require__(887);
/* harmony import */ var ModalUserMediaError___WEBPACK_IMPORTED_MODULE_2_isomorphic_style_loader_lib_withStyles___default = __webpack_require__.n(ModalUserMediaError___WEBPACK_IMPORTED_MODULE_2_isomorphic_style_loader_lib_withStyles__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__ModalUserMediaError_css__ = __webpack_require__(1227);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__ModalUserMediaError_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__ModalUserMediaError_css__);
/* harmony import */ var ModalUserMediaError___WEBPACK_IMPORTED_MODULE_4__actions_telemedicinaActions__ = __webpack_require__(416);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__constants_index__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__utils_generateAbsoluteUrl__ = __webpack_require__(127);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__utils_redirectTo__ = __webpack_require__(419);
var ModalUserMediaError__jsx = function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; }();

var ModalUserMediaError__createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function ModalUserMediaError__classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function ModalUserMediaError__possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function ModalUserMediaError__inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

/* global $ */
/* eslint react/no-did-mount-set-state: 0 */
/* eslint react/prop-types: 0 */
/* eslint consistent-return: 0 */
/* eslint-disable */










var ModalUserMediaError__ref = ModalUserMediaError__jsx('div', {
  className: 'modal-header'
}, void 0, ModalUserMediaError__jsx('h5', {
  className: 'modal-title'
}, void 0, 'Error de Videollamada'), ModalUserMediaError__jsx('button', {
  type: 'button',
  className: 'close',
  'data-dismiss': 'modal',
  'aria-label': 'Close'
}, void 0, ModalUserMediaError__jsx('span', {
  'aria-hidden': 'true'
}, void 0, '\xD7')));

var ModalUserMediaError__ref2 = ModalUserMediaError__jsx('div', {}, void 0, 'La comunicaci\xF3n por videollamada no podr\xE1 ser realizada en este momento debido a problemas en los perif\xE9ricos de Audio y/o Video de su equipo. Verifique de cerrar programas que puedan estar consumiendo los mismos para poder establecer una comunicaci\xF3n por videollamada exitosa.');

var ModalUserMediaError = function (_Component) {
  ModalUserMediaError__inherits(ModalUserMediaError, _Component);

  function ModalUserMediaError(props) {
    ModalUserMediaError__classCallCheck(this, ModalUserMediaError);

    var _this = ModalUserMediaError__possibleConstructorReturn(this, (ModalUserMediaError.__proto__ || Object.getPrototypeOf(ModalUserMediaError)).call(this, props));

    _this.hideModalVideoLlamada = _this.hideModalVideoLlamada.bind(_this);
    _this.finalizar = _this.finalizar.bind(_this);
    return _this;
  }

  ModalUserMediaError__createClass(ModalUserMediaError, [{
    key: 'finalizar',
    value: function finalizar() {
      this.props.cleanLlamada();
      if (document.getElementById('localView') && document.getElementById('localView').srcObject) {
        document.getElementById('localView').srcObject.getTracks().forEach(function (track) {
          return track.stop();
        });
        $('localView').srcObject = null;
      }
      var datos = JSON.parse(localStorage.getItem(__WEBPACK_IMPORTED_MODULE_5__constants_index__["_30" /* LOCALSTORAGE_AUTH_KEY */]));
      var token = datos.token;
      var dataToken = {
        token: token
      };
      $.ajax({
        url: Object(__WEBPACK_IMPORTED_MODULE_6__utils_generateAbsoluteUrl__["a" /* default */])() + '/renew-token',
        global: false,
        type: 'POST',
        headers: {
          'Content-Type': 'application/json'
        },
        data: JSON.stringify(dataToken),
        async: false,
        success: function success(response) {
          if (response.data && response.data.token && response.data.exp) {
            var authData = localStorage.getItem(__WEBPACK_IMPORTED_MODULE_5__constants_index__["_30" /* LOCALSTORAGE_AUTH_KEY */]);
            var authJson = JSON.parse(authData);
            authJson.token = response.data.token;
            authJson.exp = response.data.exp;
            localStorage.setItem('token', JSON.stringify(authJson.token));
            localStorage.setItem(__WEBPACK_IMPORTED_MODULE_5__constants_index__["_30" /* LOCALSTORAGE_AUTH_KEY */], JSON.stringify(authJson));
          }
        }
      });
      this.props.hideValidacionesTecnicas();
      Object(__WEBPACK_IMPORTED_MODULE_7__utils_redirectTo__["a" /* default */])('/telemedicina');
    }
  }, {
    key: 'hideModalVideoLlamada',
    value: function hideModalVideoLlamada() {
      if (this.props.llamadaIniciada) {
        document.getElementById('localView').srcObject.getTracks().forEach(function (track) {
          return track.stop();
        });
        $('localView').srcObject = null;
      }

      $('#estudiosIcon').popover('hide');
      $('#modalVideoLlamada').fadeOut(200);
      $('#modalUserMediaError').modal('hide');
      this.finalizar();
    }
  }, {
    key: 'componentDidMount',
    value: function componentDidMount() {
      var _this2 = this;

      $('#modalUserMediaError').modal('show');
      //setTimeout(() => { $('#boton_salir_id').trigger('click') }, 3000);
      setTimeout(function () {
        _this2.hideModalVideoLlamada();
      }, 3000);
    }
  }, {
    key: 'render',
    value: function render() {
      var _this3 = this;

      return ModalUserMediaError__jsx('div', {
        className: 'modal fade',
        id: 'modalUserMediaError'
      }, void 0, ModalUserMediaError__jsx('div', {
        className: 'modal-dialog'
      }, void 0, ModalUserMediaError__jsx('div', {
        className: __WEBPACK_IMPORTED_MODULE_3__ModalUserMediaError_css___default.a.modalContent + ' modal-content'
      }, void 0, ModalUserMediaError__ref, ModalUserMediaError__jsx('div', {
        className: __WEBPACK_IMPORTED_MODULE_3__ModalUserMediaError_css___default.a.modalBody + ' modal-body'
      }, void 0, ModalUserMediaError__ref2), ModalUserMediaError__jsx('div', {
        className: __WEBPACK_IMPORTED_MODULE_3__ModalUserMediaError_css___default.a.modalFooter + ' modal-footer'
      }, void 0, ModalUserMediaError__jsx('button', {
        id: 'boton_salir_id',
        'data-dismiss': 'modal',
        className: __WEBPACK_IMPORTED_MODULE_3__ModalUserMediaError_css___default.a.boton_rojo + ' btn btn-danger',
        onClick: function onClick() {
          _this3.hideModalVideoLlamada();
        }
      }, void 0, 'Salir')))));
    }
  }]);

  return ModalUserMediaError;
}(ModalUserMediaError___WEBPACK_IMPORTED_MODULE_0_react__["Component"]);

/* harmony default export */ var ModalUserMediaError_defaultExport = (Object(ModalUserMediaError___WEBPACK_IMPORTED_MODULE_1_react_redux__["b" /* connect */])(null, ModalUserMediaError___WEBPACK_IMPORTED_MODULE_4__actions_telemedicinaActions__)(ModalUserMediaError___WEBPACK_IMPORTED_MODULE_2_isomorphic_style_loader_lib_withStyles___default()(__WEBPACK_IMPORTED_MODULE_3__ModalUserMediaError_css___default.a)(ModalUserMediaError)));
// CONCATENATED MODULE: ./src/components/FormComponents/InputPlacesAutocomplete/InputPlacesAutocomplete.js
/* harmony import */ var InputPlacesAutocomplete___WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(71);
/* harmony import */ var InputPlacesAutocomplete___WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(InputPlacesAutocomplete___WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash__ = __webpack_require__(183);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_places_autocomplete__ = __webpack_require__(1231);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_places_autocomplete___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_react_places_autocomplete__);
var InputPlacesAutocomplete__jsx = function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; }();

var InputPlacesAutocomplete__createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function InputPlacesAutocomplete__classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function InputPlacesAutocomplete__possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function InputPlacesAutocomplete__inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

/* eslint react/prop-types: 0 */
/* eslint no-console: 0 */





var InputPlacesAutocomplete = function (_React$Component) {
  InputPlacesAutocomplete__inherits(InputPlacesAutocomplete, _React$Component);

  function InputPlacesAutocomplete(props) {
    InputPlacesAutocomplete__classCallCheck(this, InputPlacesAutocomplete);

    var _this = InputPlacesAutocomplete__possibleConstructorReturn(this, (InputPlacesAutocomplete.__proto__ || Object.getPrototypeOf(InputPlacesAutocomplete)).call(this, props));

    _this.handleFormSubmit = function (event) {
      event.preventDefault();

      Object(__WEBPACK_IMPORTED_MODULE_2_react_places_autocomplete__["geocodeByAddress"])(_this.state.address).then(function (results) {
        return Object(__WEBPACK_IMPORTED_MODULE_2_react_places_autocomplete__["getLatLng"])(results[0]);
      }).then(function (latLng) {
        return console.log('Success', latLng);
      }).catch(function (error) {
        return console.error('Error', error);
      });
    };

    _this.state = { address: '', firstTime: true };
    _this.onChange = function (address) {
      return _this.setState({ address: address, firstTime: false });
    };
    return _this;
  }

  InputPlacesAutocomplete__createClass(InputPlacesAutocomplete, [{
    key: 'render',
    value: function render() {
      var inputProps = {
        id: 'direccion',
        value: __WEBPACK_IMPORTED_MODULE_1_lodash___default.a.isEmpty(this.state.address) && this.state.firstTime ? this.props.direccion : this.state.address,
        placeholder: '',
        onChange: this.onChange
      };

      var cssClasses = {
        root: 'form-group',
        input: 'form-control',
        autocompleteContainer: 'my-autocomplete-container'
      };

      return InputPlacesAutocomplete__jsx('form', {
        onSubmit: this.handleFormSubmit
      }, void 0, InputPlacesAutocomplete__jsx(__WEBPACK_IMPORTED_MODULE_2_react_places_autocomplete___default.a, {
        inputProps: inputProps,
        classNames: cssClasses
      }));
    }
  }]);

  return InputPlacesAutocomplete;
}(InputPlacesAutocomplete___WEBPACK_IMPORTED_MODULE_0_react___default.a.Component);

/* harmony default export */ var InputPlacesAutocomplete_defaultExport = (InputPlacesAutocomplete);
// CONCATENATED MODULE: ./src/components/ModalIngresoDireccionActual/ModalIngresoDireccionActual.js
/* harmony import */ var ModalIngresoDireccionActual___WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(71);
/* harmony import */ var ModalIngresoDireccionActual___WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(ModalIngresoDireccionActual___WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var ModalIngresoDireccionActual___WEBPACK_IMPORTED_MODULE_1_react_redux__ = __webpack_require__(415);
/* harmony import */ var ModalIngresoDireccionActual___WEBPACK_IMPORTED_MODULE_2_isomorphic_style_loader_lib_withStyles__ = __webpack_require__(887);
/* harmony import */ var ModalIngresoDireccionActual___WEBPACK_IMPORTED_MODULE_2_isomorphic_style_loader_lib_withStyles___default = __webpack_require__.n(ModalIngresoDireccionActual___WEBPACK_IMPORTED_MODULE_2_isomorphic_style_loader_lib_withStyles__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__ModalIngresoDireccionActual_css__ = __webpack_require__(1229);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__ModalIngresoDireccionActual_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__ModalIngresoDireccionActual_css__);
/* harmony import */ var ModalIngresoDireccionActual___WEBPACK_IMPORTED_MODULE_5__actions_telemedicinaActions__ = __webpack_require__(416);
var ModalIngresoDireccionActual__jsx = function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; }();

var ModalIngresoDireccionActual__createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function ModalIngresoDireccionActual__defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function ModalIngresoDireccionActual__classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function ModalIngresoDireccionActual__possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function ModalIngresoDireccionActual__inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

/* global $ */
/* eslint react/prop-types: 0 */
/* eslint class-methods-use-this:0 */
/* eslint css-modules/no-unused-class: 0 */
/* eslint react/no-did-mount-set-state: 0 */
/* eslint consistent-return: 0 */








var ModalIngresoDireccionActual__ref2 = ModalIngresoDireccionActual__jsx('br', {});

var ModalIngresoDireccionActual__ref3 = ModalIngresoDireccionActual__jsx('br', {});

var ModalIngresoDireccionActual__ref4 = ModalIngresoDireccionActual__jsx('br', {});

var ModalIngresoDireccionActual__ref5 = ModalIngresoDireccionActual__jsx('br', {});

var ModalIngresoDireccionActual__ref6 = ModalIngresoDireccionActual__jsx('br', {});

var ModalIngresoDireccionActual_ModalIngresoDireccionActual = function (_React$Component) {
  ModalIngresoDireccionActual__inherits(ModalIngresoDireccionActual, _React$Component);

  function ModalIngresoDireccionActual() {
    var _ref;

    var _temp, _this, _ret;

    ModalIngresoDireccionActual__classCallCheck(this, ModalIngresoDireccionActual);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = ModalIngresoDireccionActual__possibleConstructorReturn(this, (_ref = ModalIngresoDireccionActual.__proto__ || Object.getPrototypeOf(ModalIngresoDireccionActual)).call.apply(_ref, [this].concat(args))), _this), _this.state = {
      telefono1: _this.props.oldTelephone.telefono1,
      telefono2: _this.props.oldTelephone.telefono2,
      email: _this.props.oldTelephone.email
    }, _this.validateCharacter = function (evt) {
      var regex = /[0-9]/;
      if (evt.keyCode !== 8 && evt.keyCode !== 9 && !regex.test(evt.key)) {
        return evt.preventDefault();
      }
    }, _this.handleChange = function (e) {
      var _e$target = e.target,
          name = _e$target.name,
          value = _e$target.value;

      _this.setState(ModalIngresoDireccionActual__defineProperty({}, name, value));
    }, _temp), ModalIngresoDireccionActual__possibleConstructorReturn(_this, _ret);
  }

  ModalIngresoDireccionActual__createClass(ModalIngresoDireccionActual, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      $('#modalIngresoDireccionActual').modal({
        backdrop: 'static',
        keyboard: false
      });
      $('.close').hide();
    }
  }, {
    key: 'render',
    value: function render() {
      var _this2 = this;

      return ModalIngresoDireccionActual__jsx('div', {
        className: 'modal fade',
        id: 'modalIngresoDireccionActual'
      }, void 0, ModalIngresoDireccionActual__jsx('div', {
        className: 'modal-dialog'
      }, void 0, ModalIngresoDireccionActual__jsx('div', {
        className: __WEBPACK_IMPORTED_MODULE_3__ModalIngresoDireccionActual_css___default.a.modalContent + ' modal-content'
      }, void 0, ModalIngresoDireccionActual__jsx('div', {
        className: __WEBPACK_IMPORTED_MODULE_3__ModalIngresoDireccionActual_css___default.a.modalHeader + ' modal-header'
      }, void 0, ModalIngresoDireccionActual__jsx('h6', {
        className: 'modal-title',
        style: { fontWeight: '600' }
      }, void 0, 'Por favor ingres\xE1 tu direcci\xF3n actual y tel\xE9fono celular')), ModalIngresoDireccionActual__jsx('div', {
        className: __WEBPACK_IMPORTED_MODULE_3__ModalIngresoDireccionActual_css___default.a.modalBody + ' modal-body'
      }, void 0, ModalIngresoDireccionActual__jsx('div', {
        className: __WEBPACK_IMPORTED_MODULE_3__ModalIngresoDireccionActual_css___default.a.regularText + ' text-left'
      }, void 0, 'Por tu seguridad necesitamos saber en que direcci\xF3n te encontr\xE1s actualmente. Si la direcci\xF3n precargada no coincide con tu direcci\xF3n actual por favor modificala abajo. ', ModalIngresoDireccionActual__ref2, ' ', ModalIngresoDireccionActual__ref3, ModalIngresoDireccionActual__jsx('span', {
        className: '' + __WEBPACK_IMPORTED_MODULE_3__ModalIngresoDireccionActual_css___default.a.boldText
      }, void 0, 'La direcci\xF3n solo la utilizaremos si durante la consulta tu vida se encuentra en riesgo.'), ModalIngresoDireccionActual__ref4, ModalIngresoDireccionActual__jsx('span', {
        className: '' + __WEBPACK_IMPORTED_MODULE_3__ModalIngresoDireccionActual_css___default.a.boldText
      }, void 0, ModalIngresoDireccionActual__ref5, 'Direcci\xF3n actual'), ModalIngresoDireccionActual__ref6, ModalIngresoDireccionActual__jsx(InputPlacesAutocomplete_defaultExport, {
        direccion: this.props.direccion
      }), ModalIngresoDireccionActual__jsx('div', {
        className: 'd-flex justify-content-between flex-wrap'
      }, void 0, ModalIngresoDireccionActual__jsx('div', {}, void 0, ModalIngresoDireccionActual__jsx('span', {
        className: '' + __WEBPACK_IMPORTED_MODULE_3__ModalIngresoDireccionActual_css___default.a.boldText
      }, void 0, 'N\xFAmero de Celular'), ModalIngresoDireccionActual__jsx('input', {
        type: 'text',
        id: 'telefono1',
        name: 'telefono1',
        className: 'form-control',
        value: this.state.telefono1,
        onKeyDown: this.validateCharacter,
        onChange: this.handleChange
      }))), ModalIngresoDireccionActual__jsx('span', {
        className: '' + __WEBPACK_IMPORTED_MODULE_3__ModalIngresoDireccionActual_css___default.a.boldText
      }, void 0, 'Correo'), ModalIngresoDireccionActual__jsx('input', {
        type: 'text',
        id: 'email',
        name: 'email',
        className: 'form-control',
        defaultValue: this.state.email,
        onChange: this.handleChange
      }), this.props.validateSubmit ? ModalIngresoDireccionActual__jsx('div', {
        className: '' + __WEBPACK_IMPORTED_MODULE_3__ModalIngresoDireccionActual_css___default.a.text_danger
      }, void 0, ' ', this.props.validateSubmit, ' ') : null)), ModalIngresoDireccionActual__jsx('div', {
        className: __WEBPACK_IMPORTED_MODULE_3__ModalIngresoDireccionActual_css___default.a.modalFooter + ' modal-footer'
      }, void 0, ModalIngresoDireccionActual__jsx('button', {
        onClick: function onClick() {
          return _this2.props.cleanDomicilio();
        },
        'data-dismiss': 'modal',
        className: __WEBPACK_IMPORTED_MODULE_3__ModalIngresoDireccionActual_css___default.a.boton_blanco + ' ' + __WEBPACK_IMPORTED_MODULE_3__ModalIngresoDireccionActual_css___default.a.robotoMedium + ' btn btn-default float-left'
      }, void 0, 'Cancelar'), ModalIngresoDireccionActual__jsx('button', {
        className: __WEBPACK_IMPORTED_MODULE_3__ModalIngresoDireccionActual_css___default.a.boton_rojo + ' btn btn-default text-center',
        onClick: function onClick() {
          return _this2.props.continuar($('#direccion').val(), $('#telefono1').val(), $('#telefono2').val(), $('#email').val());
        }
      }, void 0, 'Iniciar Consulta')))));
    }
  }]);

  return ModalIngresoDireccionActual;
}(ModalIngresoDireccionActual___WEBPACK_IMPORTED_MODULE_0_react___default.a.Component);

var ModalIngresoDireccionActual_mapStateToProps = function mapStateToProps(state) {
  return {
    get_telefonos: state.telemedicina.get_telefonos,
    validateSubmit: state.telemedicina.validateSubmit
    // linkDoc: state.telemedicina.linkDoc
  };
};

/* harmony default export */ var ModalIngresoDireccionActual_defaultExport = (Object(ModalIngresoDireccionActual___WEBPACK_IMPORTED_MODULE_1_react_redux__["b" /* connect */])(ModalIngresoDireccionActual_mapStateToProps, ModalIngresoDireccionActual___WEBPACK_IMPORTED_MODULE_5__actions_telemedicinaActions__)(ModalIngresoDireccionActual___WEBPACK_IMPORTED_MODULE_2_isomorphic_style_loader_lib_withStyles___default()(__WEBPACK_IMPORTED_MODULE_3__ModalIngresoDireccionActual_css___default.a)(ModalIngresoDireccionActual_ModalIngresoDireccionActual)));
// CONCATENATED MODULE: ./src/components/Telemedicina/ValidacionesTecnicas/ValidacionesTecnicas.js
/* harmony import */ var ValidacionesTecnicas___WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(71);
/* harmony import */ var ValidacionesTecnicas___WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(ValidacionesTecnicas___WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var ValidacionesTecnicas___WEBPACK_IMPORTED_MODULE_1_react_redux__ = __webpack_require__(415);
/* harmony import */ var ValidacionesTecnicas___WEBPACK_IMPORTED_MODULE_2_isomorphic_style_loader_lib_withStyles__ = __webpack_require__(887);
/* harmony import */ var ValidacionesTecnicas___WEBPACK_IMPORTED_MODULE_2_isomorphic_style_loader_lib_withStyles___default = __webpack_require__.n(ValidacionesTecnicas___WEBPACK_IMPORTED_MODULE_2_isomorphic_style_loader_lib_withStyles__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_lodash__ = __webpack_require__(183);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__ValidacionesTecnicas_css__ = __webpack_require__(1145);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__ValidacionesTecnicas_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__ValidacionesTecnicas_css__);
/* harmony import */ var ValidacionesTecnicas___WEBPACK_IMPORTED_MODULE_5__actions_telemedicinaActions__ = __webpack_require__(416);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__public_images_ic_desktop_png__ = __webpack_require__(1196);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__public_images_ic_desktop_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7__public_images_ic_desktop_png__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__public_images_ic_microphone_png__ = __webpack_require__(1197);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__public_images_ic_microphone_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8__public_images_ic_microphone_png__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__public_images_ic_padlock_png__ = __webpack_require__(1198);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__public_images_ic_padlock_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9__public_images_ic_padlock_png__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__public_images_ic_video_png__ = __webpack_require__(1199);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__public_images_ic_video_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10__public_images_ic_video_png__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__public_images_validacion_green_png__ = __webpack_require__(1200);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__public_images_validacion_green_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11__public_images_validacion_green_png__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__public_images_Validacion_red_png__ = __webpack_require__(1201);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__public_images_Validacion_red_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_12__public_images_Validacion_red_png__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__public_images_broken_cable_png__ = __webpack_require__(1202);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__public_images_broken_cable_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_13__public_images_broken_cable_png__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18__constants_index__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19__utils_redirectTo__ = __webpack_require__(419);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20__utils_generateAbsoluteUrl__ = __webpack_require__(127);
var ValidacionesTecnicas__createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var ValidacionesTecnicas__jsx = function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; }();

function ValidacionesTecnicas__classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function ValidacionesTecnicas__possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function ValidacionesTecnicas__inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

/* eslint react/no-did-mount-set-state: 0 */
/* eslint react/prop-types: 0 */
/* eslint consistent-return: 0 */
/* eslint-disable */



















/* import ModalCalificacion from '../../../components/Telemedicina/ModalCalificacion/ModalCalificacion'; */



//import {checkCrossnet} from '../../../utils/requests'

//import MonitoringUtil from '../../../utils/monitoringUtil.js';

var ComponentValidation = function ComponentValidation(props) {
  return ValidacionesTecnicas__jsx('div', {
    className: __WEBPACK_IMPORTED_MODULE_4__ValidacionesTecnicas_css___default.a.validacion_row + ' col-md-11 row'
  }, void 0, ValidacionesTecnicas__jsx('div', {
    className: 'col-md-1',
    style: { height: '44px', textAlign: 'center' }
  }, void 0, ValidacionesTecnicas__jsx('img', {
    alt: 'icon',
    src: props.icon
  }), ValidacionesTecnicas__jsx('img', {
    className: '' + __WEBPACK_IMPORTED_MODULE_4__ValidacionesTecnicas_css___default.a.crossIcon,
    alt: 'icon',
    src: props.checkIcon
  })), ValidacionesTecnicas__jsx('div', {
    className: props.msgClass
  }, void 0, props.msg));
};

var PeriphericCheckComponent = function PeriphericCheckComponent(props) {
  return ValidacionesTecnicas__jsx('div', {}, void 0, props.validation ? ValidacionesTecnicas__jsx(ComponentValidation, {
    icon: props.icon,
    checkIcon: __WEBPACK_IMPORTED_MODULE_11__public_images_validacion_green_png___default.a,
    msg: props.msgSuccess,
    msgClass: props.msgClass
  }) : ValidacionesTecnicas__jsx(ComponentValidation, {
    icon: props.icon,
    checkIcon: __WEBPACK_IMPORTED_MODULE_12__public_images_Validacion_red_png___default.a,
    msg: props.msgError,
    msgClass: props.msgClass
  }));
};

var ValidacionesTecnicas__ref = ValidacionesTecnicas__jsx(ModalUserMediaError_defaultExport, {});

var ValidacionesTecnicas__ref2 = ValidacionesTecnicas__jsx(ModalConsultaSinFinalizar_defaultExport, {});

var ValidacionesTecnicas__ref3 = ValidacionesTecnicas__jsx('img', {
  alt: 'icon',
  src: __WEBPACK_IMPORTED_MODULE_7__public_images_ic_desktop_png___default.a
});

var ValidacionesTecnicas__ref4 = ValidacionesTecnicas__jsx('strong', {}, void 0, 'Tu consulta se iniciar\xE1 una vez que chequeemos que tu c\xE1mara y', ValidacionesTecnicas__jsx('br', {}), 'micr\xF3fono funcionan correctamente.');

var ValidacionesTecnicas__ref5 = ValidacionesTecnicas__jsx('i', {
  className: 'glyphicon glyphicon-chevron-left'
});

var ValidacionesTecnicas__ref6 = ValidacionesTecnicas__jsx('div', {
  className: 'col-md-10'
});

var ValidacionesTecnicas_ValidacionesTecnicas = function (_React$Component) {
  ValidacionesTecnicas__inherits(ValidacionesTecnicas, _React$Component);

  function ValidacionesTecnicas(props) {
    ValidacionesTecnicas__classCallCheck(this, ValidacionesTecnicas);

    var _this = ValidacionesTecnicas__possibleConstructorReturn(this, (ValidacionesTecnicas.__proto__ || Object.getPrototypeOf(ValidacionesTecnicas)).call(this, props));

    _this.setHasMediaError = function () {
      _this.setState({ hasMediaError: true });
    };

    _this.state = {
      validationVideo: false,
      validationMicro: false,
      iniciarLlamada: false,
      turnoOcupado: false,
      validationCrossnet: false,
      turno: null,
      direccion: '',
      hasMediaError: false,
      urlLink: null,
      velidateTel: false,
      credential: null
    };
    _this.validateVideo = _this.validateVideo.bind(_this);
    _this.validateMicro = _this.validateMicro.bind(_this);
    _this.changeStateVideo = _this.changeStateVideo.bind(_this);
    _this.changeStateMicro = _this.changeStateMicro.bind(_this);
    _this.onButtonContinuarClick = _this.onButtonContinuarClick.bind(_this);
    _this.volverAConsultaTurnos = _this.volverAConsultaTurnos.bind(_this);
    _this.setHasMediaError = _this.setHasMediaError.bind(_this);
    //this.openInNewTab = this.openInNewTab.bind(this);

    return _this;
  }

  ValidacionesTecnicas__createClass(ValidacionesTecnicas, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      var _this2 = this;

      this.validateMicro();
      this.validateVideo();
      this.props.fetchEmail();
      //checkCrossnet(this);
      if (this.props.origen === 'espontaneo') {
        this.props.fetchPrepaga();
      }

      if (this.props.origen === 'consulta') {
        this.setState({ turno: this.props.validaciones_tecnicas.data });
      }

      if (this.props.origen === 'mail') {
        var datos = JSON.parse(localStorage.getItem(__WEBPACK_IMPORTED_MODULE_18__constants_index__["_30" /* LOCALSTORAGE_AUTH_KEY */]));
        var token = datos.token;
        this.props.fetchDomicilioAfiliado();
        var url = new URL(window.location.href);
        var turnoEncrypted = url.searchParams.get('token');

        var json = {
          token: token,
          data: turnoEncrypted
        };

        fetch(Object(__WEBPACK_IMPORTED_MODULE_20__utils_generateAbsoluteUrl__["a" /* default */])() + '/api/desencriptarToken', {
          method: 'POST',
          body: JSON.stringify(json),
          headers: new Headers({
            'Content-Type': 'application/json'
          })
        }).then(function (res) {
          return res.json();
        }).then(function (response) {
          _this2.setState({ turno: response.idTurno });
          _this2.obtenerDetalleTurno(_this2.state.turno);
        });
      }
    }
  }, {
    key: 'componentWillReceiveProps',
    value: function componentWillReceiveProps(nextProps) {
      if (!__WEBPACK_IMPORTED_MODULE_3_lodash___default.a.isEmpty(nextProps.tomarTurnoSuccess)) {
        if (__WEBPACK_IMPORTED_MODULE_3_lodash___default.a.isEmpty(nextProps.tomarTurnoSuccess.error)) {
          this.setState({
            turno: nextProps.tomarTurnoSuccess.turno,
            //iniciarLlamada: true,
            iniciarLlamada: false
          });
        } else {
          this.setState({
            turnoOcupado: true
          });
        }
      }
    }
  }, {
    key: 'componentWillUnmount',
    value: function componentWillUnmount() {
      this.state = {
        validationVideo: false,
        validationMicro: false,
        iniciarLlamada: false,
        turnoOcupado: false,
        validationCrossnet: false,
        turno: null,
        direccion: ''
      };
      this.props.espontaneoEnd();
    }
  }, {
    key: 'openInNewTab',
    value: function openInNewTab(url) {
      var win = window.open(url, '_blank');
      this.volverAConsultaTurnos();
      win.focus();
    }
  }, {
    key: 'validateEmail',
    value: function validateEmail(email) {
      var re = /^(([^<>()[\]\\.,;:\s@\"]+(\.[^<>()[\]\\.,;:\s@\"]+)*)|(\".+\"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
      return re.test(email);
    }
  }, {
    key: 'onButtonContinuarClick',
    value: function onButtonContinuarClick(direccion, telefono, telefono2, email) {
      var _this3 = this;

      this.setState({
        velidateTel: false
      });
      //Validation mail
      var prueba = this.validateEmail(email);
      this.props.validateEmail(prueba);
      this.props.credentialUser().then(function (data) {
        _this3.setState({
          credential: _this3.props.numberCredentialUser
        });
      }).catch(function (err) {
        console.error(err);
      });
      var oldTelephone = this.props.get_telefonos;
      var especialidad = this.props.id_especialidad;
      var motivo = this.props.id_motivo;
      //const urlLink= this.props.linkDoc && this.props.linkDoc.data.url_email;
      //const email = this.props.email
      var datos = JSON.parse(localStorage.getItem(__WEBPACK_IMPORTED_MODULE_18__constants_index__["_30" /* LOCALSTORAGE_AUTH_KEY */]));

      var token = datos.token;
      var dataToken = {
        token: token
      };
      setTimeout(function () {
        if (telefono2 === '' || telefono === '') {
          _this3.setState({
            velidateTel: true
          });
          _this3.props.validateSubmitSuccess('El numero de telefono es obligatorio');
          return false;
        }
        if (telefono === telefono2) {
          _this3.setState({
            velidateTel: true
          });
          _this3.props.validateSubmitSuccess('Deben ser diferentes numeros de telefono');
          return false;
        }
        if (!_this3.props.valEmail) {
          _this3.props.validateSubmitSuccess('El mail debe ser valido');
          return false;
        }

        if (telefono !== "") {
          _this3.props.postTelefonoAfiliado(oldTelephone, telefono, email, telefono2);
          _this3.props.fetchEspontaneo(especialidad, 23912, _this3.props.prepaga);
          _this3.props.postLinkDoc(oldTelephone, telefono, telefono2, email, especialidad, motivo, _this3.props.numberCredentialUser).then(function (data) {
            _this3.setState({
              urlLink: _this3.props.linkDoc
            });
          }).catch(function (err) {
            console.error(err);
          }).finally(function () {
            _this3.openInNewTab(_this3.state.urlLink);
            _this3.props.tomarTurno(_this3.props.prepaga, especialidad);
            //this.props.closeSelectEspecialidades(true);
            $('.modal-backdrop').hide();
          });
          // setTimeout(() => {
          //   this.setState({
          //     urlLink: this.props.linkDoc
          //   });
          //   this.openInNewTab(this.state.urlLink);
          //   this.props.closeSelectEspecialidades(true);
          //   $('.modal-backdrop').hide();
          // }, 5000);
        } else {
          return;
        }
      }, 1500);

      // const contra = datos.modelEspecifico.contra;
      // const inte = datos.modelEspecifico.inte;
      // newrelic.setCustomAttribute(
      //   'message',
      //   'VALIDACIONES - TECNICAS CONTINUAR O INICIAR CONSULTA',
      // );
      // newrelic.setCustomAttribute('contra', contra);
      // newrelic.setCustomAttribute('inte', inte);

      //Monitoring log
      //const monitoringUtil = new MonitoringUtil();
      //monitoringUtil.createAffilliateLog({ interaction:"VALIDACIONES - TECNICAS CONTINUAR", message:"El afiliado paso las validaciones tecnicas y continua con el proceso de la llamada." });  

      // fetch(`${generateAbsoluteUrl()}/renew-token`, {
      //   method: 'POST',
      //   body: JSON.stringify(dataToken),
      //   headers: new Headers({
      //     'Content-Type': 'application/json',
      //   }),
      // })
      //   .then(res => res.json())
      //   .then(response => {
      //     if (response.data && response.data.token && response.data.exp) {
      //       const authData = localStorage.getItem(LOCALSTORAGE_AUTH_KEY);
      //       const authJson = JSON.parse(authData);
      //       authJson.token = response.data.token;
      //       authJson.exp = response.data.exp;
      //       localStorage.setItem('token', JSON.stringify(authJson.token));
      //       localStorage.setItem(LOCALSTORAGE_AUTH_KEY, JSON.stringify(authJson));
      //     }
      //     this.setState({
      //       direccion,
      //     });
      //     if (this.props.origen === 'espontaneo') {
      //       this.props.tomarTurno(
      //         this.props.prepaga,
      //         this.props.practica,
      //         this.props.especialidad,
      //       );
      //     } else if (this.props.origen === 'mail' ||
      //                this.props.origen === 'consulta') {
      //       this.setState({
      //         iniciarLlamada: true,
      //       });
      //     }
      //   });
    }
  }, {
    key: 'onButtonReintentarClick',
    value: function onButtonReintentarClick() {
      this.validateMicro();
      this.validateVideo();
    }
  }, {
    key: 'validateVideo',
    value: function validateVideo() {
      var _this4 = this;

      navigator.getMedia = navigator.getUserMedia || navigator.webkitGetUserMedia || navigator.mozGetUserMedia || navigator.msGetUserMedia;

      navigator.getMedia({ video: true }, function (stream) {
        _this4.changeStateVideo(true);
        stream.stop();
      }, function (stream) {
        _this4.changeStateVideo(false);
        stream.stop();
      });
    }
  }, {
    key: 'validateMicro',
    value: function validateMicro() {
      var _this5 = this;

      navigator.getMedia = navigator.getUserMedia || navigator.webkitGetUserMedia || navigator.mozGetUserMedia || navigator.msGetUserMedia;

      navigator.getMedia({ audio: true }, function () {
        return _this5.changeStateMicro(true);
      }, function () {
        return _this5.changeStateMicro(false);
      });
    }
  }, {
    key: 'changeStateMicro',
    value: function changeStateMicro(value) {
      this.setState({
        validationMicro: value
      });
    }
  }, {
    key: 'changeStateVideo',
    value: function changeStateVideo(value) {
      this.setState({
        validationVideo: value
      });
    }
  }, {
    key: 'obtenerDetalleTurno',
    value: function obtenerDetalleTurno(turno) {
      var _this6 = this;

      var datos = JSON.parse(localStorage.getItem(__WEBPACK_IMPORTED_MODULE_18__constants_index__["_30" /* LOCALSTORAGE_AUTH_KEY */]));
      var datosInteSelected = JSON.parse(localStorage.getItem('inteSelected'));
      var token = datos.token;
      var contra = datos.modelEspecifico.contra;
      var inte = datosInteSelected.inte;
      var url = Object(__WEBPACK_IMPORTED_MODULE_20__utils_generateAbsoluteUrl__["a" /* default */])() + '/api/getTurnoPorId';
      var dataDetail = {
        token: token,
        contra: contra,
        inte: inte,
        idTurno: turno
      };
      fetch(url, {
        method: 'POST',
        body: JSON.stringify(dataDetail),
        headers: new Headers({
          'Content-Type': 'application/json'
        })
      }).then(function (res) {
        return res.json();
      }).then(function (response) {
        _this6.setState({ turno: response });
      });
    }
  }, {
    key: 'volverAConsultaTurnos',
    value: function volverAConsultaTurnos() {
      this.props.hideValidacionesTecnicas();
      Object(__WEBPACK_IMPORTED_MODULE_19__utils_redirectTo__["a" /* default */])('/telemedicina/solicitud-turnos');
    }
  }, {
    key: 'render',
    value: function render() {
      var _this7 = this;

      if (this.props.domicilio) {
        this.domicilioParticular = this.props.domicilio.calle + ' ' + this.props.domicilio.numero + ', ' + this.props.domicilio.partido + ', ' + this.props.domicilio.cp;
      }
      // if (!this.state.iniciarLlamada) {
      //   const datos = JSON.parse(localStorage.getItem(LOCALSTORAGE_AUTH_KEY));
      //   const contra = datos.modelEspecifico.contra;
      //   const inte = datos.modelEspecifico.inte;
      //   newrelic.setCustomAttribute(
      //     'message',
      //     'EL PACIENTE NO CUMPLE LOS REQUISITOS PARA INICIAR LA LLAMADA',
      //   );
      //   newrelic.setCustomAttribute('contra', contra);
      //   newrelic.setCustomAttribute('inte', inte);

      //   //Monitoring log
      //   if(!(this.state.validationVideo && this.state.validationMicro && this.state.validationCrossnet)){
      //     //const monitoringUtil = new MonitoringUtil();
      //     //monitoringUtil.createAffilliateLog({ interaction:"VALIDACIONES TECNICAS - NO PASADAS", message:"El afiliado no paso las validaciones tecnicas requeridas para iniciar la llamada." });    
      //   }   
      // }
      return ValidacionesTecnicas__jsx('div', {
        className: '' + __WEBPACK_IMPORTED_MODULE_4__ValidacionesTecnicas_css___default.a.root
      }, void 0, this.state.hasMediaError ? ValidacionesTecnicas__ref : "", ValidacionesTecnicas__ref2, ValidacionesTecnicas__jsx('div', {
        className: __WEBPACK_IMPORTED_MODULE_4__ValidacionesTecnicas_css___default.a.container + ' col-md-10',
        style: { marginTop: '50px' }
      }, void 0, ValidacionesTecnicas__jsx('div', {
        className: __WEBPACK_IMPORTED_MODULE_4__ValidacionesTecnicas_css___default.a.validacion_row + ' col-md-12 row'
      }, void 0, ValidacionesTecnicas__jsx('div', {
        className: 'col-md-1',
        style: { textAlign: 'center' }
      }, void 0, ValidacionesTecnicas__ref3), ValidacionesTecnicas__jsx('div', {
        className: 'col-md-11'
      }, void 0, ValidacionesTecnicas__ref4)), ValidacionesTecnicas__jsx(PeriphericCheckComponent, {
        validation: this.state.validationMicro,
        icon: __WEBPACK_IMPORTED_MODULE_8__public_images_ic_microphone_png___default.a,
        msgSuccess: 'Record\xE1 que es mejor utilizar auriculares para que la calidad de\n                                    audio sea \xF3ptima.',
        msgError: 'Tu micr\xF3fono no funciona correctamente, por favor chequealo\n                                    para continuar.',
        msgClass: 'col-md-11'
      }), ValidacionesTecnicas__jsx(PeriphericCheckComponent, {
        validation: this.state.validationVideo,
        icon: __WEBPACK_IMPORTED_MODULE_10__public_images_ic_video_png___default.a,
        msgSuccess: 'Es necesario que poseas una webcam para que el m\xE9dico pueda\n                                    observar tu estado y s\xEDntomas.',
        msgError: 'Tu c\xE1mara no funciona correctamente, por favor chequeala\n                                    para continuar.',
        msgClass: 'col-md-11'
      }), ValidacionesTecnicas__jsx(PeriphericCheckComponent, {
        validation: this.state.validationVideo && this.state.validationMicro,
        icon: __WEBPACK_IMPORTED_MODULE_9__public_images_ic_padlock_png___default.a,
        msgSuccess: 'Tu navegador va a solicitar los permisos para utilizar la webcam \n                                    y el micr\xF3fono, record\xE1 habilitarlos.',
        msgError: 'Tu navegador va a solicitar los permisos para utilizar la webcam \n                                    y el micr\xF3fono, record\xE1 habilitarlos.',
        msgClass: 'col-md-11'
      }), ValidacionesTecnicas__jsx('div', {
        className: 'col-md-12 row',
        style: { marginBottom: '25px', marginTop: '25px' }
      }, void 0, ValidacionesTecnicas__jsx('div', {
        className: 'col-md-3'
      }, void 0, this.state.validationVideo && this.state.validationMicro ? ValidacionesTecnicas__jsx('button', {
        id: 'openModalButton',
        className: __WEBPACK_IMPORTED_MODULE_4__ValidacionesTecnicas_css___default.a.boton_rojo + ' btn btn-default text-center',
        onClick: function onClick() {
          return _this7.props.fetchDomicilio();
        }
      }, void 0, 'Continuar') : ValidacionesTecnicas__jsx('button', {
        className: __WEBPACK_IMPORTED_MODULE_4__ValidacionesTecnicas_css___default.a.boton_rojo + ' btn btn-default text-center',
        onClick: function onClick() {
          return _this7.onButtonReintentarClick();
        }
      }, void 0, 'Reintentar'), ValidacionesTecnicas__jsx('div', {}, void 0, ValidacionesTecnicas__jsx('button', {
        onClick: function onClick() {
          return _this7.volverAConsultaTurnos();
        },
        className: '' + __WEBPACK_IMPORTED_MODULE_4__ValidacionesTecnicas_css___default.a.boton_volver
      }, void 0, ValidacionesTecnicas__ref5, ' Volver a solicitud de turnos'))), ValidacionesTecnicas__ref6), this.state.turnoOcupado ? ValidacionesTecnicas__jsx(ModalTurnoElegidoYaFueSeleccionado_defaultExport, {
        proximoTurno: this.props.proximoDisponible
      }) : '', this.props.domicilio ? ValidacionesTecnicas__jsx(ModalIngresoDireccionActual_defaultExport, {
        direccion: this.domicilioParticular,
        telefono: this.props.telefono,
        oldTelephone: this.props.get_telefonos,
        continuar: this.onButtonContinuarClick,
        valEmail: this.props.valEmail,
        velidateTel: this.state.velidateTel,
        validateSubmit: this.props.validateSubmit
      }) : ''), this.state.iniciarLlamada ? ValidacionesTecnicas__jsx('div', {
        className: 'col-md-1'
      }, void 0, ValidacionesTecnicas__jsx(ModalVideoLlamada_defaultExport, {
        turno: this.state.turno,
        espontaneo: this.props.llamada_espontanea,
        origen: this.props.origen,
        direccion: this.state.direccion,
        prepaga: this.props.prepaga,
        practica: this.props.practica,
        especialidad: this.props.especialidad,
        setHasMediaError: this.setHasMediaError
      })) : '');
    }
  }]);

  return ValidacionesTecnicas;
}(ValidacionesTecnicas___WEBPACK_IMPORTED_MODULE_0_react___default.a.Component);

var ValidacionesTecnicas_mapStateToProps = function mapStateToProps(state) {
  return {
    tomarTurnoSuccess: state.telemedicina.turnoTomado,
    domicilioAfiliado: state.telemedicina.domicilio_particular,
    domicilio: state.telemedicina.domicilio,
    prepaga: state.telemedicina.prepaga,
    practica: state.telemedicina.practica,
    proximoDisponible: state.telemedicina.proximoDisponible,
    llamada_espontanea: state.telemedicina.llamada_espontanea,
    email: state.telemedicina.email,
    telefono: state.telemedicina.telefono,
    get_telefonos: state.telemedicina.get_telefonos,
    id_especialidad: state.telemedicina.id_especialidad,
    id_motivo: state.telemedicina.id_motivo,
    linkDoc: state.telemedicina.linkDoc,
    valEmail: state.telemedicina.valEmail,
    validateSubmit: state.telemedicina.validateSubmit,
    numberCredentialUser: state.telemedicina.numberCredentialUser
  };
};

/* harmony default export */ var ValidacionesTecnicas_defaultExport = __webpack_exports__["a"] = (Object(ValidacionesTecnicas___WEBPACK_IMPORTED_MODULE_1_react_redux__["b" /* connect */])(ValidacionesTecnicas_mapStateToProps, ValidacionesTecnicas___WEBPACK_IMPORTED_MODULE_5__actions_telemedicinaActions__)(ValidacionesTecnicas___WEBPACK_IMPORTED_MODULE_2_isomorphic_style_loader_lib_withStyles___default()(__WEBPACK_IMPORTED_MODULE_4__ValidacionesTecnicas_css___default.a)(ValidacionesTecnicas_ValidacionesTecnicas)));

/***/ }),
/* 1145 */
/***/ (function(module, exports, __webpack_require__) {


    var content = __webpack_require__(1146);
    var insertCss = __webpack_require__(889);

    if (typeof content === 'string') {
      content = [[module.i, content, '']];
    }

    module.exports = content.locals || {};
    module.exports._getContent = function() { return content; };
    module.exports._getCss = function() { return content.toString(); };
    module.exports._insertCss = function(options) { return insertCss(content, options) };
    
    // Hot Module Replacement
    // https://webpack.github.io/docs/hot-module-replacement
    // Only activated in browser context
    if (false) {
      var removeCss = function() {};
      module.hot.accept("!!../../../../node_modules/css-loader/index.js??ref--2-rules-2!../../../../node_modules/postcss-loader/lib/index.js??ref--2-rules-3!./ValidacionesTecnicas.css", function() {
        content = require("!!../../../../node_modules/css-loader/index.js??ref--2-rules-2!../../../../node_modules/postcss-loader/lib/index.js??ref--2-rules-3!./ValidacionesTecnicas.css");

        if (typeof content === 'string') {
          content = [[module.id, content, '']];
        }

        removeCss = insertCss(content, { replace: true });
      });
      module.hot.dispose(function() { removeCss(); });
    }
  

/***/ }),
/* 1146 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(888)(false);
// imports


// module
exports.push([module.i, ".IJ0VP{padding-left:90px;padding-right:20px}._1nov7{font-family:Roboto,sans-serif;font-size:20px;color:#363636}._3vXWz{margin-bottom:20px}._3vXWz img{margin-top:10px}._3vXWz span{color:#e4002b;font-size:16px;font-weight:700}._1l8YA{color:#eee;background-color:#e4002b;border-color:#e4002b;cursor:pointer;font-family:Roboto\\, Medium;width:140px}._33YyZ{color:#e4002b;font-size:25px;position:absolute;right:10px;bottom:-15px}._2bErR{color:#e4002b;background-color:#fff;border:0;margin-top:15px;cursor:pointer;width:250px;font-size:18px;text-align:left;padding:0}._2bErR:hover{cursor:pointer;text-decoration:underline}", ""]);

// exports
exports.locals = {
	"root": "IJ0VP",
	"container": "_1nov7",
	"validacion_row": "_3vXWz",
	"boton_rojo": "_1l8YA",
	"crossIcon": "_33YyZ",
	"boton_volver": "_2bErR"
};

/***/ }),
/* 1147 */
/***/ (function(module, exports, __webpack_require__) {


    var content = __webpack_require__(1148);
    var insertCss = __webpack_require__(889);

    if (typeof content === 'string') {
      content = [[module.i, content, '']];
    }

    module.exports = content.locals || {};
    module.exports._getContent = function() { return content; };
    module.exports._getCss = function() { return content.toString(); };
    module.exports._insertCss = function(options) { return insertCss(content, options) };
    
    // Hot Module Replacement
    // https://webpack.github.io/docs/hot-module-replacement
    // Only activated in browser context
    if (false) {
      var removeCss = function() {};
      module.hot.accept("!!../../../../node_modules/css-loader/index.js??ref--2-rules-2!../../../../node_modules/postcss-loader/lib/index.js??ref--2-rules-3!./ModalVideoLlamada.css", function() {
        content = require("!!../../../../node_modules/css-loader/index.js??ref--2-rules-2!../../../../node_modules/postcss-loader/lib/index.js??ref--2-rules-3!./ModalVideoLlamada.css");

        if (typeof content === 'string') {
          content = [[module.id, content, '']];
        }

        removeCss = insertCss(content, { replace: true });
      });
      module.hot.dispose(function() { removeCss(); });
    }
  

/***/ }),
/* 1148 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(888)(false);
// imports


// module
exports.push([module.i, "._3f4AY{width:98%;height:80%;min-width:350px;min-height:350px;border:1px solid #ccc;border-radius:3px;padding:10px 10px 68px;background-color:#fff;position:fixed!important;right:20px;top:60px;-webkit-box-shadow:2px 2px 3px rgba(0,0,0,.6);box-shadow:2px 2px 3px rgba(0,0,0,.6)}._1jW4m{top:0;left:0;width:100%;display:none;-webkit-box-shadow:#000 0 107px 105px -58px inset;box-shadow:inset 0 107px 105px -58px #000;padding:34px 20px 50px 30px;font-size:30px}._1jW4m,._359ai{position:absolute;color:#fff}._359ai{bottom:100px;left:47%;border-radius:30px;background-color:#e4002b;padding:9px 20px;font-size:28px;cursor:pointer;-webkit-box-shadow:#000 1px 1px 6px 0;box-shadow:1px 1px 6px 0 #000}._2G8_H{text-align:right;position:absolute;bottom:0;left:0;width:100%;padding:10px 0;background:transparent;color:#333;border-top:1px solid #ccc}._2G8_H._2MEGG{-webkit-box-shadow:#000 0 -50px 60px -24px inset;box-shadow:inset 0 -50px 60px -24px #000;color:#fff;border-top:0 none;padding:40px 0 10px}._1jW4m._2MEGG{display:block}._10ekU{-webkit-transform:rotateY(180deg);transform:rotateY(180deg);-moz-transform:rotateY(180deg)}.z7oCK{position:fixed;top:0;right:0;bottom:0;left:0;background-color:rgba(0,0,0,.52);overflow:none}", ""]);

// exports
exports.locals = {
	"modalVideoLLamada": "_3f4AY",
	"modalVideoLlamadaheader": "_1jW4m",
	"full": "_2MEGG",
	"modalVideoLlamadaEnd": "_359ai",
	"modalVideoLlamadaFooter": "_2G8_H",
	"modalLocalView": "_10ekU",
	"root": "z7oCK"
};

/***/ }),
/* 1149 */
/***/ (function(module, exports, __webpack_require__) {


    var content = __webpack_require__(1150);
    var insertCss = __webpack_require__(889);

    if (typeof content === 'string') {
      content = [[module.i, content, '']];
    }

    module.exports = content.locals || {};
    module.exports._getContent = function() { return content; };
    module.exports._getCss = function() { return content.toString(); };
    module.exports._insertCss = function(options) { return insertCss(content, options) };
    
    // Hot Module Replacement
    // https://webpack.github.io/docs/hot-module-replacement
    // Only activated in browser context
    if (false) {
      var removeCss = function() {};
      module.hot.accept("!!../../../../../node_modules/css-loader/index.js??ref--2-rules-2!../../../../../node_modules/postcss-loader/lib/index.js??ref--2-rules-3!./TimerModalVideoLlamada.css", function() {
        content = require("!!../../../../../node_modules/css-loader/index.js??ref--2-rules-2!../../../../../node_modules/postcss-loader/lib/index.js??ref--2-rules-3!./TimerModalVideoLlamada.css");

        if (typeof content === 'string') {
          content = [[module.id, content, '']];
        }

        removeCss = insertCss(content, { replace: true });
      });
      module.hot.dispose(function() { removeCss(); });
    }
  

/***/ }),
/* 1150 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(888)(false);
// imports


// module
exports.push([module.i, "._1Dho4{font-family:Roboto\\, Medium}._3IGng{width:116px;height:116px;border-radius:100px;border:2px solid red;display:inline-block;position:relative;-webkit-box-shadow:0 1px 3px 0 rgba(0,0,0,.2);box-shadow:0 1px 3px 0 rgba(0,0,0,.2);border-width:2px}._2HuBE{padding-bottom:72px}", ""]);

// exports
exports.locals = {
	"posicionText": "_1Dho4",
	"imgAvatar": "_3IGng",
	"datosMedico": "_2HuBE"
};

/***/ }),
/* 1151 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "7b4aa2e2.mp4";

/***/ }),
/* 1152 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "324384db.mp4";

/***/ }),
/* 1153 */
/***/ (function(module, exports, __webpack_require__) {


    var content = __webpack_require__(1154);
    var insertCss = __webpack_require__(889);

    if (typeof content === 'string') {
      content = [[module.i, content, '']];
    }

    module.exports = content.locals || {};
    module.exports._getContent = function() { return content; };
    module.exports._getCss = function() { return content.toString(); };
    module.exports._insertCss = function(options) { return insertCss(content, options) };
    
    // Hot Module Replacement
    // https://webpack.github.io/docs/hot-module-replacement
    // Only activated in browser context
    if (false) {
      var removeCss = function() {};
      module.hot.accept("!!../../../../node_modules/css-loader/index.js??ref--2-rules-2!../../../../node_modules/postcss-loader/lib/index.js??ref--2-rules-3!./ModalReprogramarTurno.css", function() {
        content = require("!!../../../../node_modules/css-loader/index.js??ref--2-rules-2!../../../../node_modules/postcss-loader/lib/index.js??ref--2-rules-3!./ModalReprogramarTurno.css");

        if (typeof content === 'string') {
          content = [[module.id, content, '']];
        }

        removeCss = insertCss(content, { replace: true });
      });
      module.hot.dispose(function() { removeCss(); });
    }
  

/***/ }),
/* 1154 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(888)(false);
// imports


// module
exports.push([module.i, "._1zw8k{text-align:center}._2PcZp{margin:0 auto}._3fJn4{font-family:Roboto,sans-serif;padding:25px 0}._13zf-{color:#fff;background-color:#e4002b;border-color:#e4002b;cursor:pointer;font-family:Roboto\\, Medium;width:190px}", ""]);

// exports
exports.locals = {
	"modalContent": "_1zw8k",
	"modalFooter": "_2PcZp",
	"modalBody": "_3fJn4",
	"boton_rojo": "_13zf-"
};

/***/ }),
/* 1155 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "95c7bf6c.svg";

/***/ }),
/* 1156 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(Buffer) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(71);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_isomorphic_style_loader_lib_withStyles__ = __webpack_require__(887);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_isomorphic_style_loader_lib_withStyles___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_isomorphic_style_loader_lib_withStyles__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__FooterModalVideoLlamada_css__ = __webpack_require__(1157);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__FooterModalVideoLlamada_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__FooterModalVideoLlamada_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__constants_index__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__public_images_ic_sound_png__ = __webpack_require__(1159);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__public_images_ic_sound_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__public_images_ic_sound_png__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__public_images_ic_maximizar_png__ = __webpack_require__(1160);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__public_images_ic_maximizar_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__public_images_ic_maximizar_png__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__public_images_ic_attached_png__ = __webpack_require__(1161);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__public_images_ic_attached_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__public_images_ic_attached_png__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__public_images_ic_estudios_png__ = __webpack_require__(1162);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__public_images_ic_estudios_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7__public_images_ic_estudios_png__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__public_images_volume_up_png__ = __webpack_require__(1163);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__public_images_volume_up_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8__public_images_volume_up_png__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__public_images_expand_arrows_png__ = __webpack_require__(1164);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__public_images_expand_arrows_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9__public_images_expand_arrows_png__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__public_images_paperclip_png__ = __webpack_require__(1165);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__public_images_paperclip_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10__public_images_paperclip_png__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__public_images_clipboard_png__ = __webpack_require__(1166);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__public_images_clipboard_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11__public_images_clipboard_png__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__utils_generateAbsoluteUrl__ = __webpack_require__(127);
var _jsx = function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; }();

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

/* global $ */
/* eslint react/prop-types: 0 */
/* eslint import/no-unresolved:0 */
/* eslint-disable */















var FooterModalVideoLlamada = function (_React$Component) {
  _inherits(FooterModalVideoLlamada, _React$Component);

  _createClass(FooterModalVideoLlamada, null, [{
    key: 'ShowPDF',
    value: function ShowPDF(pdf, nombre) {
      //window.open(pdf);
      //return false;
      var temp = Buffer.from(pdf).toString('base64');
      var a = document.createElement('a');
      a.href = 'data:application/octet-stream;base64,' + temp;
      a.download = nombre + '.pdf';
      a.click();
    }
  }, {
    key: 'formatDate',
    value: function formatDate(date) {
      var year = date.substr(0, 4);
      var month = date.substr(4, 2);
      var day = date.substr(6, 8);
      var dateFormat = day + '/' + month + '/' + year;
      return dateFormat;
    }
  }]);

  function FooterModalVideoLlamada(props) {
    _classCallCheck(this, FooterModalVideoLlamada);

    var _this = _possibleConstructorReturn(this, (FooterModalVideoLlamada.__proto__ || Object.getPrototypeOf(FooterModalVideoLlamada)).call(this, props));

    _this.state = {
      // estudios: `<div class="${s.popOverEstudio} row"><div class="col-4">12/06/18</div><div class="col-6" style="padding:0;">Ecocardiografia blablabla</div><div class="col-2"><i class="fa fa-download" aria-hidden="true" /></div></div>`,
      estudios: '',
      download: ''
    };
    _this.showDivEstudios = _this.showDivEstudios.bind(_this);
    _this.showVolume = _this.showVolume.bind(_this);
    return _this;
  }

  _createClass(FooterModalVideoLlamada, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      var _this2 = this;

      $('body').on('click', function (e) {
        //did not click a popover toggle or popover
        if ($(e.target).data('toggle') !== 'popover' && $(e.target).parents('.popover.in').length === 0) {
          $('[data-toggle="popover"]').popover('hide');
        }
      });

      function setVolume(val, video) {
        if (!val) return;
        event.preventDefault();
        var player = document.getElementById(video);
        player.volume = val / 100;
      }

      var datos = JSON.parse(localStorage.getItem(__WEBPACK_IMPORTED_MODULE_3__constants_index__["_30" /* LOCALSTORAGE_AUTH_KEY */]));
      var datosInteSelected = JSON.parse(localStorage.getItem('inteSelected'));
      var token = datos.token;
      var tipoDoc = datosInteSelected.tipodoc;
      var nroDoc = datosInteSelected.nrodoc;
      var contra = datos.modelEspecifico.contra;
      var inte = datosInteSelected.inte;
      var credencial = datosInteSelected.credencial;
      var fechaNac = datosInteSelected.fechanacimiento;
      var prepaga = datosInteSelected.prepaga;

      var data = {
        contra: contra,
        token: token,
        inte: inte,
        credencial: credencial,
        tipoDoc: tipoDoc,
        nroDoc: nroDoc,
        fechaNac: fechaNac,
        prepaga: prepaga
      };

      fetch(Object(__WEBPACK_IMPORTED_MODULE_12__utils_generateAbsoluteUrl__["a" /* default */])() + '/api/getEstudios', {

        method: 'POST',
        body: JSON.stringify(data),
        headers: new Headers({
          'Content-Type': 'application/json'
        })
      }).then(function (res) {
        return res.json();
      }).then(function (response) {
        var listEstudios = '';
        if (response.informes) {
          for (var i = 0; i < response.informes.length; i += 1) {
            listEstudios += '<div style="margin: 0; border-bottom: 1px solid; border-color: #e6e2e2; padding-top: 10px;" class="col-md-12 row"><div style="padding-bottom: 15px;" class="col-4">' + FooterModalVideoLlamada.formatDate(response.informes[i].fecha) + '</div><div class="col-6" style="padding-bottom: 15px;">' + response.informes[i].tipo + '</div><div class="col-2"><i style=" padding-bottom: 15px; cursor: pointer; font-size: 20px; color: #000;" id="descargar" data-informe=' + response.informes[i].idInforme + ' data-imagen=' + response.informes[i].idImagen + ' data-fecha=' + response.informes[i].fecha + ' data-hora=' + response.informes[i].hora + ' class="fa fa-download" aria-hidden="true" /></div></div>';
          }
        }
        _this2.setState({ estudios: listEstudios });
      });

      $('#estudiosIcon').popover({
        trigger: 'click',
        html: true,
        container: 'body'
      });

      $('#estudiosIconWhite').popover({
        trigger: 'click',
        html: true,
        container: 'body'
      });

      $('#VolumeIcon').popover({
        trigger: 'click',
        html: true,
        container: 'body',
        template: getPopoverCustomTemplate('myCustomClass')
      });

      $('#VolumeIconWhite').popover({
        trigger: 'click',
        html: true,
        container: 'body',
        template: getPopoverCustomTemplate('myCustomClass')
      });

      $('#VolumeIconVideo').popover({
        trigger: 'click',
        html: true,
        container: 'body',
        template: getPopoverCustomTemplate('myCustomClass')
      });

      function getPopoverCustomTemplate(className) {
        return '<div class="popover ' + className + '" role="tooltip"><div class="arrow"><div id="divInputVolume"><input style="padding: 5px; margin-top: 5px;" id="vol-control" class=slider type="range" min="0" max="100" value="100" step="1"></input></div></div></div>';
      }

      $('#VolumeIconWhiteVideo').popover({
        trigger: 'click',
        html: true,
        container: 'body'
      });

      $('body').on('click', '#descargar', function (e) {
        var _this3 = this;

        e.preventDefault();
        e.stopImmediatePropagation();
        var informe = $(this).data('informe');
        var imagen = $(this).data('imagen');
        var fecha = $(this).data('fecha');
        var hora = $(this).data('hora');

        fetch(Object(__WEBPACK_IMPORTED_MODULE_12__utils_generateAbsoluteUrl__["a" /* default */])() + '/api/getVariablesEntorno', {
          method: 'POST',
          headers: new Headers({
            'Content-Type': 'application/json'
          })
        }).then(function (res) {
          return res.json();
        }).then(function (response) {
          var apiManagerUrl = response.apiManagerUrl;
          var datos = JSON.parse(localStorage.getItem(__WEBPACK_IMPORTED_MODULE_3__constants_index__["_30" /* LOCALSTORAGE_AUTH_KEY */]));
          var token = datos.token;
          var dataDownload = {
            contra: contra,
            token: token,
            inte: inte,
            credencial: credencial,
            tipoDoc: tipoDoc,
            nroDoc: nroDoc,
            fechaNac: fechaNac,
            prepaga: prepaga,
            informe: informe,
            imagen: imagen,
            fecha: fecha,
            hora: hora
          };

          var xhr = new XMLHttpRequest();
          var uri = apiManagerUrl + '/api-smg/v0/pacientes/' + contra + '/integrantes;nacimiento=' + fechaNac + ';documento=' + nroDoc + '/' + inte + '/estudios/clinica/informes/' + informe + '/imagen/' + imagen + '?fecha=' + fecha + '&hora=' + hora;
          //const uri = `https://mobileqa.swissmedical.com.ar/api-smg/v0/pacientes/${contra}/integrantes;nacimiento=${fechaNac};documento=${nroDoc}/${inte}/estudios/clinica/informes/${informe}/imagen/${imagen}?fecha=${fecha}&hora=${hora}`;
          console.log(uri);

          //set the request type to post and the destination url to '/convert'
          xhr.open('GET', uri);

          xhr.setRequestHeader("Authorization", 'Bearer ' + token);
          //set the reponse type to blob since that's what we're expecting back
          xhr.responseType = 'blob';
          var formData = new FormData(_this3);
          xhr.send(formData);
          xhr.onload = function (e) {
            if (this.status == 200) {
              // Create a new Blob object using the response data of the onload object
              var blob = new Blob([this.response], { type: 'image/pdf' });
              //Create a link element, hide it, direct it towards the blob, and then 'click' it programatically
              var a = document.createElement("a");
              a.style = "display: none";
              document.body.appendChild(a);
              //Create a DOMString representing the blob and point the link element towards it
              var url = window.URL.createObjectURL(blob);
              a.href = url;
              a.download = 'estudio_' + informe + '.pdf';
              //programatically click the link to trigger the download
              a.click();
              //release the reference to the file by revoking the Object URL
              window.URL.revokeObjectURL(url);
            } else {
              //deal with your error state here
            }
          };
        });
      });

      $('body').on('change', '#vol-control', function (event) {
        setVolume(this.value, 'videoSwiss');
      });

      $('body').on('input', '#vol-control', function (event) {
        setVolume(this.value, 'videoSwiss');
      });

      $('body').on('change', '#vol-control', function (event) {
        setVolume(this.value, 'remoteView');
      });

      $('body').on('input', '#vol-control', function (event) {
        setVolume(this.value, 'remoteView');
      });
    }
  }, {
    key: 'showVolume',
    value: function showVolume() {
      if ($('#divInputVolume').is(':visible')) {
        $('#divInputVolume').hide();
      } else {
        $('#divInputVolume').show();
      }
    }
  }, {
    key: 'showDivEstudios',
    value: function showDivEstudios() {
      var estudios = '';
      if ($('#divEstudios').is(':visible')) {
        $('#divEstudios').hide();
      } else {
        estudios = this.state.estudios;
        var estudiosHeader = '<div style="background-color:#f1f1f1; color: #000; text-align: left;"><b>Estudios realizados</b></div>' + estudios;
        $('#divEstudios').html(estudiosHeader);
        $('#divEstudios').show();
      }
    }
  }, {
    key: 'componentWillReceiveProps',
    value: function componentWillReceiveProps() {}
  }, {
    key: 'componentWillUnmount',
    value: function componentWillUnmount() {}
  }, {
    key: 'render',
    value: function render() {
      var _jsx2;

      var estudios = this.state.estudios;
      return this.props.llamadaIniciada ? _jsx('div', {
        className: __WEBPACK_IMPORTED_MODULE_2__FooterModalVideoLlamada_css___default.a.footerContent + ' row'
      }, void 0, _jsx('div', {
        style: { width: '96%' }
      }, void 0, _jsx('img', {
        alt: 'Anterior',
        src: __WEBPACK_IMPORTED_MODULE_7__public_images_ic_estudios_png___default.a,
        className: 'fa fa-calendar-o',
        'aria-hidden': 'true',
        'data-toggle': 'popover',
        'data-placement': 'top',
        title: 'Estudios realizados',
        'data-content': estudios,
        'data-container': 'body',
        id: 'estudiosIcon',
        style: { cursor: 'pointer', marginRight: '25px' }
      }), _jsx('img', (_jsx2 = {
        id: 'modalClip',
        alt: 'Anterior',
        src: __WEBPACK_IMPORTED_MODULE_11__public_images_clipboard_png___default.a,
        className: 'fa fa-calendar-o',
        'aria-hidden': 'true',
        onClick: this.showDivEstudios
      }, _defineProperty(_jsx2, 'id', 'estudiosIconWhite'), _defineProperty(_jsx2, 'style', {
        cursor: 'pointer',
        marginRight: '25px',
        display: 'none'
      }), _jsx2)), _jsx('label', {
        htmlFor: 'fileInput',
        style: { marginBottom: '0' }
      }, void 0, _jsx('img', {
        id: 'modalClip',
        alt: 'Anterior',
        src: __WEBPACK_IMPORTED_MODULE_6__public_images_ic_attached_png___default.a,
        style: { cursor: 'pointer', marginRight: '25px' }
      }), _jsx('img', {
        id: 'modalClipWhite',
        alt: 'Anterior',
        src: __WEBPACK_IMPORTED_MODULE_10__public_images_paperclip_png___default.a,
        style: {
          cursor: 'pointer',
          marginRight: '25px',
          display: 'none'
        }
      })), _jsx('input', {
        id: 'fileInput',
        type: 'file',
        className: __WEBPACK_IMPORTED_MODULE_2__FooterModalVideoLlamada_css___default.a.fileUpload,
        onChange: this.props.getPhoto
      }), ' ', _jsx('img', {
        alt: 'Anterior',
        src: __WEBPACK_IMPORTED_MODULE_4__public_images_ic_sound_png___default.a,
        'data-toggle': 'popover',
        'data-placement': 'top',
        id: 'VolumeIcon',
        'data-content': '<input id="vol-control-video" class=slider type="range" min="0" max="100" step="1"></input>',
        style: { cursor: 'pointer', marginRight: '25px' }
      }), _jsx('img', {
        alt: 'Anterior',
        src: __WEBPACK_IMPORTED_MODULE_8__public_images_volume_up_png___default.a,
        id: 'VolumeIconWhite',
        style: {
          cursor: 'pointer',
          marginRight: '25px',
          display: 'none'
        },
        onClick: this.showVolume
      }), _jsx('img', {
        alt: 'Anterior',
        src: __WEBPACK_IMPORTED_MODULE_8__public_images_volume_up_png___default.a,
        'data-toggle': 'popover',
        'data-placement': 'top',
        id: 'VolumeIconWhite',
        'data-content': '<input id="vol-control-video" class=slider type="range" min="0" max="100" step="1"></input>',
        style: { cursor: 'pointer', marginRight: '25px', display: 'none' }
      }), _jsx('img', {
        alt: 'Anterior',
        src: __WEBPACK_IMPORTED_MODULE_5__public_images_ic_maximizar_png___default.a,
        onClick: this.props.maximizeModalVideoLlamada,
        id: 'modalMaximize',
        style: { cursor: 'pointer' }
      }), _jsx('img', {
        alt: 'Anterior',
        src: __WEBPACK_IMPORTED_MODULE_9__public_images_expand_arrows_png___default.a,
        onClick: this.props.restoreModalVideoLlamada,
        id: 'modalRestore',
        style: { cursor: 'pointer', display: 'none' }
      }), _jsx('div', {
        id: 'divInputVolume',
        style: {
          display: 'none',
          position: 'absolute',
          right: '20px',
          bottom: '31px',
          width: '130px',
          height: '40px',
          backgroundColor: '#fff',
          borderRadius: '.3rem'
        }
      }, void 0, _jsx('input', {
        style: { marginTop: '8px' },
        id: 'vol-control',
        className: 'slider',
        type: 'range',
        min: '0',
        max: '100',
        step: '1',
        defaultValue: '100'
      })), _jsx('div', {
        id: 'divEstudios',
        className: '' + __WEBPACK_IMPORTED_MODULE_2__FooterModalVideoLlamada_css___default.a.modalEstudios,
        style: {
          display: 'none',
          position: 'absolute',
          right: '20px',
          bottom: '30px',
          maxWidth: '375px',
          maxHeight: '550px',
          color: '#6f6b6b',
          backgroundColor: '#fff',
          borderRadius: '.3rem',
          overflow: 'auto',
          fontSize: '.875rem',
          fontFamily: 'font-family: Roboto'
        }
      }))) : _jsx('div', {
        className: __WEBPACK_IMPORTED_MODULE_2__FooterModalVideoLlamada_css___default.a.footerContent + ' row'
      }, void 0, _jsx('div', {
        style: { width: '96%' }
      }, void 0, _jsx('img', {
        className: ' ' + __WEBPACK_IMPORTED_MODULE_2__FooterModalVideoLlamada_css___default.a.popoverVolume,
        alt: 'volume',
        src: __WEBPACK_IMPORTED_MODULE_4__public_images_ic_sound_png___default.a,
        style: { marginRight: '30px', cursor: 'pointer' },
        'data-toggle': 'popover',
        'data-placement': 'top',
        id: 'VolumeIconVideo',
        'data-content': '<input id=\'vol-control\' class=\'slider\' type=\'range\' min=\'0\' max=\'100\' value=\'100\' step=\'1\'></input>'
      }), _jsx('img', {
        alt: 'volume',
        src: __WEBPACK_IMPORTED_MODULE_8__public_images_volume_up_png___default.a,
        style: {
          marginRight: '30px',
          cursor: 'pointer',
          display: 'none'
        },
        'data-toggle': 'popover',
        'data-placement': 'top',
        id: 'VolumeIconWhiteVideo',
        'data-content': '<input id="vol-control" class=slider type="range" min="0" max="100" step="1"></input>'
      }), _jsx('img', {
        alt: 'volume',
        src: __WEBPACK_IMPORTED_MODULE_8__public_images_volume_up_png___default.a,
        style: { marginRight: '30px', cursor: 'pointer', display: 'none' },
        'data-toggle': 'popover',
        'data-placement': 'top',
        id: 'VolumeIconWhite',
        'data-content': '<input id="vol-control" class=slider type="range" min="0" max="100" step="1"></input>'
      }), _jsx('img', {
        alt: 'Anterior',
        src: __WEBPACK_IMPORTED_MODULE_5__public_images_ic_maximizar_png___default.a,
        onClick: this.props.maximizeModalVideoLlamada,
        id: 'modalMaximize',
        style: { cursor: 'pointer' }
      }), _jsx('img', {
        alt: 'Anterior',
        src: __WEBPACK_IMPORTED_MODULE_9__public_images_expand_arrows_png___default.a,
        onClick: this.props.restoreModalVideoLlamada,
        id: 'modalRestore',
        style: { cursor: 'pointer', display: 'none' }
      })));
    }
  }]);

  return FooterModalVideoLlamada;
}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component);
/*
const mapStateToProps = state => ({
  fileuploadStatus: state.telemedicina.fileuploadStatus,
});
*/


/* harmony default export */ __webpack_exports__["a"] = (__WEBPACK_IMPORTED_MODULE_1_isomorphic_style_loader_lib_withStyles___default()(__WEBPACK_IMPORTED_MODULE_2__FooterModalVideoLlamada_css___default.a)(FooterModalVideoLlamada));
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__(2).Buffer))

/***/ }),
/* 1157 */
/***/ (function(module, exports, __webpack_require__) {


    var content = __webpack_require__(1158);
    var insertCss = __webpack_require__(889);

    if (typeof content === 'string') {
      content = [[module.i, content, '']];
    }

    module.exports = content.locals || {};
    module.exports._getContent = function() { return content; };
    module.exports._getCss = function() { return content.toString(); };
    module.exports._insertCss = function(options) { return insertCss(content, options) };
    
    // Hot Module Replacement
    // https://webpack.github.io/docs/hot-module-replacement
    // Only activated in browser context
    if (false) {
      var removeCss = function() {};
      module.hot.accept("!!../../../../../node_modules/css-loader/index.js??ref--2-rules-2!../../../../../node_modules/postcss-loader/lib/index.js??ref--2-rules-3!./FooterModalVideoLlamada.css", function() {
        content = require("!!../../../../../node_modules/css-loader/index.js??ref--2-rules-2!../../../../../node_modules/postcss-loader/lib/index.js??ref--2-rules-3!./FooterModalVideoLlamada.css");

        if (typeof content === 'string') {
          content = [[module.id, content, '']];
        }

        removeCss = insertCss(content, { replace: true });
      });
      module.hot.dispose(function() { removeCss(); });
    }
  

/***/ }),
/* 1158 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(888)(false);
// imports


// module
exports.push([module.i, "._2_IwO i{font-size:25px;margin:0 15px;cursor:pointer}._1xnT8{display:none}::-webkit-scrollbar{width:4px}::-webkit-scrollbar-track{background:#fff}::-webkit-scrollbar-thumb,::-webkit-scrollbar-thumb:hover{background:#e4002b}h3{color:#000!important}", ""]);

// exports
exports.locals = {
	"footerContent": "_2_IwO",
	"fileUpload": "_1xnT8"
};

/***/ }),
/* 1159 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "daf0a25a.png";

/***/ }),
/* 1160 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "b51200a7.png";

/***/ }),
/* 1161 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "89d049c1.png";

/***/ }),
/* 1162 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "d8894c86.png";

/***/ }),
/* 1163 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "98c59910.png";

/***/ }),
/* 1164 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "3cac19bb.png";

/***/ }),
/* 1165 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "18da2ef6.png";

/***/ }),
/* 1166 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "1a45a90f.png";

/***/ }),
/* 1167 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(1168);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(1185);

var _propTypes2 = _interopRequireDefault(_propTypes);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var Progress = function (_React$Component) {
  _inherits(Progress, _React$Component);

  function Progress() {
    _classCallCheck(this, Progress);

    return _possibleConstructorReturn(this, (Progress.__proto__ || Object.getPrototypeOf(Progress)).apply(this, arguments));
  }

  _createClass(Progress, [{
    key: 'render',
    value: function render() {
      var _props = this.props,
          color = _props.color,
          completed = _props.completed,
          animation = _props.animation,
          height = _props.height,
          className = _props.className,
          children = _props.children,
          rest = _objectWithoutProperties(_props, ['color', 'completed', 'animation', 'height', 'className', 'children']);

      var style = {
        backgroundColor: color,
        width: completed + '%',
        transition: 'width ' + animation + 'ms',
        height: height
      };

      return _react2.default.createElement(
        'div',
        _extends({ className: className || "progressbar-container" }, rest),
        _react2.default.createElement(
          'div',
          { className: 'progressbar-progress', style: style },
          children
        )
      );
    }
  }], [{
    key: 'throwError',
    value: function throwError() {
      return new (Function.prototype.bind.apply(Error, [null].concat(Array.prototype.slice.call(arguments))))();
    }
  }]);

  return Progress;
}(_react2.default.Component);

Progress.propTypes = {
  completed: function completed(props, propName) {
    if (typeof props[propName] !== 'number') return Progress.throwError('Invalid Props: "completed" should ∈ ℝ ');
    if (props[propName] < 0 || props[propName] > 100) {
      return Progress.throwError('Invalid Props: "completed" should be between 0 and 100');
    }
  },
  color: _propTypes2.default.string,
  animation: _propTypes2.default.number,
  height: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.number])
};
Progress.defaultProps = {
  completed: 0,
  color: '#0BD318',
  animation: 200,
  height: 10
};
exports.default = Progress;

/***/ }),
/* 1168 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


module.exports = __webpack_require__(1169);


/***/ }),
/* 1169 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */



var _assign = __webpack_require__(131);

var ReactBaseClasses = __webpack_require__(1128);
var ReactChildren = __webpack_require__(1171);
var ReactDOMFactories = __webpack_require__(1176);
var ReactElement = __webpack_require__(1115);
var ReactPropTypes = __webpack_require__(1177);
var ReactVersion = __webpack_require__(1181);

var createReactClass = __webpack_require__(1182);
var onlyChild = __webpack_require__(1184);

var createElement = ReactElement.createElement;
var createFactory = ReactElement.createFactory;
var cloneElement = ReactElement.cloneElement;

if (false) {
  var lowPriorityWarning = require('./lowPriorityWarning');
  var canDefineProperty = require('./canDefineProperty');
  var ReactElementValidator = require('./ReactElementValidator');
  var didWarnPropTypesDeprecated = false;
  createElement = ReactElementValidator.createElement;
  createFactory = ReactElementValidator.createFactory;
  cloneElement = ReactElementValidator.cloneElement;
}

var __spread = _assign;
var createMixin = function (mixin) {
  return mixin;
};

if (false) {
  var warnedForSpread = false;
  var warnedForCreateMixin = false;
  __spread = function () {
    lowPriorityWarning(warnedForSpread, 'React.__spread is deprecated and should not be used. Use ' + 'Object.assign directly or another helper function with similar ' + 'semantics. You may be seeing this warning due to your compiler. ' + 'See https://fb.me/react-spread-deprecation for more details.');
    warnedForSpread = true;
    return _assign.apply(null, arguments);
  };

  createMixin = function (mixin) {
    lowPriorityWarning(warnedForCreateMixin, 'React.createMixin is deprecated and should not be used. ' + 'In React v16.0, it will be removed. ' + 'You can use this mixin directly instead. ' + 'See https://fb.me/createmixin-was-never-implemented for more info.');
    warnedForCreateMixin = true;
    return mixin;
  };
}

var React = {
  // Modern

  Children: {
    map: ReactChildren.map,
    forEach: ReactChildren.forEach,
    count: ReactChildren.count,
    toArray: ReactChildren.toArray,
    only: onlyChild
  },

  Component: ReactBaseClasses.Component,
  PureComponent: ReactBaseClasses.PureComponent,

  createElement: createElement,
  cloneElement: cloneElement,
  isValidElement: ReactElement.isValidElement,

  // Classic

  PropTypes: ReactPropTypes,
  createClass: createReactClass,
  createFactory: createFactory,
  createMixin: createMixin,

  // This looks DOM specific but these are actually isomorphic helpers
  // since they are just generating DOM strings.
  DOM: ReactDOMFactories,

  version: ReactVersion,

  // Deprecated hook for JSX spread, don't use this for anything.
  __spread: __spread
};

if (false) {
  var warnedForCreateClass = false;
  if (canDefineProperty) {
    Object.defineProperty(React, 'PropTypes', {
      get: function () {
        lowPriorityWarning(didWarnPropTypesDeprecated, 'Accessing PropTypes via the main React package is deprecated,' + ' and will be removed in  React v16.0.' + ' Use the latest available v15.* prop-types package from npm instead.' + ' For info on usage, compatibility, migration and more, see ' + 'https://fb.me/prop-types-docs');
        didWarnPropTypesDeprecated = true;
        return ReactPropTypes;
      }
    });

    Object.defineProperty(React, 'createClass', {
      get: function () {
        lowPriorityWarning(warnedForCreateClass, 'Accessing createClass via the main React package is deprecated,' + ' and will be removed in React v16.0.' + " Use a plain JavaScript class instead. If you're not yet " + 'ready to migrate, create-react-class v15.* is available ' + 'on npm as a temporary, drop-in replacement. ' + 'For more info see https://fb.me/react-create-class');
        warnedForCreateClass = true;
        return createReactClass;
      }
    });
  }

  // React.DOM factories are deprecated. Wrap these methods so that
  // invocations of the React.DOM namespace and alert users to switch
  // to the `react-dom-factories` package.
  React.DOM = {};
  var warnedForFactories = false;
  Object.keys(ReactDOMFactories).forEach(function (factory) {
    React.DOM[factory] = function () {
      if (!warnedForFactories) {
        lowPriorityWarning(false, 'Accessing factories like React.DOM.%s has been deprecated ' + 'and will be removed in v16.0+. Use the ' + 'react-dom-factories package instead. ' + ' Version 1.0 provides a drop-in replacement.' + ' For more info, see https://fb.me/react-dom-factories', factory);
        warnedForFactories = true;
      }
      return ReactDOMFactories[factory].apply(ReactDOMFactories, arguments);
    };
  });
}

module.exports = React;

/***/ }),
/* 1170 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2014-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */



/**
 * Forked from fbjs/warning:
 * https://github.com/facebook/fbjs/blob/e66ba20ad5be433eb54423f2b097d829324d9de6/packages/fbjs/src/__forks__/warning.js
 *
 * Only change is we use console.warn instead of console.error,
 * and do nothing when 'console' is not supported.
 * This really simplifies the code.
 * ---
 * Similar to invariant but only logs a warning if the condition is not met.
 * This can be used to log issues in development environments in critical
 * paths. Removing the logging code for production environments will keep the
 * same logic and follow the same code paths.
 */

var lowPriorityWarning = function () {};

if (false) {
  var printWarning = function (format) {
    for (var _len = arguments.length, args = Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
      args[_key - 1] = arguments[_key];
    }

    var argIndex = 0;
    var message = 'Warning: ' + format.replace(/%s/g, function () {
      return args[argIndex++];
    });
    if (typeof console !== 'undefined') {
      console.warn(message);
    }
    try {
      // --- Welcome to debugging React ---
      // This error was thrown as a convenience so that you can use this stack
      // to find the callsite that caused this warning to fire.
      throw new Error(message);
    } catch (x) {}
  };

  lowPriorityWarning = function (condition, format) {
    if (format === undefined) {
      throw new Error('`warning(condition, format, ...args)` requires a warning ' + 'message argument');
    }
    if (!condition) {
      for (var _len2 = arguments.length, args = Array(_len2 > 2 ? _len2 - 2 : 0), _key2 = 2; _key2 < _len2; _key2++) {
        args[_key2 - 2] = arguments[_key2];
      }

      printWarning.apply(undefined, [format].concat(args));
    }
  };
}

module.exports = lowPriorityWarning;

/***/ }),
/* 1171 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */



var PooledClass = __webpack_require__(1172);
var ReactElement = __webpack_require__(1115);

var emptyFunction = __webpack_require__(418);
var traverseAllChildren = __webpack_require__(1173);

var twoArgumentPooler = PooledClass.twoArgumentPooler;
var fourArgumentPooler = PooledClass.fourArgumentPooler;

var userProvidedKeyEscapeRegex = /\/+/g;
function escapeUserProvidedKey(text) {
  return ('' + text).replace(userProvidedKeyEscapeRegex, '$&/');
}

/**
 * PooledClass representing the bookkeeping associated with performing a child
 * traversal. Allows avoiding binding callbacks.
 *
 * @constructor ForEachBookKeeping
 * @param {!function} forEachFunction Function to perform traversal with.
 * @param {?*} forEachContext Context to perform context with.
 */
function ForEachBookKeeping(forEachFunction, forEachContext) {
  this.func = forEachFunction;
  this.context = forEachContext;
  this.count = 0;
}
ForEachBookKeeping.prototype.destructor = function () {
  this.func = null;
  this.context = null;
  this.count = 0;
};
PooledClass.addPoolingTo(ForEachBookKeeping, twoArgumentPooler);

function forEachSingleChild(bookKeeping, child, name) {
  var func = bookKeeping.func,
      context = bookKeeping.context;

  func.call(context, child, bookKeeping.count++);
}

/**
 * Iterates through children that are typically specified as `props.children`.
 *
 * See https://facebook.github.io/react/docs/top-level-api.html#react.children.foreach
 *
 * The provided forEachFunc(child, index) will be called for each
 * leaf child.
 *
 * @param {?*} children Children tree container.
 * @param {function(*, int)} forEachFunc
 * @param {*} forEachContext Context for forEachContext.
 */
function forEachChildren(children, forEachFunc, forEachContext) {
  if (children == null) {
    return children;
  }
  var traverseContext = ForEachBookKeeping.getPooled(forEachFunc, forEachContext);
  traverseAllChildren(children, forEachSingleChild, traverseContext);
  ForEachBookKeeping.release(traverseContext);
}

/**
 * PooledClass representing the bookkeeping associated with performing a child
 * mapping. Allows avoiding binding callbacks.
 *
 * @constructor MapBookKeeping
 * @param {!*} mapResult Object containing the ordered map of results.
 * @param {!function} mapFunction Function to perform mapping with.
 * @param {?*} mapContext Context to perform mapping with.
 */
function MapBookKeeping(mapResult, keyPrefix, mapFunction, mapContext) {
  this.result = mapResult;
  this.keyPrefix = keyPrefix;
  this.func = mapFunction;
  this.context = mapContext;
  this.count = 0;
}
MapBookKeeping.prototype.destructor = function () {
  this.result = null;
  this.keyPrefix = null;
  this.func = null;
  this.context = null;
  this.count = 0;
};
PooledClass.addPoolingTo(MapBookKeeping, fourArgumentPooler);

function mapSingleChildIntoContext(bookKeeping, child, childKey) {
  var result = bookKeeping.result,
      keyPrefix = bookKeeping.keyPrefix,
      func = bookKeeping.func,
      context = bookKeeping.context;


  var mappedChild = func.call(context, child, bookKeeping.count++);
  if (Array.isArray(mappedChild)) {
    mapIntoWithKeyPrefixInternal(mappedChild, result, childKey, emptyFunction.thatReturnsArgument);
  } else if (mappedChild != null) {
    if (ReactElement.isValidElement(mappedChild)) {
      mappedChild = ReactElement.cloneAndReplaceKey(mappedChild,
      // Keep both the (mapped) and old keys if they differ, just as
      // traverseAllChildren used to do for objects as children
      keyPrefix + (mappedChild.key && (!child || child.key !== mappedChild.key) ? escapeUserProvidedKey(mappedChild.key) + '/' : '') + childKey);
    }
    result.push(mappedChild);
  }
}

function mapIntoWithKeyPrefixInternal(children, array, prefix, func, context) {
  var escapedPrefix = '';
  if (prefix != null) {
    escapedPrefix = escapeUserProvidedKey(prefix) + '/';
  }
  var traverseContext = MapBookKeeping.getPooled(array, escapedPrefix, func, context);
  traverseAllChildren(children, mapSingleChildIntoContext, traverseContext);
  MapBookKeeping.release(traverseContext);
}

/**
 * Maps children that are typically specified as `props.children`.
 *
 * See https://facebook.github.io/react/docs/top-level-api.html#react.children.map
 *
 * The provided mapFunction(child, key, index) will be called for each
 * leaf child.
 *
 * @param {?*} children Children tree container.
 * @param {function(*, int)} func The map function.
 * @param {*} context Context for mapFunction.
 * @return {object} Object containing the ordered map of results.
 */
function mapChildren(children, func, context) {
  if (children == null) {
    return children;
  }
  var result = [];
  mapIntoWithKeyPrefixInternal(children, result, null, func, context);
  return result;
}

function forEachSingleChildDummy(traverseContext, child, name) {
  return null;
}

/**
 * Count the number of children that are typically specified as
 * `props.children`.
 *
 * See https://facebook.github.io/react/docs/top-level-api.html#react.children.count
 *
 * @param {?*} children Children tree container.
 * @return {number} The number of children.
 */
function countChildren(children, context) {
  return traverseAllChildren(children, forEachSingleChildDummy, null);
}

/**
 * Flatten a children object (typically specified as `props.children`) and
 * return an array with appropriately re-keyed children.
 *
 * See https://facebook.github.io/react/docs/top-level-api.html#react.children.toarray
 */
function toArray(children) {
  var result = [];
  mapIntoWithKeyPrefixInternal(children, result, null, emptyFunction.thatReturnsArgument);
  return result;
}

var ReactChildren = {
  forEach: forEachChildren,
  map: mapChildren,
  mapIntoWithKeyPrefixInternal: mapIntoWithKeyPrefixInternal,
  count: countChildren,
  toArray: toArray
};

module.exports = ReactChildren;

/***/ }),
/* 1172 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * 
 */



var _prodInvariant = __webpack_require__(1117);

var invariant = __webpack_require__(417);

/**
 * Static poolers. Several custom versions for each potential number of
 * arguments. A completely generic pooler is easy to implement, but would
 * require accessing the `arguments` object. In each of these, `this` refers to
 * the Class itself, not an instance. If any others are needed, simply add them
 * here, or in their own files.
 */
var oneArgumentPooler = function (copyFieldsFrom) {
  var Klass = this;
  if (Klass.instancePool.length) {
    var instance = Klass.instancePool.pop();
    Klass.call(instance, copyFieldsFrom);
    return instance;
  } else {
    return new Klass(copyFieldsFrom);
  }
};

var twoArgumentPooler = function (a1, a2) {
  var Klass = this;
  if (Klass.instancePool.length) {
    var instance = Klass.instancePool.pop();
    Klass.call(instance, a1, a2);
    return instance;
  } else {
    return new Klass(a1, a2);
  }
};

var threeArgumentPooler = function (a1, a2, a3) {
  var Klass = this;
  if (Klass.instancePool.length) {
    var instance = Klass.instancePool.pop();
    Klass.call(instance, a1, a2, a3);
    return instance;
  } else {
    return new Klass(a1, a2, a3);
  }
};

var fourArgumentPooler = function (a1, a2, a3, a4) {
  var Klass = this;
  if (Klass.instancePool.length) {
    var instance = Klass.instancePool.pop();
    Klass.call(instance, a1, a2, a3, a4);
    return instance;
  } else {
    return new Klass(a1, a2, a3, a4);
  }
};

var standardReleaser = function (instance) {
  var Klass = this;
  !(instance instanceof Klass) ?  false ? invariant(false, 'Trying to release an instance into a pool of a different type.') : _prodInvariant('25') : void 0;
  instance.destructor();
  if (Klass.instancePool.length < Klass.poolSize) {
    Klass.instancePool.push(instance);
  }
};

var DEFAULT_POOL_SIZE = 10;
var DEFAULT_POOLER = oneArgumentPooler;

/**
 * Augments `CopyConstructor` to be a poolable class, augmenting only the class
 * itself (statically) not adding any prototypical fields. Any CopyConstructor
 * you give this may have a `poolSize` property, and will look for a
 * prototypical `destructor` on instances.
 *
 * @param {Function} CopyConstructor Constructor that can be used to reset.
 * @param {Function} pooler Customizable pooler.
 */
var addPoolingTo = function (CopyConstructor, pooler) {
  // Casting as any so that flow ignores the actual implementation and trusts
  // it to match the type we declared
  var NewKlass = CopyConstructor;
  NewKlass.instancePool = [];
  NewKlass.getPooled = pooler || DEFAULT_POOLER;
  if (!NewKlass.poolSize) {
    NewKlass.poolSize = DEFAULT_POOL_SIZE;
  }
  NewKlass.release = standardReleaser;
  return NewKlass;
};

var PooledClass = {
  addPoolingTo: addPoolingTo,
  oneArgumentPooler: oneArgumentPooler,
  twoArgumentPooler: twoArgumentPooler,
  threeArgumentPooler: threeArgumentPooler,
  fourArgumentPooler: fourArgumentPooler
};

module.exports = PooledClass;

/***/ }),
/* 1173 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */



var _prodInvariant = __webpack_require__(1117);

var ReactCurrentOwner = __webpack_require__(1132);
var REACT_ELEMENT_TYPE = __webpack_require__(1133);

var getIteratorFn = __webpack_require__(1174);
var invariant = __webpack_require__(417);
var KeyEscapeUtils = __webpack_require__(1175);
var warning = __webpack_require__(1118);

var SEPARATOR = '.';
var SUBSEPARATOR = ':';

/**
 * This is inlined from ReactElement since this file is shared between
 * isomorphic and renderers. We could extract this to a
 *
 */

/**
 * TODO: Test that a single child and an array with one item have the same key
 * pattern.
 */

var didWarnAboutMaps = false;

/**
 * Generate a key string that identifies a component within a set.
 *
 * @param {*} component A component that could contain a manual key.
 * @param {number} index Index that is used if a manual key is not provided.
 * @return {string}
 */
function getComponentKey(component, index) {
  // Do some typechecking here since we call this blindly. We want to ensure
  // that we don't block potential future ES APIs.
  if (component && typeof component === 'object' && component.key != null) {
    // Explicit key
    return KeyEscapeUtils.escape(component.key);
  }
  // Implicit key determined by the index in the set
  return index.toString(36);
}

/**
 * @param {?*} children Children tree container.
 * @param {!string} nameSoFar Name of the key path so far.
 * @param {!function} callback Callback to invoke with each child found.
 * @param {?*} traverseContext Used to pass information throughout the traversal
 * process.
 * @return {!number} The number of children in this subtree.
 */
function traverseAllChildrenImpl(children, nameSoFar, callback, traverseContext) {
  var type = typeof children;

  if (type === 'undefined' || type === 'boolean') {
    // All of the above are perceived as null.
    children = null;
  }

  if (children === null || type === 'string' || type === 'number' ||
  // The following is inlined from ReactElement. This means we can optimize
  // some checks. React Fiber also inlines this logic for similar purposes.
  type === 'object' && children.$$typeof === REACT_ELEMENT_TYPE) {
    callback(traverseContext, children,
    // If it's the only child, treat the name as if it was wrapped in an array
    // so that it's consistent if the number of children grows.
    nameSoFar === '' ? SEPARATOR + getComponentKey(children, 0) : nameSoFar);
    return 1;
  }

  var child;
  var nextName;
  var subtreeCount = 0; // Count of children found in the current subtree.
  var nextNamePrefix = nameSoFar === '' ? SEPARATOR : nameSoFar + SUBSEPARATOR;

  if (Array.isArray(children)) {
    for (var i = 0; i < children.length; i++) {
      child = children[i];
      nextName = nextNamePrefix + getComponentKey(child, i);
      subtreeCount += traverseAllChildrenImpl(child, nextName, callback, traverseContext);
    }
  } else {
    var iteratorFn = getIteratorFn(children);
    if (iteratorFn) {
      var iterator = iteratorFn.call(children);
      var step;
      if (iteratorFn !== children.entries) {
        var ii = 0;
        while (!(step = iterator.next()).done) {
          child = step.value;
          nextName = nextNamePrefix + getComponentKey(child, ii++);
          subtreeCount += traverseAllChildrenImpl(child, nextName, callback, traverseContext);
        }
      } else {
        if (false) {
          var mapsAsChildrenAddendum = '';
          if (ReactCurrentOwner.current) {
            var mapsAsChildrenOwnerName = ReactCurrentOwner.current.getName();
            if (mapsAsChildrenOwnerName) {
              mapsAsChildrenAddendum = ' Check the render method of `' + mapsAsChildrenOwnerName + '`.';
            }
          }
          process.env.NODE_ENV !== 'production' ? warning(didWarnAboutMaps, 'Using Maps as children is not yet fully supported. It is an ' + 'experimental feature that might be removed. Convert it to a ' + 'sequence / iterable of keyed ReactElements instead.%s', mapsAsChildrenAddendum) : void 0;
          didWarnAboutMaps = true;
        }
        // Iterator will provide entry [k,v] tuples rather than values.
        while (!(step = iterator.next()).done) {
          var entry = step.value;
          if (entry) {
            child = entry[1];
            nextName = nextNamePrefix + KeyEscapeUtils.escape(entry[0]) + SUBSEPARATOR + getComponentKey(child, 0);
            subtreeCount += traverseAllChildrenImpl(child, nextName, callback, traverseContext);
          }
        }
      }
    } else if (type === 'object') {
      var addendum = '';
      if (false) {
        addendum = ' If you meant to render a collection of children, use an array ' + 'instead or wrap the object using createFragment(object) from the ' + 'React add-ons.';
        if (children._isReactElement) {
          addendum = " It looks like you're using an element created by a different " + 'version of React. Make sure to use only one copy of React.';
        }
        if (ReactCurrentOwner.current) {
          var name = ReactCurrentOwner.current.getName();
          if (name) {
            addendum += ' Check the render method of `' + name + '`.';
          }
        }
      }
      var childrenString = String(children);
       true ?  false ? invariant(false, 'Objects are not valid as a React child (found: %s).%s', childrenString === '[object Object]' ? 'object with keys {' + Object.keys(children).join(', ') + '}' : childrenString, addendum) : _prodInvariant('31', childrenString === '[object Object]' ? 'object with keys {' + Object.keys(children).join(', ') + '}' : childrenString, addendum) : void 0;
    }
  }

  return subtreeCount;
}

/**
 * Traverses children that are typically specified as `props.children`, but
 * might also be specified through attributes:
 *
 * - `traverseAllChildren(this.props.children, ...)`
 * - `traverseAllChildren(this.props.leftPanelChildren, ...)`
 *
 * The `traverseContext` is an optional argument that is passed through the
 * entire traversal. It can be used to store accumulations or anything else that
 * the callback might find relevant.
 *
 * @param {?*} children Children tree object.
 * @param {!function} callback To invoke upon traversing each child.
 * @param {?*} traverseContext Context for traversal.
 * @return {!number} The number of children in this subtree.
 */
function traverseAllChildren(children, callback, traverseContext) {
  if (children == null) {
    return 0;
  }

  return traverseAllChildrenImpl(children, '', callback, traverseContext);
}

module.exports = traverseAllChildren;

/***/ }),
/* 1174 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * 
 */



/* global Symbol */

var ITERATOR_SYMBOL = typeof Symbol === 'function' && Symbol.iterator;
var FAUX_ITERATOR_SYMBOL = '@@iterator'; // Before Symbol spec.

/**
 * Returns the iterator method function contained on the iterable object.
 *
 * Be sure to invoke the function with the iterable as context:
 *
 *     var iteratorFn = getIteratorFn(myIterable);
 *     if (iteratorFn) {
 *       var iterator = iteratorFn.call(myIterable);
 *       ...
 *     }
 *
 * @param {?object} maybeIterable
 * @return {?function}
 */
function getIteratorFn(maybeIterable) {
  var iteratorFn = maybeIterable && (ITERATOR_SYMBOL && maybeIterable[ITERATOR_SYMBOL] || maybeIterable[FAUX_ITERATOR_SYMBOL]);
  if (typeof iteratorFn === 'function') {
    return iteratorFn;
  }
}

module.exports = getIteratorFn;

/***/ }),
/* 1175 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * 
 */



/**
 * Escape and wrap key so it is safe to use as a reactid
 *
 * @param {string} key to be escaped.
 * @return {string} the escaped key.
 */

function escape(key) {
  var escapeRegex = /[=:]/g;
  var escaperLookup = {
    '=': '=0',
    ':': '=2'
  };
  var escapedString = ('' + key).replace(escapeRegex, function (match) {
    return escaperLookup[match];
  });

  return '$' + escapedString;
}

/**
 * Unescape and unwrap key for human-readable display
 *
 * @param {string} key to unescape.
 * @return {string} the unescaped key.
 */
function unescape(key) {
  var unescapeRegex = /(=0|=2)/g;
  var unescaperLookup = {
    '=0': '=',
    '=2': ':'
  };
  var keySubstring = key[0] === '.' && key[1] === '$' ? key.substring(2) : key.substring(1);

  return ('' + keySubstring).replace(unescapeRegex, function (match) {
    return unescaperLookup[match];
  });
}

var KeyEscapeUtils = {
  escape: escape,
  unescape: unescape
};

module.exports = KeyEscapeUtils;

/***/ }),
/* 1176 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */



var ReactElement = __webpack_require__(1115);

/**
 * Create a factory that creates HTML tag elements.
 *
 * @private
 */
var createDOMFactory = ReactElement.createFactory;
if (false) {
  var ReactElementValidator = require('./ReactElementValidator');
  createDOMFactory = ReactElementValidator.createFactory;
}

/**
 * Creates a mapping from supported HTML tags to `ReactDOMComponent` classes.
 *
 * @public
 */
var ReactDOMFactories = {
  a: createDOMFactory('a'),
  abbr: createDOMFactory('abbr'),
  address: createDOMFactory('address'),
  area: createDOMFactory('area'),
  article: createDOMFactory('article'),
  aside: createDOMFactory('aside'),
  audio: createDOMFactory('audio'),
  b: createDOMFactory('b'),
  base: createDOMFactory('base'),
  bdi: createDOMFactory('bdi'),
  bdo: createDOMFactory('bdo'),
  big: createDOMFactory('big'),
  blockquote: createDOMFactory('blockquote'),
  body: createDOMFactory('body'),
  br: createDOMFactory('br'),
  button: createDOMFactory('button'),
  canvas: createDOMFactory('canvas'),
  caption: createDOMFactory('caption'),
  cite: createDOMFactory('cite'),
  code: createDOMFactory('code'),
  col: createDOMFactory('col'),
  colgroup: createDOMFactory('colgroup'),
  data: createDOMFactory('data'),
  datalist: createDOMFactory('datalist'),
  dd: createDOMFactory('dd'),
  del: createDOMFactory('del'),
  details: createDOMFactory('details'),
  dfn: createDOMFactory('dfn'),
  dialog: createDOMFactory('dialog'),
  div: createDOMFactory('div'),
  dl: createDOMFactory('dl'),
  dt: createDOMFactory('dt'),
  em: createDOMFactory('em'),
  embed: createDOMFactory('embed'),
  fieldset: createDOMFactory('fieldset'),
  figcaption: createDOMFactory('figcaption'),
  figure: createDOMFactory('figure'),
  footer: createDOMFactory('footer'),
  form: createDOMFactory('form'),
  h1: createDOMFactory('h1'),
  h2: createDOMFactory('h2'),
  h3: createDOMFactory('h3'),
  h4: createDOMFactory('h4'),
  h5: createDOMFactory('h5'),
  h6: createDOMFactory('h6'),
  head: createDOMFactory('head'),
  header: createDOMFactory('header'),
  hgroup: createDOMFactory('hgroup'),
  hr: createDOMFactory('hr'),
  html: createDOMFactory('html'),
  i: createDOMFactory('i'),
  iframe: createDOMFactory('iframe'),
  img: createDOMFactory('img'),
  input: createDOMFactory('input'),
  ins: createDOMFactory('ins'),
  kbd: createDOMFactory('kbd'),
  keygen: createDOMFactory('keygen'),
  label: createDOMFactory('label'),
  legend: createDOMFactory('legend'),
  li: createDOMFactory('li'),
  link: createDOMFactory('link'),
  main: createDOMFactory('main'),
  map: createDOMFactory('map'),
  mark: createDOMFactory('mark'),
  menu: createDOMFactory('menu'),
  menuitem: createDOMFactory('menuitem'),
  meta: createDOMFactory('meta'),
  meter: createDOMFactory('meter'),
  nav: createDOMFactory('nav'),
  noscript: createDOMFactory('noscript'),
  object: createDOMFactory('object'),
  ol: createDOMFactory('ol'),
  optgroup: createDOMFactory('optgroup'),
  option: createDOMFactory('option'),
  output: createDOMFactory('output'),
  p: createDOMFactory('p'),
  param: createDOMFactory('param'),
  picture: createDOMFactory('picture'),
  pre: createDOMFactory('pre'),
  progress: createDOMFactory('progress'),
  q: createDOMFactory('q'),
  rp: createDOMFactory('rp'),
  rt: createDOMFactory('rt'),
  ruby: createDOMFactory('ruby'),
  s: createDOMFactory('s'),
  samp: createDOMFactory('samp'),
  script: createDOMFactory('script'),
  section: createDOMFactory('section'),
  select: createDOMFactory('select'),
  small: createDOMFactory('small'),
  source: createDOMFactory('source'),
  span: createDOMFactory('span'),
  strong: createDOMFactory('strong'),
  style: createDOMFactory('style'),
  sub: createDOMFactory('sub'),
  summary: createDOMFactory('summary'),
  sup: createDOMFactory('sup'),
  table: createDOMFactory('table'),
  tbody: createDOMFactory('tbody'),
  td: createDOMFactory('td'),
  textarea: createDOMFactory('textarea'),
  tfoot: createDOMFactory('tfoot'),
  th: createDOMFactory('th'),
  thead: createDOMFactory('thead'),
  time: createDOMFactory('time'),
  title: createDOMFactory('title'),
  tr: createDOMFactory('tr'),
  track: createDOMFactory('track'),
  u: createDOMFactory('u'),
  ul: createDOMFactory('ul'),
  'var': createDOMFactory('var'),
  video: createDOMFactory('video'),
  wbr: createDOMFactory('wbr'),

  // SVG
  circle: createDOMFactory('circle'),
  clipPath: createDOMFactory('clipPath'),
  defs: createDOMFactory('defs'),
  ellipse: createDOMFactory('ellipse'),
  g: createDOMFactory('g'),
  image: createDOMFactory('image'),
  line: createDOMFactory('line'),
  linearGradient: createDOMFactory('linearGradient'),
  mask: createDOMFactory('mask'),
  path: createDOMFactory('path'),
  pattern: createDOMFactory('pattern'),
  polygon: createDOMFactory('polygon'),
  polyline: createDOMFactory('polyline'),
  radialGradient: createDOMFactory('radialGradient'),
  rect: createDOMFactory('rect'),
  stop: createDOMFactory('stop'),
  svg: createDOMFactory('svg'),
  text: createDOMFactory('text'),
  tspan: createDOMFactory('tspan')
};

module.exports = ReactDOMFactories;

/***/ }),
/* 1177 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */



var _require = __webpack_require__(1115),
    isValidElement = _require.isValidElement;

var factory = __webpack_require__(1178);

module.exports = factory(isValidElement);

/***/ }),
/* 1178 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 */



// React 15.5 references this module, and assumes PropTypes are still callable in production.
// Therefore we re-export development-only version with all the PropTypes checks here.
// However if one is migrating to the `prop-types` npm library, they will go through the
// `index.js` entry point, and it will branch depending on the environment.
var factory = __webpack_require__(1179);
module.exports = function(isValidElement) {
  // It is still allowed in 15.5.
  var throwOnDirectAccess = false;
  return factory(isValidElement, throwOnDirectAccess);
};


/***/ }),
/* 1179 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 */



var emptyFunction = __webpack_require__(418);
var invariant = __webpack_require__(417);
var warning = __webpack_require__(1118);

var ReactPropTypesSecret = __webpack_require__(1134);
var checkPropTypes = __webpack_require__(1180);

module.exports = function(isValidElement, throwOnDirectAccess) {
  /* global Symbol */
  var ITERATOR_SYMBOL = typeof Symbol === 'function' && Symbol.iterator;
  var FAUX_ITERATOR_SYMBOL = '@@iterator'; // Before Symbol spec.

  /**
   * Returns the iterator method function contained on the iterable object.
   *
   * Be sure to invoke the function with the iterable as context:
   *
   *     var iteratorFn = getIteratorFn(myIterable);
   *     if (iteratorFn) {
   *       var iterator = iteratorFn.call(myIterable);
   *       ...
   *     }
   *
   * @param {?object} maybeIterable
   * @return {?function}
   */
  function getIteratorFn(maybeIterable) {
    var iteratorFn = maybeIterable && (ITERATOR_SYMBOL && maybeIterable[ITERATOR_SYMBOL] || maybeIterable[FAUX_ITERATOR_SYMBOL]);
    if (typeof iteratorFn === 'function') {
      return iteratorFn;
    }
  }

  /**
   * Collection of methods that allow declaration and validation of props that are
   * supplied to React components. Example usage:
   *
   *   var Props = require('ReactPropTypes');
   *   var MyArticle = React.createClass({
   *     propTypes: {
   *       // An optional string prop named "description".
   *       description: Props.string,
   *
   *       // A required enum prop named "category".
   *       category: Props.oneOf(['News','Photos']).isRequired,
   *
   *       // A prop named "dialog" that requires an instance of Dialog.
   *       dialog: Props.instanceOf(Dialog).isRequired
   *     },
   *     render: function() { ... }
   *   });
   *
   * A more formal specification of how these methods are used:
   *
   *   type := array|bool|func|object|number|string|oneOf([...])|instanceOf(...)
   *   decl := ReactPropTypes.{type}(.isRequired)?
   *
   * Each and every declaration produces a function with the same signature. This
   * allows the creation of custom validation functions. For example:
   *
   *  var MyLink = React.createClass({
   *    propTypes: {
   *      // An optional string or URI prop named "href".
   *      href: function(props, propName, componentName) {
   *        var propValue = props[propName];
   *        if (propValue != null && typeof propValue !== 'string' &&
   *            !(propValue instanceof URI)) {
   *          return new Error(
   *            'Expected a string or an URI for ' + propName + ' in ' +
   *            componentName
   *          );
   *        }
   *      }
   *    },
   *    render: function() {...}
   *  });
   *
   * @internal
   */

  var ANONYMOUS = '<<anonymous>>';

  // Important!
  // Keep this list in sync with production version in `./factoryWithThrowingShims.js`.
  var ReactPropTypes = {
    array: createPrimitiveTypeChecker('array'),
    bool: createPrimitiveTypeChecker('boolean'),
    func: createPrimitiveTypeChecker('function'),
    number: createPrimitiveTypeChecker('number'),
    object: createPrimitiveTypeChecker('object'),
    string: createPrimitiveTypeChecker('string'),
    symbol: createPrimitiveTypeChecker('symbol'),

    any: createAnyTypeChecker(),
    arrayOf: createArrayOfTypeChecker,
    element: createElementTypeChecker(),
    instanceOf: createInstanceTypeChecker,
    node: createNodeChecker(),
    objectOf: createObjectOfTypeChecker,
    oneOf: createEnumTypeChecker,
    oneOfType: createUnionTypeChecker,
    shape: createShapeTypeChecker
  };

  /**
   * inlined Object.is polyfill to avoid requiring consumers ship their own
   * https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Object/is
   */
  /*eslint-disable no-self-compare*/
  function is(x, y) {
    // SameValue algorithm
    if (x === y) {
      // Steps 1-5, 7-10
      // Steps 6.b-6.e: +0 != -0
      return x !== 0 || 1 / x === 1 / y;
    } else {
      // Step 6.a: NaN == NaN
      return x !== x && y !== y;
    }
  }
  /*eslint-enable no-self-compare*/

  /**
   * We use an Error-like object for backward compatibility as people may call
   * PropTypes directly and inspect their output. However, we don't use real
   * Errors anymore. We don't inspect their stack anyway, and creating them
   * is prohibitively expensive if they are created too often, such as what
   * happens in oneOfType() for any type before the one that matched.
   */
  function PropTypeError(message) {
    this.message = message;
    this.stack = '';
  }
  // Make `instanceof Error` still work for returned errors.
  PropTypeError.prototype = Error.prototype;

  function createChainableTypeChecker(validate) {
    if (false) {
      var manualPropTypeCallCache = {};
      var manualPropTypeWarningCount = 0;
    }
    function checkType(isRequired, props, propName, componentName, location, propFullName, secret) {
      componentName = componentName || ANONYMOUS;
      propFullName = propFullName || propName;

      if (secret !== ReactPropTypesSecret) {
        if (throwOnDirectAccess) {
          // New behavior only for users of `prop-types` package
          invariant(
            false,
            'Calling PropTypes validators directly is not supported by the `prop-types` package. ' +
            'Use `PropTypes.checkPropTypes()` to call them. ' +
            'Read more at http://fb.me/use-check-prop-types'
          );
        } else if (false) {
          // Old behavior for people using React.PropTypes
          var cacheKey = componentName + ':' + propName;
          if (
            !manualPropTypeCallCache[cacheKey] &&
            // Avoid spamming the console because they are often not actionable except for lib authors
            manualPropTypeWarningCount < 3
          ) {
            warning(
              false,
              'You are manually calling a React.PropTypes validation ' +
              'function for the `%s` prop on `%s`. This is deprecated ' +
              'and will throw in the standalone `prop-types` package. ' +
              'You may be seeing this warning due to a third-party PropTypes ' +
              'library. See https://fb.me/react-warning-dont-call-proptypes ' + 'for details.',
              propFullName,
              componentName
            );
            manualPropTypeCallCache[cacheKey] = true;
            manualPropTypeWarningCount++;
          }
        }
      }
      if (props[propName] == null) {
        if (isRequired) {
          if (props[propName] === null) {
            return new PropTypeError('The ' + location + ' `' + propFullName + '` is marked as required ' + ('in `' + componentName + '`, but its value is `null`.'));
          }
          return new PropTypeError('The ' + location + ' `' + propFullName + '` is marked as required in ' + ('`' + componentName + '`, but its value is `undefined`.'));
        }
        return null;
      } else {
        return validate(props, propName, componentName, location, propFullName);
      }
    }

    var chainedCheckType = checkType.bind(null, false);
    chainedCheckType.isRequired = checkType.bind(null, true);

    return chainedCheckType;
  }

  function createPrimitiveTypeChecker(expectedType) {
    function validate(props, propName, componentName, location, propFullName, secret) {
      var propValue = props[propName];
      var propType = getPropType(propValue);
      if (propType !== expectedType) {
        // `propValue` being instance of, say, date/regexp, pass the 'object'
        // check, but we can offer a more precise error message here rather than
        // 'of type `object`'.
        var preciseType = getPreciseType(propValue);

        return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of type ' + ('`' + preciseType + '` supplied to `' + componentName + '`, expected ') + ('`' + expectedType + '`.'));
      }
      return null;
    }
    return createChainableTypeChecker(validate);
  }

  function createAnyTypeChecker() {
    return createChainableTypeChecker(emptyFunction.thatReturnsNull);
  }

  function createArrayOfTypeChecker(typeChecker) {
    function validate(props, propName, componentName, location, propFullName) {
      if (typeof typeChecker !== 'function') {
        return new PropTypeError('Property `' + propFullName + '` of component `' + componentName + '` has invalid PropType notation inside arrayOf.');
      }
      var propValue = props[propName];
      if (!Array.isArray(propValue)) {
        var propType = getPropType(propValue);
        return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of type ' + ('`' + propType + '` supplied to `' + componentName + '`, expected an array.'));
      }
      for (var i = 0; i < propValue.length; i++) {
        var error = typeChecker(propValue, i, componentName, location, propFullName + '[' + i + ']', ReactPropTypesSecret);
        if (error instanceof Error) {
          return error;
        }
      }
      return null;
    }
    return createChainableTypeChecker(validate);
  }

  function createElementTypeChecker() {
    function validate(props, propName, componentName, location, propFullName) {
      var propValue = props[propName];
      if (!isValidElement(propValue)) {
        var propType = getPropType(propValue);
        return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of type ' + ('`' + propType + '` supplied to `' + componentName + '`, expected a single ReactElement.'));
      }
      return null;
    }
    return createChainableTypeChecker(validate);
  }

  function createInstanceTypeChecker(expectedClass) {
    function validate(props, propName, componentName, location, propFullName) {
      if (!(props[propName] instanceof expectedClass)) {
        var expectedClassName = expectedClass.name || ANONYMOUS;
        var actualClassName = getClassName(props[propName]);
        return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of type ' + ('`' + actualClassName + '` supplied to `' + componentName + '`, expected ') + ('instance of `' + expectedClassName + '`.'));
      }
      return null;
    }
    return createChainableTypeChecker(validate);
  }

  function createEnumTypeChecker(expectedValues) {
    if (!Array.isArray(expectedValues)) {
       false ? warning(false, 'Invalid argument supplied to oneOf, expected an instance of array.') : void 0;
      return emptyFunction.thatReturnsNull;
    }

    function validate(props, propName, componentName, location, propFullName) {
      var propValue = props[propName];
      for (var i = 0; i < expectedValues.length; i++) {
        if (is(propValue, expectedValues[i])) {
          return null;
        }
      }

      var valuesString = JSON.stringify(expectedValues);
      return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of value `' + propValue + '` ' + ('supplied to `' + componentName + '`, expected one of ' + valuesString + '.'));
    }
    return createChainableTypeChecker(validate);
  }

  function createObjectOfTypeChecker(typeChecker) {
    function validate(props, propName, componentName, location, propFullName) {
      if (typeof typeChecker !== 'function') {
        return new PropTypeError('Property `' + propFullName + '` of component `' + componentName + '` has invalid PropType notation inside objectOf.');
      }
      var propValue = props[propName];
      var propType = getPropType(propValue);
      if (propType !== 'object') {
        return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of type ' + ('`' + propType + '` supplied to `' + componentName + '`, expected an object.'));
      }
      for (var key in propValue) {
        if (propValue.hasOwnProperty(key)) {
          var error = typeChecker(propValue, key, componentName, location, propFullName + '.' + key, ReactPropTypesSecret);
          if (error instanceof Error) {
            return error;
          }
        }
      }
      return null;
    }
    return createChainableTypeChecker(validate);
  }

  function createUnionTypeChecker(arrayOfTypeCheckers) {
    if (!Array.isArray(arrayOfTypeCheckers)) {
       false ? warning(false, 'Invalid argument supplied to oneOfType, expected an instance of array.') : void 0;
      return emptyFunction.thatReturnsNull;
    }

    for (var i = 0; i < arrayOfTypeCheckers.length; i++) {
      var checker = arrayOfTypeCheckers[i];
      if (typeof checker !== 'function') {
        warning(
          false,
          'Invalid argument supplid to oneOfType. Expected an array of check functions, but ' +
          'received %s at index %s.',
          getPostfixForTypeWarning(checker),
          i
        );
        return emptyFunction.thatReturnsNull;
      }
    }

    function validate(props, propName, componentName, location, propFullName) {
      for (var i = 0; i < arrayOfTypeCheckers.length; i++) {
        var checker = arrayOfTypeCheckers[i];
        if (checker(props, propName, componentName, location, propFullName, ReactPropTypesSecret) == null) {
          return null;
        }
      }

      return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` supplied to ' + ('`' + componentName + '`.'));
    }
    return createChainableTypeChecker(validate);
  }

  function createNodeChecker() {
    function validate(props, propName, componentName, location, propFullName) {
      if (!isNode(props[propName])) {
        return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` supplied to ' + ('`' + componentName + '`, expected a ReactNode.'));
      }
      return null;
    }
    return createChainableTypeChecker(validate);
  }

  function createShapeTypeChecker(shapeTypes) {
    function validate(props, propName, componentName, location, propFullName) {
      var propValue = props[propName];
      var propType = getPropType(propValue);
      if (propType !== 'object') {
        return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of type `' + propType + '` ' + ('supplied to `' + componentName + '`, expected `object`.'));
      }
      for (var key in shapeTypes) {
        var checker = shapeTypes[key];
        if (!checker) {
          continue;
        }
        var error = checker(propValue, key, componentName, location, propFullName + '.' + key, ReactPropTypesSecret);
        if (error) {
          return error;
        }
      }
      return null;
    }
    return createChainableTypeChecker(validate);
  }

  function isNode(propValue) {
    switch (typeof propValue) {
      case 'number':
      case 'string':
      case 'undefined':
        return true;
      case 'boolean':
        return !propValue;
      case 'object':
        if (Array.isArray(propValue)) {
          return propValue.every(isNode);
        }
        if (propValue === null || isValidElement(propValue)) {
          return true;
        }

        var iteratorFn = getIteratorFn(propValue);
        if (iteratorFn) {
          var iterator = iteratorFn.call(propValue);
          var step;
          if (iteratorFn !== propValue.entries) {
            while (!(step = iterator.next()).done) {
              if (!isNode(step.value)) {
                return false;
              }
            }
          } else {
            // Iterator will provide entry [k,v] tuples rather than values.
            while (!(step = iterator.next()).done) {
              var entry = step.value;
              if (entry) {
                if (!isNode(entry[1])) {
                  return false;
                }
              }
            }
          }
        } else {
          return false;
        }

        return true;
      default:
        return false;
    }
  }

  function isSymbol(propType, propValue) {
    // Native Symbol.
    if (propType === 'symbol') {
      return true;
    }

    // 19.4.3.5 Symbol.prototype[@@toStringTag] === 'Symbol'
    if (propValue['@@toStringTag'] === 'Symbol') {
      return true;
    }

    // Fallback for non-spec compliant Symbols which are polyfilled.
    if (typeof Symbol === 'function' && propValue instanceof Symbol) {
      return true;
    }

    return false;
  }

  // Equivalent of `typeof` but with special handling for array and regexp.
  function getPropType(propValue) {
    var propType = typeof propValue;
    if (Array.isArray(propValue)) {
      return 'array';
    }
    if (propValue instanceof RegExp) {
      // Old webkits (at least until Android 4.0) return 'function' rather than
      // 'object' for typeof a RegExp. We'll normalize this here so that /bla/
      // passes PropTypes.object.
      return 'object';
    }
    if (isSymbol(propType, propValue)) {
      return 'symbol';
    }
    return propType;
  }

  // This handles more types than `getPropType`. Only used for error messages.
  // See `createPrimitiveTypeChecker`.
  function getPreciseType(propValue) {
    if (typeof propValue === 'undefined' || propValue === null) {
      return '' + propValue;
    }
    var propType = getPropType(propValue);
    if (propType === 'object') {
      if (propValue instanceof Date) {
        return 'date';
      } else if (propValue instanceof RegExp) {
        return 'regexp';
      }
    }
    return propType;
  }

  // Returns a string that is postfixed to a warning about an invalid type.
  // For example, "undefined" or "of type array"
  function getPostfixForTypeWarning(value) {
    var type = getPreciseType(value);
    switch (type) {
      case 'array':
      case 'object':
        return 'an ' + type;
      case 'boolean':
      case 'date':
      case 'regexp':
        return 'a ' + type;
      default:
        return type;
    }
  }

  // Returns class name of the object, if any.
  function getClassName(propValue) {
    if (!propValue.constructor || !propValue.constructor.name) {
      return ANONYMOUS;
    }
    return propValue.constructor.name;
  }

  ReactPropTypes.checkPropTypes = checkPropTypes;
  ReactPropTypes.PropTypes = ReactPropTypes;

  return ReactPropTypes;
};


/***/ }),
/* 1180 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 */



if (false) {
  var invariant = require('fbjs/lib/invariant');
  var warning = require('fbjs/lib/warning');
  var ReactPropTypesSecret = require('./lib/ReactPropTypesSecret');
  var loggedTypeFailures = {};
}

/**
 * Assert that the values match with the type specs.
 * Error messages are memorized and will only be shown once.
 *
 * @param {object} typeSpecs Map of name to a ReactPropType
 * @param {object} values Runtime values that need to be type-checked
 * @param {string} location e.g. "prop", "context", "child context"
 * @param {string} componentName Name of the component for error messages.
 * @param {?Function} getStack Returns the component stack.
 * @private
 */
function checkPropTypes(typeSpecs, values, location, componentName, getStack) {
  if (false) {
    for (var typeSpecName in typeSpecs) {
      if (typeSpecs.hasOwnProperty(typeSpecName)) {
        var error;
        // Prop type validation may throw. In case they do, we don't want to
        // fail the render phase where it didn't fail before. So we log it.
        // After these have been cleaned up, we'll let them throw.
        try {
          // This is intentionally an invariant that gets caught. It's the same
          // behavior as without this statement except with a better message.
          invariant(typeof typeSpecs[typeSpecName] === 'function', '%s: %s type `%s` is invalid; it must be a function, usually from ' + 'React.PropTypes.', componentName || 'React class', location, typeSpecName);
          error = typeSpecs[typeSpecName](values, typeSpecName, componentName, location, null, ReactPropTypesSecret);
        } catch (ex) {
          error = ex;
        }
        warning(!error || error instanceof Error, '%s: type specification of %s `%s` is invalid; the type checker ' + 'function must return `null` or an `Error` but returned a %s. ' + 'You may have forgotten to pass an argument to the type checker ' + 'creator (arrayOf, instanceOf, objectOf, oneOf, oneOfType, and ' + 'shape all require an argument).', componentName || 'React class', location, typeSpecName, typeof error);
        if (error instanceof Error && !(error.message in loggedTypeFailures)) {
          // Only monitor this failure once because there tends to be a lot of the
          // same error.
          loggedTypeFailures[error.message] = true;

          var stack = getStack ? getStack() : '';

          warning(false, 'Failed %s type: %s%s', location, error.message, stack != null ? stack : '');
        }
      }
    }
  }
}

module.exports = checkPropTypes;


/***/ }),
/* 1181 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */



module.exports = '15.6.2';

/***/ }),
/* 1182 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */



var _require = __webpack_require__(1128),
    Component = _require.Component;

var _require2 = __webpack_require__(1115),
    isValidElement = _require2.isValidElement;

var ReactNoopUpdateQueue = __webpack_require__(1129);
var factory = __webpack_require__(1183);

module.exports = factory(Component, isValidElement, ReactNoopUpdateQueue);

/***/ }),
/* 1183 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */



var _assign = __webpack_require__(131);

var emptyObject = __webpack_require__(1131);
var _invariant = __webpack_require__(417);

if (false) {
  var warning = require('fbjs/lib/warning');
}

var MIXINS_KEY = 'mixins';

// Helper function to allow the creation of anonymous functions which do not
// have .name set to the name of the variable being assigned to.
function identity(fn) {
  return fn;
}

var ReactPropTypeLocationNames;
if (false) {
  ReactPropTypeLocationNames = {
    prop: 'prop',
    context: 'context',
    childContext: 'child context'
  };
} else {
  ReactPropTypeLocationNames = {};
}

function factory(ReactComponent, isValidElement, ReactNoopUpdateQueue) {
  /**
   * Policies that describe methods in `ReactClassInterface`.
   */

  var injectedMixins = [];

  /**
   * Composite components are higher-level components that compose other composite
   * or host components.
   *
   * To create a new type of `ReactClass`, pass a specification of
   * your new class to `React.createClass`. The only requirement of your class
   * specification is that you implement a `render` method.
   *
   *   var MyComponent = React.createClass({
   *     render: function() {
   *       return <div>Hello World</div>;
   *     }
   *   });
   *
   * The class specification supports a specific protocol of methods that have
   * special meaning (e.g. `render`). See `ReactClassInterface` for
   * more the comprehensive protocol. Any other properties and methods in the
   * class specification will be available on the prototype.
   *
   * @interface ReactClassInterface
   * @internal
   */
  var ReactClassInterface = {
    /**
     * An array of Mixin objects to include when defining your component.
     *
     * @type {array}
     * @optional
     */
    mixins: 'DEFINE_MANY',

    /**
     * An object containing properties and methods that should be defined on
     * the component's constructor instead of its prototype (static methods).
     *
     * @type {object}
     * @optional
     */
    statics: 'DEFINE_MANY',

    /**
     * Definition of prop types for this component.
     *
     * @type {object}
     * @optional
     */
    propTypes: 'DEFINE_MANY',

    /**
     * Definition of context types for this component.
     *
     * @type {object}
     * @optional
     */
    contextTypes: 'DEFINE_MANY',

    /**
     * Definition of context types this component sets for its children.
     *
     * @type {object}
     * @optional
     */
    childContextTypes: 'DEFINE_MANY',

    // ==== Definition methods ====

    /**
     * Invoked when the component is mounted. Values in the mapping will be set on
     * `this.props` if that prop is not specified (i.e. using an `in` check).
     *
     * This method is invoked before `getInitialState` and therefore cannot rely
     * on `this.state` or use `this.setState`.
     *
     * @return {object}
     * @optional
     */
    getDefaultProps: 'DEFINE_MANY_MERGED',

    /**
     * Invoked once before the component is mounted. The return value will be used
     * as the initial value of `this.state`.
     *
     *   getInitialState: function() {
     *     return {
     *       isOn: false,
     *       fooBaz: new BazFoo()
     *     }
     *   }
     *
     * @return {object}
     * @optional
     */
    getInitialState: 'DEFINE_MANY_MERGED',

    /**
     * @return {object}
     * @optional
     */
    getChildContext: 'DEFINE_MANY_MERGED',

    /**
     * Uses props from `this.props` and state from `this.state` to render the
     * structure of the component.
     *
     * No guarantees are made about when or how often this method is invoked, so
     * it must not have side effects.
     *
     *   render: function() {
     *     var name = this.props.name;
     *     return <div>Hello, {name}!</div>;
     *   }
     *
     * @return {ReactComponent}
     * @required
     */
    render: 'DEFINE_ONCE',

    // ==== Delegate methods ====

    /**
     * Invoked when the component is initially created and about to be mounted.
     * This may have side effects, but any external subscriptions or data created
     * by this method must be cleaned up in `componentWillUnmount`.
     *
     * @optional
     */
    componentWillMount: 'DEFINE_MANY',

    /**
     * Invoked when the component has been mounted and has a DOM representation.
     * However, there is no guarantee that the DOM node is in the document.
     *
     * Use this as an opportunity to operate on the DOM when the component has
     * been mounted (initialized and rendered) for the first time.
     *
     * @param {DOMElement} rootNode DOM element representing the component.
     * @optional
     */
    componentDidMount: 'DEFINE_MANY',

    /**
     * Invoked before the component receives new props.
     *
     * Use this as an opportunity to react to a prop transition by updating the
     * state using `this.setState`. Current props are accessed via `this.props`.
     *
     *   componentWillReceiveProps: function(nextProps, nextContext) {
     *     this.setState({
     *       likesIncreasing: nextProps.likeCount > this.props.likeCount
     *     });
     *   }
     *
     * NOTE: There is no equivalent `componentWillReceiveState`. An incoming prop
     * transition may cause a state change, but the opposite is not true. If you
     * need it, you are probably looking for `componentWillUpdate`.
     *
     * @param {object} nextProps
     * @optional
     */
    componentWillReceiveProps: 'DEFINE_MANY',

    /**
     * Invoked while deciding if the component should be updated as a result of
     * receiving new props, state and/or context.
     *
     * Use this as an opportunity to `return false` when you're certain that the
     * transition to the new props/state/context will not require a component
     * update.
     *
     *   shouldComponentUpdate: function(nextProps, nextState, nextContext) {
     *     return !equal(nextProps, this.props) ||
     *       !equal(nextState, this.state) ||
     *       !equal(nextContext, this.context);
     *   }
     *
     * @param {object} nextProps
     * @param {?object} nextState
     * @param {?object} nextContext
     * @return {boolean} True if the component should update.
     * @optional
     */
    shouldComponentUpdate: 'DEFINE_ONCE',

    /**
     * Invoked when the component is about to update due to a transition from
     * `this.props`, `this.state` and `this.context` to `nextProps`, `nextState`
     * and `nextContext`.
     *
     * Use this as an opportunity to perform preparation before an update occurs.
     *
     * NOTE: You **cannot** use `this.setState()` in this method.
     *
     * @param {object} nextProps
     * @param {?object} nextState
     * @param {?object} nextContext
     * @param {ReactReconcileTransaction} transaction
     * @optional
     */
    componentWillUpdate: 'DEFINE_MANY',

    /**
     * Invoked when the component's DOM representation has been updated.
     *
     * Use this as an opportunity to operate on the DOM when the component has
     * been updated.
     *
     * @param {object} prevProps
     * @param {?object} prevState
     * @param {?object} prevContext
     * @param {DOMElement} rootNode DOM element representing the component.
     * @optional
     */
    componentDidUpdate: 'DEFINE_MANY',

    /**
     * Invoked when the component is about to be removed from its parent and have
     * its DOM representation destroyed.
     *
     * Use this as an opportunity to deallocate any external resources.
     *
     * NOTE: There is no `componentDidUnmount` since your component will have been
     * destroyed by that point.
     *
     * @optional
     */
    componentWillUnmount: 'DEFINE_MANY',

    // ==== Advanced methods ====

    /**
     * Updates the component's currently mounted DOM representation.
     *
     * By default, this implements React's rendering and reconciliation algorithm.
     * Sophisticated clients may wish to override this.
     *
     * @param {ReactReconcileTransaction} transaction
     * @internal
     * @overridable
     */
    updateComponent: 'OVERRIDE_BASE'
  };

  /**
   * Mapping from class specification keys to special processing functions.
   *
   * Although these are declared like instance properties in the specification
   * when defining classes using `React.createClass`, they are actually static
   * and are accessible on the constructor instead of the prototype. Despite
   * being static, they must be defined outside of the "statics" key under
   * which all other static methods are defined.
   */
  var RESERVED_SPEC_KEYS = {
    displayName: function(Constructor, displayName) {
      Constructor.displayName = displayName;
    },
    mixins: function(Constructor, mixins) {
      if (mixins) {
        for (var i = 0; i < mixins.length; i++) {
          mixSpecIntoComponent(Constructor, mixins[i]);
        }
      }
    },
    childContextTypes: function(Constructor, childContextTypes) {
      if (false) {
        validateTypeDef(Constructor, childContextTypes, 'childContext');
      }
      Constructor.childContextTypes = _assign(
        {},
        Constructor.childContextTypes,
        childContextTypes
      );
    },
    contextTypes: function(Constructor, contextTypes) {
      if (false) {
        validateTypeDef(Constructor, contextTypes, 'context');
      }
      Constructor.contextTypes = _assign(
        {},
        Constructor.contextTypes,
        contextTypes
      );
    },
    /**
     * Special case getDefaultProps which should move into statics but requires
     * automatic merging.
     */
    getDefaultProps: function(Constructor, getDefaultProps) {
      if (Constructor.getDefaultProps) {
        Constructor.getDefaultProps = createMergedResultFunction(
          Constructor.getDefaultProps,
          getDefaultProps
        );
      } else {
        Constructor.getDefaultProps = getDefaultProps;
      }
    },
    propTypes: function(Constructor, propTypes) {
      if (false) {
        validateTypeDef(Constructor, propTypes, 'prop');
      }
      Constructor.propTypes = _assign({}, Constructor.propTypes, propTypes);
    },
    statics: function(Constructor, statics) {
      mixStaticSpecIntoComponent(Constructor, statics);
    },
    autobind: function() {}
  };

  function validateTypeDef(Constructor, typeDef, location) {
    for (var propName in typeDef) {
      if (typeDef.hasOwnProperty(propName)) {
        // use a warning instead of an _invariant so components
        // don't show up in prod but only in __DEV__
        if (false) {
          warning(
            typeof typeDef[propName] === 'function',
            '%s: %s type `%s` is invalid; it must be a function, usually from ' +
              'React.PropTypes.',
            Constructor.displayName || 'ReactClass',
            ReactPropTypeLocationNames[location],
            propName
          );
        }
      }
    }
  }

  function validateMethodOverride(isAlreadyDefined, name) {
    var specPolicy = ReactClassInterface.hasOwnProperty(name)
      ? ReactClassInterface[name]
      : null;

    // Disallow overriding of base class methods unless explicitly allowed.
    if (ReactClassMixin.hasOwnProperty(name)) {
      _invariant(
        specPolicy === 'OVERRIDE_BASE',
        'ReactClassInterface: You are attempting to override ' +
          '`%s` from your class specification. Ensure that your method names ' +
          'do not overlap with React methods.',
        name
      );
    }

    // Disallow defining methods more than once unless explicitly allowed.
    if (isAlreadyDefined) {
      _invariant(
        specPolicy === 'DEFINE_MANY' || specPolicy === 'DEFINE_MANY_MERGED',
        'ReactClassInterface: You are attempting to define ' +
          '`%s` on your component more than once. This conflict may be due ' +
          'to a mixin.',
        name
      );
    }
  }

  /**
   * Mixin helper which handles policy validation and reserved
   * specification keys when building React classes.
   */
  function mixSpecIntoComponent(Constructor, spec) {
    if (!spec) {
      if (false) {
        var typeofSpec = typeof spec;
        var isMixinValid = typeofSpec === 'object' && spec !== null;

        if (process.env.NODE_ENV !== 'production') {
          warning(
            isMixinValid,
            "%s: You're attempting to include a mixin that is either null " +
              'or not an object. Check the mixins included by the component, ' +
              'as well as any mixins they include themselves. ' +
              'Expected object but got %s.',
            Constructor.displayName || 'ReactClass',
            spec === null ? null : typeofSpec
          );
        }
      }

      return;
    }

    _invariant(
      typeof spec !== 'function',
      "ReactClass: You're attempting to " +
        'use a component class or function as a mixin. Instead, just use a ' +
        'regular object.'
    );
    _invariant(
      !isValidElement(spec),
      "ReactClass: You're attempting to " +
        'use a component as a mixin. Instead, just use a regular object.'
    );

    var proto = Constructor.prototype;
    var autoBindPairs = proto.__reactAutoBindPairs;

    // By handling mixins before any other properties, we ensure the same
    // chaining order is applied to methods with DEFINE_MANY policy, whether
    // mixins are listed before or after these methods in the spec.
    if (spec.hasOwnProperty(MIXINS_KEY)) {
      RESERVED_SPEC_KEYS.mixins(Constructor, spec.mixins);
    }

    for (var name in spec) {
      if (!spec.hasOwnProperty(name)) {
        continue;
      }

      if (name === MIXINS_KEY) {
        // We have already handled mixins in a special case above.
        continue;
      }

      var property = spec[name];
      var isAlreadyDefined = proto.hasOwnProperty(name);
      validateMethodOverride(isAlreadyDefined, name);

      if (RESERVED_SPEC_KEYS.hasOwnProperty(name)) {
        RESERVED_SPEC_KEYS[name](Constructor, property);
      } else {
        // Setup methods on prototype:
        // The following member methods should not be automatically bound:
        // 1. Expected ReactClass methods (in the "interface").
        // 2. Overridden methods (that were mixed in).
        var isReactClassMethod = ReactClassInterface.hasOwnProperty(name);
        var isFunction = typeof property === 'function';
        var shouldAutoBind =
          isFunction &&
          !isReactClassMethod &&
          !isAlreadyDefined &&
          spec.autobind !== false;

        if (shouldAutoBind) {
          autoBindPairs.push(name, property);
          proto[name] = property;
        } else {
          if (isAlreadyDefined) {
            var specPolicy = ReactClassInterface[name];

            // These cases should already be caught by validateMethodOverride.
            _invariant(
              isReactClassMethod &&
                (specPolicy === 'DEFINE_MANY_MERGED' ||
                  specPolicy === 'DEFINE_MANY'),
              'ReactClass: Unexpected spec policy %s for key %s ' +
                'when mixing in component specs.',
              specPolicy,
              name
            );

            // For methods which are defined more than once, call the existing
            // methods before calling the new property, merging if appropriate.
            if (specPolicy === 'DEFINE_MANY_MERGED') {
              proto[name] = createMergedResultFunction(proto[name], property);
            } else if (specPolicy === 'DEFINE_MANY') {
              proto[name] = createChainedFunction(proto[name], property);
            }
          } else {
            proto[name] = property;
            if (false) {
              // Add verbose displayName to the function, which helps when looking
              // at profiling tools.
              if (typeof property === 'function' && spec.displayName) {
                proto[name].displayName = spec.displayName + '_' + name;
              }
            }
          }
        }
      }
    }
  }

  function mixStaticSpecIntoComponent(Constructor, statics) {
    if (!statics) {
      return;
    }
    for (var name in statics) {
      var property = statics[name];
      if (!statics.hasOwnProperty(name)) {
        continue;
      }

      var isReserved = name in RESERVED_SPEC_KEYS;
      _invariant(
        !isReserved,
        'ReactClass: You are attempting to define a reserved ' +
          'property, `%s`, that shouldn\'t be on the "statics" key. Define it ' +
          'as an instance property instead; it will still be accessible on the ' +
          'constructor.',
        name
      );

      var isInherited = name in Constructor;
      _invariant(
        !isInherited,
        'ReactClass: You are attempting to define ' +
          '`%s` on your component more than once. This conflict may be ' +
          'due to a mixin.',
        name
      );
      Constructor[name] = property;
    }
  }

  /**
   * Merge two objects, but throw if both contain the same key.
   *
   * @param {object} one The first object, which is mutated.
   * @param {object} two The second object
   * @return {object} one after it has been mutated to contain everything in two.
   */
  function mergeIntoWithNoDuplicateKeys(one, two) {
    _invariant(
      one && two && typeof one === 'object' && typeof two === 'object',
      'mergeIntoWithNoDuplicateKeys(): Cannot merge non-objects.'
    );

    for (var key in two) {
      if (two.hasOwnProperty(key)) {
        _invariant(
          one[key] === undefined,
          'mergeIntoWithNoDuplicateKeys(): ' +
            'Tried to merge two objects with the same key: `%s`. This conflict ' +
            'may be due to a mixin; in particular, this may be caused by two ' +
            'getInitialState() or getDefaultProps() methods returning objects ' +
            'with clashing keys.',
          key
        );
        one[key] = two[key];
      }
    }
    return one;
  }

  /**
   * Creates a function that invokes two functions and merges their return values.
   *
   * @param {function} one Function to invoke first.
   * @param {function} two Function to invoke second.
   * @return {function} Function that invokes the two argument functions.
   * @private
   */
  function createMergedResultFunction(one, two) {
    return function mergedResult() {
      var a = one.apply(this, arguments);
      var b = two.apply(this, arguments);
      if (a == null) {
        return b;
      } else if (b == null) {
        return a;
      }
      var c = {};
      mergeIntoWithNoDuplicateKeys(c, a);
      mergeIntoWithNoDuplicateKeys(c, b);
      return c;
    };
  }

  /**
   * Creates a function that invokes two functions and ignores their return vales.
   *
   * @param {function} one Function to invoke first.
   * @param {function} two Function to invoke second.
   * @return {function} Function that invokes the two argument functions.
   * @private
   */
  function createChainedFunction(one, two) {
    return function chainedFunction() {
      one.apply(this, arguments);
      two.apply(this, arguments);
    };
  }

  /**
   * Binds a method to the component.
   *
   * @param {object} component Component whose method is going to be bound.
   * @param {function} method Method to be bound.
   * @return {function} The bound method.
   */
  function bindAutoBindMethod(component, method) {
    var boundMethod = method.bind(component);
    if (false) {
      boundMethod.__reactBoundContext = component;
      boundMethod.__reactBoundMethod = method;
      boundMethod.__reactBoundArguments = null;
      var componentName = component.constructor.displayName;
      var _bind = boundMethod.bind;
      boundMethod.bind = function(newThis) {
        for (
          var _len = arguments.length,
            args = Array(_len > 1 ? _len - 1 : 0),
            _key = 1;
          _key < _len;
          _key++
        ) {
          args[_key - 1] = arguments[_key];
        }

        // User is trying to bind() an autobound method; we effectively will
        // ignore the value of "this" that the user is trying to use, so
        // let's warn.
        if (newThis !== component && newThis !== null) {
          if (process.env.NODE_ENV !== 'production') {
            warning(
              false,
              'bind(): React component methods may only be bound to the ' +
                'component instance. See %s',
              componentName
            );
          }
        } else if (!args.length) {
          if (process.env.NODE_ENV !== 'production') {
            warning(
              false,
              'bind(): You are binding a component method to the component. ' +
                'React does this for you automatically in a high-performance ' +
                'way, so you can safely remove this call. See %s',
              componentName
            );
          }
          return boundMethod;
        }
        var reboundMethod = _bind.apply(boundMethod, arguments);
        reboundMethod.__reactBoundContext = component;
        reboundMethod.__reactBoundMethod = method;
        reboundMethod.__reactBoundArguments = args;
        return reboundMethod;
      };
    }
    return boundMethod;
  }

  /**
   * Binds all auto-bound methods in a component.
   *
   * @param {object} component Component whose method is going to be bound.
   */
  function bindAutoBindMethods(component) {
    var pairs = component.__reactAutoBindPairs;
    for (var i = 0; i < pairs.length; i += 2) {
      var autoBindKey = pairs[i];
      var method = pairs[i + 1];
      component[autoBindKey] = bindAutoBindMethod(component, method);
    }
  }

  var IsMountedPreMixin = {
    componentDidMount: function() {
      this.__isMounted = true;
    }
  };

  var IsMountedPostMixin = {
    componentWillUnmount: function() {
      this.__isMounted = false;
    }
  };

  /**
   * Add more to the ReactClass base class. These are all legacy features and
   * therefore not already part of the modern ReactComponent.
   */
  var ReactClassMixin = {
    /**
     * TODO: This will be deprecated because state should always keep a consistent
     * type signature and the only use case for this, is to avoid that.
     */
    replaceState: function(newState, callback) {
      this.updater.enqueueReplaceState(this, newState, callback);
    },

    /**
     * Checks whether or not this composite component is mounted.
     * @return {boolean} True if mounted, false otherwise.
     * @protected
     * @final
     */
    isMounted: function() {
      if (false) {
        warning(
          this.__didWarnIsMounted,
          '%s: isMounted is deprecated. Instead, make sure to clean up ' +
            'subscriptions and pending requests in componentWillUnmount to ' +
            'prevent memory leaks.',
          (this.constructor && this.constructor.displayName) ||
            this.name ||
            'Component'
        );
        this.__didWarnIsMounted = true;
      }
      return !!this.__isMounted;
    }
  };

  var ReactClassComponent = function() {};
  _assign(
    ReactClassComponent.prototype,
    ReactComponent.prototype,
    ReactClassMixin
  );

  /**
   * Creates a composite component class given a class specification.
   * See https://facebook.github.io/react/docs/top-level-api.html#react.createclass
   *
   * @param {object} spec Class specification (which must define `render`).
   * @return {function} Component constructor function.
   * @public
   */
  function createClass(spec) {
    // To keep our warnings more understandable, we'll use a little hack here to
    // ensure that Constructor.name !== 'Constructor'. This makes sure we don't
    // unnecessarily identify a class without displayName as 'Constructor'.
    var Constructor = identity(function(props, context, updater) {
      // This constructor gets overridden by mocks. The argument is used
      // by mocks to assert on what gets mounted.

      if (false) {
        warning(
          this instanceof Constructor,
          'Something is calling a React component directly. Use a factory or ' +
            'JSX instead. See: https://fb.me/react-legacyfactory'
        );
      }

      // Wire up auto-binding
      if (this.__reactAutoBindPairs.length) {
        bindAutoBindMethods(this);
      }

      this.props = props;
      this.context = context;
      this.refs = emptyObject;
      this.updater = updater || ReactNoopUpdateQueue;

      this.state = null;

      // ReactClasses doesn't have constructors. Instead, they use the
      // getInitialState and componentWillMount methods for initialization.

      var initialState = this.getInitialState ? this.getInitialState() : null;
      if (false) {
        // We allow auto-mocks to proceed as if they're returning null.
        if (
          initialState === undefined &&
          this.getInitialState._isMockFunction
        ) {
          // This is probably bad practice. Consider warning here and
          // deprecating this convenience.
          initialState = null;
        }
      }
      _invariant(
        typeof initialState === 'object' && !Array.isArray(initialState),
        '%s.getInitialState(): must return an object or null',
        Constructor.displayName || 'ReactCompositeComponent'
      );

      this.state = initialState;
    });
    Constructor.prototype = new ReactClassComponent();
    Constructor.prototype.constructor = Constructor;
    Constructor.prototype.__reactAutoBindPairs = [];

    injectedMixins.forEach(mixSpecIntoComponent.bind(null, Constructor));

    mixSpecIntoComponent(Constructor, IsMountedPreMixin);
    mixSpecIntoComponent(Constructor, spec);
    mixSpecIntoComponent(Constructor, IsMountedPostMixin);

    // Initialize the defaultProps property after all mixins have been merged.
    if (Constructor.getDefaultProps) {
      Constructor.defaultProps = Constructor.getDefaultProps();
    }

    if (false) {
      // This is a tag to indicate that the use of these method names is ok,
      // since it's used with createClass. If it's not, then it's likely a
      // mistake so we'll warn you to use the static property, property
      // initializer or constructor respectively.
      if (Constructor.getDefaultProps) {
        Constructor.getDefaultProps.isReactClassApproved = {};
      }
      if (Constructor.prototype.getInitialState) {
        Constructor.prototype.getInitialState.isReactClassApproved = {};
      }
    }

    _invariant(
      Constructor.prototype.render,
      'createClass(...): Class specification must implement a `render` method.'
    );

    if (false) {
      warning(
        !Constructor.prototype.componentShouldUpdate,
        '%s has a method called ' +
          'componentShouldUpdate(). Did you mean shouldComponentUpdate()? ' +
          'The name is phrased as a question because the function is ' +
          'expected to return a value.',
        spec.displayName || 'A component'
      );
      warning(
        !Constructor.prototype.componentWillRecieveProps,
        '%s has a method called ' +
          'componentWillRecieveProps(). Did you mean componentWillReceiveProps()?',
        spec.displayName || 'A component'
      );
    }

    // Reduce time spent doing lookups by setting these on the prototype.
    for (var methodName in ReactClassInterface) {
      if (!Constructor.prototype[methodName]) {
        Constructor.prototype[methodName] = null;
      }
    }

    return Constructor;
  }

  return createClass;
}

module.exports = factory;


/***/ }),
/* 1184 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */


var _prodInvariant = __webpack_require__(1117);

var ReactElement = __webpack_require__(1115);

var invariant = __webpack_require__(417);

/**
 * Returns the first child in a collection of children and verifies that there
 * is only one child in the collection.
 *
 * See https://facebook.github.io/react/docs/top-level-api.html#react.children.only
 *
 * The current implementation of this function assumes that a single child gets
 * passed without a wrapper, but the purpose of this helper function is to
 * abstract away the particular structure of children.
 *
 * @param {?object} children Child collection structure.
 * @return {ReactElement} The first and only `ReactElement` contained in the
 * structure.
 */
function onlyChild(children) {
  !ReactElement.isValidElement(children) ?  false ? invariant(false, 'React.Children.only expected to receive a single React element child.') : _prodInvariant('143') : void 0;
  return children;
}

module.exports = onlyChild;

/***/ }),
/* 1185 */
/***/ (function(module, exports, __webpack_require__) {

/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 */

if (false) {
  var REACT_ELEMENT_TYPE = (typeof Symbol === 'function' &&
    Symbol.for &&
    Symbol.for('react.element')) ||
    0xeac7;

  var isValidElement = function(object) {
    return typeof object === 'object' &&
      object !== null &&
      object.$$typeof === REACT_ELEMENT_TYPE;
  };

  // By explicitly using `prop-types` you are opting into new development behavior.
  // http://fb.me/prop-types-in-prod
  var throwOnDirectAccess = true;
  module.exports = require('./factoryWithTypeCheckers')(isValidElement, throwOnDirectAccess);
} else {
  // By explicitly using `prop-types` you are opting into new production behavior.
  // http://fb.me/prop-types-in-prod
  module.exports = __webpack_require__(1186)();
}


/***/ }),
/* 1186 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 */



var emptyFunction = __webpack_require__(418);
var invariant = __webpack_require__(417);
var ReactPropTypesSecret = __webpack_require__(1134);

module.exports = function() {
  function shim(props, propName, componentName, location, propFullName, secret) {
    if (secret === ReactPropTypesSecret) {
      // It is still safe when called from React.
      return;
    }
    invariant(
      false,
      'Calling PropTypes validators directly is not supported by the `prop-types` package. ' +
      'Use PropTypes.checkPropTypes() to call them. ' +
      'Read more at http://fb.me/use-check-prop-types'
    );
  };
  shim.isRequired = shim;
  function getShim() {
    return shim;
  };
  // Important!
  // Keep this list in sync with production version in `./factoryWithTypeCheckers.js`.
  var ReactPropTypes = {
    array: shim,
    bool: shim,
    func: shim,
    number: shim,
    object: shim,
    string: shim,
    symbol: shim,

    any: shim,
    arrayOf: getShim,
    element: shim,
    instanceOf: getShim,
    node: shim,
    objectOf: getShim,
    oneOf: getShim,
    oneOfType: getShim,
    shape: getShim
  };

  ReactPropTypes.checkPropTypes = emptyFunction;
  ReactPropTypes.PropTypes = ReactPropTypes;

  return ReactPropTypes;
};


/***/ }),
/* 1187 */
/***/ (function(module, exports, __webpack_require__) {


    var content = __webpack_require__(1188);
    var insertCss = __webpack_require__(889);

    if (typeof content === 'string') {
      content = [[module.i, content, '']];
    }

    module.exports = content.locals || {};
    module.exports._getContent = function() { return content; };
    module.exports._getCss = function() { return content.toString(); };
    module.exports._insertCss = function(options) { return insertCss(content, options) };
    
    // Hot Module Replacement
    // https://webpack.github.io/docs/hot-module-replacement
    // Only activated in browser context
    if (false) {
      var removeCss = function() {};
      module.hot.accept("!!../../../../../node_modules/css-loader/index.js??ref--2-rules-2!../../../../../node_modules/postcss-loader/lib/index.js??ref--2-rules-3!./UploadsModalVideoLlamada.css", function() {
        content = require("!!../../../../../node_modules/css-loader/index.js??ref--2-rules-2!../../../../../node_modules/postcss-loader/lib/index.js??ref--2-rules-3!./UploadsModalVideoLlamada.css");

        if (typeof content === 'string') {
          content = [[module.id, content, '']];
        }

        removeCss = insertCss(content, { replace: true });
      });
      module.hot.dispose(function() { removeCss(); });
    }
  

/***/ }),
/* 1188 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(888)(false);
// imports


// module
exports.push([module.i, "._2PLgW{position:absolute;bottom:75px;right:25px;width:400px;min-height:200px;max-height:80%;border:1px solid #ccc;border-radius:3px;-webkit-box-shadow:0 0 3px rgba(0,0,0,.6);box-shadow:0 0 3px rgba(0,0,0,.6);background-color:#fff;padding:10px;display:none;overflow:auto}._2PLgW img{width:50px}._3XSHQ{margin:5px 0}._3XSHQ i{line-height:24px}", ""]);

// exports
exports.locals = {
	"modalVideoLlamadaUploads": "_2PLgW",
	"uploadedFile": "_3XSHQ"
};

/***/ }),
/* 1189 */
/***/ (function(module, exports, __webpack_require__) {


    var content = __webpack_require__(1190);
    var insertCss = __webpack_require__(889);

    if (typeof content === 'string') {
      content = [[module.i, content, '']];
    }

    module.exports = content.locals || {};
    module.exports._getContent = function() { return content; };
    module.exports._getCss = function() { return content.toString(); };
    module.exports._insertCss = function(options) { return insertCss(content, options) };
    
    // Hot Module Replacement
    // https://webpack.github.io/docs/hot-module-replacement
    // Only activated in browser context
    if (false) {
      var removeCss = function() {};
      module.hot.accept("!!../../../../../node_modules/css-loader/index.js??ref--2-rules-2!../../../../../node_modules/postcss-loader/lib/index.js??ref--2-rules-3!./UploadsOkModalVideoLlamada.css", function() {
        content = require("!!../../../../../node_modules/css-loader/index.js??ref--2-rules-2!../../../../../node_modules/postcss-loader/lib/index.js??ref--2-rules-3!./UploadsOkModalVideoLlamada.css");

        if (typeof content === 'string') {
          content = [[module.id, content, '']];
        }

        removeCss = insertCss(content, { replace: true });
      });
      module.hot.dispose(function() { removeCss(); });
    }
  

/***/ }),
/* 1190 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(888)(false);
// imports


// module
exports.push([module.i, ".LhxDz{background-color:#ebf6f5;color:#1b5e20;position:absolute;bottom:75px;right:25px;width:330px;border:1px solid #007a6e;border-radius:3px;-webkit-box-shadow:0 0 3px rgba(0,0,0,.6);box-shadow:0 0 3px rgba(0,0,0,.6);padding:10px;overflow:auto;display:none}", ""]);

// exports
exports.locals = {
	"modalVideoLlamadaUploadsOk": "LhxDz"
};

/***/ }),
/* 1191 */
/***/ (function(module, exports, __webpack_require__) {


    var content = __webpack_require__(1192);
    var insertCss = __webpack_require__(889);

    if (typeof content === 'string') {
      content = [[module.i, content, '']];
    }

    module.exports = content.locals || {};
    module.exports._getContent = function() { return content; };
    module.exports._getCss = function() { return content.toString(); };
    module.exports._insertCss = function(options) { return insertCss(content, options) };
    
    // Hot Module Replacement
    // https://webpack.github.io/docs/hot-module-replacement
    // Only activated in browser context
    if (false) {
      var removeCss = function() {};
      module.hot.accept("!!../../../../../node_modules/css-loader/index.js??ref--2-rules-2!../../../../../node_modules/postcss-loader/lib/index.js??ref--2-rules-3!./HideModalVideoLlamada.css", function() {
        content = require("!!../../../../../node_modules/css-loader/index.js??ref--2-rules-2!../../../../../node_modules/postcss-loader/lib/index.js??ref--2-rules-3!./HideModalVideoLlamada.css");

        if (typeof content === 'string') {
          content = [[module.id, content, '']];
        }

        removeCss = insertCss(content, { replace: true });
      });
      module.hot.dispose(function() { removeCss(); });
    }
  

/***/ }),
/* 1192 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(888)(false);
// imports


// module
exports.push([module.i, "._1Ojeg{position:absolute;bottom:-50px;right:0;border-radius:20px;background-color:#e4002b;color:#fff;padding:5px 14px;font-size:20px;font-weight:700;cursor:pointer}", ""]);

// exports
exports.locals = {
	"modalVideoLlamadaHide": "_1Ojeg"
};

/***/ }),
/* 1193 */
/***/ (function(module, exports, __webpack_require__) {


    var content = __webpack_require__(1194);
    var insertCss = __webpack_require__(889);

    if (typeof content === 'string') {
      content = [[module.i, content, '']];
    }

    module.exports = content.locals || {};
    module.exports._getContent = function() { return content; };
    module.exports._getCss = function() { return content.toString(); };
    module.exports._insertCss = function(options) { return insertCss(content, options) };
    
    // Hot Module Replacement
    // https://webpack.github.io/docs/hot-module-replacement
    // Only activated in browser context
    if (false) {
      var removeCss = function() {};
      module.hot.accept("!!../../../../node_modules/css-loader/index.js??ref--2-rules-2!../../../../node_modules/postcss-loader/lib/index.js??ref--2-rules-3!./ModalConsultaSinFinalizar.css", function() {
        content = require("!!../../../../node_modules/css-loader/index.js??ref--2-rules-2!../../../../node_modules/postcss-loader/lib/index.js??ref--2-rules-3!./ModalConsultaSinFinalizar.css");

        if (typeof content === 'string') {
          content = [[module.id, content, '']];
        }

        removeCss = insertCss(content, { replace: true });
      });
      module.hot.dispose(function() { removeCss(); });
    }
  

/***/ }),
/* 1194 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(888)(false);
// imports


// module
exports.push([module.i, ".PdCh9{background-color:#e4002b;cursor:pointer;margin-left:10px!important;width:140px}._28CBd{text-align:center}._1O7HI{color:#333;background-color:#fff;border-color:#ccc;cursor:pointer;margin-right:10px!important;width:140px}._2SRVM{margin:0 auto}.UkQIn{font-family:Roboto,sans-serif;padding:25px 0}", ""]);

// exports
exports.locals = {
	"boton_rojo": "PdCh9",
	"modalContent": "_28CBd",
	"boton_blanco": "_1O7HI",
	"modalFooter": "_2SRVM",
	"modalBody": "UkQIn"
};

/***/ }),
/* 1195 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "ef1bb203.wav";

/***/ }),
/* 1196 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "868fb770.png";

/***/ }),
/* 1197 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "e78cbf6b.png";

/***/ }),
/* 1198 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "53cf4ad6.png";

/***/ }),
/* 1199 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "bc521fdc.png";

/***/ }),
/* 1200 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "af4f4505.png";

/***/ }),
/* 1201 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "ba44f797.png";

/***/ }),
/* 1202 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "9a77c357.png";

/***/ }),
/* 1203 */
/***/ (function(module, exports, __webpack_require__) {


    var content = __webpack_require__(1204);
    var insertCss = __webpack_require__(889);

    if (typeof content === 'string') {
      content = [[module.i, content, '']];
    }

    module.exports = content.locals || {};
    module.exports._getContent = function() { return content; };
    module.exports._getCss = function() { return content.toString(); };
    module.exports._insertCss = function(options) { return insertCss(content, options) };
    
    // Hot Module Replacement
    // https://webpack.github.io/docs/hot-module-replacement
    // Only activated in browser context
    if (false) {
      var removeCss = function() {};
      module.hot.accept("!!../../../../node_modules/css-loader/index.js??ref--2-rules-2!../../../../node_modules/postcss-loader/lib/index.js??ref--2-rules-3!./ModalTurnoElegidoYaFueSeleccionado.css", function() {
        content = require("!!../../../../node_modules/css-loader/index.js??ref--2-rules-2!../../../../node_modules/postcss-loader/lib/index.js??ref--2-rules-3!./ModalTurnoElegidoYaFueSeleccionado.css");

        if (typeof content === 'string') {
          content = [[module.id, content, '']];
        }

        removeCss = insertCss(content, { replace: true });
      });
      module.hot.dispose(function() { removeCss(); });
    }
  

/***/ }),
/* 1204 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(888)(false);
// imports


// module
exports.push([module.i, "._2I50O{background-color:#f40000;cursor:pointer;margin-left:10px!important}._3VmVw{text-align:center}._21i62{color:#333;background-color:#fff;border-color:#ccc;cursor:pointer;margin-right:10px!important}._2b76v{margin:0 auto}._17mpc{font-family:Roboto,sans-serif;padding:25px 0}", ""]);

// exports
exports.locals = {
	"boton_rojo": "_2I50O",
	"modalContent": "_3VmVw",
	"boton_blanco": "_21i62",
	"modalFooter": "_2b76v",
	"modalBody": "_17mpc"
};

/***/ }),
/* 1205 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 */



var emptyFunction = __webpack_require__(418);
var invariant = __webpack_require__(417);
var ReactPropTypesSecret = __webpack_require__(1206);

module.exports = function() {
  function shim(props, propName, componentName, location, propFullName, secret) {
    if (secret === ReactPropTypesSecret) {
      // It is still safe when called from React.
      return;
    }
    invariant(
      false,
      'Calling PropTypes validators directly is not supported by the `prop-types` package. ' +
      'Use PropTypes.checkPropTypes() to call them. ' +
      'Read more at http://fb.me/use-check-prop-types'
    );
  };
  shim.isRequired = shim;
  function getShim() {
    return shim;
  };
  // Important!
  // Keep this list in sync with production version in `./factoryWithTypeCheckers.js`.
  var ReactPropTypes = {
    array: shim,
    bool: shim,
    func: shim,
    number: shim,
    object: shim,
    string: shim,
    symbol: shim,

    any: shim,
    arrayOf: getShim,
    element: shim,
    instanceOf: getShim,
    node: shim,
    objectOf: getShim,
    oneOf: getShim,
    oneOfType: getShim,
    shape: getShim
  };

  ReactPropTypes.checkPropTypes = emptyFunction;
  ReactPropTypes.PropTypes = ReactPropTypes;

  return ReactPropTypes;
};


/***/ }),
/* 1206 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 */



var ReactPropTypesSecret = 'SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED';

module.exports = ReactPropTypesSecret;


/***/ }),
/* 1207 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(global) {/**
 * Lodash (Custom Build) <https://lodash.com/>
 * Build: `lodash modularize exports="npm" -o ./`
 * Copyright JS Foundation and other contributors <https://js.foundation/>
 * Released under MIT license <https://lodash.com/license>
 * Based on Underscore.js 1.8.3 <http://underscorejs.org/LICENSE>
 * Copyright Jeremy Ashkenas, DocumentCloud and Investigative Reporters & Editors
 */

/** `Object#toString` result references. */
var asyncTag = '[object AsyncFunction]',
    funcTag = '[object Function]',
    genTag = '[object GeneratorFunction]',
    nullTag = '[object Null]',
    proxyTag = '[object Proxy]',
    undefinedTag = '[object Undefined]';

/** Detect free variable `global` from Node.js. */
var freeGlobal = typeof global == 'object' && global && global.Object === Object && global;

/** Detect free variable `self`. */
var freeSelf = typeof self == 'object' && self && self.Object === Object && self;

/** Used as a reference to the global object. */
var root = freeGlobal || freeSelf || Function('return this')();

/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/**
 * Used to resolve the
 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
 * of values.
 */
var nativeObjectToString = objectProto.toString;

/** Built-in value references. */
var Symbol = root.Symbol,
    symToStringTag = Symbol ? Symbol.toStringTag : undefined;

/**
 * The base implementation of `getTag` without fallbacks for buggy environments.
 *
 * @private
 * @param {*} value The value to query.
 * @returns {string} Returns the `toStringTag`.
 */
function baseGetTag(value) {
  if (value == null) {
    return value === undefined ? undefinedTag : nullTag;
  }
  return (symToStringTag && symToStringTag in Object(value))
    ? getRawTag(value)
    : objectToString(value);
}

/**
 * A specialized version of `baseGetTag` which ignores `Symbol.toStringTag` values.
 *
 * @private
 * @param {*} value The value to query.
 * @returns {string} Returns the raw `toStringTag`.
 */
function getRawTag(value) {
  var isOwn = hasOwnProperty.call(value, symToStringTag),
      tag = value[symToStringTag];

  try {
    value[symToStringTag] = undefined;
    var unmasked = true;
  } catch (e) {}

  var result = nativeObjectToString.call(value);
  if (unmasked) {
    if (isOwn) {
      value[symToStringTag] = tag;
    } else {
      delete value[symToStringTag];
    }
  }
  return result;
}

/**
 * Converts `value` to a string using `Object.prototype.toString`.
 *
 * @private
 * @param {*} value The value to convert.
 * @returns {string} Returns the converted string.
 */
function objectToString(value) {
  return nativeObjectToString.call(value);
}

/**
 * Checks if `value` is classified as a `Function` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a function, else `false`.
 * @example
 *
 * _.isFunction(_);
 * // => true
 *
 * _.isFunction(/abc/);
 * // => false
 */
function isFunction(value) {
  if (!isObject(value)) {
    return false;
  }
  // The use of `Object#toString` avoids issues with the `typeof` operator
  // in Safari 9 which returns 'object' for typed arrays and other constructors.
  var tag = baseGetTag(value);
  return tag == funcTag || tag == genTag || tag == asyncTag || tag == proxyTag;
}

/**
 * Checks if `value` is the
 * [language type](http://www.ecma-international.org/ecma-262/7.0/#sec-ecmascript-language-types)
 * of `Object`. (e.g. arrays, functions, objects, regexes, `new Number(0)`, and `new String('')`)
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an object, else `false`.
 * @example
 *
 * _.isObject({});
 * // => true
 *
 * _.isObject([1, 2, 3]);
 * // => true
 *
 * _.isObject(_.noop);
 * // => true
 *
 * _.isObject(null);
 * // => false
 */
function isObject(value) {
  var type = typeof value;
  return value != null && (type == 'object' || type == 'function');
}

module.exports = isFunction;

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(5)))

/***/ }),
/* 1208 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */



var ReactPropTypesSecret = __webpack_require__(1209);

function emptyFunction() {}
function emptyFunctionWithReset() {}
emptyFunctionWithReset.resetWarningCache = emptyFunction;

module.exports = function() {
  function shim(props, propName, componentName, location, propFullName, secret) {
    if (secret === ReactPropTypesSecret) {
      // It is still safe when called from React.
      return;
    }
    var err = new Error(
      'Calling PropTypes validators directly is not supported by the `prop-types` package. ' +
      'Use PropTypes.checkPropTypes() to call them. ' +
      'Read more at http://fb.me/use-check-prop-types'
    );
    err.name = 'Invariant Violation';
    throw err;
  };
  shim.isRequired = shim;
  function getShim() {
    return shim;
  };
  // Important!
  // Keep this list in sync with production version in `./factoryWithTypeCheckers.js`.
  var ReactPropTypes = {
    array: shim,
    bool: shim,
    func: shim,
    number: shim,
    object: shim,
    string: shim,
    symbol: shim,

    any: shim,
    arrayOf: getShim,
    element: shim,
    elementType: shim,
    instanceOf: getShim,
    node: shim,
    objectOf: getShim,
    oneOf: getShim,
    oneOfType: getShim,
    shape: getShim,
    exact: getShim,

    checkPropTypes: emptyFunctionWithReset,
    resetWarningCache: emptyFunction
  };

  ReactPropTypes.PropTypes = ReactPropTypes;

  return ReactPropTypes;
};


/***/ }),
/* 1209 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */



var ReactPropTypesSecret = 'SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED';

module.exports = ReactPropTypesSecret;


/***/ }),
/* 1210 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(global) {/**!
 * @fileOverview Kickass library to create and place poppers near their reference elements.
 * @version 1.14.7
 * @license
 * Copyright (c) 2016 Federico Zivolo and contributors
 *
 * Permission is hereby granted, free of charge, to any person obtaining a copy
 * of this software and associated documentation files (the "Software"), to deal
 * in the Software without restriction, including without limitation the rights
 * to use, copy, modify, merge, publish, distribute, sublicense, and/or sell
 * copies of the Software, and to permit persons to whom the Software is
 * furnished to do so, subject to the following conditions:
 *
 * The above copyright notice and this permission notice shall be included in all
 * copies or substantial portions of the Software.
 *
 * THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
 * IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
 * FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
 * AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
 * LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
 * OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN THE
 * SOFTWARE.
 */
var isBrowser = typeof window !== 'undefined' && typeof document !== 'undefined';

var longerTimeoutBrowsers = ['Edge', 'Trident', 'Firefox'];
var timeoutDuration = 0;
for (var i = 0; i < longerTimeoutBrowsers.length; i += 1) {
  if (isBrowser && navigator.userAgent.indexOf(longerTimeoutBrowsers[i]) >= 0) {
    timeoutDuration = 1;
    break;
  }
}

function microtaskDebounce(fn) {
  var called = false;
  return function () {
    if (called) {
      return;
    }
    called = true;
    window.Promise.resolve().then(function () {
      called = false;
      fn();
    });
  };
}

function taskDebounce(fn) {
  var scheduled = false;
  return function () {
    if (!scheduled) {
      scheduled = true;
      setTimeout(function () {
        scheduled = false;
        fn();
      }, timeoutDuration);
    }
  };
}

var supportsMicroTasks = isBrowser && window.Promise;

/**
* Create a debounced version of a method, that's asynchronously deferred
* but called in the minimum time possible.
*
* @method
* @memberof Popper.Utils
* @argument {Function} fn
* @returns {Function}
*/
var debounce = supportsMicroTasks ? microtaskDebounce : taskDebounce;

/**
 * Check if the given variable is a function
 * @method
 * @memberof Popper.Utils
 * @argument {Any} functionToCheck - variable to check
 * @returns {Boolean} answer to: is a function?
 */
function isFunction(functionToCheck) {
  var getType = {};
  return functionToCheck && getType.toString.call(functionToCheck) === '[object Function]';
}

/**
 * Get CSS computed property of the given element
 * @method
 * @memberof Popper.Utils
 * @argument {Eement} element
 * @argument {String} property
 */
function getStyleComputedProperty(element, property) {
  if (element.nodeType !== 1) {
    return [];
  }
  // NOTE: 1 DOM access here
  var window = element.ownerDocument.defaultView;
  var css = window.getComputedStyle(element, null);
  return property ? css[property] : css;
}

/**
 * Returns the parentNode or the host of the element
 * @method
 * @memberof Popper.Utils
 * @argument {Element} element
 * @returns {Element} parent
 */
function getParentNode(element) {
  if (element.nodeName === 'HTML') {
    return element;
  }
  return element.parentNode || element.host;
}

/**
 * Returns the scrolling parent of the given element
 * @method
 * @memberof Popper.Utils
 * @argument {Element} element
 * @returns {Element} scroll parent
 */
function getScrollParent(element) {
  // Return body, `getScroll` will take care to get the correct `scrollTop` from it
  if (!element) {
    return document.body;
  }

  switch (element.nodeName) {
    case 'HTML':
    case 'BODY':
      return element.ownerDocument.body;
    case '#document':
      return element.body;
  }

  // Firefox want us to check `-x` and `-y` variations as well

  var _getStyleComputedProp = getStyleComputedProperty(element),
      overflow = _getStyleComputedProp.overflow,
      overflowX = _getStyleComputedProp.overflowX,
      overflowY = _getStyleComputedProp.overflowY;

  if (/(auto|scroll|overlay)/.test(overflow + overflowY + overflowX)) {
    return element;
  }

  return getScrollParent(getParentNode(element));
}

var isIE11 = isBrowser && !!(window.MSInputMethodContext && document.documentMode);
var isIE10 = isBrowser && /MSIE 10/.test(navigator.userAgent);

/**
 * Determines if the browser is Internet Explorer
 * @method
 * @memberof Popper.Utils
 * @param {Number} version to check
 * @returns {Boolean} isIE
 */
function isIE(version) {
  if (version === 11) {
    return isIE11;
  }
  if (version === 10) {
    return isIE10;
  }
  return isIE11 || isIE10;
}

/**
 * Returns the offset parent of the given element
 * @method
 * @memberof Popper.Utils
 * @argument {Element} element
 * @returns {Element} offset parent
 */
function getOffsetParent(element) {
  if (!element) {
    return document.documentElement;
  }

  var noOffsetParent = isIE(10) ? document.body : null;

  // NOTE: 1 DOM access here
  var offsetParent = element.offsetParent || null;
  // Skip hidden elements which don't have an offsetParent
  while (offsetParent === noOffsetParent && element.nextElementSibling) {
    offsetParent = (element = element.nextElementSibling).offsetParent;
  }

  var nodeName = offsetParent && offsetParent.nodeName;

  if (!nodeName || nodeName === 'BODY' || nodeName === 'HTML') {
    return element ? element.ownerDocument.documentElement : document.documentElement;
  }

  // .offsetParent will return the closest TH, TD or TABLE in case
  // no offsetParent is present, I hate this job...
  if (['TH', 'TD', 'TABLE'].indexOf(offsetParent.nodeName) !== -1 && getStyleComputedProperty(offsetParent, 'position') === 'static') {
    return getOffsetParent(offsetParent);
  }

  return offsetParent;
}

function isOffsetContainer(element) {
  var nodeName = element.nodeName;

  if (nodeName === 'BODY') {
    return false;
  }
  return nodeName === 'HTML' || getOffsetParent(element.firstElementChild) === element;
}

/**
 * Finds the root node (document, shadowDOM root) of the given element
 * @method
 * @memberof Popper.Utils
 * @argument {Element} node
 * @returns {Element} root node
 */
function getRoot(node) {
  if (node.parentNode !== null) {
    return getRoot(node.parentNode);
  }

  return node;
}

/**
 * Finds the offset parent common to the two provided nodes
 * @method
 * @memberof Popper.Utils
 * @argument {Element} element1
 * @argument {Element} element2
 * @returns {Element} common offset parent
 */
function findCommonOffsetParent(element1, element2) {
  // This check is needed to avoid errors in case one of the elements isn't defined for any reason
  if (!element1 || !element1.nodeType || !element2 || !element2.nodeType) {
    return document.documentElement;
  }

  // Here we make sure to give as "start" the element that comes first in the DOM
  var order = element1.compareDocumentPosition(element2) & Node.DOCUMENT_POSITION_FOLLOWING;
  var start = order ? element1 : element2;
  var end = order ? element2 : element1;

  // Get common ancestor container
  var range = document.createRange();
  range.setStart(start, 0);
  range.setEnd(end, 0);
  var commonAncestorContainer = range.commonAncestorContainer;

  // Both nodes are inside #document

  if (element1 !== commonAncestorContainer && element2 !== commonAncestorContainer || start.contains(end)) {
    if (isOffsetContainer(commonAncestorContainer)) {
      return commonAncestorContainer;
    }

    return getOffsetParent(commonAncestorContainer);
  }

  // one of the nodes is inside shadowDOM, find which one
  var element1root = getRoot(element1);
  if (element1root.host) {
    return findCommonOffsetParent(element1root.host, element2);
  } else {
    return findCommonOffsetParent(element1, getRoot(element2).host);
  }
}

/**
 * Gets the scroll value of the given element in the given side (top and left)
 * @method
 * @memberof Popper.Utils
 * @argument {Element} element
 * @argument {String} side `top` or `left`
 * @returns {number} amount of scrolled pixels
 */
function getScroll(element) {
  var side = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'top';

  var upperSide = side === 'top' ? 'scrollTop' : 'scrollLeft';
  var nodeName = element.nodeName;

  if (nodeName === 'BODY' || nodeName === 'HTML') {
    var html = element.ownerDocument.documentElement;
    var scrollingElement = element.ownerDocument.scrollingElement || html;
    return scrollingElement[upperSide];
  }

  return element[upperSide];
}

/*
 * Sum or subtract the element scroll values (left and top) from a given rect object
 * @method
 * @memberof Popper.Utils
 * @param {Object} rect - Rect object you want to change
 * @param {HTMLElement} element - The element from the function reads the scroll values
 * @param {Boolean} subtract - set to true if you want to subtract the scroll values
 * @return {Object} rect - The modifier rect object
 */
function includeScroll(rect, element) {
  var subtract = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;

  var scrollTop = getScroll(element, 'top');
  var scrollLeft = getScroll(element, 'left');
  var modifier = subtract ? -1 : 1;
  rect.top += scrollTop * modifier;
  rect.bottom += scrollTop * modifier;
  rect.left += scrollLeft * modifier;
  rect.right += scrollLeft * modifier;
  return rect;
}

/*
 * Helper to detect borders of a given element
 * @method
 * @memberof Popper.Utils
 * @param {CSSStyleDeclaration} styles
 * Result of `getStyleComputedProperty` on the given element
 * @param {String} axis - `x` or `y`
 * @return {number} borders - The borders size of the given axis
 */

function getBordersSize(styles, axis) {
  var sideA = axis === 'x' ? 'Left' : 'Top';
  var sideB = sideA === 'Left' ? 'Right' : 'Bottom';

  return parseFloat(styles['border' + sideA + 'Width'], 10) + parseFloat(styles['border' + sideB + 'Width'], 10);
}

function getSize(axis, body, html, computedStyle) {
  return Math.max(body['offset' + axis], body['scroll' + axis], html['client' + axis], html['offset' + axis], html['scroll' + axis], isIE(10) ? parseInt(html['offset' + axis]) + parseInt(computedStyle['margin' + (axis === 'Height' ? 'Top' : 'Left')]) + parseInt(computedStyle['margin' + (axis === 'Height' ? 'Bottom' : 'Right')]) : 0);
}

function getWindowSizes(document) {
  var body = document.body;
  var html = document.documentElement;
  var computedStyle = isIE(10) && getComputedStyle(html);

  return {
    height: getSize('Height', body, html, computedStyle),
    width: getSize('Width', body, html, computedStyle)
  };
}

var classCallCheck = function (instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
};

var createClass = function () {
  function defineProperties(target, props) {
    for (var i = 0; i < props.length; i++) {
      var descriptor = props[i];
      descriptor.enumerable = descriptor.enumerable || false;
      descriptor.configurable = true;
      if ("value" in descriptor) descriptor.writable = true;
      Object.defineProperty(target, descriptor.key, descriptor);
    }
  }

  return function (Constructor, protoProps, staticProps) {
    if (protoProps) defineProperties(Constructor.prototype, protoProps);
    if (staticProps) defineProperties(Constructor, staticProps);
    return Constructor;
  };
}();





var defineProperty = function (obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
};

var _extends = Object.assign || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];

    for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }

  return target;
};

/**
 * Given element offsets, generate an output similar to getBoundingClientRect
 * @method
 * @memberof Popper.Utils
 * @argument {Object} offsets
 * @returns {Object} ClientRect like output
 */
function getClientRect(offsets) {
  return _extends({}, offsets, {
    right: offsets.left + offsets.width,
    bottom: offsets.top + offsets.height
  });
}

/**
 * Get bounding client rect of given element
 * @method
 * @memberof Popper.Utils
 * @param {HTMLElement} element
 * @return {Object} client rect
 */
function getBoundingClientRect(element) {
  var rect = {};

  // IE10 10 FIX: Please, don't ask, the element isn't
  // considered in DOM in some circumstances...
  // This isn't reproducible in IE10 compatibility mode of IE11
  try {
    if (isIE(10)) {
      rect = element.getBoundingClientRect();
      var scrollTop = getScroll(element, 'top');
      var scrollLeft = getScroll(element, 'left');
      rect.top += scrollTop;
      rect.left += scrollLeft;
      rect.bottom += scrollTop;
      rect.right += scrollLeft;
    } else {
      rect = element.getBoundingClientRect();
    }
  } catch (e) {}

  var result = {
    left: rect.left,
    top: rect.top,
    width: rect.right - rect.left,
    height: rect.bottom - rect.top
  };

  // subtract scrollbar size from sizes
  var sizes = element.nodeName === 'HTML' ? getWindowSizes(element.ownerDocument) : {};
  var width = sizes.width || element.clientWidth || result.right - result.left;
  var height = sizes.height || element.clientHeight || result.bottom - result.top;

  var horizScrollbar = element.offsetWidth - width;
  var vertScrollbar = element.offsetHeight - height;

  // if an hypothetical scrollbar is detected, we must be sure it's not a `border`
  // we make this check conditional for performance reasons
  if (horizScrollbar || vertScrollbar) {
    var styles = getStyleComputedProperty(element);
    horizScrollbar -= getBordersSize(styles, 'x');
    vertScrollbar -= getBordersSize(styles, 'y');

    result.width -= horizScrollbar;
    result.height -= vertScrollbar;
  }

  return getClientRect(result);
}

function getOffsetRectRelativeToArbitraryNode(children, parent) {
  var fixedPosition = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;

  var isIE10 = isIE(10);
  var isHTML = parent.nodeName === 'HTML';
  var childrenRect = getBoundingClientRect(children);
  var parentRect = getBoundingClientRect(parent);
  var scrollParent = getScrollParent(children);

  var styles = getStyleComputedProperty(parent);
  var borderTopWidth = parseFloat(styles.borderTopWidth, 10);
  var borderLeftWidth = parseFloat(styles.borderLeftWidth, 10);

  // In cases where the parent is fixed, we must ignore negative scroll in offset calc
  if (fixedPosition && isHTML) {
    parentRect.top = Math.max(parentRect.top, 0);
    parentRect.left = Math.max(parentRect.left, 0);
  }
  var offsets = getClientRect({
    top: childrenRect.top - parentRect.top - borderTopWidth,
    left: childrenRect.left - parentRect.left - borderLeftWidth,
    width: childrenRect.width,
    height: childrenRect.height
  });
  offsets.marginTop = 0;
  offsets.marginLeft = 0;

  // Subtract margins of documentElement in case it's being used as parent
  // we do this only on HTML because it's the only element that behaves
  // differently when margins are applied to it. The margins are included in
  // the box of the documentElement, in the other cases not.
  if (!isIE10 && isHTML) {
    var marginTop = parseFloat(styles.marginTop, 10);
    var marginLeft = parseFloat(styles.marginLeft, 10);

    offsets.top -= borderTopWidth - marginTop;
    offsets.bottom -= borderTopWidth - marginTop;
    offsets.left -= borderLeftWidth - marginLeft;
    offsets.right -= borderLeftWidth - marginLeft;

    // Attach marginTop and marginLeft because in some circumstances we may need them
    offsets.marginTop = marginTop;
    offsets.marginLeft = marginLeft;
  }

  if (isIE10 && !fixedPosition ? parent.contains(scrollParent) : parent === scrollParent && scrollParent.nodeName !== 'BODY') {
    offsets = includeScroll(offsets, parent);
  }

  return offsets;
}

function getViewportOffsetRectRelativeToArtbitraryNode(element) {
  var excludeScroll = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;

  var html = element.ownerDocument.documentElement;
  var relativeOffset = getOffsetRectRelativeToArbitraryNode(element, html);
  var width = Math.max(html.clientWidth, window.innerWidth || 0);
  var height = Math.max(html.clientHeight, window.innerHeight || 0);

  var scrollTop = !excludeScroll ? getScroll(html) : 0;
  var scrollLeft = !excludeScroll ? getScroll(html, 'left') : 0;

  var offset = {
    top: scrollTop - relativeOffset.top + relativeOffset.marginTop,
    left: scrollLeft - relativeOffset.left + relativeOffset.marginLeft,
    width: width,
    height: height
  };

  return getClientRect(offset);
}

/**
 * Check if the given element is fixed or is inside a fixed parent
 * @method
 * @memberof Popper.Utils
 * @argument {Element} element
 * @argument {Element} customContainer
 * @returns {Boolean} answer to "isFixed?"
 */
function isFixed(element) {
  var nodeName = element.nodeName;
  if (nodeName === 'BODY' || nodeName === 'HTML') {
    return false;
  }
  if (getStyleComputedProperty(element, 'position') === 'fixed') {
    return true;
  }
  var parentNode = getParentNode(element);
  if (!parentNode) {
    return false;
  }
  return isFixed(parentNode);
}

/**
 * Finds the first parent of an element that has a transformed property defined
 * @method
 * @memberof Popper.Utils
 * @argument {Element} element
 * @returns {Element} first transformed parent or documentElement
 */

function getFixedPositionOffsetParent(element) {
  // This check is needed to avoid errors in case one of the elements isn't defined for any reason
  if (!element || !element.parentElement || isIE()) {
    return document.documentElement;
  }
  var el = element.parentElement;
  while (el && getStyleComputedProperty(el, 'transform') === 'none') {
    el = el.parentElement;
  }
  return el || document.documentElement;
}

/**
 * Computed the boundaries limits and return them
 * @method
 * @memberof Popper.Utils
 * @param {HTMLElement} popper
 * @param {HTMLElement} reference
 * @param {number} padding
 * @param {HTMLElement} boundariesElement - Element used to define the boundaries
 * @param {Boolean} fixedPosition - Is in fixed position mode
 * @returns {Object} Coordinates of the boundaries
 */
function getBoundaries(popper, reference, padding, boundariesElement) {
  var fixedPosition = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : false;

  // NOTE: 1 DOM access here

  var boundaries = { top: 0, left: 0 };
  var offsetParent = fixedPosition ? getFixedPositionOffsetParent(popper) : findCommonOffsetParent(popper, reference);

  // Handle viewport case
  if (boundariesElement === 'viewport') {
    boundaries = getViewportOffsetRectRelativeToArtbitraryNode(offsetParent, fixedPosition);
  } else {
    // Handle other cases based on DOM element used as boundaries
    var boundariesNode = void 0;
    if (boundariesElement === 'scrollParent') {
      boundariesNode = getScrollParent(getParentNode(reference));
      if (boundariesNode.nodeName === 'BODY') {
        boundariesNode = popper.ownerDocument.documentElement;
      }
    } else if (boundariesElement === 'window') {
      boundariesNode = popper.ownerDocument.documentElement;
    } else {
      boundariesNode = boundariesElement;
    }

    var offsets = getOffsetRectRelativeToArbitraryNode(boundariesNode, offsetParent, fixedPosition);

    // In case of HTML, we need a different computation
    if (boundariesNode.nodeName === 'HTML' && !isFixed(offsetParent)) {
      var _getWindowSizes = getWindowSizes(popper.ownerDocument),
          height = _getWindowSizes.height,
          width = _getWindowSizes.width;

      boundaries.top += offsets.top - offsets.marginTop;
      boundaries.bottom = height + offsets.top;
      boundaries.left += offsets.left - offsets.marginLeft;
      boundaries.right = width + offsets.left;
    } else {
      // for all the other DOM elements, this one is good
      boundaries = offsets;
    }
  }

  // Add paddings
  padding = padding || 0;
  var isPaddingNumber = typeof padding === 'number';
  boundaries.left += isPaddingNumber ? padding : padding.left || 0;
  boundaries.top += isPaddingNumber ? padding : padding.top || 0;
  boundaries.right -= isPaddingNumber ? padding : padding.right || 0;
  boundaries.bottom -= isPaddingNumber ? padding : padding.bottom || 0;

  return boundaries;
}

function getArea(_ref) {
  var width = _ref.width,
      height = _ref.height;

  return width * height;
}

/**
 * Utility used to transform the `auto` placement to the placement with more
 * available space.
 * @method
 * @memberof Popper.Utils
 * @argument {Object} data - The data object generated by update method
 * @argument {Object} options - Modifiers configuration and options
 * @returns {Object} The data object, properly modified
 */
function computeAutoPlacement(placement, refRect, popper, reference, boundariesElement) {
  var padding = arguments.length > 5 && arguments[5] !== undefined ? arguments[5] : 0;

  if (placement.indexOf('auto') === -1) {
    return placement;
  }

  var boundaries = getBoundaries(popper, reference, padding, boundariesElement);

  var rects = {
    top: {
      width: boundaries.width,
      height: refRect.top - boundaries.top
    },
    right: {
      width: boundaries.right - refRect.right,
      height: boundaries.height
    },
    bottom: {
      width: boundaries.width,
      height: boundaries.bottom - refRect.bottom
    },
    left: {
      width: refRect.left - boundaries.left,
      height: boundaries.height
    }
  };

  var sortedAreas = Object.keys(rects).map(function (key) {
    return _extends({
      key: key
    }, rects[key], {
      area: getArea(rects[key])
    });
  }).sort(function (a, b) {
    return b.area - a.area;
  });

  var filteredAreas = sortedAreas.filter(function (_ref2) {
    var width = _ref2.width,
        height = _ref2.height;
    return width >= popper.clientWidth && height >= popper.clientHeight;
  });

  var computedPlacement = filteredAreas.length > 0 ? filteredAreas[0].key : sortedAreas[0].key;

  var variation = placement.split('-')[1];

  return computedPlacement + (variation ? '-' + variation : '');
}

/**
 * Get offsets to the reference element
 * @method
 * @memberof Popper.Utils
 * @param {Object} state
 * @param {Element} popper - the popper element
 * @param {Element} reference - the reference element (the popper will be relative to this)
 * @param {Element} fixedPosition - is in fixed position mode
 * @returns {Object} An object containing the offsets which will be applied to the popper
 */
function getReferenceOffsets(state, popper, reference) {
  var fixedPosition = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : null;

  var commonOffsetParent = fixedPosition ? getFixedPositionOffsetParent(popper) : findCommonOffsetParent(popper, reference);
  return getOffsetRectRelativeToArbitraryNode(reference, commonOffsetParent, fixedPosition);
}

/**
 * Get the outer sizes of the given element (offset size + margins)
 * @method
 * @memberof Popper.Utils
 * @argument {Element} element
 * @returns {Object} object containing width and height properties
 */
function getOuterSizes(element) {
  var window = element.ownerDocument.defaultView;
  var styles = window.getComputedStyle(element);
  var x = parseFloat(styles.marginTop || 0) + parseFloat(styles.marginBottom || 0);
  var y = parseFloat(styles.marginLeft || 0) + parseFloat(styles.marginRight || 0);
  var result = {
    width: element.offsetWidth + y,
    height: element.offsetHeight + x
  };
  return result;
}

/**
 * Get the opposite placement of the given one
 * @method
 * @memberof Popper.Utils
 * @argument {String} placement
 * @returns {String} flipped placement
 */
function getOppositePlacement(placement) {
  var hash = { left: 'right', right: 'left', bottom: 'top', top: 'bottom' };
  return placement.replace(/left|right|bottom|top/g, function (matched) {
    return hash[matched];
  });
}

/**
 * Get offsets to the popper
 * @method
 * @memberof Popper.Utils
 * @param {Object} position - CSS position the Popper will get applied
 * @param {HTMLElement} popper - the popper element
 * @param {Object} referenceOffsets - the reference offsets (the popper will be relative to this)
 * @param {String} placement - one of the valid placement options
 * @returns {Object} popperOffsets - An object containing the offsets which will be applied to the popper
 */
function getPopperOffsets(popper, referenceOffsets, placement) {
  placement = placement.split('-')[0];

  // Get popper node sizes
  var popperRect = getOuterSizes(popper);

  // Add position, width and height to our offsets object
  var popperOffsets = {
    width: popperRect.width,
    height: popperRect.height
  };

  // depending by the popper placement we have to compute its offsets slightly differently
  var isHoriz = ['right', 'left'].indexOf(placement) !== -1;
  var mainSide = isHoriz ? 'top' : 'left';
  var secondarySide = isHoriz ? 'left' : 'top';
  var measurement = isHoriz ? 'height' : 'width';
  var secondaryMeasurement = !isHoriz ? 'height' : 'width';

  popperOffsets[mainSide] = referenceOffsets[mainSide] + referenceOffsets[measurement] / 2 - popperRect[measurement] / 2;
  if (placement === secondarySide) {
    popperOffsets[secondarySide] = referenceOffsets[secondarySide] - popperRect[secondaryMeasurement];
  } else {
    popperOffsets[secondarySide] = referenceOffsets[getOppositePlacement(secondarySide)];
  }

  return popperOffsets;
}

/**
 * Mimics the `find` method of Array
 * @method
 * @memberof Popper.Utils
 * @argument {Array} arr
 * @argument prop
 * @argument value
 * @returns index or -1
 */
function find(arr, check) {
  // use native find if supported
  if (Array.prototype.find) {
    return arr.find(check);
  }

  // use `filter` to obtain the same behavior of `find`
  return arr.filter(check)[0];
}

/**
 * Return the index of the matching object
 * @method
 * @memberof Popper.Utils
 * @argument {Array} arr
 * @argument prop
 * @argument value
 * @returns index or -1
 */
function findIndex(arr, prop, value) {
  // use native findIndex if supported
  if (Array.prototype.findIndex) {
    return arr.findIndex(function (cur) {
      return cur[prop] === value;
    });
  }

  // use `find` + `indexOf` if `findIndex` isn't supported
  var match = find(arr, function (obj) {
    return obj[prop] === value;
  });
  return arr.indexOf(match);
}

/**
 * Loop trough the list of modifiers and run them in order,
 * each of them will then edit the data object.
 * @method
 * @memberof Popper.Utils
 * @param {dataObject} data
 * @param {Array} modifiers
 * @param {String} ends - Optional modifier name used as stopper
 * @returns {dataObject}
 */
function runModifiers(modifiers, data, ends) {
  var modifiersToRun = ends === undefined ? modifiers : modifiers.slice(0, findIndex(modifiers, 'name', ends));

  modifiersToRun.forEach(function (modifier) {
    if (modifier['function']) {
      // eslint-disable-line dot-notation
      console.warn('`modifier.function` is deprecated, use `modifier.fn`!');
    }
    var fn = modifier['function'] || modifier.fn; // eslint-disable-line dot-notation
    if (modifier.enabled && isFunction(fn)) {
      // Add properties to offsets to make them a complete clientRect object
      // we do this before each modifier to make sure the previous one doesn't
      // mess with these values
      data.offsets.popper = getClientRect(data.offsets.popper);
      data.offsets.reference = getClientRect(data.offsets.reference);

      data = fn(data, modifier);
    }
  });

  return data;
}

/**
 * Updates the position of the popper, computing the new offsets and applying
 * the new style.<br />
 * Prefer `scheduleUpdate` over `update` because of performance reasons.
 * @method
 * @memberof Popper
 */
function update() {
  // if popper is destroyed, don't perform any further update
  if (this.state.isDestroyed) {
    return;
  }

  var data = {
    instance: this,
    styles: {},
    arrowStyles: {},
    attributes: {},
    flipped: false,
    offsets: {}
  };

  // compute reference element offsets
  data.offsets.reference = getReferenceOffsets(this.state, this.popper, this.reference, this.options.positionFixed);

  // compute auto placement, store placement inside the data object,
  // modifiers will be able to edit `placement` if needed
  // and refer to originalPlacement to know the original value
  data.placement = computeAutoPlacement(this.options.placement, data.offsets.reference, this.popper, this.reference, this.options.modifiers.flip.boundariesElement, this.options.modifiers.flip.padding);

  // store the computed placement inside `originalPlacement`
  data.originalPlacement = data.placement;

  data.positionFixed = this.options.positionFixed;

  // compute the popper offsets
  data.offsets.popper = getPopperOffsets(this.popper, data.offsets.reference, data.placement);

  data.offsets.popper.position = this.options.positionFixed ? 'fixed' : 'absolute';

  // run the modifiers
  data = runModifiers(this.modifiers, data);

  // the first `update` will call `onCreate` callback
  // the other ones will call `onUpdate` callback
  if (!this.state.isCreated) {
    this.state.isCreated = true;
    this.options.onCreate(data);
  } else {
    this.options.onUpdate(data);
  }
}

/**
 * Helper used to know if the given modifier is enabled.
 * @method
 * @memberof Popper.Utils
 * @returns {Boolean}
 */
function isModifierEnabled(modifiers, modifierName) {
  return modifiers.some(function (_ref) {
    var name = _ref.name,
        enabled = _ref.enabled;
    return enabled && name === modifierName;
  });
}

/**
 * Get the prefixed supported property name
 * @method
 * @memberof Popper.Utils
 * @argument {String} property (camelCase)
 * @returns {String} prefixed property (camelCase or PascalCase, depending on the vendor prefix)
 */
function getSupportedPropertyName(property) {
  var prefixes = [false, 'ms', 'Webkit', 'Moz', 'O'];
  var upperProp = property.charAt(0).toUpperCase() + property.slice(1);

  for (var i = 0; i < prefixes.length; i++) {
    var prefix = prefixes[i];
    var toCheck = prefix ? '' + prefix + upperProp : property;
    if (typeof document.body.style[toCheck] !== 'undefined') {
      return toCheck;
    }
  }
  return null;
}

/**
 * Destroys the popper.
 * @method
 * @memberof Popper
 */
function destroy() {
  this.state.isDestroyed = true;

  // touch DOM only if `applyStyle` modifier is enabled
  if (isModifierEnabled(this.modifiers, 'applyStyle')) {
    this.popper.removeAttribute('x-placement');
    this.popper.style.position = '';
    this.popper.style.top = '';
    this.popper.style.left = '';
    this.popper.style.right = '';
    this.popper.style.bottom = '';
    this.popper.style.willChange = '';
    this.popper.style[getSupportedPropertyName('transform')] = '';
  }

  this.disableEventListeners();

  // remove the popper if user explicity asked for the deletion on destroy
  // do not use `remove` because IE11 doesn't support it
  if (this.options.removeOnDestroy) {
    this.popper.parentNode.removeChild(this.popper);
  }
  return this;
}

/**
 * Get the window associated with the element
 * @argument {Element} element
 * @returns {Window}
 */
function getWindow(element) {
  var ownerDocument = element.ownerDocument;
  return ownerDocument ? ownerDocument.defaultView : window;
}

function attachToScrollParents(scrollParent, event, callback, scrollParents) {
  var isBody = scrollParent.nodeName === 'BODY';
  var target = isBody ? scrollParent.ownerDocument.defaultView : scrollParent;
  target.addEventListener(event, callback, { passive: true });

  if (!isBody) {
    attachToScrollParents(getScrollParent(target.parentNode), event, callback, scrollParents);
  }
  scrollParents.push(target);
}

/**
 * Setup needed event listeners used to update the popper position
 * @method
 * @memberof Popper.Utils
 * @private
 */
function setupEventListeners(reference, options, state, updateBound) {
  // Resize event listener on window
  state.updateBound = updateBound;
  getWindow(reference).addEventListener('resize', state.updateBound, { passive: true });

  // Scroll event listener on scroll parents
  var scrollElement = getScrollParent(reference);
  attachToScrollParents(scrollElement, 'scroll', state.updateBound, state.scrollParents);
  state.scrollElement = scrollElement;
  state.eventsEnabled = true;

  return state;
}

/**
 * It will add resize/scroll events and start recalculating
 * position of the popper element when they are triggered.
 * @method
 * @memberof Popper
 */
function enableEventListeners() {
  if (!this.state.eventsEnabled) {
    this.state = setupEventListeners(this.reference, this.options, this.state, this.scheduleUpdate);
  }
}

/**
 * Remove event listeners used to update the popper position
 * @method
 * @memberof Popper.Utils
 * @private
 */
function removeEventListeners(reference, state) {
  // Remove resize event listener on window
  getWindow(reference).removeEventListener('resize', state.updateBound);

  // Remove scroll event listener on scroll parents
  state.scrollParents.forEach(function (target) {
    target.removeEventListener('scroll', state.updateBound);
  });

  // Reset state
  state.updateBound = null;
  state.scrollParents = [];
  state.scrollElement = null;
  state.eventsEnabled = false;
  return state;
}

/**
 * It will remove resize/scroll events and won't recalculate popper position
 * when they are triggered. It also won't trigger `onUpdate` callback anymore,
 * unless you call `update` method manually.
 * @method
 * @memberof Popper
 */
function disableEventListeners() {
  if (this.state.eventsEnabled) {
    cancelAnimationFrame(this.scheduleUpdate);
    this.state = removeEventListeners(this.reference, this.state);
  }
}

/**
 * Tells if a given input is a number
 * @method
 * @memberof Popper.Utils
 * @param {*} input to check
 * @return {Boolean}
 */
function isNumeric(n) {
  return n !== '' && !isNaN(parseFloat(n)) && isFinite(n);
}

/**
 * Set the style to the given popper
 * @method
 * @memberof Popper.Utils
 * @argument {Element} element - Element to apply the style to
 * @argument {Object} styles
 * Object with a list of properties and values which will be applied to the element
 */
function setStyles(element, styles) {
  Object.keys(styles).forEach(function (prop) {
    var unit = '';
    // add unit if the value is numeric and is one of the following
    if (['width', 'height', 'top', 'right', 'bottom', 'left'].indexOf(prop) !== -1 && isNumeric(styles[prop])) {
      unit = 'px';
    }
    element.style[prop] = styles[prop] + unit;
  });
}

/**
 * Set the attributes to the given popper
 * @method
 * @memberof Popper.Utils
 * @argument {Element} element - Element to apply the attributes to
 * @argument {Object} styles
 * Object with a list of properties and values which will be applied to the element
 */
function setAttributes(element, attributes) {
  Object.keys(attributes).forEach(function (prop) {
    var value = attributes[prop];
    if (value !== false) {
      element.setAttribute(prop, attributes[prop]);
    } else {
      element.removeAttribute(prop);
    }
  });
}

/**
 * @function
 * @memberof Modifiers
 * @argument {Object} data - The data object generated by `update` method
 * @argument {Object} data.styles - List of style properties - values to apply to popper element
 * @argument {Object} data.attributes - List of attribute properties - values to apply to popper element
 * @argument {Object} options - Modifiers configuration and options
 * @returns {Object} The same data object
 */
function applyStyle(data) {
  // any property present in `data.styles` will be applied to the popper,
  // in this way we can make the 3rd party modifiers add custom styles to it
  // Be aware, modifiers could override the properties defined in the previous
  // lines of this modifier!
  setStyles(data.instance.popper, data.styles);

  // any property present in `data.attributes` will be applied to the popper,
  // they will be set as HTML attributes of the element
  setAttributes(data.instance.popper, data.attributes);

  // if arrowElement is defined and arrowStyles has some properties
  if (data.arrowElement && Object.keys(data.arrowStyles).length) {
    setStyles(data.arrowElement, data.arrowStyles);
  }

  return data;
}

/**
 * Set the x-placement attribute before everything else because it could be used
 * to add margins to the popper margins needs to be calculated to get the
 * correct popper offsets.
 * @method
 * @memberof Popper.modifiers
 * @param {HTMLElement} reference - The reference element used to position the popper
 * @param {HTMLElement} popper - The HTML element used as popper
 * @param {Object} options - Popper.js options
 */
function applyStyleOnLoad(reference, popper, options, modifierOptions, state) {
  // compute reference element offsets
  var referenceOffsets = getReferenceOffsets(state, popper, reference, options.positionFixed);

  // compute auto placement, store placement inside the data object,
  // modifiers will be able to edit `placement` if needed
  // and refer to originalPlacement to know the original value
  var placement = computeAutoPlacement(options.placement, referenceOffsets, popper, reference, options.modifiers.flip.boundariesElement, options.modifiers.flip.padding);

  popper.setAttribute('x-placement', placement);

  // Apply `position` to popper before anything else because
  // without the position applied we can't guarantee correct computations
  setStyles(popper, { position: options.positionFixed ? 'fixed' : 'absolute' });

  return options;
}

/**
 * @function
 * @memberof Popper.Utils
 * @argument {Object} data - The data object generated by `update` method
 * @argument {Boolean} shouldRound - If the offsets should be rounded at all
 * @returns {Object} The popper's position offsets rounded
 *
 * The tale of pixel-perfect positioning. It's still not 100% perfect, but as
 * good as it can be within reason.
 * Discussion here: https://github.com/FezVrasta/popper.js/pull/715
 *
 * Low DPI screens cause a popper to be blurry if not using full pixels (Safari
 * as well on High DPI screens).
 *
 * Firefox prefers no rounding for positioning and does not have blurriness on
 * high DPI screens.
 *
 * Only horizontal placement and left/right values need to be considered.
 */
function getRoundedOffsets(data, shouldRound) {
  var _data$offsets = data.offsets,
      popper = _data$offsets.popper,
      reference = _data$offsets.reference;
  var round = Math.round,
      floor = Math.floor;

  var noRound = function noRound(v) {
    return v;
  };

  var referenceWidth = round(reference.width);
  var popperWidth = round(popper.width);

  var isVertical = ['left', 'right'].indexOf(data.placement) !== -1;
  var isVariation = data.placement.indexOf('-') !== -1;
  var sameWidthParity = referenceWidth % 2 === popperWidth % 2;
  var bothOddWidth = referenceWidth % 2 === 1 && popperWidth % 2 === 1;

  var horizontalToInteger = !shouldRound ? noRound : isVertical || isVariation || sameWidthParity ? round : floor;
  var verticalToInteger = !shouldRound ? noRound : round;

  return {
    left: horizontalToInteger(bothOddWidth && !isVariation && shouldRound ? popper.left - 1 : popper.left),
    top: verticalToInteger(popper.top),
    bottom: verticalToInteger(popper.bottom),
    right: horizontalToInteger(popper.right)
  };
}

var isFirefox = isBrowser && /Firefox/i.test(navigator.userAgent);

/**
 * @function
 * @memberof Modifiers
 * @argument {Object} data - The data object generated by `update` method
 * @argument {Object} options - Modifiers configuration and options
 * @returns {Object} The data object, properly modified
 */
function computeStyle(data, options) {
  var x = options.x,
      y = options.y;
  var popper = data.offsets.popper;

  // Remove this legacy support in Popper.js v2

  var legacyGpuAccelerationOption = find(data.instance.modifiers, function (modifier) {
    return modifier.name === 'applyStyle';
  }).gpuAcceleration;
  if (legacyGpuAccelerationOption !== undefined) {
    console.warn('WARNING: `gpuAcceleration` option moved to `computeStyle` modifier and will not be supported in future versions of Popper.js!');
  }
  var gpuAcceleration = legacyGpuAccelerationOption !== undefined ? legacyGpuAccelerationOption : options.gpuAcceleration;

  var offsetParent = getOffsetParent(data.instance.popper);
  var offsetParentRect = getBoundingClientRect(offsetParent);

  // Styles
  var styles = {
    position: popper.position
  };

  var offsets = getRoundedOffsets(data, window.devicePixelRatio < 2 || !isFirefox);

  var sideA = x === 'bottom' ? 'top' : 'bottom';
  var sideB = y === 'right' ? 'left' : 'right';

  // if gpuAcceleration is set to `true` and transform is supported,
  //  we use `translate3d` to apply the position to the popper we
  // automatically use the supported prefixed version if needed
  var prefixedProperty = getSupportedPropertyName('transform');

  // now, let's make a step back and look at this code closely (wtf?)
  // If the content of the popper grows once it's been positioned, it
  // may happen that the popper gets misplaced because of the new content
  // overflowing its reference element
  // To avoid this problem, we provide two options (x and y), which allow
  // the consumer to define the offset origin.
  // If we position a popper on top of a reference element, we can set
  // `x` to `top` to make the popper grow towards its top instead of
  // its bottom.
  var left = void 0,
      top = void 0;
  if (sideA === 'bottom') {
    // when offsetParent is <html> the positioning is relative to the bottom of the screen (excluding the scrollbar)
    // and not the bottom of the html element
    if (offsetParent.nodeName === 'HTML') {
      top = -offsetParent.clientHeight + offsets.bottom;
    } else {
      top = -offsetParentRect.height + offsets.bottom;
    }
  } else {
    top = offsets.top;
  }
  if (sideB === 'right') {
    if (offsetParent.nodeName === 'HTML') {
      left = -offsetParent.clientWidth + offsets.right;
    } else {
      left = -offsetParentRect.width + offsets.right;
    }
  } else {
    left = offsets.left;
  }
  if (gpuAcceleration && prefixedProperty) {
    styles[prefixedProperty] = 'translate3d(' + left + 'px, ' + top + 'px, 0)';
    styles[sideA] = 0;
    styles[sideB] = 0;
    styles.willChange = 'transform';
  } else {
    // othwerise, we use the standard `top`, `left`, `bottom` and `right` properties
    var invertTop = sideA === 'bottom' ? -1 : 1;
    var invertLeft = sideB === 'right' ? -1 : 1;
    styles[sideA] = top * invertTop;
    styles[sideB] = left * invertLeft;
    styles.willChange = sideA + ', ' + sideB;
  }

  // Attributes
  var attributes = {
    'x-placement': data.placement
  };

  // Update `data` attributes, styles and arrowStyles
  data.attributes = _extends({}, attributes, data.attributes);
  data.styles = _extends({}, styles, data.styles);
  data.arrowStyles = _extends({}, data.offsets.arrow, data.arrowStyles);

  return data;
}

/**
 * Helper used to know if the given modifier depends from another one.<br />
 * It checks if the needed modifier is listed and enabled.
 * @method
 * @memberof Popper.Utils
 * @param {Array} modifiers - list of modifiers
 * @param {String} requestingName - name of requesting modifier
 * @param {String} requestedName - name of requested modifier
 * @returns {Boolean}
 */
function isModifierRequired(modifiers, requestingName, requestedName) {
  var requesting = find(modifiers, function (_ref) {
    var name = _ref.name;
    return name === requestingName;
  });

  var isRequired = !!requesting && modifiers.some(function (modifier) {
    return modifier.name === requestedName && modifier.enabled && modifier.order < requesting.order;
  });

  if (!isRequired) {
    var _requesting = '`' + requestingName + '`';
    var requested = '`' + requestedName + '`';
    console.warn(requested + ' modifier is required by ' + _requesting + ' modifier in order to work, be sure to include it before ' + _requesting + '!');
  }
  return isRequired;
}

/**
 * @function
 * @memberof Modifiers
 * @argument {Object} data - The data object generated by update method
 * @argument {Object} options - Modifiers configuration and options
 * @returns {Object} The data object, properly modified
 */
function arrow(data, options) {
  var _data$offsets$arrow;

  // arrow depends on keepTogether in order to work
  if (!isModifierRequired(data.instance.modifiers, 'arrow', 'keepTogether')) {
    return data;
  }

  var arrowElement = options.element;

  // if arrowElement is a string, suppose it's a CSS selector
  if (typeof arrowElement === 'string') {
    arrowElement = data.instance.popper.querySelector(arrowElement);

    // if arrowElement is not found, don't run the modifier
    if (!arrowElement) {
      return data;
    }
  } else {
    // if the arrowElement isn't a query selector we must check that the
    // provided DOM node is child of its popper node
    if (!data.instance.popper.contains(arrowElement)) {
      console.warn('WARNING: `arrow.element` must be child of its popper element!');
      return data;
    }
  }

  var placement = data.placement.split('-')[0];
  var _data$offsets = data.offsets,
      popper = _data$offsets.popper,
      reference = _data$offsets.reference;

  var isVertical = ['left', 'right'].indexOf(placement) !== -1;

  var len = isVertical ? 'height' : 'width';
  var sideCapitalized = isVertical ? 'Top' : 'Left';
  var side = sideCapitalized.toLowerCase();
  var altSide = isVertical ? 'left' : 'top';
  var opSide = isVertical ? 'bottom' : 'right';
  var arrowElementSize = getOuterSizes(arrowElement)[len];

  //
  // extends keepTogether behavior making sure the popper and its
  // reference have enough pixels in conjunction
  //

  // top/left side
  if (reference[opSide] - arrowElementSize < popper[side]) {
    data.offsets.popper[side] -= popper[side] - (reference[opSide] - arrowElementSize);
  }
  // bottom/right side
  if (reference[side] + arrowElementSize > popper[opSide]) {
    data.offsets.popper[side] += reference[side] + arrowElementSize - popper[opSide];
  }
  data.offsets.popper = getClientRect(data.offsets.popper);

  // compute center of the popper
  var center = reference[side] + reference[len] / 2 - arrowElementSize / 2;

  // Compute the sideValue using the updated popper offsets
  // take popper margin in account because we don't have this info available
  var css = getStyleComputedProperty(data.instance.popper);
  var popperMarginSide = parseFloat(css['margin' + sideCapitalized], 10);
  var popperBorderSide = parseFloat(css['border' + sideCapitalized + 'Width'], 10);
  var sideValue = center - data.offsets.popper[side] - popperMarginSide - popperBorderSide;

  // prevent arrowElement from being placed not contiguously to its popper
  sideValue = Math.max(Math.min(popper[len] - arrowElementSize, sideValue), 0);

  data.arrowElement = arrowElement;
  data.offsets.arrow = (_data$offsets$arrow = {}, defineProperty(_data$offsets$arrow, side, Math.round(sideValue)), defineProperty(_data$offsets$arrow, altSide, ''), _data$offsets$arrow);

  return data;
}

/**
 * Get the opposite placement variation of the given one
 * @method
 * @memberof Popper.Utils
 * @argument {String} placement variation
 * @returns {String} flipped placement variation
 */
function getOppositeVariation(variation) {
  if (variation === 'end') {
    return 'start';
  } else if (variation === 'start') {
    return 'end';
  }
  return variation;
}

/**
 * List of accepted placements to use as values of the `placement` option.<br />
 * Valid placements are:
 * - `auto`
 * - `top`
 * - `right`
 * - `bottom`
 * - `left`
 *
 * Each placement can have a variation from this list:
 * - `-start`
 * - `-end`
 *
 * Variations are interpreted easily if you think of them as the left to right
 * written languages. Horizontally (`top` and `bottom`), `start` is left and `end`
 * is right.<br />
 * Vertically (`left` and `right`), `start` is top and `end` is bottom.
 *
 * Some valid examples are:
 * - `top-end` (on top of reference, right aligned)
 * - `right-start` (on right of reference, top aligned)
 * - `bottom` (on bottom, centered)
 * - `auto-end` (on the side with more space available, alignment depends by placement)
 *
 * @static
 * @type {Array}
 * @enum {String}
 * @readonly
 * @method placements
 * @memberof Popper
 */
var placements = ['auto-start', 'auto', 'auto-end', 'top-start', 'top', 'top-end', 'right-start', 'right', 'right-end', 'bottom-end', 'bottom', 'bottom-start', 'left-end', 'left', 'left-start'];

// Get rid of `auto` `auto-start` and `auto-end`
var validPlacements = placements.slice(3);

/**
 * Given an initial placement, returns all the subsequent placements
 * clockwise (or counter-clockwise).
 *
 * @method
 * @memberof Popper.Utils
 * @argument {String} placement - A valid placement (it accepts variations)
 * @argument {Boolean} counter - Set to true to walk the placements counterclockwise
 * @returns {Array} placements including their variations
 */
function clockwise(placement) {
  var counter = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;

  var index = validPlacements.indexOf(placement);
  var arr = validPlacements.slice(index + 1).concat(validPlacements.slice(0, index));
  return counter ? arr.reverse() : arr;
}

var BEHAVIORS = {
  FLIP: 'flip',
  CLOCKWISE: 'clockwise',
  COUNTERCLOCKWISE: 'counterclockwise'
};

/**
 * @function
 * @memberof Modifiers
 * @argument {Object} data - The data object generated by update method
 * @argument {Object} options - Modifiers configuration and options
 * @returns {Object} The data object, properly modified
 */
function flip(data, options) {
  // if `inner` modifier is enabled, we can't use the `flip` modifier
  if (isModifierEnabled(data.instance.modifiers, 'inner')) {
    return data;
  }

  if (data.flipped && data.placement === data.originalPlacement) {
    // seems like flip is trying to loop, probably there's not enough space on any of the flippable sides
    return data;
  }

  var boundaries = getBoundaries(data.instance.popper, data.instance.reference, options.padding, options.boundariesElement, data.positionFixed);

  var placement = data.placement.split('-')[0];
  var placementOpposite = getOppositePlacement(placement);
  var variation = data.placement.split('-')[1] || '';

  var flipOrder = [];

  switch (options.behavior) {
    case BEHAVIORS.FLIP:
      flipOrder = [placement, placementOpposite];
      break;
    case BEHAVIORS.CLOCKWISE:
      flipOrder = clockwise(placement);
      break;
    case BEHAVIORS.COUNTERCLOCKWISE:
      flipOrder = clockwise(placement, true);
      break;
    default:
      flipOrder = options.behavior;
  }

  flipOrder.forEach(function (step, index) {
    if (placement !== step || flipOrder.length === index + 1) {
      return data;
    }

    placement = data.placement.split('-')[0];
    placementOpposite = getOppositePlacement(placement);

    var popperOffsets = data.offsets.popper;
    var refOffsets = data.offsets.reference;

    // using floor because the reference offsets may contain decimals we are not going to consider here
    var floor = Math.floor;
    var overlapsRef = placement === 'left' && floor(popperOffsets.right) > floor(refOffsets.left) || placement === 'right' && floor(popperOffsets.left) < floor(refOffsets.right) || placement === 'top' && floor(popperOffsets.bottom) > floor(refOffsets.top) || placement === 'bottom' && floor(popperOffsets.top) < floor(refOffsets.bottom);

    var overflowsLeft = floor(popperOffsets.left) < floor(boundaries.left);
    var overflowsRight = floor(popperOffsets.right) > floor(boundaries.right);
    var overflowsTop = floor(popperOffsets.top) < floor(boundaries.top);
    var overflowsBottom = floor(popperOffsets.bottom) > floor(boundaries.bottom);

    var overflowsBoundaries = placement === 'left' && overflowsLeft || placement === 'right' && overflowsRight || placement === 'top' && overflowsTop || placement === 'bottom' && overflowsBottom;

    // flip the variation if required
    var isVertical = ['top', 'bottom'].indexOf(placement) !== -1;
    var flippedVariation = !!options.flipVariations && (isVertical && variation === 'start' && overflowsLeft || isVertical && variation === 'end' && overflowsRight || !isVertical && variation === 'start' && overflowsTop || !isVertical && variation === 'end' && overflowsBottom);

    if (overlapsRef || overflowsBoundaries || flippedVariation) {
      // this boolean to detect any flip loop
      data.flipped = true;

      if (overlapsRef || overflowsBoundaries) {
        placement = flipOrder[index + 1];
      }

      if (flippedVariation) {
        variation = getOppositeVariation(variation);
      }

      data.placement = placement + (variation ? '-' + variation : '');

      // this object contains `position`, we want to preserve it along with
      // any additional property we may add in the future
      data.offsets.popper = _extends({}, data.offsets.popper, getPopperOffsets(data.instance.popper, data.offsets.reference, data.placement));

      data = runModifiers(data.instance.modifiers, data, 'flip');
    }
  });
  return data;
}

/**
 * @function
 * @memberof Modifiers
 * @argument {Object} data - The data object generated by update method
 * @argument {Object} options - Modifiers configuration and options
 * @returns {Object} The data object, properly modified
 */
function keepTogether(data) {
  var _data$offsets = data.offsets,
      popper = _data$offsets.popper,
      reference = _data$offsets.reference;

  var placement = data.placement.split('-')[0];
  var floor = Math.floor;
  var isVertical = ['top', 'bottom'].indexOf(placement) !== -1;
  var side = isVertical ? 'right' : 'bottom';
  var opSide = isVertical ? 'left' : 'top';
  var measurement = isVertical ? 'width' : 'height';

  if (popper[side] < floor(reference[opSide])) {
    data.offsets.popper[opSide] = floor(reference[opSide]) - popper[measurement];
  }
  if (popper[opSide] > floor(reference[side])) {
    data.offsets.popper[opSide] = floor(reference[side]);
  }

  return data;
}

/**
 * Converts a string containing value + unit into a px value number
 * @function
 * @memberof {modifiers~offset}
 * @private
 * @argument {String} str - Value + unit string
 * @argument {String} measurement - `height` or `width`
 * @argument {Object} popperOffsets
 * @argument {Object} referenceOffsets
 * @returns {Number|String}
 * Value in pixels, or original string if no values were extracted
 */
function toValue(str, measurement, popperOffsets, referenceOffsets) {
  // separate value from unit
  var split = str.match(/((?:\-|\+)?\d*\.?\d*)(.*)/);
  var value = +split[1];
  var unit = split[2];

  // If it's not a number it's an operator, I guess
  if (!value) {
    return str;
  }

  if (unit.indexOf('%') === 0) {
    var element = void 0;
    switch (unit) {
      case '%p':
        element = popperOffsets;
        break;
      case '%':
      case '%r':
      default:
        element = referenceOffsets;
    }

    var rect = getClientRect(element);
    return rect[measurement] / 100 * value;
  } else if (unit === 'vh' || unit === 'vw') {
    // if is a vh or vw, we calculate the size based on the viewport
    var size = void 0;
    if (unit === 'vh') {
      size = Math.max(document.documentElement.clientHeight, window.innerHeight || 0);
    } else {
      size = Math.max(document.documentElement.clientWidth, window.innerWidth || 0);
    }
    return size / 100 * value;
  } else {
    // if is an explicit pixel unit, we get rid of the unit and keep the value
    // if is an implicit unit, it's px, and we return just the value
    return value;
  }
}

/**
 * Parse an `offset` string to extrapolate `x` and `y` numeric offsets.
 * @function
 * @memberof {modifiers~offset}
 * @private
 * @argument {String} offset
 * @argument {Object} popperOffsets
 * @argument {Object} referenceOffsets
 * @argument {String} basePlacement
 * @returns {Array} a two cells array with x and y offsets in numbers
 */
function parseOffset(offset, popperOffsets, referenceOffsets, basePlacement) {
  var offsets = [0, 0];

  // Use height if placement is left or right and index is 0 otherwise use width
  // in this way the first offset will use an axis and the second one
  // will use the other one
  var useHeight = ['right', 'left'].indexOf(basePlacement) !== -1;

  // Split the offset string to obtain a list of values and operands
  // The regex addresses values with the plus or minus sign in front (+10, -20, etc)
  var fragments = offset.split(/(\+|\-)/).map(function (frag) {
    return frag.trim();
  });

  // Detect if the offset string contains a pair of values or a single one
  // they could be separated by comma or space
  var divider = fragments.indexOf(find(fragments, function (frag) {
    return frag.search(/,|\s/) !== -1;
  }));

  if (fragments[divider] && fragments[divider].indexOf(',') === -1) {
    console.warn('Offsets separated by white space(s) are deprecated, use a comma (,) instead.');
  }

  // If divider is found, we divide the list of values and operands to divide
  // them by ofset X and Y.
  var splitRegex = /\s*,\s*|\s+/;
  var ops = divider !== -1 ? [fragments.slice(0, divider).concat([fragments[divider].split(splitRegex)[0]]), [fragments[divider].split(splitRegex)[1]].concat(fragments.slice(divider + 1))] : [fragments];

  // Convert the values with units to absolute pixels to allow our computations
  ops = ops.map(function (op, index) {
    // Most of the units rely on the orientation of the popper
    var measurement = (index === 1 ? !useHeight : useHeight) ? 'height' : 'width';
    var mergeWithPrevious = false;
    return op
    // This aggregates any `+` or `-` sign that aren't considered operators
    // e.g.: 10 + +5 => [10, +, +5]
    .reduce(function (a, b) {
      if (a[a.length - 1] === '' && ['+', '-'].indexOf(b) !== -1) {
        a[a.length - 1] = b;
        mergeWithPrevious = true;
        return a;
      } else if (mergeWithPrevious) {
        a[a.length - 1] += b;
        mergeWithPrevious = false;
        return a;
      } else {
        return a.concat(b);
      }
    }, [])
    // Here we convert the string values into number values (in px)
    .map(function (str) {
      return toValue(str, measurement, popperOffsets, referenceOffsets);
    });
  });

  // Loop trough the offsets arrays and execute the operations
  ops.forEach(function (op, index) {
    op.forEach(function (frag, index2) {
      if (isNumeric(frag)) {
        offsets[index] += frag * (op[index2 - 1] === '-' ? -1 : 1);
      }
    });
  });
  return offsets;
}

/**
 * @function
 * @memberof Modifiers
 * @argument {Object} data - The data object generated by update method
 * @argument {Object} options - Modifiers configuration and options
 * @argument {Number|String} options.offset=0
 * The offset value as described in the modifier description
 * @returns {Object} The data object, properly modified
 */
function offset(data, _ref) {
  var offset = _ref.offset;
  var placement = data.placement,
      _data$offsets = data.offsets,
      popper = _data$offsets.popper,
      reference = _data$offsets.reference;

  var basePlacement = placement.split('-')[0];

  var offsets = void 0;
  if (isNumeric(+offset)) {
    offsets = [+offset, 0];
  } else {
    offsets = parseOffset(offset, popper, reference, basePlacement);
  }

  if (basePlacement === 'left') {
    popper.top += offsets[0];
    popper.left -= offsets[1];
  } else if (basePlacement === 'right') {
    popper.top += offsets[0];
    popper.left += offsets[1];
  } else if (basePlacement === 'top') {
    popper.left += offsets[0];
    popper.top -= offsets[1];
  } else if (basePlacement === 'bottom') {
    popper.left += offsets[0];
    popper.top += offsets[1];
  }

  data.popper = popper;
  return data;
}

/**
 * @function
 * @memberof Modifiers
 * @argument {Object} data - The data object generated by `update` method
 * @argument {Object} options - Modifiers configuration and options
 * @returns {Object} The data object, properly modified
 */
function preventOverflow(data, options) {
  var boundariesElement = options.boundariesElement || getOffsetParent(data.instance.popper);

  // If offsetParent is the reference element, we really want to
  // go one step up and use the next offsetParent as reference to
  // avoid to make this modifier completely useless and look like broken
  if (data.instance.reference === boundariesElement) {
    boundariesElement = getOffsetParent(boundariesElement);
  }

  // NOTE: DOM access here
  // resets the popper's position so that the document size can be calculated excluding
  // the size of the popper element itself
  var transformProp = getSupportedPropertyName('transform');
  var popperStyles = data.instance.popper.style; // assignment to help minification
  var top = popperStyles.top,
      left = popperStyles.left,
      transform = popperStyles[transformProp];

  popperStyles.top = '';
  popperStyles.left = '';
  popperStyles[transformProp] = '';

  var boundaries = getBoundaries(data.instance.popper, data.instance.reference, options.padding, boundariesElement, data.positionFixed);

  // NOTE: DOM access here
  // restores the original style properties after the offsets have been computed
  popperStyles.top = top;
  popperStyles.left = left;
  popperStyles[transformProp] = transform;

  options.boundaries = boundaries;

  var order = options.priority;
  var popper = data.offsets.popper;

  var check = {
    primary: function primary(placement) {
      var value = popper[placement];
      if (popper[placement] < boundaries[placement] && !options.escapeWithReference) {
        value = Math.max(popper[placement], boundaries[placement]);
      }
      return defineProperty({}, placement, value);
    },
    secondary: function secondary(placement) {
      var mainSide = placement === 'right' ? 'left' : 'top';
      var value = popper[mainSide];
      if (popper[placement] > boundaries[placement] && !options.escapeWithReference) {
        value = Math.min(popper[mainSide], boundaries[placement] - (placement === 'right' ? popper.width : popper.height));
      }
      return defineProperty({}, mainSide, value);
    }
  };

  order.forEach(function (placement) {
    var side = ['left', 'top'].indexOf(placement) !== -1 ? 'primary' : 'secondary';
    popper = _extends({}, popper, check[side](placement));
  });

  data.offsets.popper = popper;

  return data;
}

/**
 * @function
 * @memberof Modifiers
 * @argument {Object} data - The data object generated by `update` method
 * @argument {Object} options - Modifiers configuration and options
 * @returns {Object} The data object, properly modified
 */
function shift(data) {
  var placement = data.placement;
  var basePlacement = placement.split('-')[0];
  var shiftvariation = placement.split('-')[1];

  // if shift shiftvariation is specified, run the modifier
  if (shiftvariation) {
    var _data$offsets = data.offsets,
        reference = _data$offsets.reference,
        popper = _data$offsets.popper;

    var isVertical = ['bottom', 'top'].indexOf(basePlacement) !== -1;
    var side = isVertical ? 'left' : 'top';
    var measurement = isVertical ? 'width' : 'height';

    var shiftOffsets = {
      start: defineProperty({}, side, reference[side]),
      end: defineProperty({}, side, reference[side] + reference[measurement] - popper[measurement])
    };

    data.offsets.popper = _extends({}, popper, shiftOffsets[shiftvariation]);
  }

  return data;
}

/**
 * @function
 * @memberof Modifiers
 * @argument {Object} data - The data object generated by update method
 * @argument {Object} options - Modifiers configuration and options
 * @returns {Object} The data object, properly modified
 */
function hide(data) {
  if (!isModifierRequired(data.instance.modifiers, 'hide', 'preventOverflow')) {
    return data;
  }

  var refRect = data.offsets.reference;
  var bound = find(data.instance.modifiers, function (modifier) {
    return modifier.name === 'preventOverflow';
  }).boundaries;

  if (refRect.bottom < bound.top || refRect.left > bound.right || refRect.top > bound.bottom || refRect.right < bound.left) {
    // Avoid unnecessary DOM access if visibility hasn't changed
    if (data.hide === true) {
      return data;
    }

    data.hide = true;
    data.attributes['x-out-of-boundaries'] = '';
  } else {
    // Avoid unnecessary DOM access if visibility hasn't changed
    if (data.hide === false) {
      return data;
    }

    data.hide = false;
    data.attributes['x-out-of-boundaries'] = false;
  }

  return data;
}

/**
 * @function
 * @memberof Modifiers
 * @argument {Object} data - The data object generated by `update` method
 * @argument {Object} options - Modifiers configuration and options
 * @returns {Object} The data object, properly modified
 */
function inner(data) {
  var placement = data.placement;
  var basePlacement = placement.split('-')[0];
  var _data$offsets = data.offsets,
      popper = _data$offsets.popper,
      reference = _data$offsets.reference;

  var isHoriz = ['left', 'right'].indexOf(basePlacement) !== -1;

  var subtractLength = ['top', 'left'].indexOf(basePlacement) === -1;

  popper[isHoriz ? 'left' : 'top'] = reference[basePlacement] - (subtractLength ? popper[isHoriz ? 'width' : 'height'] : 0);

  data.placement = getOppositePlacement(placement);
  data.offsets.popper = getClientRect(popper);

  return data;
}

/**
 * Modifier function, each modifier can have a function of this type assigned
 * to its `fn` property.<br />
 * These functions will be called on each update, this means that you must
 * make sure they are performant enough to avoid performance bottlenecks.
 *
 * @function ModifierFn
 * @argument {dataObject} data - The data object generated by `update` method
 * @argument {Object} options - Modifiers configuration and options
 * @returns {dataObject} The data object, properly modified
 */

/**
 * Modifiers are plugins used to alter the behavior of your poppers.<br />
 * Popper.js uses a set of 9 modifiers to provide all the basic functionalities
 * needed by the library.
 *
 * Usually you don't want to override the `order`, `fn` and `onLoad` props.
 * All the other properties are configurations that could be tweaked.
 * @namespace modifiers
 */
var modifiers = {
  /**
   * Modifier used to shift the popper on the start or end of its reference
   * element.<br />
   * It will read the variation of the `placement` property.<br />
   * It can be one either `-end` or `-start`.
   * @memberof modifiers
   * @inner
   */
  shift: {
    /** @prop {number} order=100 - Index used to define the order of execution */
    order: 100,
    /** @prop {Boolean} enabled=true - Whether the modifier is enabled or not */
    enabled: true,
    /** @prop {ModifierFn} */
    fn: shift
  },

  /**
   * The `offset` modifier can shift your popper on both its axis.
   *
   * It accepts the following units:
   * - `px` or unit-less, interpreted as pixels
   * - `%` or `%r`, percentage relative to the length of the reference element
   * - `%p`, percentage relative to the length of the popper element
   * - `vw`, CSS viewport width unit
   * - `vh`, CSS viewport height unit
   *
   * For length is intended the main axis relative to the placement of the popper.<br />
   * This means that if the placement is `top` or `bottom`, the length will be the
   * `width`. In case of `left` or `right`, it will be the `height`.
   *
   * You can provide a single value (as `Number` or `String`), or a pair of values
   * as `String` divided by a comma or one (or more) white spaces.<br />
   * The latter is a deprecated method because it leads to confusion and will be
   * removed in v2.<br />
   * Additionally, it accepts additions and subtractions between different units.
   * Note that multiplications and divisions aren't supported.
   *
   * Valid examples are:
   * ```
   * 10
   * '10%'
   * '10, 10'
   * '10%, 10'
   * '10 + 10%'
   * '10 - 5vh + 3%'
   * '-10px + 5vh, 5px - 6%'
   * ```
   * > **NB**: If you desire to apply offsets to your poppers in a way that may make them overlap
   * > with their reference element, unfortunately, you will have to disable the `flip` modifier.
   * > You can read more on this at this [issue](https://github.com/FezVrasta/popper.js/issues/373).
   *
   * @memberof modifiers
   * @inner
   */
  offset: {
    /** @prop {number} order=200 - Index used to define the order of execution */
    order: 200,
    /** @prop {Boolean} enabled=true - Whether the modifier is enabled or not */
    enabled: true,
    /** @prop {ModifierFn} */
    fn: offset,
    /** @prop {Number|String} offset=0
     * The offset value as described in the modifier description
     */
    offset: 0
  },

  /**
   * Modifier used to prevent the popper from being positioned outside the boundary.
   *
   * A scenario exists where the reference itself is not within the boundaries.<br />
   * We can say it has "escaped the boundaries" — or just "escaped".<br />
   * In this case we need to decide whether the popper should either:
   *
   * - detach from the reference and remain "trapped" in the boundaries, or
   * - if it should ignore the boundary and "escape with its reference"
   *
   * When `escapeWithReference` is set to`true` and reference is completely
   * outside its boundaries, the popper will overflow (or completely leave)
   * the boundaries in order to remain attached to the edge of the reference.
   *
   * @memberof modifiers
   * @inner
   */
  preventOverflow: {
    /** @prop {number} order=300 - Index used to define the order of execution */
    order: 300,
    /** @prop {Boolean} enabled=true - Whether the modifier is enabled or not */
    enabled: true,
    /** @prop {ModifierFn} */
    fn: preventOverflow,
    /**
     * @prop {Array} [priority=['left','right','top','bottom']]
     * Popper will try to prevent overflow following these priorities by default,
     * then, it could overflow on the left and on top of the `boundariesElement`
     */
    priority: ['left', 'right', 'top', 'bottom'],
    /**
     * @prop {number} padding=5
     * Amount of pixel used to define a minimum distance between the boundaries
     * and the popper. This makes sure the popper always has a little padding
     * between the edges of its container
     */
    padding: 5,
    /**
     * @prop {String|HTMLElement} boundariesElement='scrollParent'
     * Boundaries used by the modifier. Can be `scrollParent`, `window`,
     * `viewport` or any DOM element.
     */
    boundariesElement: 'scrollParent'
  },

  /**
   * Modifier used to make sure the reference and its popper stay near each other
   * without leaving any gap between the two. Especially useful when the arrow is
   * enabled and you want to ensure that it points to its reference element.
   * It cares only about the first axis. You can still have poppers with margin
   * between the popper and its reference element.
   * @memberof modifiers
   * @inner
   */
  keepTogether: {
    /** @prop {number} order=400 - Index used to define the order of execution */
    order: 400,
    /** @prop {Boolean} enabled=true - Whether the modifier is enabled or not */
    enabled: true,
    /** @prop {ModifierFn} */
    fn: keepTogether
  },

  /**
   * This modifier is used to move the `arrowElement` of the popper to make
   * sure it is positioned between the reference element and its popper element.
   * It will read the outer size of the `arrowElement` node to detect how many
   * pixels of conjunction are needed.
   *
   * It has no effect if no `arrowElement` is provided.
   * @memberof modifiers
   * @inner
   */
  arrow: {
    /** @prop {number} order=500 - Index used to define the order of execution */
    order: 500,
    /** @prop {Boolean} enabled=true - Whether the modifier is enabled or not */
    enabled: true,
    /** @prop {ModifierFn} */
    fn: arrow,
    /** @prop {String|HTMLElement} element='[x-arrow]' - Selector or node used as arrow */
    element: '[x-arrow]'
  },

  /**
   * Modifier used to flip the popper's placement when it starts to overlap its
   * reference element.
   *
   * Requires the `preventOverflow` modifier before it in order to work.
   *
   * **NOTE:** this modifier will interrupt the current update cycle and will
   * restart it if it detects the need to flip the placement.
   * @memberof modifiers
   * @inner
   */
  flip: {
    /** @prop {number} order=600 - Index used to define the order of execution */
    order: 600,
    /** @prop {Boolean} enabled=true - Whether the modifier is enabled or not */
    enabled: true,
    /** @prop {ModifierFn} */
    fn: flip,
    /**
     * @prop {String|Array} behavior='flip'
     * The behavior used to change the popper's placement. It can be one of
     * `flip`, `clockwise`, `counterclockwise` or an array with a list of valid
     * placements (with optional variations)
     */
    behavior: 'flip',
    /**
     * @prop {number} padding=5
     * The popper will flip if it hits the edges of the `boundariesElement`
     */
    padding: 5,
    /**
     * @prop {String|HTMLElement} boundariesElement='viewport'
     * The element which will define the boundaries of the popper position.
     * The popper will never be placed outside of the defined boundaries
     * (except if `keepTogether` is enabled)
     */
    boundariesElement: 'viewport'
  },

  /**
   * Modifier used to make the popper flow toward the inner of the reference element.
   * By default, when this modifier is disabled, the popper will be placed outside
   * the reference element.
   * @memberof modifiers
   * @inner
   */
  inner: {
    /** @prop {number} order=700 - Index used to define the order of execution */
    order: 700,
    /** @prop {Boolean} enabled=false - Whether the modifier is enabled or not */
    enabled: false,
    /** @prop {ModifierFn} */
    fn: inner
  },

  /**
   * Modifier used to hide the popper when its reference element is outside of the
   * popper boundaries. It will set a `x-out-of-boundaries` attribute which can
   * be used to hide with a CSS selector the popper when its reference is
   * out of boundaries.
   *
   * Requires the `preventOverflow` modifier before it in order to work.
   * @memberof modifiers
   * @inner
   */
  hide: {
    /** @prop {number} order=800 - Index used to define the order of execution */
    order: 800,
    /** @prop {Boolean} enabled=true - Whether the modifier is enabled or not */
    enabled: true,
    /** @prop {ModifierFn} */
    fn: hide
  },

  /**
   * Computes the style that will be applied to the popper element to gets
   * properly positioned.
   *
   * Note that this modifier will not touch the DOM, it just prepares the styles
   * so that `applyStyle` modifier can apply it. This separation is useful
   * in case you need to replace `applyStyle` with a custom implementation.
   *
   * This modifier has `850` as `order` value to maintain backward compatibility
   * with previous versions of Popper.js. Expect the modifiers ordering method
   * to change in future major versions of the library.
   *
   * @memberof modifiers
   * @inner
   */
  computeStyle: {
    /** @prop {number} order=850 - Index used to define the order of execution */
    order: 850,
    /** @prop {Boolean} enabled=true - Whether the modifier is enabled or not */
    enabled: true,
    /** @prop {ModifierFn} */
    fn: computeStyle,
    /**
     * @prop {Boolean} gpuAcceleration=true
     * If true, it uses the CSS 3D transformation to position the popper.
     * Otherwise, it will use the `top` and `left` properties
     */
    gpuAcceleration: true,
    /**
     * @prop {string} [x='bottom']
     * Where to anchor the X axis (`bottom` or `top`). AKA X offset origin.
     * Change this if your popper should grow in a direction different from `bottom`
     */
    x: 'bottom',
    /**
     * @prop {string} [x='left']
     * Where to anchor the Y axis (`left` or `right`). AKA Y offset origin.
     * Change this if your popper should grow in a direction different from `right`
     */
    y: 'right'
  },

  /**
   * Applies the computed styles to the popper element.
   *
   * All the DOM manipulations are limited to this modifier. This is useful in case
   * you want to integrate Popper.js inside a framework or view library and you
   * want to delegate all the DOM manipulations to it.
   *
   * Note that if you disable this modifier, you must make sure the popper element
   * has its position set to `absolute` before Popper.js can do its work!
   *
   * Just disable this modifier and define your own to achieve the desired effect.
   *
   * @memberof modifiers
   * @inner
   */
  applyStyle: {
    /** @prop {number} order=900 - Index used to define the order of execution */
    order: 900,
    /** @prop {Boolean} enabled=true - Whether the modifier is enabled or not */
    enabled: true,
    /** @prop {ModifierFn} */
    fn: applyStyle,
    /** @prop {Function} */
    onLoad: applyStyleOnLoad,
    /**
     * @deprecated since version 1.10.0, the property moved to `computeStyle` modifier
     * @prop {Boolean} gpuAcceleration=true
     * If true, it uses the CSS 3D transformation to position the popper.
     * Otherwise, it will use the `top` and `left` properties
     */
    gpuAcceleration: undefined
  }
};

/**
 * The `dataObject` is an object containing all the information used by Popper.js.
 * This object is passed to modifiers and to the `onCreate` and `onUpdate` callbacks.
 * @name dataObject
 * @property {Object} data.instance The Popper.js instance
 * @property {String} data.placement Placement applied to popper
 * @property {String} data.originalPlacement Placement originally defined on init
 * @property {Boolean} data.flipped True if popper has been flipped by flip modifier
 * @property {Boolean} data.hide True if the reference element is out of boundaries, useful to know when to hide the popper
 * @property {HTMLElement} data.arrowElement Node used as arrow by arrow modifier
 * @property {Object} data.styles Any CSS property defined here will be applied to the popper. It expects the JavaScript nomenclature (eg. `marginBottom`)
 * @property {Object} data.arrowStyles Any CSS property defined here will be applied to the popper arrow. It expects the JavaScript nomenclature (eg. `marginBottom`)
 * @property {Object} data.boundaries Offsets of the popper boundaries
 * @property {Object} data.offsets The measurements of popper, reference and arrow elements
 * @property {Object} data.offsets.popper `top`, `left`, `width`, `height` values
 * @property {Object} data.offsets.reference `top`, `left`, `width`, `height` values
 * @property {Object} data.offsets.arrow] `top` and `left` offsets, only one of them will be different from 0
 */

/**
 * Default options provided to Popper.js constructor.<br />
 * These can be overridden using the `options` argument of Popper.js.<br />
 * To override an option, simply pass an object with the same
 * structure of the `options` object, as the 3rd argument. For example:
 * ```
 * new Popper(ref, pop, {
 *   modifiers: {
 *     preventOverflow: { enabled: false }
 *   }
 * })
 * ```
 * @type {Object}
 * @static
 * @memberof Popper
 */
var Defaults = {
  /**
   * Popper's placement.
   * @prop {Popper.placements} placement='bottom'
   */
  placement: 'bottom',

  /**
   * Set this to true if you want popper to position it self in 'fixed' mode
   * @prop {Boolean} positionFixed=false
   */
  positionFixed: false,

  /**
   * Whether events (resize, scroll) are initially enabled.
   * @prop {Boolean} eventsEnabled=true
   */
  eventsEnabled: true,

  /**
   * Set to true if you want to automatically remove the popper when
   * you call the `destroy` method.
   * @prop {Boolean} removeOnDestroy=false
   */
  removeOnDestroy: false,

  /**
   * Callback called when the popper is created.<br />
   * By default, it is set to no-op.<br />
   * Access Popper.js instance with `data.instance`.
   * @prop {onCreate}
   */
  onCreate: function onCreate() {},

  /**
   * Callback called when the popper is updated. This callback is not called
   * on the initialization/creation of the popper, but only on subsequent
   * updates.<br />
   * By default, it is set to no-op.<br />
   * Access Popper.js instance with `data.instance`.
   * @prop {onUpdate}
   */
  onUpdate: function onUpdate() {},

  /**
   * List of modifiers used to modify the offsets before they are applied to the popper.
   * They provide most of the functionalities of Popper.js.
   * @prop {modifiers}
   */
  modifiers: modifiers
};

/**
 * @callback onCreate
 * @param {dataObject} data
 */

/**
 * @callback onUpdate
 * @param {dataObject} data
 */

// Utils
// Methods
var Popper = function () {
  /**
   * Creates a new Popper.js instance.
   * @class Popper
   * @param {HTMLElement|referenceObject} reference - The reference element used to position the popper
   * @param {HTMLElement} popper - The HTML element used as the popper
   * @param {Object} options - Your custom options to override the ones defined in [Defaults](#defaults)
   * @return {Object} instance - The generated Popper.js instance
   */
  function Popper(reference, popper) {
    var _this = this;

    var options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
    classCallCheck(this, Popper);

    this.scheduleUpdate = function () {
      return requestAnimationFrame(_this.update);
    };

    // make update() debounced, so that it only runs at most once-per-tick
    this.update = debounce(this.update.bind(this));

    // with {} we create a new object with the options inside it
    this.options = _extends({}, Popper.Defaults, options);

    // init state
    this.state = {
      isDestroyed: false,
      isCreated: false,
      scrollParents: []
    };

    // get reference and popper elements (allow jQuery wrappers)
    this.reference = reference && reference.jquery ? reference[0] : reference;
    this.popper = popper && popper.jquery ? popper[0] : popper;

    // Deep merge modifiers options
    this.options.modifiers = {};
    Object.keys(_extends({}, Popper.Defaults.modifiers, options.modifiers)).forEach(function (name) {
      _this.options.modifiers[name] = _extends({}, Popper.Defaults.modifiers[name] || {}, options.modifiers ? options.modifiers[name] : {});
    });

    // Refactoring modifiers' list (Object => Array)
    this.modifiers = Object.keys(this.options.modifiers).map(function (name) {
      return _extends({
        name: name
      }, _this.options.modifiers[name]);
    })
    // sort the modifiers by order
    .sort(function (a, b) {
      return a.order - b.order;
    });

    // modifiers have the ability to execute arbitrary code when Popper.js get inited
    // such code is executed in the same order of its modifier
    // they could add new properties to their options configuration
    // BE AWARE: don't add options to `options.modifiers.name` but to `modifierOptions`!
    this.modifiers.forEach(function (modifierOptions) {
      if (modifierOptions.enabled && isFunction(modifierOptions.onLoad)) {
        modifierOptions.onLoad(_this.reference, _this.popper, _this.options, modifierOptions, _this.state);
      }
    });

    // fire the first update to position the popper in the right place
    this.update();

    var eventsEnabled = this.options.eventsEnabled;
    if (eventsEnabled) {
      // setup event listeners, they will take care of update the position in specific situations
      this.enableEventListeners();
    }

    this.state.eventsEnabled = eventsEnabled;
  }

  // We can't use class properties because they don't get listed in the
  // class prototype and break stuff like Sinon stubs


  createClass(Popper, [{
    key: 'update',
    value: function update$$1() {
      return update.call(this);
    }
  }, {
    key: 'destroy',
    value: function destroy$$1() {
      return destroy.call(this);
    }
  }, {
    key: 'enableEventListeners',
    value: function enableEventListeners$$1() {
      return enableEventListeners.call(this);
    }
  }, {
    key: 'disableEventListeners',
    value: function disableEventListeners$$1() {
      return disableEventListeners.call(this);
    }

    /**
     * Schedules an update. It will run on the next UI update available.
     * @method scheduleUpdate
     * @memberof Popper
     */


    /**
     * Collection of utilities useful when writing custom modifiers.
     * Starting from version 1.7, this method is available only if you
     * include `popper-utils.js` before `popper.js`.
     *
     * **DEPRECATION**: This way to access PopperUtils is deprecated
     * and will be removed in v2! Use the PopperUtils module directly instead.
     * Due to the high instability of the methods contained in Utils, we can't
     * guarantee them to follow semver. Use them at your own risk!
     * @static
     * @private
     * @type {Object}
     * @deprecated since version 1.8
     * @member Utils
     * @memberof Popper
     */

  }]);
  return Popper;
}();

/**
 * The `referenceObject` is an object that provides an interface compatible with Popper.js
 * and lets you use it as replacement of a real DOM node.<br />
 * You can use this method to position a popper relatively to a set of coordinates
 * in case you don't have a DOM node to use as reference.
 *
 * ```
 * new Popper(referenceObject, popperNode);
 * ```
 *
 * NB: This feature isn't supported in Internet Explorer 10.
 * @name referenceObject
 * @property {Function} data.getBoundingClientRect
 * A function that returns a set of coordinates compatible with the native `getBoundingClientRect` method.
 * @property {number} data.clientWidth
 * An ES6 getter that will return the width of the virtual reference element.
 * @property {number} data.clientHeight
 * An ES6 getter that will return the height of the virtual reference element.
 */


Popper.Utils = (typeof window !== 'undefined' ? window : global).PopperUtils;
Popper.placements = placements;
Popper.Defaults = Defaults;

/* harmony default export */ __webpack_exports__["a"] = (Popper);
//# sourceMappingURL=popper.js.map

/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__(5)))

/***/ }),
/* 1211 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
exports.default = void 0;

var PropTypes = _interopRequireWildcard(__webpack_require__(1116));

var _addClass = _interopRequireDefault(__webpack_require__(1214));

var _removeClass = _interopRequireDefault(__webpack_require__(1217));

var _react = _interopRequireDefault(__webpack_require__(71));

var _Transition = _interopRequireDefault(__webpack_require__(1136));

var _PropTypes = __webpack_require__(1137);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = Object.defineProperty && Object.getOwnPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : {}; if (desc.get || desc.set) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } } newObj.default = obj; return newObj; } }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _inheritsLoose(subClass, superClass) { subClass.prototype = Object.create(superClass.prototype); subClass.prototype.constructor = subClass; subClass.__proto__ = superClass; }

var addClass = function addClass(node, classes) {
  return node && classes && classes.split(' ').forEach(function (c) {
    return (0, _addClass.default)(node, c);
  });
};

var removeClass = function removeClass(node, classes) {
  return node && classes && classes.split(' ').forEach(function (c) {
    return (0, _removeClass.default)(node, c);
  });
};
/**
 * A `Transition` component using CSS transitions and animations.
 * It's inspired by the excellent [ng-animate](http://www.nganimate.org/) library.
 *
 * `CSSTransition` applies a pair of class names during the `appear`, `enter`,
 * and `exit` stages of the transition. The first class is applied and then a
 * second "active" class in order to activate the css animation. After the animation,
 * matching `done` class names are applied to persist the animation state.
 *
 * When the `in` prop is toggled to `true` the Component will get
 * the `example-enter` CSS class and the `example-enter-active` CSS class
 * added in the next tick. This is a convention based on the `classNames` prop.
 */


var CSSTransition =
/*#__PURE__*/
function (_React$Component) {
  _inheritsLoose(CSSTransition, _React$Component);

  function CSSTransition() {
    var _this;

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _React$Component.call.apply(_React$Component, [this].concat(args)) || this;

    _this.onEnter = function (node, appearing) {
      var _this$getClassNames = _this.getClassNames(appearing ? 'appear' : 'enter'),
          className = _this$getClassNames.className;

      _this.removeClasses(node, 'exit');

      addClass(node, className);

      if (_this.props.onEnter) {
        _this.props.onEnter(node, appearing);
      }
    };

    _this.onEntering = function (node, appearing) {
      var _this$getClassNames2 = _this.getClassNames(appearing ? 'appear' : 'enter'),
          activeClassName = _this$getClassNames2.activeClassName;

      _this.reflowAndAddClass(node, activeClassName);

      if (_this.props.onEntering) {
        _this.props.onEntering(node, appearing);
      }
    };

    _this.onEntered = function (node, appearing) {
      var _this$getClassNames3 = _this.getClassNames('enter'),
          doneClassName = _this$getClassNames3.doneClassName;

      _this.removeClasses(node, appearing ? 'appear' : 'enter');

      addClass(node, doneClassName);

      if (_this.props.onEntered) {
        _this.props.onEntered(node, appearing);
      }
    };

    _this.onExit = function (node) {
      var _this$getClassNames4 = _this.getClassNames('exit'),
          className = _this$getClassNames4.className;

      _this.removeClasses(node, 'appear');

      _this.removeClasses(node, 'enter');

      addClass(node, className);

      if (_this.props.onExit) {
        _this.props.onExit(node);
      }
    };

    _this.onExiting = function (node) {
      var _this$getClassNames5 = _this.getClassNames('exit'),
          activeClassName = _this$getClassNames5.activeClassName;

      _this.reflowAndAddClass(node, activeClassName);

      if (_this.props.onExiting) {
        _this.props.onExiting(node);
      }
    };

    _this.onExited = function (node) {
      var _this$getClassNames6 = _this.getClassNames('exit'),
          doneClassName = _this$getClassNames6.doneClassName;

      _this.removeClasses(node, 'exit');

      addClass(node, doneClassName);

      if (_this.props.onExited) {
        _this.props.onExited(node);
      }
    };

    _this.getClassNames = function (type) {
      var classNames = _this.props.classNames;
      var className = typeof classNames !== 'string' ? classNames[type] : classNames + '-' + type;
      var activeClassName = typeof classNames !== 'string' ? classNames[type + 'Active'] : className + '-active';
      var doneClassName = typeof classNames !== 'string' ? classNames[type + 'Done'] : className + '-done';
      return {
        className: className,
        activeClassName: activeClassName,
        doneClassName: doneClassName
      };
    };

    return _this;
  }

  var _proto = CSSTransition.prototype;

  _proto.removeClasses = function removeClasses(node, type) {
    var _this$getClassNames7 = this.getClassNames(type),
        className = _this$getClassNames7.className,
        activeClassName = _this$getClassNames7.activeClassName,
        doneClassName = _this$getClassNames7.doneClassName;

    className && removeClass(node, className);
    activeClassName && removeClass(node, activeClassName);
    doneClassName && removeClass(node, doneClassName);
  };

  _proto.reflowAndAddClass = function reflowAndAddClass(node, className) {
    // This is for to force a repaint,
    // which is necessary in order to transition styles when adding a class name.
    if (className) {
      /* eslint-disable no-unused-expressions */
      node && node.scrollTop;
      /* eslint-enable no-unused-expressions */

      addClass(node, className);
    }
  };

  _proto.render = function render() {
    var props = _extends({}, this.props);

    delete props.classNames;
    return _react.default.createElement(_Transition.default, _extends({}, props, {
      onEnter: this.onEnter,
      onEntered: this.onEntered,
      onEntering: this.onEntering,
      onExit: this.onExit,
      onExiting: this.onExiting,
      onExited: this.onExited
    }));
  };

  return CSSTransition;
}(_react.default.Component);

CSSTransition.propTypes =  false ? _extends({}, _Transition.default.propTypes, {
  /**
   * The animation classNames applied to the component as it enters, exits or has finished the transition.
   * A single name can be provided and it will be suffixed for each stage: e.g.
   *
   * `classNames="fade"` applies `fade-enter`, `fade-enter-active`, `fade-enter-done`,
   * `fade-exit`, `fade-exit-active`, `fade-exit-done`, `fade-appear`, and `fade-appear-active`.
   * Each individual classNames can also be specified independently like:
   *
   * ```js
   * classNames={{
   *  appear: 'my-appear',
   *  appearActive: 'my-active-appear',
   *  enter: 'my-enter',
   *  enterActive: 'my-active-enter',
   *  enterDone: 'my-done-enter',
   *  exit: 'my-exit',
   *  exitActive: 'my-active-exit',
   *  exitDone: 'my-done-exit',
   * }}
   * ```
   *
   * If you want to set these classes using CSS Modules:
   *
   * ```js
   * import styles from './styles.css';
   * ```
   *
   * you might want to use camelCase in your CSS file, that way could simply spread
   * them instead of listing them one by one:
   *
   * ```js
   * classNames={{ ...styles }}
   * ```
   *
   * @type {string | {
   *  appear?: string,
   *  appearActive?: string,
   *  enter?: string,
   *  enterActive?: string,
   *  enterDone?: string,
   *  exit?: string,
   *  exitActive?: string,
   *  exitDone?: string,
   * }}
   */
  classNames: _PropTypes.classNamesShape,

  /**
   * A `<Transition>` callback fired immediately after the 'enter' or 'appear' class is
   * applied.
   *
   * @type Function(node: HtmlElement, isAppearing: bool)
   */
  onEnter: PropTypes.func,

  /**
   * A `<Transition>` callback fired immediately after the 'enter-active' or
   * 'appear-active' class is applied.
   *
   * @type Function(node: HtmlElement, isAppearing: bool)
   */
  onEntering: PropTypes.func,

  /**
   * A `<Transition>` callback fired immediately after the 'enter' or
   * 'appear' classes are **removed** and the `done` class is added to the DOM node.
   *
   * @type Function(node: HtmlElement, isAppearing: bool)
   */
  onEntered: PropTypes.func,

  /**
   * A `<Transition>` callback fired immediately after the 'exit' class is
   * applied.
   *
   * @type Function(node: HtmlElement)
   */
  onExit: PropTypes.func,

  /**
   * A `<Transition>` callback fired immediately after the 'exit-active' is applied.
   *
   * @type Function(node: HtmlElement)
   */
  onExiting: PropTypes.func,

  /**
   * A `<Transition>` callback fired immediately after the 'exit' classes
   * are **removed** and the `exit-done` class is added to the DOM node.
   *
   * @type Function(node: HtmlElement)
   */
  onExited: PropTypes.func
}) : {};
var _default = CSSTransition;
exports.default = _default;
module.exports = exports["default"];

/***/ }),
/* 1212 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */



var ReactPropTypesSecret = __webpack_require__(1213);

function emptyFunction() {}
function emptyFunctionWithReset() {}
emptyFunctionWithReset.resetWarningCache = emptyFunction;

module.exports = function() {
  function shim(props, propName, componentName, location, propFullName, secret) {
    if (secret === ReactPropTypesSecret) {
      // It is still safe when called from React.
      return;
    }
    var err = new Error(
      'Calling PropTypes validators directly is not supported by the `prop-types` package. ' +
      'Use PropTypes.checkPropTypes() to call them. ' +
      'Read more at http://fb.me/use-check-prop-types'
    );
    err.name = 'Invariant Violation';
    throw err;
  };
  shim.isRequired = shim;
  function getShim() {
    return shim;
  };
  // Important!
  // Keep this list in sync with production version in `./factoryWithTypeCheckers.js`.
  var ReactPropTypes = {
    array: shim,
    bool: shim,
    func: shim,
    number: shim,
    object: shim,
    string: shim,
    symbol: shim,

    any: shim,
    arrayOf: getShim,
    element: shim,
    elementType: shim,
    instanceOf: getShim,
    node: shim,
    objectOf: getShim,
    oneOf: getShim,
    oneOfType: getShim,
    shape: getShim,
    exact: getShim,

    checkPropTypes: emptyFunctionWithReset,
    resetWarningCache: emptyFunction
  };

  ReactPropTypes.PropTypes = ReactPropTypes;

  return ReactPropTypes;
};


/***/ }),
/* 1213 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */



var ReactPropTypesSecret = 'SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED';

module.exports = ReactPropTypesSecret;


/***/ }),
/* 1214 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1215);

exports.__esModule = true;
exports.default = addClass;

var _hasClass = _interopRequireDefault(__webpack_require__(1216));

function addClass(element, className) {
  if (element.classList) element.classList.add(className);else if (!(0, _hasClass.default)(element, className)) if (typeof element.className === 'string') element.className = element.className + ' ' + className;else element.setAttribute('class', (element.className && element.className.baseVal || '') + ' ' + className);
}

module.exports = exports["default"];

/***/ }),
/* 1215 */
/***/ (function(module, exports) {

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

module.exports = _interopRequireDefault;

/***/ }),
/* 1216 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
exports.default = hasClass;

function hasClass(element, className) {
  if (element.classList) return !!className && element.classList.contains(className);else return (" " + (element.className.baseVal || element.className) + " ").indexOf(" " + className + " ") !== -1;
}

module.exports = exports["default"];

/***/ }),
/* 1217 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


function replaceClassName(origClass, classToRemove) {
  return origClass.replace(new RegExp('(^|\\s)' + classToRemove + '(?:\\s|$)', 'g'), '$1').replace(/\s+/g, ' ').replace(/^\s*|\s*$/g, '');
}

module.exports = function removeClass(element, className) {
  if (element.classList) element.classList.remove(className);else if (typeof element.className === 'string') element.className = replaceClassName(element.className, className);else element.setAttribute('class', replaceClassName(element.className && element.className.baseVal || '', className));
};

/***/ }),
/* 1218 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
exports.default = void 0;

var _propTypes = _interopRequireDefault(__webpack_require__(1116));

var _react = _interopRequireDefault(__webpack_require__(71));

var _reactDom = __webpack_require__(420);

var _TransitionGroup = _interopRequireDefault(__webpack_require__(1138));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

function _inheritsLoose(subClass, superClass) { subClass.prototype = Object.create(superClass.prototype); subClass.prototype.constructor = subClass; subClass.__proto__ = superClass; }

/**
 * The `<ReplaceTransition>` component is a specialized `Transition` component
 * that animates between two children.
 *
 * ```jsx
 * <ReplaceTransition in>
 *   <Fade><div>I appear first</div></Fade>
 *   <Fade><div>I replace the above</div></Fade>
 * </ReplaceTransition>
 * ```
 */
var ReplaceTransition =
/*#__PURE__*/
function (_React$Component) {
  _inheritsLoose(ReplaceTransition, _React$Component);

  function ReplaceTransition() {
    var _this;

    for (var _len = arguments.length, _args = new Array(_len), _key = 0; _key < _len; _key++) {
      _args[_key] = arguments[_key];
    }

    _this = _React$Component.call.apply(_React$Component, [this].concat(_args)) || this;

    _this.handleEnter = function () {
      for (var _len2 = arguments.length, args = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
        args[_key2] = arguments[_key2];
      }

      return _this.handleLifecycle('onEnter', 0, args);
    };

    _this.handleEntering = function () {
      for (var _len3 = arguments.length, args = new Array(_len3), _key3 = 0; _key3 < _len3; _key3++) {
        args[_key3] = arguments[_key3];
      }

      return _this.handleLifecycle('onEntering', 0, args);
    };

    _this.handleEntered = function () {
      for (var _len4 = arguments.length, args = new Array(_len4), _key4 = 0; _key4 < _len4; _key4++) {
        args[_key4] = arguments[_key4];
      }

      return _this.handleLifecycle('onEntered', 0, args);
    };

    _this.handleExit = function () {
      for (var _len5 = arguments.length, args = new Array(_len5), _key5 = 0; _key5 < _len5; _key5++) {
        args[_key5] = arguments[_key5];
      }

      return _this.handleLifecycle('onExit', 1, args);
    };

    _this.handleExiting = function () {
      for (var _len6 = arguments.length, args = new Array(_len6), _key6 = 0; _key6 < _len6; _key6++) {
        args[_key6] = arguments[_key6];
      }

      return _this.handleLifecycle('onExiting', 1, args);
    };

    _this.handleExited = function () {
      for (var _len7 = arguments.length, args = new Array(_len7), _key7 = 0; _key7 < _len7; _key7++) {
        args[_key7] = arguments[_key7];
      }

      return _this.handleLifecycle('onExited', 1, args);
    };

    return _this;
  }

  var _proto = ReplaceTransition.prototype;

  _proto.handleLifecycle = function handleLifecycle(handler, idx, originalArgs) {
    var _child$props;

    var children = this.props.children;

    var child = _react.default.Children.toArray(children)[idx];

    if (child.props[handler]) (_child$props = child.props)[handler].apply(_child$props, originalArgs);
    if (this.props[handler]) this.props[handler]((0, _reactDom.findDOMNode)(this));
  };

  _proto.render = function render() {
    var _this$props = this.props,
        children = _this$props.children,
        inProp = _this$props.in,
        props = _objectWithoutPropertiesLoose(_this$props, ["children", "in"]);

    var _React$Children$toArr = _react.default.Children.toArray(children),
        first = _React$Children$toArr[0],
        second = _React$Children$toArr[1];

    delete props.onEnter;
    delete props.onEntering;
    delete props.onEntered;
    delete props.onExit;
    delete props.onExiting;
    delete props.onExited;
    return _react.default.createElement(_TransitionGroup.default, props, inProp ? _react.default.cloneElement(first, {
      key: 'first',
      onEnter: this.handleEnter,
      onEntering: this.handleEntering,
      onEntered: this.handleEntered
    }) : _react.default.cloneElement(second, {
      key: 'second',
      onEnter: this.handleExit,
      onEntering: this.handleExiting,
      onEntered: this.handleExited
    }));
  };

  return ReplaceTransition;
}(_react.default.Component);

ReplaceTransition.propTypes =  false ? {
  in: _propTypes.default.bool.isRequired,
  children: function children(props, propName) {
    if (_react.default.Children.count(props[propName]) !== 2) return new Error("\"" + propName + "\" must be exactly two transition components.");
    return null;
  }
} : {};
var _default = ReplaceTransition;
exports.default = _default;
module.exports = exports["default"];

/***/ }),
/* 1219 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
exports.getChildMapping = getChildMapping;
exports.mergeChildMappings = mergeChildMappings;
exports.getInitialChildMapping = getInitialChildMapping;
exports.getNextChildMapping = getNextChildMapping;

var _react = __webpack_require__(71);

/**
 * Given `this.props.children`, return an object mapping key to child.
 *
 * @param {*} children `this.props.children`
 * @return {object} Mapping of key to child
 */
function getChildMapping(children, mapFn) {
  var mapper = function mapper(child) {
    return mapFn && (0, _react.isValidElement)(child) ? mapFn(child) : child;
  };

  var result = Object.create(null);
  if (children) _react.Children.map(children, function (c) {
    return c;
  }).forEach(function (child) {
    // run the map function here instead so that the key is the computed one
    result[child.key] = mapper(child);
  });
  return result;
}
/**
 * When you're adding or removing children some may be added or removed in the
 * same render pass. We want to show *both* since we want to simultaneously
 * animate elements in and out. This function takes a previous set of keys
 * and a new set of keys and merges them with its best guess of the correct
 * ordering. In the future we may expose some of the utilities in
 * ReactMultiChild to make this easy, but for now React itself does not
 * directly have this concept of the union of prevChildren and nextChildren
 * so we implement it here.
 *
 * @param {object} prev prev children as returned from
 * `ReactTransitionChildMapping.getChildMapping()`.
 * @param {object} next next children as returned from
 * `ReactTransitionChildMapping.getChildMapping()`.
 * @return {object} a key set that contains all keys in `prev` and all keys
 * in `next` in a reasonable order.
 */


function mergeChildMappings(prev, next) {
  prev = prev || {};
  next = next || {};

  function getValueForKey(key) {
    return key in next ? next[key] : prev[key];
  } // For each key of `next`, the list of keys to insert before that key in
  // the combined list


  var nextKeysPending = Object.create(null);
  var pendingKeys = [];

  for (var prevKey in prev) {
    if (prevKey in next) {
      if (pendingKeys.length) {
        nextKeysPending[prevKey] = pendingKeys;
        pendingKeys = [];
      }
    } else {
      pendingKeys.push(prevKey);
    }
  }

  var i;
  var childMapping = {};

  for (var nextKey in next) {
    if (nextKeysPending[nextKey]) {
      for (i = 0; i < nextKeysPending[nextKey].length; i++) {
        var pendingNextKey = nextKeysPending[nextKey][i];
        childMapping[nextKeysPending[nextKey][i]] = getValueForKey(pendingNextKey);
      }
    }

    childMapping[nextKey] = getValueForKey(nextKey);
  } // Finally, add the keys which didn't appear before any key in `next`


  for (i = 0; i < pendingKeys.length; i++) {
    childMapping[pendingKeys[i]] = getValueForKey(pendingKeys[i]);
  }

  return childMapping;
}

function getProp(child, prop, props) {
  return props[prop] != null ? props[prop] : child.props[prop];
}

function getInitialChildMapping(props, onExited) {
  return getChildMapping(props.children, function (child) {
    return (0, _react.cloneElement)(child, {
      onExited: onExited.bind(null, child),
      in: true,
      appear: getProp(child, 'appear', props),
      enter: getProp(child, 'enter', props),
      exit: getProp(child, 'exit', props)
    });
  });
}

function getNextChildMapping(nextProps, prevChildMapping, onExited) {
  var nextChildMapping = getChildMapping(nextProps.children);
  var children = mergeChildMappings(prevChildMapping, nextChildMapping);
  Object.keys(children).forEach(function (key) {
    var child = children[key];
    if (!(0, _react.isValidElement)(child)) return;
    var hasPrev = key in prevChildMapping;
    var hasNext = key in nextChildMapping;
    var prevChild = prevChildMapping[key];
    var isLeaving = (0, _react.isValidElement)(prevChild) && !prevChild.props.in; // item is new (entering)

    if (hasNext && (!hasPrev || isLeaving)) {
      // console.log('entering', key)
      children[key] = (0, _react.cloneElement)(child, {
        onExited: onExited.bind(null, child),
        in: true,
        exit: getProp(child, 'exit', nextProps),
        enter: getProp(child, 'enter', nextProps)
      });
    } else if (!hasNext && hasPrev && !isLeaving) {
      // item is old (exiting)
      // console.log('leaving', key)
      children[key] = (0, _react.cloneElement)(child, {
        in: false
      });
    } else if (hasNext && hasPrev && (0, _react.isValidElement)(prevChild)) {
      // item hasn't changed transition states
      // copy over the last transition props;
      // console.log('unchanged', key)
      children[key] = (0, _react.cloneElement)(child, {
        onExited: onExited.bind(null, child),
        in: prevChild.props.in,
        exit: getProp(child, 'exit', nextProps),
        enter: getProp(child, 'enter', nextProps)
      });
    }
  });
  return children;
}

/***/ }),
/* 1220 */
/***/ (function(module, exports) {

/**
 * lodash (Custom Build) <https://lodash.com/>
 * Build: `lodash modularize exports="npm" -o ./`
 * Copyright jQuery Foundation and other contributors <https://jquery.org/>
 * Released under MIT license <https://lodash.com/license>
 * Based on Underscore.js 1.8.3 <http://underscorejs.org/LICENSE>
 * Copyright Jeremy Ashkenas, DocumentCloud and Investigative Reporters & Editors
 */

/** Used as references for various `Number` constants. */
var NAN = 0 / 0;

/** `Object#toString` result references. */
var symbolTag = '[object Symbol]';

/** Used to match leading and trailing whitespace. */
var reTrim = /^\s+|\s+$/g;

/** Used to detect bad signed hexadecimal string values. */
var reIsBadHex = /^[-+]0x[0-9a-f]+$/i;

/** Used to detect binary string values. */
var reIsBinary = /^0b[01]+$/i;

/** Used to detect octal string values. */
var reIsOctal = /^0o[0-7]+$/i;

/** Built-in method references without a dependency on `root`. */
var freeParseInt = parseInt;

/** Used for built-in method references. */
var objectProto = Object.prototype;

/**
 * Used to resolve the
 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
 * of values.
 */
var objectToString = objectProto.toString;

/**
 * Checks if `value` is the
 * [language type](http://www.ecma-international.org/ecma-262/7.0/#sec-ecmascript-language-types)
 * of `Object`. (e.g. arrays, functions, objects, regexes, `new Number(0)`, and `new String('')`)
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an object, else `false`.
 * @example
 *
 * _.isObject({});
 * // => true
 *
 * _.isObject([1, 2, 3]);
 * // => true
 *
 * _.isObject(_.noop);
 * // => true
 *
 * _.isObject(null);
 * // => false
 */
function isObject(value) {
  var type = typeof value;
  return !!value && (type == 'object' || type == 'function');
}

/**
 * Checks if `value` is object-like. A value is object-like if it's not `null`
 * and has a `typeof` result of "object".
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is object-like, else `false`.
 * @example
 *
 * _.isObjectLike({});
 * // => true
 *
 * _.isObjectLike([1, 2, 3]);
 * // => true
 *
 * _.isObjectLike(_.noop);
 * // => false
 *
 * _.isObjectLike(null);
 * // => false
 */
function isObjectLike(value) {
  return !!value && typeof value == 'object';
}

/**
 * Checks if `value` is classified as a `Symbol` primitive or object.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a symbol, else `false`.
 * @example
 *
 * _.isSymbol(Symbol.iterator);
 * // => true
 *
 * _.isSymbol('abc');
 * // => false
 */
function isSymbol(value) {
  return typeof value == 'symbol' ||
    (isObjectLike(value) && objectToString.call(value) == symbolTag);
}

/**
 * Converts `value` to a number.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to process.
 * @returns {number} Returns the number.
 * @example
 *
 * _.toNumber(3.2);
 * // => 3.2
 *
 * _.toNumber(Number.MIN_VALUE);
 * // => 5e-324
 *
 * _.toNumber(Infinity);
 * // => Infinity
 *
 * _.toNumber('3.2');
 * // => 3.2
 */
function toNumber(value) {
  if (typeof value == 'number') {
    return value;
  }
  if (isSymbol(value)) {
    return NAN;
  }
  if (isObject(value)) {
    var other = typeof value.valueOf == 'function' ? value.valueOf() : value;
    value = isObject(other) ? (other + '') : other;
  }
  if (typeof value != 'string') {
    return value === 0 ? value : +value;
  }
  value = value.replace(reTrim, '');
  var isBinary = reIsBinary.test(value);
  return (isBinary || reIsOctal.test(value))
    ? freeParseInt(value.slice(2), isBinary ? 2 : 8)
    : (reIsBadHex.test(value) ? NAN : +value);
}

module.exports = toNumber;


/***/ }),
/* 1221 */
/***/ (function(module, exports, __webpack_require__) {


    var content = __webpack_require__(1222);
    var insertCss = __webpack_require__(889);

    if (typeof content === 'string') {
      content = [[module.i, content, '']];
    }

    module.exports = content.locals || {};
    module.exports._getContent = function() { return content; };
    module.exports._getCss = function() { return content.toString(); };
    module.exports._insertCss = function(options) { return insertCss(content, options) };
    
    // Hot Module Replacement
    // https://webpack.github.io/docs/hot-module-replacement
    // Only activated in browser context
    if (false) {
      var removeCss = function() {};
      module.hot.accept("!!../../../../node_modules/css-loader/index.js??ref--2-rules-2!../../../../node_modules/postcss-loader/lib/index.js??ref--2-rules-3!./ModalConfirmacionTurno.css", function() {
        content = require("!!../../../../node_modules/css-loader/index.js??ref--2-rules-2!../../../../node_modules/postcss-loader/lib/index.js??ref--2-rules-3!./ModalConfirmacionTurno.css");

        if (typeof content === 'string') {
          content = [[module.id, content, '']];
        }

        removeCss = insertCss(content, { replace: true });
      });
      module.hot.dispose(function() { removeCss(); });
    }
  

/***/ }),
/* 1222 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(888)(false);
// imports


// module
exports.push([module.i, "._1lxsc{background-color:#e4002b;cursor:pointer;width:140px}.yC0p7{font-family:Roboto\\, Medium}._3qxDX{color:#333;background-color:#fff;border-color:#ccc;cursor:pointer;width:140px}._1veou{position:relative}._1veou i{position:absolute;padding:10px;pointer-events:none}._2jLs4 i{left:0}._2jLs4 input{padding-left:35px}input:focus{border-color:#e4002b!important}", ""]);

// exports
exports.locals = {
	"boton_rojo": "_1lxsc",
	"robotoMedium": "yC0p7",
	"boton_blanco": "_3qxDX",
	"innerAddon": "_1veou",
	"leftAddon": "_2jLs4"
};

/***/ }),
/* 1223 */
/***/ (function(module, exports, __webpack_require__) {


    var content = __webpack_require__(1224);
    var insertCss = __webpack_require__(889);

    if (typeof content === 'string') {
      content = [[module.i, content, '']];
    }

    module.exports = content.locals || {};
    module.exports._getContent = function() { return content; };
    module.exports._getCss = function() { return content.toString(); };
    module.exports._insertCss = function(options) { return insertCss(content, options) };
    
    // Hot Module Replacement
    // https://webpack.github.io/docs/hot-module-replacement
    // Only activated in browser context
    if (false) {
      var removeCss = function() {};
      module.hot.accept("!!../../../../node_modules/css-loader/index.js??ref--2-rules-2!../../../../node_modules/postcss-loader/lib/index.js??ref--2-rules-3!./ModalConfirmacionTurnoResp.css", function() {
        content = require("!!../../../../node_modules/css-loader/index.js??ref--2-rules-2!../../../../node_modules/postcss-loader/lib/index.js??ref--2-rules-3!./ModalConfirmacionTurnoResp.css");

        if (typeof content === 'string') {
          content = [[module.id, content, '']];
        }

        removeCss = insertCss(content, { replace: true });
      });
      module.hot.dispose(function() { removeCss(); });
    }
  

/***/ }),
/* 1224 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(888)(false);
// imports


// module
exports.push([module.i, "._1qFfP{background-color:#e4002b;cursor:pointer;font-family:Roboto\\, Medium}.ck3Ng{text-align:center}.ck3Ng i{color:#e4002b}._3S_aP{padding-right:195px}", ""]);

// exports
exports.locals = {
	"boton_rojo": "_1qFfP",
	"modalContent": "ck3Ng",
	"modalFooter": "_3S_aP"
};

/***/ }),
/* 1225 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "219f7eb1.png";

/***/ }),
/* 1226 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "17cbf57d.png";

/***/ }),
/* 1227 */
/***/ (function(module, exports, __webpack_require__) {


    var content = __webpack_require__(1228);
    var insertCss = __webpack_require__(889);

    if (typeof content === 'string') {
      content = [[module.i, content, '']];
    }

    module.exports = content.locals || {};
    module.exports._getContent = function() { return content; };
    module.exports._getCss = function() { return content.toString(); };
    module.exports._insertCss = function(options) { return insertCss(content, options) };
    
    // Hot Module Replacement
    // https://webpack.github.io/docs/hot-module-replacement
    // Only activated in browser context
    if (false) {
      var removeCss = function() {};
      module.hot.accept("!!../../../../node_modules/css-loader/index.js??ref--2-rules-2!../../../../node_modules/postcss-loader/lib/index.js??ref--2-rules-3!./ModalUserMediaError.css", function() {
        content = require("!!../../../../node_modules/css-loader/index.js??ref--2-rules-2!../../../../node_modules/postcss-loader/lib/index.js??ref--2-rules-3!./ModalUserMediaError.css");

        if (typeof content === 'string') {
          content = [[module.id, content, '']];
        }

        removeCss = insertCss(content, { replace: true });
      });
      module.hot.dispose(function() { removeCss(); });
    }
  

/***/ }),
/* 1228 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(888)(false);
// imports


// module
exports.push([module.i, "._1wstX{background-color:#e4002b;cursor:pointer;margin-left:10px!important;width:140px}._20Tw6{text-align:center}._3zbp7{color:#333;background-color:#fff;border-color:#ccc;cursor:pointer;margin-right:10px!important;width:140px}._3EWSj{margin:0 auto}._2QGuc{font-family:Roboto,sans-serif;padding:25px 0}", ""]);

// exports
exports.locals = {
	"boton_rojo": "_1wstX",
	"modalContent": "_20Tw6",
	"boton_blanco": "_3zbp7",
	"modalFooter": "_3EWSj",
	"modalBody": "_2QGuc"
};

/***/ }),
/* 1229 */
/***/ (function(module, exports, __webpack_require__) {


    var content = __webpack_require__(1230);
    var insertCss = __webpack_require__(889);

    if (typeof content === 'string') {
      content = [[module.i, content, '']];
    }

    module.exports = content.locals || {};
    module.exports._getContent = function() { return content; };
    module.exports._getCss = function() { return content.toString(); };
    module.exports._insertCss = function(options) { return insertCss(content, options) };
    
    // Hot Module Replacement
    // https://webpack.github.io/docs/hot-module-replacement
    // Only activated in browser context
    if (false) {
      var removeCss = function() {};
      module.hot.accept("!!../../../node_modules/css-loader/index.js??ref--2-rules-2!../../../node_modules/postcss-loader/lib/index.js??ref--2-rules-3!./ModalIngresoDireccionActual.css", function() {
        content = require("!!../../../node_modules/css-loader/index.js??ref--2-rules-2!../../../node_modules/postcss-loader/lib/index.js??ref--2-rules-3!./ModalIngresoDireccionActual.css");

        if (typeof content === 'string') {
          content = [[module.id, content, '']];
        }

        removeCss = insertCss(content, { replace: true });
      });
      module.hot.dispose(function() { removeCss(); });
    }
  

/***/ }),
/* 1230 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(888)(false);
// imports


// module
exports.push([module.i, "._2djtJ{text-align:center;font-family:Roboto}._2198B{color:#fff;background-color:#e4002b;border-color:#e4002b;cursor:pointer;font-family:Roboto\\, Medium}._2hWTb,._36yAl{padding:20px 50px}._14FwJ{display:block;padding:20px 100px}.qZsK9{font-family:Roboto\\, Medium}._1BidJ,.qZsK9{font-size:14px}input:focus{border-color:#e4002b!important}._1TY6G{font-family:Roboto\\, Medium}.NbSzY{color:#e4002b}.xMyvK{color:#333;background-color:#fff;border-color:#ccc;cursor:pointer;width:140px}", ""]);

// exports
exports.locals = {
	"modalContent": "_2djtJ",
	"boton_rojo": "_2198B",
	"modalHeader": "_36yAl",
	"modalBody": "_2hWTb",
	"modalFooter": "_14FwJ",
	"boldText": "qZsK9",
	"regularText": "_1BidJ",
	"robotoMedium": "_1TY6G",
	"text_danger": "NbSzY",
	"boton_blanco": "xMyvK"
};

/***/ }),
/* 1231 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getLatLng = exports.geocodeByPlaceId = exports.geocodeByAddress = undefined;

var _PlacesAutocomplete = __webpack_require__(1232);

var _PlacesAutocomplete2 = _interopRequireDefault(_PlacesAutocomplete);

var _utils = __webpack_require__(1238);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.geocodeByAddress = _utils.geocodeByAddress;
exports.geocodeByPlaceId = _utils.geocodeByPlaceId;
exports.getLatLng = _utils.getLatLng;
exports.default = _PlacesAutocomplete2.default;

/***/ }),
/* 1232 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(71);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(1233);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _lodash = __webpack_require__(1236);

var _lodash2 = _interopRequireDefault(_lodash);

var _defaultStyles = __webpack_require__(1237);

var _defaultStyles2 = _interopRequireDefault(_defaultStyles);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } /*
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                               * Copyright (c) 2016-present, Ken Hibino.
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                               * Licensed under the MIT License (MIT).
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                               * See https://kenny-hibino.github.io/react-places-autocomplete
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                               */

var PlacesAutocomplete = function (_Component) {
  _inherits(PlacesAutocomplete, _Component);

  function PlacesAutocomplete(props) {
    _classCallCheck(this, PlacesAutocomplete);

    var _this = _possibleConstructorReturn(this, (PlacesAutocomplete.__proto__ || Object.getPrototypeOf(PlacesAutocomplete)).call(this, props));

    _this.state = {
      autocompleteItems: [],
      userInputValue: props.inputProps.value
    };

    _this.autocompleteCallback = _this.autocompleteCallback.bind(_this);
    _this.handleInputKeyDown = _this.handleInputKeyDown.bind(_this);
    _this.handleInputChange = _this.handleInputChange.bind(_this);
    _this.debouncedFetchPredictions = (0, _lodash2.default)(_this.fetchPredictions, _this.props.debounce);
    _this.clearSuggestions = _this.clearSuggestions.bind(_this);
    return _this;
  }

  _createClass(PlacesAutocomplete, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      if (!window.google) {
        throw new Error('Google Maps JavaScript API library must be loaded. See: https://github.com/kenny-hibino/react-places-autocomplete#load-google-library');
      }

      if (!window.google.maps.places) {
        throw new Error('Google Maps Places library must be loaded. Please add `libraries=places` to the src URL. See: https://github.com/kenny-hibino/react-places-autocomplete#load-google-library');
      }

      this.autocompleteService = new google.maps.places.AutocompleteService();
      this.autocompleteOK = google.maps.places.PlacesServiceStatus.OK;
    }
  }, {
    key: 'autocompleteCallback',
    value: function autocompleteCallback(predictions, status) {
      if (status !== this.autocompleteOK) {
        this.props.onError(status, this.clearSuggestions);
        return;
      }

      // transform snake_case to camelCase
      var formattedSuggestion = function formattedSuggestion(structured_formatting) {
        return {
          mainText: structured_formatting.main_text,
          secondaryText: structured_formatting.secondary_text
        };
      };

      var highlightFirstSuggestion = this.props.highlightFirstSuggestion;


      this.setState({
        autocompleteItems: predictions.map(function (p, idx) {
          return {
            suggestion: p.description,
            placeId: p.place_id,
            active: highlightFirstSuggestion && idx === 0 ? true : false,
            index: idx,
            formattedSuggestion: formattedSuggestion(p.structured_formatting)
          };
        })
      });
    }
  }, {
    key: 'fetchPredictions',
    value: function fetchPredictions() {
      var value = this.props.inputProps.value;

      if (value.length) {
        this.autocompleteService.getPlacePredictions(_extends({}, this.props.options, {
          input: value
        }), this.autocompleteCallback);
      }
    }
  }, {
    key: 'clearSuggestions',
    value: function clearSuggestions() {
      this.setState({ autocompleteItems: [] });
    }
  }, {
    key: 'clearActive',
    value: function clearActive() {
      this.setState({
        autocompleteItems: this.state.autocompleteItems.map(function (item) {
          return _extends({}, item, {
            active: false
          });
        })
      });
    }
  }, {
    key: 'selectAddress',
    value: function selectAddress(address, placeId, e) {
      if (e !== undefined) {
        e.preventDefault();
      }
      this.clearSuggestions();
      this.handleSelect(address, placeId);
    }
  }, {
    key: 'handleSelect',
    value: function handleSelect(address, placeId) {
      this.props.onSelect ? this.props.onSelect(address, placeId) : this.props.inputProps.onChange(address);
    }
  }, {
    key: 'getActiveItem',
    value: function getActiveItem() {
      return this.state.autocompleteItems.find(function (item) {
        return item.active;
      });
    }
  }, {
    key: 'selectActiveItemAtIndex',
    value: function selectActiveItemAtIndex(index) {
      var activeName = this.state.autocompleteItems.find(function (item) {
        return item.index === index;
      }).suggestion;
      this.setActiveItemAtIndex(index);
      this.props.inputProps.onChange(activeName);
    }
  }, {
    key: 'selectUserInputValue',
    value: function selectUserInputValue() {
      this.clearActive();
      this.props.inputProps.onChange(this.state.userInputValue);
    }
  }, {
    key: 'handleEnterKey',
    value: function handleEnterKey() {
      var activeItem = this.getActiveItem();
      if (activeItem === undefined) {
        this.handleEnterKeyWithoutActiveItem();
      } else {
        this.selectAddress(activeItem.suggestion, activeItem.placeId);
      }
    }
  }, {
    key: 'handleEnterKeyWithoutActiveItem',
    value: function handleEnterKeyWithoutActiveItem() {
      if (this.props.onEnterKeyDown) {
        this.props.onEnterKeyDown(this.props.inputProps.value);
        this.clearSuggestions();
      } else {
        return; //noop
      }
    }
  }, {
    key: 'handleDownKey',
    value: function handleDownKey() {
      if (this.state.autocompleteItems.length === 0) {
        return;
      }

      var activeItem = this.getActiveItem();
      if (activeItem === undefined) {
        this.selectActiveItemAtIndex(0);
      } else if (activeItem.index === this.state.autocompleteItems.length - 1) {
        this.selectUserInputValue();
      } else {
        this.selectActiveItemAtIndex(activeItem.index + 1);
      }
    }
  }, {
    key: 'handleUpKey',
    value: function handleUpKey() {
      if (this.state.autocompleteItems.length === 0) {
        return;
      }

      var activeItem = this.getActiveItem();
      if (activeItem === undefined) {
        this.selectActiveItemAtIndex(this.state.autocompleteItems.length - 1);
      } else if (activeItem.index === 0) {
        this.selectUserInputValue();
      } else {
        this.selectActiveItemAtIndex(activeItem.index - 1);
      }
    }
  }, {
    key: 'handleInputKeyDown',
    value: function handleInputKeyDown(event) {
      switch (event.key) {
        case 'Enter':
          event.preventDefault();
          this.handleEnterKey();
          break;
        case 'ArrowDown':
          event.preventDefault(); // prevent the cursor from moving
          this.handleDownKey();
          break;
        case 'ArrowUp':
          event.preventDefault(); // prevent the cursor from moving
          this.handleUpKey();
          break;
        case 'Escape':
          this.clearSuggestions();
          break;
      }

      if (this.props.inputProps.onKeyDown) {
        this.props.inputProps.onKeyDown(event);
      }
    }
  }, {
    key: 'setActiveItemAtIndex',
    value: function setActiveItemAtIndex(index) {
      this.setState({
        autocompleteItems: this.state.autocompleteItems.map(function (item, idx) {
          if (idx === index) {
            return _extends({}, item, { active: true });
          } else {
            return _extends({}, item, { active: false });
          }
        })
      });
    }
  }, {
    key: 'handleInputChange',
    value: function handleInputChange(event) {
      var value = event.target.value;

      this.props.inputProps.onChange(value);
      this.setState({ userInputValue: value });
      if (!value) {
        this.clearSuggestions();
        return;
      }
      if (this.props.shouldFetchSuggestions({ value: value })) {
        this.debouncedFetchPredictions();
      }
    }
  }, {
    key: 'handleInputOnBlur',
    value: function handleInputOnBlur(event) {
      if (!this.mousedownOnSuggestion) {
        this.clearSuggestions();
      }

      if (this.props.inputProps.onBlur) {
        this.props.inputProps.onBlur(event);
      }
    }
  }, {
    key: 'inlineStyleFor',
    value: function inlineStyleFor() {
      var _props = this.props,
          classNames = _props.classNames,
          styles = _props.styles;
      // No inline style if className is passed via props for the element.

      for (var _len = arguments.length, props = Array(_len), _key = 0; _key < _len; _key++) {
        props[_key] = arguments[_key];
      }

      if (props.some(function (prop) {
        return classNames.hasOwnProperty(prop);
      })) {
        return {};
      }

      return props.reduce(function (acc, prop) {
        return _extends({}, acc, _defaultStyles2.default[prop], styles[prop]);
      }, {});
    }
  }, {
    key: 'classNameFor',
    value: function classNameFor() {
      var classNames = this.props.classNames;

      for (var _len2 = arguments.length, props = Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
        props[_key2] = arguments[_key2];
      }

      return props.reduce(function (acc, prop) {
        var name = classNames[prop] || '';
        return name ? acc + ' ' + name : acc;
      }, '');
    }
  }, {
    key: 'shouldRenderDropdown',
    value: function shouldRenderDropdown() {
      return this.state.autocompleteItems.length > 0;
    }
  }, {
    key: 'getInputProps',
    value: function getInputProps() {
      var _this2 = this;

      var isExpanded = this.shouldRenderDropdown();
      var activeItem = this.getActiveItem();
      var activeItemId = activeItem ? 'PlacesAutocomplete__autocomplete-item-' + activeItem.placeId : null;
      var defaultInputProps = {
        type: 'text',
        autoComplete: 'off',
        role: 'combobox',
        'aria-autocomplete': 'list',
        'aria-controls': "PlacesAutocomplete__autocomplete-container",
        'aria-expanded': isExpanded,
        'aria-haspopup': isExpanded,
        'aria-activedescendant': activeItemId
      };

      return _extends({}, defaultInputProps, this.props.inputProps, {
        onChange: function onChange(event) {
          _this2.handleInputChange(event);
        },
        onKeyDown: function onKeyDown(event) {
          _this2.handleInputKeyDown(event);
        },
        onBlur: function onBlur(event) {
          _this2.handleInputOnBlur(event);
        },
        style: this.inlineStyleFor('input'),
        className: this.classNameFor('input')
      });
    }
  }, {
    key: 'handleSuggestionMouseEnter',
    value: function handleSuggestionMouseEnter(index) {
      this.setActiveItemAtIndex(index);
    }
  }, {
    key: 'handleSuggestionMouseLeave',
    value: function handleSuggestionMouseLeave() {
      this.mousedownOnSuggestion = false;
      this.clearActive();
    }
  }, {
    key: 'handleSuggestionMouseDown',
    value: function handleSuggestionMouseDown(event) {
      event.preventDefault();
      this.mousedownOnSuggestion = true;
    }
  }, {
    key: 'handleSuggestionTouchStart',
    value: function handleSuggestionTouchStart() {
      this.mousedownOnSuggestion = true;
    }
  }, {
    key: 'handleSuggestionMouseUp',
    value: function handleSuggestionMouseUp() {
      this.mousedownOnSuggestion = false;
    }
  }, {
    key: 'handleSuggestionClick',
    value: function handleSuggestionClick(prediction, event) {
      var _this3 = this;

      var suggestion = prediction.suggestion,
          placeId = prediction.placeId;

      this.selectAddress(suggestion, placeId, event);
      setTimeout(function () {
        _this3.mousedownOnSuggestion = false;
      });
    }
  }, {
    key: 'render',
    value: function render() {
      var _this4 = this;

      var autocompleteItems = this.state.autocompleteItems;

      var inputProps = this.getInputProps();

      return _react2.default.createElement(
        'div',
        {
          id: 'PlacesAutocomplete__root',
          style: this.inlineStyleFor('root'),
          className: this.classNameFor('root')
        },
        _react2.default.createElement('input', inputProps),
        this.shouldRenderDropdown() && _react2.default.createElement(
          'div',
          {
            role: 'listbox',
            id: 'PlacesAutocomplete__autocomplete-container',
            style: this.inlineStyleFor('autocompleteContainer'),
            className: this.classNameFor('autocompleteContainer')
          },
          autocompleteItems.map(function (p, idx) {
            return _react2.default.createElement(
              'div',
              {
                key: p.placeId,
                id: 'PlacesAutocomplete__autocomplete-item-' + p.placeId,
                role: 'option',
                onMouseEnter: _this4.handleSuggestionMouseEnter.bind(_this4, idx),
                onMouseLeave: _this4.handleSuggestionMouseLeave.bind(_this4),
                onMouseDown: _this4.handleSuggestionMouseDown.bind(_this4),
                onMouseUp: _this4.handleSuggestionMouseUp.bind(_this4),
                onTouchStart: _this4.handleSuggestionTouchStart.bind(_this4),
                onTouchEnd: _this4.handleSuggestionMouseUp.bind(_this4),
                onClick: _this4.handleSuggestionClick.bind(_this4, p),
                style: p.active ? _this4.inlineStyleFor('autocompleteItem', 'autocompleteItemActive') : _this4.inlineStyleFor('autocompleteItem'),
                className: p.active ? _this4.classNameFor('autocompleteItem', 'autocompleteItemActive') : _this4.classNameFor('autocompleteItem')
              },
              _this4.props.renderSuggestion({
                suggestion: p.suggestion,
                formattedSuggestion: p.formattedSuggestion
              })
            );
          }),
          this.props.renderFooter && this.props.renderFooter()
        )
      );
    }
  }]);

  return PlacesAutocomplete;
}(_react.Component);

PlacesAutocomplete.propTypes = {
  inputProps: function inputProps(props, propName) {
    var inputProps = props[propName];

    if (!inputProps.hasOwnProperty('value')) {
      throw new Error("'inputProps' must have 'value'.");
    }

    if (!inputProps.hasOwnProperty('onChange')) {
      throw new Error("'inputProps' must have 'onChange'.");
    }
  },
  onError: _propTypes2.default.func,
  onSelect: _propTypes2.default.func,
  renderSuggestion: _propTypes2.default.func,
  classNames: _propTypes2.default.shape({
    root: _propTypes2.default.string,
    input: _propTypes2.default.string,
    autocompleteContainer: _propTypes2.default.string,
    autocompleteItem: _propTypes2.default.string,
    autocompleteItemActive: _propTypes2.default.string
  }),
  styles: _propTypes2.default.shape({
    root: _propTypes2.default.object,
    input: _propTypes2.default.object,
    autocompleteContainer: _propTypes2.default.object,
    autocompleteItem: _propTypes2.default.object,
    autocompleteItemActive: _propTypes2.default.object
  }),
  options: _propTypes2.default.shape({
    bounds: _propTypes2.default.object,
    componentRestrictions: _propTypes2.default.object,
    location: _propTypes2.default.object,
    offset: _propTypes2.default.oneOfType([_propTypes2.default.number, _propTypes2.default.string]),
    radius: _propTypes2.default.oneOfType([_propTypes2.default.number, _propTypes2.default.string]),
    types: _propTypes2.default.array
  }),
  debounce: _propTypes2.default.number,
  highlightFirstSuggestion: _propTypes2.default.bool,
  renderFooter: _propTypes2.default.func,
  shouldFetchSuggestions: _propTypes2.default.func.isRequired
};

PlacesAutocomplete.defaultProps = {
  onError: function onError(status, _clearSuggestions) {
    return console.error('[react-places-autocomplete]: error happened when fetching data from Google Maps API.\nPlease check the docs here (https://developers.google.com/maps/documentation/javascript/places#place_details_responses)\nStatus: ', status);
  },
  classNames: {},
  renderSuggestion: function renderSuggestion(_ref) {
    var suggestion = _ref.suggestion;
    return _react2.default.createElement(
      'div',
      null,
      suggestion
    );
  },
  styles: {},
  options: {},
  debounce: 200,
  highlightFirstSuggestion: false,
  shouldFetchSuggestions: function shouldFetchSuggestions() {
    return true;
  }
};

exports.default = PlacesAutocomplete;

/***/ }),
/* 1233 */
/***/ (function(module, exports, __webpack_require__) {

/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 */

if (false) {
  var REACT_ELEMENT_TYPE = (typeof Symbol === 'function' &&
    Symbol.for &&
    Symbol.for('react.element')) ||
    0xeac7;

  var isValidElement = function(object) {
    return typeof object === 'object' &&
      object !== null &&
      object.$$typeof === REACT_ELEMENT_TYPE;
  };

  // By explicitly using `prop-types` you are opting into new development behavior.
  // http://fb.me/prop-types-in-prod
  var throwOnDirectAccess = true;
  module.exports = require('./factoryWithTypeCheckers')(isValidElement, throwOnDirectAccess);
} else {
  // By explicitly using `prop-types` you are opting into new production behavior.
  // http://fb.me/prop-types-in-prod
  module.exports = __webpack_require__(1234)();
}


/***/ }),
/* 1234 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 */



var emptyFunction = __webpack_require__(418);
var invariant = __webpack_require__(417);
var ReactPropTypesSecret = __webpack_require__(1235);

module.exports = function() {
  function shim(props, propName, componentName, location, propFullName, secret) {
    if (secret === ReactPropTypesSecret) {
      // It is still safe when called from React.
      return;
    }
    invariant(
      false,
      'Calling PropTypes validators directly is not supported by the `prop-types` package. ' +
      'Use PropTypes.checkPropTypes() to call them. ' +
      'Read more at http://fb.me/use-check-prop-types'
    );
  };
  shim.isRequired = shim;
  function getShim() {
    return shim;
  };
  // Important!
  // Keep this list in sync with production version in `./factoryWithTypeCheckers.js`.
  var ReactPropTypes = {
    array: shim,
    bool: shim,
    func: shim,
    number: shim,
    object: shim,
    string: shim,
    symbol: shim,

    any: shim,
    arrayOf: getShim,
    element: shim,
    instanceOf: getShim,
    node: shim,
    objectOf: getShim,
    oneOf: getShim,
    oneOfType: getShim,
    shape: getShim
  };

  ReactPropTypes.checkPropTypes = emptyFunction;
  ReactPropTypes.PropTypes = ReactPropTypes;

  return ReactPropTypes;
};


/***/ }),
/* 1235 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 */



var ReactPropTypesSecret = 'SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED';

module.exports = ReactPropTypesSecret;


/***/ }),
/* 1236 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(global) {/**
 * lodash (Custom Build) <https://lodash.com/>
 * Build: `lodash modularize exports="npm" -o ./`
 * Copyright jQuery Foundation and other contributors <https://jquery.org/>
 * Released under MIT license <https://lodash.com/license>
 * Based on Underscore.js 1.8.3 <http://underscorejs.org/LICENSE>
 * Copyright Jeremy Ashkenas, DocumentCloud and Investigative Reporters & Editors
 */

/** Used as the `TypeError` message for "Functions" methods. */
var FUNC_ERROR_TEXT = 'Expected a function';

/** Used as references for various `Number` constants. */
var NAN = 0 / 0;

/** `Object#toString` result references. */
var symbolTag = '[object Symbol]';

/** Used to match leading and trailing whitespace. */
var reTrim = /^\s+|\s+$/g;

/** Used to detect bad signed hexadecimal string values. */
var reIsBadHex = /^[-+]0x[0-9a-f]+$/i;

/** Used to detect binary string values. */
var reIsBinary = /^0b[01]+$/i;

/** Used to detect octal string values. */
var reIsOctal = /^0o[0-7]+$/i;

/** Built-in method references without a dependency on `root`. */
var freeParseInt = parseInt;

/** Detect free variable `global` from Node.js. */
var freeGlobal = typeof global == 'object' && global && global.Object === Object && global;

/** Detect free variable `self`. */
var freeSelf = typeof self == 'object' && self && self.Object === Object && self;

/** Used as a reference to the global object. */
var root = freeGlobal || freeSelf || Function('return this')();

/** Used for built-in method references. */
var objectProto = Object.prototype;

/**
 * Used to resolve the
 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
 * of values.
 */
var objectToString = objectProto.toString;

/* Built-in method references for those with the same name as other `lodash` methods. */
var nativeMax = Math.max,
    nativeMin = Math.min;

/**
 * Gets the timestamp of the number of milliseconds that have elapsed since
 * the Unix epoch (1 January 1970 00:00:00 UTC).
 *
 * @static
 * @memberOf _
 * @since 2.4.0
 * @category Date
 * @returns {number} Returns the timestamp.
 * @example
 *
 * _.defer(function(stamp) {
 *   console.log(_.now() - stamp);
 * }, _.now());
 * // => Logs the number of milliseconds it took for the deferred invocation.
 */
var now = function() {
  return root.Date.now();
};

/**
 * Creates a debounced function that delays invoking `func` until after `wait`
 * milliseconds have elapsed since the last time the debounced function was
 * invoked. The debounced function comes with a `cancel` method to cancel
 * delayed `func` invocations and a `flush` method to immediately invoke them.
 * Provide `options` to indicate whether `func` should be invoked on the
 * leading and/or trailing edge of the `wait` timeout. The `func` is invoked
 * with the last arguments provided to the debounced function. Subsequent
 * calls to the debounced function return the result of the last `func`
 * invocation.
 *
 * **Note:** If `leading` and `trailing` options are `true`, `func` is
 * invoked on the trailing edge of the timeout only if the debounced function
 * is invoked more than once during the `wait` timeout.
 *
 * If `wait` is `0` and `leading` is `false`, `func` invocation is deferred
 * until to the next tick, similar to `setTimeout` with a timeout of `0`.
 *
 * See [David Corbacho's article](https://css-tricks.com/debouncing-throttling-explained-examples/)
 * for details over the differences between `_.debounce` and `_.throttle`.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Function
 * @param {Function} func The function to debounce.
 * @param {number} [wait=0] The number of milliseconds to delay.
 * @param {Object} [options={}] The options object.
 * @param {boolean} [options.leading=false]
 *  Specify invoking on the leading edge of the timeout.
 * @param {number} [options.maxWait]
 *  The maximum time `func` is allowed to be delayed before it's invoked.
 * @param {boolean} [options.trailing=true]
 *  Specify invoking on the trailing edge of the timeout.
 * @returns {Function} Returns the new debounced function.
 * @example
 *
 * // Avoid costly calculations while the window size is in flux.
 * jQuery(window).on('resize', _.debounce(calculateLayout, 150));
 *
 * // Invoke `sendMail` when clicked, debouncing subsequent calls.
 * jQuery(element).on('click', _.debounce(sendMail, 300, {
 *   'leading': true,
 *   'trailing': false
 * }));
 *
 * // Ensure `batchLog` is invoked once after 1 second of debounced calls.
 * var debounced = _.debounce(batchLog, 250, { 'maxWait': 1000 });
 * var source = new EventSource('/stream');
 * jQuery(source).on('message', debounced);
 *
 * // Cancel the trailing debounced invocation.
 * jQuery(window).on('popstate', debounced.cancel);
 */
function debounce(func, wait, options) {
  var lastArgs,
      lastThis,
      maxWait,
      result,
      timerId,
      lastCallTime,
      lastInvokeTime = 0,
      leading = false,
      maxing = false,
      trailing = true;

  if (typeof func != 'function') {
    throw new TypeError(FUNC_ERROR_TEXT);
  }
  wait = toNumber(wait) || 0;
  if (isObject(options)) {
    leading = !!options.leading;
    maxing = 'maxWait' in options;
    maxWait = maxing ? nativeMax(toNumber(options.maxWait) || 0, wait) : maxWait;
    trailing = 'trailing' in options ? !!options.trailing : trailing;
  }

  function invokeFunc(time) {
    var args = lastArgs,
        thisArg = lastThis;

    lastArgs = lastThis = undefined;
    lastInvokeTime = time;
    result = func.apply(thisArg, args);
    return result;
  }

  function leadingEdge(time) {
    // Reset any `maxWait` timer.
    lastInvokeTime = time;
    // Start the timer for the trailing edge.
    timerId = setTimeout(timerExpired, wait);
    // Invoke the leading edge.
    return leading ? invokeFunc(time) : result;
  }

  function remainingWait(time) {
    var timeSinceLastCall = time - lastCallTime,
        timeSinceLastInvoke = time - lastInvokeTime,
        result = wait - timeSinceLastCall;

    return maxing ? nativeMin(result, maxWait - timeSinceLastInvoke) : result;
  }

  function shouldInvoke(time) {
    var timeSinceLastCall = time - lastCallTime,
        timeSinceLastInvoke = time - lastInvokeTime;

    // Either this is the first call, activity has stopped and we're at the
    // trailing edge, the system time has gone backwards and we're treating
    // it as the trailing edge, or we've hit the `maxWait` limit.
    return (lastCallTime === undefined || (timeSinceLastCall >= wait) ||
      (timeSinceLastCall < 0) || (maxing && timeSinceLastInvoke >= maxWait));
  }

  function timerExpired() {
    var time = now();
    if (shouldInvoke(time)) {
      return trailingEdge(time);
    }
    // Restart the timer.
    timerId = setTimeout(timerExpired, remainingWait(time));
  }

  function trailingEdge(time) {
    timerId = undefined;

    // Only invoke if we have `lastArgs` which means `func` has been
    // debounced at least once.
    if (trailing && lastArgs) {
      return invokeFunc(time);
    }
    lastArgs = lastThis = undefined;
    return result;
  }

  function cancel() {
    if (timerId !== undefined) {
      clearTimeout(timerId);
    }
    lastInvokeTime = 0;
    lastArgs = lastCallTime = lastThis = timerId = undefined;
  }

  function flush() {
    return timerId === undefined ? result : trailingEdge(now());
  }

  function debounced() {
    var time = now(),
        isInvoking = shouldInvoke(time);

    lastArgs = arguments;
    lastThis = this;
    lastCallTime = time;

    if (isInvoking) {
      if (timerId === undefined) {
        return leadingEdge(lastCallTime);
      }
      if (maxing) {
        // Handle invocations in a tight loop.
        timerId = setTimeout(timerExpired, wait);
        return invokeFunc(lastCallTime);
      }
    }
    if (timerId === undefined) {
      timerId = setTimeout(timerExpired, wait);
    }
    return result;
  }
  debounced.cancel = cancel;
  debounced.flush = flush;
  return debounced;
}

/**
 * Checks if `value` is the
 * [language type](http://www.ecma-international.org/ecma-262/7.0/#sec-ecmascript-language-types)
 * of `Object`. (e.g. arrays, functions, objects, regexes, `new Number(0)`, and `new String('')`)
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an object, else `false`.
 * @example
 *
 * _.isObject({});
 * // => true
 *
 * _.isObject([1, 2, 3]);
 * // => true
 *
 * _.isObject(_.noop);
 * // => true
 *
 * _.isObject(null);
 * // => false
 */
function isObject(value) {
  var type = typeof value;
  return !!value && (type == 'object' || type == 'function');
}

/**
 * Checks if `value` is object-like. A value is object-like if it's not `null`
 * and has a `typeof` result of "object".
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is object-like, else `false`.
 * @example
 *
 * _.isObjectLike({});
 * // => true
 *
 * _.isObjectLike([1, 2, 3]);
 * // => true
 *
 * _.isObjectLike(_.noop);
 * // => false
 *
 * _.isObjectLike(null);
 * // => false
 */
function isObjectLike(value) {
  return !!value && typeof value == 'object';
}

/**
 * Checks if `value` is classified as a `Symbol` primitive or object.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a symbol, else `false`.
 * @example
 *
 * _.isSymbol(Symbol.iterator);
 * // => true
 *
 * _.isSymbol('abc');
 * // => false
 */
function isSymbol(value) {
  return typeof value == 'symbol' ||
    (isObjectLike(value) && objectToString.call(value) == symbolTag);
}

/**
 * Converts `value` to a number.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to process.
 * @returns {number} Returns the number.
 * @example
 *
 * _.toNumber(3.2);
 * // => 3.2
 *
 * _.toNumber(Number.MIN_VALUE);
 * // => 5e-324
 *
 * _.toNumber(Infinity);
 * // => Infinity
 *
 * _.toNumber('3.2');
 * // => 3.2
 */
function toNumber(value) {
  if (typeof value == 'number') {
    return value;
  }
  if (isSymbol(value)) {
    return NAN;
  }
  if (isObject(value)) {
    var other = typeof value.valueOf == 'function' ? value.valueOf() : value;
    value = isObject(other) ? (other + '') : other;
  }
  if (typeof value != 'string') {
    return value === 0 ? value : +value;
  }
  value = value.replace(reTrim, '');
  var isBinary = reIsBinary.test(value);
  return (isBinary || reIsOctal.test(value))
    ? freeParseInt(value.slice(2), isBinary ? 2 : 8)
    : (reIsBadHex.test(value) ? NAN : +value);
}

module.exports = debounce;

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(5)))

/***/ }),
/* 1237 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
var defaultStyles = {
  root: {
    position: 'relative',
    paddingBottom: '0px'
  },
  input: {
    display: 'inline-block',
    width: '100%',
    padding: '10px'
  },
  autocompleteContainer: {
    position: 'absolute',
    top: '100%',
    backgroundColor: 'white',
    border: '1px solid #555555',
    width: '100%'
  },
  autocompleteItem: {
    backgroundColor: '#ffffff',
    padding: '10px',
    color: '#555555',
    cursor: 'pointer'
  },
  autocompleteItemActive: {
    backgroundColor: '#fafafa'
  }
};

exports.default = defaultStyles;

/***/ }),
/* 1238 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
var geocodeByAddress = exports.geocodeByAddress = function geocodeByAddress(address, callback) {
  var geocoder = new google.maps.Geocoder();
  var OK = google.maps.GeocoderStatus.OK;

  return new Promise(function (resolve, reject) {
    geocoder.geocode({ address: address }, function (results, status) {
      if (status !== OK) {
        // TODO: Remove callback support in the next major version.
        if (callback) {
          console.warn('Deprecated: Passing a callback to geocodeByAddress is deprecated. Please see "https://github.com/kenny-hibino/react-places-autocomplete#geocodebyaddress-api"');
          callback({ status: status }, null, results);
          return;
        }

        reject(status);
      }

      // TODO: Remove callback support in the next major version.
      if (callback) {
        var latLng = {
          lat: results[0].geometry.location.lat(),
          lng: results[0].geometry.location.lng()
        };
        console.warn('Deprecated: Passing a callback to geocodeByAddress is deprecated. Please see "https://github.com/kenny-hibino/react-places-autocomplete#geocodebyaddress-api"');
        callback(null, latLng, results);
      }

      resolve(results);
    });
  });
};

var getLatLng = exports.getLatLng = function getLatLng(result) {
  return new Promise(function (resolve, reject) {
    try {
      var latLng = {
        lat: result.geometry.location.lat(),
        lng: result.geometry.location.lng()
      };
      resolve(latLng);
    } catch (e) {
      reject(e);
    }
  });
};

var geocodeByPlaceId = exports.geocodeByPlaceId = function geocodeByPlaceId(placeId, callback) {
  var geocoder = new google.maps.Geocoder();
  var OK = google.maps.GeocoderStatus.OK;

  return new Promise(function (resolve, reject) {
    geocoder.geocode({ placeId: placeId }, function (results, status) {
      if (status !== OK) {
        // TODO: Remove callback support in the next major version.
        if (callback) {
          console.warn('Deprecated: Passing a callback to geocodeByAddress is deprecated. Please see "https://github.com/kenny-hibino/react-places-autocomplete#geocodebyplaceid-api"');
          callback({ status: status }, null, results);
          return;
        }

        reject(status);
      }

      // TODO: Remove callback support in the next major version.
      if (callback) {
        var latLng = {
          lat: results[0].geometry.location.lat(),
          lng: results[0].geometry.location.lng()
        };
        console.warn('Deprecated: Passing a callback to geocodeByPlaceId is deprecated. Please see "https://github.com/kenny-hibino/react-places-autocomplete#geocodebyplaceid-api"');
        callback(null, latLng, results);
      }

      resolve(results);
    });
  });
};

/***/ }),
/* 1239 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(71);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_redux__ = __webpack_require__(415);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_isomorphic_style_loader_lib_withStyles__ = __webpack_require__(887);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_isomorphic_style_loader_lib_withStyles___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_isomorphic_style_loader_lib_withStyles__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_prop_types__ = __webpack_require__(182);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_lodash__ = __webpack_require__(183);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__constants__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__actions_integrantesActions__ = __webpack_require__(422);
var _jsx = function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; }();

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

/* eslint react/prop-types:0 */
/* eslint class-methods-use-this:0 */








var _ref2 = _jsx('option', {
  value: '',
  'data-sexo': '',
  'data-edad': ''
}, void 0, 'Cargando...');

var SelectIntegrantes = function (_React$Component) {
  _inherits(SelectIntegrantes, _React$Component);

  function SelectIntegrantes(props) {
    _classCallCheck(this, SelectIntegrantes);

    var _this = _possibleConstructorReturn(this, (SelectIntegrantes.__proto__ || Object.getPrototypeOf(SelectIntegrantes)).call(this, props));

    _this.state = {
      selectIntegrantes: 'PENDING'
    };
    return _this;
  }

  _createClass(SelectIntegrantes, [{
    key: 'componentWillMount',
    value: function () {
      var _ref = _asyncToGenerator(regeneratorRuntime.mark(function _callee() {
        var data, userId, contra, inte;
        return regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                data = JSON.parse(localStorage.getItem(__WEBPACK_IMPORTED_MODULE_5__constants__["_30" /* LOCALSTORAGE_AUTH_KEY */]));

                if (__WEBPACK_IMPORTED_MODULE_4_lodash___default.a.isEmpty(data)) {
                  _context.next = 7;
                  break;
                }

                userId = data.modelEspecifico.id_user;
                contra = data.modelEspecifico.contra;
                inte = data.modelEspecifico.inte;
                _context.next = 7;
                return this.props.fetchIntegrantes(userId, contra, inte);

              case 7:
              case 'end':
                return _context.stop();
            }
          }
        }, _callee, this);
      }));

      function componentWillMount() {
        return _ref.apply(this, arguments);
      }

      return componentWillMount;
    }()
  }, {
    key: 'componentWillReceiveProps',
    value: function componentWillReceiveProps(props) {
      if (!__WEBPACK_IMPORTED_MODULE_4_lodash___default.a.isEmpty(props.integrantes)) {
        for (var x = 0; x < props.integrantes.length; x += 1) {
          if (props.integrantes[x].inte === this.props.loggedUser.inte) {
            this.jsonIntegrante = this.integrante(props.integrantes[x].inte, props.integrantes[x].sexo, props.integrantes[x].edad, props.integrantes[x].prepaga, props.integrantes[x].credencial, props.integrantes[x].tipoDocumento.codigo, props.integrantes[x].documento, props.integrantes[x].fechaNacimiento, props.integrantes[x].nombreCompleto);
          }
        }
        if (__WEBPACK_IMPORTED_MODULE_4_lodash___default.a.isEmpty(this.jsonIntegrante)) {
          this.jsonIntegrante = this.integrante('', '', '');
        }
        this.props.onChange(this.jsonIntegrante);
        this.setState({ selectIntegrantes: 'SUCCESS' });
      }
    }
  }, {
    key: 'onChangeSelectIntegrantes',
    value: function onChangeSelectIntegrantes(e) {
      var integrante = this.integrante(e.target.value, e.target[e.target.selectedIndex].getAttribute('data-sexo'), e.target[e.target.selectedIndex].getAttribute('data-edad'), e.target[e.target.selectedIndex].getAttribute('data-prepaga'), e.target[e.target.selectedIndex].getAttribute('data-credencial'), e.target[e.target.selectedIndex].getAttribute('data-tipodoc'), e.target[e.target.selectedIndex].getAttribute('data-nrodoc'), e.target[e.target.selectedIndex].getAttribute('data-fechanacimiento'), e.target[e.target.selectedIndex].getAttribute('data-nombrecompleto'));
      this.props.onChange(integrante);
    }
  }, {
    key: 'integrante',
    value: function integrante(inte, sexo, edad, prepaga, credencial, tipodoc, nrodoc, fechanacimiento, nombrecompleto) {
      var integrante = {
        inte: inte,
        sexo: sexo,
        edad: edad,
        prepaga: prepaga,
        credencial: credencial,
        tipodoc: tipodoc,
        nrodoc: nrodoc,
        fechanacimiento: fechanacimiento,
        nombrecompleto: nombrecompleto
      };
      return integrante;
    }
  }, {
    key: 'render',
    value: function render() {
      var _this2 = this;

      var selectStyle = {
        textTransform: 'capitalize',
        fontFamily: '\'Roboto, Light\', sans-serif'
      };

      var options = this.props.integrantes.map(function (integrante) {
        return _jsx('option', {
          'data-sexo': integrante.sexo,
          'data-edad': integrante.edad,
          'data-prepaga': integrante.prepaga,
          'data-credencial': integrante.credencial,
          'data-tipodoc': integrante.tipoDocumento.codigo,
          'data-nrodoc': integrante.documento,
          'data-fechanacimiento': integrante.fechaNacimiento,
          'data-nombrecompleto': integrante.nombreCompleto,
          value: integrante.inte
        }, integrante.inte, __WEBPACK_IMPORTED_MODULE_4_lodash___default.a.lowerCase(integrante.apellido), ', ', __WEBPACK_IMPORTED_MODULE_4_lodash___default.a.lowerCase(integrante.nombre));
      });

      return _jsx('div', {}, void 0, _jsx('select', {
        onChange: function onChange(e) {
          return _this2.onChangeSelectIntegrantes(e);
        },
        id: 'selectIntegrantes',
        className: 'form-control',
        style: selectStyle
      }, void 0, this.state.selectIntegrantes === 'PENDING' ? _ref2 : null, options));
    }
  }]);

  return SelectIntegrantes;
}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component);

var mapStateToProps = function mapStateToProps(state) {
  return {
    integrantes: state.integrantes,
    loggedUser: __WEBPACK_IMPORTED_MODULE_4_lodash___default.a.get(state, 'auth.loginResponse.modelEspecifico', {})
  };
};

/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_1_react_redux__["b" /* connect */])(mapStateToProps, __WEBPACK_IMPORTED_MODULE_6__actions_integrantesActions__)(__WEBPACK_IMPORTED_MODULE_2_isomorphic_style_loader_lib_withStyles___default()()(SelectIntegrantes)));

SelectIntegrantes.defaultProp = {
  sexo: false,
  edad: false,
  integrantes: []
};

/***/ }),
/* 1240 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = Label;

var _react = __webpack_require__(71);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(1124);

var _propTypes2 = _interopRequireDefault(_propTypes);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/**
 * @ignore
 * @param {Object} props
 * @param {InputRangeClassNames} props.classNames
 * @param {Function} props.formatLabel
 * @param {string} props.type
 */
function Label(props) {
  var labelValue = props.formatLabel ? props.formatLabel(props.children, props.type) : props.children;

  return _react2.default.createElement(
    'span',
    { className: props.classNames[props.type + 'Label'] },
    _react2.default.createElement(
      'span',
      { className: props.classNames.labelContainer },
      labelValue
    )
  );
}

/**
 * @type {Object}
 * @property {Function} children
 * @property {Function} classNames
 * @property {Function} formatLabel
 * @property {Function} type
 */
Label.propTypes = {
  children: _propTypes2.default.node.isRequired,
  classNames: _propTypes2.default.objectOf(_propTypes2.default.string).isRequired,
  formatLabel: _propTypes2.default.func,
  type: _propTypes2.default.string.isRequired
};
module.exports = exports['default'];
//# sourceMappingURL=label.js.map

/***/ }),
/* 1241 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(71);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_redux__ = __webpack_require__(415);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_isomorphic_style_loader_lib_withStyles__ = __webpack_require__(887);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_isomorphic_style_loader_lib_withStyles___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_isomorphic_style_loader_lib_withStyles__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__ModalCuandoUtilizarEconsulta_css__ = __webpack_require__(1295);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__ModalCuandoUtilizarEconsulta_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__ModalCuandoUtilizarEconsulta_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__public_images_Tabla_green_png__ = __webpack_require__(1297);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__public_images_Tabla_green_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__public_images_Tabla_green_png__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__public_images_Tabla_red_png__ = __webpack_require__(1298);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__public_images_Tabla_red_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__public_images_Tabla_red_png__);
var _jsx = function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; }();

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

/* eslint react/no-did-mount-set-state: 0 */
/* eslint react/prop-types: 0 */
/* eslint consistent-return: 0 */








var _ref = _jsx('button', {
  type: 'button',
  className: 'close',
  'data-dismiss': 'modal',
  'aria-label': 'Close'
}, void 0, _jsx('span', {
  'aria-hidden': 'true'
}, void 0, '\xD7'));

var _ref2 = _jsx('img', {
  alt: 'Anterior',
  src: __WEBPACK_IMPORTED_MODULE_4__public_images_Tabla_green_png___default.a
});

var _ref3 = _jsx('tbody', {}, void 0, _jsx('tr', {}, void 0, _jsx('td', {}, void 0, 'Tos / Catarro / Fiebre / Congesti\xF3n nasal')), _jsx('tr', {}, void 0, _jsx('td', {}, void 0, 'Diarrea / C\xF3lico abdominal')), _jsx('tr', {}, void 0, _jsx('td', {}, void 0, 'N\xE1useas y v\xF3mitos')), _jsx('tr', {}, void 0, _jsx('td', {}, void 0, 'Dolor al orinar')), _jsx('tr', {}, void 0, _jsx('td', {}, void 0, 'Picaduras')), _jsx('tr', {}, void 0, _jsx('td', {}, void 0, 'Erupciones en la piel')), _jsx('tr', {}, void 0, _jsx('td', {}, void 0, 'Dolor articular o muscular')), _jsx('tr', {}, void 0, _jsx('td', {}, void 0, 'Dolor de cabeza')), _jsx('tr', {}, void 0, _jsx('td', {}, void 0, 'Segunda opini\xF3n sobre temas m\xE9dicos')), _jsx('tr', {}, void 0, _jsx('td', {}, void 0, 'Medicina del viajero')), _jsx('tr', {}, void 0, _jsx('td', {}, void 0, 'Recomendaciones de vacunaci\xF3n')), _jsx('tr', {}, void 0, _jsx('td', {}, void 0, 'C\xE1lculo de dosis de un medicamento recetado')));

var _ref4 = _jsx('img', {
  alt: 'Anterior',
  src: __WEBPACK_IMPORTED_MODULE_5__public_images_Tabla_red_png___default.a
});

var _ref5 = _jsx('tbody', {}, void 0, _jsx('tr', {}, void 0, _jsx('td', {}, void 0, 'Dolor de pecho')), _jsx('tr', {}, void 0, _jsx('td', {}, void 0, 'Falta de aire')), _jsx('tr', {}, void 0, _jsx('td', {}, void 0, 'Hemorragias')), _jsx('tr', {}, void 0, _jsx('td', {}, void 0, 'Fiebre por m\xE1s de 48 horas')), _jsx('tr', {}, void 0, _jsx('td', {}, void 0, 'Fiebre en menores de 3 meses')), _jsx('tr', {}, void 0, _jsx('td', {}, void 0, 'P\xE9rdida de la conciencia')), _jsx('tr', {}, void 0, _jsx('td', {}, void 0, 'Desorientaci\xF3n')), _jsx('tr', {}, void 0, _jsx('td', {}, void 0, 'Quemaduras')), _jsx('tr', {}, void 0, _jsx('td', {}, void 0, 'Fracturas')), _jsx('tr', {}, void 0, _jsx('td', {}, void 0, 'Pacientes con inmunosupresi\xF3n')), _jsx('tr', {}, void 0, _jsx('td', {}, void 0, 'Pacientes con problemas oncol\xF3gicos')), _jsx('tr', {}, void 0, _jsx('td', {}, void 0, 'Cualquier situaci\xF3n de riesgo de vida')));

var ModalCuandoUtilizarEconsulta = function (_React$Component) {
  _inherits(ModalCuandoUtilizarEconsulta, _React$Component);

  function ModalCuandoUtilizarEconsulta() {
    _classCallCheck(this, ModalCuandoUtilizarEconsulta);

    return _possibleConstructorReturn(this, (ModalCuandoUtilizarEconsulta.__proto__ || Object.getPrototypeOf(ModalCuandoUtilizarEconsulta)).apply(this, arguments));
  }

  _createClass(ModalCuandoUtilizarEconsulta, [{
    key: 'render',
    value: function render() {
      return _jsx('div', {
        className: __WEBPACK_IMPORTED_MODULE_3__ModalCuandoUtilizarEconsulta_css___default.a.modalScroll + ' modal fade',
        id: 'ModalCuandoUtilizarEconsulta'
      }, void 0, _jsx('div', {
        className: 'modal-dialog  modal-lg'
      }, void 0, _jsx('div', {
        className: __WEBPACK_IMPORTED_MODULE_3__ModalCuandoUtilizarEconsulta_css___default.a.modalContent + ' modal-content'
      }, void 0, _jsx('div', {
        className: __WEBPACK_IMPORTED_MODULE_3__ModalCuandoUtilizarEconsulta_css___default.a.modalHeader + ' modal-header'
      }, void 0, _jsx('h5', {
        className: __WEBPACK_IMPORTED_MODULE_3__ModalCuandoUtilizarEconsulta_css___default.a.modalTitle + ' modal-title'
      }, void 0, 'Cu\xE1ndo Utilizar E-Consulta'), _ref), _jsx('div', {
        className: 'modal-body',
        style: {
          maxHeight: 'calc(100vh - 212px)',
          overflowY: 'auto',
          paddingBottom: '0'
        }
      }, void 0, _jsx('div', {
        className: 'row'
      }, void 0, _jsx('div', {
        className: __WEBPACK_IMPORTED_MODULE_3__ModalCuandoUtilizarEconsulta_css___default.a.noPadding + ' col-sm-6'
      }, void 0, _jsx('table', {
        className: __WEBPACK_IMPORTED_MODULE_3__ModalCuandoUtilizarEconsulta_css___default.a.table + ' table table-striped'
      }, void 0, _jsx('thead', {}, void 0, _jsx('tr', {
        style: { borderRight: '1px solid #fff' }
      }, void 0, _jsx('th', {
        scope: 'col',
        style: { textAlign: 'center' }
      }, void 0, _ref2))), _ref3)), _jsx('div', {
        className: __WEBPACK_IMPORTED_MODULE_3__ModalCuandoUtilizarEconsulta_css___default.a.noPadding + ' col-sm-6'
      }, void 0, _jsx('table', {
        className: __WEBPACK_IMPORTED_MODULE_3__ModalCuandoUtilizarEconsulta_css___default.a.table + ' table table-striped'
      }, void 0, _jsx('thead', {}, void 0, _jsx('tr', {}, void 0, _jsx('th', {
        scope: 'col',
        style: { textAlign: 'center' }
      }, void 0, _ref4))), _ref5)))), _jsx('div', {
        className: __WEBPACK_IMPORTED_MODULE_3__ModalCuandoUtilizarEconsulta_css___default.a.modalFooter + ' modal-footer'
      }, void 0, _jsx('button', {
        'data-dismiss': 'modal',
        className: 'btn btn-danger',
        onClick: this.print,
        style: { backgroundColor: '#E4002B', cursor: 'pointer' }
      }, void 0, 'Lo entiendo')))));
    }
  }]);

  return ModalCuandoUtilizarEconsulta;
}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component);

/* const mapStateToProps = state => ({
  removeTurnoResp: state.turno.remove,
}); */

/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_1_react_redux__["b" /* connect */])(null, null)(__WEBPACK_IMPORTED_MODULE_2_isomorphic_style_loader_lib_withStyles___default()(__WEBPACK_IMPORTED_MODULE_3__ModalCuandoUtilizarEconsulta_css___default.a)(ModalCuandoUtilizarEconsulta)));

/***/ }),
/* 1242 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(71);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_redux__ = __webpack_require__(415);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_isomorphic_style_loader_lib_withStyles__ = __webpack_require__(887);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_isomorphic_style_loader_lib_withStyles___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_isomorphic_style_loader_lib_withStyles__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__constants__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__ModalFinalizado_css__ = __webpack_require__(1243);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__ModalFinalizado_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__ModalFinalizado_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__actions_telemedicinaActions__ = __webpack_require__(416);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__utils_generateAbsoluteUrl__ = __webpack_require__(127);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__utils_redirectTo__ = __webpack_require__(419);
var _jsx = function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; }();

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

/* eslint react/no-did-mount-set-state: 0 */
/* eslint react/prop-types: 0 */
/* eslint consistent-return: 0 */
/* global $ */










var _ref = _jsx('h5', {
  className: 'modal-title'
}, void 0, 'Muchas gracias por utilizar E-Consulta', _jsx('span', {}, void 0, 'Tal vez te interese.'));

var _ref2 = _jsx('i', {
  className: 'fa fa-video-camera',
  'aria-hidden': 'true'
});

var _ref3 = _jsx('p', {}, void 0, 'Programar', _jsx('br', {}), ' e-Consulta');

var ModalFinalizado = function (_React$Component) {
  _inherits(ModalFinalizado, _React$Component);

  function ModalFinalizado(props) {
    _classCallCheck(this, ModalFinalizado);

    var _this = _possibleConstructorReturn(this, (ModalFinalizado.__proto__ || Object.getPrototypeOf(ModalFinalizado)).call(this, props));

    _this.finalizar = _this.finalizar.bind(_this);
    return _this;
  }

  _createClass(ModalFinalizado, [{
    key: 'finalizar',
    value: function finalizar() {
      this.props.cleanLlamada();
      if (document.getElementById('localView') && document.getElementById('localView').srcObject) {
        document.getElementById('localView').srcObject.getTracks().forEach(function (track) {
          return track.stop();
        });
        $('localView').srcObject = null;
      }
      var datos = JSON.parse(localStorage.getItem(__WEBPACK_IMPORTED_MODULE_3__constants__["_30" /* LOCALSTORAGE_AUTH_KEY */]));
      var token = datos.token;
      var dataToken = {
        token: token
      };
      $.ajax({
        url: Object(__WEBPACK_IMPORTED_MODULE_6__utils_generateAbsoluteUrl__["a" /* default */])() + '/renew-token',
        global: false,
        type: 'POST',
        headers: {
          'Content-Type': 'application/json'
        },
        data: JSON.stringify(dataToken),
        async: false,
        success: function success(response) {
          if (response.data && response.data.token && response.data.exp) {
            var authData = localStorage.getItem(__WEBPACK_IMPORTED_MODULE_3__constants__["_30" /* LOCALSTORAGE_AUTH_KEY */]);
            var authJson = JSON.parse(authData);
            authJson.token = response.data.token;
            authJson.exp = response.data.exp;
            localStorage.setItem('token', JSON.stringify(authJson.token));
            localStorage.setItem(__WEBPACK_IMPORTED_MODULE_3__constants__["_30" /* LOCALSTORAGE_AUTH_KEY */], JSON.stringify(authJson));
          }
        }
      });
      this.props.hideValidacionesTecnicas();
      Object(__WEBPACK_IMPORTED_MODULE_7__utils_redirectTo__["a" /* default */])('/telemedicina');
    }
  }, {
    key: 'goToTurnos',
    value: function goToTurnos() {
      this.props.cleanLlamada();
      this.props.hideValidacionesTecnicas();
      window.location.href = __WEBPACK_IMPORTED_MODULE_3__constants__["_24" /* HOST_SERVER */] + 'smgnewsite/prepaga/turnos_online.php?origen=barIzq';
    }
  }, {
    key: 'render',
    value: function render() {
      var _this2 = this;

      return _jsx('div', {
        className: __WEBPACK_IMPORTED_MODULE_4__ModalFinalizado_css___default.a.modalFinalizado + ' modal fade',
        id: 'modalFinalizado'
      }, void 0, _jsx('div', {
        className: __WEBPACK_IMPORTED_MODULE_4__ModalFinalizado_css___default.a.modalDialog + ' modal-dialog',
        role: 'document'
      }, void 0, _jsx('div', {
        className: __WEBPACK_IMPORTED_MODULE_4__ModalFinalizado_css___default.a.modalFinalizadoContent + ' modal-content'
      }, void 0, _jsx('div', {
        className: __WEBPACK_IMPORTED_MODULE_4__ModalFinalizado_css___default.a.modalHeader + ' modal-header'
      }, void 0, _ref), _jsx('div', {
        className: __WEBPACK_IMPORTED_MODULE_4__ModalFinalizado_css___default.a.modalBody + ' modal-body'
      }, void 0, _jsx('button', {
        'data-dismiss': 'modal',
        className: '' + __WEBPACK_IMPORTED_MODULE_4__ModalFinalizado_css___default.a.modalButtons,
        onClick: function onClick() {
          return _this2.finalizar();
        }
      }, void 0, _ref2, _ref3)), _jsx('div', {
        className: __WEBPACK_IMPORTED_MODULE_4__ModalFinalizado_css___default.a.modalFooter + ' modal-footer'
      }, void 0, _jsx('button', {
        'data-dismiss': 'modal',
        id: 'openModalButton',
        className: __WEBPACK_IMPORTED_MODULE_4__ModalFinalizado_css___default.a.boton_rojo + ' btn btn-default text-center',
        onClick: function onClick() {
          return _this2.finalizar();
        }
      }, void 0, 'Finalizar')))));
    }
  }]);

  return ModalFinalizado;
}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component);

/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_1_react_redux__["b" /* connect */])(null, __WEBPACK_IMPORTED_MODULE_5__actions_telemedicinaActions__)(__WEBPACK_IMPORTED_MODULE_2_isomorphic_style_loader_lib_withStyles___default()(__WEBPACK_IMPORTED_MODULE_4__ModalFinalizado_css___default.a)(ModalFinalizado)));

/***/ }),
/* 1243 */
/***/ (function(module, exports, __webpack_require__) {


    var content = __webpack_require__(1244);
    var insertCss = __webpack_require__(889);

    if (typeof content === 'string') {
      content = [[module.i, content, '']];
    }

    module.exports = content.locals || {};
    module.exports._getContent = function() { return content; };
    module.exports._getCss = function() { return content.toString(); };
    module.exports._insertCss = function(options) { return insertCss(content, options) };
    
    // Hot Module Replacement
    // https://webpack.github.io/docs/hot-module-replacement
    // Only activated in browser context
    if (false) {
      var removeCss = function() {};
      module.hot.accept("!!../../../../node_modules/css-loader/index.js??ref--2-rules-2!../../../../node_modules/postcss-loader/lib/index.js??ref--2-rules-3!./ModalFinalizado.css", function() {
        content = require("!!../../../../node_modules/css-loader/index.js??ref--2-rules-2!../../../../node_modules/postcss-loader/lib/index.js??ref--2-rules-3!./ModalFinalizado.css");

        if (typeof content === 'string') {
          content = [[module.id, content, '']];
        }

        removeCss = insertCss(content, { replace: true });
      });
      module.hot.dispose(function() { removeCss(); });
    }
  

/***/ }),
/* 1244 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(888)(false);
// imports


// module
exports.push([module.i, "._2VwQC{font-family:Roboto,sans-serif}._3_zuS,._3TB2M{width:600px}._2h0OF{font-size:18px;-webkit-box-align:baseline;-ms-flex-align:baseline;align-items:baseline}._2h0OF h5{color:#363636}._2h0OF h5 span{opacity:.5;display:block}._2wlBe{text-align:center;padding:40px}._2grFB{background-color:#fff;border:1px solid #e4002b;margin:0 20px;cursor:pointer;-webkit-appearance:initial!important;display:inline-block;padding:30px;width:200px}._2grFB,a._2grFB:hover{color:#e4002b;text-decoration:none}a._2grFB:hover{background-color:#f6f6f6}._2grFB i{font-size:40px}._2grFB p{margin:10px 0 0}._2KTEs{-webkit-box-pack:center;-ms-flex-pack:center;justify-content:center}._2KTEs button{width:140px;color:#fff;font-size:14px;background-color:#e4002b;cursor:pointer}._2KTEs button:hover{color:#ddd;background-color:#e4002b}._1sQ5P{color:#eee;background-color:#e4002b;border-color:#e4002b;cursor:pointer;font-family:Roboto\\, Medium;width:140px}", ""]);

// exports
exports.locals = {
	"modalFinalizado": "_2VwQC",
	"modalFinalizadoContent": "_3TB2M",
	"modalDialog": "_3_zuS",
	"modalHeader": "_2h0OF",
	"modalBody": "_2wlBe",
	"modalButtons": "_2grFB",
	"modalFooter": "_2KTEs",
	"boton_rojo": "_1sQ5P"
};

/***/ }),
/* 1245 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";

// CONCATENATED MODULE: ./src/components/Telemedicina/NavegadorIncompatible/NavegadorIncompatible.js
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(71);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(182);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_redux__ = __webpack_require__(415);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_isomorphic_style_loader_lib_withStyles__ = __webpack_require__(887);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_isomorphic_style_loader_lib_withStyles___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_isomorphic_style_loader_lib_withStyles__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__NavegadorIncompatible_css__ = __webpack_require__(1334);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__NavegadorIncompatible_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__NavegadorIncompatible_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__public_images_browser_sad_png__ = __webpack_require__(1336);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__public_images_browser_sad_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__public_images_browser_sad_png__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__public_images_chrome_png__ = __webpack_require__(1337);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__public_images_chrome_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__public_images_chrome_png__);
var _jsx = function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; }();





// eslint-disable-next-line css-modules/no-unused-class




var _ref = _jsx('picture', {}, void 0, _jsx('img', {
  alt: '',
  src: __WEBPACK_IMPORTED_MODULE_6__public_images_chrome_png___default.a
}));

var _ref2 = _jsx('br', {});

var _ref3 = _jsx('a', {
  className: 's.download',
  href: 'https://www.google.com/chrome'
}, void 0, 'Descargar Google Chrome');

function NavegadorIncompatible(props) {
  return _jsx('div', {
    className: __WEBPACK_IMPORTED_MODULE_4__NavegadorIncompatible_css___default.a.root
  }, void 0, _jsx('picture', {}, void 0, _jsx('img', {
    alt: '',
    className: __WEBPACK_IMPORTED_MODULE_4__NavegadorIncompatible_css___default.a.browserSad,
    src: __WEBPACK_IMPORTED_MODULE_5__public_images_browser_sad_png___default.a
  })), _jsx('p', {}, void 0, _jsx('span', {
    className: __WEBPACK_IMPORTED_MODULE_4__NavegadorIncompatible_css___default.a.title
  }, void 0, 'Tu navegador no es compatible con E-Consulta')), _jsx('span', {
    className: __WEBPACK_IMPORTED_MODULE_4__NavegadorIncompatible_css___default.a.message
  }, void 0, props.children), _jsx('p', {
    className: __WEBPACK_IMPORTED_MODULE_4__NavegadorIncompatible_css___default.a.browser
  }, void 0, _ref, _ref2, _ref3));
}

/* harmony default export */ var NavegadorIncompatible_defaultExport = (Object(__WEBPACK_IMPORTED_MODULE_2_react_redux__["b" /* connect */])(null, null)(__WEBPACK_IMPORTED_MODULE_3_isomorphic_style_loader_lib_withStyles___default()(__WEBPACK_IMPORTED_MODULE_4__NavegadorIncompatible_css___default.a)(NavegadorIncompatible)));
// CONCATENATED MODULE: ./src/routes/telemedicina/ErrorConexionVideoLlamada/ErrorConexionVideoLlamada.js
/* harmony import */ var ErrorConexionVideoLlamada___WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(71);
/* harmony import */ var ErrorConexionVideoLlamada___WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(ErrorConexionVideoLlamada___WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_isomorphic_style_loader_lib_withStyles__ = __webpack_require__(887);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_isomorphic_style_loader_lib_withStyles___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_isomorphic_style_loader_lib_withStyles__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__styles_css__ = __webpack_require__(1338);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__styles_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__styles_css__);
var ErrorConexionVideoLlamada__jsx = function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; }();





var ErrorConexionVideoLlamada__ref = ErrorConexionVideoLlamada__jsx('br', {});

var ErrorConexionVideoLlamada__ref2 = ErrorConexionVideoLlamada__jsx('b', {}, void 0, ' click aqui ');

var ErrorConexionVideoLlamada__ref3 = ErrorConexionVideoLlamada__jsx('b', {}, void 0, ' click aqui ');

var _ref4 = ErrorConexionVideoLlamada__jsx('b', {}, void 0, ' Consulta de Turnos');

var ErrorConexionVideoLlamada = function ErrorConexionVideoLlamada(props) {
  function redirectToConsultaTurno() {
    console.log('redirectToConsultaTurno');
  }

  function redirectToValidacionesTecnicas() {
    console.log(props.reconectar);
  }

  return ErrorConexionVideoLlamada__jsx('div', {
    className: __WEBPACK_IMPORTED_MODULE_2__styles_css___default.a.root
  }, void 0, ErrorConexionVideoLlamada__jsx('div', {
    className: 'row'
  }, void 0, ErrorConexionVideoLlamada__jsx('div', {
    className: 'col-md-12'
  }, void 0, ErrorConexionVideoLlamada__jsx('p', {}, void 0, 'Ocurri\xF3 un error al conectar con tu m\xE9dico. Para volver a intentarlo por favor', ErrorConexionVideoLlamada__ref, ' hac\xE9', ErrorConexionVideoLlamada__jsx('a', {
    onClick: redirectToValidacionesTecnicas,
    className: __WEBPACK_IMPORTED_MODULE_2__styles_css___default.a.btnClickForward,
    'data-toggle': 'tooltip',
    role: 'button',
    'data-placement': 'bottom'
  }, void 0, ErrorConexionVideoLlamada__ref2, '>', ErrorConexionVideoLlamada__ref3), 'o ingres\xE1 desde', ErrorConexionVideoLlamada__jsx('a', {
    className: __WEBPACK_IMPORTED_MODULE_2__styles_css___default.a.btnClickForward,
    onClick: redirectToConsultaTurno,
    role: 'button'
  }, void 0, '>', _ref4), '.'))));
};

/* harmony default export */ var ErrorConexionVideoLlamada_defaultExport = (__WEBPACK_IMPORTED_MODULE_1_isomorphic_style_loader_lib_withStyles___default()(__WEBPACK_IMPORTED_MODULE_2__styles_css___default.a)(ErrorConexionVideoLlamada));
// CONCATENATED MODULE: ./src/components/Telemedicina/MuyProntoParaIniciarConsulta/MuyProntoParaIniciarConsulta.js
/* harmony import */ var MuyProntoParaIniciarConsulta___WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(71);
/* harmony import */ var MuyProntoParaIniciarConsulta___WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(MuyProntoParaIniciarConsulta___WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_redux__ = __webpack_require__(415);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_isomorphic_style_loader_lib_withStyles__ = __webpack_require__(887);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_isomorphic_style_loader_lib_withStyles___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_isomorphic_style_loader_lib_withStyles__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__MuyProntoParaIniciarConsulta_css__ = __webpack_require__(1340);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__MuyProntoParaIniciarConsulta_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__MuyProntoParaIniciarConsulta_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__public_images_ic_calendar_grey_png__ = __webpack_require__(1342);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__public_images_ic_calendar_grey_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__public_images_ic_calendar_grey_png__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__utils_redirectTo__ = __webpack_require__(419);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__actions_telemedicinaActions__ = __webpack_require__(416);
var MuyProntoParaIniciarConsulta__jsx = function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; }();

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

/* eslint react/no-did-mount-set-state: 0 */
/* eslint react/prop-types: 0 */
/* eslint consistent-return: 0 */









var MuyProntoParaIniciarConsulta__ref = MuyProntoParaIniciarConsulta__jsx('img', {
  className: 'mr-3',
  src: __WEBPACK_IMPORTED_MODULE_4__public_images_ic_calendar_grey_png___default.a,
  alt: 'calendario'
});

var MuyProntoParaIniciarConsulta__ref2 = MuyProntoParaIniciarConsulta__jsx('br', {});

var MuyProntoParaIniciarConsulta__ref3 = MuyProntoParaIniciarConsulta__jsx('i', {
  className: 'glyphicon glyphicon-chevron-left'
});

var MuyProntoParaIniciarConsulta = function (_React$Component) {
  _inherits(MuyProntoParaIniciarConsulta, _React$Component);

  function MuyProntoParaIniciarConsulta(props) {
    _classCallCheck(this, MuyProntoParaIniciarConsulta);

    var _this = _possibleConstructorReturn(this, (MuyProntoParaIniciarConsulta.__proto__ || Object.getPrototypeOf(MuyProntoParaIniciarConsulta)).call(this, props));

    _this.volverAConsultaTurnos = _this.volverAConsultaTurnos.bind(_this);
    return _this;
  }

  _createClass(MuyProntoParaIniciarConsulta, [{
    key: 'volverAConsultaTurnos',
    value: function volverAConsultaTurnos() {
      this.props.hideMuyProntoParaIniciarLaConsulta();
      Object(__WEBPACK_IMPORTED_MODULE_5__utils_redirectTo__["a" /* default */])('/telemedicina/solicitud-turnos');
    }
  }, {
    key: 'render',
    value: function render() {
      var _this2 = this;

      var arrFecha = this.props.fecha.split('-');
      var arrHora = arrFecha[2].split(' ');
      var year = arrFecha[0];
      var month = arrFecha[1];
      var day = arrHora[0];
      var hour = arrHora[1];
      return MuyProntoParaIniciarConsulta__jsx('div', {
        className: __WEBPACK_IMPORTED_MODULE_3__MuyProntoParaIniciarConsulta_css___default.a.msg
      }, void 0, MuyProntoParaIniciarConsulta__jsx('div', {
        className: 'media'
      }, void 0, MuyProntoParaIniciarConsulta__ref, MuyProntoParaIniciarConsulta__jsx('div', {
        className: ' ' + __WEBPACK_IMPORTED_MODULE_3__MuyProntoParaIniciarConsulta_css___default.a.bold + ' media-body'
      }, void 0, MuyProntoParaIniciarConsulta__jsx('div', {
        className: 'mt-0 font-weight-bold'
      }, void 0, 'Todav\xEDa es muy pronto, tu consulta se encuentra agendada para el', ' ' + day + '-' + month + '-' + year + ' ' + hour, ' Hs.'), 'Por favor, regres\xE1 unos minutos antes de tu horario de atenci\xF3n.', ' ', MuyProntoParaIniciarConsulta__ref2, MuyProntoParaIniciarConsulta__jsx('button', {
        onClick: function onClick() {
          return _this2.volverAConsultaTurnos();
        },
        className: '' + __WEBPACK_IMPORTED_MODULE_3__MuyProntoParaIniciarConsulta_css___default.a.boton_volver
      }, void 0, MuyProntoParaIniciarConsulta__ref3, ' Volver a solicitud de turnos'))));
    }
  }]);

  return MuyProntoParaIniciarConsulta;
}(MuyProntoParaIniciarConsulta___WEBPACK_IMPORTED_MODULE_0_react___default.a.Component);

/* harmony default export */ var MuyProntoParaIniciarConsulta_defaultExport = (Object(__WEBPACK_IMPORTED_MODULE_1_react_redux__["b" /* connect */])(null, __WEBPACK_IMPORTED_MODULE_6__actions_telemedicinaActions__)(__WEBPACK_IMPORTED_MODULE_2_isomorphic_style_loader_lib_withStyles___default()(__WEBPACK_IMPORTED_MODULE_3__MuyProntoParaIniciarConsulta_css___default.a)(MuyProntoParaIniciarConsulta)));
// CONCATENATED MODULE: ./src/components/Tabs/Tabs.js
/* harmony import */ var Tabs___WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(71);
/* harmony import */ var Tabs___WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(Tabs___WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var Tabs___WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(182);
/* harmony import */ var Tabs___WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(Tabs___WEBPACK_IMPORTED_MODULE_1_prop_types__);
var Tabs__jsx = function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; }();




function Tabs(props) {
  return Tabs__jsx('div', {
    className: 'mt-2'
  }, void 0, props.children);
}

/* harmony default export */ var Tabs_defaultExport = (Tabs);
// CONCATENATED MODULE: ./src/components/Tabs/TabContent.js
/* harmony import */ var TabContent___WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(71);
/* harmony import */ var TabContent___WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(TabContent___WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var TabContent___WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(182);
/* harmony import */ var TabContent___WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(TabContent___WEBPACK_IMPORTED_MODULE_1_prop_types__);
var TabContent__jsx = function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; }();




function TabPanel(props) {
  return TabContent__jsx('div', {
    className: props.active ? 'tab-pane fade show active' : 'tab-pane fade show'
  }, void 0, props.children);
}

TabPanel.defaultProps = {
  active: false
};

/* harmony default export */ var TabContent_defaultExport = (TabPanel);
// CONCATENATED MODULE: ./src/components/Tabs/Tab.js
/* harmony import */ var Tab___WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(71);
/* harmony import */ var Tab___WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(Tab___WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var Tab___WEBPACK_IMPORTED_MODULE_1_isomorphic_style_loader_lib_withStyles__ = __webpack_require__(887);
/* harmony import */ var Tab___WEBPACK_IMPORTED_MODULE_1_isomorphic_style_loader_lib_withStyles___default = __webpack_require__.n(Tab___WEBPACK_IMPORTED_MODULE_1_isomorphic_style_loader_lib_withStyles__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types__ = __webpack_require__(182);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__Link__ = __webpack_require__(908);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__Tab_css__ = __webpack_require__(1343);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__Tab_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__Tab_css__);
var Tab__jsx = function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; }();





// eslint-disable-next-line css-modules/no-unused-class


function Tab(props) {
  return Tab__jsx('li', {
    className: 'nav-item'
  }, void 0, Tab__jsx(__WEBPACK_IMPORTED_MODULE_3__Link__["a" /* default */], {
    className: props.active ? 'nav-link active ' + __WEBPACK_IMPORTED_MODULE_4__Tab_css___default.a.active : 'nav-link  ' + __WEBPACK_IMPORTED_MODULE_4__Tab_css___default.a.navItemLink + ' ',
    to: props.to
  }, void 0, props.children));
}

Tab.defaultProps = {
  active: false
};

/* harmony default export */ var Tab_defaultExport = (Tab___WEBPACK_IMPORTED_MODULE_1_isomorphic_style_loader_lib_withStyles___default()(__WEBPACK_IMPORTED_MODULE_4__Tab_css___default.a)(Tab));
// CONCATENATED MODULE: ./src/components/Tabs/TabPanel.js
/* harmony import */ var TabPanel___WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(71);
/* harmony import */ var TabPanel___WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(TabPanel___WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var TabPanel___WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(182);
/* harmony import */ var TabPanel___WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(TabPanel___WEBPACK_IMPORTED_MODULE_1_prop_types__);
var TabPanel__jsx = function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; }();




function TabPanel_TabPanel(props) {
  return TabPanel__jsx('div', {
    className: 'tab-content'
  }, void 0, props.children);
}

/* harmony default export */ var TabPanel_defaultExport = (TabPanel_TabPanel);
// CONCATENATED MODULE: ./src/components/Tabs/TabsList.js
/* harmony import */ var TabsList___WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(71);
/* harmony import */ var TabsList___WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(TabsList___WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var TabsList___WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(182);
/* harmony import */ var TabsList___WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(TabsList___WEBPACK_IMPORTED_MODULE_1_prop_types__);
var TabsList__jsx = function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; }();




function TabsList(props) {
  return TabsList__jsx('ul', {
    className: 'nav nav-tabs'
  }, void 0, props.children);
}

/* harmony default export */ var TabsList_defaultExport = (TabsList);
// CONCATENATED MODULE: ./src/components/Tabs/index.js







// CONCATENATED MODULE: ./src/routes/telemedicina/TelemedicinaPageUserLoggedIn.js
/* harmony import */ var TelemedicinaPageUserLoggedIn___WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(71);
/* harmony import */ var TelemedicinaPageUserLoggedIn___WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(TelemedicinaPageUserLoggedIn___WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var TelemedicinaPageUserLoggedIn___WEBPACK_IMPORTED_MODULE_1_react_redux__ = __webpack_require__(415);
/* harmony import */ var TelemedicinaPageUserLoggedIn___WEBPACK_IMPORTED_MODULE_2_isomorphic_style_loader_lib_withStyles__ = __webpack_require__(887);
/* harmony import */ var TelemedicinaPageUserLoggedIn___WEBPACK_IMPORTED_MODULE_2_isomorphic_style_loader_lib_withStyles___default = __webpack_require__.n(TelemedicinaPageUserLoggedIn___WEBPACK_IMPORTED_MODULE_2_isomorphic_style_loader_lib_withStyles__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__TelemedicinaPageUserLoggedIn_css__ = __webpack_require__(1248);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__TelemedicinaPageUserLoggedIn_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__TelemedicinaPageUserLoggedIn_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_Telemedicina_ValidacionesTecnicas_ValidacionesTecnicas__ = __webpack_require__(1144);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_Telemedicina_TurnosSolicitud_TurnosSolicitud__ = __webpack_require__(1246);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_Telemedicina_ModalFinalizado_ModalFinalizado__ = __webpack_require__(1242);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__components_Telemedicina_ModalCuandoUtilizarEconsulta_ModalCuandoUtilizarEconsulta__ = __webpack_require__(1241);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__components_Telemedicina_ModalError_ModalError__ = __webpack_require__(939);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__constants__ = __webpack_require__(17);
var TelemedicinaPageUserLoggedIn__jsx = function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; }();

var TelemedicinaPageUserLoggedIn__createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function TelemedicinaPageUserLoggedIn__classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function TelemedicinaPageUserLoggedIn__possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function TelemedicinaPageUserLoggedIn__inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

/* eslint react/prop-types: 0 */
/* global $ */
/* eslint-disable */












//import MonitoringUtil from '../../utils/monitoringUtil.js';




var TelemedicinaPageUserLoggedIn__ref = TelemedicinaPageUserLoggedIn__jsx(NavegadorIncompatible_defaultExport, {}, void 0, 'Estas utilizando un navegador web que no es compatible.', TelemedicinaPageUserLoggedIn__jsx('br', {}), 'Para mejorar tu experiencia recomendamos el uso de Google Chrome.');

var TelemedicinaPageUserLoggedIn__ref2 = TelemedicinaPageUserLoggedIn__jsx(NavegadorIncompatible_defaultExport, {}, void 0, 'Tu versi\xF3n de Chrome no es compatible. Para mejorar tu experiencia te recomendamos actualizar el navegador.');

var TelemedicinaPageUserLoggedIn__ref3 = TelemedicinaPageUserLoggedIn__jsx(__WEBPACK_IMPORTED_MODULE_6__components_Telemedicina_ModalFinalizado_ModalFinalizado__["a" /* default */], {});

var TelemedicinaPageUserLoggedIn__ref4 = TelemedicinaPageUserLoggedIn__jsx(__WEBPACK_IMPORTED_MODULE_7__components_Telemedicina_ModalCuandoUtilizarEconsulta_ModalCuandoUtilizarEconsulta__["a" /* default */], {});

var _ref5 = TelemedicinaPageUserLoggedIn__jsx(__WEBPACK_IMPORTED_MODULE_4__components_Telemedicina_ValidacionesTecnicas_ValidacionesTecnicas__["a" /* default */]
//origen="espontaneo"
// origen={this.props.origen}
// especialidad={$('#especialidad').val()}
, {});

var TelemedicinaPageUserLoggedIn_TelemedicinaPageUserLoggedIn = function (_React$Component) {
  TelemedicinaPageUserLoggedIn__inherits(TelemedicinaPageUserLoggedIn, _React$Component);

  function TelemedicinaPageUserLoggedIn() {
    TelemedicinaPageUserLoggedIn__classCallCheck(this, TelemedicinaPageUserLoggedIn);

    var _this = TelemedicinaPageUserLoggedIn__possibleConstructorReturn(this, (TelemedicinaPageUserLoggedIn.__proto__ || Object.getPrototypeOf(TelemedicinaPageUserLoggedIn)).call(this));

    _this.state = {
      connectionError: false
    };
    return _this;
  }

  TelemedicinaPageUserLoggedIn__createClass(TelemedicinaPageUserLoggedIn, [{
    key: 'componentWillMount',
    value: function componentWillMount() {
      //Registro en el sistema de Monitoreo si es que no existe
      //const monitoringUtil = new MonitoringUtil();
      //monitoringUtil.createAffilliate();
      //monitoringUtil.createAffilliateLog({ interaction:"E-Consulta", message:"Pantalla Inicial Tabs E-Consulta" });  
    }
  }, {
    key: 'render',
    value: function render() {
      var isOpera = typeof window.opr !== "undefined";
      var isSafari = !!navigator.userAgent.match(/Version\/[\d\.]+.*Safari/);
      var isChrome = /Chrome/.test(navigator.userAgent) && /Google Inc/.test(navigator.vendor) && !isOpera && !isSafari;
      //var isChrome = true;
      if (!isChrome) {
        return TelemedicinaPageUserLoggedIn__ref;
      } else {
        //const isNotCompatibleChromeVersion = navigator.userAgent.match(/Chrom(e|ium)\/([0-9]+)\./)[2] <= 51;
        var isNotCompatibleChromeVersion = false;
        if (isNotCompatibleChromeVersion) {
          return TelemedicinaPageUserLoggedIn__ref2;
        }
        return TelemedicinaPageUserLoggedIn__jsx('div', {
          className: __WEBPACK_IMPORTED_MODULE_3__TelemedicinaPageUserLoggedIn_css___default.a.mtMinus
        }, void 0, TelemedicinaPageUserLoggedIn__ref3, TelemedicinaPageUserLoggedIn__ref4, this.props.errorServicio ? TelemedicinaPageUserLoggedIn__jsx(__WEBPACK_IMPORTED_MODULE_8__components_Telemedicina_ModalError_ModalError__["a" /* default */], {
          msg: this.props.errorServicio
        }) : '', TelemedicinaPageUserLoggedIn__jsx('div', {
          className: '' + __WEBPACK_IMPORTED_MODULE_3__TelemedicinaPageUserLoggedIn_css___default.a.root
        }, void 0, TelemedicinaPageUserLoggedIn__jsx('div', {
          className: __WEBPACK_IMPORTED_MODULE_3__TelemedicinaPageUserLoggedIn_css___default.a.container + ' row'
        }, void 0, TelemedicinaPageUserLoggedIn__jsx('div', {
          className: 'col-md-12'
        }, void 0, this.props.validaciones_tecnicas ? _ref5 : this.props.show ? TelemedicinaPageUserLoggedIn__jsx(MuyProntoParaIniciarConsulta_defaultExport, {
          fecha: this.props.fecha
        }) : TelemedicinaPageUserLoggedIn__jsx('div', {
          className: 'col-md-12'
        }, void 0, TelemedicinaPageUserLoggedIn__jsx('p', {
          role: 'presentation',
          className: __WEBPACK_IMPORTED_MODULE_3__TelemedicinaPageUserLoggedIn_css___default.a.linkModalBienvenida,
          onClick: function onClick() {
            return TelemedicinaPageUserLoggedIn.showModalBienvenida();
          }
        }, void 0, '\xBFCu\xE1ndo utilizar E-Consulta?'), TelemedicinaPageUserLoggedIn__jsx('div', {}, void 0, TelemedicinaPageUserLoggedIn__jsx(Tabs_defaultExport, {}, void 0, TelemedicinaPageUserLoggedIn__jsx('div', {
          to: '/telemedicina/solicitud-turnos',
          active: this.props.activeSolicitud
        }, void 0), TelemedicinaPageUserLoggedIn__jsx(TabPanel_defaultExport, {}, void 0, TelemedicinaPageUserLoggedIn__jsx(TabContent_defaultExport, {
          active: true
        }, void 0, TelemedicinaPageUserLoggedIn__jsx(this.props.component, {}))))))))));
      }
    }
  }], [{
    key: 'showModalBienvenida',
    value: function showModalBienvenida() {
      if (window.location !== window.parent.location) {
        window.top.postMessage(JSON.stringify({ type: 'MODAL_WHEN_USE' }), '*');
      } else {
        $('#ModalCuandoUtilizarEconsulta').modal('show');
      }
    }
  }]);

  return TelemedicinaPageUserLoggedIn;
}(TelemedicinaPageUserLoggedIn___WEBPACK_IMPORTED_MODULE_0_react___default.a.Component);

var mapStateToProps = function mapStateToProps(state) {
  return {
    validaciones_tecnicas: state.telemedicina.validaciones_tecnicas,
    errorServicio: state.telemedicina.error_servicio,
    show: state.telemedicina.muyProntoParaIniciarConsulta.show,
    fecha: state.telemedicina.muyProntoParaIniciarConsulta.fecha
  };
};

/* harmony default export */ var TelemedicinaPageUserLoggedIn_defaultExport = __webpack_exports__["a"] = (Object(TelemedicinaPageUserLoggedIn___WEBPACK_IMPORTED_MODULE_1_react_redux__["b" /* connect */])(mapStateToProps, null)(TelemedicinaPageUserLoggedIn___WEBPACK_IMPORTED_MODULE_2_isomorphic_style_loader_lib_withStyles___default()(__WEBPACK_IMPORTED_MODULE_3__TelemedicinaPageUserLoggedIn_css___default.a)(TelemedicinaPageUserLoggedIn_TelemedicinaPageUserLoggedIn)));

/***/ }),
/* 1246 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";

// CONCATENATED MODULE: ./src/components/Telemedicina/TurnosSolicitudAlert/TurnosSolicitudAlert.js
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(71);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_redux__ = __webpack_require__(415);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_isomorphic_style_loader_lib_withStyles__ = __webpack_require__(887);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_isomorphic_style_loader_lib_withStyles___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_isomorphic_style_loader_lib_withStyles__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__TurnosSolicitudAlert_css__ = __webpack_require__(1252);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__TurnosSolicitudAlert_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__TurnosSolicitudAlert_css__);
var _jsx = function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; }();

/* eslint react/no-did-mount-set-state: 0 */
/* eslint react/prop-types: 0 */
/* eslint consistent-return: 0 */






function TurnosSolicitudAlert(props) {
  var alertType = props.alertType;
  var style = void 0;
  if (alertType === 'success') {
    style = __WEBPACK_IMPORTED_MODULE_3__TurnosSolicitudAlert_css___default.a.success;
  } else if (alertType === 'warning') {
    style = __WEBPACK_IMPORTED_MODULE_3__TurnosSolicitudAlert_css___default.a.warning;
  }

  return _jsx('div', {
    className: style + ' alert alert-' + alertType + ' text-left col-md-12',
    role: 'alert'
  }, void 0, props.children);
}

/* harmony default export */ var TurnosSolicitudAlert_defaultExport = (Object(__WEBPACK_IMPORTED_MODULE_1_react_redux__["b" /* connect */])(null, null)(__WEBPACK_IMPORTED_MODULE_2_isomorphic_style_loader_lib_withStyles___default()(__WEBPACK_IMPORTED_MODULE_3__TurnosSolicitudAlert_css___default.a)(TurnosSolicitudAlert)));
// CONCATENATED MODULE: ./src/components/Telemedicina/ModalErrorDocumento/ModalErrorDocumento.js
/* harmony import */ var ModalErrorDocumento___WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(71);
/* harmony import */ var ModalErrorDocumento___WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(ModalErrorDocumento___WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash__ = __webpack_require__(183);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_redux__ = __webpack_require__(415);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_isomorphic_style_loader_lib_withStyles__ = __webpack_require__(887);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_isomorphic_style_loader_lib_withStyles___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_isomorphic_style_loader_lib_withStyles__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__ModalErrorDocumento_css__ = __webpack_require__(1254);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__ModalErrorDocumento_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__ModalErrorDocumento_css__);
var ModalErrorDocumento__jsx = function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; }();

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

/* eslint react/no-did-mount-set-state: 0 */
/* eslint react/prop-types: 0 */
/* eslint consistent-return: 0 */






var ModalErrorDocumento__ref = ModalErrorDocumento__jsx('div', {
  className: 'modal-header'
}, void 0, ModalErrorDocumento__jsx('h5', {
  className: 'modal-title'
}, void 0, 'Actualizaci\xF3n de datos'));

var _ref2 = ModalErrorDocumento__jsx('br', {});

var _ref3 = ModalErrorDocumento__jsx('strong', {}, void 0, '0810-444-7700');

var _ref4 = ModalErrorDocumento__jsx('br', {});

var ModalErrorDocumento = function (_React$Component) {
  _inherits(ModalErrorDocumento, _React$Component);

  function ModalErrorDocumento() {
    _classCallCheck(this, ModalErrorDocumento);

    return _possibleConstructorReturn(this, (ModalErrorDocumento.__proto__ || Object.getPrototypeOf(ModalErrorDocumento)).apply(this, arguments));
  }

  _createClass(ModalErrorDocumento, [{
    key: 'componentDidMount',
    value: function componentDidMount() {}
  }, {
    key: 'render',
    value: function render() {
      return ModalErrorDocumento__jsx('div', {
        className: 'modal fade',
        id: 'ModalErrorDocumento'
      }, void 0, ModalErrorDocumento__jsx('div', {
        className: 'modal-dialog'
      }, void 0, ModalErrorDocumento__jsx('div', {
        className: __WEBPACK_IMPORTED_MODULE_4__ModalErrorDocumento_css___default.a.modalContent + ' modal-content'
      }, void 0, ModalErrorDocumento__ref, ModalErrorDocumento__jsx('div', {
        className: __WEBPACK_IMPORTED_MODULE_4__ModalErrorDocumento_css___default.a.modalBody + ' modal-body'
      }, void 0, ModalErrorDocumento__jsx('div', {}, void 0, 'No es posible solicitar turnos para', ' ', ModalErrorDocumento__jsx('span', {
        className: '' + __WEBPACK_IMPORTED_MODULE_4__ModalErrorDocumento_css___default.a.capitalize
      }, void 0, __WEBPACK_IMPORTED_MODULE_1_lodash___default.a.lowerCase(this.props.documento)), ' ', 'dado que su DNI no est\xE1 cargado correctamente. ', _ref2, 'Por favor comunicate al ', _ref3, _ref4, ' para actualizar la informaci\xF3n.')), ModalErrorDocumento__jsx('div', {
        className: __WEBPACK_IMPORTED_MODULE_4__ModalErrorDocumento_css___default.a.modalFooter + ' modal-footer'
      }, void 0, ModalErrorDocumento__jsx('button', {
        'data-dismiss': 'modal',
        className: __WEBPACK_IMPORTED_MODULE_4__ModalErrorDocumento_css___default.a.boton_rojo + ' btn btn-danger text-center'
      }, void 0, 'Aceptar')))));
    }
  }]);

  return ModalErrorDocumento;
}(ModalErrorDocumento___WEBPACK_IMPORTED_MODULE_0_react___default.a.Component);

/* harmony default export */ var ModalErrorDocumento_defaultExport = (Object(__WEBPACK_IMPORTED_MODULE_2_react_redux__["b" /* connect */])(null, null)(__WEBPACK_IMPORTED_MODULE_3_isomorphic_style_loader_lib_withStyles___default()(__WEBPACK_IMPORTED_MODULE_4__ModalErrorDocumento_css___default.a)(ModalErrorDocumento)));
// CONCATENATED MODULE: ./src/utils/validarDocumento.js
/* harmony default export */ var validarDocumento_defaultExport = (function (documento) {
  var docString = documento.toString();
  var cont = 1;
  var primerNum = docString.substr(0, 1);

  if (docString.length <= 0 || !docString) {
    return false;
  }

  if (isNaN(documento)) {
    return false;
  }

  if (docString.length < 7) {
    return false;
  }

  for (var i = 0; i < docString.length; i += 1) {
    if (docString[i + 1] !== undefined) {
      if (primerNum === docString[i + 1]) {
        cont += 1;
      }
    }
  }

  if (cont === docString.length) {
    return false;
  }

  return true;
});
// CONCATENATED MODULE: ./src/components/Telemedicina/TurnosSolicitudFilter/TurnosSolicitudFilter.js
/* harmony import */ var TurnosSolicitudFilter___WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(71);
/* harmony import */ var TurnosSolicitudFilter___WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(TurnosSolicitudFilter___WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var TurnosSolicitudFilter___WEBPACK_IMPORTED_MODULE_1_react_redux__ = __webpack_require__(415);
/* harmony import */ var TurnosSolicitudFilter___WEBPACK_IMPORTED_MODULE_2_isomorphic_style_loader_lib_withStyles__ = __webpack_require__(887);
/* harmony import */ var TurnosSolicitudFilter___WEBPACK_IMPORTED_MODULE_2_isomorphic_style_loader_lib_withStyles___default = __webpack_require__.n(TurnosSolicitudFilter___WEBPACK_IMPORTED_MODULE_2_isomorphic_style_loader_lib_withStyles__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__TurnosSolicitudFilter_css__ = __webpack_require__(1250);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__TurnosSolicitudFilter_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__TurnosSolicitudFilter_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__actions_telemedicinaActions__ = __webpack_require__(416);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__inputs_SelectIntegrantes__ = __webpack_require__(1239);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__public_images_ic_exclamation_png__ = __webpack_require__(1256);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__public_images_ic_exclamation_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8__public_images_ic_exclamation_png__);
var TurnosSolicitudFilter__jsx = function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; }();

var TurnosSolicitudFilter__createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function TurnosSolicitudFilter__classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function TurnosSolicitudFilter__possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function TurnosSolicitudFilter__inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

/* global $ */
/*eslint-disable */
/* eslint react/no-did-mount-set-state: 0 */
/* eslint react/prop-types: 0 */
/* eslint consistent-return: 0 */
/* eslint css-modules/no-unused-class: 0 */











//import { LOCALSTORAGE_AUTH_KEY } from '../../../constants/index';

//import MonitoringUtil from '../../../utils/monitoringUtil.js';

var TurnosSolicitudFilter__ref = TurnosSolicitudFilter__jsx('option', {
  id: '0',
  value: '0'
}, void 0, 'Cargando especialidades..');

var TurnosSolicitudFilter__ref2 = TurnosSolicitudFilter__jsx('br', {});

var TurnosSolicitudFilter__ref3 = TurnosSolicitudFilter__jsx('div', {
  className: 'col-md-1'
}, void 0, TurnosSolicitudFilter__jsx('img', {
  alt: 'Anterior',
  src: __WEBPACK_IMPORTED_MODULE_8__public_images_ic_exclamation_png___default.a
}));

var TurnosSolicitudFilter_TurnosSolicitudFilter = function (_React$Component) {
  TurnosSolicitudFilter__inherits(TurnosSolicitudFilter, _React$Component);

  function TurnosSolicitudFilter(props) {
    TurnosSolicitudFilter__classCallCheck(this, TurnosSolicitudFilter);

    var _this = TurnosSolicitudFilter__possibleConstructorReturn(this, (TurnosSolicitudFilter.__proto__ || Object.getPrototypeOf(TurnosSolicitudFilter)).call(this, props));

    _this.state = {
      documento: ''
    };
    _this.showModalErrorDocumento = _this.showModalErrorDocumento.bind(_this);
    return _this;
  }

  TurnosSolicitudFilter__createClass(TurnosSolicitudFilter, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      if (this.props.especialidades) {
        var esp = this.props.especialidades[0].text;
        this.props.setSpecialityName(esp);
      }
      this.props.fetchDomicilioAfiliado();
      if (this.props.integranteSeleccionado) {
        $('#selectIntegrantes').val(this.props.integranteSeleccionado);
      }
    }
  }, {
    key: 'componentWillReceiveProps',
    value: function componentWillReceiveProps(props) {
      if (props.domicilioAfiliado !== this.props.domicilioAfiliado) {
        this.props.fetchPrepaga();
      }

      if (props.practica !== this.props.practica) {
        if (props.practica) {
          this.props.fetchEspontaneo($('#especialidad').val(), props.practica, this.props.prepaga);

          var horaDesde = '0000';
          var horaHasta = '2359';
          this.props.fetchFechasDisponibles(horaDesde, horaHasta, null, props.practica, $('#especialidad').val(), this.props.prepaga);
        }
      }
    }
  }, {
    key: 'showModalErrorDocumento',
    value: function showModalErrorDocumento() {
      var selected = $('#selectIntegrantes').find('option:selected');
      if (!validarDocumento_defaultExport(selected.data('nrodoc'))) {
        this.setState({
          documento: selected.data('nombrecompleto')
        });
        return true;
      }
      return false;
    }
  }, {
    key: 'renderOption',
    value: function renderOption() {
      var items = this.props.especialidades;
      if (items.length === 2) {
        items = this.props.especialidades.filter(function (item) {
          return item.value !== '0';
        });
      }
      return items.map(function (item) {
        return TurnosSolicitudFilter__jsx('option', {
          id: item.id,
          value: item.value,
          name: item.text
        }, item.id, item.text);
      });
    }
    // renderOptionMotivo() {
    //   let items = this.props.motivos;
    //   console.log(items);
    //   if (items.length === 2) {
    //     items = this.props.motivos.filter(item => item.value !== '0');
    //   }
    //   return items.map(item =>
    //     <option key={item.id} id={item.id} value={item.value} name={item.text}>
    //       {item.text}
    //     </option>
    //   );
    // }

  }, {
    key: 'render',
    value: function render() {
      var _this2 = this;

      return TurnosSolicitudFilter__jsx('div', {
        className: __WEBPACK_IMPORTED_MODULE_3__TurnosSolicitudFilter_css___default.a.divFilter + ' row'
      }, void 0, TurnosSolicitudFilter__jsx(ModalErrorDocumento_defaultExport, {
        documento: this.state.documento
      }), TurnosSolicitudFilter__jsx('div', {
        className: 'col-md-4'
      }, void 0, TurnosSolicitudFilter__jsx('span', {
        className: __WEBPACK_IMPORTED_MODULE_3__TurnosSolicitudFilter_css___default.a.robotoMedium
      }, void 0, 'Integrante'), TurnosSolicitudFilter__jsx('div', {
        className: 'form-group'
      }, void 0, TurnosSolicitudFilter__jsx(__WEBPACK_IMPORTED_MODULE_5__inputs_SelectIntegrantes__["a" /* default */], {
        onChange: this.props.onIntegrantesChange
      }))), TurnosSolicitudFilter__jsx('div', {
        className: 'col-md-4'
      }, void 0, TurnosSolicitudFilter__jsx('span', {
        className: __WEBPACK_IMPORTED_MODULE_3__TurnosSolicitudFilter_css___default.a.robotoMedium
      }, void 0, 'Especialidad'), TurnosSolicitudFilter__jsx('div', {
        className: 'form-group'
      }, void 0, TurnosSolicitudFilter__jsx('select', {
        id: 'especialidad',
        className: __WEBPACK_IMPORTED_MODULE_3__TurnosSolicitudFilter_css___default.a.robotoLight + ' form-control',
        required: 'true',
        onChange: this.props.onEspecialidadChange
      }, void 0, this.props.especialidades ? this.renderOption() : TurnosSolicitudFilter__ref))), TurnosSolicitudFilter__jsx('div', {
        className: 'col-md-4'
      }, void 0, TurnosSolicitudFilter__ref2, TurnosSolicitudFilter__jsx('div', {
        className: 'form-group'
      }, void 0, TurnosSolicitudFilter__jsx('button', {
        onClick: function onClick() {
          return _this2.props.onVerDisponibilidadClick();
        },
        disabled: this.props.disabledButton,
        type: 'button',
        className: __WEBPACK_IMPORTED_MODULE_3__TurnosSolicitudFilter_css___default.a.input_button + ' ' + __WEBPACK_IMPORTED_MODULE_3__TurnosSolicitudFilter_css___default.a.robotoMedium + ' btn btn-danger'
      }, void 0, 'Ver Disponibilidad'))), this.props.errorEspecialidades ? TurnosSolicitudFilter__jsx(TurnosSolicitudAlert_defaultExport, {
        alertType: 'warning'
      }, void 0, TurnosSolicitudFilter__ref3, TurnosSolicitudFilter__jsx('div', {
        className: 'col-md-11'
      }, void 0, TurnosSolicitudFilter__jsx('span', {}, void 0, this.props.errorEspecialidades.text))) : '');
    }
  }]);

  return TurnosSolicitudFilter;
}(TurnosSolicitudFilter___WEBPACK_IMPORTED_MODULE_0_react___default.a.Component);

var mapStateToProps = function mapStateToProps(state) {
  return {
    especialidades: state.telemedicina.especialidadOptions,
    //motivos: state.telemedicina.motivos,
    errorEspecialidades: state.telemedicina.errorEspecialidades,
    practica: state.telemedicina.practica,
    domicilioAfiliado: state.telemedicina.domicilio_particular,
    prepaga: state.telemedicina.prepaga,
    integrantes: state.integrantes,
    integranteSeleccionado: state.telemedicina.integranteSeleccionado,
    turnWaitingTime: state.telemedicina.turnWaitingTime
    //closeEspecialidades:state.telemedicina.closeEspecialidades
  };
};

/* harmony default export */ var TurnosSolicitudFilter_defaultExport = (Object(TurnosSolicitudFilter___WEBPACK_IMPORTED_MODULE_1_react_redux__["b" /* connect */])(mapStateToProps, __WEBPACK_IMPORTED_MODULE_4__actions_telemedicinaActions__)(TurnosSolicitudFilter___WEBPACK_IMPORTED_MODULE_2_isomorphic_style_loader_lib_withStyles___default()(__WEBPACK_IMPORTED_MODULE_3__TurnosSolicitudFilter_css___default.a)(TurnosSolicitudFilter_TurnosSolicitudFilter)));
// CONCATENATED MODULE: ./src/components/Telemedicina/CardHeader/CardHeader.js
/* harmony import */ var CardHeader___WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(71);
/* harmony import */ var CardHeader___WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(CardHeader___WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_isomorphic_style_loader_lib_withStyles__ = __webpack_require__(887);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_isomorphic_style_loader_lib_withStyles___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_isomorphic_style_loader_lib_withStyles__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__CardHeader_css__ = __webpack_require__(1257);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__CardHeader_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__CardHeader_css__);
var CardHeader__jsx = function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; }();

/* eslint react/no-did-mount-set-state: 0 */
/* eslint react/prop-types: 0 */
/* eslint consistent-return: 0 */
/*eslint-disable */




var hiddeCardHeader = function hiddeCardHeader(turnos) {
  var contShow = 0;
  turnos.forEach(function (element) {
    if (element.horarios.length === 0) {
      contShow--;
    } else {
      contShow++;
    }
  });
  return contShow < 0 ? true : false;
};

var CardHeader = function CardHeader(props) {
  //if(hiddeCardHeader(props.turnosPorfecha.turnos)){
  //  return(<div></div>)
  //}
  return CardHeader__jsx('div', {
    className: __WEBPACK_IMPORTED_MODULE_2__CardHeader_css___default.a.backColor + ' card col-md-12 text-center'
  }, void 0, CardHeader__jsx('div', {
    className: __WEBPACK_IMPORTED_MODULE_2__CardHeader_css___default.a.header_card + ' ' + __WEBPACK_IMPORTED_MODULE_2__CardHeader_css___default.a.backColor + ' card-header text-center'
  }, void 0, 'Profesionales Disponibles el ' + props.fechaCard));
};
/* harmony default export */ var CardHeader_defaultExport = (__WEBPACK_IMPORTED_MODULE_1_isomorphic_style_loader_lib_withStyles___default()(__WEBPACK_IMPORTED_MODULE_2__CardHeader_css___default.a)(CardHeader));
// CONCATENATED MODULE: ./src/components/Telemedicina/FilterLeft/FilterLeft.js
/* harmony import */ var FilterLeft___WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(71);
/* harmony import */ var FilterLeft___WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(FilterLeft___WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var FilterLeft___WEBPACK_IMPORTED_MODULE_1_react_redux__ = __webpack_require__(415);
/* harmony import */ var FilterLeft___WEBPACK_IMPORTED_MODULE_2_isomorphic_style_loader_lib_withStyles__ = __webpack_require__(887);
/* harmony import */ var FilterLeft___WEBPACK_IMPORTED_MODULE_2_isomorphic_style_loader_lib_withStyles___default = __webpack_require__.n(FilterLeft___WEBPACK_IMPORTED_MODULE_2_isomorphic_style_loader_lib_withStyles__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react_input_range__ = __webpack_require__(1259);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react_input_range___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_react_input_range__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__FilterLeft_css__ = __webpack_require__(1277);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__FilterLeft_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__FilterLeft_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__actions_telemedicinaActions__ = __webpack_require__(416);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__public_images_ic_mini_calendar_png__ = __webpack_require__(1280);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__public_images_ic_mini_calendar_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__public_images_ic_mini_calendar_png__);
var FilterLeft__jsx = function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; }();

var FilterLeft__createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function FilterLeft__classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function FilterLeft__possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function FilterLeft__inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

/* eslint react/no-did-mount-set-state: 0 */
/* eslint react/prop-types: 0 */
/* eslint consistent-return: 0 */






// eslint-disable-next-line css-modules/no-unused-class




var FilterLeft__ref = FilterLeft__jsx('h6', {
  className: 'mt-0'
}, void 0, FilterLeft__jsx('strong', {}, void 0, ' Horarios de Atenci\xF3n'));

var FilterLeft__ref2 = FilterLeft__jsx('h6', {
  className: 'mt-0'
}, void 0, FilterLeft__jsx('strong', {}, void 0, ' Fecha de Atenci\xF3n'));

var FilterLeft = function (_React$Component) {
  FilterLeft__inherits(FilterLeft, _React$Component);

  function FilterLeft(props) {
    FilterLeft__classCallCheck(this, FilterLeft);

    var _this = FilterLeft__possibleConstructorReturn(this, (FilterLeft.__proto__ || Object.getPrototypeOf(FilterLeft)).call(this, props));

    _this.state = {
      fechaSeleccionada: _this.props.fechaHeader,
      fecha: '',
      fechaSiguiente: _this.props.fechaHeader,
      fechaAnterior: null,
      turno: ''
    };
    return _this;
  }

  FilterLeft__createClass(FilterLeft, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      if (this.props.fechasD) {
        this.props.load(3);
      }
      // this.validarTurnoTomado(
      //   this.props.formatDate(this.state.fechaSeleccionada, 's'),
      // );
    }
  }, {
    key: 'render',
    value: function render() {
      var _this2 = this;

      this.props.fechaPicker();
      return FilterLeft__jsx('div', {
        className: 'mt-0 card'
      }, void 0, FilterLeft__jsx('div', {
        className: __WEBPACK_IMPORTED_MODULE_4__FilterLeft_css___default.a.container + ' card-body'
      }, void 0, FilterLeft__ref, FilterLeft__jsx('div', {
        className: '' + __WEBPACK_IMPORTED_MODULE_4__FilterLeft_css___default.a.input_range
      }, void 0, FilterLeft__jsx(__WEBPACK_IMPORTED_MODULE_3_react_input_range___default.a, {
        step: 30,
        maxValue: this.props.maxValue,
        minValue: this.props.minValue,
        formatLabel: function formatLabel(value) {
          return _this2.props.formatearHora(value);
        },
        value: this.props.value,
        onChange: function onChange(value) {
          return _this2.props.change(value);
        },
        onChangeComplete: function onChangeComplete(value) {
          return _this2.props.onChangeHorario({ value: value });
        }
      })), FilterLeft__jsx('div', {
        className: __WEBPACK_IMPORTED_MODULE_4__FilterLeft_css___default.a.card_text
      }, void 0, FilterLeft__jsx('a', {
        className: __WEBPACK_IMPORTED_MODULE_4__FilterLeft_css___default.a.first,
        onClick: function onClick() {
          return _this2.props.onClickHorarioChange({
            min: 480,
            max: 1200
          });
        },
        role: 'button',
        tabIndex: '0'
      }, void 0, 'Todos'), FilterLeft__jsx('a', {
        onClick: function onClick() {
          return _this2.props.onClickHorarioChange({
            min: 480,
            max: 720
          });
        },
        role: 'button',
        tabIndex: '0'
      }, void 0, 'Ma\xF1ana'), FilterLeft__jsx('a', {
        onClick: function onClick() {
          return _this2.props.onClickHorarioChange({
            min: 720,
            max: 1050
          });
        },
        role: 'button',
        tabIndex: '0'
      }, void 0, 'Tarde'), FilterLeft__jsx('a', {
        className: __WEBPACK_IMPORTED_MODULE_4__FilterLeft_css___default.a.last,
        onClick: function onClick() {
          return _this2.props.onClickHorarioChange({
            min: 1050,
            max: 1200
          });
        },
        role: 'button',
        tabIndex: '0'
      }, void 0, 'Noche'))), FilterLeft__jsx('ul', {
        className: 'list-group list-group-flush'
      }, void 0, FilterLeft__jsx('li', {
        className: ' ' + __WEBPACK_IMPORTED_MODULE_4__FilterLeft_css___default.a.container + ' list-group-item'
      }, void 0, FilterLeft__ref2, FilterLeft__jsx('h4', {
        id: 'calendario',
        style: { margin: '0', display: 'inline' }
      }, void 0, FilterLeft__jsx('input', {
        type: 'text',
        value: this.props.fecha,
        onChange: this.props.changeDate,
        className: 'form-control fechaInput',
        placeholder: 'Fecha'
      }), FilterLeft__jsx('img', {
        alt: 'calendario',
        src: __WEBPACK_IMPORTED_MODULE_6__public_images_ic_mini_calendar_png___default.a,
        style: {
          position: 'absolute',
          top: '54px',
          left: '208px'
        }
      })))));
    }
  }]);

  return FilterLeft;
}(FilterLeft___WEBPACK_IMPORTED_MODULE_0_react___default.a.Component);

var FilterLeft_mapStateToProps = function mapStateToProps(state) {
  return {
    // fechasDisponibles: state.telemedicina.fechas_disponibles,
    turnosPorFecha: state.telemedicina.turnos_por_fecha,
    practica: state.telemedicina.practica,
    prepaga: state.telemedicina.prepaga
  };
};

/* harmony default export */ var FilterLeft_defaultExport = (Object(FilterLeft___WEBPACK_IMPORTED_MODULE_1_react_redux__["b" /* connect */])(FilterLeft_mapStateToProps, __WEBPACK_IMPORTED_MODULE_5__actions_telemedicinaActions__)(FilterLeft___WEBPACK_IMPORTED_MODULE_2_isomorphic_style_loader_lib_withStyles___default()(__WEBPACK_IMPORTED_MODULE_4__FilterLeft_css___default.a)(FilterLeft)));
// CONCATENATED MODULE: ./src/components/Telemedicina/SinHorariosDisponibles/SinHorariosDisponibles.js
/* harmony import */ var SinHorariosDisponibles___WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(71);
/* harmony import */ var SinHorariosDisponibles___WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(SinHorariosDisponibles___WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var SinHorariosDisponibles___WEBPACK_IMPORTED_MODULE_1_react_redux__ = __webpack_require__(415);
/* harmony import */ var SinHorariosDisponibles___WEBPACK_IMPORTED_MODULE_2_isomorphic_style_loader_lib_withStyles__ = __webpack_require__(887);
/* harmony import */ var SinHorariosDisponibles___WEBPACK_IMPORTED_MODULE_2_isomorphic_style_loader_lib_withStyles___default = __webpack_require__.n(SinHorariosDisponibles___WEBPACK_IMPORTED_MODULE_2_isomorphic_style_loader_lib_withStyles__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__SinHorariosDisponibles_css__ = __webpack_require__(1283);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__SinHorariosDisponibles_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__SinHorariosDisponibles_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__public_images_embudo_png__ = __webpack_require__(1285);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__public_images_embudo_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__public_images_embudo_png__);
var SinHorariosDisponibles__jsx = function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; }();







var SinHorariosDisponibles__ref = SinHorariosDisponibles__jsx('img', {
  alt: 'Anterior',
  src: __WEBPACK_IMPORTED_MODULE_4__public_images_embudo_png___default.a
});

var SinHorariosDisponibles__ref2 = SinHorariosDisponibles__jsx('strong', {}, void 0, 'modifique los filtros aplicados.');

function SinHorariosDisponibles(props) {
  return SinHorariosDisponibles__jsx('div', {
    className: 'col-md-12'
  }, void 0, SinHorariosDisponibles__jsx('div', {
    className: '' + __WEBPACK_IMPORTED_MODULE_3__SinHorariosDisponibles_css___default.a.divImagen
  }, void 0, SinHorariosDisponibles__ref), SinHorariosDisponibles__jsx('div', {
    className: __WEBPACK_IMPORTED_MODULE_3__SinHorariosDisponibles_css___default.a.divTexto + ' col-md-12'
  }, void 0, 'No se encuentran resultados seg\xFAn su criterio de b\xFAsqueda.'), SinHorariosDisponibles__jsx('div', {
    className: __WEBPACK_IMPORTED_MODULE_3__SinHorariosDisponibles_css___default.a.divTexto + ' col-md-12'
  }, void 0, 'Por favor ', SinHorariosDisponibles__ref2));
}

/* harmony default export */ var SinHorariosDisponibles_defaultExport = (Object(SinHorariosDisponibles___WEBPACK_IMPORTED_MODULE_1_react_redux__["b" /* connect */])(null, null)(SinHorariosDisponibles___WEBPACK_IMPORTED_MODULE_2_isomorphic_style_loader_lib_withStyles___default()(__WEBPACK_IMPORTED_MODULE_3__SinHorariosDisponibles_css___default.a)(SinHorariosDisponibles)));
// CONCATENATED MODULE: ./src/components/Telemedicina/ModalYaTomoTurno/ModalYaTomoTurno.js
/* harmony import */ var ModalYaTomoTurno___WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(71);
/* harmony import */ var ModalYaTomoTurno___WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(ModalYaTomoTurno___WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var ModalYaTomoTurno___WEBPACK_IMPORTED_MODULE_1_react_redux__ = __webpack_require__(415);
/* harmony import */ var ModalYaTomoTurno___WEBPACK_IMPORTED_MODULE_2_isomorphic_style_loader_lib_withStyles__ = __webpack_require__(887);
/* harmony import */ var ModalYaTomoTurno___WEBPACK_IMPORTED_MODULE_2_isomorphic_style_loader_lib_withStyles___default = __webpack_require__.n(ModalYaTomoTurno___WEBPACK_IMPORTED_MODULE_2_isomorphic_style_loader_lib_withStyles__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__ModalYaTomoTurno_css__ = __webpack_require__(1286);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__ModalYaTomoTurno_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__ModalYaTomoTurno_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__utils_redirectTo__ = __webpack_require__(419);
var ModalYaTomoTurno__jsx = function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; }();

var ModalYaTomoTurno__createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function ModalYaTomoTurno__classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function ModalYaTomoTurno__possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function ModalYaTomoTurno__inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

/* eslint react/no-did-mount-set-state: 0 */
/* eslint react/prop-types: 0 */
/* eslint consistent-return: 0 */






var ModalYaTomoTurno__ref2 = ModalYaTomoTurno__jsx('div', {
  className: 'modal-header'
}, void 0, ModalYaTomoTurno__jsx('h5', {
  className: 'modal-title'
}, void 0, 'Turno ya asignado'));

var ModalYaTomoTurno = function (_React$Component) {
  ModalYaTomoTurno__inherits(ModalYaTomoTurno, _React$Component);

  function ModalYaTomoTurno() {
    var _ref;

    var _temp, _this, _ret;

    ModalYaTomoTurno__classCallCheck(this, ModalYaTomoTurno);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = ModalYaTomoTurno__possibleConstructorReturn(this, (_ref = ModalYaTomoTurno.__proto__ || Object.getPrototypeOf(ModalYaTomoTurno)).call.apply(_ref, [this].concat(args))), _this), _this.showDateModal = function (date) {
      var days = ['Lunes', 'Martes', 'Miércoles', 'Jueves', 'Viernes', 'Sábado', 'Domingo'];
      var months = ['Enero', 'Febrero', 'Marzo', 'Abril', 'Mayo', 'Junio', 'Julio', 'Agosto', 'Septiembre', 'Octubre', 'Noviembre', 'Diciembre'];
      if (date) {
        var year = date.substr(0, 4);
        var month = date.substr(4, 2);
        var day = date.substr(6, 8);
        // const hourFormated = `${hour.substr(0, 2)}:${hour.substr(2, 4)}`;
        var dateFormated = new Date(year + '-' + month + '-' + day + ' 00:00:00');
        var dayWeek = dateFormated.getDay();
        if (dayWeek === 0) {
          dayWeek = 7;
        }
        // Martes 8 de agosto 8:15AM
        return days[dayWeek - 1] + ' ' + day + ' de ' + months[parseInt(month, 10) - 1];
      }
      return '';
    }, _temp), ModalYaTomoTurno__possibleConstructorReturn(_this, _ret);
  }

  ModalYaTomoTurno__createClass(ModalYaTomoTurno, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      // $('#ModalYaTomoTurno').modal({ backdrop: 'static', keyboard: false });
      // $('.close').hide();
    }
  }, {
    key: 'render',
    value: function render() {
      var url = '/telemedicina/consulta-turnos';
      return ModalYaTomoTurno__jsx('div', {
        className: 'modal fade',
        id: 'ModalYaTomoTurno'
      }, void 0, ModalYaTomoTurno__jsx('div', {
        className: 'modal-dialog'
      }, void 0, ModalYaTomoTurno__jsx('div', {
        className: __WEBPACK_IMPORTED_MODULE_3__ModalYaTomoTurno_css___default.a.modalContent + ' modal-content'
      }, void 0, ModalYaTomoTurno__ref2, ModalYaTomoTurno__jsx('div', {
        className: __WEBPACK_IMPORTED_MODULE_3__ModalYaTomoTurno_css___default.a.modalBody + ' modal-body'
      }, void 0, ModalYaTomoTurno__jsx('div', {}, void 0, 'Ya ten\xE9s un turno asignado en E-Consulta para el d\xEDa', ' ', ModalYaTomoTurno__jsx('strong', {}, void 0, '' + this.showDateModal(this.props.turno.fecha, this.props.turno.hora)), ' ', 'en la especialidad seleccionada.')), ModalYaTomoTurno__jsx('div', {
        className: __WEBPACK_IMPORTED_MODULE_3__ModalYaTomoTurno_css___default.a.modalFooter + ' modal-footer'
      }, void 0, ModalYaTomoTurno__jsx('button', {
        'data-dismiss': 'modal',
        className: __WEBPACK_IMPORTED_MODULE_3__ModalYaTomoTurno_css___default.a.boton_blanco + ' ' + __WEBPACK_IMPORTED_MODULE_3__ModalYaTomoTurno_css___default.a.robotoMedium + ' btn btn-default float-left'
      }, void 0, 'Cerrar'), ModalYaTomoTurno__jsx('button', {
        'data-dismiss': 'modal',
        className: __WEBPACK_IMPORTED_MODULE_3__ModalYaTomoTurno_css___default.a.boton_rojo + ' btn btn-danger text-center',
        onClick: function onClick() {
          return Object(__WEBPACK_IMPORTED_MODULE_4__utils_redirectTo__["a" /* default */])(url);
        }
      }, void 0, 'Ir a Consulta de turnos')))));
    }
  }]);

  return ModalYaTomoTurno;
}(ModalYaTomoTurno___WEBPACK_IMPORTED_MODULE_0_react___default.a.Component);

/* harmony default export */ var ModalYaTomoTurno_defaultExport = (Object(ModalYaTomoTurno___WEBPACK_IMPORTED_MODULE_1_react_redux__["b" /* connect */])(null, null)(ModalYaTomoTurno___WEBPACK_IMPORTED_MODULE_2_isomorphic_style_loader_lib_withStyles___default()(__WEBPACK_IMPORTED_MODULE_3__ModalYaTomoTurno_css___default.a)(ModalYaTomoTurno)));
// CONCATENATED MODULE: ./src/components/Telemedicina/ListCards/ListCards.js
/* harmony import */ var ListCards___WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(71);
/* harmony import */ var ListCards___WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(ListCards___WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var ListCards___WEBPACK_IMPORTED_MODULE_1_react_redux__ = __webpack_require__(415);
/* harmony import */ var ListCards___WEBPACK_IMPORTED_MODULE_2_isomorphic_style_loader_lib_withStyles__ = __webpack_require__(887);
/* harmony import */ var ListCards___WEBPACK_IMPORTED_MODULE_2_isomorphic_style_loader_lib_withStyles___default = __webpack_require__.n(ListCards___WEBPACK_IMPORTED_MODULE_2_isomorphic_style_loader_lib_withStyles__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__ListCards_css__ = __webpack_require__(1281);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__ListCards_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__ListCards_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_Telemedicina_ModalConfirmacionTurno_ModalConfirmacionTurno__ = __webpack_require__(1140);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_Telemedicina_ModalConfirmacionTurnoResp_ModalConfirmacionTurnoResp__ = __webpack_require__(1141);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__utils_generateAbsoluteUrl__ = __webpack_require__(127);
var ListCards__jsx = function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; }();

var ListCards__createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function ListCards__classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function ListCards__possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function ListCards__inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

/* eslint-disable prettier/prettier */
/* eslint react/no-did-mount-set-state: 0 */
/* eslint react/prop-types: 0 */
/* eslint consistent-return: 0 */
/* global $ */












var ListCards__ref = ListCards__jsx('p', {}, void 0, 'Horarios de Atenci\xF3n');

var ListCards__ref2 = ListCards__jsx('div', {}, void 0, ListCards__jsx(SinHorariosDisponibles_defaultExport, {}));

var ListCards__ref3 = ListCards__jsx(__WEBPACK_IMPORTED_MODULE_6__components_Telemedicina_ModalConfirmacionTurnoResp_ModalConfirmacionTurnoResp__["a" /* default */], {});

var ListCards__ref4 = ListCards__jsx('div', {});

var ListCards_ListCards = function (_React$Component) {
  ListCards__inherits(ListCards, _React$Component);

  ListCards__createClass(ListCards, null, [{
    key: 'capitalizeEach',

    // static getDataUser() {
    //   const auth = localStorage.getItem(LOCALSTORAGE_AUTH_KEY);
    //   let user;
    //   if (auth) {
    //     user = {
    //       email: JSON.parse(auth).modelEspecifico.email,
    //     };
    //   }
    //   return user;
    // }

    value: function capitalizeEach(name) {
      if (name) {
        var splittedName = name.toLowerCase().split(' ');
        return splittedName.map(function (str) {
          return str.charAt(0).toUpperCase() + str.substring(1);
        }).join(' ');
      }
    }
  }]);

  function ListCards(props) {
    ListCards__classCallCheck(this, ListCards);

    var _this = ListCards__possibleConstructorReturn(this, (ListCards.__proto__ || Object.getPrototypeOf(ListCards)).call(this, props));

    _this.formatearHora = function (hora) {
      return hora.substr(0, 2) + ':' + hora.substr(2, 4);
    };

    _this.convertDate = function (date, hour) {
      var days = ['Lunes', 'Martes', 'Miércoles', 'Jueves', 'Viernes', 'Sábado', 'Domingo'];
      var months = ['Enero', 'Febrero', 'Marzo', 'Abril', 'Mayo', 'Junio', 'Julio', 'Agosto', 'Septiembre', 'Octubre', 'Noviembre', 'Diciembre'];

      if (date) {
        var year = date.substr(0, 4);
        var month = date.substr(4, 2);
        var day = date.substr(6, 8);
        var hourFormated = hour.substr(0, 2) + ':' + hour.substr(2, 4);
        var dateFormated = new Date(year + '-' + month + '-' + day + ' 00:00:00');
        var dayWeek = dateFormated.getDay();
        if (dayWeek === 0) {
          dayWeek = 7;
        }
        var finalDate = days[dayWeek - 1] + ' ' + day + ' de ' + months[parseInt(month, 10) - 1] + ' ' + hourFormated + ' Hs';
        // Martes 8 de agosto 8:15AM
        return finalDate;
      }
      return '';
    };

    _this.closeModal = function () {
      _this.setState({ show: false });
    };

    _this.state = {
      email: '',
      dataTurno: '',
      nombreapellido: '',
      especialidad: '',
      prestadorId: '',
      show: false,
      yaTomo: null
    };

    _this.showModal = _this.showModal.bind(_this);
    _this.renderCard = _this.renderCard.bind(_this);
    _this.capitalizeEach = ListCards.capitalizeEach.bind(_this);
    return _this;
  }

  ListCards__createClass(ListCards, [{
    key: 'componentWillReceiveProps',
    value: function componentWillReceiveProps(props) {
      if (this.props.confirmacionTurno !== props.confirmacionTurno) {
        var email = $('#email').val();
        $('#mail').html(email);
        $('#modalConfirmTurnoResp').modal('show');
      }
    }
  }, {
    key: 'showModal',
    value: function showModal(data, horario) {
      var _this2 = this;

      this.setState({ yaTomo: data.turnos[horario] });
      this.props.validarTurnoTomado(data.turnos[horario].fecha).then(function (resp) {
        if (resp && resp.showModal) {
          $('#ModalYaTomoTurno').modal({
            backdrop: 'static',
            keyboard: false
          });
        } else {
          var prestadorId = void 0;
          var nombre = void 0;
          var apellido = void 0;

          if (data.turnos[horario].reemplazo.prestador === '') {
            prestadorId = data.turnos[horario].prestador;
            nombre = data.turnos[horario].titular.nombreAbre;
            apellido = data.turnos[horario].titular.apeRazon;
          } else {
            prestadorId = data.turnos[horario].reemplazo.prestador;
            nombre = data.turnos[horario].reemplazo.nombreAbre;
            apellido = data.turnos[horario].reemplazo.apeRazon;
          }
          // console.log(data.turnos[horario].fecha)
          _this2.setState({
            dataTurno: data.turnos[horario],
            nombre: nombre,
            apellido: apellido,
            prestadorId: prestadorId,
            especialidad: data.especialidad,
            show: true
          });
        }
      });
    }
  }, {
    key: 'renderCard',
    value: function renderCard(data) {
      var _this3 = this;

      // ///PRUEBA MOMENTANEA
      var horariosSalvoX5 = data.horarios.filter(function (h) {
        return !h.slice(2, 4).match(/\d5$/g);
      });
      // ///////////////////////
      var urlImage = void 0;

      if (window.location.host.includes('localhost')) {
        urlImage = 'https://swissmedical.com.ar/smgnewsite/images/telemedicina/';
      } else {
        urlImage = 'smgnewsite/images/telemedicina/';
      }
      var img = '' + urlImage + data.prestador + '.jpg';
      var imgDefault = urlImage + 'sin_foto.jpg';
      if (horariosSalvoX5.length) {
        return ListCards__jsx('div', {}, data.prestador, ListCards__jsx('div', {
          className: __WEBPACK_IMPORTED_MODULE_3__ListCards_css___default.a.card + ' card'
        }, void 0, ListCards__jsx('div', {
          className: 'media'
        }, void 0, img ? ListCards__jsx('img', {
          id: data.prestador,
          className: __WEBPACK_IMPORTED_MODULE_3__ListCards_css___default.a.imgMedicos + ' align-self-center mr-3',
          src: img,
          alt: 'Medico'
        }) : ListCards__jsx('img', {
          id: imgDefault,
          className: __WEBPACK_IMPORTED_MODULE_3__ListCards_css___default.a.imgMedicos + ' align-self-center mr-3',
          src: imgDefault,
          alt: 'Medico'
        }), ListCards__jsx('div', {
          className: 'media-body'
        }, void 0, ListCards__jsx('h5', {
          className: 'mt-0'
        }, void 0, this.capitalizeEach(data.nombre), ' ', data.apellido), ListCards__ref, horariosSalvoX5 && horariosSalvoX5.map(function (option) {
          return ListCards__jsx('span', {}, option, ListCards__jsx('button', {
            onClick: function onClick() {
              return _this3.showModal(data, option);
            },
            type: 'button',
            'data-toggle': 'modal',
            className: __WEBPACK_IMPORTED_MODULE_3__ListCards_css___default.a.button + ' btn btn-outline-danger'
          }, void 0, _this3.formatearHora(option)));
        })))));
      }
    }
  }, {
    key: 'render',
    value: function render() {
      var _this4 = this;

      if (this.props.turnosPorfecha.turnos) {
        if (this.props.turnosPorfecha.turnos.length === 0) {
          return ListCards__ref2;
        }
        // eslint-disable-next-line no-unused-vars
        var turns = '';

        var enviroment = Object(__WEBPACK_IMPORTED_MODULE_8__utils_generateAbsoluteUrl__["a" /* default */])();

        if (this.props.specialityName === 'Well Test') {
          if (enviroment.includes('pre') || enviroment.includes('clubswiss')) {
            turns = this.props.turnosPorfecha.turnos.filter(function (prest) {
              return prest.prestador === '36274';
            });
          } else if (enviroment.includes('mobileint') || enviroment.includes('srv-php01') || enviroment.includes('localhost')) {
            turns = this.props.turnosPorfecha.turnos.filter(function (prest) {
              return prest.prestador === '35238';
            });
          } else if (enviroment.includes('srv-php02') || enviroment.includes('mobileqa')) {
            turns = this.props.turnosPorfecha.turnos.filter(function (prest) {
              return prest.prestador === '35595';
            });
          }
        } else {
          turns = this.props.turnosPorfecha.turnos.filter(function (prest) {
            return prest.prestador !== '35210' && prest.prestador !== '35238' && prest.prestador !== '35645' && prest.prestador !== '35984';
          });
        }

        var hasHoursX0 = function hasHoursX0(hour) {
          return hour.slice(2, 4).match(/\d0$/g);
        };

        var turnsWithHoursX0 = turns.filter(function (t) {
          return t.horarios.some(hasHoursX0);
        });

        return ListCards__jsx('div', {
          className: __WEBPACK_IMPORTED_MODULE_3__ListCards_css___default.a.cardButton
        }, void 0, ListCards__jsx(__WEBPACK_IMPORTED_MODULE_4__components_Telemedicina_ModalConfirmacionTurno_ModalConfirmacionTurno__["a" /* default */]
        // showModal={this.showModal}
        , {
          closeModal: this.closeModal,
          show: this.state.show,
          nombre: this.state.nombre,
          apellido: this.state.apellido,
          email: this.props.emailService,
          dataTurno: this.state.dataTurno,
          prestadorId: this.state.prestadorId,
          displayDate: '' + this.convertDate(this.state.dataTurno.fecha, this.state.dataTurno.hora)
        }), turnsWithHoursX0.length ? ListCards__jsx(CardHeader_defaultExport, {
          fechaCard: this.props.fechaCard,
          turnosPorfecha: this.props.TurnosPorFecha
        }) : '', turns.map(function (turn) {
          return _this4.renderCard(turn);
        }), this.state.yaTomo !== null && ListCards__jsx(ModalYaTomoTurno_defaultExport, {
          turno: this.state.yaTomo
        }), ListCards__ref3);
      }
      return ListCards__ref4;
    }
  }]);

  return ListCards;
}(ListCards___WEBPACK_IMPORTED_MODULE_0_react___default.a.Component);

var ListCards_mapStateToProps = function mapStateToProps(state) {
  return {
    confirmacionTurno: state.telemedicina.confirmacion_turno,
    emailService: state.telemedicina.email
  };
};

/* harmony default export */ var ListCards_defaultExport = (Object(ListCards___WEBPACK_IMPORTED_MODULE_1_react_redux__["b" /* connect */])(ListCards_mapStateToProps, null)(ListCards___WEBPACK_IMPORTED_MODULE_2_isomorphic_style_loader_lib_withStyles___default()(__WEBPACK_IMPORTED_MODULE_3__ListCards_css___default.a)(ListCards_ListCards)));
// CONCATENATED MODULE: ./src/components/Telemedicina/ModalBienvenida/ModalBienvenida.js
/* harmony import */ var ModalBienvenida___WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(71);
/* harmony import */ var ModalBienvenida___WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(ModalBienvenida___WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var ModalBienvenida___WEBPACK_IMPORTED_MODULE_1_react_redux__ = __webpack_require__(415);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_lodash__ = __webpack_require__(183);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_lodash__);
/* harmony import */ var ModalBienvenida___WEBPACK_IMPORTED_MODULE_3_isomorphic_style_loader_lib_withStyles__ = __webpack_require__(887);
/* harmony import */ var ModalBienvenida___WEBPACK_IMPORTED_MODULE_3_isomorphic_style_loader_lib_withStyles___default = __webpack_require__.n(ModalBienvenida___WEBPACK_IMPORTED_MODULE_3_isomorphic_style_loader_lib_withStyles__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__public_images_ic_arrow_foward_png__ = __webpack_require__(1288);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__public_images_ic_arrow_foward_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__public_images_ic_arrow_foward_png__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__public_images_ic_arrow_back_png__ = __webpack_require__(1289);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__public_images_ic_arrow_back_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__public_images_ic_arrow_back_png__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__public_images_ic_medico_online_png__ = __webpack_require__(1290);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__public_images_ic_medico_online_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__public_images_ic_medico_online_png__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__public_images_ic_ambulance_png__ = __webpack_require__(1291);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__public_images_ic_ambulance_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7__public_images_ic_ambulance_png__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__public_images_ic_calendar_png__ = __webpack_require__(1292);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__public_images_ic_calendar_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8__public_images_ic_calendar_png__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__public_images_ic_webcam_png__ = __webpack_require__(1293);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__public_images_ic_webcam_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9__public_images_ic_webcam_png__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__public_images_ic_stars_png__ = __webpack_require__(1294);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__public_images_ic_stars_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10__public_images_ic_stars_png__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__ModalCuandoUtilizarEconsulta_ModalCuandoUtilizarEconsulta__ = __webpack_require__(1241);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__ModalBienvenida_css__ = __webpack_require__(1299);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__ModalBienvenida_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_12__ModalBienvenida_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__constants__ = __webpack_require__(17);
var ModalBienvenida__jsx = function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; }();

var ModalBienvenida__createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function ModalBienvenida__classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function ModalBienvenida__possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function ModalBienvenida__inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

/* eslint react/no-did-mount-set-state: 0 */
/* eslint react/prop-types: 0 */
/* eslint consistent-return: 0 */
/* global $ */
















var ModalBienvenida__ref = ModalBienvenida__jsx('img', {
  className: 'align-self-center mr-3',
  src: __WEBPACK_IMPORTED_MODULE_6__public_images_ic_medico_online_png___default.a,
  alt: 'Telemedicina'
});

var ModalBienvenida__ref2 = ModalBienvenida__jsx('div', {}, void 0, 'Bienvenido a ', ModalBienvenida__jsx('strong', {}, void 0, 'E-Consulta'));

var ModalBienvenida__ref3 = ModalBienvenida__jsx('div', {}, void 0, 'Conectate con un m\xE9dico online en');

var ModalBienvenida__ref4 = ModalBienvenida__jsx('div', {}, void 0, 'lugar de asistir al consultorio.');

var _ref5 = ModalBienvenida__jsx('div', {
  className: 'col-md-4 px-0'
});

var _ref6 = ModalBienvenida__jsx('img', {
  alt: 'Siguiente',
  src: __WEBPACK_IMPORTED_MODULE_4__public_images_ic_arrow_foward_png___default.a,
  className: 'pl-2'
});

var _ref7 = ModalBienvenida__jsx('img', {
  className: 'align-self-center mr-3',
  src: __WEBPACK_IMPORTED_MODULE_7__public_images_ic_ambulance_png___default.a,
  alt: 'Telemedicina'
});

var _ref8 = ModalBienvenida__jsx('div', {}, void 0, 'Record\xE1 que ', ModalBienvenida__jsx('strong', {}, void 0, 'E-Consulta'), ' solo debe ser');

var _ref9 = ModalBienvenida__jsx('div', {}, void 0, 'utilizado ', ModalBienvenida__jsx('strong', {}, void 0, 'si tu vida no se encuentra en riesgo.'));

var _ref10 = ModalBienvenida__jsx('div', {}, void 0, 'Por urgencias, acud\xED a la guardia m\xE1s cercana.');

var _ref11 = ModalBienvenida__jsx('img', {
  alt: 'Siguiente',
  src: __WEBPACK_IMPORTED_MODULE_5__public_images_ic_arrow_back_png___default.a,
  className: 'pr-2'
});

var _ref12 = ModalBienvenida__jsx('img', {
  alt: 'Siguiente',
  src: __WEBPACK_IMPORTED_MODULE_4__public_images_ic_arrow_foward_png___default.a,
  className: 'pl-2'
});

var _ref13 = ModalBienvenida__jsx('img', {
  className: 'align-self-center mr-3',
  src: __WEBPACK_IMPORTED_MODULE_9__public_images_ic_webcam_png___default.a,
  alt: 'Telemedicina'
});

var _ref14 = ModalBienvenida__jsx('div', {}, void 0, 'Es necesario que poseas una ', ModalBienvenida__jsx('strong', {}, void 0, 'webcam'), ', un');

var _ref15 = ModalBienvenida__jsx('div', {}, void 0, ModalBienvenida__jsx('strong', {}, void 0, 'micr\xF3fono'), ' y ', ModalBienvenida__jsx('strong', {}, void 0, 'auriculares'), ' o', ' ', ModalBienvenida__jsx('strong', {}, void 0, 'parlantes'), ' para que');

var _ref16 = ModalBienvenida__jsx('div', {}, void 0, 'puedas interactuar con el profesional.');

var _ref17 = ModalBienvenida__jsx('br', {});

var _ref18 = ModalBienvenida__jsx('img', {
  alt: 'Siguiente',
  src: __WEBPACK_IMPORTED_MODULE_5__public_images_ic_arrow_back_png___default.a,
  className: 'pr-2'
});

var _ref19 = ModalBienvenida__jsx('img', {
  alt: 'Siguiente',
  src: __WEBPACK_IMPORTED_MODULE_4__public_images_ic_arrow_foward_png___default.a,
  className: 'pl-2'
});

var _ref20 = ModalBienvenida__jsx('img', {
  className: 'align-self-center mr-3',
  src: __WEBPACK_IMPORTED_MODULE_10__public_images_ic_stars_png___default.a,
  alt: 'Telemedicina'
});

var _ref21 = ModalBienvenida__jsx('div', {}, void 0, 'Al finalizar la atenci\xF3n acceder\xE1s a una');

var _ref22 = ModalBienvenida__jsx('div', {}, void 0, ModalBienvenida__jsx('strong', {}, void 0, 'encuesta'), ' para calificar la atenci\xF3n recibida y');

var _ref23 = ModalBienvenida__jsx('div', {}, void 0, 'la calidad de la videollamada.');

var _ref24 = ModalBienvenida__jsx('br', {});

var _ref25 = ModalBienvenida__jsx('img', {
  alt: 'Siguiente',
  src: __WEBPACK_IMPORTED_MODULE_5__public_images_ic_arrow_back_png___default.a,
  className: 'pr-2'
});

var _ref26 = ModalBienvenida__jsx('img', {
  alt: 'Siguiente',
  src: __WEBPACK_IMPORTED_MODULE_4__public_images_ic_arrow_foward_png___default.a,
  className: 'pl-2'
});

var _ref27 = ModalBienvenida__jsx(__WEBPACK_IMPORTED_MODULE_11__ModalCuandoUtilizarEconsulta_ModalCuandoUtilizarEconsulta__["a" /* default */], {});

var _ref28 = ModalBienvenida__jsx('div', {}, void 0, 'En el caso de que no haya m\xE9dico');

var _ref29 = ModalBienvenida__jsx('div', {}, void 0, 'disponible, pod\xE9s ', ModalBienvenida__jsx('strong', {}, void 0, 'programar tu E-Consulta'));

var _ref30 = ModalBienvenida__jsx('div', {}, void 0, 'para otro momento. ');

var _ref31 = ModalBienvenida__jsx('br', {});

var _ref32 = ModalBienvenida__jsx('img', {
  alt: 'Siguiente',
  src: __WEBPACK_IMPORTED_MODULE_5__public_images_ic_arrow_back_png___default.a,
  className: 'pr-2'
});

var _ref33 = ModalBienvenida__jsx('div', {});

var _ref34 = ModalBienvenida__jsx('button', {
  type: 'button',
  className: 'close',
  'data-dismiss': 'modal',
  'aria-label': 'Close'
}, void 0, ModalBienvenida__jsx('span', {
  'aria-hidden': 'true'
}, void 0, '\xD7'));

var ModalBienvenida = function (_React$Component) {
  ModalBienvenida__inherits(ModalBienvenida, _React$Component);

  function ModalBienvenida() {
    ModalBienvenida__classCallCheck(this, ModalBienvenida);

    return ModalBienvenida__possibleConstructorReturn(this, (ModalBienvenida.__proto__ || Object.getPrototypeOf(ModalBienvenida)).apply(this, arguments));
  }

  ModalBienvenida__createClass(ModalBienvenida, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      var datos = JSON.parse(localStorage.getItem(__WEBPACK_IMPORTED_MODULE_13__constants__["_30" /* LOCALSTORAGE_AUTH_KEY */]));
      var dni = datos.modelEspecifico.docu_nro;
      var modalShowBienvenida = localStorage.getItem('showModalBienvenida');
      var documentos = !__WEBPACK_IMPORTED_MODULE_2_lodash___default.a.isEmpty(modalShowBienvenida) ? JSON.parse(modalShowBienvenida) : [];
      if (__WEBPACK_IMPORTED_MODULE_2_lodash___default.a.isEmpty(modalShowBienvenida) || !documentos.includes(dni)) {
        documentos.push(dni);
        localStorage.setItem('showModalBienvenida', JSON.stringify(documentos));
        $('#ModalBienvenida').modal('show');
      } else {
        $('#ModalBienvenida').modal('hide');
      }
    }
  }, {
    key: 'componentWillUnmount',
    value: function componentWillUnmount() {
      $('#ModalBienvenida').modal('hide');
    }
  }, {
    key: 'render',
    value: function render() {
      var _this2 = this;

      var modal = void 0;
      switch (this.props.step) {
        case 1:
          modal = ModalBienvenida__jsx('div', {}, void 0, ModalBienvenida__jsx('div', {
            className: __WEBPACK_IMPORTED_MODULE_12__ModalBienvenida_css___default.a.modalBody + ' modal-body'
          }, void 0, ModalBienvenida__jsx('div', {
            className: __WEBPACK_IMPORTED_MODULE_12__ModalBienvenida_css___default.a.imageContainer
          }, void 0, ModalBienvenida__ref), ModalBienvenida__ref2, ModalBienvenida__ref3, ModalBienvenida__ref4), ModalBienvenida__jsx('div', {
            className: __WEBPACK_IMPORTED_MODULE_12__ModalBienvenida_css___default.a.modalFooter + ' modal-footer col-md-12'
          }, void 0, _ref5, ModalBienvenida__jsx('div', {
            className: 'col-md-4 px-0'
          }, void 0, this.props.step, '/5'), ModalBienvenida__jsx('div', {
            className: 'col-md-4 px-0'
          }, void 0, ModalBienvenida__jsx('button', {
            onClick: function onClick() {
              return _this2.props.next(_this2.props.step);
            },
            className: '' + __WEBPACK_IMPORTED_MODULE_12__ModalBienvenida_css___default.a.boton_accion
          }, void 0, 'Siguiente', _ref6))));
          break;
        case 2:
          modal = ModalBienvenida__jsx('div', {}, void 0, ModalBienvenida__jsx('div', {
            className: __WEBPACK_IMPORTED_MODULE_12__ModalBienvenida_css___default.a.modalBody + ' modal-body'
          }, void 0, ModalBienvenida__jsx('div', {
            className: __WEBPACK_IMPORTED_MODULE_12__ModalBienvenida_css___default.a.imageContainer
          }, void 0, _ref7), _ref8, _ref9, _ref10), ModalBienvenida__jsx('div', {
            className: __WEBPACK_IMPORTED_MODULE_12__ModalBienvenida_css___default.a.modalFooter + ' modal-footer col-md-12'
          }, void 0, ModalBienvenida__jsx('div', {
            className: 'col-md-4 px-0'
          }, void 0, ModalBienvenida__jsx('button', {
            onClick: function onClick() {
              return _this2.props.back(_this2.props.step);
            },
            className: '' + __WEBPACK_IMPORTED_MODULE_12__ModalBienvenida_css___default.a.boton_accion
          }, void 0, _ref11, 'Anterior')), ModalBienvenida__jsx('div', {
            className: 'col-md-4 px-0'
          }, void 0, this.props.step, '/5'), ModalBienvenida__jsx('div', {
            className: 'col-md-4  px-0'
          }, void 0, ModalBienvenida__jsx('button', {
            onClick: function onClick() {
              return _this2.props.next(_this2.props.step);
            },
            className: '' + __WEBPACK_IMPORTED_MODULE_12__ModalBienvenida_css___default.a.boton_accion
          }, void 0, 'Siguiente', _ref12))));
          break;
        case 3:
          modal = ModalBienvenida__jsx('div', {}, void 0, ModalBienvenida__jsx('div', {
            className: __WEBPACK_IMPORTED_MODULE_12__ModalBienvenida_css___default.a.modalBody + ' modal-body'
          }, void 0, ModalBienvenida__jsx('div', {
            className: __WEBPACK_IMPORTED_MODULE_12__ModalBienvenida_css___default.a.imageContainer
          }, void 0, _ref13), _ref14, _ref15, _ref16, _ref17), ModalBienvenida__jsx('div', {
            className: __WEBPACK_IMPORTED_MODULE_12__ModalBienvenida_css___default.a.modalFooter + ' modal-footer col-md-12'
          }, void 0, ModalBienvenida__jsx('div', {
            className: 'col-md-4 px-0'
          }, void 0, ModalBienvenida__jsx('button', {
            onClick: function onClick() {
              return _this2.props.back(_this2.props.step);
            },
            className: '' + __WEBPACK_IMPORTED_MODULE_12__ModalBienvenida_css___default.a.boton_accion
          }, void 0, _ref18, 'Anterior')), ModalBienvenida__jsx('div', {
            className: 'col-md-4 px-0'
          }, void 0, this.props.step, '/5'), ModalBienvenida__jsx('div', {
            className: 'col-md-4 px-0'
          }, void 0, ModalBienvenida__jsx('button', {
            onClick: function onClick() {
              return _this2.props.next(_this2.props.step);
            },
            className: '' + __WEBPACK_IMPORTED_MODULE_12__ModalBienvenida_css___default.a.boton_accion
          }, void 0, 'Siguiente', _ref19))));
          break;
        case 4:
          modal = ModalBienvenida__jsx('div', {}, void 0, ModalBienvenida__jsx('div', {
            className: __WEBPACK_IMPORTED_MODULE_12__ModalBienvenida_css___default.a.modalBody + ' modal-body'
          }, void 0, ModalBienvenida__jsx('div', {
            className: __WEBPACK_IMPORTED_MODULE_12__ModalBienvenida_css___default.a.imageContainer
          }, void 0, _ref20), _ref21, _ref22, _ref23, _ref24), ModalBienvenida__jsx('div', {
            className: __WEBPACK_IMPORTED_MODULE_12__ModalBienvenida_css___default.a.modalFooter + ' modal-footer col-md-12'
          }, void 0, ModalBienvenida__jsx('div', {
            className: 'col-md-4 px-0'
          }, void 0, ModalBienvenida__jsx('button', {
            onClick: function onClick() {
              return _this2.props.back(_this2.props.step);
            },
            className: '' + __WEBPACK_IMPORTED_MODULE_12__ModalBienvenida_css___default.a.boton_accion
          }, void 0, _ref25, 'Anterior')), ModalBienvenida__jsx('div', {
            className: 'col-md-4 px-0'
          }, void 0, this.props.step, '/5'), ModalBienvenida__jsx('div', {
            className: 'col-md-4 px-0'
          }, void 0, ModalBienvenida__jsx('button', {
            onClick: function onClick() {
              return _this2.props.next(_this2.props.step);
            },
            className: '' + __WEBPACK_IMPORTED_MODULE_12__ModalBienvenida_css___default.a.boton_accion
          }, void 0, 'Siguiente', _ref26))));
          break;
        case 5:
          modal = ModalBienvenida__jsx('div', {}, void 0, _ref27, ModalBienvenida__jsx('div', {
            className: __WEBPACK_IMPORTED_MODULE_12__ModalBienvenida_css___default.a.modalBody + ' modal-body'
          }, void 0, ModalBienvenida__jsx('div', {
            className: __WEBPACK_IMPORTED_MODULE_12__ModalBienvenida_css___default.a.imageContainer
          }, void 0, ModalBienvenida__jsx('img', {
            style: { paddingLeft: '35px' },
            className: 'align-self-center mr-3',
            src: __WEBPACK_IMPORTED_MODULE_8__public_images_ic_calendar_png___default.a,
            alt: 'Telemedicina'
          })), _ref28, _ref29, _ref30, _ref31), ModalBienvenida__jsx('div', {
            className: __WEBPACK_IMPORTED_MODULE_12__ModalBienvenida_css___default.a.modalFooter + ' modal-footer col-md-12'
          }, void 0, ModalBienvenida__jsx('div', {
            className: 'col-md-4 px-0'
          }, void 0, ModalBienvenida__jsx('button', {
            onClick: function onClick() {
              return _this2.props.back(_this2.props.step);
            },
            className: '' + __WEBPACK_IMPORTED_MODULE_12__ModalBienvenida_css___default.a.boton_accion
          }, void 0, _ref32, 'Anterior')), ModalBienvenida__jsx('div', {
            className: 'col-md-4 px-0'
          }, void 0, ModalBienvenida__jsx('button', {
            'data-dismiss': 'modal',
            className: __WEBPACK_IMPORTED_MODULE_12__ModalBienvenida_css___default.a.boton_rojo + ' btn btn-danger',
            onClick: ModalBienvenida.showModalCuandoUtilizar
          }, void 0, 'Comenzar')), ModalBienvenida__jsx('div', {
            className: 'col-md-4 px-0'
          }, void 0, ModalBienvenida__jsx('input', {
            type: 'image',
            alt: 'Siguiente',
            src: __WEBPACK_IMPORTED_MODULE_4__public_images_ic_arrow_foward_png___default.a,
            style: { display: 'none' },
            onClick: function onClick() {
              return _this2.props.next(_this2.props.step);
            }
          }))));
          break;
        default:
      }
      return ModalBienvenida__jsx('div', {
        className: 'modal fade',
        id: 'ModalBienvenida'
      }, void 0, ModalBienvenida__jsx('div', {
        className: 'modal-dialog'
      }, void 0, ModalBienvenida__jsx('div', {
        className: __WEBPACK_IMPORTED_MODULE_12__ModalBienvenida_css___default.a.modalContent + ' modal-content'
      }, void 0, ModalBienvenida__jsx('div', {
        className: __WEBPACK_IMPORTED_MODULE_12__ModalBienvenida_css___default.a.modalHeader + ' modal-header'
      }, void 0, _ref33, _ref34), modal)));
    }
  }], [{
    key: 'showModalCuandoUtilizar',
    value: function showModalCuandoUtilizar() {
      $('#ModalCuandoUtilizarEconsulta').modal('show');
    }
  }]);

  return ModalBienvenida;
}(ModalBienvenida___WEBPACK_IMPORTED_MODULE_0_react___default.a.Component);

/* harmony default export */ var ModalBienvenida_defaultExport = (Object(ModalBienvenida___WEBPACK_IMPORTED_MODULE_1_react_redux__["b" /* connect */])(null, null)(ModalBienvenida___WEBPACK_IMPORTED_MODULE_3_isomorphic_style_loader_lib_withStyles___default()(__WEBPACK_IMPORTED_MODULE_12__ModalBienvenida_css___default.a)(ModalBienvenida)));
// CONCATENATED MODULE: ./src/components/Telemedicina/SinTurnosDisponibles/SinTurnosDisponibles.js
/* harmony import */ var SinTurnosDisponibles___WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(71);
/* harmony import */ var SinTurnosDisponibles___WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(SinTurnosDisponibles___WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var SinTurnosDisponibles___WEBPACK_IMPORTED_MODULE_1_react_redux__ = __webpack_require__(415);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types__ = __webpack_require__(182);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_prop_types__);
/* harmony import */ var SinTurnosDisponibles___WEBPACK_IMPORTED_MODULE_3_isomorphic_style_loader_lib_withStyles__ = __webpack_require__(887);
/* harmony import */ var SinTurnosDisponibles___WEBPACK_IMPORTED_MODULE_3_isomorphic_style_loader_lib_withStyles___default = __webpack_require__.n(SinTurnosDisponibles___WEBPACK_IMPORTED_MODULE_3_isomorphic_style_loader_lib_withStyles__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__SinTurnosDisponibles_css__ = __webpack_require__(1301);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__SinTurnosDisponibles_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__SinTurnosDisponibles_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__public_SVG_ic_calendar_svg__ = __webpack_require__(1303);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__public_SVG_ic_calendar_svg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__public_SVG_ic_calendar_svg__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__actions_telemedicinaActions__ = __webpack_require__(416);
var SinTurnosDisponibles__jsx = function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; }();

var SinTurnosDisponibles__createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function SinTurnosDisponibles__classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function SinTurnosDisponibles__possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function SinTurnosDisponibles__inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }





// import { HOST_SERVER } from '../../../constants';

// import ImageCalendar from '../../../../public/images/ic_calendar.png';



var SinTurnosDisponibles__ref = SinTurnosDisponibles__jsx('div', {
  className: 'col-md-5'
});

var SinTurnosDisponibles__ref2 = SinTurnosDisponibles__jsx('img', {
  src: __WEBPACK_IMPORTED_MODULE_5__public_SVG_ic_calendar_svg___default.a,
  alt: 'Anterior'
});

var SinTurnosDisponibles__ref3 = SinTurnosDisponibles__jsx('br', {});

var SinTurnosDisponibles__ref4 = SinTurnosDisponibles__jsx('br', {});

var SinTurnosDisponibles = function (_React$Component) {
  SinTurnosDisponibles__inherits(SinTurnosDisponibles, _React$Component);

  function SinTurnosDisponibles() {
    SinTurnosDisponibles__classCallCheck(this, SinTurnosDisponibles);

    return SinTurnosDisponibles__possibleConstructorReturn(this, (SinTurnosDisponibles.__proto__ || Object.getPrototypeOf(SinTurnosDisponibles)).apply(this, arguments));
  }

  SinTurnosDisponibles__createClass(SinTurnosDisponibles, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      this.props.endResponse();
    }
  }, {
    key: 'render',
    value: function render() {
      return SinTurnosDisponibles__jsx('div', {
        className: 'col-md-12'
      }, void 0, SinTurnosDisponibles__jsx('div', {
        className: __WEBPACK_IMPORTED_MODULE_4__SinTurnosDisponibles_css___default.a.divImagen + ' row'
      }, void 0, SinTurnosDisponibles__ref, SinTurnosDisponibles__ref2), SinTurnosDisponibles__jsx('div', {
        className: __WEBPACK_IMPORTED_MODULE_4__SinTurnosDisponibles_css___default.a.divTexto + ' col-md-12'
      }, void 0, 'Por el momento no tenemos turnos disponibles para consultas online.', SinTurnosDisponibles__ref3, 'Estamos trabajando para ampliar la disponibilidad de turnos.', SinTurnosDisponibles__ref4, 'Pod\xE9s agendar un Turno Presencial o ir a la Guardia m\xE1s cercana.'));
    }
  }]);

  return SinTurnosDisponibles;
}(SinTurnosDisponibles___WEBPACK_IMPORTED_MODULE_0_react___default.a.Component);

/* harmony default export */ var SinTurnosDisponibles_defaultExport = (Object(SinTurnosDisponibles___WEBPACK_IMPORTED_MODULE_1_react_redux__["b" /* connect */])(null, __WEBPACK_IMPORTED_MODULE_6__actions_telemedicinaActions__)(SinTurnosDisponibles___WEBPACK_IMPORTED_MODULE_3_isomorphic_style_loader_lib_withStyles___default()(__WEBPACK_IMPORTED_MODULE_4__SinTurnosDisponibles_css___default.a)(SinTurnosDisponibles)));
// CONCATENATED MODULE: ./src/components/Telemedicina/ModalErrorDocumentoIntes/ModalErrorDocumentoIntes.js
/* harmony import */ var ModalErrorDocumentoIntes___WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(71);
/* harmony import */ var ModalErrorDocumentoIntes___WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(ModalErrorDocumentoIntes___WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var ModalErrorDocumentoIntes___WEBPACK_IMPORTED_MODULE_1_react_redux__ = __webpack_require__(415);
/* harmony import */ var ModalErrorDocumentoIntes___WEBPACK_IMPORTED_MODULE_2_isomorphic_style_loader_lib_withStyles__ = __webpack_require__(887);
/* harmony import */ var ModalErrorDocumentoIntes___WEBPACK_IMPORTED_MODULE_2_isomorphic_style_loader_lib_withStyles___default = __webpack_require__.n(ModalErrorDocumentoIntes___WEBPACK_IMPORTED_MODULE_2_isomorphic_style_loader_lib_withStyles__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__ModalErrorDocumentoIntes_css__ = __webpack_require__(1307);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__ModalErrorDocumentoIntes_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__ModalErrorDocumentoIntes_css__);
var ModalErrorDocumentoIntes__jsx = function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; }();

var ModalErrorDocumentoIntes__createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function ModalErrorDocumentoIntes__classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function ModalErrorDocumentoIntes__possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function ModalErrorDocumentoIntes__inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

/* eslint react/no-did-mount-set-state: 0 */
/* eslint react/prop-types: 0 */
/* eslint consistent-return: 0 */





var ModalErrorDocumentoIntes__ref = ModalErrorDocumentoIntes__jsx('div', {
  className: 'modal-header'
}, void 0, ModalErrorDocumentoIntes__jsx('h5', {
  className: 'modal-title'
}, void 0, 'Actualizaci\xF3n de datos'));

var ModalErrorDocumentoIntes__ref2 = ModalErrorDocumentoIntes__jsx('div', {}, void 0, 'Los datos de uno de los integrantes de tu grupo familiar est\xE1n desactualizados y no podr\xE1 visualizar la informaci\xF3n correspondiente. Por favor comunicate al \xA0', ModalErrorDocumentoIntes__jsx('strong', {}, void 0, '0810-444-7700'), '\xA0para actualizar la informaci\xF3n.');

var ModalErrorDocumentoIntes = function (_React$Component) {
  ModalErrorDocumentoIntes__inherits(ModalErrorDocumentoIntes, _React$Component);

  function ModalErrorDocumentoIntes() {
    ModalErrorDocumentoIntes__classCallCheck(this, ModalErrorDocumentoIntes);

    return ModalErrorDocumentoIntes__possibleConstructorReturn(this, (ModalErrorDocumentoIntes.__proto__ || Object.getPrototypeOf(ModalErrorDocumentoIntes)).apply(this, arguments));
  }

  ModalErrorDocumentoIntes__createClass(ModalErrorDocumentoIntes, [{
    key: 'componentDidMount',
    value: function componentDidMount() {}
  }, {
    key: 'render',
    value: function render() {
      return ModalErrorDocumentoIntes__jsx('div', {
        className: 'modal fade',
        id: 'ModalErrorDocumentoIntes'
      }, void 0, ModalErrorDocumentoIntes__jsx('div', {
        className: 'modal-dialog'
      }, void 0, ModalErrorDocumentoIntes__jsx('div', {
        className: __WEBPACK_IMPORTED_MODULE_3__ModalErrorDocumentoIntes_css___default.a.modalContent + ' modal-content'
      }, void 0, ModalErrorDocumentoIntes__ref, ModalErrorDocumentoIntes__jsx('div', {
        className: __WEBPACK_IMPORTED_MODULE_3__ModalErrorDocumentoIntes_css___default.a.modalBody + ' modal-body'
      }, void 0, ModalErrorDocumentoIntes__ref2), ModalErrorDocumentoIntes__jsx('div', {
        className: __WEBPACK_IMPORTED_MODULE_3__ModalErrorDocumentoIntes_css___default.a.modalFooter + ' modal-footer'
      }, void 0, ModalErrorDocumentoIntes__jsx('button', {
        'data-dismiss': 'modal',
        className: __WEBPACK_IMPORTED_MODULE_3__ModalErrorDocumentoIntes_css___default.a.boton_rojo + ' btn btn-danger text-center'
      }, void 0, 'Aceptar')))));
    }
  }]);

  return ModalErrorDocumentoIntes;
}(ModalErrorDocumentoIntes___WEBPACK_IMPORTED_MODULE_0_react___default.a.Component);

/* harmony default export */ var ModalErrorDocumentoIntes_defaultExport = (Object(ModalErrorDocumentoIntes___WEBPACK_IMPORTED_MODULE_1_react_redux__["b" /* connect */])(null, null)(ModalErrorDocumentoIntes___WEBPACK_IMPORTED_MODULE_2_isomorphic_style_loader_lib_withStyles___default()(__WEBPACK_IMPORTED_MODULE_3__ModalErrorDocumentoIntes_css___default.a)(ModalErrorDocumentoIntes)));
// CONCATENATED MODULE: ./src/components/Telemedicina/TurnosEspontaneos/TurnosEspontaneos.js
/* harmony import */ var TurnosEspontaneos___WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(71);
/* harmony import */ var TurnosEspontaneos___WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(TurnosEspontaneos___WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var TurnosEspontaneos___WEBPACK_IMPORTED_MODULE_1_react_redux__ = __webpack_require__(415);
/* harmony import */ var TurnosEspontaneos___WEBPACK_IMPORTED_MODULE_2_prop_types__ = __webpack_require__(182);
/* harmony import */ var TurnosEspontaneos___WEBPACK_IMPORTED_MODULE_2_prop_types___default = __webpack_require__.n(TurnosEspontaneos___WEBPACK_IMPORTED_MODULE_2_prop_types__);
/* harmony import */ var TurnosEspontaneos___WEBPACK_IMPORTED_MODULE_3_isomorphic_style_loader_lib_withStyles__ = __webpack_require__(887);
/* harmony import */ var TurnosEspontaneos___WEBPACK_IMPORTED_MODULE_3_isomorphic_style_loader_lib_withStyles___default = __webpack_require__.n(TurnosEspontaneos___WEBPACK_IMPORTED_MODULE_3_isomorphic_style_loader_lib_withStyles__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__TurnosEspontaneos_css__ = __webpack_require__(1309);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__TurnosEspontaneos_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__TurnosEspontaneos_css__);
var TurnosEspontaneos__jsx = function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; }();

var TurnosEspontaneos__createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function TurnosEspontaneos__classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function TurnosEspontaneos__possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function TurnosEspontaneos__inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

/* eslint-disable global-require */




// eslint-disable-next-line css-modules/no-unused-class

// const medicosClinicos = [
//     '../../../../public/images/ClinicaMedica/91252.jpg',
//     '../../../../public/images/ClinicaMedica/144731.jpg',
//     '../../../../public/images/ClinicaMedica/156280.jpg',
//     '../../../../public/images/ClinicaMedica/191577.jpg',
//     '../../../../public/images/ClinicaMedica/209560.jpg',
// ]

var doctors = {
  ClinicaMedica: ['ClinicaMedica/553', 'ClinicaMedica/749', 'ClinicaMedica/24579', 'ClinicaMedica/19524', 'ClinicaMedica/18046', 'ClinicaMedica/17991'],
  Pediatria: ['Pediatria/24576', 'Pediatria/24577', 'Pediatria/25829', 'Pediatria/24574', 'Pediatria/25241']
};

var TurnosEspontaneos = function (_React$Component) {
  TurnosEspontaneos__inherits(TurnosEspontaneos, _React$Component);

  function TurnosEspontaneos() {
    var _ref;

    var _temp, _this, _ret;

    TurnosEspontaneos__classCallCheck(this, TurnosEspontaneos);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = TurnosEspontaneos__possibleConstructorReturn(this, (_ref = TurnosEspontaneos.__proto__ || Object.getPrototypeOf(TurnosEspontaneos)).call.apply(_ref, [this].concat(args))), _this), _this.deleteWhiteSpaces = function (string) {
      return string.replace(/ /g, '');
    }, _this.deleteAccents = function (string) {
      return string.normalize('NFD').replace(/[\u0300-\u036f]/g, '');
    }, _temp), TurnosEspontaneos__possibleConstructorReturn(_this, _ret);
  }

  TurnosEspontaneos__createClass(TurnosEspontaneos, [{
    key: 'render',
    value: function render() {
      // const speciality = this.deleteWhiteSpaces(
      //   this.deleteAccents(this.props.especialidad),
      // );

      var images = doctors.ClinicaMedica.map(function (image, index) {
        return TurnosEspontaneos__jsx('li', {}, index.toString(), TurnosEspontaneos__jsx('img', {
          src: __webpack_require__(1311)("./" + image + '.jpg'),
          alt: '',
          className: '' + __WEBPACK_IMPORTED_MODULE_4__TurnosEspontaneos_css___default.a.imgAvatar
        }, image));
      });

      return TurnosEspontaneos__jsx('div', {}, void 0, TurnosEspontaneos__jsx('div', {
        className: ' card ' + __WEBPACK_IMPORTED_MODULE_4__TurnosEspontaneos_css___default.a.content
      }, void 0, TurnosEspontaneos__jsx('div', {
        className: 'card-header  text-center ' + __WEBPACK_IMPORTED_MODULE_4__TurnosEspontaneos_css___default.a.header
      }, void 0, 'Profesionales para Atenci\xF3n Inmediata'), TurnosEspontaneos__jsx('div', {
        className: 'card-body'
      }, void 0, TurnosEspontaneos__jsx('div', {
        className: 'container'
      }, void 0, TurnosEspontaneos__jsx('div', {
        className: 'row'
      }, void 0, TurnosEspontaneos__jsx('div', {
        className: 'col text-center ' + __WEBPACK_IMPORTED_MODULE_4__TurnosEspontaneos_css___default.a.divRow
      }, void 0, ' ', TurnosEspontaneos__jsx('ul', {
        className: '' + __WEBPACK_IMPORTED_MODULE_4__TurnosEspontaneos_css___default.a.avataresUl
      }, void 0, images)), TurnosEspontaneos__jsx('div', {
        className: 'col ' + __WEBPACK_IMPORTED_MODULE_4__TurnosEspontaneos_css___default.a.buttonDiv
      }, void 0, TurnosEspontaneos__jsx('button', {
        onClick: this.props.press,
        className: 'btn ' + __WEBPACK_IMPORTED_MODULE_4__TurnosEspontaneos_css___default.a.button,
        style: { cursor: 'pointer' }
      }, void 0, 'Iniciar Atenci\xF3n')))))));
    }
  }]);

  return TurnosEspontaneos;
}(TurnosEspontaneos___WEBPACK_IMPORTED_MODULE_0_react___default.a.Component);

var TurnosEspontaneos_mapStateToProps = function mapStateToProps(state) {
  return {
    espontaneo: state.telemedicina.espontaneo
    // turnWaitingTime: state.telemedicina.turnWaitingTime,
  };
};

/* harmony default export */ var TurnosEspontaneos_defaultExport = (Object(TurnosEspontaneos___WEBPACK_IMPORTED_MODULE_1_react_redux__["b" /* connect */])(TurnosEspontaneos_mapStateToProps, null)(TurnosEspontaneos___WEBPACK_IMPORTED_MODULE_3_isomorphic_style_loader_lib_withStyles___default()(__WEBPACK_IMPORTED_MODULE_4__TurnosEspontaneos_css___default.a)(TurnosEspontaneos)));
// CONCATENATED MODULE: ./src/components/Telemedicina/AlertDisponibilidad/AlertDisponibilidad.js
/* harmony import */ var AlertDisponibilidad___WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(71);
/* harmony import */ var AlertDisponibilidad___WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(AlertDisponibilidad___WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var AlertDisponibilidad___WEBPACK_IMPORTED_MODULE_1_react_redux__ = __webpack_require__(415);
/* harmony import */ var AlertDisponibilidad___WEBPACK_IMPORTED_MODULE_2_prop_types__ = __webpack_require__(182);
/* harmony import */ var AlertDisponibilidad___WEBPACK_IMPORTED_MODULE_2_prop_types___default = __webpack_require__.n(AlertDisponibilidad___WEBPACK_IMPORTED_MODULE_2_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__actions_telemedicinaActions__ = __webpack_require__(416);
var AlertDisponibilidad__jsx = function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; }();

var AlertDisponibilidad__createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function AlertDisponibilidad__classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function AlertDisponibilidad__possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function AlertDisponibilidad__inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

/* eslint-disable no-undef */




// import TurnosSolicitudAlert from '../../../components/Telemedicina/TurnosSolicitudAlert/TurnosSolicitudAlert';

// import IconCalendar from '../../../../public/images/agenda notif.png';

var AlertDisponibilidad_AlertDisponibilidad = function (_Component) {
  AlertDisponibilidad__inherits(AlertDisponibilidad, _Component);

  function AlertDisponibilidad() {
    var _ref;

    var _temp, _this, _ret;

    AlertDisponibilidad__classCallCheck(this, AlertDisponibilidad);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = AlertDisponibilidad__possibleConstructorReturn(this, (_ref = AlertDisponibilidad.__proto__ || Object.getPrototypeOf(AlertDisponibilidad)).call.apply(_ref, [this].concat(args))), _this), _this.clickEspontaneo = function () {
      // this.props.espontaneoCall();
      _this.props.validaciones();
      _this.props.getTelefonoAfiliado();
    }, _this.alert = function () {
      var alert = '';
      if (_this.props.showEspontaneos) {
        alert = AlertDisponibilidad__jsx(TurnosEspontaneos_defaultExport
        // turno={this.props.espontaneo.hora}
        // especialidad={this.props.especialidad.especialidadOptions[1].text}
        , {
          press: function press() {
            return _this.clickEspontaneo();
          }
        });
        // }else{
        //   alert=(null)
      }
      return alert;
    }, _temp), AlertDisponibilidad__possibleConstructorReturn(_this, _ret);
  }

  // ALERT NEW DOC24


  AlertDisponibilidad__createClass(AlertDisponibilidad, [{
    key: 'render',


    // ALERT OLD
    // alert = () => {
    //   // const turnTime = moment(this.props.espontaneo.hora, 'hh:mm');
    //   // const endTime = moment('2045', 'hh:mm');
    //   // const firstTime = moment('0900', 'hh:mm');
    //   // const areTurnsAvailable =
    //   // turnTime.isSameOrAfter(firstTime) && turnTime.isBefore(endTime);
    //   console.log(this.props.especialidad && this.props.especialidad.especialidadOptions[1].text);
    //   let alert = '';
    //   if (this.props.alertTurnos === 1) {
    //     if (
    //       // areTurnsAvailable &&
    //       this.props.turnWaitingTime &&
    //       !this.props.turnWaitingTime.errorCode &&
    //       this.props.specialityName !== 'Well Test'
    //     ) {
    //       if (this.props.showEspontaneos) {
    //         alert = (
    //           <TurnosEspontaneos
    //             turno={this.props.espontaneo.hora}
    //             especialidad={this.props.especialidad.especialidadOptions[1].text}
    //             press={() => this.clickEspontaneo()}
    //           />
    //         );
    //       } else {
    //         // alert = (
    //         //   <TurnosSolicitudAlert alertType="success">
    //         //     <img
    //         //       alt="Anterior"
    //         //       src={IconCalendar}
    //         //       style={{ width: '30px', marginRight: '34px' }}
    //         //     />
    //         //     <span>
    //         //       Al tener un programado pedido no podrás acceder a los turnos
    //         //       espontáneos.
    //         //     </span>
    //         //   </TurnosSolicitudAlert>
    //         // );
    //       }
    //     } else {
    //       alert = (
    //         <TurnosSolicitudAlert alertType="success">
    //           <img
    //             alt="Anterior"
    //             src={IconCalendar}
    //             style={{ width: '30px', marginRight: '34px' }}
    //           />
    //           <span>En este momento no hay médicos disponibles.</span>
    //         </TurnosSolicitudAlert>
    //       );
    //     }
    //   } else if (this.props.alertTurnos === 2) {
    //     alert = (
    //       <TurnosSolicitudAlert alertType="warning">
    //         <i
    //           className="fa fa-exclamation-circle"
    //           aria-hidden="true"
    //           style={{
    //             color: '#FF7D00',
    //             fontSize: '20px',
    //             marginRight: '34px',
    //           }}
    //         />
    //         <span>En este momento no hay médicos disponibles.</span>
    //       </TurnosSolicitudAlert>
    //     );
    //   } else if (this.props.alertTurnos === 3) {
    //     alert = (
    //       <TurnosSolicitudAlert alertType="success">
    //         <img
    //           alt="Anterior"
    //           src={IconCalendar}
    //           style={{ width: '30px', marginRight: '34px' }}
    //         />
    //         <span>En este momento no hay médicos disponibles.</span>
    //       </TurnosSolicitudAlert>
    //     );
    //   }
    //   return alert;
    // };

    value: function render() {
      return AlertDisponibilidad__jsx('div', {}, void 0, this.alert());
    }
  }]);

  return AlertDisponibilidad;
}(AlertDisponibilidad___WEBPACK_IMPORTED_MODULE_0_react__["Component"]);

var AlertDisponibilidad_mapStateToProps = function mapStateToProps(state) {
  return {
    turnWaitingTime: state.telemedicina.turnWaitingTime,
    stateEspecialidades: state.telemedicina.stateEspecialidades,
    stateMotivo: state.telemedicina.stateMotivo
  };
};

/* harmony default export */ var AlertDisponibilidad_defaultExport = (Object(AlertDisponibilidad___WEBPACK_IMPORTED_MODULE_1_react_redux__["b" /* connect */])(AlertDisponibilidad_mapStateToProps, __WEBPACK_IMPORTED_MODULE_3__actions_telemedicinaActions__)(AlertDisponibilidad_AlertDisponibilidad));
// CONCATENATED MODULE: ./src/components/Telemedicina/TurnosSolicitud/TurnosSolicitud.js
/* harmony import */ var TurnosSolicitud___WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(71);
/* harmony import */ var TurnosSolicitud___WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(TurnosSolicitud___WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var TurnosSolicitud___WEBPACK_IMPORTED_MODULE_1_react_redux__ = __webpack_require__(415);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_moment__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_moment__);
/* harmony import */ var TurnosSolicitud___WEBPACK_IMPORTED_MODULE_3_isomorphic_style_loader_lib_withStyles__ = __webpack_require__(887);
/* harmony import */ var TurnosSolicitud___WEBPACK_IMPORTED_MODULE_3_isomorphic_style_loader_lib_withStyles___default = __webpack_require__.n(TurnosSolicitud___WEBPACK_IMPORTED_MODULE_3_isomorphic_style_loader_lib_withStyles__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__public_images_checked_notif_png__ = __webpack_require__(1304);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__public_images_checked_notif_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10__public_images_checked_notif_png__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__actions_telemedicinaActions__ = __webpack_require__(416);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__components_Loading_Loading__ = __webpack_require__(940);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__TurnosSolicitud_css__ = __webpack_require__(1305);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__TurnosSolicitud_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_13__TurnosSolicitud_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__constants__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__utils_generateAbsoluteUrl__ = __webpack_require__(127);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19__src_constants_index__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20__utils_turnUtils__ = __webpack_require__(1247);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21__utils_timeManipulation__ = __webpack_require__(1139);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var TurnosSolicitud__createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var TurnosSolicitud__jsx = function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; }();

function TurnosSolicitud__classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function TurnosSolicitud__possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function TurnosSolicitud__inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

/* eslint react/no-did-mount-set-state: 0 */
/* eslint react/prop-types: 0 */
/* eslint consistent-return: 0 */
/* global $ */
/* eslint-disable */
























var TurnosSolicitud__ref = TurnosSolicitud__jsx(__WEBPACK_IMPORTED_MODULE_12__components_Loading_Loading__["a" /* default */], {});

var TurnosSolicitud_MedicCard = function MedicCard(props) {
  return TurnosSolicitud__jsx('div', {
    className: 'col-md-12',
    style: { paddingLeft: '0', paddingRight: '0' }
  }, void 0, props.TurnosPorFecha ? TurnosSolicitud__jsx(ListCards_defaultExport, {
    validarTurnoTomado: props.validarTurnoTomado,
    turnosPorfecha: props.TurnosPorFecha,
    specialityName: props.specialityName,
    fechaCard: props.dateCard
  }) : TurnosSolicitud__ref);
};

var initialState = {
  step: 1,
  email: '',
  buttonCards: 0,
  cardsData: [],
  cardsDataFilter: [],
  fecha: '',
  fechaSeleccionada: '',
  value: { min: 480, max: 1200 },
  maxValue: 1200,
  minValue: 480,
  desde: '',
  hasta: '',
  showEspontaneos: false,
  disabledButton: false
  // disabledButton: true //estabe asi
};

var TurnosSolicitud__ref2 = TurnosSolicitud__jsx(SinTurnosDisponibles_defaultExport, {});

var TurnosSolicitud__ref3 = TurnosSolicitud__jsx(ModalErrorDocumentoIntes_defaultExport, {});

var TurnosSolicitud_TurnosSolicitud = function (_React$Component) {
  TurnosSolicitud__inherits(TurnosSolicitud, _React$Component);

  function TurnosSolicitud(props) {
    TurnosSolicitud__classCallCheck(this, TurnosSolicitud);

    var _this = TurnosSolicitud__possibleConstructorReturn(this, (TurnosSolicitud.__proto__ || Object.getPrototypeOf(TurnosSolicitud)).call(this, props));

    _this.setAreDoctorsOnline = function (val) {
      _this.setState({ areDoctorsOnline: val });
    };

    _this.formatDate = function (date, format) {
      var dateFormat = void 0;
      var arrDate = date.split('/');
      var year = arrDate[2];
      var month = arrDate[1] < 10 && arrDate[1].substr(0, 1) !== '0' ? 0 + arrDate[1] : arrDate[1];
      var day = arrDate[0] < 10 && arrDate[0].substr(0, 1) !== '0' ? 0 + arrDate[0] : arrDate[0];
      if (format === 's') {
        dateFormat = year + month + day;
      } else {
        dateFormat = day + '/' + month + '/' + year;
      }
      return dateFormat;
    };

    _this.dateMedicCard = function (date) {
      var year = date.substr(0, 4);
      var month = date.substr(4, 2);
      var day = date.substr(6, 8);
      var dateFormat = day + '/' + month + '/' + year;
      return dateFormat;
    };

    _this.getDocumentos = function (integrantes) {
      var arrIntes = [];
      integrantes.forEach(function (option) {
        arrIntes.push({ documento: option.documento });
      });
      return arrIntes;
    };

    _this.obtenerFechaHoy = function () {
      var hoy = new Date();
      var dd = hoy.getDate();
      var mm = hoy.getMonth() + 1;
      var yyyy = hoy.getFullYear();

      if (dd < 10) {
        dd = '0' + dd;
      }

      if (mm < 10) {
        mm = '0' + mm;
      }

      return dd + '/' + mm + '/' + yyyy;
    };

    _this.findDatePick = function () {
      if (_this.state.fecha !== '') {
        var day = _this.state.fecha.substring(0, 2);
        var month = _this.state.fecha.substring(3, 5);
        var year = _this.state.fecha.substring(6, 11);
        var dateFormat = Number(day) + '/' + Number(month) + '/' + year;

        var dateIndex = _this.props.fechasDisponibles.indexOf(dateFormat);
        _this.props.fetchTurnosPorFechaAsync(_this.formatDate(_this.props.fechasDisponibles[dateIndex], 's'), _this.props.especialidades[1].espe, _this.props.practica, _this.props.prepaga).then(function () {
          var turnos = {
            date: _this.props.fechasDisponibles[dateIndex],
            turnos: _this.props.TurnosPorFecha
          };
          var foundDate = [turnos];
          dateIndex = dateIndex + 1;
          if (_this.state.cardsDataFilter.length > 0) {
            var cardsDataFilter = foundDate;
            cardsDataFilter = _this.filterByTime(_this.state.desde, _this.state.hasta);
            _this.setState({
              buttonCards: dateIndex,
              cardsData: foundDate,
              cardsDataFilter: cardsDataFilter
            });
          } else {
            _this.setState({
              buttonCards: dateIndex,
              cardsData: foundDate
            });
          }
        });
      }
    };

    _this.fechaPicker = function () {
      var fechasDisponibles = _this.props.fechasDisponibles;
      if (fechasDisponibles) {
        $('#calendario').show();
        $('#calendario').datepicker({
          format: 'dd/mm/yyyy',
          autoclose: true,
          language: 'es',
          beforeShowDay: function beforeShowDay(date) {
            var onlyThisDates = fechasDisponibles;
            var jsonReturn = void 0;
            var day = date.getDate() + '/' + (date.getMonth() + 1) + '/' + date.getFullYear();
            if (onlyThisDates.indexOf(day) !== -1) {
              jsonReturn = {
                enabled: true,
                tooltip: 'Seleccionar fecha'
              };
            } else {
              jsonReturn = {
                enabled: false,
                tooltip: 'Fecha no disponible'
              };
            }
            return jsonReturn;
          }
        }).on('changeDate', function (e) {
          $('#fechaTurno').val(_this.formatDate(e.date.toLocaleDateString(), 's'));
          if (_this.formatDate(_this.state.fechaSeleccionada, 's') !== _this.formatDate(e.date.toLocaleDateString(), 's')) {
            $('#fechaTurno').click();
          }
          var fecha = _this.formatDate(e.date.toLocaleDateString(), 'h');
          _this.setState({ fecha: fecha }, function () {
            return _this.findDatePick();
          });
        });
      } else {
        $('#calendario').datepicker('remove');
      }
    };

    _this.formatearHora = function (paramHora) {
      var hora = paramHora;
      var min = Math.floor(hora / 60);
      hora = Math.round(Math.abs(hora) % 60);
      return min + ':' + (hora < 10 ? '0' + hora : hora);
    };

    _this.onChangeHorario = function (value) {
      var horaDesdeFormat = _this.formatearHora(value.value.min).replace(':', '');
      var horaHastaFormat = _this.formatearHora(value.value.max).replace(':', '');
      var horaDesde = horaDesdeFormat < 1000 ? 0 + horaDesdeFormat : horaDesdeFormat;
      var horaHasta = horaHastaFormat < 1000 ? 0 + horaHastaFormat : horaHastaFormat;
      var cardDataFiltradoPorTurno = _this.filterByTime(horaDesde, horaHasta);
      _this.setState({ cardsDataFilter: cardDataFiltradoPorTurno });
    };

    _this.onClickHorarioChange = function (obj) {
      var horaDesdeFormat = _this.formatearHora(obj.min).replace(':', '');
      var horaHastaFormat = _this.formatearHora(obj.max).replace(':', '');
      var horaDesde = horaDesdeFormat < 1000 ? 0 + horaDesdeFormat : horaDesdeFormat;
      var horaHasta = horaHastaFormat < 1000 ? 0 + horaHastaFormat : horaHastaFormat;

      var cardDataFiltradoPorTurno = _this.filterByTime(horaDesde, horaHasta);

      _this.setState({
        value: obj,
        cardsDataFilter: cardDataFiltradoPorTurno,
        desde: horaDesde,
        hasta: horaHasta
      });
    };

    _this.setHora = function (value) {
      _this.setState({ value: value });
    };

    _this.filterByTime = function (desde, hasta, turnos) {
      if (_this.state.cardsData.length > 0) {
        if (turnos) {
          turnos = JSON.parse(JSON.stringify(turnos));
        } else {
          turnos = JSON.parse(JSON.stringify(_this.state.cardsData));
        }

        var cardDataFiltradoPorTurno = turnos.map(function (turno) {

          var nuevosTurnos = turno.turnos.map(function (turnoPorMedico) {

            var horarios = turnoPorMedico.horarios;

            var filtered = horarios.filter(function (horario) {
              return horario.replace(':', '') >= desde && horario.replace(':', '') < hasta;
            });
            turnoPorMedico.horarios = filtered;
            return turnoPorMedico;
          });
          turno.turnos = nuevosTurnos;
          return turno;
        });
        return cardDataFiltradoPorTurno;
      }
    };

    _this.turnoVencido = function (pDate) {
      var year = pDate.substring(0, 4);
      var month = pDate.substring(4, 6);
      var day = pDate.substring(6, 8);
      var hour = pDate.substring(8, 10);
      var min = pDate.substring(10, 12);
      var dateFormated = year + '-' + month + '-' + day + ' ' + hour + ':' + min;
      var date = __WEBPACK_IMPORTED_MODULE_2_moment___default()(dateFormated);
      return __WEBPACK_IMPORTED_MODULE_2_moment___default()().isAfter(__WEBPACK_IMPORTED_MODULE_2_moment___default()(date).add(10, 'minutes'));
    };

    _this.getProgrammedTurn = function (turns) {
      var programmedTurn = turns.filter(function (turn) {
        return turn.centro === __WEBPACK_IMPORTED_MODULE_19__src_constants_index__["f" /* CENTRO */] && !Object(__WEBPACK_IMPORTED_MODULE_20__utils_turnUtils__["a" /* default */])(turn.prestador);
      });
      return programmedTurn.length ? programmedTurn[programmedTurn.length - 1] : undefined;
    };

    _this.validarTurnoTomado = function (fecha) {
      var inte = '';
      var prepaga = '';
      var datos = JSON.parse(localStorage.getItem(__WEBPACK_IMPORTED_MODULE_16__constants__["_30" /* LOCALSTORAGE_AUTH_KEY */]));
      var datosInteSelected = JSON.parse(localStorage.getItem('inteSelected'));
      var contra = datos.modelEspecifico.contra;
      if (datosInteSelected) {
        inte = datosInteSelected.inte;
        prepaga = datosInteSelected.prepaga;
      }

      var token = datos.token;
      var dataTurnoTomado = {
        token: token,
        fechaDesde: fecha,
        fechaHasta: fecha,
        contra: contra,
        prepaga: prepaga,
        intes: [{ inte: inte }],
        tipo: 'CMA'
      };
      return fetch(Object(__WEBPACK_IMPORTED_MODULE_17__utils_generateAbsoluteUrl__["a" /* default */])() + '/api/telemedicinaTurnos', {
        method: 'POST',
        body: JSON.stringify(dataTurnoTomado),
        headers: new Headers({
          'Content-Type': 'application/json'
        })
      }).then(function (res) {
        return res.json();
      }).then(function (turns) {
        // const filtered = response.filter(turno => turno.centro === CENTRO);
        // let ultimoProgramado = filtered.filter( e =>  e.titular.nombreAbre !== 'CLINICO GENERICO')
        var programmedTurn = _this.getProgrammedTurn(turns);
        // ultimoProgramado = ultimoProgramado[ultimoProgramado.length - 1]
        // const ultimoTurno = filtered.length > 0 ? filtered[filtered.length - 1] : undefined;

        var showEspontaneo = !programmedTurn || programmedTurn.idEspecialidad === $('#especialidad').val() && (!__WEBPACK_IMPORTED_MODULE_21__utils_timeManipulation__["a" /* default */].hourDifferenceLessThan(programmedTurn.fechaDesde, __WEBPACK_IMPORTED_MODULE_2_moment___default()(), 1) || _this.turnoVencido(programmedTurn.fechaDesde));
        var showModal = programmedTurn && !_this.turnoVencido(programmedTurn.fechaDesde);
        return { showEspontaneo: showEspontaneo, showModal: showModal };
      }).catch(function (error) {
        return console.error('Error:', error);
      });
    };

    _this.state = _extends({}, initialState, {
      areDoctorsOnline: null,
      specialityName: ''
    });

    _this.setAreDoctorsOnline = _this.setAreDoctorsOnline.bind(_this);
    //this.setSpecialityName = this.setSpecialityName.bind(this);
    _this.onVerDisponibilidadClick = _this.onVerDisponibilidadClick.bind(_this);

    _this.onEspecialidadChange = _this.onEspecialidadChange.bind(_this);
    // this.onMotivoChange = this.onMotivoChange.bind(this);
    _this.onIntegrantesChange = _this.onIntegrantesChange.bind(_this);
    _this.getProgrammedTurn = _this.getProgrammedTurn.bind(_this);

    return _this;
  }

  // setSpecialityName = (val) => {
  //   this.setState({specialityName : val})
  // }

  TurnosSolicitud__createClass(TurnosSolicitud, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      $('#nav_main').css('z-index', '4');
      // validar que tenga productos vinculados, sino redireccionar a vinculacion
      var datos = JSON.parse(localStorage.getItem(__WEBPACK_IMPORTED_MODULE_16__constants__["_30" /* LOCALSTORAGE_AUTH_KEY */]));
      var contra = void 0;
      var inte = void 0;
      if (datos) {
        contra = datos.modelEspecifico.contra;
        inte = datos.modelEspecifico.inte;
      }

      if (contra === ' ') {
        window.location.href = __WEBPACK_IMPORTED_MODULE_16__constants__["_24" /* HOST_SERVER */] + 'smgnewsite/prepaga/mis_productos.php?origen=barIzq';
      }
      this.props.setHorarios('0800', '2000');
      newrelic.setCustomAttribute('contra', contra);
      newrelic.setCustomAttribute('inte', inte);
    }
  }, {
    key: 'componentWillReceiveProps',
    value: function componentWillReceiveProps(props) {
      if (this.props.TurnosPorFecha) {
        if (props.horaDesde !== this.props.horaDesde || props.horaHasta !== this.props.horaHasta) {
          this.props.filterTurnosPorHorario(props.horaDesde, props.horaHasta, this.props.TurnosPorFecha);
        }
      }

      if (props.integrantes !== this.props.integrantes) {
        var arrDocumentos = this.getDocumentos(props.integrantes);
        for (var i = 0; i < arrDocumentos.length; i += 1) {
          if (!validarDocumento_defaultExport(arrDocumentos[i].documento)) {
            $('#ModalErrorDocumentoIntes').modal();
          }
        }
      }
    }
  }, {
    key: 'componentWillMount',
    value: function componentWillMount() {
      this.resetState();
      //this.setState({disabledButton: true});
    }
  }, {
    key: 'componentWillUnmount',
    value: function componentWillUnmount() {
      this.props.cleanListEspecialidad();
      this.props.cleanFechasDisponibles();
    }
  }, {
    key: 'resetState',
    value: function resetState() {
      this.setState(initialState);
    }
  }, {
    key: 'next',
    value: function next(step) {
      this.setState({
        step: step + 1
      });
    }
  }, {
    key: 'back',
    value: function back(step) {
      this.setState({
        step: step - 1
      });
    }
  }, {
    key: 'stateDisableButton',
    value: function stateDisableButton() {
      if (this.props.stateEspecialidades && this.props.stateMotivo) {
        this.setState({
          disabledButton: false
        });
      }
    }
  }, {
    key: 'onVerDisponibilidadClick',
    value: function onVerDisponibilidadClick() {
      var _this2 = this;

      // const especialidad = $('#especialidad').val();  
      // this.props.fetchPracticas(especialidad).then(
      //   res => this.props.fetchTurnWaitingTime(especialidad, this.props.prepaga,res[0].practica)
      //   .then(obj => obj)
      // );
      // this.props.cleanTurnosPorFecha();
      // $('#especialidad option[value=0]').hide();
      // this.props.fetchEmail();

      // this.validarTurnoTomado(this.formatDate(this.obtenerFechaHoy(), 's'))
      // .then(res => res)
      // .then(res => {

      //   this.setState({ showEspontaneos: res.showEspontaneo, disabledButton: false });
      // })
      // .catch(error => console.error('Error:', error));

      // this.setState({
      //   disabledButton: true,
      // });
      var especialidad = $('#especialidad').val();
      this.props.motivoAdd(especialidad).then(function (data) {
        var motivo = _this2.props.motivos && _this2.props.motivos['id_motivo_consulta'];
        _this2.props.fetchMotivo(motivo);
      }).catch(function (err) {
        console.error(err);
      });

      this.props.fetchEspecialidad(especialidad);
      this.setState({ showEspontaneos: true, disabledButton: false });
    }
  }, {
    key: 'onEspecialidadChange',
    value: function onEspecialidadChange() {
      var _this3 = this;

      var selectedName = $('#especialidad').find('option:selected').attr("name");
      //this.props.setSpecialityName(selectedName)
      var especialidad = $('#especialidad').val();

      if (selectedName === 'Seleccione especialidad') {
        this.props.stateEspecialidades(false);
        return;
      }
      //Aca va un then catch
      this.props.motivoAdd(especialidad).then(function (data) {
        setTimeout(function () {
          console.log('pase por aca');
          _this3.props.stateEspecialidades(true);
          _this3.props.fetchEspecialidad(especialidad);
          _this3.props.stateMotivo(true);
          _this3.stateDisableButton();
          var motivo = _this3.props.motivos && _this3.props.motivos['id_motivo_consulta'];
          //let motivo = this.props.motivos;
          _this3.props.fetchMotivo(motivo);
        }, 1500);
      }).catch(function (err) {
        console.error(err);
      });
      if (especialidad === '0') {
        this.props.cleanList();
      }
    }

    // onMotivoChange(){
    //   let selectedName = $('#motivo').find('option:selected').attr("name");
    //   const motivo = $('#motivo').val();
    //   if(selectedName === 'Seleccione motivo'){
    //     this.props.stateMotivo(false);
    //     return;
    //   }
    //       this.props.stateMotivo(true);
    //       this.props.fetchMotivo(motivo);
    //       this.stateDisableButton();
    //   if ( motivo === '0') {
    //     this.props.cleanList();
    //   }
    // }


  }, {
    key: 'onIntegrantesChange',
    value: function onIntegrantesChange(selectValue) {
      if ($('#selectIntegrantes').val() !== '') {
        var selected = $('#selectIntegrantes').find('option:selected');
        var authData = localStorage.getItem('inteSelected');
        var authJson = JSON.parse(authData);
        if (authJson && selected.data()) {
          authJson.credencial = selected.data('credencial');
          authJson.edad = selected.data('edad');
          authJson.fechanacimiento = selected.data('fechanacimiento');
          authJson.inte = $('#selectIntegrantes').val();
          authJson.nombrecompleto = selected.data('nombrecompleto');
          authJson.nrodoc = selected.data('nrodoc');
          authJson.prepaga = selected.data('prepaga');
          authJson.sexo = selected.data('sexo');
          authJson.tipodoc = selected.data('tipodoc');

          localStorage.setItem('inteSelected', JSON.stringify(authJson));
        }
      } else {
        localStorage.setItem('inteSelected', JSON.stringify(selectValue));
      }

      this.props.setIntegranteSeleccionado($('#selectIntegrantes').val());
      $('#especialidad option[value=0]').show();
      this.props.cleanList();
      this.props.cleanListEspecialidad();
      this.props.cleanFechasDisponibles();
      this.resetState();

      if ($('#selectIntegrantes').val() === '') {
        //Aca va un then catch
        this.props.fetchEspecialidades(selectValue.sexo, selectValue.edad);
        console.log('especialidades pase');
      } else {
        var _selected = $('#selectIntegrantes').find('option:selected');
        this.props.fetchEspecialidades(_selected.data('sexo'), _selected.data('edad'));
        // .then((data)=>{
        //   console.log('especialidades',this.props.especialidades)
        // })
      }
    }
    //especialidadOptions

  }, {
    key: 'render',
    value: function render() {
      var _this4 = this;

      var cardsData = this.state.cardsDataFilter.length > 0 ? this.state.cardsDataFilter : this.state.cardsData;
      var alertTurnos = 1;
      var hayTurnos = true;
      var body = '';
      var componentCard = '';

      var fechaHoy = this.obtenerFechaHoy();
      var espontaneo = this.props.espontaneo;
      var fechaPrimerTurno = this.props.primerTurno;

      // if (fechaPrimerTurno && espontaneo) {
      //   // muestro el alert espontaneo con boton a videollamada
      //   if (espontaneo.fecha) {
      //     alertTurnos = 1; 
      //   } else {
      //     // muestro el alert no hay turnos para hoy
      //     if (fechaPrimerTurno !== fechaHoy) {
      //       alertTurnos = 2; 
      //     }
      //     // muestro el alert hay turnos para hoy
      //     if (fechaPrimerTurno === fechaHoy) {
      //       alertTurnos = 3; 
      //     }
      //     // muestro pantalla no turnos disponibles
      //     if (fechaPrimerTurno === '0') {
      //       hayTurnos = false; 
      //     }
      //   }
      // }
      if (hayTurnos) {
        componentCard = TurnosSolicitud__jsx('div', {
          className: 'row'
        }, void 0, this.props.fechasDisponibles && this.state.cardsData.length > 0 && TurnosSolicitud__jsx('div', {
          className: 'col-md-3'
        }, void 0, TurnosSolicitud__jsx(FilterLeft_defaultExport, {
          formatDate: this.formatDate,
          fechasD: this.props.fechasDisponibles,
          load: this.loadeMoreCards,
          change: this.setHora,
          formatearHora: this.formatearHora,
          value: this.state.value,
          maxValue: this.state.maxValue,
          minValue: this.state.minValue,
          onChangeHorario: this.onChangeHorario,
          onClickHorarioChange: this.onClickHorarioChange,
          changeDate: this.changeDate,
          fecha: this.state.fecha,
          fechaPicker: this.fechaPicker,
          fechaHeader: this.props.primeraFechaDisponible,
          horaDesde: this.props.horaDesde,
          horaHasta: this.props.horaHasta
        })), TurnosSolicitud__jsx('div', {
          className: 'col-md-9'
        }, void 0, TurnosSolicitud__jsx(AlertDisponibilidad_defaultExport, {
          showEspontaneos: this.state.showEspontaneos,
          validaciones: this.props.showValidacionesTecnicas
        }), this.props.fechasDisponibles && this.state.cardsData.length > 0 && cardsData.map(function (e, index) {
          return TurnosSolicitud__jsx('div', {}, index, TurnosSolicitud__jsx(TurnosSolicitud_MedicCard, {
            validarTurnoTomado: _this4.validarTurnoTomado,
            dateCard: e.date,
            primeraFechaDisponible: e.date,
            horaDesde: _this4.props.horaDesde,
            horaHasta: _this4.props.horaHasta,
            specialityName: _this4.state.specialityName,
            TurnosPorFecha: e
          }));
        })));
      }
      // ALERTS
      if (hayTurnos) {
        body = TurnosSolicitud__jsx('div', {}, void 0, TurnosSolicitud__jsx(TurnosSolicitudFilter_defaultExport, {
          onVerDisponibilidadClick: this.onVerDisponibilidadClick,
          onIntegrantesChange: this.onIntegrantesChange,
          onEspecialidadChange: this.onEspecialidadChange,
          onMotivoChange: this.onMotivoChange,
          setAreDoctorsOnline: this.setAreDoctorsOnline,
          disabledButton: this.state.disabledButton
        }), alertTurnos > 0 ? componentCard : '');
      } else {
        body = TurnosSolicitud__jsx('div', {}, void 0, TurnosSolicitud__jsx(TurnosSolicitudFilter_defaultExport, {
          setAreDoctorsOnline: this.setAreDoctorsOnline,
          onIntegrantesChange: this.onIntegrantesChange
        }), TurnosSolicitud__ref2);
      }
      return TurnosSolicitud__jsx('div', {}, void 0, TurnosSolicitud__ref3, body);
    }
  }]);

  return TurnosSolicitud;
}(TurnosSolicitud___WEBPACK_IMPORTED_MODULE_0_react___default.a.Component);

var TurnosSolicitud_mapStateToProps = function mapStateToProps(state) {
  return {
    stateMotivo: state.telemedicina.stateMotivo,
    fechasDisponibles: state.telemedicina.fechas_disponibles,
    primerTurno: state.telemedicina.primer_turno,
    espontaneo: state.telemedicina.espontaneo,
    TurnosPorFecha: state.telemedicina.turnos_por_fecha,
    primeraFechaDisponible: state.telemedicina.primera_fecha_disponible,
    horaDesde: state.telemedicina.horaDesde,
    horaHasta: state.telemedicina.horaHasta,
    integrantes: state.integrantes,
    turnos: state.turnos,
    practica: state.telemedicina.practica,
    prepaga: state.telemedicina.prepaga,
    especialidades: state.turnos.especialidadOptions,
    stateEspecialidades: state.telemedicina.stateEspecialidades,
    id_motivo: state.telemedicina.id_motivo,
    motivos: state.telemedicina.motivos
  };
};

/* harmony default export */ var TurnosSolicitud_defaultExport = __webpack_exports__["a"] = (Object(TurnosSolicitud___WEBPACK_IMPORTED_MODULE_1_react_redux__["b" /* connect */])(TurnosSolicitud_mapStateToProps, __WEBPACK_IMPORTED_MODULE_11__actions_telemedicinaActions__)(TurnosSolicitud___WEBPACK_IMPORTED_MODULE_3_isomorphic_style_loader_lib_withStyles___default()(__WEBPACK_IMPORTED_MODULE_13__TurnosSolicitud_css___default.a)(TurnosSolicitud_TurnosSolicitud)));

/***/ }),
/* 1247 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = esEspontaneo;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__generateAbsoluteUrl__ = __webpack_require__(127);
/* eslint-disable */


function esEspontaneo(prestador) {
  var ret = false;
  var enviroment = Object(__WEBPACK_IMPORTED_MODULE_0__generateAbsoluteUrl__["a" /* default */])();
  if (enviroment.includes('pre') || enviroment.includes('clubswiss')) {
    ret = prestador.toString() === '35645' || prestador.toString() === '35646';
  } else if (enviroment.includes('localhost') || enviroment.includes('mobileint') || enviroment.includes('srv-php01') || enviroment.includes('srv-php02') || enviroment.includes('mobileqa')) {
    ret = prestador.toString() === '35210' || prestador.toString() === '35211';
  } else {
    ret = prestador.toString() === '35645' || prestador.toString() === '35646';
  }
  return ret;
}

/***/ }),
/* 1248 */
/***/ (function(module, exports, __webpack_require__) {


    var content = __webpack_require__(1249);
    var insertCss = __webpack_require__(889);

    if (typeof content === 'string') {
      content = [[module.i, content, '']];
    }

    module.exports = content.locals || {};
    module.exports._getContent = function() { return content; };
    module.exports._getCss = function() { return content.toString(); };
    module.exports._insertCss = function(options) { return insertCss(content, options) };
    
    // Hot Module Replacement
    // https://webpack.github.io/docs/hot-module-replacement
    // Only activated in browser context
    if (false) {
      var removeCss = function() {};
      module.hot.accept("!!../../../node_modules/css-loader/index.js??ref--2-rules-2!../../../node_modules/postcss-loader/lib/index.js??ref--2-rules-3!./TelemedicinaPageUserLoggedIn.css", function() {
        content = require("!!../../../node_modules/css-loader/index.js??ref--2-rules-2!../../../node_modules/postcss-loader/lib/index.js??ref--2-rules-3!./TelemedicinaPageUserLoggedIn.css");

        if (typeof content === 'string') {
          content = [[module.id, content, '']];
        }

        removeCss = insertCss(content, { replace: true });
      });
      module.hot.dispose(function() { removeCss(); });
    }
  

/***/ }),
/* 1249 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(888)(false);
// imports


// module
exports.push([module.i, ".aHLPi{padding-top:0;padding-left:20px;padding-right:20px;font-family:Roboto,sans-serif}._3vmN0{margin:0 50px;padding:0 0 40px}._38iXq{height:200px}._38iXq h1{color:#fff;margin:0 50px;padding:30px 15px;font-family:Roboto\\, Thin,sans-serif}._38iXq h1 small{font-family:Roboto\\, Medium,sans-serif;font-size:20px}._1-bb1{font-size:48px}._3_o99{font-family:Roboto\\, Medium,sans-serif;position:inherit;color:#e4002b;cursor:pointer;outline:none;font-size:18px;clear:left;right:inherit;text-align:inherit;margin-top:20px;margin-bottom:0}._3_o99:focus,._3_o99:hover{color:#e4002b;text-decoration:none}._28MMp{margin-top:22px}@media (max-width:770px){._3wW99{margin-top:-70px}._3_o99{position:static}}", ""]);

// exports
exports.locals = {
	"root": "aHLPi",
	"container": "_3vmN0",
	"imageBanner": "_38iXq",
	"eConsulta": "_1-bb1",
	"linkModalBienvenida": "_3_o99",
	"eConsultaDiv": "_28MMp",
	"mtMinus": "_3wW99"
};

/***/ }),
/* 1250 */
/***/ (function(module, exports, __webpack_require__) {


    var content = __webpack_require__(1251);
    var insertCss = __webpack_require__(889);

    if (typeof content === 'string') {
      content = [[module.i, content, '']];
    }

    module.exports = content.locals || {};
    module.exports._getContent = function() { return content; };
    module.exports._getCss = function() { return content.toString(); };
    module.exports._insertCss = function(options) { return insertCss(content, options) };
    
    // Hot Module Replacement
    // https://webpack.github.io/docs/hot-module-replacement
    // Only activated in browser context
    if (false) {
      var removeCss = function() {};
      module.hot.accept("!!../../../../node_modules/css-loader/index.js??ref--2-rules-2!../../../../node_modules/postcss-loader/lib/index.js??ref--2-rules-3!./TurnosSolicitudFilter.css", function() {
        content = require("!!../../../../node_modules/css-loader/index.js??ref--2-rules-2!../../../../node_modules/postcss-loader/lib/index.js??ref--2-rules-3!./TurnosSolicitudFilter.css");

        if (typeof content === 'string') {
          content = [[module.id, content, '']];
        }

        removeCss = insertCss(content, { replace: true });
      });
      module.hot.dispose(function() { removeCss(); });
    }
  

/***/ }),
/* 1251 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(888)(false);
// imports


// module
exports.push([module.i, "._1Wj_m{font-family:Roboto\\, Medium,sans-serif}._9r8Wu{font-family:Roboto\\, Light,sans-serif}._24L5V{width:100%;cursor:pointer;background-color:#e4002b}._2ED9o{margin-top:20px}._24L5V:disabled{background-color:#bcbcbd;border-color:#bcbcbd}._195YG:focus,select:focus{border-color:#e4002b!important}._24L5V:focus{-webkit-box-shadow:none;box-shadow:none}", ""]);

// exports
exports.locals = {
	"robotoMedium": "_1Wj_m",
	"robotoLight": "_9r8Wu",
	"input_button": "_24L5V",
	"divFilter": "_2ED9o",
	"input": "_195YG"
};

/***/ }),
/* 1252 */
/***/ (function(module, exports, __webpack_require__) {


    var content = __webpack_require__(1253);
    var insertCss = __webpack_require__(889);

    if (typeof content === 'string') {
      content = [[module.i, content, '']];
    }

    module.exports = content.locals || {};
    module.exports._getContent = function() { return content; };
    module.exports._getCss = function() { return content.toString(); };
    module.exports._insertCss = function(options) { return insertCss(content, options) };
    
    // Hot Module Replacement
    // https://webpack.github.io/docs/hot-module-replacement
    // Only activated in browser context
    if (false) {
      var removeCss = function() {};
      module.hot.accept("!!../../../../node_modules/css-loader/index.js??ref--2-rules-2!../../../../node_modules/postcss-loader/lib/index.js??ref--2-rules-3!./TurnosSolicitudAlert.css", function() {
        content = require("!!../../../../node_modules/css-loader/index.js??ref--2-rules-2!../../../../node_modules/postcss-loader/lib/index.js??ref--2-rules-3!./TurnosSolicitudAlert.css");

        if (typeof content === 'string') {
          content = [[module.id, content, '']];
        }

        removeCss = insertCss(content, { replace: true });
      });
      module.hot.dispose(function() { removeCss(); });
    }
  

/***/ }),
/* 1253 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(888)(false);
// imports


// module
exports.push([module.i, "._1AQML{border-color:#007a6e;background-color:#ebf6f5;-webkit-box-align:center;-ms-flex-align:center;align-items:center}._1AQML,._1AQML span{color:#1b5e20}._1AQML button{width:200px;background-color:#007a6e;border-color:#007a6e}._1AQML button:hover{width:200px;background-color:#005d54;border-color:#005d54;cursor:pointer}._1C4VS{color:#363636;background-color:#f3f3f3;border-color:#ef6d11;-webkit-box-align:center;-ms-flex-align:center;align-items:center}", ""]);

// exports
exports.locals = {
	"success": "_1AQML",
	"warning": "_1C4VS"
};

/***/ }),
/* 1254 */
/***/ (function(module, exports, __webpack_require__) {


    var content = __webpack_require__(1255);
    var insertCss = __webpack_require__(889);

    if (typeof content === 'string') {
      content = [[module.i, content, '']];
    }

    module.exports = content.locals || {};
    module.exports._getContent = function() { return content; };
    module.exports._getCss = function() { return content.toString(); };
    module.exports._insertCss = function(options) { return insertCss(content, options) };
    
    // Hot Module Replacement
    // https://webpack.github.io/docs/hot-module-replacement
    // Only activated in browser context
    if (false) {
      var removeCss = function() {};
      module.hot.accept("!!../../../../node_modules/css-loader/index.js??ref--2-rules-2!../../../../node_modules/postcss-loader/lib/index.js??ref--2-rules-3!./ModalErrorDocumento.css", function() {
        content = require("!!../../../../node_modules/css-loader/index.js??ref--2-rules-2!../../../../node_modules/postcss-loader/lib/index.js??ref--2-rules-3!./ModalErrorDocumento.css");

        if (typeof content === 'string') {
          content = [[module.id, content, '']];
        }

        removeCss = insertCss(content, { replace: true });
      });
      module.hot.dispose(function() { removeCss(); });
    }
  

/***/ }),
/* 1255 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(888)(false);
// imports


// module
exports.push([module.i, "._1GBD4{text-align:center;width:624px}._1mQt6{font-family:Roboto,sans-serif;margin-left:68px;margin-right:68px}._3IsFD{color:#fff;background-color:#e4002b;border-color:#e4002b;cursor:pointer;font-family:Roboto\\, Medium;width:140px}.z4zww{padding:15px 65px;display:block}.Y4H0M{text-transform:capitalize}", ""]);

// exports
exports.locals = {
	"modalContent": "_1GBD4",
	"modalBody": "_1mQt6",
	"boton_rojo": "_3IsFD",
	"modalFooter": "z4zww",
	"capitalize": "Y4H0M"
};

/***/ }),
/* 1256 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "58bb5742.png";

/***/ }),
/* 1257 */
/***/ (function(module, exports, __webpack_require__) {


    var content = __webpack_require__(1258);
    var insertCss = __webpack_require__(889);

    if (typeof content === 'string') {
      content = [[module.i, content, '']];
    }

    module.exports = content.locals || {};
    module.exports._getContent = function() { return content; };
    module.exports._getCss = function() { return content.toString(); };
    module.exports._insertCss = function(options) { return insertCss(content, options) };
    
    // Hot Module Replacement
    // https://webpack.github.io/docs/hot-module-replacement
    // Only activated in browser context
    if (false) {
      var removeCss = function() {};
      module.hot.accept("!!../../../../node_modules/css-loader/index.js??ref--2-rules-2!../../../../node_modules/postcss-loader/lib/index.js??ref--2-rules-3!./CardHeader.css", function() {
        content = require("!!../../../../node_modules/css-loader/index.js??ref--2-rules-2!../../../../node_modules/postcss-loader/lib/index.js??ref--2-rules-3!./CardHeader.css");

        if (typeof content === 'string') {
          content = [[module.id, content, '']];
        }

        removeCss = insertCss(content, { replace: true });
      });
      module.hot.dispose(function() { removeCss(); });
    }
  

/***/ }),
/* 1258 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(888)(false);
// imports


// module
exports.push([module.i, "._2CJpC{background-color:#fff;padding:12px 0;padding:.75rem 0;border-bottom:0}._2CJpC span{color:red}._2CJpC img{cursor:pointer}._2CJpC i{color:#e4002b;font-size:30px;margin:0 15px}._2CJpC h4{cursor:pointer;text-align:center}._2CJpC h4 img{margin-left:15px}._1N94f{background-color:#fafafa}", ""]);

// exports
exports.locals = {
	"header_card": "_2CJpC",
	"backColor": "_1N94f"
};

/***/ }),
/* 1259 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _inputRange = __webpack_require__(1260);

var _inputRange2 = _interopRequireDefault(_inputRange);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/**
 * @ignore
 * @typedef {Object} ClientRect
 * @property {number} height
 * @property {number} left
 * @property {number} top
 * @property {number} width
 */

/**
 * @typedef {Object} InputRangeClassNames
 * @property {string} activeTrack
 * @property {string} disabledInputRange
 * @property {string} inputRange
 * @property {string} labelContainer
 * @property {string} maxLabel
 * @property {string} minLabel
 * @property {string} slider
 * @property {string} sliderContainer
 * @property {string} track
 * @property {string} valueLabel
 */

/**
 * @typedef {Function} LabelFormatter
 * @param {number} value
 * @param {string} type
 * @return {string}
 */

/**
 * @ignore
 * @typedef {Object} Point
 * @property {number} x
 * @property {number} y
 */

/**
 * @typedef {Object} Range
 * @property {number} min - Min value
 * @property {number} max - Max value
 */

exports.default = _inputRange2.default;
module.exports = exports['default'];
//# sourceMappingURL=index.js.map

/***/ }),
/* 1260 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _desc, _value, _class;

var _react = __webpack_require__(71);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(1124);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _autobindDecorator = __webpack_require__(1142);

var _autobindDecorator2 = _interopRequireDefault(_autobindDecorator);

var _valueTransformer = __webpack_require__(1263);

var valueTransformer = _interopRequireWildcard(_valueTransformer);

var _defaultClassNames = __webpack_require__(1271);

var _defaultClassNames2 = _interopRequireDefault(_defaultClassNames);

var _label = __webpack_require__(1240);

var _label2 = _interopRequireDefault(_label);

var _rangePropType = __webpack_require__(1272);

var _rangePropType2 = _interopRequireDefault(_rangePropType);

var _valuePropType = __webpack_require__(1273);

var _valuePropType2 = _interopRequireDefault(_valuePropType);

var _slider = __webpack_require__(1274);

var _slider2 = _interopRequireDefault(_slider);

var _track = __webpack_require__(1275);

var _track2 = _interopRequireDefault(_track);

var _utils = __webpack_require__(1125);

var _keyCodes = __webpack_require__(1276);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

function _applyDecoratedDescriptor(target, property, decorators, descriptor, context) {
  var desc = {};
  Object['ke' + 'ys'](descriptor).forEach(function (key) {
    desc[key] = descriptor[key];
  });
  desc.enumerable = !!desc.enumerable;
  desc.configurable = !!desc.configurable;

  if ('value' in desc || desc.initializer) {
    desc.writable = true;
  }

  desc = decorators.slice().reverse().reduce(function (desc, decorator) {
    return decorator(target, property, desc) || desc;
  }, desc);

  if (context && desc.initializer !== void 0) {
    desc.value = desc.initializer ? desc.initializer.call(context) : void 0;
    desc.initializer = undefined;
  }

  if (desc.initializer === void 0) {
    Object['define' + 'Property'](target, property, desc);
    desc = null;
  }

  return desc;
}

/**
 * A React component that allows users to input numeric values within a range
 * by dragging its sliders.
 */
var InputRange = (_class = function (_React$Component) {
  _inherits(InputRange, _React$Component);

  _createClass(InputRange, null, [{
    key: 'propTypes',

    /**
     * @ignore
     * @override
     * @return {Object}
     */
    get: function get() {
      return {
        ariaLabelledby: _propTypes2.default.string,
        ariaControls: _propTypes2.default.string,
        classNames: _propTypes2.default.objectOf(_propTypes2.default.string),
        disabled: _propTypes2.default.bool,
        draggableTrack: _propTypes2.default.bool,
        formatLabel: _propTypes2.default.func,
        maxValue: _rangePropType2.default,
        minValue: _rangePropType2.default,
        name: _propTypes2.default.string,
        onChangeStart: _propTypes2.default.func,
        onChange: _propTypes2.default.func.isRequired,
        onChangeComplete: _propTypes2.default.func,
        step: _propTypes2.default.number,
        value: _valuePropType2.default
      };
    }

    /**
     * @ignore
     * @override
     * @return {Object}
     */

  }, {
    key: 'defaultProps',
    get: function get() {
      return {
        classNames: _defaultClassNames2.default,
        disabled: false,
        maxValue: 10,
        minValue: 0,
        step: 1
      };
    }

    /**
     * @param {Object} props
     * @param {string} [props.ariaLabelledby]
     * @param {string} [props.ariaControls]
     * @param {InputRangeClassNames} [props.classNames]
     * @param {boolean} [props.disabled = false]
     * @param {Function} [props.formatLabel]
     * @param {number|Range} [props.maxValue = 10]
     * @param {number|Range} [props.minValue = 0]
     * @param {string} [props.name]
     * @param {string} props.onChange
     * @param {Function} [props.onChangeComplete]
     * @param {Function} [props.onChangeStart]
     * @param {number} [props.step = 1]
     * @param {number|Range} props.value
     */

  }]);

  function InputRange(props) {
    _classCallCheck(this, InputRange);

    /**
     * @private
     * @type {?number}
     */
    var _this = _possibleConstructorReturn(this, (InputRange.__proto__ || Object.getPrototypeOf(InputRange)).call(this, props));

    _this.startValue = null;

    /**
     * @private
     * @type {?Component}
     */
    _this.node = null;

    /**
     * @private
     * @type {?Component}
     */
    _this.trackNode = null;

    /**
     * @private
     * @type {bool}
     */
    _this.isSliderDragging = false;
    return _this;
  }

  /**
   * @ignore
   * @override
   * @return {void}
   */


  _createClass(InputRange, [{
    key: 'componentWillUnmount',
    value: function componentWillUnmount() {
      this.removeDocumentMouseUpListener();
      this.removeDocumentTouchEndListener();
    }

    /**
     * Return the CSS class name of the component
     * @private
     * @return {string}
     */

  }, {
    key: 'getComponentClassName',
    value: function getComponentClassName() {
      if (!this.props.disabled) {
        return this.props.classNames.inputRange;
      }

      return this.props.classNames.disabledInputRange;
    }

    /**
     * Return the bounding rect of the track
     * @private
     * @return {ClientRect}
     */

  }, {
    key: 'getTrackClientRect',
    value: function getTrackClientRect() {
      return this.trackNode.getClientRect();
    }

    /**
     * Return the slider key closest to a point
     * @private
     * @param {Point} position
     * @return {string}
     */

  }, {
    key: 'getKeyByPosition',
    value: function getKeyByPosition(position) {
      var values = valueTransformer.getValueFromProps(this.props, this.isMultiValue());
      var positions = valueTransformer.getPositionsFromValues(values, this.props.minValue, this.props.maxValue, this.getTrackClientRect());

      if (this.isMultiValue()) {
        var distanceToMin = (0, _utils.distanceTo)(position, positions.min);
        var distanceToMax = (0, _utils.distanceTo)(position, positions.max);

        if (distanceToMin < distanceToMax) {
          return 'min';
        }
      }

      return 'max';
    }

    /**
     * Return all the slider keys
     * @private
     * @return {string[]}
     */

  }, {
    key: 'getKeys',
    value: function getKeys() {
      if (this.isMultiValue()) {
        return ['min', 'max'];
      }

      return ['max'];
    }

    /**
     * Return true if the difference between the new and the current value is
     * greater or equal to the step amount of the component
     * @private
     * @param {Range} values
     * @return {boolean}
     */

  }, {
    key: 'hasStepDifference',
    value: function hasStepDifference(values) {
      var currentValues = valueTransformer.getValueFromProps(this.props, this.isMultiValue());

      return (0, _utils.length)(values.min, currentValues.min) >= this.props.step || (0, _utils.length)(values.max, currentValues.max) >= this.props.step;
    }

    /**
     * Return true if the component accepts a min and max value
     * @private
     * @return {boolean}
     */

  }, {
    key: 'isMultiValue',
    value: function isMultiValue() {
      return (0, _utils.isObject)(this.props.value);
    }

    /**
     * Return true if the range is within the max and min value of the component
     * @private
     * @param {Range} values
     * @return {boolean}
     */

  }, {
    key: 'isWithinRange',
    value: function isWithinRange(values) {
      if (this.isMultiValue()) {
        return values.min >= this.props.minValue && values.max <= this.props.maxValue && values.min < values.max;
      }

      return values.max >= this.props.minValue && values.max <= this.props.maxValue;
    }

    /**
     * Return true if the new value should trigger a render
     * @private
     * @param {Range} values
     * @return {boolean}
     */

  }, {
    key: 'shouldUpdate',
    value: function shouldUpdate(values) {
      return this.isWithinRange(values) && this.hasStepDifference(values);
    }

    /**
     * Update the position of a slider
     * @private
     * @param {string} key
     * @param {Point} position
     * @return {void}
     */

  }, {
    key: 'updatePosition',
    value: function updatePosition(key, position) {
      var values = valueTransformer.getValueFromProps(this.props, this.isMultiValue());
      var positions = valueTransformer.getPositionsFromValues(values, this.props.minValue, this.props.maxValue, this.getTrackClientRect());

      positions[key] = position;

      this.updatePositions(positions);
    }

    /**
     * Update the positions of multiple sliders
     * @private
     * @param {Object} positions
     * @param {Point} positions.min
     * @param {Point} positions.max
     * @return {void}
     */

  }, {
    key: 'updatePositions',
    value: function updatePositions(positions) {
      var values = {
        min: valueTransformer.getValueFromPosition(positions.min, this.props.minValue, this.props.maxValue, this.getTrackClientRect()),
        max: valueTransformer.getValueFromPosition(positions.max, this.props.minValue, this.props.maxValue, this.getTrackClientRect())
      };

      var transformedValues = {
        min: valueTransformer.getStepValueFromValue(values.min, this.props.step),
        max: valueTransformer.getStepValueFromValue(values.max, this.props.step)
      };

      this.updateValues(transformedValues);
    }

    /**
     * Update the value of a slider
     * @private
     * @param {string} key
     * @param {number} value
     * @return {void}
     */

  }, {
    key: 'updateValue',
    value: function updateValue(key, value) {
      var values = valueTransformer.getValueFromProps(this.props, this.isMultiValue());

      values[key] = value;

      this.updateValues(values);
    }

    /**
     * Update the values of multiple sliders
     * @private
     * @param {Range|number} values
     * @return {void}
     */

  }, {
    key: 'updateValues',
    value: function updateValues(values) {
      if (!this.shouldUpdate(values)) {
        return;
      }

      this.props.onChange(this.isMultiValue() ? values : values.max);
    }

    /**
     * Increment the value of a slider by key name
     * @private
     * @param {string} key
     * @return {void}
     */

  }, {
    key: 'incrementValue',
    value: function incrementValue(key) {
      var values = valueTransformer.getValueFromProps(this.props, this.isMultiValue());
      var value = values[key] + this.props.step;

      this.updateValue(key, value);
    }

    /**
     * Decrement the value of a slider by key name
     * @private
     * @param {string} key
     * @return {void}
     */

  }, {
    key: 'decrementValue',
    value: function decrementValue(key) {
      var values = valueTransformer.getValueFromProps(this.props, this.isMultiValue());
      var value = values[key] - this.props.step;

      this.updateValue(key, value);
    }

    /**
     * Listen to mouseup event
     * @private
     * @return {void}
     */

  }, {
    key: 'addDocumentMouseUpListener',
    value: function addDocumentMouseUpListener() {
      this.removeDocumentMouseUpListener();
      this.node.ownerDocument.addEventListener('mouseup', this.handleMouseUp);
    }

    /**
     * Listen to touchend event
     * @private
     * @return {void}
     */

  }, {
    key: 'addDocumentTouchEndListener',
    value: function addDocumentTouchEndListener() {
      this.removeDocumentTouchEndListener();
      this.node.ownerDocument.addEventListener('touchend', this.handleTouchEnd);
    }

    /**
     * Stop listening to mouseup event
     * @private
     * @return {void}
     */

  }, {
    key: 'removeDocumentMouseUpListener',
    value: function removeDocumentMouseUpListener() {
      this.node.ownerDocument.removeEventListener('mouseup', this.handleMouseUp);
    }

    /**
     * Stop listening to touchend event
     * @private
     * @return {void}
     */

  }, {
    key: 'removeDocumentTouchEndListener',
    value: function removeDocumentTouchEndListener() {
      this.node.ownerDocument.removeEventListener('touchend', this.handleTouchEnd);
    }

    /**
     * Handle any "mousemove" event received by the slider
     * @private
     * @param {SyntheticEvent} event
     * @param {string} key
     * @return {void}
     */

  }, {
    key: 'handleSliderDrag',
    value: function handleSliderDrag(event, key) {
      var _this2 = this;

      if (this.props.disabled) {
        return;
      }

      var position = valueTransformer.getPositionFromEvent(event, this.getTrackClientRect());
      this.isSliderDragging = true;
      requestAnimationFrame(function () {
        return _this2.updatePosition(key, position);
      });
    }

    /**
     * Handle any "mousemove" event received by the track
     * @private
     * @param {SyntheticEvent} event
     * @return {void}
     */

  }, {
    key: 'handleTrackDrag',
    value: function handleTrackDrag(event, prevEvent) {
      if (this.props.disabled || !this.props.draggableTrack || this.isSliderDragging) {
        return;
      }

      var _props = this.props,
          maxValue = _props.maxValue,
          minValue = _props.minValue,
          _props$value = _props.value,
          max = _props$value.max,
          min = _props$value.min;


      var position = valueTransformer.getPositionFromEvent(event, this.getTrackClientRect());
      var value = valueTransformer.getValueFromPosition(position, minValue, maxValue, this.getTrackClientRect());
      var stepValue = valueTransformer.getStepValueFromValue(value, this.props.step);

      var prevPosition = valueTransformer.getPositionFromEvent(prevEvent, this.getTrackClientRect());
      var prevValue = valueTransformer.getValueFromPosition(prevPosition, minValue, maxValue, this.getTrackClientRect());
      var prevStepValue = valueTransformer.getStepValueFromValue(prevValue, this.props.step);

      var offset = prevStepValue - stepValue;

      var transformedValues = {
        min: min - offset,
        max: max - offset
      };

      this.updateValues(transformedValues);
    }

    /**
     * Handle any "keydown" event received by the slider
     * @private
     * @param {SyntheticEvent} event
     * @param {string} key
     * @return {void}
     */

  }, {
    key: 'handleSliderKeyDown',
    value: function handleSliderKeyDown(event, key) {
      if (this.props.disabled) {
        return;
      }

      switch (event.keyCode) {
        case _keyCodes.LEFT_ARROW:
        case _keyCodes.DOWN_ARROW:
          event.preventDefault();
          this.decrementValue(key);
          break;

        case _keyCodes.RIGHT_ARROW:
        case _keyCodes.UP_ARROW:
          event.preventDefault();
          this.incrementValue(key);
          break;

        default:
          break;
      }
    }

    /**
     * Handle any "mousedown" event received by the track
     * @private
     * @param {SyntheticEvent} event
     * @param {Point} position
     * @return {void}
     */

  }, {
    key: 'handleTrackMouseDown',
    value: function handleTrackMouseDown(event, position) {
      if (this.props.disabled) {
        return;
      }

      var _props2 = this.props,
          maxValue = _props2.maxValue,
          minValue = _props2.minValue,
          _props2$value = _props2.value,
          max = _props2$value.max,
          min = _props2$value.min;


      event.preventDefault();

      var value = valueTransformer.getValueFromPosition(position, minValue, maxValue, this.getTrackClientRect());
      var stepValue = valueTransformer.getStepValueFromValue(value, this.props.step);

      if (!this.props.draggableTrack || stepValue > max || stepValue < min) {
        this.updatePosition(this.getKeyByPosition(position), position);
      }
    }

    /**
     * Handle the start of any mouse/touch event
     * @private
     * @return {void}
     */

  }, {
    key: 'handleInteractionStart',
    value: function handleInteractionStart() {
      if (this.props.onChangeStart) {
        this.props.onChangeStart(this.props.value);
      }

      if (this.props.onChangeComplete && !(0, _utils.isDefined)(this.startValue)) {
        this.startValue = this.props.value;
      }
    }

    /**
     * Handle the end of any mouse/touch event
     * @private
     * @return {void}
     */

  }, {
    key: 'handleInteractionEnd',
    value: function handleInteractionEnd() {
      if (this.isSliderDragging) {
        this.isSliderDragging = false;
      }

      if (!this.props.onChangeComplete || !(0, _utils.isDefined)(this.startValue)) {
        return;
      }

      if (this.startValue !== this.props.value) {
        this.props.onChangeComplete(this.props.value);
      }

      this.startValue = null;
    }

    /**
     * Handle any "keydown" event received by the component
     * @private
     * @param {SyntheticEvent} event
     * @return {void}
     */

  }, {
    key: 'handleKeyDown',
    value: function handleKeyDown(event) {
      this.handleInteractionStart(event);
    }

    /**
     * Handle any "keyup" event received by the component
     * @private
     * @param {SyntheticEvent} event
     * @return {void}
     */

  }, {
    key: 'handleKeyUp',
    value: function handleKeyUp(event) {
      this.handleInteractionEnd(event);
    }

    /**
     * Handle any "mousedown" event received by the component
     * @private
     * @param {SyntheticEvent} event
     * @return {void}
     */

  }, {
    key: 'handleMouseDown',
    value: function handleMouseDown(event) {
      this.handleInteractionStart(event);
      this.addDocumentMouseUpListener();
    }

    /**
     * Handle any "mouseup" event received by the component
     * @private
     * @param {SyntheticEvent} event
     */

  }, {
    key: 'handleMouseUp',
    value: function handleMouseUp(event) {
      this.handleInteractionEnd(event);
      this.removeDocumentMouseUpListener();
    }

    /**
     * Handle any "touchstart" event received by the component
     * @private
     * @param {SyntheticEvent} event
     * @return {void}
     */

  }, {
    key: 'handleTouchStart',
    value: function handleTouchStart(event) {
      this.handleInteractionStart(event);
      this.addDocumentTouchEndListener();
    }

    /**
     * Handle any "touchend" event received by the component
     * @private
     * @param {SyntheticEvent} event
     */

  }, {
    key: 'handleTouchEnd',
    value: function handleTouchEnd(event) {
      this.handleInteractionEnd(event);
      this.removeDocumentTouchEndListener();
    }

    /**
     * Return JSX of sliders
     * @private
     * @return {JSX.Element}
     */

  }, {
    key: 'renderSliders',
    value: function renderSliders() {
      var _this3 = this;

      var values = valueTransformer.getValueFromProps(this.props, this.isMultiValue());
      var percentages = valueTransformer.getPercentagesFromValues(values, this.props.minValue, this.props.maxValue);

      return this.getKeys().map(function (key) {
        var value = values[key];
        var percentage = percentages[key];

        var _props3 = _this3.props,
            maxValue = _props3.maxValue,
            minValue = _props3.minValue;


        if (key === 'min') {
          maxValue = values.max;
        } else {
          minValue = values.min;
        }

        var slider = _react2.default.createElement(_slider2.default, {
          ariaLabelledby: _this3.props.ariaLabelledby,
          ariaControls: _this3.props.ariaControls,
          classNames: _this3.props.classNames,
          formatLabel: _this3.props.formatLabel,
          key: key,
          maxValue: maxValue,
          minValue: minValue,
          onSliderDrag: _this3.handleSliderDrag,
          onSliderKeyDown: _this3.handleSliderKeyDown,
          percentage: percentage,
          type: key,
          value: value });

        return slider;
      });
    }

    /**
     * Return JSX of hidden inputs
     * @private
     * @return {JSX.Element}
     */

  }, {
    key: 'renderHiddenInputs',
    value: function renderHiddenInputs() {
      var _this4 = this;

      if (!this.props.name) {
        return [];
      }

      var isMultiValue = this.isMultiValue();
      var values = valueTransformer.getValueFromProps(this.props, isMultiValue);

      return this.getKeys().map(function (key) {
        var value = values[key];
        var name = isMultiValue ? '' + _this4.props.name + (0, _utils.captialize)(key) : _this4.props.name;

        return _react2.default.createElement('input', { key: key, type: 'hidden', name: name, value: value });
      });
    }

    /**
     * @ignore
     * @override
     * @return {JSX.Element}
     */

  }, {
    key: 'render',
    value: function render() {
      var _this5 = this;

      var componentClassName = this.getComponentClassName();
      var values = valueTransformer.getValueFromProps(this.props, this.isMultiValue());
      var percentages = valueTransformer.getPercentagesFromValues(values, this.props.minValue, this.props.maxValue);

      return _react2.default.createElement(
        'div',
        {
          'aria-disabled': this.props.disabled,
          ref: function ref(node) {
            _this5.node = node;
          },
          className: componentClassName,
          onKeyDown: this.handleKeyDown,
          onKeyUp: this.handleKeyUp,
          onMouseDown: this.handleMouseDown,
          onTouchStart: this.handleTouchStart },
        _react2.default.createElement(
          _label2.default,
          {
            classNames: this.props.classNames,
            formatLabel: this.props.formatLabel,
            type: 'min' },
          this.props.minValue
        ),
        _react2.default.createElement(
          _track2.default,
          {
            classNames: this.props.classNames,
            draggableTrack: this.props.draggableTrack,
            ref: function ref(trackNode) {
              _this5.trackNode = trackNode;
            },
            percentages: percentages,
            onTrackDrag: this.handleTrackDrag,
            onTrackMouseDown: this.handleTrackMouseDown },
          this.renderSliders()
        ),
        _react2.default.createElement(
          _label2.default,
          {
            classNames: this.props.classNames,
            formatLabel: this.props.formatLabel,
            type: 'max' },
          this.props.maxValue
        ),
        this.renderHiddenInputs()
      );
    }
  }]);

  return InputRange;
}(_react2.default.Component), (_applyDecoratedDescriptor(_class.prototype, 'handleSliderDrag', [_autobindDecorator2.default], Object.getOwnPropertyDescriptor(_class.prototype, 'handleSliderDrag'), _class.prototype), _applyDecoratedDescriptor(_class.prototype, 'handleTrackDrag', [_autobindDecorator2.default], Object.getOwnPropertyDescriptor(_class.prototype, 'handleTrackDrag'), _class.prototype), _applyDecoratedDescriptor(_class.prototype, 'handleSliderKeyDown', [_autobindDecorator2.default], Object.getOwnPropertyDescriptor(_class.prototype, 'handleSliderKeyDown'), _class.prototype), _applyDecoratedDescriptor(_class.prototype, 'handleTrackMouseDown', [_autobindDecorator2.default], Object.getOwnPropertyDescriptor(_class.prototype, 'handleTrackMouseDown'), _class.prototype), _applyDecoratedDescriptor(_class.prototype, 'handleInteractionStart', [_autobindDecorator2.default], Object.getOwnPropertyDescriptor(_class.prototype, 'handleInteractionStart'), _class.prototype), _applyDecoratedDescriptor(_class.prototype, 'handleInteractionEnd', [_autobindDecorator2.default], Object.getOwnPropertyDescriptor(_class.prototype, 'handleInteractionEnd'), _class.prototype), _applyDecoratedDescriptor(_class.prototype, 'handleKeyDown', [_autobindDecorator2.default], Object.getOwnPropertyDescriptor(_class.prototype, 'handleKeyDown'), _class.prototype), _applyDecoratedDescriptor(_class.prototype, 'handleKeyUp', [_autobindDecorator2.default], Object.getOwnPropertyDescriptor(_class.prototype, 'handleKeyUp'), _class.prototype), _applyDecoratedDescriptor(_class.prototype, 'handleMouseDown', [_autobindDecorator2.default], Object.getOwnPropertyDescriptor(_class.prototype, 'handleMouseDown'), _class.prototype), _applyDecoratedDescriptor(_class.prototype, 'handleMouseUp', [_autobindDecorator2.default], Object.getOwnPropertyDescriptor(_class.prototype, 'handleMouseUp'), _class.prototype), _applyDecoratedDescriptor(_class.prototype, 'handleTouchStart', [_autobindDecorator2.default], Object.getOwnPropertyDescriptor(_class.prototype, 'handleTouchStart'), _class.prototype), _applyDecoratedDescriptor(_class.prototype, 'handleTouchEnd', [_autobindDecorator2.default], Object.getOwnPropertyDescriptor(_class.prototype, 'handleTouchEnd'), _class.prototype)), _class);
exports.default = InputRange;
module.exports = exports['default'];
//# sourceMappingURL=input-range.js.map

/***/ }),
/* 1261 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 */



var emptyFunction = __webpack_require__(418);
var invariant = __webpack_require__(417);
var ReactPropTypesSecret = __webpack_require__(1262);

module.exports = function() {
  function shim(props, propName, componentName, location, propFullName, secret) {
    if (secret === ReactPropTypesSecret) {
      // It is still safe when called from React.
      return;
    }
    invariant(
      false,
      'Calling PropTypes validators directly is not supported by the `prop-types` package. ' +
      'Use PropTypes.checkPropTypes() to call them. ' +
      'Read more at http://fb.me/use-check-prop-types'
    );
  };
  shim.isRequired = shim;
  function getShim() {
    return shim;
  };
  // Important!
  // Keep this list in sync with production version in `./factoryWithTypeCheckers.js`.
  var ReactPropTypes = {
    array: shim,
    bool: shim,
    func: shim,
    number: shim,
    object: shim,
    string: shim,
    symbol: shim,

    any: shim,
    arrayOf: getShim,
    element: shim,
    instanceOf: getShim,
    node: shim,
    objectOf: getShim,
    oneOf: getShim,
    oneOfType: getShim,
    shape: getShim
  };

  ReactPropTypes.checkPropTypes = emptyFunction;
  ReactPropTypes.PropTypes = ReactPropTypes;

  return ReactPropTypes;
};


/***/ }),
/* 1262 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 */



var ReactPropTypesSecret = 'SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED';

module.exports = ReactPropTypesSecret;


/***/ }),
/* 1263 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

exports.getPercentageFromPosition = getPercentageFromPosition;
exports.getValueFromPosition = getValueFromPosition;
exports.getValueFromProps = getValueFromProps;
exports.getPercentageFromValue = getPercentageFromValue;
exports.getPercentagesFromValues = getPercentagesFromValues;
exports.getPositionFromValue = getPositionFromValue;
exports.getPositionsFromValues = getPositionsFromValues;
exports.getPositionFromEvent = getPositionFromEvent;
exports.getStepValueFromValue = getStepValueFromValue;

var _utils = __webpack_require__(1125);

/**
 * Convert a point into a percentage value
 * @ignore
 * @param {Point} position
 * @param {ClientRect} clientRect
 * @return {number} Percentage value
 */
function getPercentageFromPosition(position, clientRect) {
  var length = clientRect.width;
  var sizePerc = position.x / length;

  return sizePerc || 0;
}

/**
 * Convert a point into a model value
 * @ignore
 * @param {Point} position
 * @param {number} minValue
 * @param {number} maxValue
 * @param {ClientRect} clientRect
 * @return {number}
 */
function getValueFromPosition(position, minValue, maxValue, clientRect) {
  var sizePerc = getPercentageFromPosition(position, clientRect);
  var valueDiff = maxValue - minValue;

  return minValue + valueDiff * sizePerc;
}

/**
 * Convert props into a range value
 * @ignore
 * @param {Object} props
 * @param {boolean} isMultiValue
 * @return {Range}
 */
function getValueFromProps(props, isMultiValue) {
  if (isMultiValue) {
    return _extends({}, props.value);
  }

  return {
    min: props.minValue,
    max: props.value
  };
}

/**
 * Convert a model value into a percentage value
 * @ignore
 * @param {number} value
 * @param {number} minValue
 * @param {number} maxValue
 * @return {number}
 */
function getPercentageFromValue(value, minValue, maxValue) {
  var validValue = (0, _utils.clamp)(value, minValue, maxValue);
  var valueDiff = maxValue - minValue;
  var valuePerc = (validValue - minValue) / valueDiff;

  return valuePerc || 0;
}

/**
 * Convert model values into percentage values
 * @ignore
 * @param {Range} values
 * @param {number} minValue
 * @param {number} maxValue
 * @return {Range}
 */
function getPercentagesFromValues(values, minValue, maxValue) {
  return {
    min: getPercentageFromValue(values.min, minValue, maxValue),
    max: getPercentageFromValue(values.max, minValue, maxValue)
  };
}

/**
 * Convert a value into a point
 * @ignore
 * @param {number} value
 * @param {number} minValue
 * @param {number} maxValue
 * @param {ClientRect} clientRect
 * @return {Point} Position
 */
function getPositionFromValue(value, minValue, maxValue, clientRect) {
  var length = clientRect.width;
  var valuePerc = getPercentageFromValue(value, minValue, maxValue);
  var positionValue = valuePerc * length;

  return {
    x: positionValue,
    y: 0
  };
}

/**
 * Convert a range of values into points
 * @ignore
 * @param {Range} values
 * @param {number} minValue
 * @param {number} maxValue
 * @param {ClientRect} clientRect
 * @return {Range}
 */
function getPositionsFromValues(values, minValue, maxValue, clientRect) {
  return {
    min: getPositionFromValue(values.min, minValue, maxValue, clientRect),
    max: getPositionFromValue(values.max, minValue, maxValue, clientRect)
  };
}

/**
 * Convert an event into a point
 * @ignore
 * @param {Event} event
 * @param {ClientRect} clientRect
 * @return {Point}
 */
function getPositionFromEvent(event, clientRect) {
  var length = clientRect.width;

  var _ref = event.touches ? event.touches[0] : event,
      clientX = _ref.clientX;

  return {
    x: (0, _utils.clamp)(clientX - clientRect.left, 0, length),
    y: 0
  };
}

/**
 * Convert a value into a step value
 * @ignore
 * @param {number} value
 * @param {number} valuePerStep
 * @return {number}
 */
function getStepValueFromValue(value, valuePerStep) {
  return Math.round(value / valuePerStep) * valuePerStep;
}
//# sourceMappingURL=value-transformer.js.map

/***/ }),
/* 1264 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = captialize;
/**
 * Captialize a string
 * @ignore
 * @param {string} string
 * @return {string}
 */
function captialize(string) {
  return string.charAt(0).toUpperCase() + string.slice(1);
}
module.exports = exports["default"];
//# sourceMappingURL=captialize.js.map

/***/ }),
/* 1265 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = clamp;
/**
 * Clamp a value between a min and max value
 * @ignore
 * @param {number} value
 * @param {number} min
 * @param {number} max
 * @return {number}
 */
function clamp(value, min, max) {
  return Math.min(Math.max(value, min), max);
}
module.exports = exports["default"];
//# sourceMappingURL=clamp.js.map

/***/ }),
/* 1266 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = distanceTo;
/**
 * Calculate the distance between pointA and pointB
 * @ignore
 * @param {Point} pointA
 * @param {Point} pointB
 * @return {number} Distance
 */
function distanceTo(pointA, pointB) {
  var xDiff = Math.pow(pointB.x - pointA.x, 2);
  var yDiff = Math.pow(pointB.y - pointA.y, 2);

  return Math.sqrt(xDiff + yDiff);
}
module.exports = exports["default"];
//# sourceMappingURL=distance-to.js.map

/***/ }),
/* 1267 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = isDefined;
/**
 * Check if a value is defined
 * @ignore
 * @param {*} value
 * @return {boolean}
 */
function isDefined(value) {
  return value !== undefined && value !== null;
}
module.exports = exports["default"];
//# sourceMappingURL=is-defined.js.map

/***/ }),
/* 1268 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = isNumber;
/**
 * Check if a value is a number
 * @ignore
 * @param {*} value
 * @return {boolean}
 */
function isNumber(value) {
  return typeof value === 'number';
}
module.exports = exports['default'];
//# sourceMappingURL=is-number.js.map

/***/ }),
/* 1269 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

exports.default = isObject;
/**
 * Check if a value is an object
 * @ignore
 * @param {*} value
 * @return {boolean}
 */
function isObject(value) {
  return value !== null && (typeof value === 'undefined' ? 'undefined' : _typeof(value)) === 'object';
}
module.exports = exports['default'];
//# sourceMappingURL=is-object.js.map

/***/ }),
/* 1270 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = length;
/**
 * Calculate the absolute difference between two numbers
 * @ignore
 * @param {number} numA
 * @param {number} numB
 * @return {number}
 */
function length(numA, numB) {
  return Math.abs(numA - numB);
}
module.exports = exports["default"];
//# sourceMappingURL=length.js.map

/***/ }),
/* 1271 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
/**
 * Default CSS class names
 * @ignore
 * @type {InputRangeClassNames}
 */
var DEFAULT_CLASS_NAMES = {
  activeTrack: 'input-range__track input-range__track--active',
  disabledInputRange: 'input-range input-range--disabled',
  inputRange: 'input-range',
  labelContainer: 'input-range__label-container',
  maxLabel: 'input-range__label input-range__label--max',
  minLabel: 'input-range__label input-range__label--min',
  slider: 'input-range__slider',
  sliderContainer: 'input-range__slider-container',
  track: 'input-range__track input-range__track--background',
  valueLabel: 'input-range__label input-range__label--value'
};

exports.default = DEFAULT_CLASS_NAMES;
module.exports = exports['default'];
//# sourceMappingURL=default-class-names.js.map

/***/ }),
/* 1272 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = rangePropType;

var _utils = __webpack_require__(1125);

/**
 * @ignore
 * @param {Object} props - React component props
 * @return {?Error} Return Error if validation fails
 */
function rangePropType(props) {
  var maxValue = props.maxValue,
      minValue = props.minValue;


  if (!(0, _utils.isNumber)(minValue) || !(0, _utils.isNumber)(maxValue)) {
    return new Error('"minValue" and "maxValue" must be a number');
  }

  if (minValue >= maxValue) {
    return new Error('"minValue" must be smaller than "maxValue"');
  }
}
module.exports = exports['default'];
//# sourceMappingURL=range-prop-type.js.map

/***/ }),
/* 1273 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = valuePropType;

var _utils = __webpack_require__(1125);

/**
 * @ignore
 * @param {Object} props
 * @return {?Error} Return Error if validation fails
 */
function valuePropType(props, propName) {
  var maxValue = props.maxValue,
      minValue = props.minValue;

  var value = props[propName];

  if (!(0, _utils.isNumber)(value) && (!(0, _utils.isObject)(value) || !(0, _utils.isNumber)(value.min) || !(0, _utils.isNumber)(value.max))) {
    return new Error('"' + propName + '" must be a number or a range object');
  }

  if ((0, _utils.isNumber)(value) && (value < minValue || value > maxValue)) {
    return new Error('"' + propName + '" must be in between "minValue" and "maxValue"');
  }

  if ((0, _utils.isObject)(value) && (value.min < minValue || value.min > maxValue || value.max < minValue || value.max > maxValue)) {
    return new Error('"' + propName + '" must be in between "minValue" and "maxValue"');
  }
}
module.exports = exports['default'];
//# sourceMappingURL=value-prop-type.js.map

/***/ }),
/* 1274 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _desc, _value, _class;

var _react = __webpack_require__(71);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(1124);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _autobindDecorator = __webpack_require__(1142);

var _autobindDecorator2 = _interopRequireDefault(_autobindDecorator);

var _label = __webpack_require__(1240);

var _label2 = _interopRequireDefault(_label);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

function _applyDecoratedDescriptor(target, property, decorators, descriptor, context) {
  var desc = {};
  Object['ke' + 'ys'](descriptor).forEach(function (key) {
    desc[key] = descriptor[key];
  });
  desc.enumerable = !!desc.enumerable;
  desc.configurable = !!desc.configurable;

  if ('value' in desc || desc.initializer) {
    desc.writable = true;
  }

  desc = decorators.slice().reverse().reduce(function (desc, decorator) {
    return decorator(target, property, desc) || desc;
  }, desc);

  if (context && desc.initializer !== void 0) {
    desc.value = desc.initializer ? desc.initializer.call(context) : void 0;
    desc.initializer = undefined;
  }

  if (desc.initializer === void 0) {
    Object['define' + 'Property'](target, property, desc);
    desc = null;
  }

  return desc;
}

/**
 * @ignore
 */
var Slider = (_class = function (_React$Component) {
  _inherits(Slider, _React$Component);

  _createClass(Slider, null, [{
    key: 'propTypes',

    /**
     * Accepted propTypes of Slider
     * @override
     * @return {Object}
     * @property {Function} ariaLabelledby
     * @property {Function} ariaControls
     * @property {Function} className
     * @property {Function} formatLabel
     * @property {Function} maxValue
     * @property {Function} minValue
     * @property {Function} onSliderDrag
     * @property {Function} onSliderKeyDown
     * @property {Function} percentage
     * @property {Function} type
     * @property {Function} value
     */
    get: function get() {
      return {
        ariaLabelledby: _propTypes2.default.string,
        ariaControls: _propTypes2.default.string,
        classNames: _propTypes2.default.objectOf(_propTypes2.default.string).isRequired,
        formatLabel: _propTypes2.default.func,
        maxValue: _propTypes2.default.number,
        minValue: _propTypes2.default.number,
        onSliderDrag: _propTypes2.default.func.isRequired,
        onSliderKeyDown: _propTypes2.default.func.isRequired,
        percentage: _propTypes2.default.number.isRequired,
        type: _propTypes2.default.string.isRequired,
        value: _propTypes2.default.number.isRequired
      };
    }

    /**
     * @param {Object} props
     * @param {string} [props.ariaLabelledby]
     * @param {string} [props.ariaControls]
     * @param {InputRangeClassNames} props.classNames
     * @param {Function} [props.formatLabel]
     * @param {number} [props.maxValue]
     * @param {number} [props.minValue]
     * @param {Function} props.onSliderKeyDown
     * @param {Function} props.onSliderDrag
     * @param {number} props.percentage
     * @param {number} props.type
     * @param {number} props.value
     */

  }]);

  function Slider(props) {
    _classCallCheck(this, Slider);

    /**
     * @private
     * @type {?Component}
     */
    var _this = _possibleConstructorReturn(this, (Slider.__proto__ || Object.getPrototypeOf(Slider)).call(this, props));

    _this.node = null;
    return _this;
  }

  /**
   * @ignore
   * @override
   * @return {void}
   */


  _createClass(Slider, [{
    key: 'componentWillUnmount',
    value: function componentWillUnmount() {
      this.removeDocumentMouseMoveListener();
      this.removeDocumentMouseUpListener();
      this.removeDocumentTouchEndListener();
      this.removeDocumentTouchMoveListener();
    }

    /**
     * @private
     * @return {Object}
     */

  }, {
    key: 'getStyle',
    value: function getStyle() {
      var perc = (this.props.percentage || 0) * 100;
      var style = {
        position: 'absolute',
        left: perc + '%'
      };

      return style;
    }

    /**
     * Listen to mousemove event
     * @private
     * @return {void}
     */

  }, {
    key: 'addDocumentMouseMoveListener',
    value: function addDocumentMouseMoveListener() {
      this.removeDocumentMouseMoveListener();
      this.node.ownerDocument.addEventListener('mousemove', this.handleMouseMove);
    }

    /**
     * Listen to mouseup event
     * @private
     * @return {void}
     */

  }, {
    key: 'addDocumentMouseUpListener',
    value: function addDocumentMouseUpListener() {
      this.removeDocumentMouseUpListener();
      this.node.ownerDocument.addEventListener('mouseup', this.handleMouseUp);
    }

    /**
     * Listen to touchmove event
     * @private
     * @return {void}
     */

  }, {
    key: 'addDocumentTouchMoveListener',
    value: function addDocumentTouchMoveListener() {
      this.removeDocumentTouchMoveListener();
      this.node.ownerDocument.addEventListener('touchmove', this.handleTouchMove);
    }

    /**
     * Listen to touchend event
     * @private
     * @return {void}
     */

  }, {
    key: 'addDocumentTouchEndListener',
    value: function addDocumentTouchEndListener() {
      this.removeDocumentTouchEndListener();
      this.node.ownerDocument.addEventListener('touchend', this.handleTouchEnd);
    }

    /**
     * @private
     * @return {void}
     */

  }, {
    key: 'removeDocumentMouseMoveListener',
    value: function removeDocumentMouseMoveListener() {
      this.node.ownerDocument.removeEventListener('mousemove', this.handleMouseMove);
    }

    /**
     * @private
     * @return {void}
     */

  }, {
    key: 'removeDocumentMouseUpListener',
    value: function removeDocumentMouseUpListener() {
      this.node.ownerDocument.removeEventListener('mouseup', this.handleMouseUp);
    }

    /**
     * @private
     * @return {void}
     */

  }, {
    key: 'removeDocumentTouchMoveListener',
    value: function removeDocumentTouchMoveListener() {
      this.node.ownerDocument.removeEventListener('touchmove', this.handleTouchMove);
    }

    /**
     * @private
     * @return {void}
     */

  }, {
    key: 'removeDocumentTouchEndListener',
    value: function removeDocumentTouchEndListener() {
      this.node.ownerDocument.removeEventListener('touchend', this.handleTouchEnd);
    }

    /**
     * @private
     * @return {void}
     */

  }, {
    key: 'handleMouseDown',
    value: function handleMouseDown() {
      this.addDocumentMouseMoveListener();
      this.addDocumentMouseUpListener();
    }

    /**
     * @private
     * @return {void}
     */

  }, {
    key: 'handleMouseUp',
    value: function handleMouseUp() {
      this.removeDocumentMouseMoveListener();
      this.removeDocumentMouseUpListener();
    }

    /**
     * @private
     * @param {SyntheticEvent} event
     * @return {void}
     */

  }, {
    key: 'handleMouseMove',
    value: function handleMouseMove(event) {
      this.props.onSliderDrag(event, this.props.type);
    }

    /**
     * @private
     * @return {void}
     */

  }, {
    key: 'handleTouchStart',
    value: function handleTouchStart() {
      this.addDocumentTouchEndListener();
      this.addDocumentTouchMoveListener();
    }

    /**
     * @private
     * @param {SyntheticEvent} event
     * @return {void}
     */

  }, {
    key: 'handleTouchMove',
    value: function handleTouchMove(event) {
      this.props.onSliderDrag(event, this.props.type);
    }

    /**
     * @private
     * @return {void}
     */

  }, {
    key: 'handleTouchEnd',
    value: function handleTouchEnd() {
      this.removeDocumentTouchMoveListener();
      this.removeDocumentTouchEndListener();
    }

    /**
     * @private
     * @param {SyntheticEvent} event
     * @return {void}
     */

  }, {
    key: 'handleKeyDown',
    value: function handleKeyDown(event) {
      this.props.onSliderKeyDown(event, this.props.type);
    }

    /**
     * @override
     * @return {JSX.Element}
     */

  }, {
    key: 'render',
    value: function render() {
      var _this2 = this;

      var style = this.getStyle();

      return _react2.default.createElement(
        'span',
        {
          className: this.props.classNames.sliderContainer,
          ref: function ref(node) {
            _this2.node = node;
          },
          style: style },
        _react2.default.createElement(
          _label2.default,
          {
            classNames: this.props.classNames,
            formatLabel: this.props.formatLabel,
            type: 'value' },
          this.props.value
        ),
        _react2.default.createElement('div', {
          'aria-labelledby': this.props.ariaLabelledby,
          'aria-controls': this.props.ariaControls,
          'aria-valuemax': this.props.maxValue,
          'aria-valuemin': this.props.minValue,
          'aria-valuenow': this.props.value,
          className: this.props.classNames.slider,
          draggable: 'false',
          onKeyDown: this.handleKeyDown,
          onMouseDown: this.handleMouseDown,
          onTouchStart: this.handleTouchStart,
          role: 'slider',
          tabIndex: '0' })
      );
    }
  }]);

  return Slider;
}(_react2.default.Component), (_applyDecoratedDescriptor(_class.prototype, 'handleMouseDown', [_autobindDecorator2.default], Object.getOwnPropertyDescriptor(_class.prototype, 'handleMouseDown'), _class.prototype), _applyDecoratedDescriptor(_class.prototype, 'handleMouseUp', [_autobindDecorator2.default], Object.getOwnPropertyDescriptor(_class.prototype, 'handleMouseUp'), _class.prototype), _applyDecoratedDescriptor(_class.prototype, 'handleMouseMove', [_autobindDecorator2.default], Object.getOwnPropertyDescriptor(_class.prototype, 'handleMouseMove'), _class.prototype), _applyDecoratedDescriptor(_class.prototype, 'handleTouchStart', [_autobindDecorator2.default], Object.getOwnPropertyDescriptor(_class.prototype, 'handleTouchStart'), _class.prototype), _applyDecoratedDescriptor(_class.prototype, 'handleTouchMove', [_autobindDecorator2.default], Object.getOwnPropertyDescriptor(_class.prototype, 'handleTouchMove'), _class.prototype), _applyDecoratedDescriptor(_class.prototype, 'handleTouchEnd', [_autobindDecorator2.default], Object.getOwnPropertyDescriptor(_class.prototype, 'handleTouchEnd'), _class.prototype), _applyDecoratedDescriptor(_class.prototype, 'handleKeyDown', [_autobindDecorator2.default], Object.getOwnPropertyDescriptor(_class.prototype, 'handleKeyDown'), _class.prototype)), _class);
exports.default = Slider;
module.exports = exports['default'];
//# sourceMappingURL=slider.js.map

/***/ }),
/* 1275 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _desc, _value, _class;

var _react = __webpack_require__(71);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(1124);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _autobindDecorator = __webpack_require__(1142);

var _autobindDecorator2 = _interopRequireDefault(_autobindDecorator);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

function _applyDecoratedDescriptor(target, property, decorators, descriptor, context) {
  var desc = {};
  Object['ke' + 'ys'](descriptor).forEach(function (key) {
    desc[key] = descriptor[key];
  });
  desc.enumerable = !!desc.enumerable;
  desc.configurable = !!desc.configurable;

  if ('value' in desc || desc.initializer) {
    desc.writable = true;
  }

  desc = decorators.slice().reverse().reduce(function (desc, decorator) {
    return decorator(target, property, desc) || desc;
  }, desc);

  if (context && desc.initializer !== void 0) {
    desc.value = desc.initializer ? desc.initializer.call(context) : void 0;
    desc.initializer = undefined;
  }

  if (desc.initializer === void 0) {
    Object['define' + 'Property'](target, property, desc);
    desc = null;
  }

  return desc;
}

/**
 * @ignore
 */
var Track = (_class = function (_React$Component) {
  _inherits(Track, _React$Component);

  _createClass(Track, null, [{
    key: 'propTypes',

    /**
     * @override
     * @return {Object}
     * @property {Function} children
     * @property {Function} classNames
     * @property {Boolean} draggableTrack
     * @property {Function} onTrackDrag
     * @property {Function} onTrackMouseDown
     * @property {Function} percentages
     */
    get: function get() {
      return {
        children: _propTypes2.default.node.isRequired,
        classNames: _propTypes2.default.objectOf(_propTypes2.default.string).isRequired,
        draggableTrack: _propTypes2.default.bool,
        onTrackDrag: _propTypes2.default.func,
        onTrackMouseDown: _propTypes2.default.func.isRequired,
        percentages: _propTypes2.default.objectOf(_propTypes2.default.number).isRequired
      };
    }

    /**
     * @param {Object} props
     * @param {InputRangeClassNames} props.classNames
     * @param {Boolean} props.draggableTrack
     * @param {Function} props.onTrackDrag
     * @param {Function} props.onTrackMouseDown
     * @param {number} props.percentages
     */

  }]);

  function Track(props) {
    _classCallCheck(this, Track);

    /**
     * @private
     * @type {?Component}
     */
    var _this = _possibleConstructorReturn(this, (Track.__proto__ || Object.getPrototypeOf(Track)).call(this, props));

    _this.node = null;
    _this.trackDragEvent = null;
    return _this;
  }

  /**
   * @private
   * @return {ClientRect}
   */


  _createClass(Track, [{
    key: 'getClientRect',
    value: function getClientRect() {
      return this.node.getBoundingClientRect();
    }

    /**
     * @private
     * @return {Object} CSS styles
     */

  }, {
    key: 'getActiveTrackStyle',
    value: function getActiveTrackStyle() {
      var width = (this.props.percentages.max - this.props.percentages.min) * 100 + '%';
      var left = this.props.percentages.min * 100 + '%';

      return { left: left, width: width };
    }

    /**
     * Listen to mousemove event
     * @private
     * @return {void}
     */

  }, {
    key: 'addDocumentMouseMoveListener',
    value: function addDocumentMouseMoveListener() {
      this.removeDocumentMouseMoveListener();
      this.node.ownerDocument.addEventListener('mousemove', this.handleMouseMove);
    }

    /**
     * Listen to mouseup event
     * @private
     * @return {void}
     */

  }, {
    key: 'addDocumentMouseUpListener',
    value: function addDocumentMouseUpListener() {
      this.removeDocumentMouseUpListener();
      this.node.ownerDocument.addEventListener('mouseup', this.handleMouseUp);
    }

    /**
     * @private
     * @return {void}
     */

  }, {
    key: 'removeDocumentMouseMoveListener',
    value: function removeDocumentMouseMoveListener() {
      this.node.ownerDocument.removeEventListener('mousemove', this.handleMouseMove);
    }

    /**
     * @private
     * @return {void}
     */

  }, {
    key: 'removeDocumentMouseUpListener',
    value: function removeDocumentMouseUpListener() {
      this.node.ownerDocument.removeEventListener('mouseup', this.handleMouseUp);
    }

    /**
     * @private
     * @param {SyntheticEvent} event
     * @return {void}
     */

  }, {
    key: 'handleMouseMove',
    value: function handleMouseMove(event) {
      if (!this.props.draggableTrack) {
        return;
      }

      if (this.trackDragEvent !== null) {
        this.props.onTrackDrag(event, this.trackDragEvent);
      }

      this.trackDragEvent = event;
    }

    /**
     * @private
     * @return {void}
     */

  }, {
    key: 'handleMouseUp',
    value: function handleMouseUp() {
      if (!this.props.draggableTrack) {
        return;
      }

      this.removeDocumentMouseMoveListener();
      this.removeDocumentMouseUpListener();
      this.trackDragEvent = null;
    }

    /**
     * @private
     * @param {SyntheticEvent} event - User event
     */

  }, {
    key: 'handleMouseDown',
    value: function handleMouseDown(event) {
      var clientX = event.touches ? event.touches[0].clientX : event.clientX;
      var trackClientRect = this.getClientRect();
      var position = {
        x: clientX - trackClientRect.left,
        y: 0
      };

      this.props.onTrackMouseDown(event, position);

      if (this.props.draggableTrack) {
        this.addDocumentMouseMoveListener();
        this.addDocumentMouseUpListener();
      }
    }

    /**
     * @private
     * @param {SyntheticEvent} event - User event
     */

  }, {
    key: 'handleTouchStart',
    value: function handleTouchStart(event) {
      event.preventDefault();

      this.handleMouseDown(event);
    }

    /**
     * @override
     * @return {JSX.Element}
     */

  }, {
    key: 'render',
    value: function render() {
      var _this2 = this;

      var activeTrackStyle = this.getActiveTrackStyle();

      return _react2.default.createElement(
        'div',
        {
          className: this.props.classNames.track,
          onMouseDown: this.handleMouseDown,
          onTouchStart: this.handleTouchStart,
          ref: function ref(node) {
            _this2.node = node;
          } },
        _react2.default.createElement('div', {
          style: activeTrackStyle,
          className: this.props.classNames.activeTrack }),
        this.props.children
      );
    }
  }]);

  return Track;
}(_react2.default.Component), (_applyDecoratedDescriptor(_class.prototype, 'handleMouseMove', [_autobindDecorator2.default], Object.getOwnPropertyDescriptor(_class.prototype, 'handleMouseMove'), _class.prototype), _applyDecoratedDescriptor(_class.prototype, 'handleMouseUp', [_autobindDecorator2.default], Object.getOwnPropertyDescriptor(_class.prototype, 'handleMouseUp'), _class.prototype), _applyDecoratedDescriptor(_class.prototype, 'handleMouseDown', [_autobindDecorator2.default], Object.getOwnPropertyDescriptor(_class.prototype, 'handleMouseDown'), _class.prototype), _applyDecoratedDescriptor(_class.prototype, 'handleTouchStart', [_autobindDecorator2.default], Object.getOwnPropertyDescriptor(_class.prototype, 'handleTouchStart'), _class.prototype)), _class);
exports.default = Track;
module.exports = exports['default'];
//# sourceMappingURL=track.js.map

/***/ }),
/* 1276 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
/** @ignore */
var DOWN_ARROW = exports.DOWN_ARROW = 40;

/** @ignore */
var LEFT_ARROW = exports.LEFT_ARROW = 37;

/** @ignore */
var RIGHT_ARROW = exports.RIGHT_ARROW = 39;

/** @ignore */
var UP_ARROW = exports.UP_ARROW = 38;
//# sourceMappingURL=key-codes.js.map

/***/ }),
/* 1277 */
/***/ (function(module, exports, __webpack_require__) {


    var content = __webpack_require__(1278);
    var insertCss = __webpack_require__(889);

    if (typeof content === 'string') {
      content = [[module.i, content, '']];
    }

    module.exports = content.locals || {};
    module.exports._getContent = function() { return content; };
    module.exports._getCss = function() { return content.toString(); };
    module.exports._insertCss = function(options) { return insertCss(content, options) };
    
    // Hot Module Replacement
    // https://webpack.github.io/docs/hot-module-replacement
    // Only activated in browser context
    if (false) {
      var removeCss = function() {};
      module.hot.accept("!!../../../../node_modules/css-loader/index.js??ref--2-rules-2!../../../../node_modules/postcss-loader/lib/index.js??ref--2-rules-3!./FilterLeft.css", function() {
        content = require("!!../../../../node_modules/css-loader/index.js??ref--2-rules-2!../../../../node_modules/postcss-loader/lib/index.js??ref--2-rules-3!./FilterLeft.css");

        if (typeof content === 'string') {
          content = [[module.id, content, '']];
        }

        removeCss = insertCss(content, { replace: true });
      });
      module.hot.dispose(function() { removeCss(); });
    }
  

/***/ }),
/* 1278 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(888)(false);
// imports


// module
exports.push([module.i, "._12yiy a{border-right:1px solid #95989a;padding:0 7px;color:#f40000;font-size:14px}._12yiy a._2xuaJ{padding-left:0}._12yiy a._2tdsf{padding-right:0;border:0}._12yiy:active,._12yiy:focus,._12yiy:hover{text-decoration:none;color:#f40000}.WdZZ8{padding:20px}._1ItHT{margin:20px 0;width:100%}._1d2-W{background:url(" + __webpack_require__(1279) + ") no-repeat scroll 7px 7px;padding-left:30px}", ""]);

// exports
exports.locals = {
	"card_text": "_12yiy",
	"first": "_2xuaJ",
	"last": "_2tdsf",
	"container": "WdZZ8",
	"input_range": "_1ItHT",
	"fechaInput": "_1d2-W"
};

/***/ }),
/* 1279 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABMAAAAVCAYAAACkCdXRAAAABHNCSVQICAgIfAhkiAAAARxJREFUOI3NlM1tg0AQhb+xuONI8Rk6oAREBbEriEtIKojTQUpICU4HuIO4BM4bCfuOtDkwwHiD5CB88JNWLG9+dmdn34JBDakDr+OFAD+w7ew1pKF9YX+aS4dl6OyNvRlJFumKaw+Zh1QGW+7gLfDPTeJnB7nA9yN8AYiDPfAUrjIR+xVsxIGfmQiAFcjiutv/EQGvjBz2RJwAIg+lQDx7W7QNuM8zs8kOQCGwAc7KVUCho1LurD4Fer96GPnsDFcqV17hdl08qAIUmdMb7iGR9hsbLlYucYMSMrux+21AX6aHo7Q6hUHgFfCp8y2Q6PxdY9ZiS71lA/oy5VJSf94qU0G3uzDm9g04zE3k4QggNSybkfd+CiL4eIDTL9T7b657wL0LAAAAAElFTkSuQmCC"

/***/ }),
/* 1280 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "b969cd5d.png";

/***/ }),
/* 1281 */
/***/ (function(module, exports, __webpack_require__) {


    var content = __webpack_require__(1282);
    var insertCss = __webpack_require__(889);

    if (typeof content === 'string') {
      content = [[module.i, content, '']];
    }

    module.exports = content.locals || {};
    module.exports._getContent = function() { return content; };
    module.exports._getCss = function() { return content.toString(); };
    module.exports._insertCss = function(options) { return insertCss(content, options) };
    
    // Hot Module Replacement
    // https://webpack.github.io/docs/hot-module-replacement
    // Only activated in browser context
    if (false) {
      var removeCss = function() {};
      module.hot.accept("!!../../../../node_modules/css-loader/index.js??ref--2-rules-2!../../../../node_modules/postcss-loader/lib/index.js??ref--2-rules-3!./ListCards.css", function() {
        content = require("!!../../../../node_modules/css-loader/index.js??ref--2-rules-2!../../../../node_modules/postcss-loader/lib/index.js??ref--2-rules-3!./ListCards.css");

        if (typeof content === 'string') {
          content = [[module.id, content, '']];
        }

        removeCss = insertCss(content, { replace: true });
      });
      module.hot.dispose(function() { removeCss(); });
    }
  

/***/ }),
/* 1282 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(888)(false);
// imports


// module
exports.push([module.i, "._2a43r{border-radius:0;padding:15px;border-top:0}._2a43r h5{font-family:Roboto\\, Medium;margin:0}._2a43r p{margin-bottom:0}._1CDtN,._2a43r p{font-family:Roboto}._1CDtN{border-color:#797979;color:#e4002b;padding:8px;margin-top:15px;margin-right:10px}._1CDtN:hover{color:#fff!important;background-color:#e4002b!important}._1r6fs{border-radius:100%;width:84px;border:1px solid #797979;background-color:#797979}.Dhr6J{margin-bottom:20px}", ""]);

// exports
exports.locals = {
	"card": "_2a43r",
	"button": "_1CDtN",
	"imgMedicos": "_1r6fs",
	"cardButton": "Dhr6J"
};

/***/ }),
/* 1283 */
/***/ (function(module, exports, __webpack_require__) {


    var content = __webpack_require__(1284);
    var insertCss = __webpack_require__(889);

    if (typeof content === 'string') {
      content = [[module.i, content, '']];
    }

    module.exports = content.locals || {};
    module.exports._getContent = function() { return content; };
    module.exports._getCss = function() { return content.toString(); };
    module.exports._insertCss = function(options) { return insertCss(content, options) };
    
    // Hot Module Replacement
    // https://webpack.github.io/docs/hot-module-replacement
    // Only activated in browser context
    if (false) {
      var removeCss = function() {};
      module.hot.accept("!!../../../../node_modules/css-loader/index.js??ref--2-rules-2!../../../../node_modules/postcss-loader/lib/index.js??ref--2-rules-3!./SinHorariosDisponibles.css", function() {
        content = require("!!../../../../node_modules/css-loader/index.js??ref--2-rules-2!../../../../node_modules/postcss-loader/lib/index.js??ref--2-rules-3!./SinHorariosDisponibles.css");

        if (typeof content === 'string') {
          content = [[module.id, content, '']];
        }

        removeCss = insertCss(content, { replace: true });
      });
      module.hot.dispose(function() { removeCss(); });
    }
  

/***/ }),
/* 1284 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(888)(false);
// imports


// module
exports.push([module.i, ".JMpht{padding:25px}._3xToS,.JMpht{text-align:center}._3xToS{font-family:Roboto,sans-serif;font-size:20px;color:#363636;height:24px}._3xToS a{color:#eb0000}", ""]);

// exports
exports.locals = {
	"divImagen": "JMpht",
	"divTexto": "_3xToS"
};

/***/ }),
/* 1285 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "77418a79.png";

/***/ }),
/* 1286 */
/***/ (function(module, exports, __webpack_require__) {


    var content = __webpack_require__(1287);
    var insertCss = __webpack_require__(889);

    if (typeof content === 'string') {
      content = [[module.i, content, '']];
    }

    module.exports = content.locals || {};
    module.exports._getContent = function() { return content; };
    module.exports._getCss = function() { return content.toString(); };
    module.exports._insertCss = function(options) { return insertCss(content, options) };
    
    // Hot Module Replacement
    // https://webpack.github.io/docs/hot-module-replacement
    // Only activated in browser context
    if (false) {
      var removeCss = function() {};
      module.hot.accept("!!../../../../node_modules/css-loader/index.js??ref--2-rules-2!../../../../node_modules/postcss-loader/lib/index.js??ref--2-rules-3!./ModalYaTomoTurno.css", function() {
        content = require("!!../../../../node_modules/css-loader/index.js??ref--2-rules-2!../../../../node_modules/postcss-loader/lib/index.js??ref--2-rules-3!./ModalYaTomoTurno.css");

        if (typeof content === 'string') {
          content = [[module.id, content, '']];
        }

        removeCss = insertCss(content, { replace: true });
      });
      module.hot.dispose(function() { removeCss(); });
    }
  

/***/ }),
/* 1287 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(888)(false);
// imports


// module
exports.push([module.i, "._2NdrB{text-align:center;width:530px}._2MqDd{font-family:Roboto,sans-serif}._117Y8{font-family:Roboto\\, Medium}.rwqMX{color:#333;background-color:#fff;border-color:#ccc;cursor:pointer;width:185px}._1-CI5{color:#fff;background-color:#e4002b;border-color:#e4002b;cursor:pointer;font-family:Roboto\\, Medium;width:190px}.bHHMx{padding:15px 65px;display:block}", ""]);

// exports
exports.locals = {
	"modalContent": "_2NdrB",
	"modalBody": "_2MqDd",
	"robotoMedium": "_117Y8",
	"boton_blanco": "rwqMX",
	"boton_rojo": "_1-CI5",
	"modalFooter": "bHHMx"
};

/***/ }),
/* 1288 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "cd014c55.png";

/***/ }),
/* 1289 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "0d6da5d5.png";

/***/ }),
/* 1290 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "7f198129.png";

/***/ }),
/* 1291 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "5bc05aca.png";

/***/ }),
/* 1292 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "9d3c8cfd.png";

/***/ }),
/* 1293 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "e09f2f7e.png";

/***/ }),
/* 1294 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "a891e332.png";

/***/ }),
/* 1295 */
/***/ (function(module, exports, __webpack_require__) {


    var content = __webpack_require__(1296);
    var insertCss = __webpack_require__(889);

    if (typeof content === 'string') {
      content = [[module.i, content, '']];
    }

    module.exports = content.locals || {};
    module.exports._getContent = function() { return content; };
    module.exports._getCss = function() { return content.toString(); };
    module.exports._insertCss = function(options) { return insertCss(content, options) };
    
    // Hot Module Replacement
    // https://webpack.github.io/docs/hot-module-replacement
    // Only activated in browser context
    if (false) {
      var removeCss = function() {};
      module.hot.accept("!!../../../../node_modules/css-loader/index.js??ref--2-rules-2!../../../../node_modules/postcss-loader/lib/index.js??ref--2-rules-3!./ModalCuandoUtilizarEconsulta.css", function() {
        content = require("!!../../../../node_modules/css-loader/index.js??ref--2-rules-2!../../../../node_modules/postcss-loader/lib/index.js??ref--2-rules-3!./ModalCuandoUtilizarEconsulta.css");

        if (typeof content === 'string') {
          content = [[module.id, content, '']];
        }

        removeCss = insertCss(content, { replace: true });
      });
      module.hot.dispose(function() { removeCss(); });
    }
  

/***/ }),
/* 1296 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(888)(false);
// imports


// module
exports.push([module.i, ".p-MWM{text-align:center;font-family:Roboto,sans-serif}._3W6VI{border:0 none}._2a267{-ms-flex-pack:end;-webkit-box-pack:\"none\";justify-content:\"none\"}._2a267 button{font-family:Roboto\\, Medium,sans-serif;margin:0 auto}._sx73{margin:0 auto;font-family:Roboto\\, Bold,sans-serif;font-size:24px}._1TXAP{padding:0!important;margin:0!important}._23649 td,._23649 th{padding:7.2px;padding:.45rem;cursor:default}._23649{margin-bottom:0}._23649 th{border-top:0}tr{border-right:1px solid #efe5e5}._3Iajz ::-webkit-scrollbar{width:4px}._3Iajz ::-webkit-scrollbar-track{background:#fff}._3Iajz ::-webkit-scrollbar-thumb,._3Iajz ::-webkit-scrollbar-thumb:hover{background:#e4002b}", ""]);

// exports
exports.locals = {
	"modalContent": "p-MWM",
	"modalHeader": "_3W6VI",
	"modalFooter": "_2a267",
	"modalTitle": "_sx73",
	"noPadding": "_1TXAP",
	"table": "_23649",
	"modalScroll": "_3Iajz"
};

/***/ }),
/* 1297 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "57dbad65.png";

/***/ }),
/* 1298 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "5aeff961.png";

/***/ }),
/* 1299 */
/***/ (function(module, exports, __webpack_require__) {


    var content = __webpack_require__(1300);
    var insertCss = __webpack_require__(889);

    if (typeof content === 'string') {
      content = [[module.i, content, '']];
    }

    module.exports = content.locals || {};
    module.exports._getContent = function() { return content; };
    module.exports._getCss = function() { return content.toString(); };
    module.exports._insertCss = function(options) { return insertCss(content, options) };
    
    // Hot Module Replacement
    // https://webpack.github.io/docs/hot-module-replacement
    // Only activated in browser context
    if (false) {
      var removeCss = function() {};
      module.hot.accept("!!../../../../node_modules/css-loader/index.js??ref--2-rules-2!../../../../node_modules/postcss-loader/lib/index.js??ref--2-rules-3!./ModalBienvenida.css", function() {
        content = require("!!../../../../node_modules/css-loader/index.js??ref--2-rules-2!../../../../node_modules/postcss-loader/lib/index.js??ref--2-rules-3!./ModalBienvenida.css");

        if (typeof content === 'string') {
          content = [[module.id, content, '']];
        }

        removeCss = insertCss(content, { replace: true });
      });
      module.hot.dispose(function() { removeCss(); });
    }
  

/***/ }),
/* 1300 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(888)(false);
// imports


// module
exports.push([module.i, "._3uyMj{background-color:#e4002b;cursor:pointer;font-family:roboto\\, Medium}.eR4TR{text-align:center;margin-top:70px}.eR4TR i{color:#e4002b}.c86Hq{height:250px}._3yxMF,.c86Hq{margin-bottom:20px}._3yxMF{height:120px}._3mm8I{min-height:69px}._3mm8I span{color:#e4002b}._3mm8I input[type=image]{cursor:pointer}._2W2FC{border-bottom:0}._32Ysn{color:#e4002b;background-color:transparent;border:none;width:100%;max-width:120px;font-size:16px}._32Ysn:hover{cursor:pointer}._3mm8I>:not(:last-child){margin-right:0}._3mm8I>:not(:first-child){margin-left:0}", ""]);

// exports
exports.locals = {
	"boton_rojo": "_3uyMj",
	"modalContent": "eR4TR",
	"modalBody": "c86Hq",
	"imageContainer": "_3yxMF",
	"modalFooter": "_3mm8I",
	"modalHeader": "_2W2FC",
	"boton_accion": "_32Ysn"
};

/***/ }),
/* 1301 */
/***/ (function(module, exports, __webpack_require__) {


    var content = __webpack_require__(1302);
    var insertCss = __webpack_require__(889);

    if (typeof content === 'string') {
      content = [[module.i, content, '']];
    }

    module.exports = content.locals || {};
    module.exports._getContent = function() { return content; };
    module.exports._getCss = function() { return content.toString(); };
    module.exports._insertCss = function(options) { return insertCss(content, options) };
    
    // Hot Module Replacement
    // https://webpack.github.io/docs/hot-module-replacement
    // Only activated in browser context
    if (false) {
      var removeCss = function() {};
      module.hot.accept("!!../../../../node_modules/css-loader/index.js??ref--2-rules-2!../../../../node_modules/postcss-loader/lib/index.js??ref--2-rules-3!./SinTurnosDisponibles.css", function() {
        content = require("!!../../../../node_modules/css-loader/index.js??ref--2-rules-2!../../../../node_modules/postcss-loader/lib/index.js??ref--2-rules-3!./SinTurnosDisponibles.css");

        if (typeof content === 'string') {
          content = [[module.id, content, '']];
        }

        removeCss = insertCss(content, { replace: true });
      });
      module.hot.dispose(function() { removeCss(); });
    }
  

/***/ }),
/* 1302 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(888)(false);
// imports


// module
exports.push([module.i, ".himHE{padding:25px}._2iW__,.himHE{text-align:center}._2iW__{font-family:Roboto,sans-serif;font-size:20px;color:#363636}._2iW__ a{color:#eb0000}", ""]);

// exports
exports.locals = {
	"divImagen": "himHE",
	"divTexto": "_2iW__"
};

/***/ }),
/* 1303 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "14c59e87.svg";

/***/ }),
/* 1304 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "18dcf957.png";

/***/ }),
/* 1305 */
/***/ (function(module, exports, __webpack_require__) {


    var content = __webpack_require__(1306);
    var insertCss = __webpack_require__(889);

    if (typeof content === 'string') {
      content = [[module.i, content, '']];
    }

    module.exports = content.locals || {};
    module.exports._getContent = function() { return content; };
    module.exports._getCss = function() { return content.toString(); };
    module.exports._insertCss = function(options) { return insertCss(content, options) };
    
    // Hot Module Replacement
    // https://webpack.github.io/docs/hot-module-replacement
    // Only activated in browser context
    if (false) {
      var removeCss = function() {};
      module.hot.accept("!!../../../../node_modules/css-loader/index.js??ref--2-rules-2!../../../../node_modules/postcss-loader/lib/index.js??ref--2-rules-3!./TurnosSolicitud.css", function() {
        content = require("!!../../../../node_modules/css-loader/index.js??ref--2-rules-2!../../../../node_modules/postcss-loader/lib/index.js??ref--2-rules-3!./TurnosSolicitud.css");

        if (typeof content === 'string') {
          content = [[module.id, content, '']];
        }

        removeCss = insertCss(content, { replace: true });
      });
      module.hot.dispose(function() { removeCss(); });
    }
  

/***/ }),
/* 1306 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(888)(false);
// imports


// module
exports.push([module.i, "@media (max-width:770px){.YTKwE{text-align:center!important}}._1FVs3{background-color:#e4002b;color:#fff}._3R1Rs{margin-left:25px}", ""]);

// exports
exports.locals = {
	"textMediaCenter": "YTKwE",
	"loadButton": "_1FVs3",
	"spanAlert": "_3R1Rs"
};

/***/ }),
/* 1307 */
/***/ (function(module, exports, __webpack_require__) {


    var content = __webpack_require__(1308);
    var insertCss = __webpack_require__(889);

    if (typeof content === 'string') {
      content = [[module.i, content, '']];
    }

    module.exports = content.locals || {};
    module.exports._getContent = function() { return content; };
    module.exports._getCss = function() { return content.toString(); };
    module.exports._insertCss = function(options) { return insertCss(content, options) };
    
    // Hot Module Replacement
    // https://webpack.github.io/docs/hot-module-replacement
    // Only activated in browser context
    if (false) {
      var removeCss = function() {};
      module.hot.accept("!!../../../../node_modules/css-loader/index.js??ref--2-rules-2!../../../../node_modules/postcss-loader/lib/index.js??ref--2-rules-3!./ModalErrorDocumentoIntes.css", function() {
        content = require("!!../../../../node_modules/css-loader/index.js??ref--2-rules-2!../../../../node_modules/postcss-loader/lib/index.js??ref--2-rules-3!./ModalErrorDocumentoIntes.css");

        if (typeof content === 'string') {
          content = [[module.id, content, '']];
        }

        removeCss = insertCss(content, { replace: true });
      });
      module.hot.dispose(function() { removeCss(); });
    }
  

/***/ }),
/* 1308 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(888)(false);
// imports


// module
exports.push([module.i, "._7Pgpr{text-align:center;width:624px}.VeFDH{font-family:Roboto,sans-serif;margin-left:68px;margin-right:68px}._3_fym{color:#fff;background-color:#e4002b;border-color:#e4002b;cursor:pointer;font-family:Roboto\\, Medium;width:140px}._30keg{padding:15px 65px;display:block}", ""]);

// exports
exports.locals = {
	"modalContent": "_7Pgpr",
	"modalBody": "VeFDH",
	"boton_rojo": "_3_fym",
	"modalFooter": "_30keg"
};

/***/ }),
/* 1309 */
/***/ (function(module, exports, __webpack_require__) {


    var content = __webpack_require__(1310);
    var insertCss = __webpack_require__(889);

    if (typeof content === 'string') {
      content = [[module.i, content, '']];
    }

    module.exports = content.locals || {};
    module.exports._getContent = function() { return content; };
    module.exports._getCss = function() { return content.toString(); };
    module.exports._insertCss = function(options) { return insertCss(content, options) };
    
    // Hot Module Replacement
    // https://webpack.github.io/docs/hot-module-replacement
    // Only activated in browser context
    if (false) {
      var removeCss = function() {};
      module.hot.accept("!!../../../../node_modules/css-loader/index.js??ref--2-rules-2!../../../../node_modules/postcss-loader/lib/index.js??ref--2-rules-3!./TurnosEspontaneos.css", function() {
        content = require("!!../../../../node_modules/css-loader/index.js??ref--2-rules-2!../../../../node_modules/postcss-loader/lib/index.js??ref--2-rules-3!./TurnosEspontaneos.css");

        if (typeof content === 'string') {
          content = [[module.id, content, '']];
        }

        removeCss = insertCss(content, { replace: true });
      });
      module.hot.dispose(function() { removeCss(); });
    }
  

/***/ }),
/* 1310 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(888)(false);
// imports


// module
exports.push([module.i, "._3e7zI ul{list-style-type:none;margin:0;padding:0}._3e7zI li{display:inline-block;position:relative}._3e7zI li:nth-child(n+2){margin-left:-30px}._3zgj7{margin-top:2%;margin-bottom:2%;border-right:2px solid hsla(0,0%,44%,.25)}._3j-RK{background-color:#fafafa}._2KSZW{width:82px;height:82px;border-radius:50%;border:3px solid #fff;display:inline-block;position:relative;-webkit-box-shadow:1px 1px 3px 1px rgba(0,0,0,.2);box-shadow:1px 1px 3px 1px rgba(0,0,0,.2)}.SdhHT{margin-top:5%}._2W98o{margin-bottom:2%}._3WIfO{background-color:#007a6e;color:#fff;width:193.86px}._1YIHs{color:#797979}._3gn99{font-size:15px}._3yQeW{margin-top:10px;margin-bottom:10px}", ""]);

// exports
exports.locals = {
	"avataresUl": "_3e7zI",
	"divRow": "_3zgj7",
	"header": "_3j-RK",
	"imgAvatar": "_2KSZW",
	"buttonDiv": "SdhHT",
	"content": "_2W98o",
	"button": "_3WIfO",
	"wait": "_1YIHs",
	"turnwaitingTime": "_3gn99",
	"circularProgBar": "_3yQeW"
};

/***/ }),
/* 1311 */
/***/ (function(module, exports, __webpack_require__) {

var map = {
	"./ClinicaMedica/17978.jpg": 1312,
	"./ClinicaMedica/17991.jpg": 1313,
	"./ClinicaMedica/18046.jpg": 1314,
	"./ClinicaMedica/19524.jpg": 1315,
	"./ClinicaMedica/24579.jpg": 1316,
	"./ClinicaMedica/24580.jpg": 1317,
	"./ClinicaMedica/24581.jpg": 1318,
	"./ClinicaMedica/553.jpg": 1319,
	"./ClinicaMedica/749.jpg": 1320,
	"./Pediatria/10540.jpg": 1321,
	"./Pediatria/17997.jpg": 1322,
	"./Pediatria/24569.jpg": 1323,
	"./Pediatria/24570.jpg": 1324,
	"./Pediatria/24572.jpg": 1325,
	"./Pediatria/24573.jpg": 1326,
	"./Pediatria/24574.jpg": 1327,
	"./Pediatria/24576.jpg": 1328,
	"./Pediatria/24577.jpg": 1329,
	"./Pediatria/25241.jpg": 1330,
	"./Pediatria/25829.jpg": 1331,
	"./Pediatria/426.jpg": 1332,
	"./Pediatria/670.jpg": 1333
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 1311;

/***/ }),
/* 1312 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "48b4590d.jpg";

/***/ }),
/* 1313 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "e0c61752.jpg";

/***/ }),
/* 1314 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "d17b15ae.jpg";

/***/ }),
/* 1315 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "dc8cc292.jpg";

/***/ }),
/* 1316 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "20212ef8.jpg";

/***/ }),
/* 1317 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "b495432f.jpg";

/***/ }),
/* 1318 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "6dc26e21.jpg";

/***/ }),
/* 1319 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "f15e9719.jpg";

/***/ }),
/* 1320 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "19145d30.jpg";

/***/ }),
/* 1321 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "a58589b6.jpg";

/***/ }),
/* 1322 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "01969c7a.jpg";

/***/ }),
/* 1323 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "d19c09aa.jpg";

/***/ }),
/* 1324 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "3db3fcf0.jpg";

/***/ }),
/* 1325 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "a65f3149.jpg";

/***/ }),
/* 1326 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "4b6113a8.jpg";

/***/ }),
/* 1327 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "181b0b81.jpg";

/***/ }),
/* 1328 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "3135ccf0.jpg";

/***/ }),
/* 1329 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "85367066.jpg";

/***/ }),
/* 1330 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "499b4f3a.jpg";

/***/ }),
/* 1331 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "2bd37a07.jpg";

/***/ }),
/* 1332 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "592aeacc.jpg";

/***/ }),
/* 1333 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "7ea21a42.jpg";

/***/ }),
/* 1334 */
/***/ (function(module, exports, __webpack_require__) {


    var content = __webpack_require__(1335);
    var insertCss = __webpack_require__(889);

    if (typeof content === 'string') {
      content = [[module.i, content, '']];
    }

    module.exports = content.locals || {};
    module.exports._getContent = function() { return content; };
    module.exports._getCss = function() { return content.toString(); };
    module.exports._insertCss = function(options) { return insertCss(content, options) };
    
    // Hot Module Replacement
    // https://webpack.github.io/docs/hot-module-replacement
    // Only activated in browser context
    if (false) {
      var removeCss = function() {};
      module.hot.accept("!!../../../../node_modules/css-loader/index.js??ref--2-rules-2!../../../../node_modules/postcss-loader/lib/index.js??ref--2-rules-3!./NavegadorIncompatible.css", function() {
        content = require("!!../../../../node_modules/css-loader/index.js??ref--2-rules-2!../../../../node_modules/postcss-loader/lib/index.js??ref--2-rules-3!./NavegadorIncompatible.css");

        if (typeof content === 'string') {
          content = [[module.id, content, '']];
        }

        removeCss = insertCss(content, { replace: true });
      });
      module.hot.dispose(function() { removeCss(); });
    }
  

/***/ }),
/* 1335 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(888)(false);
// imports


// module
exports.push([module.i, "._2q5gO{margin:5 em;text-align:center}.vryl4{color:#494949;font-size:18px;font-weight:700}._6irnb,.vryl4{font-family:Roboto,sans-serif}._6irnb{text-align:justify}._4dAId{margin:45px}.dA2Xx{margin:35px}._1ywiY{text-decoration:none;color:#000;margin:10px}", ""]);

// exports
exports.locals = {
	"root": "_2q5gO",
	"title": "vryl4",
	"message": "_6irnb",
	"browserSad": "_4dAId",
	"browser": "dA2Xx",
	"download": "_1ywiY"
};

/***/ }),
/* 1336 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "426cd30e.png";

/***/ }),
/* 1337 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "e9579750.png";

/***/ }),
/* 1338 */
/***/ (function(module, exports, __webpack_require__) {


    var content = __webpack_require__(1339);
    var insertCss = __webpack_require__(889);

    if (typeof content === 'string') {
      content = [[module.i, content, '']];
    }

    module.exports = content.locals || {};
    module.exports._getContent = function() { return content; };
    module.exports._getCss = function() { return content.toString(); };
    module.exports._insertCss = function(options) { return insertCss(content, options) };
    
    // Hot Module Replacement
    // https://webpack.github.io/docs/hot-module-replacement
    // Only activated in browser context
    if (false) {
      var removeCss = function() {};
      module.hot.accept("!!../../../../node_modules/css-loader/index.js??ref--2-rules-2!../../../../node_modules/postcss-loader/lib/index.js??ref--2-rules-3!./styles.css", function() {
        content = require("!!../../../../node_modules/css-loader/index.js??ref--2-rules-2!../../../../node_modules/postcss-loader/lib/index.js??ref--2-rules-3!./styles.css");

        if (typeof content === 'string') {
          content = [[module.id, content, '']];
        }

        removeCss = insertCss(content, { replace: true });
      });
      module.hot.dispose(function() { removeCss(); });
    }
  

/***/ }),
/* 1339 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(888)(false);
// imports


// module
exports.push([module.i, "._3rEzR{margin-top:5%;padding-left:10%;padding-bottom:20%}._1o7EP,._1xfiT{font-family:roboto\\, Medium}._1o7EP{font-size:10pt}a{text-decoration:inherit}a,a:hover,a:not([href]):not([tabindex]){color:red}", ""]);

// exports
exports.locals = {
	"root": "_3rEzR",
	"btnClickForward": "_1xfiT",
	"text": "_1o7EP"
};

/***/ }),
/* 1340 */
/***/ (function(module, exports, __webpack_require__) {


    var content = __webpack_require__(1341);
    var insertCss = __webpack_require__(889);

    if (typeof content === 'string') {
      content = [[module.i, content, '']];
    }

    module.exports = content.locals || {};
    module.exports._getContent = function() { return content; };
    module.exports._getCss = function() { return content.toString(); };
    module.exports._insertCss = function(options) { return insertCss(content, options) };
    
    // Hot Module Replacement
    // https://webpack.github.io/docs/hot-module-replacement
    // Only activated in browser context
    if (false) {
      var removeCss = function() {};
      module.hot.accept("!!../../../../node_modules/css-loader/index.js??ref--2-rules-2!../../../../node_modules/postcss-loader/lib/index.js??ref--2-rules-3!./MuyProntoParaIniciarConsulta.css", function() {
        content = require("!!../../../../node_modules/css-loader/index.js??ref--2-rules-2!../../../../node_modules/postcss-loader/lib/index.js??ref--2-rules-3!./MuyProntoParaIniciarConsulta.css");

        if (typeof content === 'string') {
          content = [[module.id, content, '']];
        }

        removeCss = insertCss(content, { replace: true });
      });
      module.hot.dispose(function() { removeCss(); });
    }
  

/***/ }),
/* 1341 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(888)(false);
// imports


// module
exports.push([module.i, "._1dqnF{font-family:Roboto,sans-serif;font-size:18px;color:#363636;padding:50px 100px 100px}._22zCn{padding-left:15px}._1azyA{color:#e4002b;background-color:#fff;border:0;margin-top:15px;cursor:pointer;width:250px;font-size:18px;text-align:left;padding:0}._1azyA:hover{cursor:pointer;text-decoration:underline}", ""]);

// exports
exports.locals = {
	"msg": "_1dqnF",
	"bold": "_22zCn",
	"boton_volver": "_1azyA"
};

/***/ }),
/* 1342 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "232f65f4.png";

/***/ }),
/* 1343 */
/***/ (function(module, exports, __webpack_require__) {


    var content = __webpack_require__(1344);
    var insertCss = __webpack_require__(889);

    if (typeof content === 'string') {
      content = [[module.i, content, '']];
    }

    module.exports = content.locals || {};
    module.exports._getContent = function() { return content; };
    module.exports._getCss = function() { return content.toString(); };
    module.exports._insertCss = function(options) { return insertCss(content, options) };
    
    // Hot Module Replacement
    // https://webpack.github.io/docs/hot-module-replacement
    // Only activated in browser context
    if (false) {
      var removeCss = function() {};
      module.hot.accept("!!../../../node_modules/css-loader/index.js??ref--2-rules-2!../../../node_modules/postcss-loader/lib/index.js??ref--2-rules-3!./Tab.css", function() {
        content = require("!!../../../node_modules/css-loader/index.js??ref--2-rules-2!../../../node_modules/postcss-loader/lib/index.js??ref--2-rules-3!./Tab.css");

        if (typeof content === 'string') {
          content = [[module.id, content, '']];
        }

        removeCss = insertCss(content, { replace: true });
      });
      module.hot.dispose(function() { removeCss(); });
    }
  

/***/ }),
/* 1344 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(888)(false);
// imports


// module
exports.push([module.i, "._12mkY{background-color:#fcfcfc;height:44px;border:1px solid #dedede!important;line-height:26px;width:214px;text-align:center;font-family:Roboto\\, Light}._12mkY,._12mkY:hover{color:#333}._2VYe3{border-top:3px solid #f20000!important;font-family:Roboto\\, Medium;width:214px;text-align:center}._279hi{border-top:3px solid transparent!important}", ""]);

// exports
exports.locals = {
	"navItemLink": "_12mkY",
	"active": "_2VYe3",
	"inactive": "_279hi"
};

/***/ }),
/* 1345 */,
/* 1346 */,
/* 1347 */,
/* 1348 */,
/* 1349 */,
/* 1350 */,
/* 1351 */,
/* 1352 */,
/* 1353 */,
/* 1354 */,
/* 1355 */,
/* 1356 */,
/* 1357 */,
/* 1358 */,
/* 1359 */,
/* 1360 */,
/* 1361 */,
/* 1362 */,
/* 1363 */,
/* 1364 */,
/* 1365 */,
/* 1366 */,
/* 1367 */,
/* 1368 */,
/* 1369 */,
/* 1370 */,
/* 1371 */,
/* 1372 */,
/* 1373 */,
/* 1374 */,
/* 1375 */,
/* 1376 */,
/* 1377 */,
/* 1378 */,
/* 1379 */,
/* 1380 */,
/* 1381 */,
/* 1382 */,
/* 1383 */,
/* 1384 */,
/* 1385 */,
/* 1386 */,
/* 1387 */,
/* 1388 */,
/* 1389 */,
/* 1390 */,
/* 1391 */,
/* 1392 */,
/* 1393 */,
/* 1394 */,
/* 1395 */,
/* 1396 */,
/* 1397 */,
/* 1398 */,
/* 1399 */,
/* 1400 */,
/* 1401 */,
/* 1402 */,
/* 1403 */,
/* 1404 */,
/* 1405 */,
/* 1406 */,
/* 1407 */,
/* 1408 */,
/* 1409 */,
/* 1410 */,
/* 1411 */,
/* 1412 */,
/* 1413 */,
/* 1414 */,
/* 1415 */,
/* 1416 */,
/* 1417 */,
/* 1418 */,
/* 1419 */,
/* 1420 */,
/* 1421 */,
/* 1422 */,
/* 1423 */,
/* 1424 */,
/* 1425 */,
/* 1426 */,
/* 1427 */,
/* 1428 */,
/* 1429 */,
/* 1430 */,
/* 1431 */,
/* 1432 */,
/* 1433 */,
/* 1434 */,
/* 1435 */,
/* 1436 */,
/* 1437 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });

// CONCATENATED MODULE: ./src/routes/telemedicina/TelemedicinaPage.js
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(71);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_isomorphic_style_loader_lib_withStyles__ = __webpack_require__(887);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_isomorphic_style_loader_lib_withStyles___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_isomorphic_style_loader_lib_withStyles__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_redux__ = __webpack_require__(415);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_lodash__ = __webpack_require__(183);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__TelemedicinaPageUserLoggedIn__ = __webpack_require__(1245);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_NotLoggedIn_NotLoggedIn__ = __webpack_require__(1123);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_Telemedicina_TurnosSolicitud_TurnosSolicitud__ = __webpack_require__(1246);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__constants__ = __webpack_require__(17);
var _jsx = function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; }();

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

/* eslint react/no-did-mount-set-state: 0 */
/* eslint consistent-return: 0 */
/* eslint react/prop-types: 0 */











var _ref = _jsx(__WEBPACK_IMPORTED_MODULE_5__components_NotLoggedIn_NotLoggedIn__["a" /* default */], {}, void 0, __WEBPACK_IMPORTED_MODULE_7__constants__["_34" /* NOT_LOGGED_IN_INIT_SESSION_MSG */]);

var _ref2 = _jsx('div', {});

var _ref3 = _jsx('div', {});

var TelemedicinaPage = function (_React$Component) {
  _inherits(TelemedicinaPage, _React$Component);

  function TelemedicinaPage() {
    _classCallCheck(this, TelemedicinaPage);

    var _this = _possibleConstructorReturn(this, (TelemedicinaPage.__proto__ || Object.getPrototypeOf(TelemedicinaPage)).call(this));

    _this.state = {
      isLoggedIn: __WEBPACK_IMPORTED_MODULE_7__constants__["_33" /* LOGIN_STATUS_PENDING */]
    };
    return _this;
  }

  _createClass(TelemedicinaPage, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      var auth = this.props.auth;

      if (__WEBPACK_IMPORTED_MODULE_3_lodash___default.a.isEmpty(auth)) {
        this.setState({ isLoggedIn: __WEBPACK_IMPORTED_MODULE_7__constants__["_32" /* LOGIN_STATUS_NOT_LOGGED_IN */] });
      } else {
        this.setState({ isLoggedIn: __WEBPACK_IMPORTED_MODULE_7__constants__["_31" /* LOGIN_STATUS_LOGGED_IN */] });
      }
    }
  }, {
    key: 'componentWillReceiveProps',
    value: function componentWillReceiveProps(nextProps) {
      if (__WEBPACK_IMPORTED_MODULE_3_lodash___default.a.isEmpty(nextProps.auth)) {
        this.setState({ isLoggedIn: __WEBPACK_IMPORTED_MODULE_7__constants__["_32" /* LOGIN_STATUS_NOT_LOGGED_IN */] });
      } else {
        this.setState({ isLoggedIn: __WEBPACK_IMPORTED_MODULE_7__constants__["_31" /* LOGIN_STATUS_LOGGED_IN */] });
      }
    }
  }, {
    key: 'render',
    value: function render() {
      var isLoggedIn = this.state.isLoggedIn;


      switch (isLoggedIn) {
        case __WEBPACK_IMPORTED_MODULE_7__constants__["_31" /* LOGIN_STATUS_LOGGED_IN */]:
          return _jsx(__WEBPACK_IMPORTED_MODULE_4__TelemedicinaPageUserLoggedIn__["a" /* default */], {
            component: __WEBPACK_IMPORTED_MODULE_6__components_Telemedicina_TurnosSolicitud_TurnosSolicitud__["a" /* default */],
            activeSolicitud: true,
            context: this.props.context,
            origen: 'espontaneo'
          });

        case __WEBPACK_IMPORTED_MODULE_7__constants__["_32" /* LOGIN_STATUS_NOT_LOGGED_IN */]:
          return _ref;

        case __WEBPACK_IMPORTED_MODULE_7__constants__["_33" /* LOGIN_STATUS_PENDING */]:
          return _ref2;

        default:
          return _ref3;
      }
    }
  }]);

  return TelemedicinaPage;
}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component);

var mapStateToProps = function mapStateToProps(state) {
  return {
    auth: state.auth.loginResponse
  };
};

/* harmony default export */ var TelemedicinaPage_defaultExport = (Object(__WEBPACK_IMPORTED_MODULE_2_react_redux__["b" /* connect */])(mapStateToProps, null)(__WEBPACK_IMPORTED_MODULE_1_isomorphic_style_loader_lib_withStyles___default()()(TelemedicinaPage)));
// CONCATENATED MODULE: ./src/routes/telemedicina/index.js
/* harmony import */ var telemedicina___WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(71);
/* harmony import */ var telemedicina___WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(telemedicina___WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_Layout__ = __webpack_require__(941);
var telemedicina__jsx = function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; }();

var action = function () {
  var _ref = _asyncToGenerator(regeneratorRuntime.mark(function _callee(context) {
    return regeneratorRuntime.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            return _context.abrupt('return', {
              chunks: ['telemedicina'],
              title: 'E-Consulta',
              component: telemedicina__jsx(__WEBPACK_IMPORTED_MODULE_2__components_Layout__["a" /* default */], {
                hideLayout: context.query.hideLayout
              }, void 0, telemedicina__ref2)
            });

          case 1:
          case 'end':
            return _context.stop();
        }
      }
    }, _callee, this);
  }));

  return function action(_x) {
    return _ref.apply(this, arguments);
  };
}();

function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }





var telemedicina__ref2 = telemedicina__jsx(TelemedicinaPage_defaultExport, {});

/* harmony default export */ var telemedicina_defaultExport = __webpack_exports__["default"] = (action);

/***/ })
]));


// WEBPACK FOOTER //
// telemedicina.ef3951e9.chunk.js